import React from "react";
import $ from 'jquery';
import { Link } from "react-router-dom";
import parse from 'html-react-parser';
import { ConnectCallTWebSocket, GETUSERCUSTOMDATA } from './SocketAPI';
import cookie from 'react-cookies';
import { getUserTokenMethod, getTelegramPersonal } from "./MLayout";
import { Bar, Line } from "react-chartjs-2";
import ReactGA from 'react-ga';
import { getStore, DispatchFromAppJs } from "./app";
import { StoreUserData, StoreMasterData, StoreUser, StoreGPTData } from "./DataStore";
import { modes } from "react-transition-group/SwitchTransition";

var currentURL = "https://www.pinnacleblooms.org/";
var googlePingUrl = "https://clients1.google.se/generate_204";
export default class RUtlity extends React.Component {

  constructor(props) {
    super(props);

  }

  render() { return <div></div> }


}


let bbp = class BBP {


  static async Log(Title = null, Start = null, End = null) {

    try {
      var type = localStorage.getItem("BBP");
      var newData = type && type != '1' && type != 'null' ? JSON.parse(type) : [];
      newData.push({ T: Title, S: Start, E: End, CDT: new Date() });
      localStorage.setItem("BBP", JSON.stringify(newData));

    } catch (e) {
      console.log("Error in getUsageTypeFromLS : " + e);
    }
  }
}




export function GetDateString(date) {
  date = new Date(date);
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const day = date.getDate();
  const monthName = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${monthName} ${year}`;
}

var appMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var appShortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

export const familyIncentiveIds = [2413, 2412, 2411, 2410, 2409, 2408, 2407, 2406, 2405];

export const PinnacleAIOptions = [{ Name: "Pinnacle AI Early Intervention Plan", val: "eip", key: "pinnacle-ai-eip" }, { Name: "Pinnacle AI Therapy Goals", val: "goals", key: "pinnacle-ai-goal" }, { Name: "Pinnacle AI Therapy Program", val: "program", key: "pinnacle-ai-program" }, { Name: "Pinnacle AI Today Therapy Session", val: "session", key: "pinnacle-ai-today-therapy" }];

export const memoCategories = ["AbilityScore Refresh Pending", "Appron Missing", "Biometric-Tampering", "Id Card Missing", "Walk-in Not Marked", "EIP Not Created", "Stealing  Kids Life - Money", "Camera Related", "Mobile Usage", "Group", "Wrong Expense", "Repetitive Expense Image", "Irregular Expense Booking", "Discipline", "Attendance Pending", "Clarity Pending", "Assessment Related", "Discipline-Tardiness", "Call Quality"];



export const COLORS = { green: "#00b14f", yellow: "#c56f00", red: "#bf0e00" };
const niceStep = (max) => {
  if (max <= 10) return 2;
  if (max <= 20) return 5;
  if (max <= 50) return 10;
  if (max <= 100) return 20;
  return Math.ceil(max / 5); // fallback
};
  export const baseOptions = (max, onePoint) => ({
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  resizeDelay: 100,
  scales: {
    y: {
      beginAtZero: true,
      suggestedMax: Math.max(10, max || 0),
      ticks: { stepSize: niceStep(Math.max(1, max)) },
    },
    x: {
      grid: { display: false },
      // avoid odd hover when only one label
      offset: !!onePoint,
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true, mode: "index", intersect: false },
  },
});

export const lineSpecific = {
  elements: {
    line: { tension: 0.4, borderWidth: 2 },
    point: { radius: 4, hoverRadius: 6 },
  },
};

export const BossCreationsURL = [
  {
    Title: "Service Requests",
    URL: "/servicerequest",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path data-cap="butt" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} d="M27,12c0.6,1.5,1,3.2,1,5 c0,7.2-5.8,13-13,13S2,24.2,2,17S7.8,4,15,4c2.5,0,4.9,0.7,6.9,2" strokeLinejoin="miter" strokeLinecap="butt" /> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points=" 10,13 15,18 30,3 " strokeLinejoin="miter" /></g></svg>
    ),
  },
  {
    Title: "Leaves",
    URL: "/allparentleaves?t=LEAVEREQUEST",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M21.88,2.157a3.738,3.738,0,0,0-5.287-.12,3.688,3.688,0,0,0-.593.73,3.74,3.74,0,0,0-5.881-.61,4.046,4.046,0,0,0,0,5.587L16,13.831l5.881-6.087A4.045,4.045,0,0,0,21.88,2.157Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M7,31V29L1.722,22.843A3,3,0,0,1,1,20.89V12a2,2,0,0,1,2-2H3a2,2,0,0,1,2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M14,31V24.243a3,3,0,0,0-.879-2.122L8.5,17.5a2.122,2.122,0,0,0-3,0h0a2.122,2.122,0,0,0,0,3L9,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M25,31V29l5.278-6.157A3,3,0,0,0,31,20.89V12a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M18,31V24.243a3,3,0,0,1,.879-2.122L23.5,17.5a2.122,2.122,0,0,1,3,0h0a2.122,2.122,0,0,1,0,3L23,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
    ),
  },
  {
    Title: "Grace Sessions",
    URL: "/allparentleaves?t=GRACESESSION",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M21.88,2.157a3.738,3.738,0,0,0-5.287-.12,3.688,3.688,0,0,0-.593.73,3.74,3.74,0,0,0-5.881-.61,4.046,4.046,0,0,0,0,5.587L16,13.831l5.881-6.087A4.045,4.045,0,0,0,21.88,2.157Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M7,31V29L1.722,22.843A3,3,0,0,1,1,20.89V12a2,2,0,0,1,2-2H3a2,2,0,0,1,2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M14,31V24.243a3,3,0,0,0-.879-2.122L8.5,17.5a2.122,2.122,0,0,0-3,0h0a2.122,2.122,0,0,0,0,3L9,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M25,31V29l5.278-6.157A3,3,0,0,0,31,20.89V12a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M18,31V24.243a3,3,0,0,1,.879-2.122L23.5,17.5a2.122,2.122,0,0,1,3,0h0a2.122,2.122,0,0,1,0,3L23,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
    ),
  },
  {
    Title: "Leaves & Grace Sessions",
    URL: "/compensation",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M21.88,2.157a3.738,3.738,0,0,0-5.287-.12,3.688,3.688,0,0,0-.593.73,3.74,3.74,0,0,0-5.881-.61,4.046,4.046,0,0,0,0,5.587L16,13.831l5.881-6.087A4.045,4.045,0,0,0,21.88,2.157Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M7,31V29L1.722,22.843A3,3,0,0,1,1,20.89V12a2,2,0,0,1,2-2H3a2,2,0,0,1,2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M14,31V24.243a3,3,0,0,0-.879-2.122L8.5,17.5a2.122,2.122,0,0,0-3,0h0a2.122,2.122,0,0,0,0,3L9,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M25,31V29l5.278-6.157A3,3,0,0,0,31,20.89V12a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M18,31V24.243a3,3,0,0,1,.879-2.122L23.5,17.5a2.122,2.122,0,0,1,3,0h0a2.122,2.122,0,0,1,0,3L23,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
    ),
  },
  {
    Title: "TherapeuticAI Remote/Homework",
    URL: "/therapeuticairemote",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line x1={11} y1={4} x2={11} y2={1} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={21} y1={4} x2={21} y2={1} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={16} y1={4} x2={16} y2={1} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={4} y1={21} x2={1} y2={21} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={4} y1={11} x2={1} y2={11} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={4} y1={16} x2={1} y2={16} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={31} y1={21} x2={28} y2={21} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={31} y1={11} x2={28} y2={11} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={31} y1={16} x2={28} y2={16} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={11} y1={31} x2={11} y2={28} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={21} y1={31} x2={21} y2={28} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={16} y1={31} x2={16} y2={28} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><rect x={4} y={4} width={24} height={24} rx={2} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><rect x={9} y={9} width={14} height={14} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /></g></svg>
    ),
  },
  {
    Title: "Credits Bal & Usage",
    URL: "/Credits",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={25} y1={22} x2={25} y2={26} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={23} y1={24} x2={27} y2={24} strokeLinejoin="miter" /> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={25} cy={24} r={6} strokeLinejoin="miter" /> <line fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={1} y1={8} x2={31} y2={8} strokeLinejoin="miter" /> <line fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={1} y1={13} x2={31} y2={13} strokeLinejoin="miter" /> <path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M15,24H3 c-1.105,0-2-0.895-2-2V4c0-1.105,0.895-2,2-2h26c1.105,0,2,0.895,2,2v9" strokeLinejoin="miter" /> <line fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={5} y1={19} x2={12} y2={19} strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "Invoices & Receipts",
    URL: "/bossreceipts",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polygon points="4 1 28 1 28 30 23 28 20 30 16 28 12 30 9 28 4 30 4 1" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <line x1={9} y1={23} x2={16} y2={23} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /> <line x1={21} y1={23} x2={23} y2={23} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /> <line x1={9} y1={18} x2={16} y2={18} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /> <line x1={21} y1={18} x2={23} y2={18} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /> <circle cx={16} cy={9} r={4} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "Therapy Service Letter",
    Method: "DownloadTherapyServiceLetter({kidid})",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points=" 12,19 15,22 21,16 " strokeLinejoin="miter" /> <path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M19,4c0-1.657-1.343-3-3-3 s-3,1.343-3,3h-3v4h12V4H19z" strokeLinejoin="miter" /> <polyline data-cap="butt" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} points="25,5 28,5 28,31 4,31 4,5 7,5 " strokeLinejoin="miter" strokeLinecap="butt" /></g></svg>
    ),
  },
  {
    Title: "Attendance Letter",
    URL: "/attendancesheet?facility=&kidid={kidid}",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><rect x={3} y={1} fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} width={26} height={30} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={19} y1={8} x2={23} y2={8} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={19} y1={13} x2={23} y2={13} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={9} y1={18} x2={23} y2={18} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={9} y1={23} x2={23} y2={23} strokeLinejoin="miter" /> <rect data-color="color-2" x={9} y={8} fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} width={6} height={5} strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "ID Card",
    URL: "/pinnacleidcard",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polyline points="2 8 2 2 8 2" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polyline points="30 8 30 2 24 2" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polyline points="2 24 2 30 8 30" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polyline points="30 24 30 30 24 30" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M7,26l4.632-1.544A2,2,0,0,0,13,22.558V21.243C10.187,19.678,9,15.97,9,13V12a7,7,0,0,1,14,0v1c0,2.97-1.187,6.678-4,8.243v1.315a2,2,0,0,0,1.368,1.9L25,26" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "Diagnosis Reports",
    URL: "/viewalleips?kid={kidid}",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><rect x={13} y={18} fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} width={6} height={13} strokeLinejoin="miter" /> <rect x={1} y={24} fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} width={6} height={7} strokeLinejoin="miter" /> <rect x={25} y={12} fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} width={6} height={19} strokeLinejoin="miter" /> <polyline data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} points="6,11 11,6 16,11 26,1 " strokeLinejoin="miter" strokeLinecap="butt" /> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points=" 20,1 26,1 26,7 " strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "Therapy Goals",
    URL: "/goalsuggestion?kid={kidid}",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M24.621,15.996 C24.868,16.956,25,17.963,25,19c0,6.627-5.373,12-12,12S1,25.627,1,19S6.373,7,13,7c1.037,0,2.044,0.132,3.003,0.379" strokeLinejoin="miter" /> <circle fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={13} cy={19} r={7} strokeLinejoin="miter" /> <line data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} x1={13} y1={19} x2={29} y2={3} strokeLinejoin="miter" strokeLinecap="butt" /> <polygon data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} points="25,7 24,2 20,6 21,11 26,12 30,8 " strokeLinejoin="miter" strokeLinecap="square" /></g></svg>

    ),
  },
  {
    Title: "Therapy Materials",
    URL: "/therapysession?kid={kidid}",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M4.7,23.754l3.68-10.121A4,4,0,0,1,12.135,11h4.618a3.9,3.9,0,0,0,3.685-2.443A7,7,0,0,1,27,4V6l1.755,4.388a1,1,0,0,1-.221,1.078L27.5,12.5,25,11l-1,4,3.287,8.765" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M9.831,11.731A5.927,5.927,0,0,0,7,11a6,6,0,0,0-6,6" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M7.938,25.42l.747-2.057h0a7.67,7.67,0,0,1,14.63,0h0l.747,2.057" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M2.312,22.021a21.3,21.3,0,0,0,27.376,0" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "Therapy Techniques",
    URL: "/therapysession?kid={kidid}",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polygon points="2 26 6 30 24 12 20 8 2 26" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><line x1={16} y1={12} x2={20} y2={16} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M31,5c-2.209,0-4,1.791-4,4,0-2.209-1.791-4-4-4,2.209,0,4-1.791,4-4,0,2.209,1.791,4,4,4Z" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" data-color="color-2" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M15,5c-2.209,0-4,1.791-4,4,0-2.209-1.791-4-4-4,2.209,0,4-1.791,4-4,0,2.209,1.791,4,4,4Z" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" data-color="color-2" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M31,21c-2.209,0-4,1.791-4,4,0-2.209-1.791-4-4-4,2.209,0,4-1.791,4-4,0,2.209,1.791,4,4,4Z" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" data-color="color-2" strokeLinecap="butt" strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "AbilityScore® & 7 Readiness Indices",
    URL: "/pinnacleai",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} x1={16} y1={4} x2={16} y2={8} strokeLinejoin="miter" strokeLinecap="butt" /> <line data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} x1="26.607" y1="8.393" x2="23.778" y2="11.222" strokeLinejoin="miter" strokeLinecap="butt" /> <line data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} x1={31} y1={19} x2={27} y2={19} strokeLinejoin="miter" strokeLinecap="butt" /> <line data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} x1={1} y1={19} x2={5} y2={19} strokeLinejoin="miter" strokeLinecap="butt" /> <line data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} x1="13.879" y1="16.879" x2={8} y2={11} strokeLinejoin="miter" strokeLinecap="butt" /> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={16} cy={19} r={3} strokeLinejoin="miter" /> <path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M27.98,28 c1.888-2.509,3.02-5.618,3.02-9c0-8.284-6.716-15-15-15C7.716,4,1,10.716,1,19c0,3.382,1.133,6.491,3.02,9H27.98z" strokeLinejoin="miter" /></g></svg>

    ),
  },
  {
    Title: "TherapeuticAI® Chief Therapist",
    URL: "/pinnacleai",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line x1={10} y1="14.182" x2={10} y2={31} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /> <line x1={22} y1="14.182" x2={22} y2={31} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /> <path d="M25,25l2.6-4.33a1,1,0,0,0-.15-1.222l-4.862-4.862A2,2,0,0,0,21.172,14H10.828a2,2,0,0,0-1.414.586L4.552,19.448A1,1,0,0,0,4.4,20.67L7,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <circle cx={16} cy={6} r={4} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <line x1={16} y1={19} x2={18} y2={19} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /></g></svg>

    ),

  },
  {
    Title: "Everydaya Therapy Programme®",
    URL: "/therapysession?kid={kidid}",
    Roles: "Boss",
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M16,25A14,14,0,0,0,30,11a13.94,13.94,0,0,0-5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M16,25A14,14,0,0,1,2,11a13.94,13.94,0,0,1,5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M2.521,22.9A9.539,9.539,0,0,0,1.31,23.971,9.5,9.5,0,0,0,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><ellipse cx={16} cy="13.4" rx={5} ry="11.599" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M29.479,22.9a9.539,9.539,0,0,1,1.211,1.069A9.5,9.5,0,0,1,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

    ),

  },
];


const Block = ({ children, title, organ }) => (
  <div>
    <div
      style={{
        width: "100vw",
        maxHeight: "180px",
        height: "300px",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      {children}
    </div>
    <div className="meter-bg" style={{ marginTop: 5 }}>
      <span className="desc" style={{ marginBottom: 0, fontSize: 16 }}>
        {title}
      </span>
      <span className="desc acenter">{organ?.name}</span>
    </div>
  </div>
);

// build slides from abilityProgress [{month, percent}] and organ {name}
export function getAbilitySlides(abilityProgress = [], organ) {
  const labels = abilityProgress.map((x) => x.month);
  const values = abilityProgress.map((x) => x.percent);

  // derive max dynamically for scaling
  const maxValue = Math.max(100, ...values);
  const onePoint = labels.length <= 1;

    // use shared utilities
  const barOptions =  baseOptions(maxValue, onePoint);
  const lineOptions =({ ...baseOptions(maxValue, onePoint), ...lineSpecific });

  const data = {
    labels,
    datasets: [
      {
        label: "Scores (Max 100)",
        data: values,
        backgroundColor: COLORS.green,
        borderColor: COLORS.green,
        borderWidth: 1,
        borderRadius: 6,
      },
    ],
  };

  const barSlide = (
    <Block key="bar" title="Progress" organ={organ}>
      <Bar data={data} options={barOptions} />
    </Block>
  );

  const lineSlide = (
    <Block key="line" title="Trend" organ={organ}>
      <Line data={data} options={lineOptions} />
    </Block>
  );

  return [barSlide, lineSlide];
}


export var AllCreationsURL = [
  {
    "Title": "Milestones",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><rect x={3} y={1} fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} width={26} height={30} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={16} y1={11} x2={16} y2={21} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={11} y1={18} x2={11} y2={21} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={21} y1={15} x2={21} y2={21} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,Harvest,NCC,BDC,Receptionist,Therapist,Senior,Boss",
    "URL": "/pinnacleai"
  },
  {
    "Title": "KidStates",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={4} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><path d="M21,12.683c-1.075-1.617-2.913-2.683-5-2.683-2.087,0-3.925,1.066-5,2.683" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><circle cx={7} cy={19} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M7,25c-3.314,0-6,2.686-6,6H13c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><circle cx={25} cy={19} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M25,25c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,Harvest,NCC,BDC,Receptionist,Therapist,Senior,Boss",
    "URL": "/pinnacleai"
  },
  {
    "Title": "SR",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><polygon data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} points=" 17,2 17,15 22,11 31,11 31,2 " strokeLinejoin="miter" /> <circle fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} cx={9} cy={14} r={4} strokeLinejoin="miter" /> <path fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} d="M17,30H1v-4.169 c0-1.229,0.739-2.345,1.885-2.787C4.217,22.53,6.256,22,9,22s4.783,0.53,6.115,1.044C16.261,23.486,17,24.602,17,25.831V30z" strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,FranciseOwner,Harvest,NCC,BDC,Receptionist,Therapist,Senior,Boss,Investor",
    "URL": "/servicerequest"
  },
  {
    "Title": "Lead",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 48 48" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><polyline fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points="22,30 2,30 2,2 42,2 42,15 " strokeLinejoin="miter"></polyline> <ellipse data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="37" cy="24" rx="9" ry="4" strokeLinejoin="miter"></ellipse> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M28,24v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6" strokeLinejoin="miter" strokeLinecap="butt"></path> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M28,30v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6" strokeLinejoin="miter" strokeLinecap="butt"></path> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M28,36v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6" strokeLinejoin="miter" strokeLinecap="butt"></path> <circle fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="22" cy="16" r="4" strokeLinejoin="miter"></circle></g></svg>,
    "Roles": "Owner,FranciseOwner,Harvest,NCC,BDC,Receptionist",
    "URL": "/createlead"
  },
  {
    "Title": "Lead History",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path data-color="color-2" d="M16,6a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h9a1,1,0,0,0,0-2H17V7A1,1,0,0,0,16,6Z" fill="#444444" /><path d="M20.99.8A16.005,16.005,0,0,0,0,16a1,1,0,0,0,1,1H1a1,1,0,0,0,1-1A14.005,14.005,0,0,1,28.5,9.679,14,14,0,0,1,8.073,27.546l2.892-2.892a1,1,0,0,0-.513-1.688l-8.617-1.7A1,1,0,0,0,.658,22.433l1.617,8.7a1,1,0,0,0,1.69.525l2.683-2.683A16,16,0,1,0,20.99.8Z" fill="#444444" /></g></svg>,
    "Roles": "Owner,NCC,BDC",
    "URL": "/hermes"
  },
  {
    "Title": "Invoice",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="38" y1="22" x2="34" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="26" y1="22" x2="22" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="14" y1="22" x2="10" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="38" y1="52" x2="34" y2="52" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="50" y1="22" x2="46" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="50" y1="52" x2="46" y2="52" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="26" y1="52" x2="22" y2="52" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="14" y1="52" x2="10" y2="52" strokeLinejoin="miter"></line> <circle data-stroke="none" fill="#444444" cx="48" cy="37" r="2" strokeLinejoin="miter" strokeLinecap="square"></circle> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M7,15c-2.761,0-5-2.239-5-5 v0c0-2.761,2.239-5,5-5h40v4" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M58,31V15H7 c-2.761,0-5-2.239-5-5v41c0,4.418,3.582,8,8,8h48V43" strokeLinejoin="miter"></path> <path data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M62,43H48 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h14V43z" strokeLinejoin="miter"></path></g></svg>,
    "Roles": "Owner,Receptionist,BDC",
    "URL": "/createinvoice"
  },
  {
    "Title": "Payment",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M24,0H8A3,3,0,0,0,5,3V29a3,3,0,0,0,3,3H24a3,3,0,0,0,3-3h0V3A3,3,0,0,0,24,0Zm1,27a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V5A1,1,0,0,1,8,4H24a1,1,0,0,1,1,1Z" fill="#444444" /><path d="M20.338,16.718a7.477,7.477,0,0,0-2.83-1.657l-.818-.312V10.831a11.528,11.528,0,0,1,3.358.8l.785-1.97a11.843,11.843,0,0,0-4.143-.883V7H15.259V8.8a5.729,5.729,0,0,0-3.137,1.163,3.03,3.03,0,0,0-1.158,2.443,3.444,3.444,0,0,0,.813,2.331,6.355,6.355,0,0,0,2.577,1.619l.9.333v4.023a9.776,9.776,0,0,1-2.218-.315,10.93,10.93,0,0,1-2.163-.758v2.27a11.106,11.106,0,0,0,4.381.819V25h1.431V22.665a5.8,5.8,0,0,0,3.293-1.249,3.288,3.288,0,0,0,1.144-2.567A3.071,3.071,0,0,0,20.338,16.718Zm-5.079-2.5a3.932,3.932,0,0,1-1.384-.808,1.439,1.439,0,0,1-.382-1.023,1.267,1.267,0,0,1,.452-.99,2.528,2.528,0,0,1,1.314-.527Zm1.428,6.414V17.2a4.5,4.5,0,0,1,1.459.781,1.343,1.343,0,0,1,.435,1.028Q18.581,20.341,16.687,20.632Z" fill="#444444" data-color="color-2" /></g></svg>,
    "Roles": "Owner,Receptionist",
    "URL": "/pendinginvoices"
  },
  {
    "Title": "Expense",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><circle data-stroke="none" fill="#444444" cx="48" cy="40" r="2" strokeLinejoin="miter" strokeLinecap="square"></circle> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M7,18c-2.761,0-5-2.239-5-5 v0c0-2.761,2.239-5,5-5h4" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M58,34V18H7 c-2.761,0-5-2.239-5-5v41c0,4.418,3.582,8,8,8h48V46" strokeLinejoin="miter"></path> <path data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M62,46H48 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h14V46z" strokeLinejoin="miter"></path> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points=" 11,13 11,2 51,2 51,13 11,13 " strokeLinejoin="miter"></polyline></g></svg>,
    "Roles": "Owner,Receptionist",
    "URL": "/createexpense"
  },
  {
    "Title": "Royalty",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={27} y1={6} x2={5} y2={6} strokeLinejoin="miter" /> <rect data-color="color-2" x={8} y={18} fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} width={6} height={6} strokeLinejoin="miter" /> <polyline fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="4,13 4,31 18,31 18,22 24,22 24,31 28,31 28,13 " strokeLinejoin="miter" /> <polygon fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="27,6 31,10 31,13 1,13 1,10 5,6 5,1 27,1 " strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,",
    "URL": "/royalty"
  },
  // {
  //   "Title": "Royalty Payment",
  //   "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={27} y1={6} x2={5} y2={6} strokeLinejoin="miter" /> <rect data-color="color-2" x={8} y={18} fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} width={6} height={6} strokeLinejoin="miter" /> <polyline fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="4,13 4,31 18,31 18,22 24,22 24,31 28,31 28,13 " strokeLinejoin="miter" /> <polygon fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="27,6 31,10 31,13 1,13 1,10 5,6 5,1 27,1 " strokeLinejoin="miter" /></g></svg>,
  //   "Roles": "Owner,",
  //   "URL": "/royalty"
  // },
  {
    "Title": "Staff",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M21.427,27.439 C20.464,25.41,18.395,24,16,24H8c-3.314,0-6,2.686-6,6v8l4,2l1,14h11" strokeLinejoin="miter" strokeLinecap="butt"></path> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="12" cy="12" r="6" strokeLinejoin="miter"></circle> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M42.573,27.439 C43.536,25.41,45.605,24,48,24h8c3.314,0,6,2.686,6,6v8l-4,2l-1,14H46" strokeLinejoin="miter" strokeLinecap="butt"></path> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="52" cy="12" r="6" strokeLinejoin="miter"></circle> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M38,62H26l-1-16l-5-1V32 c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v13l-5,1L38,62z" strokeLinejoin="miter"></path> <circle fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="32" cy="10" r="8" strokeLinejoin="miter"></circle></g></svg>,
    "Roles": "Owner,",
    "URL": "/createstaff?type=create"
  },
  {
    "Title": "Parent",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 48 48" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M24,11 c0-4.971,4.029-9,9-9s9,4.029,9,9s-4.029,11-9,11S24,15.971,24,11z" strokeLinejoin="miter"></path> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M26,27.968 C27.905,27.398,30.227,27,33,27c4.986,0,8.258,1.286,10.273,2.553c1.719,1.082,2.727,3,2.727,5.031V46H33" strokeLinejoin="miter" strokeLinecap="butt"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M6,23c0-4.418,3.582-8,8-8 s8,3.582,8,8s-3.582,9-8,9S6,27.418,6,23z" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M26,42.494 c0-1.628-0.977-3.1-2.488-3.705C21.432,37.957,18.141,37,14,37s-7.432,0.957-9.512,1.789C2.977,39.394,2,40.867,2,42.494V46h24 V42.494z" strokeLinejoin="miter"></path></g></svg>,
    "Roles": "Owner,FranciseOwner,Harvest,NCC,BDC,Receptionist",
    "URL": "/createparent"
  },
  {
    "Title": "Services",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 48 48" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M24,8c0-3.3-2.7-6-6-6 c-2.6,0-4.8,1.7-5.6,4c-0.1,0-0.2,0-0.4,0C6.5,6,2,10.5,2,16c0,2.7,1.1,5.1,2.8,6.9C3.1,24,2,25.9,2,28c0,2,1,3.8,2.5,4.9 c-0.3,1-0.5,2-0.5,3.1c0,5.5,4.5,10,10,10s10-4.5,10-10V20" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M24,8c0-3.3,2.7-6,6-6 c2.6,0,4.8,1.7,5.6,4c0.1,0,0.2,0,0.4,0c5.5,0,10,4.5,10,10c0,2.7-1.1,5.1-2.8,6.9C44.9,24,46,25.9,46,28c0,2-1,3.8-2.5,4.9 c0.3,1,0.5,2,0.5,3.1c0,5.5-4.5,10-10,10s-10-4.5-10-10" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M12,26 c-2.8,0-5.4-1.2-7.2-3.1" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M36,26 c2.8,0,5.4-1.2,7.2-3.1" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M24,8c0,3.3-2.7,6-6,6" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M24,8c0,3.3,2.7,6,6,6" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M16,31.7 c-2.3-0.8-4-3-4-5.7c0-1.8,0.8-3.4,2-4.5" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M32,31.7c2.3-0.8,4-3,4-5.7 c0-1.8-0.8-3.4-2-4.5" strokeLinejoin="miter"></path></g></svg>,
    "Roles": "Owner,FranciseOwner,Harvest,NCC,BDC,Receptionist",
    "URL": "/serviceland"
  },
  {
    "Title": "TA",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M13.279,17A7.967,7.967,0,0,1,2.721,17,7.991,7.991,0,0,1,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M18.721,17a7.967,7.967,0,0,0,10.558,0A7.991,7.991,0,0,0,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><circle cx={16} cy={7} r={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><line x1={16} y1={5} x2={16} y2={9} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polygon points="10 23 22 23 21 31 11 31 10 23" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,Harvest",
    "URL": "/talentacquisition"
  },
  {
    "Title": "Memo",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line x1={16} y1={7} x2={16} y2={19} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><circle cx={16} cy="24.5" r="1.5" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><polygon points="22.213 1 9.787 1 1 9.787 1 22.213 9.787 31 22.213 31 31 22.213 31 9.787 22.213 1" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,NCC,BDC,Receptionist",
    "URL": "/publishscreen?t=memo"
  },
  {
    "Title": "Award",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><path data-cap="butt" d="M14.705,28C9.5,28,5,24,5,17V7h9" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" /> <path data-cap="butt" d="M50,7h9V17c0,7-4.5,11-9.7,11" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" /> <line data-color="color-2" x1={32} y1={53} x2={32} y2={46} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /> <path d="M32,41h0A18,18,0,0,1,14,23V3H50V23A18,18,0,0,1,32,41Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /> <path data-color="color-2" d="M18,61c0-4.418,3-8,10-8h8c7,0,10,3.582,10,8Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,NCC,BDC,Receptionist",
    "URL": "/publishscreen?t=award"
  },
  {
    "Title": "Approve Leaves",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx="13.273" cy={8} r={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M22.427,22c-2.279-2.46-5.535-4-9.155-4-6.735,0-12.21,5.33-12.475,12H17" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polyline points="20 27 23 30 30 23" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,FranciseOwner,Harvest,NCC,BDC,Receptionist",
    "URL": "/leaveapprovals"
  },
  {
    "Title": "Adv Invoices",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><polygon fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} points="56,2 8,2 8,60 16,55 24,60 32,55 40,60 48,55 56,60 " strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={18} y1={17} x2={34} y2={17} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={18} y1={29} x2={34} y2={29} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={18} y1={41} x2={34} y2={41} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={42} y1={41} x2={46} y2={41} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={42} y1={29} x2={46} y2={29} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} x1={42} y1={17} x2={46} y2={17} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Owner,FranciseOwner,NCC,BDC,Receptionist",
    "URL": "/AdvancedInvoices"
  },
  {
    "Title": "Book Assess",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth="2"><g strokeWidth="2" transform="translate(0, 0)"><rect x="5" y="5" width="54" height="54" rx="5" ry="5" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></rect> <line data-cap="butt" data-color="color-2" x1="32" y1="30" x2="37" y2="20" fill="none" stroke="#444444" strokeMiterlimit="10" strokeWidth="2" strokeLinecap="butt" strokeLinejoin="miter"></line> <path data-color="color-2" d="M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></path></g></svg>,
    "Roles": "Owner,FranciseOwner,Harvest,NCC,BDC,Receptionist",
    "URL": "/bookassessment"
  },
  {
    "Title": "Leaves",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><line x1={16} y1={2} x2={16} y2={10} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={12} y1={6} x2={20} y2={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><circle cx={7} cy={18} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M7,24c-3.314,0-6,2.686-6,6H13c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><circle cx={25} cy={18} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M25,24c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Harvest,NCC,BDC,Receptionist,Therapist,Senior,Boss",
    "URL": "/leaverequest"
  },
  {
    "Title": "Attendance",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><g className="js-nc-int-icon nc-int-copy-to-clipboard js-nc-int-icon-loaded" strokeWidth={2}><path d="M25,4h1a2,2,0,0,1,2,2V28a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H7" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><rect data-color="color-2" fill="none" height={4} stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} width={10} x={11} y={2} strokeLinejoin="miter" /><polyline data-color="color-2" fill="none" points="10 19 13 22 22 13" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g><style data-cap="butt" strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" dangerouslySetInnerHTML={{ __html: ".nc-int-copy-to-clipboard{--transition-duration:0.3s}.nc-int-copy-to-clipboard :nth-child(3){stroke-dasharray:17px;stroke-dashoffset:17px;transition:stroke-dashoffset var(--transition-duration) cubic-bezier(.77,0,.18,1)}.nc-int-copy-to-clipboard.nc-int-icon-state-b :nth-child(3){stroke-dashoffset:0}" }} /></g></svg>,
    "Roles": "Receptionist,Therapist,Senior",
    "URL": "/aipendingattendance"
  },
  {
    "Title": "Compensation",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><polyline fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points="22,40 2,40 2,2 36,2 36,18 " strokeLinejoin="miter"></polyline> <rect x="28" y="24" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" width="34" height="38" strokeLinejoin="miter"></rect> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M44,10h8c4.418,0,8,3.582,8,8v0" strokeLinejoin="miter" strokeLinecap="butt"></path> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points=" 50,4 44,10 50,16 " strokeLinejoin="miter"></polyline> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M20,54h-8c-4.418,0-8-3.582-8-8 v0" strokeLinejoin="miter" strokeLinecap="butt"></path> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points=" 14,60 20,54 14,48 " strokeLinejoin="miter"></polyline></g></svg>,
    "Roles": "Receptionist,Therapist,Senior,Boss",
    "URL": "/compensation"
  },
  {
    "Title": "Therapist Leave",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth="0.5"><g strokeWidth="0.5" transform="translate(0.5, 0.5)"><polyline data-color="color-2" points="16 13 16 19 22 19" fill="none" stroke="#484141" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="0.5" strokeLinejoin="miter"></polyline> <circle cx="16" cy="19" r="12" fill="none" stroke="#484141" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="0.5" strokeLinejoin="miter"></circle> <line data-color="color-2" x1="12" y1="1" x2="20" y2="1" fill="none" stroke="#484141" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="0.5" strokeLinejoin="miter"></line> <line data-cap="butt" data-color="color-2" x1="16" y1="1" x2="16" y2="4" fill="none" stroke="#484141" strokeMiterlimit="10" strokeWidth="0.5" strokeLinecap="butt" strokeLinejoin="miter"></line> <line data-color="color-2" x1="26" y1="7" x2="28" y2="9" fill="none" stroke="#484141" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="0.5" strokeLinejoin="miter"></line></g></svg>,
    "Roles": "Receptionist",
    "URL": "/therapistleaverequest"
  },
  {
    "Title": "Goal",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path data-cap="butt" fill="none" stroke="#000000" strokeWidth={1} strokeMiterlimit={10} d="M48.255,29 C49.38,31.779,50,34.817,50,38c0,13.255-10.745,24-24,24S2,51.255,2,38s10.745-24,24-24c3.182,0,6.22,0.619,8.999,1.744" strokeLinejoin="miter" strokeLinecap="butt" /> <circle fill="none" stroke="#000000" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={26} cy={38} r={13} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#000000" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={26} y1={38} x2={58} y2={6} strokeLinejoin="miter" /> <polygon data-color="color-2" fill="none" stroke="#000000" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points=" 51,13 49,3 41,11 43,21 53,23 61,15 " strokeLinejoin="miter" /></g></svg>,
    "Roles": "Therapist,Senior",
    "URL": "/pinnacleai"
  },
  {
    "Title": "HomeWork",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><rect x={2} y={2} width={28} height={28} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line x1={30} y1={10} x2={2} y2={10} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line x1={6} y1={22} x2={14} y2={22} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={18} y1={22} x2={26} y2={22} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={6} y1={18} x2={14} y2={18} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={18} y1={18} x2={26} y2={18} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={6} y1={14} x2={14} y2={14} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={18} y1={14} x2={26} y2={14} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={6} y1={26} x2={14} y2={26} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={18} y1={26} x2={26} y2={26} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={6} y1={6} x2={14} y2={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line x1={18} y1={6} x2={26} y2={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Boss",
    "URL": "/parenthomeworkpending"
  },
  {
    "Title": "Credits",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1.5}><g strokeWidth={1.5} transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth={1.5} strokeLinecap="square" strokeMiterlimit={10} d="M9,24L9,24 c-2.209,0-4-1.791-4-4V1h22v19c0,2.209-1.791,4-4,4h0" strokeLinejoin="miter" /> <polygon fill="none" stroke="#444444" strokeWidth={1.5} strokeLinecap="square" strokeMiterlimit={10} points="23,11 9,11 9,5 9,5 23,5 " strokeLinejoin="miter" /> <polygon data-color="color-2" fill="none" stroke="#444444" strokeWidth={1.5} strokeLinecap="square" strokeMiterlimit={10} points=" 23,31 9,31 9,17 23,17 23,17 " strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1.5} strokeLinecap="square" strokeMiterlimit={10} x1={14} y1={17} x2={14} y2={31} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1.5} strokeLinecap="square" strokeMiterlimit={10} x1={18} y1={24} x2={18} y2={27} strokeLinejoin="miter" /></g></svg>,
    "Roles": "Boss",
    "URL": "/AdvancedInvoices"
  },
  {
    "Title": "Comp Assessment",
    "Icon": <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 64 64" strokeWidth="2"><g strokeWidth="2" transform="translate(0, 0)"><rect x="5" y="5" width="54" height="54" rx="5" ry="5" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></rect> <line data-cap="butt" data-color="color-2" x1="32" y1="30" x2="37" y2="20" fill="none" stroke="#444444" strokeMiterlimit="10" strokeWidth="2" strokeLinecap="butt" strokeLinejoin="miter"></line> <path data-color="color-2" d="M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></path></g></svg>,
    "Roles": "Therapist,Senior",
    "URL": "/bookedassessments"
  }
]

export var MileStoneQuestions = [
  {
    "Id": 1,
    "AgeGroup": "Birth to 1 month",
    "Category": "Gross Motor",
    "Question": "Does the baby display equal movement on both sides?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 1
  },
  {
    "Id": 2,
    "AgeGroup": "Birth to 1 month",
    "Category": "Gross Motor",
    "Question": "Does the baby show reflexes like sucking and grasping?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 2
  },
  {
    "Id": 3,
    "AgeGroup": "Birth to 1 month",
    "Category": "Fine Motor",
    "Question": "Exhibits palmar grasp reflex: This primitive reflex involves an infant closing their hand around an object placed in their palm.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 3
  },
  {
    "Id": 4,
    "AgeGroup": "Birth to 1 month",
    "Category": "Fine Motor",
    "Question": "Hand-to-mouth coordination: Infants begin to bring their hands to their mouth as they start to gain control over their arm movements.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 4
  },
  {
    "Id": 5,
    "AgeGroup": "Birth to 1 month",
    "Category": "Communication\/Speech",
    "Question": "Reflexive communication: Expresses through crying, fussing, and other reflexive responses. ",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 5
  },
  {
    "Id": 6,
    "AgeGroup": "Birth to 1 month",
    "Category": "Communication\/Speech",
    "Question": "Alertness to noise: Shows signs of noticing certain sounds.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 6
  },
  {
    "Id": 7,
    "AgeGroup": "Birth to 1 month",
    "Category": "Cognitive",
    "Question": "Does your baby react to bright lights or loud noises?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 7
  },
  {
    "Id": 8,
    "AgeGroup": "Birth to 1 month",
    "Category": "Cognitive",
    "Question": "Have you noticed your baby gazing at faces?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 8
  },
  {
    "Id": 9,
    "AgeGroup": "Birth to 1 month",
    "Category": "Social & Emotional",
    "Question": "Begins to exhibit a differential response to parental stimuli.   E.g. \"Does your baby seem to react differently to your voice or face compared to other sounds or faces?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 9
  },
  {
    "Id": 10,
    "AgeGroup": "Birth to 1 month",
    "Category": "Social & Emotional",
    "Question": "Shows distinct crying patterns for different needs.  E.g. \"Have you noticed different types of crying when your baby is hungry, tired, or uncomfortable?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 10
  },
  {
    "Id": 11,
    "AgeGroup": "Birth to 1 month",
    "Category": "Sensory Development",
    "Question": "Responds to tactile stimuli and exhibits nociceptive (pain) response.\n    E.g. \"Does your baby react to touch or appear uncomfortable when in a certain position?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 11
  },
  {
    "Id": 12,
    "AgeGroup": "Birth to 1 month",
    "Category": "Sensory Development",
    "Question": "Shows sensitivity to bright lights and loud sounds.\n    E.g. \"Does your baby squint or close their eyes in bright light? Do they startle at loud noises?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 12
  },
  {
    "Id": 13,
    "AgeGroup": "1-3 months",
    "Category": "Gross Motor",
    "Question": "Does the baby hold up their head during tummy time?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 13
  },
  {
    "Id": 14,
    "AgeGroup": "1-3 months",
    "Category": "Gross Motor",
    "Question": "Does the baby control movements like kicking and arm waving?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 14
  },
  {
    "Id": 15,
    "AgeGroup": "1-3 months",
    "Category": "Fine Motor",
    "Question": "Hand regard: This is when infants start to notice their hands and observe them.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 16,
    "AgeGroup": "1-3 months",
    "Category": "Fine Motor",
    "Question": "Primitive swiping at objects: Initially, these movements are not directed, but over time they become more purposeful.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 17,
    "AgeGroup": "1-3 months",
    "Category": "Communication\/ Speech",
    "Question": "Cooing: Makes comfort sounds and vowel-like sounds (oo\/ah), often in response to verbal stimulation.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 15
  },
  {
    "Id": 18,
    "AgeGroup": "1-3 months",
    "Category": "Communication\/ Speech",
    "Question": "Attention to speech: Infants display increased attention to speech sounds and may quiet to familiar voices.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 16
  },
  {
    "Id": 19,
    "AgeGroup": "1-3 months",
    "Category": "Cognitive",
    "Question": "Does your baby follow moving objects with their eyes?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 17
  },
  {
    "Id": 20,
    "AgeGroup": "1-3 months",
    "Category": "Cognitive",
    "Question": "Have you noticed your baby losing interest in a toy after playing with it for a while?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 18
  },
  {
    "Id": 21,
    "AgeGroup": "1-3 months",
    "Category": "Social & Emotional",
    "Question": "Exhibits social smiling as a response to social stimuli.\n  E.g. \"Does your baby respond with a smile when you talk or smile at them?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 19
  },
  {
    "Id": 22,
    "AgeGroup": "1-3 months",
    "Category": "Social & Emotional",
    "Question": "Demonstrates self-soothing behaviors.\n  E.g. \"Does your baby calm themselves by sucking their hand or fingers?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 20
  },
  {
    "Id": 23,
    "AgeGroup": "1-3 months",
    "Category": "Sensory Development",
    "Question": "Begins to follow moving objects with eyes.   E.g. \"Does your baby track a toy with their eyes as it moves?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 24,
    "AgeGroup": "1-3 months",
    "Category": "Sensory Development",
    "Question": "Reacts to sounds and begins to turn head towards them.  E.g.  \"Does your baby seem to respond to certain sounds or voices?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 3,
    "RS": "ACTIVE",
    "Sequnce": 21
  },
  {
    "Id": 25,
    "AgeGroup": "3-6 months",
    "Category": "Gross Motor",
    "Question": "Can the baby roll over?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 22
  },
  {
    "Id": 26,
    "AgeGroup": "3-6 months",
    "Category": "Gross Motor",
    "Question": "Can the baby sit with support?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 23
  },
  {
    "Id": 27,
    "AgeGroup": "3-6 months",
    "Category": "Gross Motor",
    "Question": "Does the baby bear weight on their legs?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 28,
    "AgeGroup": "3-6 months",
    "Category": "Fine Motor",
    "Question": "Bilateral reaching: Infants start to reach for objects using both hands simultaneously.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 24
  },
  {
    "Id": 29,
    "AgeGroup": "3-6 months",
    "Category": "Fine Motor",
    "Question": "Begins to show hand preference: Although not definitive at this stage, infants may start to favor one hand over the other.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 30,
    "AgeGroup": "3-6 months",
    "Category": "Fine Motor",
    "Question": "Object transfer from hand to hand: Infants begin to move objects from one hand to the other, demonstrating improved hand coordination.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 25
  },
  {
    "Id": 31,
    "AgeGroup": "3-6 months",
    "Category": "Communication\/ Speech",
    "Question": "Babbling: Begins to produce consonant-vowel combinations, such as \"ba,\" \"ma,\" \"da.\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 26
  },
  {
    "Id": 32,
    "AgeGroup": "3-6 months",
    "Category": "Communication\/ Speech",
    "Question": "Voice imitation: May imitate pitch and volume changes in other people's speech.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 27
  },
  {
    "Id": 33,
    "AgeGroup": "3-6 months",
    "Category": "Cognitive",
    "Question": "Does your baby explore objects by grabbing or mouthing them?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 28
  },
  {
    "Id": 34,
    "AgeGroup": "3-6 months",
    "Category": "Cognitive",
    "Question": "Does your baby shake a rattle to hear the noise it makes?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 29
  },
  {
    "Id": 35,
    "AgeGroup": "3-6 months",
    "Category": "Social & Emotional",
    "Question": "Shows pleasure during social interactions and protests when they end.\n   E.g. \"Does your baby enjoy playtime and seem upset when it's over?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 30
  },
  {
    "Id": 36,
    "AgeGroup": "3-6 months",
    "Category": "Social & Emotional",
    "Question": "Begins to differentiate between familiar individuals and strangers, showing signs of stranger anxiety.\n   E.g. \"Does your baby seem more comfortable with familiar people and anxious around strangers?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 31
  },
  {
    "Id": 37,
    "AgeGroup": "3-6 months",
    "Category": "Sensory Development",
    "Question": "Begins to reach for objects and shows interest in different textures.\n  E.g. \"Does your baby reach for toys or objects? Do they explore different textures?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 32
  },
  {
    "Id": 38,
    "AgeGroup": "3-6 months",
    "Category": "Sensory Development",
    "Question": "Responds to changes in tone of your voice.\n  E.g.  \"Does your baby react differently to changes in the tone of your voice?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 6,
    "RS": "ACTIVE",
    "Sequnce": 33
  },
  {
    "Id": 39,
    "AgeGroup": "6-9 months",
    "Category": "Gross Motor",
    "Question": "Can the baby crawl?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 34
  },
  {
    "Id": 40,
    "AgeGroup": "6-9 months",
    "Category": "Gross Motor",
    "Question": "Can the baby sit without support?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 35
  },
  {
    "Id": 41,
    "AgeGroup": "6-9 months",
    "Category": "Gross Motor",
    "Question": "Does the baby pull up to stand?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 36
  },
  {
    "Id": 42,
    "AgeGroup": "6-9 months",
    "Category": "Fine Motor",
    "Question": "Radial-palmar grasp: Infants can now grasp objects using the thumb and all four fingers.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 37
  },
  {
    "Id": 43,
    "AgeGroup": "6-9 months",
    "Category": "Fine Motor",
    "Question": "Radial-digital grasp: This is the ability to grasp an object using the thumb and just a few fingers, not involving the pinky.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 38
  },
  {
    "Id": 44,
    "AgeGroup": "6-9 months",
    "Category": "Fine Motor",
    "Question": "Voluntary release of objects: Infants begin intentionally letting go of objects, rather than only releasing when they lose their grip.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 39
  },
  {
    "Id": 45,
    "AgeGroup": "6-9 months",
    "Category": "Communication\/ Speech",
    "Question": "Reduplicated babbling: Repeats same syllable (e.g., \"ba ba ba\"). ",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 40
  },
  {
    "Id": 46,
    "AgeGroup": "6-9 months",
    "Category": "Communication\/ Speech",
    "Question": "Understands first words: Although they may not be able to say them, infants often understand a few common words like \"mama\" and \"dada.\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 41
  },
  {
    "Id": 47,
    "AgeGroup": "6-9 months",
    "Category": "Cognitive",
    "Question": "Does your baby look for a toy if you hide it while they are watching?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 42
  },
  {
    "Id": 48,
    "AgeGroup": "6-9 months",
    "Category": "Cognitive",
    "Question": "Does your baby try to imitate your facial expressions or simple actions?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 43
  },
  {
    "Id": 49,
    "AgeGroup": "6-9 months",
    "Category": "Social & Emotional",
    "Question": "Exhibits attachment behaviors toward primary caregivers.\n   E.g. \"Does your baby show a preference for you or other primary caregivers, like reaching out to be picked up?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 44
  },
  {
    "Id": 50,
    "AgeGroup": "6-9 months",
    "Category": "Social & Emotional",
    "Question": "Shows preferential behavior for specific people and objects.\n   E.g. \"Does your baby have favorite people or toys that they prefer over others?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 9,
    "RS": "ACTIVE",
    "Sequnce": 45
  },
  {
    "Id": 51,
    "AgeGroup": "9-12 months",
    "Category": "Gross Motor",
    "Question": "Can the baby stand alone?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 46
  },
  {
    "Id": 52,
    "AgeGroup": "9-12 months",
    "Category": "Gross Motor",
    "Question": "Does the baby cruise around furniture?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 47
  },
  {
    "Id": 53,
    "AgeGroup": "9-12 months",
    "Category": "Gross Motor",
    "Question": "Has the baby taken first steps?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 48
  },
  {
    "Id": 54,
    "AgeGroup": "9-12 months",
    "Category": "Fine Motor",
    "Question": "Pincer grasp: The ability to pick up small objects using the thumb and index finger.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 49
  },
  {
    "Id": 55,
    "AgeGroup": "9-12 months",
    "Category": "Fine Motor",
    "Question": "Neat pincer grasp: The ability to pick up small objects with precision, using the tips of the thumb and index finger.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 50
  },
  {
    "Id": 56,
    "AgeGroup": "9-12 months",
    "Category": "Fine Motor",
    "Question": "Begins to show hand dominance: While not definitive, children may start to consistently favor one hand over the other.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 51
  },
  {
    "Id": 57,
    "AgeGroup": "9-12 months",
    "Category": "Communication\/ Speech",
    "Question": "Variegated babbling: Mixes different sounds and intonations (e.g., \"ba ma goo\").",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 52
  },
  {
    "Id": 58,
    "AgeGroup": "9-12 months",
    "Category": "Communication\/ Speech",
    "Question": "Gesture use: Frequently uses gestures to communicate, such as waving or pointing.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 53
  },
  {
    "Id": 59,
    "AgeGroup": "9-12 months",
    "Category": "Cognitive",
    "Question": "Does your baby try different ways to reach or obtain a toy?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 54
  },
  {
    "Id": 60,
    "AgeGroup": "9-12 months",
    "Category": "Cognitive",
    "Question": "Does your baby mimic complex actions, like clapping hands?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 55
  },
  {
    "Id": 61,
    "AgeGroup": "9-12 months",
    "Category": "Social & Emotional",
    "Question": "May exhibit separation anxiety when apart from primary caregivers.\n   E.g. \"Does your baby cry or show signs of distress when you leave the room?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 56
  },
  {
    "Id": 63,
    "AgeGroup": "9-12 months",
    "Category": "Social & Emotional",
    "Question": "Displays a range of basic emotions such as happiness, sadness, and anger.\n   E.g. \"Does your baby show clear signs of different emotions, like laughing when happy or crying when upset?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 57
  },
  {
    "Id": 64,
    "AgeGroup": "9-12 months",
    "Category": "Sensory Development",
    "Question": "Develops depth perception and hand-eye coordination.\n  E.g. \"Does your baby reach accurately for objects?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "ACTIVE",
    "Sequnce": 58
  },
  {
    "Id": 65,
    "AgeGroup": "9-12 months",
    "Category": "Sensory Development",
    "Question": "Starts to develop an understanding of object permanence.\n  E.g. \"Does your baby look for toys that have been covered up or hidden?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 12,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 66,
    "AgeGroup": "12-18 months",
    "Category": "Gross Motor",
    "Question": "Can the baby walk independently?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 59
  },
  {
    "Id": 67,
    "AgeGroup": "12-18 months",
    "Category": "Gross Motor",
    "Question": "Does the baby squat to pick up toys?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 60
  },
  {
    "Id": 68,
    "AgeGroup": "12-18 months",
    "Category": "Gross Motor",
    "Question": "Can the baby climb stairs with help?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 61
  },
  {
    "Id": 69,
    "AgeGroup": "12-18 months",
    "Category": "Fine Motor",
    "Question": "Mature pincer grasp: The ability to manipulate small objects with the thumb and index finger, such as turning a page in a book.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 62
  },
  {
    "Id": 70,
    "AgeGroup": "12-18 months",
    "Category": "Fine Motor",
    "Question": "Scribbles on paper: The child begins mark-making, often using a whole-hand grasp to control the writing instrument.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 63
  },
  {
    "Id": 71,
    "AgeGroup": "12-18 months",
    "Category": "Communication\/ Speech",
    "Question": "First words: Begins to use one or more words consistently, and those words have meaning to them.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 64
  },
  {
    "Id": 72,
    "AgeGroup": "12-18 months",
    "Category": "Communication\/ Speech",
    "Question": "Receptive vocabulary: Understands simple instructions, particularly if vocal cues are accompanied by gestures.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 65
  },
  {
    "Id": 73,
    "AgeGroup": "12-18 months",
    "Category": "Cognitive",
    "Question": "If you hide a toy under a blanket, does your child look for it?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 74,
    "AgeGroup": "12-18 months",
    "Category": "Cognitive",
    "Question": "Does your child pretend to talk on a toy phone or feed a doll?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 66
  },
  {
    "Id": 75,
    "AgeGroup": "12-18 months",
    "Category": "Social & Emotional",
    "Question": "Shows a wider range of emotions, including complex ones like defiance.\n   E.g. \"Has your child started to test boundaries or say 'no'?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 67
  },
  {
    "Id": 76,
    "AgeGroup": "12-18 months",
    "Category": "Social & Emotional",
    "Question": "Begins to exhibit signs of empathy.\n   E.g. \"Does your child seem to react when they see others upset, like patting another child's back if they're crying?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 68
  },
  {
    "Id": 77,
    "AgeGroup": "12-18 months",
    "Category": "Sensory Development",
    "Question": "Begins to recognize self in mirror.\n  - \"Does your child recognize themselves in the mirror?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 69
  },
  {
    "Id": 78,
    "AgeGroup": "12-18 months",
    "Category": "Sensory Development",
    "Question": "Shows an increase in coordination, such as stacking blocks or using simple tools.\n  - \"Can your child stack blocks or use a spoon?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 18,
    "RS": "ACTIVE",
    "Sequnce": 70
  },
  {
    "Id": 79,
    "AgeGroup": "18-24 months",
    "Category": "Gross Motor",
    "Question": "Can the baby run stably?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 71
  },
  {
    "Id": 80,
    "AgeGroup": "18-24 months",
    "Category": "Gross Motor",
    "Question": "Can the baby kick a ball?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 72
  },
  {
    "Id": 81,
    "AgeGroup": "18-24 months",
    "Category": "Gross Motor",
    "Question": "Can the baby jump off the ground?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 73
  },
  {
    "Id": 82,
    "AgeGroup": "18-24 months",
    "Category": "Gross Motor",
    "Question": "Can the baby climb furniture without help?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 74
  },
  {
    "Id": 83,
    "AgeGroup": "18-24 months",
    "Category": "Fine Motor",
    "Question": "Two-block tower: The child can stack two blocks or similar objects one on top of the other.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 75
  },
  {
    "Id": 84,
    "AgeGroup": "18-24 months",
    "Category": "Fine Motor",
    "Question": "Vertical stroke: The child can imitate a vertical stroke with a crayon or pencil.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 76
  },
  {
    "Id": 85,
    "AgeGroup": "18-24 months",
    "Category": "Communication\/ Speech",
    "Question": "Two-word combinations: Begins to put two words together to form mini sentences (e.g., \"more cookie\").",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 77
  },
  {
    "Id": 86,
    "AgeGroup": "18-24 months",
    "Category": "Communication\/ Speech",
    "Question": "Vocabulary growth: Rapid increase in word learning, known as the \"vocabulary spurt.\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 78
  },
  {
    "Id": 87,
    "AgeGroup": "18-24 months",
    "Category": "Cognitive",
    "Question": "Does your child sort toys by color or shape?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 79
  },
  {
    "Id": 88,
    "AgeGroup": "18-24 months",
    "Category": "Cognitive",
    "Question": "Does your child engage in pretend play, like making a toy animal 'eat' pretend food?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 80
  },
  {
    "Id": 89,
    "AgeGroup": "18-24 months",
    "Category": "Social & Emotional",
    "Question": "Begins to understand possession and may show territorial behaviors.\n   E.g. \"Does your child understand the concept of 'mine' and 'yours'?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 81
  },
  {
    "Id": 90,
    "AgeGroup": "18-24 months",
    "Category": "Social & Emotional",
    "Question": "Demonstrates parallel play (playing alongside other children, not with them).\n   E.g. \"Does your child play next to other children, even if they're not playing together?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 24,
    "RS": "ACTIVE",
    "Sequnce": 82
  },
  {
    "Id": 91,
    "AgeGroup": "2-3 years",
    "Category": "Gross Motor",
    "Question": "Can the child climb stairs step by step with support?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 83
  },
  {
    "Id": 92,
    "AgeGroup": "2-3 years",
    "Category": "Gross Motor",
    "Question": "Can the child pedal a tricycle?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 84
  },
  {
    "Id": 93,
    "AgeGroup": "2-3 years",
    "Category": "Gross Motor",
    "Question": "Can the child run and dodge obstacles?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 85
  },
  {
    "Id": 94,
    "AgeGroup": "2-3 years",
    "Category": "Gross Motor",
    "Question": "Can the child stand on one foot momentarily?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 86
  },
  {
    "Id": 95,
    "AgeGroup": "2-3 years",
    "Category": "Fine Motor",
    "Question": "Can draw a circular motion and starts to create circular scribbles.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 87
  },
  {
    "Id": 96,
    "AgeGroup": "2-3 years",
    "Category": "Fine Motor",
    "Question": "Can string large beads: This demonstrates improved hand-eye coordination and fine motor control.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 88
  },
  {
    "Id": 97,
    "AgeGroup": "2-3 years",
    "Category": "Fine Motor",
    "Question": "Uses a palmar-supinate grasp to hold a crayon: This involves holding the crayon with the palm facing down and the wrist bent back slightly.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 89
  },
  {
    "Id": 98,
    "AgeGroup": "2-3 years",
    "Category": "Communication\/ Speech",
    "Question": "Sentence length: Starts using three- and four-word sentences.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 90
  },
  {
    "Id": 99,
    "AgeGroup": "2-3 years",
    "Category": "Communication\/ Speech",
    "Question": "Vocabulary expansion: Vocabulary typically ranges from 200 to 1,000 words.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 91
  },
  {
    "Id": 100,
    "AgeGroup": "2-3 years",
    "Category": "Communication\/ Speech",
    "Question": "Plurals and pronouns: Begins to correctly use plurals and pronouns (though mistakes are common).",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 92
  },
  {
    "Id": 101,
    "AgeGroup": "2-3 years",
    "Category": "Cognitive",
    "Question": "Can your child count or recognize numbers?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 93
  },
  {
    "Id": 102,
    "AgeGroup": "2-3 years",
    "Category": "Cognitive",
    "Question": "Does your child understand basic time concepts like morning, afternoon, and night?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 94
  },
  {
    "Id": 103,
    "AgeGroup": "2-3 years",
    "Category": "Social & Emotional",
    "Question": "Begins to engage in associative play (sharing materials and following themes, but not yet working toward a common goal).\n   E.g. \"Does your child share toys and follow similar themes in play as other children, even if they're not coordinating their play yet?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 95
  },
  {
    "Id": 104,
    "AgeGroup": "2-3 years",
    "Category": "Social & Emotional",
    "Question": "Expresses a wide range of emotions, which may include intense tantrums.\n   E.g. \"Does your child show a variety of emotions and sometimes have temper tantrums?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 96
  },
  {
    "Id": 105,
    "AgeGroup": "2-3 years",
    "Category": "Sensory Development",
    "Question": "Develops the ability to recognize and match similar shapes and colors.\n  - \"Can your child match and name simple shapes and colors?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 97
  },
  {
    "Id": 106,
    "AgeGroup": "2-3 years",
    "Category": "Sensory Development",
    "Question": "Begins to develop a sense of balance and coordination.\n  - \"Can your child balance on one foot or walk on tiptoes?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 36,
    "RS": "ACTIVE",
    "Sequnce": 98
  },
  {
    "Id": 107,
    "AgeGroup": "3-4 years",
    "Category": "Gross Motor",
    "Question": "Can the child hop and stand on one foot?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 99
  },
  {
    "Id": 108,
    "AgeGroup": "3-4 years",
    "Category": "Gross Motor",
    "Question": "Can the child climb stairs step by step without support?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 100
  },
  {
    "Id": 109,
    "AgeGroup": "3-4 years",
    "Category": "Gross Motor",
    "Question": "Can the child walk on tiptoes?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 101
  },
  {
    "Id": 110,
    "AgeGroup": "3-4 years",
    "Category": "Gross Motor",
    "Question": "Can the child catch a large bouncing ball?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 102
  },
  {
    "Id": 111,
    "AgeGroup": "3-4 years",
    "Category": "Fine Motor",
    "Question": "Can cut across a piece of paper using scissors: This is a complex task that requires coordinated use of both hands and good fine motor control.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 103
  },
  {
    "Id": 112,
    "AgeGroup": "3-4 years",
    "Category": "Fine Motor",
    "Question": "Can copy a circle and a cross: This demonstrates improved control of drawing tools.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 104
  },
  {
    "Id": 113,
    "AgeGroup": "3-4 years",
    "Category": "Communication\/ Speech",
    "Question": "Complex sentences: Begins using sentences with four or more words. Sentences may include more complex ideas through the use of conjunctions (e.g., \"and,\" \"but\").",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 105
  },
  {
    "Id": 114,
    "AgeGroup": "3-4 years",
    "Category": "Communication\/ Speech",
    "Question": "Understanding of prepositions: Shows understanding of spatial prepositions, such as \"in,\" \"on,\" \"under.\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 115,
    "AgeGroup": "3-4 years",
    "Category": "Cognitive",
    "Question": "Can your child sort objects by different categories like color and shape?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 106
  },
  {
    "Id": 116,
    "AgeGroup": "3-4 years",
    "Category": "Cognitive",
    "Question": "Does your child realize that others can have different thoughts and feelings?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 107
  },
  {
    "Id": 117,
    "AgeGroup": "3-4 years",
    "Category": "Social & Emotional",
    "Question": "Engages in cooperative play (working together toward a common goal).\n   E.g. \"Does your child play games with other children where they need to work together, like building a tower of blocks?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 108
  },
  {
    "Id": 118,
    "AgeGroup": "3-4 years",
    "Category": "Social & Emotional",
    "Question": "Begins to understand and occasionally exhibit sharing behaviors.\n   E.g. \"Does your child understand the concept of taking turns or sharing toys?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 109
  },
  {
    "Id": 119,
    "AgeGroup": "3-4 years",
    "Category": "Sensory Development",
    "Question": "Shows increased manual dexterity, such as using scissors or drawing shapes.\n  - \"Can your child manipulate small objects or start to use scissors?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 110
  },
  {
    "Id": 120,
    "AgeGroup": "3-4 years",
    "Category": "Sensory Development",
    "Question": "Begins to develop spatial awareness and understand concept of time.\n  - \"Does your child understand 'near' and 'far', 'before' and 'after'?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 48,
    "RS": "ACTIVE",
    "Sequnce": 111
  },
  {
    "Id": 121,
    "AgeGroup": "4-5 years",
    "Category": "Gross Motor",
    "Question": "Can the child hop consecutively?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 112
  },
  {
    "Id": 122,
    "AgeGroup": "4-5 years",
    "Category": "Gross Motor",
    "Question": "Can the child balance on one foot for 10 seconds?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 113
  },
  {
    "Id": 123,
    "AgeGroup": "4-5 years",
    "Category": "Gross Motor",
    "Question": "Can the child run smoothly?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 114
  },
  {
    "Id": 124,
    "AgeGroup": "4-5 years",
    "Category": "Gross Motor",
    "Question": "Can the child catch a small bouncing ball?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 115
  },
  {
    "Id": 125,
    "AgeGroup": "4-5 years",
    "Category": "Fine Motor",
    "Question": "Can cut out simple shapes: This shows further development of fine motor skills and hand-eye coordination.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 116
  },
  {
    "Id": 126,
    "AgeGroup": "4-5 years",
    "Category": "Fine Motor",
    "Question": "Can copy some capital letters: This requires good fine motor control and the understanding of more complex shapes.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 117
  },
  {
    "Id": 127,
    "AgeGroup": "4-5 years",
    "Category": "Communication\/ Speech",
    "Question": "Fluent speech: Most speech is intelligible and has appropriate rhythm and rate.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 118
  },
  {
    "Id": 128,
    "AgeGroup": "4-5 years",
    "Category": "Communication\/ Speech",
    "Question": "Narrative skills: Can tell a simple story using complete sentences.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 119
  },
  {
    "Id": 129,
    "AgeGroup": "4-5 years",
    "Category": "Cognitive",
    "Question": "Does your child understand that the amount of water remains the same whether it's in a tall glass or a short wide bowl?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 130,
    "AgeGroup": "4-5 years",
    "Category": "Cognitive",
    "Question": "Can your child solve simple math problems using physical objects, like blocks or fingers?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 120
  },
  {
    "Id": 131,
    "AgeGroup": "4-5 years",
    "Category": "Social & Emotional",
    "Question": "Can verbally identify and discuss their own emotions and those of others.\n   E.g. \"Can your child talk about how they're feeling? Can they understand how others might feel in different situations?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 121
  },
  {
    "Id": 132,
    "AgeGroup": "4-5 years",
    "Category": "Social & Emotional",
    "Question": "Shows increasing independence and may start to form friendships.\n   E.g. \"Does your child show signs of independence? Do they have any favorite friends they prefer to play with?\"\n",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "ACTIVE",
    "Sequnce": 122
  },
  {
    "Id": 133,
    "AgeGroup": "4-5 years",
    "Category": "Sensory Development",
    "Question": "Exhibits refined visual perceptual skills, such as identifying letters and numbers.\n  - \"Can your child recognize and name common letters and numbers?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 134,
    "AgeGroup": "4-5 years",
    "Category": "Sensory Development",
    "Question": "Demonstrates understanding of more complex spatial relationships, like 'under', 'above', 'behind'.\n  - \"Can your child understand and follow instructions related to spatial relationships?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 60,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 135,
    "AgeGroup": "5-6 years",
    "Category": "Gross Motor",
    "Question": "Can the child skip and gallop?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 123
  },
  {
    "Id": 136,
    "AgeGroup": "5-6 years",
    "Category": "Gross Motor",
    "Question": "Can the child balance on one foot for more than 10 seconds?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 137,
    "AgeGroup": "5-6 years",
    "Category": "Gross Motor",
    "Question": "Can the child swing and climb with agility?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 124
  },
  {
    "Id": 138,
    "AgeGroup": "5-6 years",
    "Category": "Fine Motor",
    "Question": "Can write some or all letters and numbers: This is a complex task that involves cognitive understanding as well as fine motor control.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 125
  },
  {
    "Id": 139,
    "AgeGroup": "5-6 years",
    "Category": "Fine Motor",
    "Question": "Can cut out a wider range of shapes: This demonstrates further development of fine motor skills.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 126
  },
  {
    "Id": 140,
    "AgeGroup": "5-6 years",
    "Category": "Communication\/ Speech",
    "Question": "Language complexity: Uses complex sentences, understands and uses conditional phrases (e.g., \"if...then\").",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 127
  },
  {
    "Id": 141,
    "AgeGroup": "5-6 years",
    "Category": "Communication\/ Speech",
    "Question": "Understanding of temporal sequences: Understands order of events and can retell a story in order.",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 128
  },
  {
    "Id": 142,
    "AgeGroup": "5-6 years",
    "Category": "Cognitive",
    "Question": "Can your child think hypothetically or make predictions about the future?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 129
  },
  {
    "Id": 143,
    "AgeGroup": "5-6 years",
    "Category": "Cognitive",
    "Question": "Does your child understand that if they were to first add two blocks to a pile of three blocks and then remove those two blocks, they would end up with the original three blocks?",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 144,
    "AgeGroup": "5-6 years",
    "Category": "Social & Emotional",
    "Question": "Begins to understand and conform to social norms and rules.\n   E.g. \"Does your child understand common rules and expectations, like waiting their turn?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 130
  },
  {
    "Id": 145,
    "AgeGroup": "5-6 years",
    "Category": "Social & Emotional",
    "Question": "Exhibits improved emotional self-regulation.\n   E.g. \"Does your child show more control over their emotions, like calming down more quickly after being upset?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 131
  },
  {
    "Id": 146,
    "AgeGroup": "5-6 years",
    "Category": "Sensory Development",
    "Question": "Shows mature fine motor skills, such as tying shoelaces.\n  - \"Can your child complete tasks that require fine motor skills, like buttoning a shirt or tying shoelaces?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "ACTIVE",
    "Sequnce": 132
  },
  {
    "Id": 147,
    "AgeGroup": "5-6 years",
    "Category": "Sensory Development",
    "Question": "Exhibits mature spatial and temporal understanding, such as understanding maps or sequencing events.\n  - \"Can your child follow along with a simple map? Can they understand and sequence events in a story?\"",
    "Type": "Radio",
    "Options": "Yes,No",
    "Age": 72,
    "RS": "DELETEACTIVITY"
  },
  {
    "Id": 148,
    "AgeGroup": "Learning Style",
    "Category": "Learning Style",
    "Question": "Child's preferred learning style",
    "Type": "Radio",
    "Options": "Visual-Spatial Learners: \n    - Does your child remember visuals well like images or diagrams?\n   - Do they enjoy drawing painting or watching videos?\n    - Do they organize their thoughts by creating mind maps or flowcharts?,\nAuditory-Musical Learners:\n    - Does your child remember information better after hearing it?\n    - Do they enjoy songs rhythms or rhymes?\n    - Do they prefer to have stories read out loud to them?,\nVerbal-Linguistic Learners:\n    - Does your child enjoy reading and writing?\n    - Do they express themselves well in words both spoken and written?\n    - Do they enjoy word games poetry or journaling?,\nPhysical-Kinesthetic Learners:\n    - Does your child learn by doing and touching?\n    - Do they enjoy hands-on activities or crafts?\n    - Do they move around a lot while thinking or expressing a point?,\n Logical-Mathematical Learners:\n    - Does your child enjoy working with numbers patterns or puzzles?\n    - Do they like to conduct experiments or figure out how things work?\n    - Do they prefer structured environments and logical reasoning?,\nSocial-Interpersonal Learners:\n    - Does your child enjoy group activities and discussions?\n    - Do they learn better when they can share and collaborate with others?\n    - Do they often seek advice from family members or friends when facing difficulties?,\nSolitary-Intrapersonal Learners:\n    - Does your child prefer studying alone or need quiet time for reflection?\n    - Do they enjoy independent tasks like reading or creative writing?\n    - Do they understand their feelings and thoughts better when they have some alone time?",
    "Age": 1,
    "RS": "ACTIVE",
    "Sequnce": 133
  }
];

export const InclusiveCategories = [

  {
    key: "primary_school", title: "Primary", pending: 0, URL: "/inclusiveleaderscategories?type=primary_school", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>abc</title><g><path fill="#E86C60" d="M30,22h-7c-3.86,0-7-3.141-7-7s3.14-7,7-7h7c1.104,0,2,0.896,2,2v10C32,21.104,31.104,22,30,22z M23,12 c-1.654,0-3,1.346-3,3s1.346,3,3,3h5v-6H23z" /> <path fill="#E86C60" d="M30,22c-1.104,0-2-0.896-2-2V8c0-1.103-0.897-2-2-2h-4c-1.104,0-2-0.896-2-2s0.896-2,2-2h4 c3.309,0,6,2.691,6,6v12C32,21.104,31.104,22,30,22z" /> <path fill="#72C472" d="M6,46c-1.104,0-2-0.896-2-2V22c0-1.104,0.896-2,2-2s2,0.896,2,2v22C8,45.104,7.104,46,6,46z" /> <path fill="#72C472" d="M12,46H6c-1.104,0-2-0.896-2-2V32c0-1.104,0.896-2,2-2h6c4.411,0,8,3.589,8,8S16.411,46,12,46z M8,42h4 c2.206,0,4-1.794,4-4s-1.794-4-4-4H8V42z" /> <path fill="#43A6DD" d="M40,46h-4c-3.309,0-6-2.691-6-6v-6c0-3.309,2.691-6,6-6h4c2.134,0,4.124,1.147,5.194,2.995 c0.554,0.956,0.228,2.18-0.728,2.733c-0.956,0.553-2.18,0.228-2.733-0.728C41.376,32.384,40.711,32,40,32h-4c-1.103,0-2,0.897-2,2v6 c0,1.103,0.897,2,2,2h4c0.712,0,1.376-0.384,1.734-1.002c0.553-0.956,1.776-1.282,2.733-0.729c0.956,0.553,1.282,1.776,0.729,2.732 C44.125,44.852,42.134,46,40,46z" /></g></svg>


  },

  {
    key: "school", title: "Schools", pending: 0, URL: "/inclusiveleaderscategories?type=school", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>white-house</title><g><path d="M35,45V27a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1V45a1,1,0,0,1-1,1H36A1,1,0,0,1,35,45Z" fill="#b3b3b3" /><path d="M12,46H3a1,1,0,0,1-1-1V27a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1V45A1,1,0,0,1,12,46Z" fill="#b3b3b3" /><path d="M36,46H12a1,1,0,0,1-1-1V22a1,1,0,0,1,1-1H36a1,1,0,0,1,1,1V45A1,1,0,0,1,36,46Z" fill="#b3b3b3" /><path d="M24,14a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1V13A1,1,0,0,1,24,14Z" fill="#4c4c4c" /><path d="M33,9H25V2h8a1,1,0,0,1,1,1V8A1,1,0,0,1,33,9Z" fill="#f74b3b" /><path d="M40,23H8a1,1,0,0,1-.529-1.848l16-10a1,1,0,0,1,1.06,0l16,10A1,1,0,0,1,40,23Z" fill="#e3e3e3" /><rect x={10} y={23} width={4} height={23} fill="#e3e3e3" /><rect x={34} y={23} width={4} height={23} fill="#e3e3e3" /><rect x={18} y={23} width={4} height={23} fill="#e3e3e3" /><rect x={26} y={23} width={4} height={23} fill="#e3e3e3" /><rect x={10} y={44} width={28} height={2} fill="#e3e3e3" /><path d="M14.314,46A7,7,0,1,0,1,43a6.932,6.932,0,0,0,.686,3Z" fill="#49c549" /><path d="M33.686,46a7,7,0,1,1,12.628,0Z" fill="#49c549" /><rect x={10} y={23} width={4} height={3} fill="#c8c8c8" /><rect x={18} y={23} width={4} height={3} fill="#c8c8c8" /><rect x={26} y={23} width={4} height={3} fill="#c8c8c8" /><rect x={14} y={23} width={4} height={3} fill="#949494" /><rect x={22} y={23} width={4} height={3} fill="#949494" /><rect x={30} y={23} width={4} height={3} fill="#949494" /><rect x={34} y={23} width={4} height={3} fill="#c8c8c8" /></g></svg>

  },
  {
    key: "hospital", title: "Hospitals", pending: 0, URL: "/inclusiveleaderscategories?type=hospital", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>gym</title><g><polygon points="27 3 33 6 27 9 27 3" fill="#ed7064" /> <path d="M24,14a1,1,0,0,1-1-1V3a1,1,0,0,1,2,0V13A1,1,0,0,1,24,14Z" fill="#b3b3b3" /> <path d="M46,45H2a1,1,0,0,1,0-2H46a1,1,0,0,1,0,2Z" fill="#72c472" /> <path d="M38,12H10a5,5,0,0,0-5,5V41H43V17A5,5,0,0,0,38,12Z" fill="#e6e6e6" /> <rect x={22} y={19} width={4} height={4} rx={1} ry={1} fill="#47b0ea" /> <rect x={13} y={19} width={4} height={4} rx={1} ry={1} fill="#47b0ea" /> <rect x={31} y={19} width={4} height={4} rx={1} ry={1} fill="#47b0ea" /> <path d="M29,41V30a1,1,0,0,0-1-1H20a1,1,0,0,0-1,1V41Z" fill="#335262" /></g></svg>
  },
  // { key: "book_store", title: "Book Stores", pending: 0, URL: "/inclusiveleaderscategories?type=book_store",svg:<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>books-46</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" strokeMiterlimit={10}><line fill="none" stroke="#212121" strokeWidth={2} x1={10} y1={16} x2={15} y2={16} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={25} y1={12} x2={25} y2={20} /> <rect x={5} y={12} fill="none" stroke="#212121" strokeWidth={2} width={26} height={8} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={6} y1={24} x2={11} y2={24} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={21} y1={20} x2={21} y2={28} /> <rect x={1} y={20} fill="none" stroke="#212121" strokeWidth={2} width={26} height={8} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={6} y1={8} x2={11} y2={8} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={21} y1={4} x2={21} y2={12} /> <rect x={1} y={4} fill="none" stroke="#212121" strokeWidth={2} width={26} height={8} /></g></svg>},
  {
    key: "doctor", title: "Doctors", pending: 0, URL: "/inclusiveleaderscategories?type=doctor", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bag-49</title><g><path fill="#B3B3B3" d="M44,45H4c-0.553,0-1-0.448-1-1v-8c0-0.552,0.447-1,1-1h40c0.553,0,1,0.448,1,1v8C45,44.552,44.553,45,44,45z " /> <path fill="#B3B3B3" d="M32,13c-0.553,0-1-0.448-1-1V5H17v7c0,0.552-0.447,1-1,1s-1-0.448-1-1V4c0-0.552,0.447-1,1-1h16 c0.553,0,1,0.448,1,1v8C33,12.552,32.553,13,32,13z" /> <path fill="#E6E6E6" d="M46,37H2c-0.552,0-1-0.448-1-1V12c0-0.552,0.448-1,1-1h44c0.552,0,1,0.448,1,1v24C47,36.552,46.552,37,46,37 z" /> <path fill="#00b14f" d="M29,22h-3v-3c0-0.552-0.448-1-1-1h-2c-0.552,0-1,0.448-1,1v3h-3c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1 h3v3c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-3h3c0.552,0,1-0.448,1-1v-2C30,22.448,29.552,22,29,22z" /></g></svg>



  },

  //{ key: "secondary_school", title: "Secondary Schools", pending: 0, URL: "/inclusiveleaderscategories?type=secondary_school",svg:<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>backpack-58</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" strokeMiterlimit={10}><polyline fill="none" stroke="#212121" strokeWidth={2} points=" 11,6 11,1 21,1 21,6 " /> <polyline fill="none" stroke="#212121" strokeWidth={2} points="28,26 28,31 4,31 4,26 " /> <path fill="none" stroke="#212121" strokeWidth={2} d="M27,22H5 c-1.657,0-3-1.343-3-3V6h28v13C30,20.657,28.657,22,27,22z" /> <line fill="none" stroke="#212121" strokeWidth={2} x1={8} y1={18} x2={12} y2={18} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={10} y1={18} x2={10} y2={26} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={20} y1={18} x2={24} y2={18} /> <line fill="none" stroke="#212121" strokeWidth={2} x1={22} y1={18} x2={22} y2={26} /> <rect x={11} y={10} fill="none" stroke="#212121" strokeWidth={2} width={10} height={4} /></g></svg>
  //},
  {
    key: "physiotherapist", title: "Physio", pending: 0, URL: "/inclusiveleaderscategories?type=physiotherapist", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>recycling</title><g><path fill="#4DA34D" d="M20,35H9l-3,8h14c0.55231,0,1-0.44775,1-1v-6C21,35.44769,20.55231,35,20,35z" /> <path fill="#4DA34D" d="M47,36l-7.23163-15.40625c-0.23488-0.50697-0.8396-0.72312-1.34262-0.47992l-5.55053,2.68358 c-0.49265,0.23819-0.70237,0.82812-0.4706,1.32383l5.87664,12.56625L47,36z" /> <path fill="#72C472" d="M30.12371,45.99853l-5.81568-6.64649c-0.17334-0.1981-0.1634-0.49667,0.02274-0.68281l5.81568-5.81568 C30.46143,32.53857,31,32.76165,31,33.20711V36h16l-3.71208,6.49614C43.10988,42.80771,42.77853,43,42.41968,43H31v2.66928 C31,46.13096,30.42773,46.34598,30.12371,45.99853z" /> <path fill="#72C472" d="M3.58378,24.06916l8.17743-2.80084c0.25835-0.08849,0.53991,0.04668,0.63244,0.30361l2.96533,8.234 c0.15055,0.41804-0.27821,0.8101-0.68114,0.62284l-2.5904-1.20382L6,43l-4.66086-6.5252 c-0.20956-0.29338-0.24497-0.67686-0.09267-1.00366l4.42037-9.48487l-2.13176-0.99065 C3.12664,24.80581,3.15769,24.2151,3.58378,24.06916z" /> <path fill="#4DA34D" d="M17.64853,1.01617l-7.60955,14.68772c-0.26031,0.50321-0.05099,1.12195,0.46134,1.36378l5.55786,2.6234 c0.48956,0.23108,1.07413,0.03062,1.31885-0.45227L23.375,7.375L17.64853,1.01617z" /> <path fill="#72C472" d="M36.02328,10.09075l-1.91426,8.42922c-0.06048,0.26632-0.32346,0.43484-0.59069,0.37852l-8.56359-1.80464 c-0.43475-0.09162-0.54298-0.66239-0.17195-0.9068l2.3855-1.57143L17.64853,1.01617l9.59552,0.00135 c0.36312,0.00005,0.69769,0.19694,0.87403,0.51438l5.1797,9.32394l1.9628-1.29333 C35.6367,9.31468,36.12302,9.65151,36.02328,10.09075z" /></g></svg>

  },
  {
    key: "dentist", title: "Dentists", pending: 0, URL: "/inclusiveleaderscategories?type=dentist", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>tooth</title><g><path fill="#00b14f" d="M40.189,45c-1.986,0-3.407-1.423-4.077-2.271l-7.694-9.107C26.886,31.835,25.481,31,24,31 c-1.863,0-3.427,1.421-4.411,2.614l-7.722,9.141C10.567,44.249,9.206,45,7.811,45C5.158,45,3,42.842,3,40.189l1.986-20.094 C4.652,18.944,3,13.083,3,10c0-3.86,3.14-7,7-7c1.508,0,4.396,0.69,8.584,2.052c3.507,1.139,7.322,1.14,10.831,0 C33.604,3.69,36.492,3,38,3c3.86,0,7,3.14,7,7c0,3.083-1.652,8.944-1.986,10.094l1.981,19.996C45,42.842,42.842,45,40.189,45z" /> <path fill="#ffffff" d="M23.993,15.913c-2.094-0.002-4.186-0.243-6.22-0.716c-0.538-0.125-0.873-0.663-0.748-1.201 c0.125-0.539,0.662-0.871,1.201-0.748c1.887,0.439,3.827,0.663,5.767,0.665c1.948-0.002,3.893-0.226,5.781-0.665 c0.535-0.125,1.076,0.209,1.201,0.748c0.125,0.538-0.209,1.076-0.748,1.201C28.192,15.67,26.094,15.911,23.993,15.913z" /></g></svg>
  },
  {
    key: "psychologist", title: "Psychologists", pending: 0, URL: "/inclusiveleaderscategories?type=psychologist", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>verified</title><g><path d="M42.164 4.01399L24.164 1.01399C24.055 0.995988 23.945 0.995988 23.836 1.01399L5.836 4.01399C5.354 4.09399 5 4.51099 5 4.99999V26C5 32.059 8.256 37.612 14.414 42.061C17.264 44.109 20.384 45.753 23.684 46.948C23.889 47.017 24.111 47.017 24.316 46.948C27.616 45.753 30.736 44.109 33.586 42.061C39.744 37.612 43 32.059 43 26V4.99999C43 4.51099 42.646 4.09399 42.164 4.01399Z" fill="url(#nc-ui-1-0_linear_43_137)" /> <path d="M42.164 4.01401L24.164 1.01401C24.11 1.00501 24.055 1.01401 24 1.01401V47C24.107 47 24.214 46.983 24.316 46.948C27.616 45.753 30.736 44.109 33.586 42.061C39.744 37.612 43 32.059 43 26V5.00001C43 4.51101 42.646 4.09401 42.164 4.01401Z" fill="#3CB34B" /> <path d="M21.349 32.177L13.879 24.707C13.488 24.316 13.488 23.683 13.879 23.293L15.293 21.879C15.684 21.488 16.317 21.488 16.707 21.879L21.887 27.059L33.137 13.939C33.496 13.52 34.127 13.471 34.546 13.83L36.064 15.129C36.484 15.488 36.532 16.12 36.173 16.539L22.816 32.12C22.437 32.562 21.762 32.588 21.35 32.176L21.349 32.177Z" fill="url(#nc-ui-1-1_linear_43_137)" /> <defs> <linearGradient id="nc-ui-1-0_linear_43_137" x1={24} y1="1.00049" x2={24} y2="46.9997" gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-ui-1-1_linear_43_137" x1="24.9997" y1="13.5898" x2="24.9997" y2="32.469" gradientUnits="userSpaceOnUse"> <stop stopColor="white" /> <stop offset={1} stopColor="#D8F3E0" /> </linearGradient> </defs></g></svg>
  },
  {
    key: "pharmacy", title: "Pharmacies", pending: 0, URL: "/inclusiveleaderscategories?type=pharmacy", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>salad</title><g><path d="M22.9,21h18.81a6.99,6.99,0,0,0-5.753-8.936A9,9,0,1,0,22.9,21Z" fill="#72c472" /> <path d="M5,5A1,1,0,0,0,4,6v4A11.013,11.013,0,0,0,15,21a1,1,0,0,0,1-1V16A11.013,11.013,0,0,0,5,5Z" fill="#72c472" /> <path d="M32,18a8.009,8.009,0,0,1-8-8,1,1,0,0,1,2,0,6.006,6.006,0,0,0,6,6,1,1,0,0,1,0,2Z" fill="#4da34d" /> <path d="M45,23H3a1,1,0,0,0-1,1A22.09,22.09,0,0,0,14.675,43.905.992.992,0,0,0,15.1,44H32.9a.992.992,0,0,0,.425-.095A22.09,22.09,0,0,0,46,24,1,1,0,0,0,45,23Z" fill="#e6e6e6" /></g></svg>
  },

  {
    key: "north", title: "North", pending: 0, URL: "/inclusiveleaderscategories?direction=north", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>arrow-left-3</title><g><path d="M40,17H22V8a1,1,0,0,0-1.644-.765l-19,16a1,1,0,0,0-.121,1.409.988.988,0,0,0,.121.121l19,16A1,1,0,0,0,22,40V31H40a7,7,0,0,0,0-14Z" fill="#00b14f" /></g></svg>
  },
  {
    key: "south", title: "South", pending: 0, URL: "/inclusiveleaderscategories?direction=south", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>arrow-left-3</title><g><path d="M8 17h18v-9a1 1 0 0 1 1.64-0.77l19 16a1 1 0 0 1 0.13 1.41 0.99 0.99 0 0 1-0.13 0.12l-19 16a1 1 0 0 1-1.64-0.76v-9h-18a7 7 0 0 1 0-14z" fill="#00b14f" /></g></svg>
  },


  {
    key: "east", title: "East", pending: 0, URL: "/inclusiveleaderscategories?direction=east", svg: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><title>arrow-up-3</title><g><path d="M24.765,1.356A1.034,1.034,0,0,0,23.3,1.287q-.036.033-.069.069l-16,19A1,1,0,0,0,8,22h9V40a7,7,0,0,0,14,0V22h9a1,1,0,0,0,.765-1.644Z" fill="#00b14f"></path></g></svg>
  },


  {
    key: "west", title: "West", pending: 0, URL: "/inclusiveleaderscategories?direction=west", svg: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>arrow-up-3</title><g><path d="M24.77 46.64a1.03 1.03 0 0 1-1.47 0.07q-0.04-0.03-0.07-0.07l-16-19a1 1 0 0 1 0.77-1.64h9v-18a7 7 0 0 1 14 0v18h9a1 1 0 0 1 0.77 1.64z" fill="#00b14f" /></g></svg>
  },

  //{ key: "park", title: "Parks", pending: 0, URL: "/inclusiveleaderscategories?type=park",svg:<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>land</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" strokeMiterlimit={10}><line x1={11} y1={27} x2={11} y2={15} fill="none" stroke="#212121" strokeWidth={2} /><path d="M14.516,8.336A5.929,5.929,0,0,0,15,6c0-2.761-1.791-5-4-5S7,3.239,7,6a5.929,5.929,0,0,0,.484,2.336A7.4,7.4,0,0,0,5,14c0,3.866,2.686,7,6,7s6-3.134,6-7A7.4,7.4,0,0,0,14.516,8.336Z" fill="none" stroke="#212121" strokeWidth={2} /><line x1={21} y1={27} x2={21} y2={15} fill="none" stroke="#212121" strokeWidth={2} /><path d="M18.1,20.126A5.325,5.325,0,0,0,21,21c3.314,0,6-3.134,6-7a7.4,7.4,0,0,0-2.484-5.664A5.929,5.929,0,0,0,25,6c0-2.761-1.791-5-4-5a3.9,3.9,0,0,0-3.393,2.38" fill="none" stroke="#212121" strokeWidth={2} /><path d="M3.98,20.242A24.093,24.093,0,0,0,1,22.271V31H31V22.271a24.093,24.093,0,0,0-2.98-2.029" fill="none" stroke="#212121" strokeWidth={2} /></g></svg> }
];

export const IncetiveContributions = [
  {
    "SId": 2405,
    "title": "📈 Upgrade",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>organic</title><g> <path d="M42.1 6.33399C41.832 5.85199 41.224 5.67699 40.741 5.94499C40.222 6.23299 27.984 13.128 25.155 23.028C24.055 26.896 24.191 30.414 25.563 33.202C26.897 35.846 29.3 37.793 32.163 38.55C33.197 38.851 34.267 39.007 35.344 39.013C40.373 39.013 44.509 35.377 46.311 29.071C49.142 19.172 42.394 6.85399 42.1 6.33399Z" fill="url(#nc-organic-0_linear_307_235)" /> <path d="M5.9 6.33399C6.168 5.85199 6.776 5.67699 7.259 5.94499C7.778 6.23299 20.016 13.128 22.845 23.028C23.945 26.896 23.809 30.414 22.437 33.202C21.103 35.846 18.7 37.793 15.837 38.55C14.803 38.851 13.733 39.007 12.656 39.013C7.627 39.013 3.491 35.377 1.689 29.071C-1.142 19.172 5.606 6.85399 5.9 6.33399Z" fill="url(#nc-organic-1_linear_307_235)" /> <path d="M24.74 2.32697C24.341 1.91797 23.687 1.90997 23.278 2.30897C23.272 2.31497 23.266 2.32097 23.26 2.32697C22.841 2.78797 13 13.731 13 24C13 31.9 17.317 37 24 37C30.683 37 35 31.9 35 24C35 13.731 25.159 2.78797 24.74 2.32697Z" fill="url(#nc-organic-2_linear_307_235)" /> <path d="M30.707 25.318C30.323 24.921 29.69 24.91 29.293 25.293L25 29.586V13C25 12.448 24.552 12 24 12C23.448 12 23 12.448 23 13V23.586L18.707 19.293C18.319 18.919 17.705 18.919 17.318 19.293C16.921 19.677 16.91 20.31 17.293 20.707L23 26.414V46C23 46.552 23.448 47 24 47C24.552 47 25 46.552 25 46V32.414L30.707 26.707C31.081 26.319 31.081 25.705 30.707 25.318Z" fill="url(#nc-organic-3_linear_307_235)" /> <defs> <linearGradient id="nc-organic-0_linear_307_235" x1="35.712" y1="5.81934" x2="35.712" y2="39.013" gradientUnits="userSpaceOnUse"> <stop stopColor="#3CB34B" /> <stop offset={1} stopColor="#288031" /> </linearGradient> <linearGradient id="nc-organic-1_linear_307_235" x1="12.288" y1="5.81934" x2="12.288" y2="39.013" gradientUnits="userSpaceOnUse"> <stop stopColor="#3CB34B" /> <stop offset={1} stopColor="#288031" /> </linearGradient> <linearGradient id="nc-organic-2_linear_307_235" x1={24} y1="2.01489" x2={24} y2={37} gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-organic-3_linear_307_235" x1="24.0001" y1={12} x2="24.0001" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#3CB34B" /> <stop offset={1} stopColor="#288031" /> </linearGradient> </defs> </g></svg>
    ,
    "label": "credits",
    "description": "You helped a family commit to their child’s brighter future.",
    "what": "Guiding parents to move from short-term therapy to long-term structured care — for example, from 3-month to 6-month or 12-month programs, or upgrading from 12 credits to 24.",
    "why": "Upgrades ensure consistent therapy, faster developmental improvements, and more powerful recovery windows during a child’s golden age."
  },
  {
    "SId": 2408,
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><title>verified</title><g><path d="M42.164 4.01399L24.164 1.01399C24.055 0.995988 23.945 0.995988 23.836 1.01399L5.836 4.01399C5.354 4.09399 5 4.51099 5 4.99999V26C5 32.059 8.256 37.612 14.414 42.061C17.264 44.109 20.384 45.753 23.684 46.948C23.889 47.017 24.111 47.017 24.316 46.948C27.616 45.753 30.736 44.109 33.586 42.061C39.744 37.612 43 32.059 43 26V4.99999C43 4.51099 42.646 4.09399 42.164 4.01399Z" fill="url(#nc-ui-1-0_linear_43_137)"></path> <path d="M42.164 4.01401L24.164 1.01401C24.11 1.00501 24.055 1.01401 24 1.01401V47C24.107 47 24.214 46.983 24.316 46.948C27.616 45.753 30.736 44.109 33.586 42.061C39.744 37.612 43 32.059 43 26V5.00001C43 4.51101 42.646 4.09401 42.164 4.01401Z" fill="#3CB34B"></path> <path d="M21.349 32.177L13.879 24.707C13.488 24.316 13.488 23.683 13.879 23.293L15.293 21.879C15.684 21.488 16.317 21.488 16.707 21.879L21.887 27.059L33.137 13.939C33.496 13.52 34.127 13.471 34.546 13.83L36.064 15.129C36.484 15.488 36.532 16.12 36.173 16.539L22.816 32.12C22.437 32.562 21.762 32.588 21.35 32.176L21.349 32.177Z" fill="url(#nc-ui-1-1_linear_43_137)"></path> <defs> <linearGradient id="nc-ui-1-0_linear_43_137" x1="24" y1="1.00049" x2="24" y2="46.9997" gradientUnits="userSpaceOnUse"> <stop stop-color="#6AD084"></stop> <stop offset="1" stop-color="#3CB34B"></stop> </linearGradient> <linearGradient id="nc-ui-1-1_linear_43_137" x1="24.9997" y1="13.5898" x2="24.9997" y2="32.469" gradientUnits="userSpaceOnUse"> <stop stop-color="white"></stop> <stop offset="1" stop-color="#D8F3E0"></stop> </linearGradient> </defs></g></svg>,

    "title": "🧩 Fulfill Need",
    "label": "services",
    "description": "You ensured a child gets the complete therapy they truly need.",
    "what": "When AbilityScore shows a child needs 3 therapies, but the parent opts for 1 or 2 — helping them understand and commit to the missing therapies.",
    "why": "Partial therapy equals partial progress. This contribution directly saves a child from regressing or missing their golden window."
  },
  {
    "SId": 2409,
    "title": "💛 Refer a Parent",
    "label": "kids",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><title>mistletoe</title><g><path fill="#4DA34D" d="M18.09863,34.3208l-0.66016-0.55615c-2.84375-2.39551-6.0918-4.00635-9.65332-4.78809L6.75195,28.75 l0.28516-1.01953c1.24414-4.44531-1.3916-11.20752-3.64551-12.93701l-0.77539-0.59521l0.57617-0.78857 c2.76367-3.77881,1.83301-9.17725,1.82324-9.23145L4.7168,2.5127l1.60449,0.54004c0.05566,0.02002,5.65234,1.86475,11.36816-0.00342 l1.02051-0.33301l0.25977,1.04102c0.74707,2.98486,3.36426,6.479,6.66895,8.90088l0.37109,0.27197l1.02539,13.48975 L18.09863,34.3208z"></path> <path fill="#72C472" d="M45.2373,14.25928l-0.33789-0.69629C42.90918,9.46533,42.99902,4.07568,43,4.02148l0.03418-1.63428 l-1.4707,0.71289C41.51172,3.12549,36.25,5.63574,30.10156,5.00537l-0.99023-0.10156l-0.10547,0.99023 c-0.36914,3.46387-5.64844,8.74316-9.11133,9.11133l-1.28809,0.13721l0.45801,1.21094 c1.18457,3.13184,1.93457,8.66113,1.95117,11.98779l0.00293,0.60889l10.69336,5.45801l0.51172-0.46973 c2.4375-2.2373,6.2666-4.13818,9.99219-4.96191l1.03809-0.22949l-0.29199-1.02197 c-1.21289-4.24512-0.29883-11.27246,1.68652-12.96387L45.2373,14.25928z"></path> <path fill="#4DA34D" d="M27.36523,30.03271c-0.17578,0-0.35352-0.0459-0.51465-0.14307 c-0.47266-0.28467-0.62598-0.89893-0.3418-1.37207l6.63379-11.03271c0.28613-0.47314,0.90039-0.62793,1.37305-0.3418 c0.47266,0.28467,0.62598,0.89893,0.3418,1.37207l-6.63379,11.03271C28.03516,29.85986,27.70508,30.03271,27.36523,30.03271z"></path> <circle fill="#C64747" cx="18.5" cy="38.5" r="5.5"></circle> <circle fill="#C64747" cx="29.5" cy="38.5" r="5.5"></circle> <circle fill="#E86C60" cx="24" cy="34" r="6"></circle></g></svg>,

    "description": "You introduced another family to Pinnacle’s life-changing support.",
    "what": "Helping another child or parent begin their journey by referring them to Pinnacle’s proven ecosystem.",
    "why": "Every referral is a lifeline. You don’t just refer — you help a parent find direction and a child find their voice."
  },
  {
    "SId": 2413,
    "title": "📝 Admissions",
    "label": "kids",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>golf-course</title><g><path d="M30.871,7.071l-12.5-5A1,1,0,0,0,18,2.008V14a.991.991,0,0,0,.371-.071l12.5-5a1,1,0,0,0,0-1.858Z" fill="#ed7064" /> <path d="M24,26c1.425,0,2.854.055,4.251.166A2.973,2.973,0,0,1,30.9,28.345a3.15,3.15,0,0,1-.875,3.046l-.831.83a1,1,0,0,0,.881,1.693l12.178-2.148a3.921,3.921,0,0,1,4.288,2.174A4.948,4.948,0,0,1,47,36c0,5.607-10.1,10-23,10C11.347,46,1,41.767,1,36S11.347,26,24,26" fill="#4da34d" fillRule="evenodd" /> <path d="M18,37a1,1,0,0,1-1-1V3a1,1,0,0,1,2,0V36A1,1,0,0,1,18,37Z" fill="#b3b3b3" /></g></svg>,

    "description": "You helped a hesitant parent take the final step into Pinnacle.",
    "what": "Supporting families who’ve visited but not yet joined — answering questions, clearing fears, and guiding them to say yes.",
    "why": "The first decision is the hardest. You make it easier — and unlock a whole new life for that child."
  },
  {
    "SId": 2410,
    "title": "🔁 Renewals",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>organic-2</title><g><circle cx={24} cy={24} r={21} fill="#72c472" /> <path d="M24,46A22,22,0,1,1,46,24,22.025,22.025,0,0,1,24,46ZM24,4A20,20,0,1,0,44,24,20.023,20.023,0,0,0,24,4Z" fill="#4da34d" /> <path d="M21,34h0a9,9,0,0,1-9-9V21h0a9,9,0,0,1,9,9Z" fill="#fff" /> <path d="M36,14h0a0,0,0,0,1,0,0v7A13,13,0,0,1,23,34h0a0,0,0,0,1,0,0V27A13,13,0,0,1,36,14Z" fill="#fff" /></g></svg>
    ,
    "label": "credits",
    "description": "You helped a family continue the journey when credits were ending.",
    "what": "Guiding families to renew their services before expiry so their child gets uninterrupted support.",
    "why": "Breaks in therapy delay development. Your gentle nudge protects a child’s momentum."
  },
  {
    "SId": 2407,
    "title": "♻️ Reactivations",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>recycling</title><g><path fill="#4DA34D" d="M20,35H9l-3,8h14c0.55231,0,1-0.44775,1-1v-6C21,35.44769,20.55231,35,20,35z" /> <path fill="#4DA34D" d="M47,36l-7.23163-15.40625c-0.23488-0.50697-0.8396-0.72312-1.34262-0.47992l-5.55053,2.68358 c-0.49265,0.23819-0.70237,0.82812-0.4706,1.32383l5.87664,12.56625L47,36z" /> <path fill="#72C472" d="M30.12371,45.99853l-5.81568-6.64649c-0.17334-0.1981-0.1634-0.49667,0.02274-0.68281l5.81568-5.81568 C30.46143,32.53857,31,32.76165,31,33.20711V36h16l-3.71208,6.49614C43.10988,42.80771,42.77853,43,42.41968,43H31v2.66928 C31,46.13096,30.42773,46.34598,30.12371,45.99853z" /> <path fill="#72C472" d="M3.58378,24.06916l8.17743-2.80084c0.25835-0.08849,0.53991,0.04668,0.63244,0.30361l2.96533,8.234 c0.15055,0.41804-0.27821,0.8101-0.68114,0.62284l-2.5904-1.20382L6,43l-4.66086-6.5252 c-0.20956-0.29338-0.24497-0.67686-0.09267-1.00366l4.42037-9.48487l-2.13176-0.99065 C3.12664,24.80581,3.15769,24.2151,3.58378,24.06916z" /> <path fill="#4DA34D" d="M17.64853,1.01617l-7.60955,14.68772c-0.26031,0.50321-0.05099,1.12195,0.46134,1.36378l5.55786,2.6234 c0.48956,0.23108,1.07413,0.03062,1.31885-0.45227L23.375,7.375L17.64853,1.01617z" /> <path fill="#72C472" d="M36.02328,10.09075l-1.91426,8.42922c-0.06048,0.26632-0.32346,0.43484-0.59069,0.37852l-8.56359-1.80464 c-0.43475-0.09162-0.54298-0.66239-0.17195-0.9068l2.3855-1.57143L17.64853,1.01617l9.59552,0.00135 c0.36312,0.00005,0.69769,0.19694,0.87403,0.51438l5.1797,9.32394l1.9628-1.29333 C35.6367,9.31468,36.12302,9.65151,36.02328,10.09075z" /></g></svg>
    ,
    "label": "services",
    "description": "You reactivated a therapy that was dropped but still needed.",
    "what": "Some families stop needed therapies due to confusion or doubt. You helped them see why it’s essential and restart it.",
    "why": "Interrupted therapy can undo months of effort. You helped a child stay on the path to progress."
  },
  {
    "SId": 2412,
    "title": "🚪 Closed Walk-Ins",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>weed</title><g><path fill="#72C472" d="M24,34c-0.353,0-0.679-0.186-0.859-0.488C22.972,33.228,19,26.462,19,18s3.972-15.228,4.141-15.512 c0.361-0.605,1.357-0.605,1.719,0C25.028,2.772,29,9.538,29,18s-3.972,15.228-4.141,15.512C24.679,33.814,24.353,34,24,34z" /> <path fill="#4DA34D" d="M24,47c-0.552,0-1-0.447-1-1V33c0-0.553,0.448-1,1-1s1,0.447,1,1v13C25,46.553,24.552,47,24,47z" /> <path fill="#4DA34D" d="M24,42c-0.256,0-0.512-0.098-0.707-0.293l-6-6c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0l6,6 c0.391,0.391,0.391,1.023,0,1.414C24.512,41.902,24.256,42,24,42z" /> <path fill="#72C472" d="M18,36c-0.062,0-0.124-0.006-0.186-0.018c-0.226-0.043-5.584-1.096-9.597-5.109 c-4.013-4.013-5.066-9.371-5.109-9.597c-0.062-0.325,0.042-0.66,0.275-0.894c0.234-0.234,0.57-0.337,0.894-0.275 c0.226,0.043,5.583,1.097,9.597,5.109l0,0c4.013,4.013,5.066,9.371,5.109,9.597c0.062,0.325-0.042,0.66-0.275,0.894 C18.518,35.896,18.263,36,18,36z" /> <path fill="#4DA34D" d="M24,42c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l6-6 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-6,6C24.512,41.902,24.256,42,24,42z" /> <path fill="#72C472" d="M30,36c-0.263,0-0.518-0.104-0.707-0.293c-0.234-0.233-0.337-0.568-0.275-0.894 c0.043-0.226,1.096-5.584,5.109-9.597l0,0c4.013-4.013,9.371-5.066,9.597-5.109c0.326-0.061,0.66,0.041,0.894,0.275 c0.234,0.233,0.337,0.568,0.275,0.894c-0.043,0.226-1.096,5.584-5.109,9.597c-4.013,4.014-9.371,5.066-9.597,5.109 C30.124,35.994,30.062,36,30,36z" /> <path fill="#4DA34D" d="M29.001,43c-0.065,0-0.131-0.006-0.197-0.02l-5-1c-0.542-0.108-0.893-0.635-0.784-1.177 c0.108-0.542,0.632-0.898,1.177-0.784l5,1c0.542,0.108,0.893,0.635,0.784,1.177C29.886,42.672,29.468,43,29.001,43z" /> <path fill="#4DA34D" d="M18.999,43c-0.467,0-0.885-0.328-0.979-0.804c-0.108-0.542,0.243-1.068,0.784-1.177l5-1 c0.544-0.113,1.069,0.242,1.177,0.784c0.108,0.542-0.243,1.068-0.784,1.177l-5,1C19.13,42.994,19.064,43,18.999,43z" /> <path fill="#72C472" d="M11.045,46c-4.522,0-8.109-3.117-8.26-3.25C2.57,42.561,2.447,42.287,2.447,42s0.124-0.561,0.338-0.75 C2.936,41.117,6.522,38,11.045,38c4.523,0,8.109,3.117,8.26,3.25c0.215,0.189,0.338,0.463,0.338,0.75s-0.124,0.561-0.338,0.75 C19.154,42.883,15.568,46,11.045,46z" /> <path fill="#72C472" d="M36.955,46c-4.523,0-8.109-3.117-8.26-3.25c-0.215-0.189-0.338-0.463-0.338-0.75s0.124-0.561,0.338-0.75 c0.151-0.133,3.737-3.25,8.26-3.25c4.522,0,8.109,3.117,8.26,3.25c0.215,0.189,0.338,0.463,0.338,0.75s-0.124,0.561-0.338,0.75 C45.064,42.883,41.478,46,36.955,46z" /></g></svg>
    ,
    "label": "kids",
    "description": "You reopened the door for a child who was turned away too soon.",
    "what": "Following up with families who walked in but were marked as ‘not joining’ — and helping them try again.",
    "why": "Sometimes all a parent needs is one more honest voice. You were that voice."
  },
  {
    "SId": 2411,
    "title": "📞 Closed Leads",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>forest</title><g><path fill="#A67C52" d="M24,46c-1.10449,0-2-0.89551-2-2v-6c0-1.10449,0.89551-2,2-2s2,0.89551,2,2v6C26,45.10449,25.10449,46,24,46 z" /> <path fill="#4DA34D" d="M14.89453,3.55273c-0.33887-0.67773-1.4502-0.67773-1.78906,0l-10,20 c-0.15479,0.31006-0.13818,0.67822,0.04395,0.97314C3.33154,24.82031,3.65332,25,4,25h12.125c0.55225,0,1-0.44775,1-1 c0-0.40955-0.24756-0.75958-0.60004-0.91418l2.87946-6.58154c0.26239,0.11469,0.56616,0.12848,0.84265-0.00964 c0.49414-0.24707,0.69434-0.84766,0.44727-1.3418L14.89453,3.55273z" /> <path fill="#4DA34D" d="M44.89453,23.55273l-10-20c-0.33887-0.67773-1.4502-0.67773-1.78906,0l-5.7998,11.6001 c-0.24707,0.49414-0.04688,1.09473,0.44727,1.3418c0.27698,0.13806,0.58051,0.12408,0.84259,0.0094l2.87952,6.58179 C31.12256,23.24042,30.875,23.59045,30.875,24c0,0.55225,0.44775,1,1,1H44c0.34668,0,0.66846-0.17969,0.85059-0.47412 C45.03271,24.23096,45.04932,23.86279,44.89453,23.55273z" /> <path fill="#72C472" d="M38,39H10c-0.3374,0-0.65234-0.17041-0.83691-0.45264s-0.21436-0.63916-0.0791-0.94824l14-32 C23.24316,5.23535,23.60254,5,24,5s0.75684,0.23535,0.91602,0.59912l14,32c0.13525,0.30908,0.10547,0.66602-0.0791,0.94824 S38.3374,39,38,39z" /></g></svg>
    ,
    "label": "kids",
    "description": "You reopened hope for families who never even walked in.",
    "what": "BDC/Admin follow-up on leads marked ‘not responding’ or ‘closed’ and helped bring them in.",
    "why": "They could have stayed lost forever. But your call changed everything."
  },
  {
    "SId": 2406,
    "title": "🎉 Welcome Back",
    "label": "kids",
    "icon": <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>tree-2</title><g> <path d="M36 37H12C7.038 37 3 32.962 3 28C3 24.12 5.529 20.682 9.142 19.469C9.046 18.958 9 18.477 9 18C9 14.932 10.574 12.108 13.155 10.457C13.05 9.948 13 9.474 13 9C13 4.589 16.589 1 21 1C24.652 1 27.834 3.538 28.724 7.029C33.35 7.399 37 11.281 37 16C37 17.031 36.819 18.039 36.46 19.012C41.209 19.253 45 23.192 45 28C45 32.962 40.962 37 36 37Z" fill="url(#nc-tree-2-0_linear_307_240)" /> <path d="M34 45H25V31.414L29.707 26.707C30.098 26.316 30.098 25.684 29.707 25.293C29.316 24.902 28.684 24.902 28.293 25.293L25 28.586V17C25 16.448 24.552 16 24 16C23.448 16 23 16.448 23 17V23.586L19.707 20.293C19.316 19.902 18.684 19.902 18.293 20.293C17.902 20.684 17.902 21.316 18.293 21.707L23 26.414V45H14C13.448 45 13 45.448 13 46C13 46.552 13.448 47 14 47H34C34.552 47 35 46.552 35 46C35 45.448 34.552 45 34 45Z" fill="url(#nc-tree-2-1_linear_307_240)" /> <defs> <linearGradient id="nc-tree-2-0_linear_307_240" x1={24} y1={1} x2={24} y2={37} gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-tree-2-1_linear_307_240" x1={24} y1={16} x2={24} y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#3CB34B" /> <stop offset={1} stopColor="#288031" /> </linearGradient> </defs> </g></svg>
    ,
    "description": "You helped a family who had left, return to Pinnacle again.",
    "what": "Life happens. Families leave. But you followed up and reminded them that help is still here.",
    "why": "Returning to therapy can feel like failure. You made it feel like homecoming."
  }
];


export const PlanetAutismEditions = [
  {
    Id: 3,
    Name: " Early Preview #3",
    Image: "https://images.pinnacleblooms.org/PlanetAutism/images/Pinnacle-Planet-Autism-Early-Preview-Edition3.jpg",
    PDF: "https://images.pinnacleblooms.org/PlanetAutism/Pinnacle-Planet-Autism-Early-Preview-Edition3-RGB.pdf"
  },
  {
    Id: 2,
    Name: " Early Preview #2",
    Image: "https://images.pinnacleblooms.org/PlanetAutism/images/Edition-2.jpg",
    PDF: "https://images.pinnacleblooms.org/PlanetAutism/edition2.pdf"
  },
  {
    Id: 1,
    Name: " Early Preview #1",
    Image: "https://images.pinnacleblooms.org/PlanetAutism/images/Edition-1.jpg",
    PDF: "https://images.pinnacleblooms.org/PlanetAutism/edition1.pdf"
  }
]

export var IncentiveBenifits = [
  {
    Id: 2479,
    type: "TIER#1",
    name: "Swiggy /Zomato Family Delight Coupon",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>apple-2</title><g><path d="M24,14a1,1,0,0,1-1-1c0-3.441-2.4-7.877-6.287-9.042a1,1,0,1,1,.574-1.916C22.051,3.472,25,8.843,25,13A1,1,0,0,1,24,14Z" fill="#a67c52" /> <path d="M29.122,46a21.1,21.1,0,0,1-3.226-.31,13.564,13.564,0,0,0-1.9-.208,13.564,13.564,0,0,0-1.9.208c-3.52.533-8.837,1.338-13.94-6.819C1.924,28.9,3.231,17.4,8.308,13.311c3.835-3.085,7.988-2.393,11.655-1.786A25.329,25.329,0,0,0,24,11.987a25.329,25.329,0,0,0,4.037-.462c3.668-.608,7.82-1.3,11.655,1.786,5.077,4.084,6.384,15.586.144,25.563C36.119,44.816,32.289,46,29.122,46Z" fill="#e86c60" /> <path d="M34,0h0V2a7,7,0,0,1-7,7h0V7A7,7,0,0,1,34,0Z" fill="#72c472" /></g></svg>
    , description: "Shared meals, shared happiness.",
    summary: "Shared meals, shared happiness. This blessing ensures your family can enjoy quality time together over delicious food, creating moments of joy and togetherness. Whether it’s a cozy dinner at home or a special treat delivered to your doorstep, this coupon brings your family closer, one meal at a time.",
    B: [{ N: "Swiggy", I: "/images/Incentives/Swiggy.jpg" }, { N: "Zomato", I: "/images/Incentives/Zomato.jpg" }]

  },
  {
    Id: 2480,
    type: "TIER#1",
    name: "Rapido /Ola /Uber Comfort Pass",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>car-front</title><g><path d="M11,45H5a1,1,0,0,1-1-1V36a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v8A1,1,0,0,1,11,45Z" fill="#363636" /><path d="M43,45H37a1,1,0,0,1-1-1V36a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v8A1,1,0,0,1,43,45Z" fill="#363636" /><path d="M42,21,40.415,7.533A4,4,0,0,0,36.443,4H11.557A4,4,0,0,0,7.585,7.533L6,21Z" fill="#e3e3e3" /><path d="M42,22a1,1,0,0,1-.992-.883L39.422,7.649A3,3,0,0,0,36.442,5H11.558a3,3,0,0,0-2.98,2.649L6.993,21.117a1,1,0,0,1-1.986-.234L6.592,7.415A5,5,0,0,1,11.558,3H36.442a5,5,0,0,1,4.966,4.415l1.585,13.468a1,1,0,0,1-.876,1.11A.945.945,0,0,1,42,22Z" fill="#38a838" /><path d="M46,38H2a1,1,0,0,1-1-1V26a6,6,0,0,1,6-6H41a6,6,0,0,1,6,6V37A1,1,0,0,1,46,38Z" fill="#78d478" /><circle cx={40} cy={27} r={3} fill="#fff" /><circle cx={8} cy={27} r={3} fill="#fff" /><path d="M31,31H17a2,2,0,0,1,0-4H31a2,2,0,0,1,0,4Z" fill="#363636" /><path d="M1,34H47a0,0,0,0,1,0,0v3a1,1,0,0,1-1,1H2a1,1,0,0,1-1-1V34A0,0,0,0,1,1,34Z" fill="#49c549" /><circle cx={8} cy={34} r={2} fill="#f7bf26" /><circle cx={40} cy={34} r={2} fill="#f7bf26" /></g></svg>
    , description: "Safe and seamless travel for your loved ones.",
    summary: "Safe and seamless travel for your loved ones. This blessing ensures your family can travel with ease and peace of mind, whether it’s for daily commutes or special outings. From school runs to weekend getaways, this pass makes every journey comfortable and stress-free.",
    B: [{ N: "Uber", I: "/images/Incentives/Uber.jpg" }, { N: "Rapido", I: "/images/Incentives/Rapido.jpg" }, { N: "Ola", I: "https://upload.wikimedia.org/wikipedia/en/thumb/0/0f/Ola_Cabs_logo.svg/2560px-Ola_Cabs_logo.svg.png" }]
  },
  {
    Id: 2481,
    type: "TIER#1",
    name: "Amazon /Flipkart /Myntra Family Care Voucher",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bag-add-18</title><g><path fill="#EFD358" d="M40,47H4c-0.298,0-0.58-0.133-0.771-0.362c-0.189-0.23-0.268-0.532-0.212-0.825L7,24.906V14 c0-0.552,0.447-1,1-1h28c0.553,0,1,0.448,1,1v10.906l3.982,20.907c0.056,0.292-0.022,0.595-0.212,0.825 C40.58,46.867,40.298,47,40,47z" /> <path fill="#87613E" d="M29,21c-0.553,0-1-0.448-1-1V9c0-3.309-2.691-6-6-6s-6,2.691-6,6v11c0,0.552-0.447,1-1,1s-1-0.448-1-1V9 c0-4.411,3.589-8,8-8s8,3.589,8,8v11C30,20.552,29.553,21,29,21z" /> <circle fill="#72C472" cx={37} cy={33} r={8} /> <path fill="#FFFFFF" d="M40,32h-2v-2c0-0.552-0.448-1-1-1s-1,0.448-1,1v2h-2c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1h2v2 c0,0.552,0.448,1,1,1s1-0.448,1-1v-2h2c0.552,0,1-0.448,1-1C41,32.448,40.552,32,40,32z" /></g></svg>, description: "Everything your home & heart needs.",
    summary: "Everything your home and heart needs. This blessing provides your family with essential items, from household goods to personal care, ensuring they have everything to thrive. Whether it’s a new appliance, a cozy blanket, or a special gift, this voucher brings comfort and joy to your home.",
    B: [{ N: "Amazon", I: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBBBUUNIFQdJ7AAlx9NufMlUI1sslkJENqUw&s" }, { N: "Flipkart", I: "/images/Incentives/Flipkart.jpg" }, { N: "Myntra", I: "/images/Incentives/Myntra.jpg" }]
  },
  {
    Id: 2482,
    type: "TIER#1",
    name: "Medplus/ Apollo/ 1Mg Health & Wellness Gift",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>medicine</title><g><path d="M18.222,4.222A11,11,0,0,1,33.778,19.778l-14,14A11,11,0,0,1,4.222,18.222Z" fill="#f888c0" /><path d="M33.778,4.222a11,11,0,0,0-15.556,0l-7,7L26.778,26.778l7-7A11,11,0,0,0,33.778,4.222Z" fill="#ffe699" /><circle cx={34} cy={34} r={13} fill="#e3e3e3" /><path d="M6.343,32.657a.993.993,0,0,1-.707-.293,9.01,9.01,0,0,1,0-12.728A1,1,0,0,1,7.05,21.05a7.009,7.009,0,0,0,0,9.9,1,1,0,0,1-.707,1.707Z" fill="#fddded" /><path d="M27,42a1,1,0,0,1-.707-1.707l14-14a1,1,0,0,1,1.414,1.414l-14,14A1,1,0,0,1,27,42Z" fill="#c8c8c8" /></g></svg>,
    description: "Prioritizing your family's health and well-being.",
    summary: "Prioritizing your family’s health and well-being. This blessing ensures your loved ones have access to health and wellness products, keeping them healthy and happy. From vitamins to first-aid supplies, this gift supports your family’s physical and mental well-being.",
    B: [{ N: "Medplus", I: "/images/Incentives/MedPlus.jpg" }, { N: "Apollo", I: "/images/Incentives/Apollo.jpg" }, { N: "1Mg", I: "/images/Incentives/1MG.jpg" }]
  },
  {
    Id: 2483,
    type: "TIER#2",
    name: "Premium Health Check-up for You & One Family Member",
    mName: <>Premium Health<br />Check-up for You &<br />One Family Member</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bag-49</title><g><path fill="#B3B3B3" d="M44,45H4c-0.553,0-1-0.448-1-1v-8c0-0.552,0.447-1,1-1h40c0.553,0,1,0.448,1,1v8C45,44.552,44.553,45,44,45z " /> <path fill="#B3B3B3" d="M32,13c-0.553,0-1-0.448-1-1V5H17v7c0,0.552-0.447,1-1,1s-1-0.448-1-1V4c0-0.552,0.447-1,1-1h16 c0.553,0,1,0.448,1,1v8C33,12.552,32.553,13,32,13z" /> <path fill="#E6E6E6" d="M46,37H2c-0.552,0-1-0.448-1-1V12c0-0.552,0.448-1,1-1h44c0.552,0,1,0.448,1,1v24C47,36.552,46.552,37,46,37 z" /> <path fill="#E86C60" d="M29,22h-3v-3c0-0.552-0.448-1-1-1h-2c-0.552,0-1,0.448-1,1v3h-3c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1 h3v3c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-3h3c0.552,0,1-0.448,1-1v-2C30,22.448,29.552,22,29,22z" /></g></svg>
    ,
    description: "Because those who care for others should never neglect their own well-being.",
    summary: "Because those who care for others should never neglect their own well-being. This blessing ensures you and your loved one stay healthy and proactive about your health. From comprehensive health screenings to personalized wellness plans, this check-up ensures your family’s health is in top shape"
  },
  {
    Id: 2484,
    type: "TIER#2",
    name: "Family Wellness & Fitness Subscription",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>spa</title><g><path d="M33.757,45.033A12.86,12.86,0,0,1,22.576,25.9c4.207-7.5,19.528-12.553,21.261-13.1a1,1,0,0,1,1.274.715c.432,1.764,4.1,17.449-.115,24.958a12.763,12.763,0,0,1-7.729,6.081A12.919,12.919,0,0,1,33.757,45.033Z" fill="#ea5da3" /><path d="M10.733,44.545A12.763,12.763,0,0,1,3,38.464c-4.21-7.509-.547-23.194-.115-24.958a1,1,0,0,1,1.274-.715c1.733.551,17.054,5.6,21.261,13.1A12.854,12.854,0,0,1,14.243,45.033,12.919,12.919,0,0,1,10.733,44.545Z" fill="#ea5da3" /><path d="M23.912,45a15.017,15.017,0,0,1-15-15C8.912,19.719,22.618,4.96,23.2,4.336a1,1,0,0,1,.73-.316h0a1,1,0,0,1,.73.317c.582.624,14.25,15.382,14.25,25.658A15.017,15.017,0,0,1,23.912,45Z" fill="#f888c0" /></g></svg>,
    description: "A gym, yoga, or wellness program membership to encourage a healthier, happier you, your family.",
    summary: "A gym, yoga, or wellness program membership to encourage a healthier, happier you and your family. This blessing supports your family’s physical and mental well-being, helping you stay active, energized, and balanced. Whether it’s a yoga class, a gym session, or a wellness workshop, this subscription brings health and happiness to your home."
  },
  {
    Id: 2485,
    type: "TIER#2",
    name: "Exclusive Family Leisure & Experience Pass",
    mName: <>Exclusive Family Leisure & Experience Pass</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>world-marker</title><g><circle cx={24} cy={25} r={22} fill="#cbeafb" /><path d="M2,25A21.942,21.942,0,0,0,9.43,41.478l1.944-2.915s1.389-.4,1.688-.938C14,35.938,12.335,33,12.335,33A9.523,9.523,0,0,0,12,30.919c-.25-.625-2-1.481-2-1.481S8.312,26.688,8.312,25a2.517,2.517,0,0,1,2.375-2.624,4.1,4.1,0,0,0,2.688-1.938S15.5,19.875,16,19s-.562-3.994-.562-3.994a5.221,5.221,0,0,0-.021-2.506,4.739,4.739,0,0,0-1.574-1.895,10.4,10.4,0,0,0-2.449-3.631A21.97,21.97,0,0,0,2,25Z" fill="#78d478" /><path d="M40.9,25.716c.5,1.188-.939,4.22-2.125,4.812a8.054,8.054,0,0,0-3.08,2.456c-.438.688-1.013,3.524-2.45,4.087s-4.845,3.77-6.657,3.27-1.813-4.813-.563-6.751c.746-1.157-.125-3.688-.188-4.562s-2.687-2.5-2.688-3.375c0-1.375,3-5,3-5a10.673,10.673,0,0,1,3.208-.625,11.346,11.346,0,0,1,2.167,1.062A15.05,15.05,0,0,1,35.4,21.9l1.438,1.312S40.4,24.528,40.9,25.716Z" fill="#78d478" /><path d="M33,25a1,1,0,0,1-1-1V18a1,1,0,0,1,2,0v6A1,1,0,0,1,33,25Z" fill="#2a4b55" /><path d="M33,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,33,19Z" fill="#ff7163" /></g></svg>
    ,
    description: "A curated movie, amusement park, or family dining experience to create cherished memories together.",
    summary: "A curated movie, amusement park, or family dining experience to create cherished memories together. This blessing ensures your family enjoys quality time and unforgettable moments. Whether it’s a day at the amusement park, a movie night, or a special dinner, this pass brings joy and laughter to your family."
  },
  {
    Id: 2486,
    type: "TIER#2",
    name: "One Extra Paid Leave",
    mName: <>One day <br /> Extra Paid Leave</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>honeymoon</title><g><path d="M37.117,19.373l-9.206,9.2L38.144,45.517a1,1,0,0,0,1.563.19l2.275-2.275a4.977,4.977,0,0,0,1.225-5.061Z" fill="#c8c8c8" /><path d="M18.386,36.539a35.965,35.965,0,0,0,7.03-5.471L43.258,13.233c2.343-2.343,3.656-8.828,2-10.484-1.672-1.672-8.142-.344-10.485,2L16.932,22.583a36.014,36.014,0,0,0-5.472,7.031L5.122,41.55A.981.981,0,0,0,6.45,42.878Z" fill="#e3e3e3" /><path d="M2.484,9.856,19.427,20.088l9.206-9.2-19-6.093A4.979,4.979,0,0,0,4.568,6.018L2.293,8.293a1,1,0,0,0,.191,1.563Z" fill="#c8c8c8" /><path d="M42.086,11.171h-.043a1,1,0,0,1-.957-1.041,3.019,3.019,0,0,0-.876-2.251A2.975,2.975,0,0,0,37.959,7a1.028,1.028,0,0,1-1.041-.956A1,1,0,0,1,37.875,5a5,5,0,0,1,5.209,5.21A1,1,0,0,1,42.086,11.171Z" fill="#444" /><path d="M3.079,31a1,1,0,0,0-.784,1.7L7.209,37.62l3.213-6.052Z" fill="#c6c6c6" /><path d="M15.293,45.705a1,1,0,0,0,1.7-.784l-.565-7.344-6.053,3.214Z" fill="#c6c6c6" /><path d="M10,17.364a.993.993,0,0,1-.707-.293L2.61,10.388A5.5,5.5,0,0,1,10,2.257a5.5,5.5,0,0,1,7.39,8.131l-6.683,6.683A.993.993,0,0,1,10,17.364Z" fill="#f74b3b" /></g></svg>
    ,
    description: "Because time spent with family is the greatest reward of all.",
    summary: "Because time spent with family is the greatest reward of all. This blessing gives you an extra day to recharge and connect with your loved ones. Whether it’s a day at home, a family outing, or simply a day to relax, this leave ensures you have time to cherish the moments that matter most."
  },
  {
    Id: 2487,
    type: "TIER#3",
    name: "₹25L Accidental Life Insurance",
    mName: <>₹25L Accidental<br />Life Insurance</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>security</title><g><path d="M24 46C23.866 46 23.731 45.973 23.606 45.919C10.077 40.121 2 26.32 2 9C2 8.448 2.447 8 3 8C8.655 8 16.996 6.468 23.445 2.168C23.781 1.944 24.218 1.944 24.554 2.168C31.003 6.468 39.344 8 44.999 8C45.552 8 45.999 8.448 45.999 9C45.999 26.32 37.922 40.121 24.393 45.919C24.268 45.973 24.134 46 24 46Z" fill="url(#nc-ui-3-0_linear_119_108)" /> <path d="M45 8C39.345 8 31.004 6.468 24.555 2.168C24.387 2.056 24.194 2 24 2V24H43.734C45.217 19.43 46 14.386 46 9C46 8.448 45.553 8 45 8Z" fill="url(#nc-ui-3-1_linear_119_108)" /> <path d="M4.26599 24C7.55199 34.128 14.284 41.924 23.606 45.919C23.731 45.973 23.866 46 24 46V24H4.26599Z" fill="url(#nc-ui-3-2_linear_119_108)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_108" x1="23.9995" y1={2} x2="23.9995" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_108" x1={35} y1={2} x2={35} y2={24} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_108" x1="14.133" y1={24} x2="14.133" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    ,
    description: "Providing long-term financial security for your family, just as you provide stability to others.",
    summary: "Providing long-term financial security for your family, just as you provide stability to others. This blessing ensures your loved ones are protected in case of unforeseen events, giving you peace of mind and ensuring their future is secure."
  },
  {
    Id: 2488,
    type: "TIER#3",
    name: "Post Office Savings Bond",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>award-49</title><g><path fill="#E6E6E6" d="M37,1H5C3.89543,1,3,1.89543,3,3v36c0,1.10457,0.89543,2,2,2h32c1.10457,0,2-0.89543,2-2V3 C39,1.89543,38.10457,1,37,1z" /> <polygon fill="#EFD358" points="44,29.2501 44,46 38,43 32,46 32,29.2501 " /> <path fill="#B3B3B3" d="M30,14H12c-0.55273,0-1-0.44775-1-1s0.44727-1,1-1h18c0.55273,0,1,0.44775,1,1S30.55273,14,30,14z" /> <path fill="#B3B3B3" d="M24,22H12c-0.55273,0-1-0.44775-1-1s0.44727-1,1-1h12c0.55273,0,1,0.44775,1,1S24.55273,22,24,22z" /> <path fill="#B3B3B3" d="M24,30H12c-0.55273,0-1-0.44775-1-1s0.44727-1,1-1h12c0.55273,0,1,0.44775,1,1S24.55273,30,24,30z" /> <path fill="#E86C60" d="M38,15c-4.96289,0-9,4.0376-9,9s4.03711,9,9,9s9-4.0376,9-9S42.96289,15,38,15z" /> <circle fill="#C94949" cx={38} cy={24} r={4} /></g></svg>
    ,
    description: "A government-backed savings plan, ensuring financial stability for your family.",
    summary: "A government-backed savings plan, ensuring financial stability for your family. This blessing helps secure your family’s future with a reliable investment, offering a safe and steady way to grow your savings."
  },
  {
    Id: 2489,
    type: "TIER#3",
    name: "Two Extra Paid Leaves",
    mName: <>Two days of<br /> Extra Paid Leaves</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>honeymoon</title><g><path d="M37.117,19.373l-9.206,9.2L38.144,45.517a1,1,0,0,0,1.563.19l2.275-2.275a4.977,4.977,0,0,0,1.225-5.061Z" fill="#c8c8c8" /><path d="M18.386,36.539a35.965,35.965,0,0,0,7.03-5.471L43.258,13.233c2.343-2.343,3.656-8.828,2-10.484-1.672-1.672-8.142-.344-10.485,2L16.932,22.583a36.014,36.014,0,0,0-5.472,7.031L5.122,41.55A.981.981,0,0,0,6.45,42.878Z" fill="#e3e3e3" /><path d="M2.484,9.856,19.427,20.088l9.206-9.2-19-6.093A4.979,4.979,0,0,0,4.568,6.018L2.293,8.293a1,1,0,0,0,.191,1.563Z" fill="#c8c8c8" /><path d="M42.086,11.171h-.043a1,1,0,0,1-.957-1.041,3.019,3.019,0,0,0-.876-2.251A2.975,2.975,0,0,0,37.959,7a1.028,1.028,0,0,1-1.041-.956A1,1,0,0,1,37.875,5a5,5,0,0,1,5.209,5.21A1,1,0,0,1,42.086,11.171Z" fill="#444" /><path d="M3.079,31a1,1,0,0,0-.784,1.7L7.209,37.62l3.213-6.052Z" fill="#c6c6c6" /><path d="M15.293,45.705a1,1,0,0,0,1.7-.784l-.565-7.344-6.053,3.214Z" fill="#c6c6c6" /><path d="M10,17.364a.993.993,0,0,1-.707-.293L2.61,10.388A5.5,5.5,0,0,1,10,2.257a5.5,5.5,0,0,1,7.39,8.131l-6.683,6.683A.993.993,0,0,1,10,17.364Z" fill="#f74b3b" /></g></svg>,
    description: "Because time spent with family is the greatest reward of all.",
    summary: "Because time spent with family is the greatest reward of all. This blessing gives you extra days to recharge and connect with your loved ones. Whether it’s a family vacation, a special celebration, or simply a day to relax, these leaves ensure you have time to cherish the moments that matter most."
  },
  {
    Id: 2490,
    type: "TIER#3",
    name: "Personal & Professional Growth Grant",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>temple</title><g><rect x={6} y={20} width={6} height={26} fill="#aeaeae" /><rect x={16} y={20} width={6} height={26} fill="#aeaeae" /><rect x={26} y={20} width={6} height={26} fill="#aeaeae" /><rect x={36} y={20} width={6} height={26} fill="#aeaeae" /><path d="M46.479,15.122l-22-12a1,1,0,0,0-.958,0l-22,12A1,1,0,0,0,1,16v6a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V16A1,1,0,0,0,46.479,15.122Z" fill="#e3e3e3" /><path d="M46,43H2a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V44A1,1,0,0,0,46,43Z" fill="#e3e3e3" /><circle cx={24} cy={14} r={4} fill="#949494" /><rect x={6} y={23} width={6} height={3} fill="#949494" /><rect x={16} y={23} width={6} height={3} fill="#949494" /><rect x={26} y={23} width={6} height={3} fill="#949494" /><rect x={36} y={23} width={6} height={3} fill="#949494" /></g></svg>
    ,
    description: "A fund that can be used for skill development, certification courses, or personal enrichment, ensuring your growth matches the impact you create.",
    summary: "A fund for skill development, certification courses, or personal enrichment, ensuring your growth matches the impact you create. This blessing supports your continuous learning and development, helping you achieve your personal and professional goals."
  },
  {
    Id: 2491,
    type: "TIER#3",
    name: "Mental Wellness & Counseling Support",
    mName: <>Mental Wellness &<br />Counseling Support</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>spa</title><g><path d="M33.757,45.033A12.86,12.86,0,0,1,22.576,25.9c4.207-7.5,19.528-12.553,21.261-13.1a1,1,0,0,1,1.274.715c.432,1.764,4.1,17.449-.115,24.958a12.763,12.763,0,0,1-7.729,6.081A12.919,12.919,0,0,1,33.757,45.033Z" fill="#ea5da3" /><path d="M10.733,44.545A12.763,12.763,0,0,1,3,38.464c-4.21-7.509-.547-23.194-.115-24.958a1,1,0,0,1,1.274-.715c1.733.551,17.054,5.6,21.261,13.1A12.854,12.854,0,0,1,14.243,45.033,12.919,12.919,0,0,1,10.733,44.545Z" fill="#ea5da3" /><path d="M23.912,45a15.017,15.017,0,0,1-15-15C8.912,19.719,22.618,4.96,23.2,4.336a1,1,0,0,1,.73-.316h0a1,1,0,0,1,.73.317c.582.624,14.25,15.382,14.25,25.658A15.017,15.017,0,0,1,23.912,45Z" fill="#f888c0" /></g></svg>,
    description: "Access to therapy, stress management sessions, or mindfulness programs for employees and their families.",
    summary: "Access to therapy, stress management sessions, or mindfulness programs for you and your family. This blessing ensures your family’s mental well-being is prioritized, offering support and guidance to help you navigate life’s challenges."
  },
  {
    Id: 2492,
    type: "TIER#4",
    name: "Your Child Education Scholarship",

    mName: <>Your Child<br />Education Scholarship</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>certificate</title><g><path fill="#B3B3B3" d="M8.00098,13c-0.34131,0-0.67432-0.1748-0.86133-0.49023c-0.28125-0.47461-0.12451-1.08789,0.3501-1.37012 l12.16162-7.21191c0.4751-0.28125,1.08838-0.125,1.37061,0.35059c0.28125,0.47461,0.12451,1.08789-0.3501,1.37012L8.51025,12.86035 C8.3501,12.95508,8.17432,13,8.00098,13z" /> <path fill="#B3B3B3" d="M35.99902,13c-0.17334,0-0.34912-0.04492-0.50928-0.13965L23.32812,5.64844 c-0.47461-0.28223-0.63135-0.89551-0.3501-1.37012c0.28223-0.47559,0.896-0.63184,1.37061-0.35059l12.16162,7.21191 c0.47461,0.28223,0.63135,0.89551,0.3501,1.37012C36.67334,12.8252,36.34033,13,35.99902,13z" /> <path fill="#A67C52" d="M42,41H2c-0.55225,0-1-0.44727-1-1V12c0-0.55273,0.44775-1,1-1h40c0.55225,0,1,0.44727,1,1v28 C43,40.55273,42.55225,41,42,41z" /> <circle fill="#A67C52" cx={22} cy={4} r={3} /> <rect x={4} y={14} fill="#E6E6E6" width={36} height={24} /> <path fill="#B3B3B3" d="M26,23H10c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h16c0.55225,0,1,0.44727,1,1S26.55225,23,26,23z" /> <path fill="#B3B3B3" d="M22,31H10c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h12c0.55225,0,1,0.44727,1,1S22.55225,31,22,31z" /> <polygon fill="#EFD358" points="44,30.2501 44,47 38,44 32,47 32,30.2501 " /> <path fill="#E86C60" d="M38,16c-4.96289,0-9,4.0376-9,9s4.03711,9,9,9s9-4.0376,9-9S42.96289,16,38,16z" /> <circle fill="#C94949" cx={38} cy={25} r={4} /></g></svg>
    ,
    description: "A direct contribution toward your child's schooling or higher education, ensuring their dreams have a strong foundation—just as you build for so many others.",
    summary: "A direct contribution toward your child's schooling or higher education, ensuring their dreams have a strong foundation—just as you build for so many others. This blessing supports your child’s academic journey, helping them achieve their full potential."
  },
  {
    Id: 2493,
    type: "TIER#4",
    name: "₹50L Accidental Life Insurance",
    mName: <>₹50L Accidental<br />Life Insurance</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>security</title><g><path d="M24 46C23.866 46 23.731 45.973 23.606 45.919C10.077 40.121 2 26.32 2 9C2 8.448 2.447 8 3 8C8.655 8 16.996 6.468 23.445 2.168C23.781 1.944 24.218 1.944 24.554 2.168C31.003 6.468 39.344 8 44.999 8C45.552 8 45.999 8.448 45.999 9C45.999 26.32 37.922 40.121 24.393 45.919C24.268 45.973 24.134 46 24 46Z" fill="url(#nc-ui-3-0_linear_119_108)" /> <path d="M45 8C39.345 8 31.004 6.468 24.555 2.168C24.387 2.056 24.194 2 24 2V24H43.734C45.217 19.43 46 14.386 46 9C46 8.448 45.553 8 45 8Z" fill="url(#nc-ui-3-1_linear_119_108)" /> <path d="M4.26599 24C7.55199 34.128 14.284 41.924 23.606 45.919C23.731 45.973 23.866 46 24 46V24H4.26599Z" fill="url(#nc-ui-3-2_linear_119_108)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_108" x1="23.9995" y1={2} x2="23.9995" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_108" x1={35} y1={2} x2={35} y2={24} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_108" x1="14.133" y1={24} x2="14.133" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    ,
    description: "Providing long-term financial security for your family, just as you provide stability to others.",
    summary: "Providing long-term financial security for your family, just as you provide stability to others. This blessing ensures your loved ones are protected in case of unforeseen events, giving you peace of mind and ensuring their future is secure."
  },
  {
    Id: 2494,
    type: "TIER#4",
    name: "Home Makeover Support",
    mName: <>Your Home<br />Makeover Support</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>eco-home</title><g><path d="M24,2.876,6,17.6V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V17.6Z" fill="#ead8c5" /><path d="M46,22a1,1,0,0,1-.632-.226L24,4.292,2.633,21.774a1,1,0,0,1-1.266-1.548l22-18a1,1,0,0,1,1.266,0l22,18A1,1,0,0,1,46,22Z" fill="#e86c60" /><path d="M32.694,19.28A.985.985,0,0,0,31.926,19c-.367.027-9.051.708-12.633,4.29-4.387,4.387-2.331,10.754-2.241,11.023a1,1,0,0,0,.647.638,13.626,13.626,0,0,0,3.78.523,9.975,9.975,0,0,0,7.228-2.77C32.619,28.8,32.985,20.394,33,20.039A1,1,0,0,0,32.694,19.28Z" fill="#72c472" /><path d="M14,39a1,1,0,0,1-.707-1.707l10-10a1,1,0,0,1,1.414,1.414l-10,10A1,1,0,0,1,14,39Z" fill="#4da34d" /></g></svg>
    ,
    description: "A contribution towards home improvements, appliances, or furniture, making your home as comfortable as the lives you help improve.",
    summary: "A contribution towards home improvements, appliances, or furniture, making your home as comfortable as the lives you help improve. This blessing ensures your home is a place of comfort, warmth, and happiness for your family."
  },
  {
    Id: 2495,
    type: "TIER#4",
    name: "Family Leisure & Experience Pass",
    mName: <>Family Leisure &<br /> Experience Pass</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>world-marker</title><g><circle cx={24} cy={25} r={22} fill="#cbeafb" /><path d="M2,25A21.942,21.942,0,0,0,9.43,41.478l1.944-2.915s1.389-.4,1.688-.938C14,35.938,12.335,33,12.335,33A9.523,9.523,0,0,0,12,30.919c-.25-.625-2-1.481-2-1.481S8.312,26.688,8.312,25a2.517,2.517,0,0,1,2.375-2.624,4.1,4.1,0,0,0,2.688-1.938S15.5,19.875,16,19s-.562-3.994-.562-3.994a5.221,5.221,0,0,0-.021-2.506,4.739,4.739,0,0,0-1.574-1.895,10.4,10.4,0,0,0-2.449-3.631A21.97,21.97,0,0,0,2,25Z" fill="#78d478" /><path d="M40.9,25.716c.5,1.188-.939,4.22-2.125,4.812a8.054,8.054,0,0,0-3.08,2.456c-.438.688-1.013,3.524-2.45,4.087s-4.845,3.77-6.657,3.27-1.813-4.813-.563-6.751c.746-1.157-.125-3.688-.188-4.562s-2.687-2.5-2.688-3.375c0-1.375,3-5,3-5a10.673,10.673,0,0,1,3.208-.625,11.346,11.346,0,0,1,2.167,1.062A15.05,15.05,0,0,1,35.4,21.9l1.438,1.312S40.4,24.528,40.9,25.716Z" fill="#78d478" /><path d="M33,25a1,1,0,0,1-1-1V18a1,1,0,0,1,2,0v6A1,1,0,0,1,33,25Z" fill="#2a4b55" /><path d="M33,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,33,19Z" fill="#ff7163" /></g></svg>

    , description: "Fully sponsored family outings, amusement park visits, or exclusive leisure experiences to create cherished memories.",
    summary: "Fully sponsored family outings, amusement park visits, or exclusive leisure experiences to create cherished memories. This blessing ensures your family enjoys quality time and unforgettable moments together."
  },
  {
    Id: 2496,
    type: "TIER#4",
    name: "Golden Years Parental Support",
    mName: <>Golden Years<br />Parental Support</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>lifering</title><g><path d="M45 24C45 12.42 35.579 3 24 3C12.421 3 3 12.42 3 24C3 35.58 12.421 45 24 45C35.579 45 45 35.58 45 24ZM24 33C19.037 33 15 28.962 15 24C15 19.038 19.037 15 24 15C28.963 15 33 19.038 33 24C33 28.962 28.963 33 24 33Z" fill="url(#nc-ui-3-0_linear_119_188)" /> <path d="M2 14C2.553 14 3 13.552 3 13C3 7.486 7.486 3 13 3C13.553 3 14 2.552 14 2C14 1.448 13.553 1 13 1C6.383 1 1 6.383 1 13C1 13.552 1.447 14 2 14Z" fill="url(#nc-ui-3-1_linear_119_188)" /> <path d="M35 3C40.514 3 45 7.486 45 13C45 13.552 45.447 14 46 14C46.553 14 47 13.552 47 13C47 6.383 41.617 1 35 1C34.447 1 34 1.448 34 2C34 2.552 34.447 3 35 3Z" fill="url(#nc-ui-3-2_linear_119_188)" /> <path d="M46 34C45.447 34 45 34.448 45 35C45 40.514 40.514 45 35 45C34.447 45 34 45.448 34 46C34 46.552 34.447 47 35 47C41.617 47 47 41.617 47 35C47 34.448 46.553 34 46 34Z" fill="url(#nc-ui-3-3_linear_119_188)" /> <path d="M13 45C7.486 45 3 40.514 3 35C3 34.448 2.553 34 2 34C1.447 34 1 34.448 1 35C1 41.617 6.383 47 13 47C13.553 47 14 46.552 14 46C14 45.448 13.553 45 13 45Z" fill="url(#nc-ui-3-4_linear_119_188)" /> <path d="M28 2H20C19.4477 2 19 2.44772 19 3V16C19 16.5523 19.4477 17 20 17H28C28.5523 17 29 16.5523 29 16V3C29 2.44772 28.5523 2 28 2Z" fill="url(#nc-ui-3-5_linear_119_188)" /> <path d="M46 28V20C46 19.4477 45.5523 19 45 19H32C31.4477 19 31 19.4477 31 20V28C31 28.5523 31.4477 29 32 29H45C45.5523 29 46 28.5523 46 28Z" fill="url(#nc-ui-3-6_linear_119_188)" /> <path d="M20 46H28C28.5523 46 29 45.5523 29 45V32C29 31.4477 28.5523 31 28 31H20C19.4477 31 19 31.4477 19 32V45C19 45.5523 19.4477 46 20 46Z" fill="url(#nc-ui-3-7_linear_119_188)" /> <path d="M2 20L2 28C2 28.5523 2.44772 29 3 29H16C16.5523 29 17 28.5523 17 28V20C17 19.4477 16.5523 19 16 19H3C2.44772 19 2 19.4477 2 20Z" fill="url(#nc-ui-3-8_linear_119_188)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_188" x1={24} y1={3} x2={24} y2={45} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_188" x1="7.5" y1={1} x2="7.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_188" x1="40.5" y1={1} x2="40.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-3_linear_119_188" x1="40.5" y1={34} x2="40.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-4_linear_119_188" x1="7.5" y1={34} x2="7.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-5_linear_119_188" x1={24} y1={2} x2={24} y2="46.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-6_linear_119_188" x1={25} y1="2.5" x2={24} y2="45.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-7_linear_119_188" x1={24} y1="2.5" x2={24} y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-8_linear_119_188" x1={23} y1={2} x2="22.5" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    , description: "A wellness package for your parents, including comprehensive health check-ups and lifestyle support, ensuring their well-being.",
    summary: "A wellness package for your parents, including comprehensive health check-ups and lifestyle support, ensuring their well-being. This blessing ensures your parents are healthy, happy, and well-cared for in their golden years."
  },
  {
    Id: 2497,
    type: "TIER#4",
    name: "3 Days of Paid Leave",
    mName: <>3 Days of<br /> Extra Paid Leaves</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>honeymoon</title><g><path d="M37.117,19.373l-9.206,9.2L38.144,45.517a1,1,0,0,0,1.563.19l2.275-2.275a4.977,4.977,0,0,0,1.225-5.061Z" fill="#c8c8c8" /><path d="M18.386,36.539a35.965,35.965,0,0,0,7.03-5.471L43.258,13.233c2.343-2.343,3.656-8.828,2-10.484-1.672-1.672-8.142-.344-10.485,2L16.932,22.583a36.014,36.014,0,0,0-5.472,7.031L5.122,41.55A.981.981,0,0,0,6.45,42.878Z" fill="#e3e3e3" /><path d="M2.484,9.856,19.427,20.088l9.206-9.2-19-6.093A4.979,4.979,0,0,0,4.568,6.018L2.293,8.293a1,1,0,0,0,.191,1.563Z" fill="#c8c8c8" /><path d="M42.086,11.171h-.043a1,1,0,0,1-.957-1.041,3.019,3.019,0,0,0-.876-2.251A2.975,2.975,0,0,0,37.959,7a1.028,1.028,0,0,1-1.041-.956A1,1,0,0,1,37.875,5a5,5,0,0,1,5.209,5.21A1,1,0,0,1,42.086,11.171Z" fill="#444" /><path d="M3.079,31a1,1,0,0,0-.784,1.7L7.209,37.62l3.213-6.052Z" fill="#c6c6c6" /><path d="M15.293,45.705a1,1,0,0,0,1.7-.784l-.565-7.344-6.053,3.214Z" fill="#c6c6c6" /><path d="M10,17.364a.993.993,0,0,1-.707-.293L2.61,10.388A5.5,5.5,0,0,1,10,2.257a5.5,5.5,0,0,1,7.39,8.131l-6.683,6.683A.993.993,0,0,1,10,17.364Z" fill="#f74b3b" /></g></svg>
    ,
    description: "Extra time off to spend quality moments with your family, recharge, and embrace life’s special occasions.",
    summary: "Extra time off to spend quality moments with your family, recharge, and embrace life’s special occasions. This blessing ensures you have time to cherish the moments that matter most with your loved ones."
  },
  {
    Id: 2498,
    type: "TIER#5",
    name: "₹5L Corporate Health Insurance with 12,000+ Hospitals Across India",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bag-49</title><g><path fill="#B3B3B3" d="M44,45H4c-0.553,0-1-0.448-1-1v-8c0-0.552,0.447-1,1-1h40c0.553,0,1,0.448,1,1v8C45,44.552,44.553,45,44,45z " /> <path fill="#B3B3B3" d="M32,13c-0.553,0-1-0.448-1-1V5H17v7c0,0.552-0.447,1-1,1s-1-0.448-1-1V4c0-0.552,0.447-1,1-1h16 c0.553,0,1,0.448,1,1v8C33,12.552,32.553,13,32,13z" /> <path fill="#E6E6E6" d="M46,37H2c-0.552,0-1-0.448-1-1V12c0-0.552,0.448-1,1-1h44c0.552,0,1,0.448,1,1v24C47,36.552,46.552,37,46,37 z" /> <path fill="#E86C60" d="M29,22h-3v-3c0-0.552-0.448-1-1-1h-2c-0.552,0-1,0.448-1,1v3h-3c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1 h3v3c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-3h3c0.552,0,1-0.448,1-1v-2C30,22.448,29.552,22,29,22z" /></g></svg>, description: "For You, Your Parents, Your Wife/Husband, Your Little Boy, Your Cute Girl—Your Whole Family. Because your loved ones deserve the very best healthcare, always.",
    summary: "Covering you, your parents, your spouse, and your children with the best healthcare. This blessing ensures your entire family has access to world-class medical care, keeping them healthy and protected."
  },
  {
    Id: 2499,
    type: "TIER#5",
    name: "₹75L Accidental Life Insurance",
    mName: <>₹75L Accidental<br />Life Insurance</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>security</title><g><path d="M24 46C23.866 46 23.731 45.973 23.606 45.919C10.077 40.121 2 26.32 2 9C2 8.448 2.447 8 3 8C8.655 8 16.996 6.468 23.445 2.168C23.781 1.944 24.218 1.944 24.554 2.168C31.003 6.468 39.344 8 44.999 8C45.552 8 45.999 8.448 45.999 9C45.999 26.32 37.922 40.121 24.393 45.919C24.268 45.973 24.134 46 24 46Z" fill="url(#nc-ui-3-0_linear_119_108)" /> <path d="M45 8C39.345 8 31.004 6.468 24.555 2.168C24.387 2.056 24.194 2 24 2V24H43.734C45.217 19.43 46 14.386 46 9C46 8.448 45.553 8 45 8Z" fill="url(#nc-ui-3-1_linear_119_108)" /> <path d="M4.26599 24C7.55199 34.128 14.284 41.924 23.606 45.919C23.731 45.973 23.866 46 24 46V24H4.26599Z" fill="url(#nc-ui-3-2_linear_119_108)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_108" x1="23.9995" y1={2} x2="23.9995" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_108" x1={35} y1={2} x2={35} y2={24} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_108" x1="14.133" y1={24} x2="14.133" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    ,
    description: "Because the people who protect others must be protected themselves. Your family’s future is secured, just as you secure the future of others.",
    summary: "High-level financial protection for your family. This blessing ensures your loved ones are protected in case of unforeseen events, giving you peace of mind and ensuring their future is secure."
  },
  {
    Id: 2500,
    type: "TIER#5",
    name: "4 Paid Holidays",
    mName: <>4 Days of<br /> Extra Paid Leaves</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>honeymoon</title><g><path d="M37.117,19.373l-9.206,9.2L38.144,45.517a1,1,0,0,0,1.563.19l2.275-2.275a4.977,4.977,0,0,0,1.225-5.061Z" fill="#c8c8c8" /><path d="M18.386,36.539a35.965,35.965,0,0,0,7.03-5.471L43.258,13.233c2.343-2.343,3.656-8.828,2-10.484-1.672-1.672-8.142-.344-10.485,2L16.932,22.583a36.014,36.014,0,0,0-5.472,7.031L5.122,41.55A.981.981,0,0,0,6.45,42.878Z" fill="#e3e3e3" /><path d="M2.484,9.856,19.427,20.088l9.206-9.2-19-6.093A4.979,4.979,0,0,0,4.568,6.018L2.293,8.293a1,1,0,0,0,.191,1.563Z" fill="#c8c8c8" /><path d="M42.086,11.171h-.043a1,1,0,0,1-.957-1.041,3.019,3.019,0,0,0-.876-2.251A2.975,2.975,0,0,0,37.959,7a1.028,1.028,0,0,1-1.041-.956A1,1,0,0,1,37.875,5a5,5,0,0,1,5.209,5.21A1,1,0,0,1,42.086,11.171Z" fill="#444" /><path d="M3.079,31a1,1,0,0,0-.784,1.7L7.209,37.62l3.213-6.052Z" fill="#c6c6c6" /><path d="M15.293,45.705a1,1,0,0,0,1.7-.784l-.565-7.344-6.053,3.214Z" fill="#c6c6c6" /><path d="M10,17.364a.993.993,0,0,1-.707-.293L2.61,10.388A5.5,5.5,0,0,1,10,2.257a5.5,5.5,0,0,1,7.39,8.131l-6.683,6.683A.993.993,0,0,1,10,17.364Z" fill="#f74b3b" /></g></svg>
    ,
    description: "A well-earned break, so you can step away, recharge, and return even stronger for your family, your dreams, and your purpose.",
    summary: "Extended time off for relaxation and family bonding. This blessing ensures you have time to recharge, reconnect, and celebrate life’s special moments with your loved ones."
  },
  {
    Id: 2501,
    type: "TIER#5",
    name: "Festival & Life Celebration Bonus",
    mName: <>Festival & Life<br /> Celebration Bonus</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>party-popper</title><g><path d="M37.648,32.979,15.021,10.352a1,1,0,0,0-1.656.39L2.052,44.684A1,1,0,0,0,3,46a.987.987,0,0,0,.316-.052L37.258,34.635a1,1,0,0,0,.39-1.656Z" fill="#efd358" /> <ellipse cx="25.627" cy="22.373" rx={5} ry={17} transform="translate(-8.314 24.674) rotate(-45)" fill="#e2ac4b" /> <path d="M31,25a1,1,0,0,1-.9-1.426c2.516-5.349,8.805-7.2,15.29-4.5a1,1,0,1,1-.77,1.846c-5.451-2.27-10.674-.828-12.71,3.5A1,1,0,0,1,31,25Z" fill="#43a6dd" /> <circle cx={37} cy={9} r={3} fill="#e86c60" /> <circle cx={41} cy={39} r={2} fill="#e2ac4b" /> <circle cx={28} cy={18} r={2} fill="#5a7a84" /> <circle cx="42.5" cy="26.5" r="1.5" fill="#ae453e" /> <circle cx="17.5" cy="4.5" r="1.5" fill="#e2ac4b" /> <path d="M21,19a1,1,0,0,1-.6-1.8A12.026,12.026,0,0,0,24.081,2.394a1,1,0,0,1,1.838-.788A13.975,13.975,0,0,1,21.6,18.8.994.994,0,0,1,21,19Z" fill="#e86c60" /> <path d="M4.172,13.828a1,1,0,0,1-.707-.293,5,5,0,1,1,7.07-7.07A1,1,0,0,1,9.121,7.879a3.072,3.072,0,0,0-4.242,0,3,3,0,0,0,0,4.242,1,1,0,0,1-.707,1.707Z" fill="#43a6dd" /></g></svg>

    , description: "Extra financial support during festivals and your family's milestones—because life’s special moments should always be celebrated.",
    summary: "Extra financial support during festivals and your family’s milestones. This blessing ensures you can celebrate life’s special moments with joy and abundance."
  },
  {
    Id: 2502,
    type: "TIER#5",
    name: "Exclusive Child Talent & Education Fund",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>certificate</title><g><path fill="#B3B3B3" d="M8.00098,13c-0.34131,0-0.67432-0.1748-0.86133-0.49023c-0.28125-0.47461-0.12451-1.08789,0.3501-1.37012 l12.16162-7.21191c0.4751-0.28125,1.08838-0.125,1.37061,0.35059c0.28125,0.47461,0.12451,1.08789-0.3501,1.37012L8.51025,12.86035 C8.3501,12.95508,8.17432,13,8.00098,13z" /> <path fill="#B3B3B3" d="M35.99902,13c-0.17334,0-0.34912-0.04492-0.50928-0.13965L23.32812,5.64844 c-0.47461-0.28223-0.63135-0.89551-0.3501-1.37012c0.28223-0.47559,0.896-0.63184,1.37061-0.35059l12.16162,7.21191 c0.47461,0.28223,0.63135,0.89551,0.3501,1.37012C36.67334,12.8252,36.34033,13,35.99902,13z" /> <path fill="#A67C52" d="M42,41H2c-0.55225,0-1-0.44727-1-1V12c0-0.55273,0.44775-1,1-1h40c0.55225,0,1,0.44727,1,1v28 C43,40.55273,42.55225,41,42,41z" /> <circle fill="#A67C52" cx={22} cy={4} r={3} /> <rect x={4} y={14} fill="#E6E6E6" width={36} height={24} /> <path fill="#B3B3B3" d="M26,23H10c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h16c0.55225,0,1,0.44727,1,1S26.55225,23,26,23z" /> <path fill="#B3B3B3" d="M22,31H10c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h12c0.55225,0,1,0.44727,1,1S22.55225,31,22,31z" /> <polygon fill="#EFD358" points="44,30.2501 44,47 38,44 32,47 32,30.2501 " /> <path fill="#E86C60" d="M38,16c-4.96289,0-9,4.0376-9,9s4.03711,9,9,9s9-4.0376,9-9S42.96289,16,38,16z" /> <circle fill="#C94949" cx={38} cy={25} r={4} /></g></svg>

    , description: "Because every child has a gift waiting to be nurtured. This fund supports tuition, sports, music, arts, or any field where your child shines.",
    summary: "Support for your child’s talents and education, ensuring their success. This blessing ensures your child has the resources they need to achieve their dreams and reach their full potential."
  },
  {
    Id: 2503,
    type: "TIER#5",
    name: "Home Makeover Support",
    mName: <>Your Home<br />Makeover Support</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>eco-home</title><g><path d="M24,2.876,6,17.6V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V17.6Z" fill="#ead8c5" /><path d="M46,22a1,1,0,0,1-.632-.226L24,4.292,2.633,21.774a1,1,0,0,1-1.266-1.548l22-18a1,1,0,0,1,1.266,0l22,18A1,1,0,0,1,46,22Z" fill="#e86c60" /><path d="M32.694,19.28A.985.985,0,0,0,31.926,19c-.367.027-9.051.708-12.633,4.29-4.387,4.387-2.331,10.754-2.241,11.023a1,1,0,0,0,.647.638,13.626,13.626,0,0,0,3.78.523,9.975,9.975,0,0,0,7.228-2.77C32.619,28.8,32.985,20.394,33,20.039A1,1,0,0,0,32.694,19.28Z" fill="#72c472" /><path d="M14,39a1,1,0,0,1-.707-1.707l10-10a1,1,0,0,1,1.414,1.414l-10,10A1,1,0,0,1,14,39Z" fill="#4da34d" /></g></svg>

    , description: "A contribution towards home improvements, appliances, or furniture, making your home as comfortable as the lives you help improve.",
    summary: "Contribution for home improvements or appliances. This blessing ensures your home is a place of comfort, warmth, and happiness for your family."
  },
  {
    Id: 2504,
    type: "TIER#5",
    name: "Family Leisure & Experience Pass",
    mName: <>Family Leisure &<br />Experience Pass</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>world-marker</title><g><circle cx={24} cy={25} r={22} fill="#cbeafb" /><path d="M2,25A21.942,21.942,0,0,0,9.43,41.478l1.944-2.915s1.389-.4,1.688-.938C14,35.938,12.335,33,12.335,33A9.523,9.523,0,0,0,12,30.919c-.25-.625-2-1.481-2-1.481S8.312,26.688,8.312,25a2.517,2.517,0,0,1,2.375-2.624,4.1,4.1,0,0,0,2.688-1.938S15.5,19.875,16,19s-.562-3.994-.562-3.994a5.221,5.221,0,0,0-.021-2.506,4.739,4.739,0,0,0-1.574-1.895,10.4,10.4,0,0,0-2.449-3.631A21.97,21.97,0,0,0,2,25Z" fill="#78d478" /><path d="M40.9,25.716c.5,1.188-.939,4.22-2.125,4.812a8.054,8.054,0,0,0-3.08,2.456c-.438.688-1.013,3.524-2.45,4.087s-4.845,3.77-6.657,3.27-1.813-4.813-.563-6.751c.746-1.157-.125-3.688-.188-4.562s-2.687-2.5-2.688-3.375c0-1.375,3-5,3-5a10.673,10.673,0,0,1,3.208-.625,11.346,11.346,0,0,1,2.167,1.062A15.05,15.05,0,0,1,35.4,21.9l1.438,1.312S40.4,24.528,40.9,25.716Z" fill="#78d478" /><path d="M33,25a1,1,0,0,1-1-1V18a1,1,0,0,1,2,0v6A1,1,0,0,1,33,25Z" fill="#2a4b55" /><path d="M33,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,33,19Z" fill="#ff7163" /></g></svg>

    , description: "Fully sponsored family outings, amusement park visits, or exclusive leisure experiences to create cherished memories.",
    summary: "Fully sponsored family outings or exclusive leisure experiences. This blessing ensures your family enjoys quality time and unforgettable moments together."
  },
  {
    Id: 2505,
    type: "TIER#5",
    name: "Golden Years Parental Support",
    mName: <>Golden Years<br />Parental Support</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>lifering</title><g><path d="M45 24C45 12.42 35.579 3 24 3C12.421 3 3 12.42 3 24C3 35.58 12.421 45 24 45C35.579 45 45 35.58 45 24ZM24 33C19.037 33 15 28.962 15 24C15 19.038 19.037 15 24 15C28.963 15 33 19.038 33 24C33 28.962 28.963 33 24 33Z" fill="url(#nc-ui-3-0_linear_119_188)" /> <path d="M2 14C2.553 14 3 13.552 3 13C3 7.486 7.486 3 13 3C13.553 3 14 2.552 14 2C14 1.448 13.553 1 13 1C6.383 1 1 6.383 1 13C1 13.552 1.447 14 2 14Z" fill="url(#nc-ui-3-1_linear_119_188)" /> <path d="M35 3C40.514 3 45 7.486 45 13C45 13.552 45.447 14 46 14C46.553 14 47 13.552 47 13C47 6.383 41.617 1 35 1C34.447 1 34 1.448 34 2C34 2.552 34.447 3 35 3Z" fill="url(#nc-ui-3-2_linear_119_188)" /> <path d="M46 34C45.447 34 45 34.448 45 35C45 40.514 40.514 45 35 45C34.447 45 34 45.448 34 46C34 46.552 34.447 47 35 47C41.617 47 47 41.617 47 35C47 34.448 46.553 34 46 34Z" fill="url(#nc-ui-3-3_linear_119_188)" /> <path d="M13 45C7.486 45 3 40.514 3 35C3 34.448 2.553 34 2 34C1.447 34 1 34.448 1 35C1 41.617 6.383 47 13 47C13.553 47 14 46.552 14 46C14 45.448 13.553 45 13 45Z" fill="url(#nc-ui-3-4_linear_119_188)" /> <path d="M28 2H20C19.4477 2 19 2.44772 19 3V16C19 16.5523 19.4477 17 20 17H28C28.5523 17 29 16.5523 29 16V3C29 2.44772 28.5523 2 28 2Z" fill="url(#nc-ui-3-5_linear_119_188)" /> <path d="M46 28V20C46 19.4477 45.5523 19 45 19H32C31.4477 19 31 19.4477 31 20V28C31 28.5523 31.4477 29 32 29H45C45.5523 29 46 28.5523 46 28Z" fill="url(#nc-ui-3-6_linear_119_188)" /> <path d="M20 46H28C28.5523 46 29 45.5523 29 45V32C29 31.4477 28.5523 31 28 31H20C19.4477 31 19 31.4477 19 32V45C19 45.5523 19.4477 46 20 46Z" fill="url(#nc-ui-3-7_linear_119_188)" /> <path d="M2 20L2 28C2 28.5523 2.44772 29 3 29H16C16.5523 29 17 28.5523 17 28V20C17 19.4477 16.5523 19 16 19H3C2.44772 19 2 19.4477 2 20Z" fill="url(#nc-ui-3-8_linear_119_188)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_188" x1={24} y1={3} x2={24} y2={45} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_188" x1="7.5" y1={1} x2="7.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_188" x1="40.5" y1={1} x2="40.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-3_linear_119_188" x1="40.5" y1={34} x2="40.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-4_linear_119_188" x1="7.5" y1={34} x2="7.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-5_linear_119_188" x1={24} y1={2} x2={24} y2="46.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-6_linear_119_188" x1={25} y1="2.5" x2={24} y2="45.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-7_linear_119_188" x1={24} y1="2.5" x2={24} y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-8_linear_119_188" x1={23} y1={2} x2="22.5" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    , description: "A wellness package for your parents, including comprehensive health check-ups and lifestyle support, ensuring their well-being.",
    summary: "A wellness package for your parents, including comprehensive health check-ups and lifestyle support, ensuring their well-being. This blessing is designed to honor the role your parents have played in shaping your life and ensuring they are cared for in their golden years. From annual health screenings to personalized wellness plans, this support ensures your parents are healthy, happy, and well-cared for. It’s a way to give back to those who have given so much to you, ensuring their golden years are filled with comfort, care, and joy."
  },
  {
    Id: 2506,
    type: "TIER#6",
    name: "₹1 Cr Accidental Life Insurance",
    mName: <>₹1 Cr Accidental<br />Life Insurance</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>security</title><g><path d="M24 46C23.866 46 23.731 45.973 23.606 45.919C10.077 40.121 2 26.32 2 9C2 8.448 2.447 8 3 8C8.655 8 16.996 6.468 23.445 2.168C23.781 1.944 24.218 1.944 24.554 2.168C31.003 6.468 39.344 8 44.999 8C45.552 8 45.999 8.448 45.999 9C45.999 26.32 37.922 40.121 24.393 45.919C24.268 45.973 24.134 46 24 46Z" fill="url(#nc-ui-3-0_linear_119_108)" /> <path d="M45 8C39.345 8 31.004 6.468 24.555 2.168C24.387 2.056 24.194 2 24 2V24H43.734C45.217 19.43 46 14.386 46 9C46 8.448 45.553 8 45 8Z" fill="url(#nc-ui-3-1_linear_119_108)" /> <path d="M4.26599 24C7.55199 34.128 14.284 41.924 23.606 45.919C23.731 45.973 23.866 46 24 46V24H4.26599Z" fill="url(#nc-ui-3-2_linear_119_108)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_108" x1="23.9995" y1={2} x2="23.9995" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_108" x1={35} y1={2} x2={35} y2={24} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_108" x1="14.133" y1={24} x2="14.133" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    ,
    description: "Because the ones who uplift others must always be protected at the highest level.",
    summary: "Maximum financial security for your family. This blessing ensures your loved ones are protected at the highest level, giving you peace of mind and ensuring their future is secure."
  },
  {
    Id: 2507,
    type: "TIER#6",
    name: "₹5L Corporate Health Insurance with 12,000+ Hospitals Across India",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bag-49</title><g><path fill="#B3B3B3" d="M44,45H4c-0.553,0-1-0.448-1-1v-8c0-0.552,0.447-1,1-1h40c0.553,0,1,0.448,1,1v8C45,44.552,44.553,45,44,45z " /> <path fill="#B3B3B3" d="M32,13c-0.553,0-1-0.448-1-1V5H17v7c0,0.552-0.447,1-1,1s-1-0.448-1-1V4c0-0.552,0.447-1,1-1h16 c0.553,0,1,0.448,1,1v8C33,12.552,32.553,13,32,13z" /> <path fill="#E6E6E6" d="M46,37H2c-0.552,0-1-0.448-1-1V12c0-0.552,0.448-1,1-1h44c0.552,0,1,0.448,1,1v24C47,36.552,46.552,37,46,37 z" /> <path fill="#E86C60" d="M29,22h-3v-3c0-0.552-0.448-1-1-1h-2c-0.552,0-1,0.448-1,1v3h-3c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1 h3v3c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-3h3c0.552,0,1-0.448,1-1v-2C30,22.448,29.552,22,29,22z" /></g></svg>
    ,
    description: "Covering you, your parents, your wife/husband, your little boy, your cute girl—your entire family with the best healthcare.",
    summary: "Premium healthcare for your entire family. This blessing ensures your family has access to the best medical care, keeping them healthy and protected."
  },
  {
    Id: 2508,
    type: "TIER#6",
    name: "Salary Bonus - Take Home Blessed Savings Direct",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bow</title><g><path fill="#C64B4B" d="M15.58984,46.05078l-4.61816-7.03125l-8.26367,1.55908l11.11914-26.28662l13.17578,4.89746 L15.58984,46.05078z" /> <path fill="#C64B4B" d="M32.41113,46.04932L20.52148,18.12256l13.41895-4.15723L45.2998,40.58008l-8.27148-1.56055 L32.41113,46.04932z" /> <path fill="#E86C60" d="M5.99707,26.79102c-0.94336,0-1.88086-0.26904-2.7041-0.79932C1.85742,25.06738,1,23.49561,1,21.78809 V6.21191c0-1.70752,0.85742-3.2793,2.29297-4.20361c1.4375-0.92578,3.22168-1.05566,4.77637-0.34814L21.5791,7.80078 c0.35645,0.16211,0.58594,0.51807,0.58594,0.91016v10.57812c0,0.39209-0.22949,0.74805-0.58594,0.91016L8.06934,26.33984 C7.40527,26.6416,6.7002,26.79102,5.99707,26.79102z" /> <path fill="#E86C60" d="M42.00293,26.79102c-0.70312,0-1.4082-0.14941-2.07227-0.45117L26.4209,20.19922 c-0.35645-0.16211-0.58594-0.51807-0.58594-0.91016V8.71094c0-0.39209,0.22949-0.74805,0.58594-0.91016l13.50977-6.14062 c1.55566-0.70605,3.33984-0.57666,4.77637,0.34814C46.14258,2.93262,47,4.50439,47,6.21191v15.57617 c0,1.70752-0.85742,3.2793-2.29297,4.20361C43.88379,26.52197,42.94629,26.79102,42.00293,26.79102z" /> <path fill="#EFD358" d="M24,22L24,22c-2.20914,0-4-1.79086-4-4V10c0-2.20914,1.79086-4,4-4H24c2.20914,0,4,1.79086,4,4V18 C28,20.20914,26.20914,22,24,22z" /></g></svg>
    ,
    description: "A well-earned financial appreciation for your extraordinary contributions to Pinnacle’s mission.",
    summary: "Direct financial appreciation for your extraordinary contributions. This blessing ensures your hard work is rewarded, providing financial stability and growth for your family."
  },
  {
    Id: 2509,
    type: "TIER#6",
    name: "6 Fully Paid Holidays",
    mName: <>6 Days of <br /> Extra Paid Leaves</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>honeymoon</title><g><path d="M37.117,19.373l-9.206,9.2L38.144,45.517a1,1,0,0,0,1.563.19l2.275-2.275a4.977,4.977,0,0,0,1.225-5.061Z" fill="#c8c8c8" /><path d="M18.386,36.539a35.965,35.965,0,0,0,7.03-5.471L43.258,13.233c2.343-2.343,3.656-8.828,2-10.484-1.672-1.672-8.142-.344-10.485,2L16.932,22.583a36.014,36.014,0,0,0-5.472,7.031L5.122,41.55A.981.981,0,0,0,6.45,42.878Z" fill="#e3e3e3" /><path d="M2.484,9.856,19.427,20.088l9.206-9.2-19-6.093A4.979,4.979,0,0,0,4.568,6.018L2.293,8.293a1,1,0,0,0,.191,1.563Z" fill="#c8c8c8" /><path d="M42.086,11.171h-.043a1,1,0,0,1-.957-1.041,3.019,3.019,0,0,0-.876-2.251A2.975,2.975,0,0,0,37.959,7a1.028,1.028,0,0,1-1.041-.956A1,1,0,0,1,37.875,5a5,5,0,0,1,5.209,5.21A1,1,0,0,1,42.086,11.171Z" fill="#444" /><path d="M3.079,31a1,1,0,0,0-.784,1.7L7.209,37.62l3.213-6.052Z" fill="#c6c6c6" /><path d="M15.293,45.705a1,1,0,0,0,1.7-.784l-.565-7.344-6.053,3.214Z" fill="#c6c6c6" /><path d="M10,17.364a.993.993,0,0,1-.707-.293L2.61,10.388A5.5,5.5,0,0,1,10,2.257a5.5,5.5,0,0,1,7.39,8.131l-6.683,6.683A.993.993,0,0,1,10,17.364Z" fill="#f74b3b" /></g></svg>
    ,
    description: "A well-deserved retreat to recharge, reconnect with your loved ones, and celebrate the impact you have made.",
    summary: "Extended time off for relaxation and family bonding. This blessing ensures you have time to recharge, reconnect, and celebrate life’s special moments with your loved ones."
  },
  {
    Id: 2510,
    type: "TIER#6",
    name: "Festival & Life Celebration Bonus",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>party-popper</title><g><path d="M37.648,32.979,15.021,10.352a1,1,0,0,0-1.656.39L2.052,44.684A1,1,0,0,0,3,46a.987.987,0,0,0,.316-.052L37.258,34.635a1,1,0,0,0,.39-1.656Z" fill="#efd358" /> <ellipse cx="25.627" cy="22.373" rx={5} ry={17} transform="translate(-8.314 24.674) rotate(-45)" fill="#e2ac4b" /> <path d="M31,25a1,1,0,0,1-.9-1.426c2.516-5.349,8.805-7.2,15.29-4.5a1,1,0,1,1-.77,1.846c-5.451-2.27-10.674-.828-12.71,3.5A1,1,0,0,1,31,25Z" fill="#43a6dd" /> <circle cx={37} cy={9} r={3} fill="#e86c60" /> <circle cx={41} cy={39} r={2} fill="#e2ac4b" /> <circle cx={28} cy={18} r={2} fill="#5a7a84" /> <circle cx="42.5" cy="26.5" r="1.5" fill="#ae453e" /> <circle cx="17.5" cy="4.5" r="1.5" fill="#e2ac4b" /> <path d="M21,19a1,1,0,0,1-.6-1.8A12.026,12.026,0,0,0,24.081,2.394a1,1,0,0,1,1.838-.788A13.975,13.975,0,0,1,21.6,18.8.994.994,0,0,1,21,19Z" fill="#e86c60" /> <path d="M4.172,13.828a1,1,0,0,1-.707-.293,5,5,0,1,1,7.07-7.07A1,1,0,0,1,9.121,7.879a3.072,3.072,0,0,0-4.242,0,3,3,0,0,0,0,4.242,1,1,0,0,1-.707,1.707Z" fill="#43a6dd" /></g></svg>
    ,
    description: "Extra financial support to celebrate life’s special moments, ensuring joy for you and your loved ones.",
    summary: "Financial support for celebrating life’s special moments. This blessing ensures you can celebrate life’s milestones with joy and abundance."
  },
  {
    Id: 2511,
    type: "TIER#6",
    name: "Exclusive Child Talent & Education Fund",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>certificate</title><g><path fill="#B3B3B3" d="M8.00098,13c-0.34131,0-0.67432-0.1748-0.86133-0.49023c-0.28125-0.47461-0.12451-1.08789,0.3501-1.37012 l12.16162-7.21191c0.4751-0.28125,1.08838-0.125,1.37061,0.35059c0.28125,0.47461,0.12451,1.08789-0.3501,1.37012L8.51025,12.86035 C8.3501,12.95508,8.17432,13,8.00098,13z" /> <path fill="#B3B3B3" d="M35.99902,13c-0.17334,0-0.34912-0.04492-0.50928-0.13965L23.32812,5.64844 c-0.47461-0.28223-0.63135-0.89551-0.3501-1.37012c0.28223-0.47559,0.896-0.63184,1.37061-0.35059l12.16162,7.21191 c0.47461,0.28223,0.63135,0.89551,0.3501,1.37012C36.67334,12.8252,36.34033,13,35.99902,13z" /> <path fill="#A67C52" d="M42,41H2c-0.55225,0-1-0.44727-1-1V12c0-0.55273,0.44775-1,1-1h40c0.55225,0,1,0.44727,1,1v28 C43,40.55273,42.55225,41,42,41z" /> <circle fill="#A67C52" cx={22} cy={4} r={3} /> <rect x={4} y={14} fill="#E6E6E6" width={36} height={24} /> <path fill="#B3B3B3" d="M26,23H10c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h16c0.55225,0,1,0.44727,1,1S26.55225,23,26,23z" /> <path fill="#B3B3B3" d="M22,31H10c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h12c0.55225,0,1,0.44727,1,1S22.55225,31,22,31z" /> <polygon fill="#EFD358" points="44,30.2501 44,47 38,44 32,47 32,30.2501 " /> <path fill="#E86C60" d="M38,16c-4.96289,0-9,4.0376-9,9s4.03711,9,9,9s9-4.0376,9-9S42.96289,16,38,16z" /> <circle fill="#C94949" cx={38} cy={25} r={4} /></g></svg>
    ,
    description: "A direct investment in your child’s education, skills, and passion, ensuring their success just as you ensure success for so many children.",
    summary: "Investment in your child’s education and talents. This blessing ensures your child has the resources they need to achieve their dreams and reach their full potential."
  },
  {
    Id: 2512,
    type: "TIER#6",
    name: "Golden Years Parental Support",
    mName: <>Golden Years<br />Parental Support</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>lifering</title><g><path d="M45 24C45 12.42 35.579 3 24 3C12.421 3 3 12.42 3 24C3 35.58 12.421 45 24 45C35.579 45 45 35.58 45 24ZM24 33C19.037 33 15 28.962 15 24C15 19.038 19.037 15 24 15C28.963 15 33 19.038 33 24C33 28.962 28.963 33 24 33Z" fill="url(#nc-ui-3-0_linear_119_188)" /> <path d="M2 14C2.553 14 3 13.552 3 13C3 7.486 7.486 3 13 3C13.553 3 14 2.552 14 2C14 1.448 13.553 1 13 1C6.383 1 1 6.383 1 13C1 13.552 1.447 14 2 14Z" fill="url(#nc-ui-3-1_linear_119_188)" /> <path d="M35 3C40.514 3 45 7.486 45 13C45 13.552 45.447 14 46 14C46.553 14 47 13.552 47 13C47 6.383 41.617 1 35 1C34.447 1 34 1.448 34 2C34 2.552 34.447 3 35 3Z" fill="url(#nc-ui-3-2_linear_119_188)" /> <path d="M46 34C45.447 34 45 34.448 45 35C45 40.514 40.514 45 35 45C34.447 45 34 45.448 34 46C34 46.552 34.447 47 35 47C41.617 47 47 41.617 47 35C47 34.448 46.553 34 46 34Z" fill="url(#nc-ui-3-3_linear_119_188)" /> <path d="M13 45C7.486 45 3 40.514 3 35C3 34.448 2.553 34 2 34C1.447 34 1 34.448 1 35C1 41.617 6.383 47 13 47C13.553 47 14 46.552 14 46C14 45.448 13.553 45 13 45Z" fill="url(#nc-ui-3-4_linear_119_188)" /> <path d="M28 2H20C19.4477 2 19 2.44772 19 3V16C19 16.5523 19.4477 17 20 17H28C28.5523 17 29 16.5523 29 16V3C29 2.44772 28.5523 2 28 2Z" fill="url(#nc-ui-3-5_linear_119_188)" /> <path d="M46 28V20C46 19.4477 45.5523 19 45 19H32C31.4477 19 31 19.4477 31 20V28C31 28.5523 31.4477 29 32 29H45C45.5523 29 46 28.5523 46 28Z" fill="url(#nc-ui-3-6_linear_119_188)" /> <path d="M20 46H28C28.5523 46 29 45.5523 29 45V32C29 31.4477 28.5523 31 28 31H20C19.4477 31 19 31.4477 19 32V45C19 45.5523 19.4477 46 20 46Z" fill="url(#nc-ui-3-7_linear_119_188)" /> <path d="M2 20L2 28C2 28.5523 2.44772 29 3 29H16C16.5523 29 17 28.5523 17 28V20C17 19.4477 16.5523 19 16 19H3C2.44772 19 2 19.4477 2 20Z" fill="url(#nc-ui-3-8_linear_119_188)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_188" x1={24} y1={3} x2={24} y2={45} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_188" x1="7.5" y1={1} x2="7.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_188" x1="40.5" y1={1} x2="40.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-3_linear_119_188" x1="40.5" y1={34} x2="40.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-4_linear_119_188" x1="7.5" y1={34} x2="7.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-5_linear_119_188" x1={24} y1={2} x2={24} y2="46.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-6_linear_119_188" x1={25} y1="2.5" x2={24} y2="45.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-7_linear_119_188" x1={24} y1="2.5" x2={24} y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-8_linear_119_188" x1={23} y1={2} x2="22.5" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    ,
    description: "A premium wellness package for your parents, covering annual health check-ups, lifestyle support, and exclusive eldercare benefits.",
    summary: "Premium wellness package for your parents. This blessing ensures your parents are healthy, happy, and well-cared for in their golden years."
  },
  {
    Id: 2513,
    type: "TIER#6",
    name: "Home Makeover & Comfort Allowance",
    mName: <>Home Makeover &<br /> Comfort Allowance</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>eco-home</title><g><path d="M24,2.876,6,17.6V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V17.6Z" fill="#ead8c5" /><path d="M46,22a1,1,0,0,1-.632-.226L24,4.292,2.633,21.774a1,1,0,0,1-1.266-1.548l22-18a1,1,0,0,1,1.266,0l22,18A1,1,0,0,1,46,22Z" fill="#e86c60" /><path d="M32.694,19.28A.985.985,0,0,0,31.926,19c-.367.027-9.051.708-12.633,4.29-4.387,4.387-2.331,10.754-2.241,11.023a1,1,0,0,0,.647.638,13.626,13.626,0,0,0,3.78.523,9.975,9.975,0,0,0,7.228-2.77C32.619,28.8,32.985,20.394,33,20.039A1,1,0,0,0,32.694,19.28Z" fill="#72c472" /><path d="M14,39a1,1,0,0,1-.707-1.707l10-10a1,1,0,0,1,1.414,1.414l-10,10A1,1,0,0,1,14,39Z" fill="#4da34d" /></g></svg>
    ,
    description: "A significant contribution towards home improvements, appliances, or furniture, making your home a place of comfort and warmth, just like the lives you uplift.",
    summary: "Significant contribution for home improvements. This blessing ensures your home is a place of comfort, warmth, and happiness for your family."
  },
  {
    Id: 2514,
    type: "TIER#6",
    name: "Family Leisure & India Travel Experience",
    mName: <>Family Leisure &<br /> India Travel Experience</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>world-marker</title><g><circle cx={24} cy={25} r={22} fill="#cbeafb" /><path d="M2,25A21.942,21.942,0,0,0,9.43,41.478l1.944-2.915s1.389-.4,1.688-.938C14,35.938,12.335,33,12.335,33A9.523,9.523,0,0,0,12,30.919c-.25-.625-2-1.481-2-1.481S8.312,26.688,8.312,25a2.517,2.517,0,0,1,2.375-2.624,4.1,4.1,0,0,0,2.688-1.938S15.5,19.875,16,19s-.562-3.994-.562-3.994a5.221,5.221,0,0,0-.021-2.506,4.739,4.739,0,0,0-1.574-1.895,10.4,10.4,0,0,0-2.449-3.631A21.97,21.97,0,0,0,2,25Z" fill="#78d478" /><path d="M40.9,25.716c.5,1.188-.939,4.22-2.125,4.812a8.054,8.054,0,0,0-3.08,2.456c-.438.688-1.013,3.524-2.45,4.087s-4.845,3.77-6.657,3.27-1.813-4.813-.563-6.751c.746-1.157-.125-3.688-.188-4.562s-2.687-2.5-2.688-3.375c0-1.375,3-5,3-5a10.673,10.673,0,0,1,3.208-.625,11.346,11.346,0,0,1,2.167,1.062A15.05,15.05,0,0,1,35.4,21.9l1.438,1.312S40.4,24.528,40.9,25.716Z" fill="#78d478" /><path d="M33,25a1,1,0,0,1-1-1V18a1,1,0,0,1,2,0v6A1,1,0,0,1,33,25Z" fill="#2a4b55" /><path d="M33,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,33,19Z" fill="#ff7163" /></g></svg>
    ,
    description: "Fully sponsored domestic travel for you and your family, because those who change the world also deserve to explore it.",
    summary: "Fully sponsored domestic travel for your family. This blessing ensures your family can explore and create unforgettable memories together."
  },
  {
    Id: 2515,
    type: "TIER#7",
    name: "Permanent Salary Increment (Above & Beyond Annual Appraisal)",
    mName: <>Permanent Salary Increment, Above & Beyond Annual Appraisal</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>rate-up</title><g><path d="M14,1a1,1,0,0,0-.759.35l-12,14A1,1,0,0,0,2,17H9V46a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V17h7a1,1,0,0,0,.759-1.65l-12-14A1,1,0,0,0,14,1Z" fill="#78d478" /><path d="M30,33a5,5,0,1,1,5-5A5,5,0,0,1,30,33Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,30,25Z" fill="#aeaeae" /><path d="M42,47a5,5,0,1,1,5-5A5,5,0,0,1,42,47Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,42,39Z" fill="#aeaeae" /><path d="M27,47a1,1,0,0,1-.774-1.633l18-22a1,1,0,0,1,1.549,1.266h0l-18,22A1,1,0,0,1,27,47Z" fill="#aeaeae" /></g></svg>
    ,
    description: "Your salary is permanently increased, recognizing your relentless dedication, ensuring your financial upliftment is as lasting as your impact.",
    summary: "Your salary is permanently increased, recognizing your relentless dedication. This blessing ensures your financial upliftment is as lasting as your impact, providing long-term stability and growth for your family."
  },
  {
    Id: 2516,
    type: "TIER#7",
    name: "₹1.5 Cr Accidental Life Insurance",
    mName: <>₹1.5 Cr Accidental <br />Life Insurance</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>security</title><g><path d="M24 46C23.866 46 23.731 45.973 23.606 45.919C10.077 40.121 2 26.32 2 9C2 8.448 2.447 8 3 8C8.655 8 16.996 6.468 23.445 2.168C23.781 1.944 24.218 1.944 24.554 2.168C31.003 6.468 39.344 8 44.999 8C45.552 8 45.999 8.448 45.999 9C45.999 26.32 37.922 40.121 24.393 45.919C24.268 45.973 24.134 46 24 46Z" fill="url(#nc-ui-3-0_linear_119_108)" /> <path d="M45 8C39.345 8 31.004 6.468 24.555 2.168C24.387 2.056 24.194 2 24 2V24H43.734C45.217 19.43 46 14.386 46 9C46 8.448 45.553 8 45 8Z" fill="url(#nc-ui-3-1_linear_119_108)" /> <path d="M4.26599 24C7.55199 34.128 14.284 41.924 23.606 45.919C23.731 45.973 23.866 46 24 46V24H4.26599Z" fill="url(#nc-ui-3-2_linear_119_108)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_108" x1="23.9995" y1={2} x2="23.9995" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_108" x1={35} y1={2} x2={35} y2={24} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_108" x1="14.133" y1={24} x2="14.133" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    ,
    description: "Because those who bring security to others must be protected at the highest level.",
    summary: "Top-tier financial protection for your family. This blessing ensures your loved ones are protected at the highest level, giving you peace of mind and ensuring their future is secure."
  },
  {
    Id: 2517,
    type: "TIER#7",
    name: "₹10L Corporate Health Insurance with 12,000+ Hospitals Across India",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bag-49</title><g><path fill="#B3B3B3" d="M44,45H4c-0.553,0-1-0.448-1-1v-8c0-0.552,0.447-1,1-1h40c0.553,0,1,0.448,1,1v8C45,44.552,44.553,45,44,45z " /> <path fill="#B3B3B3" d="M32,13c-0.553,0-1-0.448-1-1V5H17v7c0,0.552-0.447,1-1,1s-1-0.448-1-1V4c0-0.552,0.447-1,1-1h16 c0.553,0,1,0.448,1,1v8C33,12.552,32.553,13,32,13z" /> <path fill="#E6E6E6" d="M46,37H2c-0.552,0-1-0.448-1-1V12c0-0.552,0.448-1,1-1h44c0.552,0,1,0.448,1,1v24C47,36.552,46.552,37,46,37 z" /> <path fill="#E86C60" d="M29,22h-3v-3c0-0.552-0.448-1-1-1h-2c-0.552,0-1,0.448-1,1v3h-3c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1 h3v3c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-3h3c0.552,0,1-0.448,1-1v-2C30,22.448,29.552,22,29,22z" /></g></svg>
    ,
    description: "Covering you, your parents, your wife/husband, your little boy, your cute girl—your entire family with world-class healthcare.",
    summary: "World-class healthcare for your entire family. This blessing ensures your family has access to the best medical care, keeping them healthy and protected."
  },
  {
    Id: 2518,
    type: "TIER#7",
    name: "Double Salary Bonus - Take Home Blessed Savings Direct",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>bow</title><g><path fill="#C64B4B" d="M15.58984,46.05078l-4.61816-7.03125l-8.26367,1.55908l11.11914-26.28662l13.17578,4.89746 L15.58984,46.05078z" /> <path fill="#C64B4B" d="M32.41113,46.04932L20.52148,18.12256l13.41895-4.15723L45.2998,40.58008l-8.27148-1.56055 L32.41113,46.04932z" /> <path fill="#E86C60" d="M5.99707,26.79102c-0.94336,0-1.88086-0.26904-2.7041-0.79932C1.85742,25.06738,1,23.49561,1,21.78809 V6.21191c0-1.70752,0.85742-3.2793,2.29297-4.20361c1.4375-0.92578,3.22168-1.05566,4.77637-0.34814L21.5791,7.80078 c0.35645,0.16211,0.58594,0.51807,0.58594,0.91016v10.57812c0,0.39209-0.22949,0.74805-0.58594,0.91016L8.06934,26.33984 C7.40527,26.6416,6.7002,26.79102,5.99707,26.79102z" /> <path fill="#E86C60" d="M42.00293,26.79102c-0.70312,0-1.4082-0.14941-2.07227-0.45117L26.4209,20.19922 c-0.35645-0.16211-0.58594-0.51807-0.58594-0.91016V8.71094c0-0.39209,0.22949-0.74805,0.58594-0.91016l13.50977-6.14062 c1.55566-0.70605,3.33984-0.57666,4.77637,0.34814C46.14258,2.93262,47,4.50439,47,6.21191v15.57617 c0,1.70752-0.85742,3.2793-2.29297,4.20361C43.88379,26.52197,42.94629,26.79102,42.00293,26.79102z" /> <path fill="#EFD358" d="M24,22L24,22c-2.20914,0-4-1.79086-4-4V10c0-2.20914,1.79086-4,4-4H24c2.20914,0,4,1.79086,4,4V18 C28,20.20914,26.20914,22,24,22z" /></g></svg>
    ,
    description: "A financial appreciation for your extraordinary commitment to Pinnacle’s mission.",
    summary: "Direct financial appreciation for your extraordinary commitment. This blessing ensures your hard work is rewarded, providing financial stability and growth for your family."
  },
  {
    Id: 2519,
    type: "TIER#7",
    name: "7 Fully Paid Holidays",
    mName: <>7 Days of<br /> Extra Paid Leaves</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>honeymoon</title><g><path d="M37.117,19.373l-9.206,9.2L38.144,45.517a1,1,0,0,0,1.563.19l2.275-2.275a4.977,4.977,0,0,0,1.225-5.061Z" fill="#c8c8c8" /><path d="M18.386,36.539a35.965,35.965,0,0,0,7.03-5.471L43.258,13.233c2.343-2.343,3.656-8.828,2-10.484-1.672-1.672-8.142-.344-10.485,2L16.932,22.583a36.014,36.014,0,0,0-5.472,7.031L5.122,41.55A.981.981,0,0,0,6.45,42.878Z" fill="#e3e3e3" /><path d="M2.484,9.856,19.427,20.088l9.206-9.2-19-6.093A4.979,4.979,0,0,0,4.568,6.018L2.293,8.293a1,1,0,0,0,.191,1.563Z" fill="#c8c8c8" /><path d="M42.086,11.171h-.043a1,1,0,0,1-.957-1.041,3.019,3.019,0,0,0-.876-2.251A2.975,2.975,0,0,0,37.959,7a1.028,1.028,0,0,1-1.041-.956A1,1,0,0,1,37.875,5a5,5,0,0,1,5.209,5.21A1,1,0,0,1,42.086,11.171Z" fill="#444" /><path d="M3.079,31a1,1,0,0,0-.784,1.7L7.209,37.62l3.213-6.052Z" fill="#c6c6c6" /><path d="M15.293,45.705a1,1,0,0,0,1.7-.784l-.565-7.344-6.053,3.214Z" fill="#c6c6c6" /><path d="M10,17.364a.993.993,0,0,1-.707-.293L2.61,10.388A5.5,5.5,0,0,1,10,2.257a5.5,5.5,0,0,1,7.39,8.131l-6.683,6.683A.993.993,0,0,1,10,17.364Z" fill="#f74b3b" /></g></svg>
    ,
    description: "A well-earned break to step away, refresh, and celebrate the impact you have created.",
    summary: "Extended time off for relaxation and family bonding. This blessing ensures you have time to recharge, reconnect, and celebrate life’s special moments with your loved ones."
  },
  {
    Id: 2520,
    type: "TIER#7",
    name: "Exclusive Global Leadership Recognition",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>award</title><g><polygon fill="#EFD358" points="32,22 32,47 24,42 16,47 16,22 " /> <path fill="#E86C60" d="M24,31c-0.256,0-0.512-0.098-0.707-0.293L19.586,27H14c-0.553,0-1-0.447-1-1v-5.586l-3.707-3.707 c-0.391-0.391-0.391-1.023,0-1.414L13,11.586V6c0-0.553,0.447-1,1-1h5.586l3.707-3.707c0.391-0.391,1.023-0.391,1.414,0L28.414,5H34 c0.553,0,1,0.447,1,1v5.586l3.707,3.707c0.391,0.391,0.391,1.023,0,1.414L35,20.414V26c0,0.553-0.447,1-1,1h-5.586l-3.707,3.707 C24.512,30.902,24.256,31,24,31z M14,12h0.01H14z" /> <circle fill="#AA3333" cx={24} cy={16} r={6} /></g></svg>,
    description: "You are now part of Pinnacle’s Inner Circle of Visionaries, where your work is celebrated as a benchmark for excellence.",
    summary: "Part of Pinnacle’s Inner Circle of Visionaries. This blessing ensures your work is celebrated as a benchmark for excellence, setting you apart as a true leader and visionary."
  },
  {
    Id: 2521,
    type: "TIER#7",
    name: "Festival & Life Celebration Bonus",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>party-popper</title><g><path d="M37.648,32.979,15.021,10.352a1,1,0,0,0-1.656.39L2.052,44.684A1,1,0,0,0,3,46a.987.987,0,0,0,.316-.052L37.258,34.635a1,1,0,0,0,.39-1.656Z" fill="#efd358" /> <ellipse cx="25.627" cy="22.373" rx={5} ry={17} transform="translate(-8.314 24.674) rotate(-45)" fill="#e2ac4b" /> <path d="M31,25a1,1,0,0,1-.9-1.426c2.516-5.349,8.805-7.2,15.29-4.5a1,1,0,1,1-.77,1.846c-5.451-2.27-10.674-.828-12.71,3.5A1,1,0,0,1,31,25Z" fill="#43a6dd" /> <circle cx={37} cy={9} r={3} fill="#e86c60" /> <circle cx={41} cy={39} r={2} fill="#e2ac4b" /> <circle cx={28} cy={18} r={2} fill="#5a7a84" /> <circle cx="42.5" cy="26.5" r="1.5" fill="#ae453e" /> <circle cx="17.5" cy="4.5" r="1.5" fill="#e2ac4b" /> <path d="M21,19a1,1,0,0,1-.6-1.8A12.026,12.026,0,0,0,24.081,2.394a1,1,0,0,1,1.838-.788A13.975,13.975,0,0,1,21.6,18.8.994.994,0,0,1,21,19Z" fill="#e86c60" /> <path d="M4.172,13.828a1,1,0,0,1-.707-.293,5,5,0,1,1,7.07-7.07A1,1,0,0,1,9.121,7.879a3.072,3.072,0,0,0-4.242,0,3,3,0,0,0,0,4.242,1,1,0,0,1-.707,1.707Z" fill="#43a6dd" /></g></svg>
    ,
    description: "Extra financial support for celebrating life’s biggest moments with your loved ones.",
    summary: "Financial support for celebrating life’s biggest moments. This blessing ensures you can celebrate life’s milestones with joy and abundance."
  },
  {
    Id: 2522,
    type: "TIER#7",
    name: "Golden Years Parental Support",
    mName: <>Golden Years<br />Parental Support</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>lifering</title><g><path d="M45 24C45 12.42 35.579 3 24 3C12.421 3 3 12.42 3 24C3 35.58 12.421 45 24 45C35.579 45 45 35.58 45 24ZM24 33C19.037 33 15 28.962 15 24C15 19.038 19.037 15 24 15C28.963 15 33 19.038 33 24C33 28.962 28.963 33 24 33Z" fill="url(#nc-ui-3-0_linear_119_188)" /> <path d="M2 14C2.553 14 3 13.552 3 13C3 7.486 7.486 3 13 3C13.553 3 14 2.552 14 2C14 1.448 13.553 1 13 1C6.383 1 1 6.383 1 13C1 13.552 1.447 14 2 14Z" fill="url(#nc-ui-3-1_linear_119_188)" /> <path d="M35 3C40.514 3 45 7.486 45 13C45 13.552 45.447 14 46 14C46.553 14 47 13.552 47 13C47 6.383 41.617 1 35 1C34.447 1 34 1.448 34 2C34 2.552 34.447 3 35 3Z" fill="url(#nc-ui-3-2_linear_119_188)" /> <path d="M46 34C45.447 34 45 34.448 45 35C45 40.514 40.514 45 35 45C34.447 45 34 45.448 34 46C34 46.552 34.447 47 35 47C41.617 47 47 41.617 47 35C47 34.448 46.553 34 46 34Z" fill="url(#nc-ui-3-3_linear_119_188)" /> <path d="M13 45C7.486 45 3 40.514 3 35C3 34.448 2.553 34 2 34C1.447 34 1 34.448 1 35C1 41.617 6.383 47 13 47C13.553 47 14 46.552 14 46C14 45.448 13.553 45 13 45Z" fill="url(#nc-ui-3-4_linear_119_188)" /> <path d="M28 2H20C19.4477 2 19 2.44772 19 3V16C19 16.5523 19.4477 17 20 17H28C28.5523 17 29 16.5523 29 16V3C29 2.44772 28.5523 2 28 2Z" fill="url(#nc-ui-3-5_linear_119_188)" /> <path d="M46 28V20C46 19.4477 45.5523 19 45 19H32C31.4477 19 31 19.4477 31 20V28C31 28.5523 31.4477 29 32 29H45C45.5523 29 46 28.5523 46 28Z" fill="url(#nc-ui-3-6_linear_119_188)" /> <path d="M20 46H28C28.5523 46 29 45.5523 29 45V32C29 31.4477 28.5523 31 28 31H20C19.4477 31 19 31.4477 19 32V45C19 45.5523 19.4477 46 20 46Z" fill="url(#nc-ui-3-7_linear_119_188)" /> <path d="M2 20L2 28C2 28.5523 2.44772 29 3 29H16C16.5523 29 17 28.5523 17 28V20C17 19.4477 16.5523 19 16 19H3C2.44772 19 2 19.4477 2 20Z" fill="url(#nc-ui-3-8_linear_119_188)" /> <defs> <linearGradient id="nc-ui-3-0_linear_119_188" x1={24} y1={3} x2={24} y2={45} gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD6DA" /> <stop offset={1} stopColor="#FF9EA8" /> </linearGradient> <linearGradient id="nc-ui-3-1_linear_119_188" x1="7.5" y1={1} x2="7.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-2_linear_119_188" x1="40.5" y1={1} x2="40.5" y2={14} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-3_linear_119_188" x1="40.5" y1={34} x2="40.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-4_linear_119_188" x1="7.5" y1={34} x2="7.5" y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-5_linear_119_188" x1={24} y1={2} x2={24} y2="46.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-6_linear_119_188" x1={25} y1="2.5" x2={24} y2="45.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-7_linear_119_188" x1={24} y1="2.5" x2={24} y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> <linearGradient id="nc-ui-3-8_linear_119_188" x1={23} y1={2} x2="22.5" y2={46} gradientUnits="userSpaceOnUse"> <stop stopColor="#FF666D" /> <stop offset={1} stopColor="#E0211F" /> </linearGradient> </defs></g></svg>
    ,
    description: "A premium wellness package for your parents, covering annual health check-ups, lifestyle support, and exclusive eldercare benefits",
    summary: "Investment in your child’s education and talents. This blessing ensures your child has the resources they need to achieve their dreams and reach their full potential."
  },
  {
    Id: 2523,
    type: "TIER#7",
    name: "Home Ownership & Family Prosperity Grant",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>eco-home</title><g><path d="M24,2.876,6,17.6V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V17.6Z" fill="#ead8c5" /><path d="M46,22a1,1,0,0,1-.632-.226L24,4.292,2.633,21.774a1,1,0,0,1-1.266-1.548l22-18a1,1,0,0,1,1.266,0l22,18A1,1,0,0,1,46,22Z" fill="#e86c60" /><path d="M32.694,19.28A.985.985,0,0,0,31.926,19c-.367.027-9.051.708-12.633,4.29-4.387,4.387-2.331,10.754-2.241,11.023a1,1,0,0,0,.647.638,13.626,13.626,0,0,0,3.78.523,9.975,9.975,0,0,0,7.228-2.77C32.619,28.8,32.985,20.394,33,20.039A1,1,0,0,0,32.694,19.28Z" fill="#72c472" /><path d="M14,39a1,1,0,0,1-.707-1.707l10-10a1,1,0,0,1,1.414,1.414l-10,10A1,1,0,0,1,14,39Z" fill="#4da34d" /></g></svg>
    ,
    description: "A substantial contribution towards your homeownership journey, renovations, or property investments, ensuring generational security.",
    summary: "Contribution for homeownership or renovations. This blessing ensures your home is a place of comfort, warmth, and happiness for your family."
  },
  {
    Id: 2524,
    type: "TIER#7",
    name: "Family Leisure & Global Travel Experience",
    mName: <>Family Leisure &<br /> Global Travel Experience</>,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>world-marker</title><g><circle cx={24} cy={25} r={22} fill="#cbeafb" /><path d="M2,25A21.942,21.942,0,0,0,9.43,41.478l1.944-2.915s1.389-.4,1.688-.938C14,35.938,12.335,33,12.335,33A9.523,9.523,0,0,0,12,30.919c-.25-.625-2-1.481-2-1.481S8.312,26.688,8.312,25a2.517,2.517,0,0,1,2.375-2.624,4.1,4.1,0,0,0,2.688-1.938S15.5,19.875,16,19s-.562-3.994-.562-3.994a5.221,5.221,0,0,0-.021-2.506,4.739,4.739,0,0,0-1.574-1.895,10.4,10.4,0,0,0-2.449-3.631A21.97,21.97,0,0,0,2,25Z" fill="#78d478" /><path d="M40.9,25.716c.5,1.188-.939,4.22-2.125,4.812a8.054,8.054,0,0,0-3.08,2.456c-.438.688-1.013,3.524-2.45,4.087s-4.845,3.77-6.657,3.27-1.813-4.813-.563-6.751c.746-1.157-.125-3.688-.188-4.562s-2.687-2.5-2.688-3.375c0-1.375,3-5,3-5a10.673,10.673,0,0,1,3.208-.625,11.346,11.346,0,0,1,2.167,1.062A15.05,15.05,0,0,1,35.4,21.9l1.438,1.312S40.4,24.528,40.9,25.716Z" fill="#78d478" /><path d="M33,25a1,1,0,0,1-1-1V18a1,1,0,0,1,2,0v6A1,1,0,0,1,33,25Z" fill="#2a4b55" /><path d="M33,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,33,19Z" fill="#ff7163" /></g></svg>
    ,
    description: "Fully sponsored international & domestic travel for you and your family, because the ones who shape the world deserve to experience it.",
    summary: "Fully sponsored international & domestic travel for you and your family, because the ones who shape the world deserve to experience it."
  },
  {
    Id: 2525,
    type: "TIER#7",
    name: "Personal & Professional Growth Grant",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>temple</title><g><rect x={6} y={20} width={6} height={26} fill="#aeaeae" /><rect x={16} y={20} width={6} height={26} fill="#aeaeae" /><rect x={26} y={20} width={6} height={26} fill="#aeaeae" /><rect x={36} y={20} width={6} height={26} fill="#aeaeae" /><path d="M46.479,15.122l-22-12a1,1,0,0,0-.958,0l-22,12A1,1,0,0,0,1,16v6a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V16A1,1,0,0,0,46.479,15.122Z" fill="#e3e3e3" /><path d="M46,43H2a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V44A1,1,0,0,0,46,43Z" fill="#e3e3e3" /><circle cx={24} cy={14} r={4} fill="#949494" /><rect x={6} y={23} width={6} height={3} fill="#949494" /><rect x={16} y={23} width={6} height={3} fill="#949494" /><rect x={26} y={23} width={6} height={3} fill="#949494" /><rect x={36} y={23} width={6} height={3} fill="#949494" /></g></svg>
    ,
    description: "A fund that can be used for skill development, certification courses, or personal enrichment, ensuring your growth matches the impact you create.",
    summary: "A fund that can be used for skill development, certification courses, or personal enrichment, ensuring your growth matches the impact you create. This blessing is designed to empower you to reach new heights in your career and personal life. Whether it’s pursuing advanced certifications, attending leadership workshops, or exploring new skills, this grant ensures you have the resources to grow and thrive. It’s a testament to Pinnacle’s commitment to your continuous development, ensuring that your journey of learning and growth never stops."
  }
]

export var AllIncentive = [
  {
    name: "TIER#1",
    Id: "1",
    details: "The Seed of Change",
    sName: "Seed of Change",
    dsName: <>Seed<br />of Change</>,
    image: "https://images.pinnacleblooms.org/Assets/Incentives/Tier-1.jpg?v=1",
    e1: `🌱`,
    message: `🏡 <b>Pinnacle Family Blessings (5+ Qualifying Actions: New Referral Parent Admission,  Package Upagrdes, Renewals, or 2Needs Fulfilled) </b> <br/> <br/>

At <b>Pinnacle</b>, every step taken is a<b> gift of empowerment</b>, ensuring a child receives the care they truly need, a mother finds peace, and a family regains hope. Each effort extends far beyond a transaction—it becomes a <b>blessing that returns to you and your family in ways beyond measure.</b>  <br/> <br/> 

As a heartfelt gesture of gratitude, every team member who helps guide families toward <b>Pinnacle’s life-changing services</b> receives <b>Pinnacle Family Blessings—tokens of appreciation designed to enrich the well-being of your loved ones.</b> <br/> <br/>  

🌟 <b>Your Family’s Blessings Include:</b> <br/> <br/>
  
✅ <b>Swiggy /Zomato Family Delight Coupon</b> – Shared meals, shared happiness   <br/> <br/>

✅ <b>Rapido /Ola /Uber Comfort Pass</b> – Safe and seamless travel for your loved ones   <br/> <br/>

✅ <b>Amazon /Flipkart /Myntra Family Care Voucher </b>– Everything your home & heart needs   <br/> <br/>

✅ <b>Medplus/ Apollo/ 1Mg Health & Wellness Gift </b>– Prioritizing your family's health and well-being   <br/> <br/>

💡 <b>Value: in family-centered benefits,</b> gifted to you as a token of appreciation for your <b>role in changing lives.</b>  <br/> <br/> 

Each blessing you take home is a reminder: <b>Your work is not just a job—it is a mission. A movement. A legacy</b>.`,
    points: 5,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><title>savings</title><g><path d="M24,35a1,1,0,0,1-1-1,12.987,12.987,0,0,1,21.58-9.751,1,1,0,0,1,.089,1.411,1.068,1.068,0,0,1-.089.089,12.949,12.949,0,0,1-16.456.577A10.967,10.967,0,0,0,25,34,1,1,0,0,1,24,35Z" fill="#38a838"></path><path d="M24,35a1,1,0,0,1-1-1,10.968,10.968,0,0,0-3.124-7.672A12.949,12.949,0,0,1,3.42,25.751a1,1,0,0,1-.089-1.411,1.068,1.068,0,0,1,.089-.089A12.987,12.987,0,0,1,25,34,1,1,0,0,1,24,35Z" fill="#49c549"></path><circle cx="24" cy="11" r="11" fill="#ffd764"></circle><path d="M24,20a9,9,0,1,1,9-9A9,9,0,0,1,24,20Z" fill="#f7bf26"></path><path d="M24,18a7,7,0,1,1,7-7A7,7,0,0,1,24,18Z" fill="#ffd764"></path><path d="M24,15a1,1,0,0,1-.707-.293l-3-3a1,1,0,0,1,0-1.414l3-3a1,1,0,0,1,1.414,0l3,3a1,1,0,0,1,0,1.414l-3,3A1,1,0,0,1,24,15Z" fill="#f7bf26"></path><path d="M32,48H16a1,1,0,0,1-.986-.836l-2-12A1,1,0,0,1,14,34H34a1,1,0,0,1,.986,1.164l-2,12A1,1,0,0,1,32,48Z" fill="#a2703f"></path><polygon points="13.486 38 34.514 38 34.847 36 13.153 36 13.486 38" fill="#d0ab86"></polygon></g></svg>
    //icon: <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>grain-2</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" transform="translate(0.25 0.25)" strokeMiterlimit={10}><path d="M20,7h9c1.105,0,2,.895,2,2s-.895,2-2,2h-2" fill="none" stroke="#212121" strokeWidth="1.5" /><path d="M20,11h8c1.105,0,2,.895,2,2s-.895,2-2,2h-8" fill="none" stroke="#212121" strokeWidth="1.5" /><path d="M25,7h1c1.105,0,2-.895,2-2s-.895-2-2-2h-10" fill="none" stroke="#212121" strokeWidth="1.5" /><circle cx="13.5" cy="30.5" r="1.5" fill="#212121" data-stroke="none" stroke="none" /><circle cx="13.5" cy="13.5" r="1.5" fill="#212121" data-stroke="none" stroke="none" /><circle cx="8.5" cy="24.5" r="1.5" fill="#212121" data-stroke="none" stroke="none" /><circle cx="23.5" cy="30.5" r="1.5" fill="#212121" data-stroke="none" stroke="none" /><circle cx="18.5" cy="24.5" r="1.5" fill="#212121" data-stroke="none" stroke="none" /><path d="M5,10c2.761,0,5-2.239,5-5h2c2.209,0,4-1.791,4-4H6.759c-1.988,0-3.855,.626-5.397,1.685" fill="none" stroke="#212121" strokeWidth="1.5" strokeLinecap="butt" /><path d="M1,16.718c1.593,1.429,3.692,2.305,6,2.305l18.012-.031c1.102,0,1.996-.894,1.996-1.996s-.894-1.996-1.996-1.996h-1.012" fill="none" stroke="#212121" strokeWidth="1.5" strokeLinecap="butt" /></g></svg>
  },
  {
    name: "TIER#2",
    Id: "2",
    details: "The Nurturer’s Grace",
    sName: "Nurturer’s Grace",
    dsName: <>Nurturer’s<br />Grace</>,
    image: "https://images.pinnacleblooms.org/Assets/Incentives/Tier-2.jpg?v=1",
    e1: `🌿`,
    message: `🏡 <b>Pinnacle Family Nurturing (16+ Qualifying Actions: New Referral Parent Admission, Package Upgradations, Renewals, or 3 Needs Fulfilled)</b><br/><br/>

At <b>Pinnacle</b>, nurturing is not just a responsibility—it is a privilege. Every time you guide a family, help a child receive the therapy they truly need, or ensure a parent feels supported, you are shaping a future filled with hope. <br/><br/> 

Your dedication is what strengthens families, transforms lives, and brings comfort to those who once felt lost. It is <b>a gift that keeps giving</b>, and just as you nurture others, <b>Pinnacle nurtures you and your family in return</b>.<br/><br/>  

🌟 <b>Your Family’s Blessings Include</b>: <br/><br/> 

✅ <b>Premium Health Check-up for You & One Family Member</b> 
       – Because those who care for others should never neglect their own well-being. <br/><br/> 

✅ <b>Family Wellness & Fitness Subscription</b> <br/>
       – A gym, yoga, or wellness program membership to encourage a healthier, happier you, your family.<br/><br/>

✅ <b>Exclusive Family Leisure & Experience Pass</b> <br/>
      – A curated movie, amusement park, or family dining experience to create cherished memories together.<br/><br/>

✅ <b>One Extra Paid Leave </b><br/>
     – Because time spent with family is the greatest reward of all.<br/><br/> 

💡<b> Value: in blessings, celebrating your role as a Nurturer of families and futures</b>.  <br/><br/>

Each moment you spend uplifting others is a reminder: <b>Your work is not just a job—it is a mission. A movement. A legacy</b>. 💙
`,
    points: 16,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>clover</title><g><path d="M24,24.5C16.943,17.443,13,10,13,6a3.663,3.663,0,0,1,4-4,11.043,11.043,0,0,1,7,3,11.043,11.043,0,0,1,7-3,3.663,3.663,0,0,1,4,4C35,10,31.057,17.443,24,24.5Z" fill="#49c549" /><path d="M35,6a3.663,3.663,0,0,0-4-4,11.043,11.043,0,0,0-7,3V24.5C31.057,17.443,35,10,35,6Z" fill="#38a838" /><path d="M23.5,24C30.557,16.943,38,13,42,13a3.663,3.663,0,0,1,4,4,11.043,11.043,0,0,1-3,7,11.043,11.043,0,0,1,3,7,3.663,3.663,0,0,1-4,4C38,35,30.557,31.057,23.5,24Z" fill="#49c549" /><path d="M42,35a3.663,3.663,0,0,0,4-4,11.043,11.043,0,0,0-3-7H23.5C30.557,31.057,38,35,42,35Z" fill="#38a838" /><path d="M24,23.5C31.057,30.557,35,38,35,42a3.663,3.663,0,0,1-4,4,11.043,11.043,0,0,1-7-3,11.043,11.043,0,0,1-7,3,3.663,3.663,0,0,1-4-4C13,38,16.943,30.557,24,23.5Z" fill="#49c549" /><path d="M13,42a3.663,3.663,0,0,0,4,4,11.043,11.043,0,0,0,7-3V23.5C16.943,30.557,13,38,13,42Z" fill="#38a838" /><path d="M24.5,24C17.443,31.057,10,35,6,35a3.663,3.663,0,0,1-4-4,11.043,11.043,0,0,1,3-7,11.043,11.043,0,0,1-3-7,3.663,3.663,0,0,1,4-4C10,13,17.443,16.943,24.5,24Z" fill="#49c549" /><path d="M6,13a3.663,3.663,0,0,0-4,4,11.043,11.043,0,0,0,3,7H24.5C17.443,16.943,10,13,6,13Z" fill="#38a838" /><rect x={23} y={20} width={2} height={8} rx={1} fill="#78d478" /><rect x={23} y={20} width={2} height={8} rx={1} transform="translate(48 0) rotate(90)" fill="#78d478" /></g></svg>

    // icon:<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><title>watering-plants</title><g fill="#212121" stroke-linecap="square" stroke-linejoin="miter" transform="translate(0.25 0.25)" stroke-miterlimit="10"><path d="M25,8c0,1.657-1.343,3-3,3s-3-1.343-3-3c0-3,3-6,3-6,0,0,3,3,3,6Z" fill="none" stroke="#212121" stroke-width="1.5"></path><path d="M10,8c1.105,0,2-.895,2-2,0-1.524-2-3.333-2-3.333,0,0-2,1.81-2,3.333,0,1.105,.895,2,2,2Z" fill="none" stroke="#212121" stroke-width="1.5"></path><line x1="14" y1="31" x2="14" y2="26.857" fill="none" stroke="#212121" stroke-width="1.5"></line><path d="M21,20.766c-3.009,1.184-5.486,3.412-7,6.234" fill="none" stroke="#212121" stroke-width="1.5" stroke-linecap="butt"></path><path d="M18,26.95c5.606-.506,10-5.212,10-10.95h-6c-4.418,0-8,3.582-8,8" fill="none" stroke="#212121" stroke-width="1.5"></path><path d="M14,31v-11c0-3.866-3.134-7-7-7H3c0,4.079,3.055,7.438,7,7.931" fill="none" stroke="#212121" stroke-width="1.5"></path></g></svg>

  },
  {
    name: "TIER#3",
    Id: "3",
    details: "The Guardian’s Promise",
    sName: "Guardian’s Promise",
    dsName: <>Guardian’s<br />Promise</>,
    image: "https://images.pinnacleblooms.org/Assets/Incentives/Tier-3.jpg?v=1",
    e1: `🌳`,
    message: `🏡 <b>Pinnacle Family Security (30+ Qualifying Actions: New Referral Parent Admissions, Package Upgradations, Renewals, or 4 Needs Fulfilled)</b></br> </br>

At <b>Pinnacle</b> , you are more than an employee—you are a <b>guardian of childhood, a protector of progress, and a champion of family well-being</b> . Every time you ensure a child receives the full care they need, you are securing their future while <b>bringing peace of mind to their parents</b></br></br> .  

And just as you safeguard the well-being of others, <b>Pinnacle honors your dedication by ensuring your own family's security and growth</b>.</br></br>  

🌟 <b>Your Family’s Blessings Include</b>: </br></br> 

✅ <b>₹25L Accidental Life Insurance </b>– Providing long-term financial security for your family, just as you provide stability to others.</br></br>  


✅ <b>Post Office Savings Bond</b></br> 
       – A government-backed savings plan, ensuring financial stability for your family.</br></br>


✅ <b>Two Extra Paid Leaves </b></br>
     – Because time spent with family is the greatest reward of all.</br></br>
  

✅ <b>Personal & Professional Growth Grant</b> </br>
      – A fund that can be used for skill development, certification courses, or personal enrichment, ensuring your growth matches the impact you create.</br></br>  

✅ <b>Mental Wellness & Counseling Support</b> </br>
      – Access to therapy, stress management sessions, or mindfulness programs for employees and their families.</br></br>


💡 <b>Value: in blessings, honoring you as a Guardian of families, futures, and well-being</b>.</br></br>  

Each moment you spend uplifting others is a reminder: <b>Your work is not just a job—it is a mission. A movement. A legacy.</b> 💙</br></br>

Because at Pinnacle, <b>when you uplift families, empower families, you uplift generations - you uplift your own.</b> 💙`,
    points: 30,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><title>lotus-flower</title><g><path d="M13.816,43.991c-.5,0-.993-.022-1.49-.07h0A16.018,16.018,0,0,1,.979,37.491a1,1,0,0,1,.126-1.33,15.953,15.953,0,0,1,23.7,2.244,1,1,0,0,1-.125,1.329A16.042,16.042,0,0,1,13.816,43.991Z" fill="#d53987"></path><path d="M23,34A22,22,0,0,0,3.7,12.183a.992.992,0,0,0-1.1.762A21.93,21.93,0,0,0,23.382,39.984L24,40A15.748,15.748,0,0,1,23,34Z" fill="#ea5da3"></path><path d="M23.321,39.734a1,1,0,0,1-.125-1.329,15.953,15.953,0,0,1,23.7-2.244,1,1,0,0,1,.126,1.33,16.018,16.018,0,0,1-11.347,6.43h0c-.5.048-.994.07-1.49.07A16.042,16.042,0,0,1,23.321,39.734Z" fill="#d53987"></path><path d="M25,34A22,22,0,0,1,44.3,12.183a.992.992,0,0,1,1.1.762A21.93,21.93,0,0,1,24.618,39.984L24,40A15.748,15.748,0,0,0,25,34Z" fill="#ea5da3"></path><ellipse cx="24" cy="29.999" rx="3.742" ry="9.577" fill="#475bea"></ellipse><path d="M24,39.884a1,1,0,0,1-.667-.255,24.99,24.99,0,0,1,0-37.258,1,1,0,0,1,1.334,0,24.99,24.99,0,0,1,0,37.258A1,1,0,0,1,24,39.884Z" fill="#f888c0"></path><path d="M24,40a1,1,0,0,1-.668-.256,14.4,14.4,0,0,1,0-21.488,1,1,0,0,1,1.336,0,14.4,14.4,0,0,1,0,21.488A1,1,0,0,1,24,40Z" fill="#fbb7d9"></path></g></svg>
    // icon: <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>tree-2</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" transform="translate(0.25 0.25)" strokeMiterlimit={10}> <path d="M13 30.0001L13.5 24.5001L13.4381 25.181" stroke="#212121" strokeWidth="1.5" fill="none" /> <path d="M19 30.0001L18.4352 24.1413L18.492 24.766" stroke="#212121" strokeWidth="1.5" fill="none" /> <path d="M3 17.2353C3 21.5236 6.49218 25 10.8 25C13.0329 25 15.0467 24.066 16.4686 22.569C17.7792 24.059 19.7042 25 21.85 25C25.7988 25 29 21.8133 29 17.8824C29 14.1242 26.0741 11.0463 22.3662 10.783C22.4539 10.3592 22.5 9.92024 22.5 9.47059C22.5 5.89698 19.5898 3 16 3C12.4101 3 9.5 5.89698 9.5 9.47059C9.5 9.50639 9.50029 9.54213 9.50087 9.5778C5.81142 10.1935 3 13.3876 3 17.2353Z" stroke="#212121" strokeWidth="1.5" fill="none" strokeLinecap="butt" /> <path d="M9.49999 19.0001C10.1667 17.0001 11.3333 16.5 12.5013 16.5C12.5013 14.1242 15.1667 11.3334 18.5 14.0001" stroke="#212121" strokeWidth="1.5" fill="none" strokeLinecap="butt" /> </g></svg>

  },
  {
    name: "TIER#4",
    Id: "4",
    sName: "Lightbearer’s Reward",
    dsName: <>Lightbearer’s<br />Reward</>,
    details: "The Lightbearer’s Reward",
    image: "https://images.pinnacleblooms.org/Assets/Incentives/Tier-4.jpg?v=1",
    e1: `✨`,
    message: `🏡 <b>Pinnacle Family Prosperity (50+ Qualifying Actions: New Referral Parent Admissions, Package Upgradations, Renewals, or 5 Needs Fulfilled)</b><br/><br/>  

At  <b>Pinnacle</b>, you are not just helping children—you are transforming the course of entire families</b>. You stand as a  <b>beacon of hope</b>, ensuring that no child is left behind, no parent is left helpless, and no family walks alone.<br/><br/>  

For the dedication you bring to  <b>uplifting lives</b>, Pinnacle ensures that  <b>your own family’s growth, security, and well-being are taken care of. </b> <br/><br/>

🌟  <b>Your Family’s Exclusive Blessings Include</b>:<br/><br/>  

✅  <b>Your Child Education Scholarship</b><br/>  
       – A direct contribution toward your child's schooling or higher education, ensuring their dreams have a strong foundation—just as you build for so many others.<br/><br/>  


✅  <b>₹50L Accidental Life Insurance</b><br/> 
       – Providing long-term financial security for your family, just as you provide stability to others. <br/><br/> 

✅  <b>Home Makeover Support</b> <br/>
       – A contribution towards home improvements, appliances, or furniture, making your home as comfortable as the lives you help improve.<br/><br/>  

✅  <b>Family Leisure & Experience Pass</b><br/>  
       – Fully sponsored family outings, amusement park visits, or exclusive leisure experiences to create cherished memories.<br/><br/>  

✅  <b>Golden Years Parental Support</b><br/>  
       – A wellness package for your parents, including <b>comprehensive health check-ups and lifestyle support</b>, ensuring their well-being.<br/><br/>  

✅  <b>3 Days of Paid Leave</b><br/>  
      – Extra time off to <b>spend quality moments with your family</b>, recharge, and embrace life’s special occasions.<br/><br/>  

💡  <b>Value: A lasting impact on your family’s education, security, and happiness—honoring you as a Lightbearer of transformation and prosperity</b>.<br/><br/>  

Because at Pinnacle,  <b>when you uplift families, you don’t just build lives—you build legacies</b>. 💙
`,
    points: 50,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>fruit-crate</title><g> <path d="M18 29.011C10.953 29.011 5 23.286 5 16.511C5 12.798 6.248 9.88803 8.513 8.31903C10.155 7.18103 13.122 6.21203 18 7.94703C22.879 6.21403 25.846 7.18103 27.487 8.31903C29.752 9.88803 31 12.798 31 16.511C31 23.286 25.047 29.011 18 29.011Z" fill="url(#nc-fruit-crate-0_linear_307_23)" /> <path d="M18 9C17.447 9 17 8.553 17 8V6C17 3.243 19.243 1 22 1C22.553 1 23 1.447 23 2C23 2.553 22.553 3 22 3C20.346 3 19 4.346 19 6V8C19 8.553 18.553 9 18 9Z" fill="url(#nc-fruit-crate-1_linear_307_23)" /> <path d="M21.083 42.7239C20.689 42.7239 20.327 42.6339 20 42.4459C15.205 39.6769 25.058 19.6849 30.938 9.50094C32.868 6.15694 37.158 5.00994 40.5 6.93894C43.842 8.86894 44.991 13.1589 43.062 16.5009C37.583 25.9899 26.454 42.7239 21.083 42.7239Z" fill="url(#nc-fruit-crate-2_linear_307_23)" /> <path d="M45.091 5.47298C44.397 5.36398 43.523 5.38398 42.631 5.53498C42.408 5.57198 42.19 5.61598 41.977 5.66698C41.991 5.44598 42 5.22298 42 5.00098C42 3.06698 41.475 1.00098 40 1.00098C38.525 1.00098 38 3.06698 38 5.00098C38 6.58498 38.363 8.23898 39.301 8.79198C39.551 9.10598 40.001 9.41098 40.827 9.54198C41.118 9.58798 41.441 9.60998 41.784 9.60998C42.258 9.60998 42.769 9.56698 43.288 9.47998C45.195 9.16198 47.146 8.30398 46.904 6.84998C46.835 6.43098 46.507 5.69698 45.091 5.47298Z" fill="url(#nc-fruit-crate-3_linear_307_23)" /> <path d="M44 47H4C2.343 47 1 45.657 1 44V25C1 23.343 2.343 22 4 22H44C45.657 22 47 23.343 47 25V44C47 45.657 45.657 47 44 47Z" fill="url(#nc-fruit-crate-4_linear_307_23)" /> <path d="M47 29H1V31H47V29Z" fill="url(#nc-fruit-crate-5_linear_307_23)" /> <path d="M47 38H1V40H47V38Z" fill="url(#nc-fruit-crate-6_linear_307_23)" /> <path d="M7.5 27C8.328 27 9 26.328 9 25.5C9 24.672 8.328 24 7.5 24C6.672 24 6 24.672 6 25.5C6 26.328 6.672 27 7.5 27Z" fill="url(#nc-fruit-crate-7_linear_307_23)" /> <path d="M40.5 27C41.328 27 42 26.328 42 25.5C42 24.672 41.328 24 40.5 24C39.672 24 39 24.672 39 25.5C39 26.328 39.672 27 40.5 27Z" fill="url(#nc-fruit-crate-8_linear_307_23)" /> <path d="M40.5 36C41.328 36 42 35.328 42 34.5C42 33.672 41.328 33 40.5 33C39.672 33 39 33.672 39 34.5C39 35.328 39.672 36 40.5 36Z" fill="url(#nc-fruit-crate-9_linear_307_23)" /> <path d="M7.5 45C8.328 45 9 44.328 9 43.5C9 42.672 8.328 42 7.5 42C6.672 42 6 42.672 6 43.5C6 44.328 6.672 45 7.5 45Z" fill="url(#nc-fruit-crate-10_linear_307_23)" /> <path d="M7.5 36C8.328 36 9 35.328 9 34.5C9 33.672 8.328 33 7.5 33C6.672 33 6 33.672 6 34.5C6 35.328 6.672 36 7.5 36Z" fill="url(#nc-fruit-crate-11_linear_307_23)" /> <path d="M40.5 45C41.328 45 42 44.328 42 43.5C42 42.672 41.328 42 40.5 42C39.672 42 39 42.672 39 43.5C39 44.328 39.672 45 40.5 45Z" fill="url(#nc-fruit-crate-12_linear_307_23)" /> <defs> <linearGradient id="nc-fruit-crate-0_linear_307_23" x1={18} y1="7.00049" x2={18} y2="29.011" gradientUnits="userSpaceOnUse"> <stop stopColor="#FFD36E" /> <stop offset={1} stopColor="#F6B828" /> </linearGradient> <linearGradient id="nc-fruit-crate-1_linear_307_23" x1={20} y1={1} x2={20} y2={9} gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-2_linear_307_23" x1="31.3614" y1="6.00256" x2="31.3614" y2="42.7239" gradientUnits="userSpaceOnUse"> <stop stopColor="#F98E5E" /> <stop offset={1} stopColor="#EA6524" /> </linearGradient> <linearGradient id="nc-fruit-crate-3_linear_307_23" x1="42.462" y1="1.00098" x2="42.462" y2="9.60998" gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-fruit-crate-4_linear_307_23" x1={24} y1={22} x2={24} y2={47} gradientUnits="userSpaceOnUse"> <stop stopColor="#B88163" /> <stop offset={1} stopColor="#976545" /> </linearGradient> <linearGradient id="nc-fruit-crate-5_linear_307_23" x1={1} y1={30} x2={47} y2={30} gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-6_linear_307_23" x1={1} y1={39} x2={47} y2={39} gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-7_linear_307_23" x1="7.5" y1={24} x2="7.5" y2="44.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-8_linear_307_23" x1="40.5" y1={24} x2="40.5" y2="44.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-9_linear_307_23" x1="40.5" y1={25} x2="40.5" y2="43.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-10_linear_307_23" x1="7.5" y1="25.5" x2="7.5" y2={45} gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-11_linear_307_23" x1="7.5" y1={25} x2="7.5" y2="43.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> <linearGradient id="nc-fruit-crate-12_linear_307_23" x1="40.5" y1="25.5" x2="40.5" y2={45} gradientUnits="userSpaceOnUse"> <stop stopColor="#976545" /> <stop offset={1} stopColor="#674832" /> </linearGradient> </defs> </g></svg>

    // icon: <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>bolt-speed</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" transform="translate(0.25 0.25)" strokeMiterlimit={10}> <path d="M19.4 3L5 18.8235H15.4L14.6 29L29 13.1765H18.6L19.4 3Z" stroke="#212121" strokeWidth="1.5" fill="none" /> <path d="M4 6H11" stroke="#212121" strokeWidth="1.5" fill="none" /> <path d="M5 26H10" stroke="#212121" strokeWidth="1.5" fill="none" /> <path d="M1 11H5" stroke="#212121" strokeWidth="1.5" fill="none" /> </g></svg>    
  },
  {
    name: "TIER#5",
    Id: "5",
    sName: "Legacy Builder’s Gift",
    dsName: <>Legacy<br />Builder’s Gift</>,
    details: "The Legacy Builder’s Gift",
    image: "https://images.pinnacleblooms.org/Assets/Incentives/Tier-5.jpg?v=1",
    e1: `🌍`,
    message: `🏡 <b>Pinnacle Family Legacy (75+ Qualifying Actions: New Referral Parent Admissions, Package Upgradations, Renewals, or 9 Needs Fulfilled)</b><br/><br/>    

At <b>Pinnacle</b>, your work is more than just a role—it is <b>a mission, a movement, and a legacy in the making</b>.<br/>  <br/>    

You are not just ensuring a child’s well-being; you are <b>laying the foundation for generations to thrive</b>. Every <b>conversation with a parent, every extra effort to fulfill a child’s needs, every renewal, every referral— they are not just numbers. They are lives changed, futures reshaped, and hopes reignited</b>. <br/>  <br/>   

Pinnacle sees you, values you, and <b>uplifts your family with the same care, security, and love that you bring into the lives of others</b>.<br/>  <br/>    

🌟 <b>Your Family’s Ultimate Blessings Include:</b><br/>  <br/>    

✅ <b>₹5L Corporate Health Insurance with 12,000+ Hospitals Across India</b><br/>    
       – <b>For You, Your Parents, Your Wife/Husband, Your Little Boy, Your Cute Girl—Your Whole Family.</b> Because your loved ones deserve the very best healthcare, always.<br/>  <br/>    

✅ <b>₹75L Accidental Life Insurance </b><br/>   
      – Because the people who protect others must be protected themselves. Your family’s future is secured, just as you secure the future of others.<br/>  <br/>    

✅ <b>4 Paid Holidays</b><br/>    
       – A well-earned break, so you can <b>step away, recharge, and return even stronger for your family, your dreams, and your purpose.</b><br/>  <br/>    

✅ <b>Festival & Life Celebration Bonus</b><br/>    
       – Extra financial support during festivals and your family's milestones—because life’s special moments should always be celebrated.<br/>  <br/>    

✅ <b>Exclusive Child Talent & Education Fund</b><br/>    
      – Because every child has a gift waiting to be nurtured. This fund supports <b>tuition, sports, music, arts, or any field where your child shines</b>.<br/>  <br/>    

✅ <b>Home Makeover Support</b> <br/>   
      – A contribution towards home improvements, appliances, or furniture, making your home as comfortable as the lives you help improve.<br/>  <br/>    

✅ <b>Family Leisure & Experience Pass</b><br/>   
       – Fully sponsored family outings, amusement park visits, or exclusive leisure experiences to create cherished memories.<br/>  <br/>    

✅ <b>Golden Years Parental Support</b> <br/>   
      – A wellness package for your parents, including comprehensive health check-ups and lifestyle support, ensuring their well-being. <br/>  <br/>   

💡 <b>Value: A legacy of security, prosperity, and well-being—honoring you as a Builder of Futures, a Champion of Change, and a Light for Generations</b>.<br/>  <br/>    

Because at Pinnacle, <b>when you nurture a child, you nurture the future. When you uplift families, you uplift the world.</b> 💙`,
    points: 75,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>macro</title><g><path fill="#4DA34D" d="M24,46c-0.55273,0-1-0.44775-1-1V23c0-0.55225,0.44727-1,1-1s1,0.44775,1,1v22 C25,45.55225,24.55273,46,24,46z" /> <path fill="#E86C60" d="M24,23.00054c-7.16797,0-13-5.83154-13-13v-8c0-0.36865,0.20312-0.70752,0.52832-0.88184 c0.32422-0.17432,0.71973-0.15576,1.02637,0.0498L18,4.79888l5.44531-3.63037c0.33594-0.22363,0.77344-0.22363,1.10938,0L30,4.79888 l5.44531-3.63037c0.30664-0.20361,0.70215-0.22412,1.02637-0.0498C36.79688,1.29302,37,1.63189,37,2.00054v8 C37,17.169,31.16797,23.00054,24,23.00054z" /> <path fill="#72C472" d="M7,30c0,9.38885,7.61115,17,17,17C24,37.61115,16.38885,30,7,30z" /> <path fill="#72C472" d="M41,30c0,9.38885-7.61115,17-17,17C24,37.61115,31.61115,30,41,30z" /></g></svg>
    //  icon:<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>handshake</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" transform="translate(0.25 0.25)"> <path d="M5 7V21" stroke="#212121" strokeWidth="1.5" fill="none" strokeLinecap="butt" /> <path d="M10 7.00003L1 7.00003L1 21.0545H5L13.1926 28.3832C14.1846 29.2706 15.712 29.1693 16.5782 28.1588V28.1588C17.3818 27.2212 17.3326 25.8241 16.4649 24.9455L15 23.462L18.1807 26.3488C19.177 27.2531 20.7233 27.1562 21.5989 26.1346V26.1346C22.3951 25.2058 22.3606 23.8254 21.5189 22.9375L19.5 20.8076L22.7354 23.844C23.7189 24.767 25.2575 24.7426 26.2112 23.7888V23.7888C27.1955 22.8046 27.1854 21.2057 26.1888 20.2339L18.5 12.7366L18.7702 13" stroke="#212121" strokeWidth="1.5" fill="none" /> <path d="M20 11.5001L13.6415 16.2689C12.6996 16.9753 11.3816 16.8817 10.5491 16.0492V16.0492C9.67499 15.175 9.62124 13.7753 10.4258 12.8367L15.8493 6.50913C17.1536 4.98755 19.2403 4.39169 21.1513 4.99517L27.5 7.00003H31V21" stroke="#212121" strokeWidth="1.5" fill="none" /> <path d="M27 7V15" stroke="#212121" strokeWidth="1.5" fill="none" /> </g></svg>
  },
  {
    name: "TIER#6",
    Id: "6",
    details: "The Pinnacle Torchbearer",

    sName: "Pinnacle Torchbearer",
    dsName: <>Pinnacle<br />Torchbearer</>,
    image: "https://images.pinnacleblooms.org/Assets/Incentives/Tier-6.jpg?v=1",
    e1: `💎`,
    message: `🏡 <b>Pinnacle Family Excellence (100+ Qualifying Actions: New Referral Parent Admissions, Package Upgradations, Renewals, or 12 Needs Fulfilled)</b> <br/><br/> 

At <b>Pinnacle,</b> your work has gone beyond impact—it has become a <b>guiding force for change.</b><br/><br/>  

You have not only helped children receive the care they need—you have <b>helped shape a future where excellence in child development, empowerment, and family well-being is the standard.</b> <br/><br/> 

You are <b>a torchbearer of Pinnacle’s mission</b>, lighting the way for others, setting new benchmarks of excellence, and ensuring that the legacy of your work is felt across generations.<br/><br/>  

🌟 <b>Your Ultimate Family & Career Rewards Include:</b> <br/><br/> 

✅ <b>₹1 Cr Accidental Life Insurance</b><br/>  
     – Because the ones who uplift others must always be protected at the highest level.<br/><br/>  

✅ <b>₹5L Corporate Health Insurance with 12,000+ Hospitals Across India </b> <br/>
     – Covering <b>you, your parents, your wife/husband, your little boy, your cute girl—your entire family</b> with the best healthcare.<br/><br/>  

✅ <b>Salary Bonus - Take Home Blessed Savings Direct<br/>  
     – A well-earned financial appreciation for your extraordinary contributions to Pinnacle’s mission.</b>  <br/><br/>

✅ <b>6 Fully Paid Holidays</b><br/>  
     – A well-deserved retreat to <b>recharge, reconnect with your loved ones, and celebrate the impact you have made.</b> <br/><br/> 

✅ <b>Festival & Life Celebration Bonus</b> <br/> 
     – Extra financial support to <b>celebrate life’s special moments, ensuring joy for you and your loved ones.</b>  <br/><br/>

✅ <b>Exclusive Child Talent & Education Fund</b><br/>   
     – A direct investment in <b>your child’s education, skills, and passion</b> , ensuring their success just as you ensure success for so many children.  <br/><br/>

✅ <b>Golden Years Parental Support</b><br/>  
      – A <b>premium wellness package for your parents</b>, covering <b>annual health check-ups, lifestyle support, and exclusive eldercare benefits</b>. <br/><br/> 

✅ <b>Home Makeover & Comfort Allowance </b> <br/>
      – A significant contribution towards <b>home improvements, appliances, or furniture</b>, making your home a place of comfort and warmth, just like the lives you uplift.<br/><br/>  

✅ <b>Family Leisure & India Travel Experience</b>  <br/>
      – Fully sponsored <b>domestic travel</b> for you and your family, because those who change the world also deserve to explore it.<br/><br/>  

💡 <b>Value: A complete legacy of financial security, well-being, and global experiences—honoring you as a true Torchbearer of Pinnacle’s Future</b>.<br/><br/>  

Because at Pinnacle, <b>you don’t just change lives—you illuminate the path for generations to come.</b> 💙<br/><br/>  

---

<b>With Tier #6, we prepare to enter the final stage of the Pinnacle Family Incentives Program—where true Visionaries receive not just rewards, but a permanent mark of recognition and elevation in their professional journey.</b>`,
    points: 100,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>ecology</title><g><circle cx={24} cy={24} r={23} fill="#cbeafb" /><path d="M1,24A22.94,22.94,0,0,0,8.768,41.227L10.8,38.18s1.452-.419,1.765-.981c.98-1.764-.76-4.835-.76-4.835a9.974,9.974,0,0,0-.35-2.176c-.262-.653-2.091-1.548-2.091-1.548S7.6,25.765,7.6,24a2.63,2.63,0,0,1,2.483-2.743,4.288,4.288,0,0,0,2.81-2.026s2.222-.589,2.744-1.5-.587-4.175-.587-4.175a5.46,5.46,0,0,0-.022-2.62,4.955,4.955,0,0,0-1.646-1.981,10.868,10.868,0,0,0-2.56-3.8A22.967,22.967,0,0,0,1,24Z" fill="#78d478" /><path d="M24,1c-.62,0-1.232.032-1.839.08-.2.619-1.231,2.208-.971,2.925s2.395,1.384,2.395,1.384S23.019,7.6,24,8.383s2.549-.261,3.136-.065.457,4.05.457,4.05,1.895,2.091,3.758,2.353,4.7-2.9,4.7-2.9a37.386,37.386,0,0,0,6.1-1.95A22.954,22.954,0,0,0,24,1Z" fill="#78d478" /><path d="M38.858,25.5c.523,1.242-.982,4.412-2.222,5.031a8.421,8.421,0,0,0-3.22,2.568c-.458.719-1.059,3.684-2.561,4.272s-5.065,3.942-6.96,3.419S22,35.761,23.307,33.735c.78-1.209-.131-3.855-.2-4.769S20.3,26.352,20.3,25.438c0-1.438,3.136-5.228,3.136-5.228s2.57-.849,3.354-.653a11.848,11.848,0,0,1,2.266,1.11,15.713,15.713,0,0,1,4.051.849l1.5,1.372S38.335,24.261,38.858,25.5Z" fill="#78d478" /><path d="M47.316,19.023a1.007,1.007,0,0,0-1.117.35A13.885,13.885,0,0,1,35,25a8.992,8.992,0,0,0-4.521,16.769A5.8,5.8,0,0,1,25,45a1,1,0,0,0,0,2c3.919,0,5.86-2,7.315-4.41A8.971,8.971,0,0,0,35,43,13.015,13.015,0,0,0,48,30V19.973A1,1,0,0,0,47.316,19.023Z" fill="#38a838" /><path d="M40.313,28.337c-6.251,2.23-8.6,6.805-10.318,10.146-.415.807-.771,1.494-1.118,2.077a8.967,8.967,0,0,0,1.6,1.209v0h0c.438-.709.85-1.509,1.294-2.374,1.652-3.212,3.706-7.21,9.211-9.176a1,1,0,1,0-.672-1.883Z" fill="#9ee09e" /></g></svg>

    //icon :  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>olympic-flame</title><g fill="#212121" strokeLinecap="square" strokeLinejoin="miter" transform="translate(0.25 0.25)" strokeMiterlimit={10}><path d="M20,31V28l8.515-2.129A1.959,1.959,0,0,0,30,23.969V22H2v1.969a1.959,1.959,0,0,0,1.485,1.9L12,28v3" fill="none" stroke="#212121" strokeWidth="1.5" /> <path d="M15.333,2.025A9.064,9.064,0,0,1,13.6,6C12.566,7.346,10,8.686,10,12a6,6,0,0,0,3.053,5.223,3.251,3.251,0,0,1,1.329-2.4A4.207,4.207,0,0,0,16,12.809a6,6,0,0,1,2.947,4.414A5.993,5.993,0,0,0,22,12C22,10.322,21.7,5.752,15.333,2.025Z" fill="none" stroke="#212121" strokeWidth="1.5" /></g></svg>
  },
  {
    name: "TIER#7",
    Id: "7",
    sName: "Pinnacle Visionary",
    dsName: <>Pinnacle<br />Visionary</>,
    details: "The Pinnacle Visionary",
    image: "https://images.pinnacleblooms.org/Assets/Incentives/Tier-7.jpg?v=1",
    e1: `🚀`,
    message: `🏡 <b>Pinnacle Family Elevation (150+ Qualifying Actions: New Referral Parent Admissions, Package Upgradations, Renewals, or 15 Needs Fulfilled)</b><br/>  <br/>

You have <b>not just contributed—you have transformed.</b>  
You have <b>not just supported families—you have uplifted humanity.</b>  
You have <b>not just worked—you have created a lasting legacy</b>.<br/><br/>  

At <b>Pinnacle</b>, your journey is no longer just about service—it is about <b>defining the future of child development, family empowerment, and societal well-being.</b><br/><br/>  

For this <b>unmatched dedication</b>, Pinnacle ensures that <b>your career, your family, and your future are permanently uplifted, setting you apart as a true Visionary</b>.<br/><br/>  

---

🌟 <b>Your Ultimate Pinnacle Visionary Rewards Include</b>:<br/><br/>  

✅ <b>Permanent Salary Increment (Above & Beyond Annual Appraisal)</b> <br/> 
      – <b>Your salary is permanently increased</b>, recognizing your relentless dedication, ensuring your financial upliftment is as lasting as your impact.<br/><br/>  

✅ <b>₹1.5 Cr Accidental Life Insurance</b> <br/> 
      – Because those who bring security to others must be protected at the highest level.<br/><br/>  

✅ <b>₹10L Corporate Health Insurance with 12,000+ Hospitals Across India</b><br/>  
    – Covering <b>you, your parents, your wife/husband, your little boy, your cute girl—your entire family</b> with world-class healthcare.  <br/><br/>

✅ <b>Double Salary Bonus - Take Home Blessed Savings Direct</b><br/>  
      – A financial <b>appreciation for your extraordinary commitment to Pinnacle’s mission.</b> <br/><br/> 

✅ <b>7 Fully Paid Holidays</b><br/>  
      – A well-earned break to <b>step away, refresh, and celebrate the impact you have created.</b> <br/><br/> 

✅ <b>Exclusive Global Leadership Recognition  </b><br/>
      – You are now part of <b>Pinnacle’s Inner Circle of Visionaries,</b> where your work is celebrated as a benchmark for excellence.  <br/><br/>

✅ <b>Festival & Life Celebration Bonus</b> <br/> 
      – Extra financial support for <b>celebrating life’s biggest moments with your loved ones.</b>  <br/><br/>

✅ <b>Exclusive Child Talent & Education Fund</b><br/>  
      – A direct investment in <b>your child’s education, skills, and passions</b>, ensuring their dreams have no limits. <br/><br/> 

✅ <b>Golden Years Parental Support</b><br/>  
      – A <b>premium wellness package for your parents</b>, covering <b>annual health check-ups, lifestyle support, and exclusive eldercare benefits</b>. <br/><br/> 

✅  <b>Home Ownership & Family Prosperity Grant </b> <br/>
     – A substantial contribution towards <b>your homeownership journey, renovations, or property investments</b>, ensuring generational security.  <br/><br/>

✅ <b>Family Leisure & Global Travel Experience</b><br/>  
      – <b>Fully sponsored international & domestic travel</b> for you and your family, because the ones who shape the world deserve to experience it.  <br/><br/>

✅ <b>Personal & Professional Growth Grant</b> <br/>
      – A fund that can be used for skill development, certification courses, or personal enrichment, ensuring your growth matches the impact you create. <br/><br/> 

💡 <b>Value: A lifetime of financial security, career elevation, and global experiences—honoring you as a true Pinnacle Visionary.</b><br/><br/>  

---

🚀 <b>Because at Pinnacle, your legacy is not just in what you do—it is in the lives you touch, the futures you secure, and the world you transform. 💙 </b> <br/><br/>

With <b>Tier #7, your career, your family, and your future are elevated permanently, marking your place as a leader, a visionary, and a bui<b>lder of generational impact.</b>`,
    points: 150,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48"><title>open-ai</title><g><path d="M24 27.569L13.391 21.444V11.886C13.391 8.35396 16.265 5.47996 19.797 5.47996C21.381 5.47996 22.883 6.08296 24.041 7.10796L27.187 5.29196C27.331 5.20896 27.48 5.14296 27.627 5.06696C25.669 2.82796 22.824 1.48096 19.797 1.48096C14.06 1.48096 9.39203 6.14896 9.39203 11.887V23.754L20 29.88L24 27.569Z" fill="url(#nc-open-ai-0_linear_314_2)" /> <path d="M20.909 25.785V13.534L29.187 8.75599C32.246 6.98999 36.171 8.04099 37.938 11.1C38.73 12.472 38.959 14.074 38.65 15.589L41.796 17.405C41.94 17.488 42.072 17.584 42.211 17.673C43.171 14.858 42.915 11.72 41.402 9.09899C38.533 4.12999 32.157 2.42199 27.187 5.29099L16.909 11.224V23.475L20.909 25.785Z" fill="url(#nc-open-ai-1_linear_314_2)" /> <path d="M20.909 22.2149L31.518 16.0889L39.795 20.8689C42.854 22.6349 43.906 26.5599 42.14 29.6189C41.348 30.9909 40.075 31.9899 38.608 32.4799V36.1119C38.608 36.2789 38.591 36.4409 38.583 36.6059C41.5 36.0299 44.091 34.2389 45.604 31.6189C48.473 26.6499 46.764 20.2739 41.795 17.4049L31.518 11.4709L20.908 17.5959L20.909 22.2149Z" fill="url(#nc-open-ai-2_linear_314_2)" /> <path d="M24 20.431L34.609 26.556V36.115C34.609 39.647 31.735 42.521 28.203 42.521C26.619 42.521 25.117 41.918 23.959 40.893L20.813 42.709C20.669 42.792 20.52 42.858 20.373 42.934C22.331 45.173 25.176 46.52 28.203 46.52C33.94 46.52 38.608 41.852 38.608 36.114V24.247L28 18.121L24 20.431Z" fill="url(#nc-open-ai-3_linear_314_2)" /> <path d="M27.091 22.215V34.465L18.813 39.243C15.754 41.009 11.829 39.958 10.062 36.899C9.27001 35.527 9.04101 33.925 9.35001 32.41L6.20401 30.594C6.06001 30.511 5.92801 30.415 5.78901 30.326C4.82901 33.141 5.08501 36.279 6.59801 38.9C9.46701 43.869 15.843 45.577 20.813 42.708L31.091 36.775V24.524L27.091 22.215Z" fill="url(#nc-open-ai-4_linear_314_2)" /> <path d="M27.091 25.785L16.482 31.911L8.20502 27.131C5.14602 25.365 4.09402 21.44 5.86002 18.381C6.65202 17.009 7.92502 16.01 9.39202 15.52V11.888C9.39202 11.721 9.40902 11.559 9.41702 11.394C6.50002 11.97 3.90902 13.761 2.39602 16.381C-0.472976 21.35 1.23602 27.726 6.20502 30.595L16.482 36.529L27.092 30.404L27.091 25.785Z" fill="url(#nc-open-ai-5_linear_314_2)" /> <defs> <linearGradient id="nc-open-ai-0_linear_314_2" x1="9.5" y1="23.5" x2={24} y2="27.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-open-ai-1_linear_314_2" x1={17} y1={11} x2={21} y2={26} gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-open-ai-2_linear_314_2" x1="31.5" y1="11.5" x2={21} y2={22} gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-open-ai-3_linear_314_2" x1="38.5" y1="24.5" x2="24.5" y2="20.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-open-ai-4_linear_314_2" x1="30.5" y1={37} x2="27.5" y2="22.5" gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> <linearGradient id="nc-open-ai-5_linear_314_2" x1="16.5" y1="36.5" x2="27.5" y2={26} gradientUnits="userSpaceOnUse"> <stop stopColor="#6AD084" /> <stop offset={1} stopColor="#3CB34B" /> </linearGradient> </defs></g></svg>

    //icon: <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32"><title>spaceship-3</title><g fill="#212121" strokeLinejoin="miter" strokeLinecap="butt"><path d="m13.299,9h-3.891c-.892,0-1.738.397-2.308,1.083l-5.1,6.139,6.31,1.51" fill="none" stroke="#212121" strokeMiterlimit={10} strokeWidth="1.5" /><path d="m23,18.701v3.891c0,.892-.397,1.738-1.083,2.308l-6.139,5.1-1.51-6.31" fill="none" stroke="#212121" strokeMiterlimit={10} strokeWidth="1.5" /><path d="m14.268,23.69c7.986-2.194,14.642-9.015,15.732-21.69-12.675,1.09-19.496,7.746-21.69,15.732l5.958,5.958Z" fill="none" stroke="#212121" strokeLinecap="square" strokeMiterlimit={10} strokeWidth="1.5" /><path d="m19,5c4.111,1.389,6.778,4.056,8,8" fill="none" stroke="#212121" strokeMiterlimit={10} strokeWidth="1.5" /><circle cx={19} cy={13} r={2} fill="#212121" stroke="#212121" strokeMiterlimit={10} strokeWidth="1.5" /><path d="m2,30s.707-4.95,2.121-6.364c1.172-1.172,3.071-1.172,4.243,0s1.172,3.071,0,4.243c-1.414,1.414-6.364,2.121-6.364,2.121Z" fill="none" stroke="#212121" strokeMiterlimit={10} strokeWidth="1.5" /></g></svg>
  }
]


export var TodlerQuestions = [
  {
    "Id": "1",
    "KeyWord": "Enjoy Being Swung",
    "Assessment": "M-CHAT-R",
    "Seq": "1",
    "Question": "Does your child enjoy being swung, bounced on your knee, etc.?",
    "OptionWeightage": "Dunns{^}No{#}0{#}N/A{#}Yes,Sometimes{#}1{#}N/A{#}Yes,Often{#}2{#}N/A{#}Yes{!}M-CHAT-R{^}Yes{#}0{#}Often{#}No,No{#}1{#}No-Sometimes{#}No",
    "AgeGroup": "16-30 months",
    "Domain": "Physical Play",
    "Participating": "2",
    "Assessments": "M-CHAT-R:1;DUNNS:18"
  },
  {
    "Id": "2",
    "KeyWord": "Interest In Other",
    "Assessment": "M-CHAT-R",
    "Seq": "2",
    "Question": "Does your child take an interest in other children?",
    "OptionWeightage": "ADOS-T{^}Always{#}0{#}N/A{#}Yes,Sometimes{#}1{#}N/A{#}Yes,Rarely{#}2{#}N/A{#}Yes{!}M-CHAT-R{^}Yes{#}0{#}Always{#}No,No{#}1{#}Rarely-Sometimes{#}No",
    "AgeGroup": "16-30 months",
    "Domain": "Social Interest",
    "Participating": "2",
    "Assessments": "M-CHAT-R:2;ADOS-T:22"
  },
  {
    "Id": "3",
    "KeyWord": "Climbing on Things",
    "Assessment": "M-CHAT-R",
    "Seq": "3",
    "Question": "Does your child like climbing on things, such as stairs?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Physical Play",
    "Participating": "1",
    "Assessments": "M-CHAT-R:3"
  },
  {
    "Id": "4",
    "KeyWord": "Finger Movements",
    "Assessment": "M-CHAT-R",
    "Seq": "4",
    "Question": "Does your child make unusual finger movements near their face?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Behavioral Observation",
    "Participating": "1",
    "Assessments": "M-CHAT-R:4"
  },
  {
    "Id": "5",
    "KeyWord": "Pointing, Request",
    "Assessment": "M-CHAT-R",
    "Seq": "5",
    "Question": "Does your child point with one finger to ask for something or to get help?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Vocalization Development",
    "Participating": "2",
    "Assessments": "M-CHAT-R:5;ADOS-T:6"
  },
  {
    "Id": "6",
    "KeyWord": "Smiling, Response",
    "Assessment": "M-CHAT-R",
    "Seq": "6",
    "Question": "Does your child smile in response to your smile?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Social Interest",
    "Participating": "2",
    "Assessments": "M-CHAT-R:6;VABS:1"
  },
  {
    "Id": "7",
    "KeyWord": "Sound Sensitivity",
    "Assessment": "M-CHAT-R",
    "Seq": "7",
    "Question": "Does your child seem oversensitive to certain sounds?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Sensory Sensitivity",
    "Participating": "2",
    "Assessments": "M-CHAT-R:7;BASC:5"
  },
  {
    "Id": "8",
    "KeyWord": "Gaze Following",
    "Assessment": "M-CHAT-R",
    "Seq": "8",
    "Question": "Does your child follow your gaze if you look across the room?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Joint Attention",
    "Participating": "2",
    "Assessments": "M-CHAT-R:8;ADOS-T:12"
  },
  {
    "Id": "9",
    "KeyWord": "Imitation, Faces",
    "Assessment": "M-CHAT-R",
    "Seq": "9",
    "Question": "Does your child imitate you, such as by making faces?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Imitative Behavior",
    "Participating": "2",
    "Assessments": "M-CHAT-R:9;ADOS-T:9"
  },
  {
    "Id": "10",
    "KeyWord": "Name Response",
    "Assessment": "M-CHAT-R",
    "Seq": "10",
    "Question": "Does your child respond when you call their name?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Response to Name",
    "Participating": "6",
    "Assessments": "M-CHAT-R:10;ABAS:1;PEDI:13;CDI:22;NEPSY:6;ADOS-T:1"
  },
  {
    "Id": "11",
    "KeyWord": "Pointing, Interest",
    "Assessment": "M-CHAT-R",
    "Seq": "11",
    "Question": "Does your child point to show you something interesting?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Joint Attention",
    "Participating": "3",
    "Assessments": "M-CHAT-R:11;CDI:7;ADOS-T:7"
  },
  {
    "Id": "12",
    "KeyWord": "Joint Attention",
    "Assessment": "M-CHAT-R",
    "Seq": "12",
    "Question": "Does your child look at things you are looking at?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Joint Attention",
    "Participating": "2",
    "Assessments": "M-CHAT-R:12;ADOS-T:13"
  },
  {
    "Id": "13",
    "KeyWord": "Sounds, Attention",
    "Assessment": "M-CHAT-R",
    "Seq": "13",
    "Question": "Does your child make sounds or words to get your attention?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Vocalization Development",
    "Participating": "2",
    "Assessments": "M-CHAT-R:13;ADOS-T:15"
  },
  {
    "Id": "14",
    "KeyWord": "Peek-a-boo, Games",
    "Assessment": "M-CHAT-R",
    "Seq": "14",
    "Question": "Does your child show an interest in playing peek-a-boo or hide-and-seek?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Imitative Behavior",
    "Participating": "2",
    "Assessments": "M-CHAT-R:14;CDI:23"
  },
  {
    "Id": "15",
    "KeyWord": "Facial Expressions",
    "Assessment": "M-CHAT-R",
    "Seq": "15",
    "Question": "Does your child show a variety of facial expressions?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Social Interest",
    "Participating": "1",
    "Assessments": "M-CHAT-R:15"
  },
  {
    "Id": "16",
    "KeyWord": "Sharing, Enjoyment",
    "Assessment": "M-CHAT-R",
    "Seq": "16",
    "Question": "Does your child attempt to share their enjoyment by showing you objects?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Social Sharing",
    "Participating": "2",
    "Assessments": "M-CHAT-R:16;ADOS-T:8"
  },
  {
    "Id": "17",
    "KeyWord": "Attachment, Objects",
    "Assessment": "M-CHAT-R",
    "Seq": "17",
    "Question": "Does your child seem overly attached to certain objects?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Social Sharing",
    "Participating": "1",
    "Assessments": "M-CHAT-R:17"
  },
  {
    "Id": "18",
    "KeyWord": "Pretend Play",
    "Assessment": "M-CHAT-R",
    "Seq": "18",
    "Question": "Does your child engage in pretend play?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Pretend Play",
    "Participating": "3",
    "Assessments": "M-CHAT-R:18;CDI:9;ADOS-T:5"
  },
  {
    "Id": "19",
    "KeyWord": "Walking",
    "Assessment": "M-CHAT-R",
    "Seq": "19",
    "Question": "Does your child walk well?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Physical Play",
    "Participating": "1",
    "Assessments": "M-CHAT-R:19"
  },
  {
    "Id": "20",
    "KeyWord": "Reaction Checking",
    "Assessment": "M-CHAT-R",
    "Seq": "20",
    "Question": "Does your child look at your face to check your reaction?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "16-30 months",
    "Domain": "Social Interest",
    "Participating": "1",
    "Assessments": "M-CHAT-R:20"
  },
  {
    "Id": "21",
    "KeyWord": "Separation Reaction",
    "Assessment": "M-CHAT-R",
    "Seq": "21",
    "Question": "Does your child show a reaction (such as excitement or distress) when separated from a primary caregiver?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "6-15 months",
    "Domain": "Imitative Behavior",
    "Participating": "2",
    "Assessments": "M-CHAT-R:21;ADOS-T:18"
  },
  {
    "Id": "22",
    "KeyWord": "Babbling, Sounds",
    "Assessment": "M-CHAT-R",
    "Seq": "22",
    "Question": "Does your child babble or make repetitive sounds?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "6-15 months",
    "Domain": "Vocalization Development",
    "Participating": "2",
    "Assessments": "M-CHAT-R:22;ADOS-T:21"
  },
  {
    "Id": "23",
    "KeyWord": "Eye Contact",
    "Assessment": "M-CHAT-R",
    "Seq": "23",
    "Question": "Does your child make eye contact during feeding or play?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "6-15 months",
    "Domain": "Joint Attention",
    "Participating": "2",
    "Assessments": "M-CHAT-R:23;ADOS-T:3"
  },
  {
    "Id": "24",
    "KeyWord": "Colorful Objects, Interest",
    "Assessment": "M-CHAT-R",
    "Seq": "24",
    "Question": "Does your child show interest in colorful objects or toys?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "6-15 months",
    "Domain": "Joint Attention",
    "Participating": "1",
    "Assessments": "M-CHAT-R:24"
  },
  {
    "Id": "25",
    "KeyWord": "Comforting, Empathy",
    "Assessment": "M-CHAT-R",
    "Seq": "25",
    "Question": "Does your child try to comfort others when they seem upset?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "31-48 months",
    "Domain": "Social Interest",
    "Participating": "3",
    "Assessments": "M-CHAT-R:25;PEDI:17;ADOS-T:10"
  },
  {
    "Id": "26",
    "KeyWord": "Labeling, Words",
    "Assessment": "M-CHAT-R",
    "Seq": "26",
    "Question": "Does your child use words to label familiar people, objects, or actions?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "31-48 months",
    "Domain": "Imitative Behavior",
    "Participating": "1",
    "Assessments": "M-CHAT-R:26"
  },
  {
    "Id": "27",
    "KeyWord": "Emotions Understanding",
    "Assessment": "M-CHAT-R",
    "Seq": "27",
    "Question": "Does your child show an understanding of basic emotions in others, like recognizing when someone is sad or happy?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "49-84 months",
    "Domain": "Behavioral Observation",
    "Participating": "3",
    "Assessments": "M-CHAT-R:27;SSIS:1;ADOS-T:11"
  },
  {
    "Id": "28",
    "KeyWord": "Role-playing",
    "Assessment": "M-CHAT-R",
    "Seq": "28",
    "Question": "Does your child engage in role-playing games, such as pretending to be a doctor, teacher, or parent?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "49-84 months",
    "Domain": "Pretend Play",
    "Participating": "2",
    "Assessments": "M-CHAT-R:28;ADOS-T:19"
  },
  {
    "Id": "29",
    "KeyWord": "Two-step Instructions",
    "Assessment": "M-CHAT-R",
    "Seq": "29",
    "Question": "Does your child follow two-step instructions, like 'Pick up the toy and put it on the table'?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "49-84 months",
    "Domain": "Vocalization Development",
    "Participating": "2",
    "Assessments": "M-CHAT-R:29;ADOS-T:16"
  },
  {
    "Id": "30",
    "KeyWord": "Time Concepts",
    "Assessment": "M-CHAT-R",
    "Seq": "30",
    "Question": "Does your child understand and use basic concepts of time, such as 'yesterday' or 'tomorrow'?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "49-84 months",
    "Domain": "Vocalization Development",
    "Participating": "1",
    "Assessments": "M-CHAT-R:30"
  },
  {
    "Id": "31",
    "KeyWord": "Cooperative Play",
    "Assessment": "M-CHAT-R",
    "Seq": "31",
    "Question": "Does your child play cooperatively with other children, such as taking turns and sharing?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "49-84 months",
    "Domain": "Pretend Play",
    "Participating": "2",
    "Assessments": "M-CHAT-R:31;CDI:25"
  },
  {
    "Id": "32",
    "KeyWord": "Problem-solving",
    "Assessment": "M-CHAT-R",
    "Seq": "32",
    "Question": "Does your child engage in basic problem-solving tasks, like completing a simple puzzle or sorting objects by color or shape?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "49-84 months",
    "Domain": "Behavioral Observation",
    "Participating": "2",
    "Assessments": "M-CHAT-R:32;ABAS:3"
  },
  {
    "Id": "33",
    "KeyWord": "Social Interaction",
    "Assessment": "ADOS-T",
    "Seq": "33",
    "Question": "Social Interaction: Does the child initiate interactions, like waving or reaching out to others?",
    "OptionWeightage": "No Attempt{#}0,Rarely{#}1,Often{#}2",
    "AgeGroup": "1-2 years",
    "Domain": "Social Referencing",
    "Participating": "4",
    "Assessments": "BASC:9;SSIS:7;ADOS-T:4;VABS:2"
  },
  {
    "Id": "34",
    "KeyWord": "Distress, Routine Changes",
    "Assessment": "ADOS-T",
    "Seq": "34",
    "Question": "Does the child display distress at changes in routine?",
    "OptionWeightage": "Always{#}0,Sometimes{#}1,Rarely{#}2",
    "AgeGroup": "30-36 Months",
    "Domain": "Adaptability",
    "Participating": "2",
    "Assessments": "DUNNS:28;ADOS-T:23"
  },
  {
    "Id": "35",
    "KeyWord": "Simple Instructions",
    "Assessment": "ADOS-T",
    "Seq": "35",
    "Question": "Can the child follow simple instructions?",
    "OptionWeightage": "Yes{#}2,No{#}0,Needs Repetition{#}1",
    "AgeGroup": "12-24 Months",
    "Domain": "Language Development",
    "Participating": "2",
    "Assessments": "PEDI:18;ADOS-T:14"
  },
  {
    "Id": "36",
    "KeyWord": "Feelings, Words",
    "Assessment": "ADOS-T",
    "Seq": "36",
    "Question": "Does the child use words to express feelings or desires?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "30-36 Months",
    "Domain": "Language Development",
    "Participating": "1",
    "Assessments": "ADOS-T:20"
  },
  {
    "Id": "37",
    "KeyWord": "Play Initiation",
    "Assessment": "ADOS-T",
    "Seq": "37",
    "Question": "Does the child initiate play or interaction with adults?",
    "OptionWeightage": "Yes{#}1,No{#}0",
    "AgeGroup": "24-30 Months",
    "Domain": "Social Interest",
    "Participating": "1",
    "Assessments": "ADOS-T:17"
  },
  {
    "Id": "38",
    "KeyWord": "Receptive Language",
    "Assessment": "VABS",
    "Seq": "38",
    "Question": "Receptive Language: Does the child respond to simple commands, like 'Come here' or 'Sit down'?",
    "OptionWeightage": "No response{#}0,Inconsistent{#}1,Consistent{#}2",
    "AgeGroup": "1-3 years",
    "Domain": "Communication",
    "Participating": "4",
    "Assessments": "ABAS:5;CELF:2;CDI:21;VABS:5"
  },
  {
    "Id": "39",
    "KeyWord": "Turn-taking",
    "Assessment": "VABS",
    "Seq": "39",
    "Question": "Turn-Taking: Can the child take turns in a simple game, like rolling a ball?",
    "OptionWeightage": "Unable{#}0,Sometimes{#}1,Always{#}2",
    "AgeGroup": "2-4 years",
    "Domain": "Socialization",
    "Participating": "1",
    "Assessments": "VABS:4"
  },
  {
    "Id": "40",
    "KeyWord": "Smiling, Laughing",
    "Assessment": "ADOS-T",
    "Seq": "40",
    "Question": "Does the child smile or laugh during play?",
    "OptionWeightage": "Yes{#}2,No{#}0,Sometimes{#}1",
    "AgeGroup": "6-12 Months",
    "Domain": "Social Interest",
    "Participating": "1",
    "Assessments": "ADOS-T:2"
  },
  {
    "Id": "41",
    "KeyWord": "Eating Independence",
    "Assessment": "VABS",
    "Seq": "41",
    "Question": "Eating Independence: Does the child attempt to use utensils, like a spoon?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Often{#}2",
    "AgeGroup": "18-35 months",
    "Domain": "Daily Living Skills",
    "Participating": "3",
    "Assessments": "BASC:8;PEDI:2;VABS:12"
  },
  {
    "Id": "42",
    "KeyWord": "Dressing Assistance",
    "Assessment": "VABS",
    "Seq": "42",
    "Question": "Dressing: Does the child assist in dressing by putting arms through sleeves or legs into pants?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Daily Living Skills",
    "Participating": "2",
    "Assessments": "PEDI:4;VABS:14"
  },
  {
    "Id": "43",
    "KeyWord": "Expressive Communication",
    "Assessment": "VABS",
    "Seq": "43",
    "Question": "Expressive Communication: Does the child say simple words like 'mama' or 'ball'?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Communication",
    "Participating": "2",
    "Assessments": "CDI:11;VABS:7"
  },
  {
    "Id": "44",
    "KeyWord": "Gross Motor",
    "Assessment": "VABS",
    "Seq": "44",
    "Question": "Gross Motor: Can the child crawl or walk unassisted across a room?",
    "OptionWeightage": "No{#}0,Needs support{#}1,Independent{#}2",
    "AgeGroup": "6 months-3 years",
    "Domain": "Motor Skills",
    "Participating": "2",
    "Assessments": "PEDI:7;VABS:8"
  },
  {
    "Id": "45",
    "KeyWord": "Holding, Feeding",
    "Assessment": "VABS",
    "Seq": "45",
    "Question": "Feeding: Can the child hold a bottle or cup while drinking?",
    "OptionWeightage": "No{#}0,Needs Help{#}1,Independent{#}2",
    "AgeGroup": "6-12 months",
    "Domain": "Daily Living Skills",
    "Participating": "2",
    "Assessments": "PEDI:1;VABS:11"
  },
  {
    "Id": "46",
    "KeyWord": "Imitation",
    "Assessment": "VABS",
    "Seq": "46",
    "Question": "Imitation: Does the child imitate simple gestures or actions shown by adults?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Often{#}2",
    "AgeGroup": "6 months-3 years",
    "Domain": "Socialization",
    "Participating": "2",
    "Assessments": "PEDI:16;VABS:3"
  },
  {
    "Id": "47",
    "KeyWord": "Non-verbal Communication",
    "Assessment": "VABS",
    "Seq": "47",
    "Question": "Non-Verbal Communication: Does the child use gestures (e.g., pointing or nodding) to communicate?",
    "OptionWeightage": "No Gestures{#}0,Rarely{#}1,Often{#}2",
    "AgeGroup": "1-3 years",
    "Domain": "Communication",
    "Participating": "2",
    "Assessments": "CDI:6;VABS:6"
  },
  {
    "Id": "48",
    "KeyWord": "Toileting",
    "Assessment": "VABS",
    "Seq": "48",
    "Question": "Toileting: Is the child toilet trained or working towards it?",
    "OptionWeightage": "No{#}0,In Progress{#}1,Independent{#}2",
    "AgeGroup": "2-5 years",
    "Domain": "Practical Skills",
    "Participating": "2",
    "Assessments": "ABAS:9;VABS:13"
  },
  {
    "Id": "49",
    "KeyWord": "Balance",
    "Assessment": "VABS",
    "Seq": "49",
    "Question": "Balance: Does the child attempt to stand or walk while holding onto furniture?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Consistently{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Motor Skills",
    "Participating": "1",
    "Assessments": "VABS:10"
  },
  {
    "Id": "50",
    "KeyWord": "Fine Motor",
    "Assessment": "VABS",
    "Seq": "50",
    "Question": "Fine Motor: Can the child pick up small objects using a pincer grasp (thumb and forefinger)?",
    "OptionWeightage": "Unable{#}0,Inconsistent{#}1,Consistent{#}2",
    "AgeGroup": "6 months-3 years",
    "Domain": "Motor Skills",
    "Participating": "1",
    "Assessments": "VABS:9"
  },
  {
    "Id": "51",
    "KeyWord": "Expressing Needs",
    "Assessment": "ABAS",
    "Seq": "51",
    "Question": "Communication: Can the child express basic needs (e.g., pointing, saying 'milk')?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Consistently{#}2",
    "AgeGroup": "1-2 years",
    "Domain": "Conceptual",
    "Participating": "3",
    "Assessments": "ABAS:2;CDI:10;SSIS:2"
  },
  {
    "Id": "52",
    "KeyWord": "Self-care",
    "Assessment": "ABAS",
    "Seq": "52",
    "Question": "Self-Care: Can the child wash their hands with assistance?",
    "OptionWeightage": "Unable{#}0,Needs Help{#}1,Consistent{#}2",
    "AgeGroup": "2-4 years",
    "Domain": "Practical Skills",
    "Participating": "2",
    "Assessments": "ABAS:8;BASC:7"
  },
  {
    "Id": "53",
    "KeyWord": "Social Skills, Eye Contact",
    "Assessment": "ABAS",
    "Seq": "53",
    "Question": "Social Skills: Does the child make eye contact with familiar people?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Consistently{#}2",
    "AgeGroup": "6-12 months",
    "Domain": "Social Skills",
    "Participating": "2",
    "Assessments": "ABAS:4;PEDI:14"
  },
  {
    "Id": "54",
    "KeyWord": "Peer Interaction",
    "Assessment": "ABAS",
    "Seq": "54",
    "Question": "Peer Interaction: Does the child initiate play with other children?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Often{#}2",
    "AgeGroup": "2-5 years",
    "Domain": "Social Skills",
    "Participating": "1",
    "Assessments": "ABAS:6"
  },
  {
    "Id": "55",
    "KeyWord": "Self-feeding",
    "Assessment": "ABAS",
    "Seq": "55",
    "Question": "Feeding: Does the child feed themselves with minimal help?",
    "OptionWeightage": "Needs Full Help{#}0,Partial{#}1,Independent{#}2",
    "AgeGroup": "1-3 years",
    "Domain": "Practical Skills",
    "Participating": "1",
    "Assessments": "ABAS:7"
  },
  {
    "Id": "56",
    "KeyWord": "Avoiding, Social Interactions",
    "Assessment": "BASC",
    "Seq": "56",
    "Question": "Does the child avoid eye contact or social interactions?",
    "OptionWeightage": "Never{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3",
    "AgeGroup": "6-35 months",
    "Domain": "Internalizing Behaviors",
    "Participating": "1",
    "Assessments": "BASC:3"
  },
  {
    "Id": "57",
    "KeyWord": "Impulsive Behaviors",
    "Assessment": "BASC",
    "Seq": "57",
    "Question": "Does the child show impulsive behaviors, such as grabbing items without asking?",
    "OptionWeightage": "Never{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3",
    "AgeGroup": "6-35 months",
    "Domain": "Externalizing Behaviors",
    "Participating": "1",
    "Assessments": "BASC:2"
  },
  {
    "Id": "58",
    "KeyWord": "Physical Behaviors, Frustration",
    "Assessment": "BASC",
    "Seq": "58",
    "Question": "Does the child engage in physical behaviors when frustrated (e.g., hitting, kicking)?",
    "OptionWeightage": "Never{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3",
    "AgeGroup": "6-35 months",
    "Domain": "Externalizing Behaviors",
    "Participating": "1",
    "Assessments": "BASC:1"
  },
  {
    "Id": "59",
    "KeyWord": "Self-soothing Behaviors",
    "Assessment": "BASC",
    "Seq": "59",
    "Question": "Does the child engage in self-soothing behaviors, like rocking?",
    "OptionWeightage": "Never{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3",
    "AgeGroup": "6-35 months",
    "Domain": "Internalizing Behaviors",
    "Participating": "1",
    "Assessments": "BASC:4"
  },
  {
    "Id": "60",
    "KeyWord": "Self-soothing Strategies",
    "Assessment": "BASC",
    "Seq": "60",
    "Question": "Does the child use self-soothing strategies (e.g., holding a favorite object)?",
    "OptionWeightage": "Never{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3",
    "AgeGroup": "6-35 months",
    "Domain": "Emotional Regulation",
    "Participating": "1",
    "Assessments": "BASC:6"
  },
  {
    "Id": "61",
    "KeyWord": "Bathing Tolerance",
    "Assessment": "PEDI",
    "Seq": "61",
    "Question": "Bathing: Does the child enjoy or tolerate having their face or body washed?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Self-Care",
    "Participating": "1",
    "Assessments": "PEDI:5"
  },
  {
    "Id": "62",
    "KeyWord": "Grooming",
    "Assessment": "PEDI",
    "Seq": "62",
    "Question": "Grooming: Does the child attempt to wipe their face or hands after eating?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Consistently{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Self-Care",
    "Participating": "1",
    "Assessments": "PEDI:3"
  },
  {
    "Id": "63",
    "KeyWord": "Independent Sitting",
    "Assessment": "PEDI",
    "Seq": "63",
    "Question": "Sitting: Can the child sit independently without support?",
    "OptionWeightage": "No{#}0,Breifly{#}1,Consistently{#}2",
    "AgeGroup": "6-12 months",
    "Domain": "Motor Skills",
    "Participating": "1",
    "Assessments": "PEDI:8"
  },
  {
    "Id": "64",
    "KeyWord": "Running",
    "Assessment": "PEDI",
    "Seq": "64",
    "Question": "Running: Does the child attempt to run or move faster than walking pace?",
    "OptionWeightage": "No{#}0,Unsteady{#}1,Steady{#}2",
    "AgeGroup": "24-35 months",
    "Domain": "Motor Skills",
    "Participating": "1",
    "Assessments": "PEDI:10"
  },
  {
    "Id": "65",
    "KeyWord": "Sharing",
    "Assessment": "PEDI",
    "Seq": "65",
    "Question": "Sharing: Does the child offer toys or objects to others during play?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "24-35 months",
    "Domain": "Social Referencing",
    "Participating": "1",
    "Assessments": "PEDI:15"
  },
  {
    "Id": "66",
    "KeyWord": "Single-leg Balance",
    "Assessment": "PEDI",
    "Seq": "66",
    "Question": "Balance: Can the child stand on one foot briefly while holding onto support?",
    "OptionWeightage": "No{#}0,Breifly{#}1,Consistently{#}2",
    "AgeGroup": "24-35 months",
    "Domain": "Motor Skills",
    "Participating": "1",
    "Assessments": "PEDI:12"
  },
  {
    "Id": "67",
    "KeyWord": "Transfers, Climbing",
    "Assessment": "PEDI",
    "Seq": "67",
    "Question": "Transfers: Can the child climb onto furniture or low surfaces independently?",
    "OptionWeightage": "No{#}0,Needs Help{#}1,Independent{#}2",
    "AgeGroup": "24-35 months",
    "Domain": "Motor Skills",
    "Participating": "1",
    "Assessments": "PEDI:11"
  },
  {
    "Id": "68",
    "KeyWord": "Unassisted Walking",
    "Assessment": "PEDI",
    "Seq": "68",
    "Question": "Walking: Can the child walk unassisted across a small space?",
    "OptionWeightage": "No{#}0,Needs Support{#}1,Independent{#}2",
    "AgeGroup": "12-18 months",
    "Domain": "Motor Skills",
    "Participating": "1",
    "Assessments": "PEDI:9"
  },
  {
    "Id": "69",
    "KeyWord": "Calming, Upset",
    "Assessment": "DUNNS",
    "Seq": "69",
    "Question": "Does the child attempt to calm down after becoming upset (e.g., cuddling a favorite toy)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "18-35 months",
    "Domain": "Self-Management",
    "Participating": "2",
    "Assessments": "DUNNS:29;SSIS:4"
  },
  {
    "Id": "70",
    "KeyWord": "Tracking Objects",
    "Assessment": "DUNNS",
    "Seq": "70",
    "Question": "Does the child track moving objects (e.g., toys, people)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "6-35 months",
    "Domain": "Visual Processing",
    "Participating": "2",
    "Assessments": "DUNNS:8;NEPSY:1"
  },
  {
    "Id": "71",
    "KeyWord": "Biting, Non-food",
    "Assessment": "DUNNS",
    "Seq": "71",
    "Question": "Does the child bite or chew on objects other than food?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Oral Sensory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:24"
  },
  {
    "Id": "72",
    "KeyWord": "Bothered By Noise",
    "Assessment": "DUNNS",
    "Seq": "72",
    "Question": "Does the child seem bothered by loud or unexpected noises?",
    "OptionWeightage": "Never{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "6-35 months",
    "Domain": "Auditory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:3"
  },
  {
    "Id": "73",
    "KeyWord": "Bumping",
    "Assessment": "DUNNS",
    "Seq": "73",
    "Question": "Does the child bump into furniture or objects frequently?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Proprioceptive Processing",
    "Participating": "1",
    "Assessments": "DUNNS:21"
  },
  {
    "Id": "74",
    "KeyWord": "Calming, Familiar Sounds",
    "Assessment": "DUNNS",
    "Seq": "74",
    "Question": "Does the child calm down when exposed to familiar music or sounds?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "6-35 months",
    "Domain": "Auditory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:2"
  },
  {
    "Id": "75",
    "KeyWord": "Calming, Movement",
    "Assessment": "DUNNS",
    "Seq": "75",
    "Question": "Does the child calm down when rocked or gently moved?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "0-12 months",
    "Domain": "Vestibular Processing",
    "Participating": "1",
    "Assessments": "DUNNS:17"
  },
  {
    "Id": "76",
    "KeyWord": "Clothing Sensitivity",
    "Assessment": "DUNNS",
    "Seq": "76",
    "Question": "Does the child appear sensitive to tags or seams in clothing?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "18-35 months",
    "Domain": "Tactile Processing",
    "Participating": "1",
    "Assessments": "DUNNS:15"
  },
  {
    "Id": "77",
    "KeyWord": "Clumsy Movement",
    "Assessment": "DUNNS",
    "Seq": "77",
    "Question": "Does the child appear clumsy or unsteady when moving around?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Vestibular Processing",
    "Participating": "1",
    "Assessments": "DUNNS:19"
  },
  {
    "Id": "78",
    "KeyWord": "Crying, Rough Handling",
    "Assessment": "DUNNS",
    "Seq": "78",
    "Question": "Does the child cry when handled roughly (e.g., diaper changes, play)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "0-12 months",
    "Domain": "Tactile Processing",
    "Participating": "1",
    "Assessments": "DUNNS:12"
  },
  {
    "Id": "79",
    "KeyWord": "Food Texture Aversion",
    "Assessment": "DUNNS",
    "Seq": "79",
    "Question": "Does the child avoid certain food textures (e.g., crunchy, sticky)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "18-35 months",
    "Domain": "Oral Sensory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:25"
  },
  {
    "Id": "80",
    "KeyWord": "Heavy Objects",
    "Assessment": "DUNNS",
    "Seq": "80",
    "Question": "Does the child prefer carrying heavy objects or pushing furniture?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Proprioceptive Processing",
    "Participating": "1",
    "Assessments": "DUNNS:22"
  },
  {
    "Id": "81",
    "KeyWord": "Light Sensitivity",
    "Assessment": "DUNNS",
    "Seq": "81",
    "Question": "Does the child look at bright lights or avoid them by squinting or turning?",
    "OptionWeightage": "Never{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "0-35 months",
    "Domain": "Visual Processing",
    "Participating": "1",
    "Assessments": "DUNNS:6"
  },
  {
    "Id": "82",
    "KeyWord": "Messy Play Aversion",
    "Assessment": "DUNNS",
    "Seq": "82",
    "Question": "Does the child dislike messy play (e.g., finger paint, sand)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "18-35 months",
    "Domain": "Tactile Processing",
    "Participating": "1",
    "Assessments": "DUNNS:14"
  },
  {
    "Id": "83",
    "KeyWord": "Mouthing Objects",
    "Assessment": "DUNNS",
    "Seq": "83",
    "Question": "Does the child frequently lick or mouth objects (e.g., toys, fingers)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Oral Sensory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:27"
  },
  {
    "Id": "84",
    "KeyWord": "Movement Activities",
    "Assessment": "DUNNS",
    "Seq": "84",
    "Question": "Does the child seek out movement activities (e.g., bouncing, spinning)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "18-35 months",
    "Domain": "Vestibular Processing",
    "Participating": "1",
    "Assessments": "DUNNS:20"
  },
  {
    "Id": "85",
    "KeyWord": "Noticing Voices",
    "Assessment": "DUNNS",
    "Seq": "85",
    "Question": "Does the child notice when a familiar voice is heard from across the room?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Often{#}2",
    "AgeGroup": "6-35 months",
    "Domain": "Auditory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:4"
  },
  {
    "Id": "86",
    "KeyWord": "Object Reaching",
    "Assessment": "DUNNS",
    "Seq": "86",
    "Question": "Does the child reach for or touch objects nearby?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "6-12 months",
    "Domain": "Tactile Processing",
    "Participating": "1",
    "Assessments": "DUNNS:13"
  },
  {
    "Id": "87",
    "KeyWord": "Rough Play",
    "Assessment": "DUNNS",
    "Seq": "87",
    "Question": "Does the child enjoy rough play like wrestling or climbing?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Proprioceptive Processing",
    "Participating": "1",
    "Assessments": "DUNNS:23"
  },
  {
    "Id": "88",
    "KeyWord": "Sound Distress",
    "Assessment": "DUNNS",
    "Seq": "88",
    "Question": "Does the child appear distressed by overlapping sounds (e.g., multiple people talking)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Auditory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:5"
  },
  {
    "Id": "89",
    "KeyWord": "Spinning Objects",
    "Assessment": "DUNNS",
    "Seq": "89",
    "Question": "Does the child enjoy looking at spinning or moving objects (e.g., fan)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "6-35 months",
    "Domain": "Visual Processing",
    "Participating": "1",
    "Assessments": "DUNNS:7"
  },
  {
    "Id": "90",
    "KeyWord": "Startling",
    "Assessment": "DUNNS",
    "Seq": "90",
    "Question": "Does the child startle at sudden or loud sounds?",
    "OptionWeightage": "Never{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "0-35 months",
    "Domain": "Auditory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:1"
  },
  {
    "Id": "91",
    "KeyWord": "Temperature Sensitivity",
    "Assessment": "DUNNS",
    "Seq": "91",
    "Question": "Does the child react strongly to changes in temperature (e.g., hot or cold)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "18-35 months",
    "Domain": "Tactile Processing",
    "Participating": "1",
    "Assessments": "DUNNS:16"
  },
  {
    "Id": "92",
    "KeyWord": "Texture Enjoyment",
    "Assessment": "DUNNS",
    "Seq": "92",
    "Question": "Does the child enjoy feeling different textures (e.g., soft blankets)?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "6-35 months",
    "Domain": "Tactile Processing",
    "Participating": "1",
    "Assessments": "DUNNS:11"
  },
  {
    "Id": "93",
    "KeyWord": "Toothbrushing Resistance",
    "Assessment": "DUNNS",
    "Seq": "93",
    "Question": "Does the child resist toothbrushing or putting things in their mouth?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Oral Sensory Processing",
    "Participating": "1",
    "Assessments": "DUNNS:26"
  },
  {
    "Id": "94",
    "KeyWord": "Touch Sensitivity",
    "Assessment": "DUNNS",
    "Seq": "94",
    "Question": "Does the child resist being touched unexpectedly?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "6-35 months",
    "Domain": "Tactile Processing",
    "Participating": "1",
    "Assessments": "DUNNS:10"
  },
  {
    "Id": "95",
    "KeyWord": "Visual Patterns",
    "Assessment": "DUNNS",
    "Seq": "95",
    "Question": "Does the child appear attracted to or avoid visually busy patterns?",
    "OptionWeightage": "No{#}0,Sometimes{#}1,Often{#}2",
    "AgeGroup": "12-35 months",
    "Domain": "Visual Processing",
    "Participating": "1",
    "Assessments": "DUNNS:9"
  },
  {
    "Id": "96",
    "KeyWord": "Say Words",
    "Assessment": "CELF",
    "Seq": "96",
    "Question": "Does the child recognize or say words for common objects (e.g., ball, car)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "6 months to 3 years",
    "Domain": "Vocabulary Comprehension and Expression",
    "Participating": "2",
    "Assessments": "CELF:1;CDI:1"
  },
  {
    "Id": "97",
    "KeyWord": "Two Word Phrases",
    "Assessment": "CELF",
    "Seq": "97",
    "Question": "Does the child use two-word phrases, like \"\"more juice\"\"?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "2 to 4 years",
    "Domain": "Expressive Language",
    "Participating": "2",
    "Assessments": "CELF:4;CDI:16"
  },
  {
    "Id": "98",
    "KeyWord": "Use Pronouns",
    "Assessment": "CELF",
    "Seq": "98",
    "Question": "Does the child use pronouns correctly, like \"\"I\"\", \"\"me\"\"?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "2 to 5 years",
    "Domain": "Language Structure",
    "Participating": "2",
    "Assessments": "CELF:6;CDI:19"
  },
  {
    "Id": "99",
    "KeyWord": "Greetings",
    "Assessment": "CELF",
    "Seq": "99",
    "Question": "Does the child respond appropriately to greetings or farewells?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "2 to 7 years",
    "Domain": "Social Communication",
    "Participating": "1",
    "Assessments": "CELF:8"
  },
  {
    "Id": "100",
    "KeyWord": "Name Objects",
    "Assessment": "CELF",
    "Seq": "100",
    "Question": "Can the child name familiar objects (e.g., toy, dog, book)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "1 to 3 years",
    "Domain": "Expressive Language",
    "Participating": "1",
    "Assessments": "CELF:3"
  },
  {
    "Id": "101",
    "KeyWord": "Turn to Others",
    "Assessment": "CELF",
    "Seq": "101",
    "Question": "Does the child take turns when talking with others?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "3 to 7 years",
    "Domain": "Social Communication",
    "Participating": "1",
    "Assessments": "CELF:7"
  },
  {
    "Id": "102",
    "KeyWord": "Use Plurals",
    "Assessment": "CELF",
    "Seq": "102",
    "Question": "Does the child use plurals, like \"\"dogs\"\"?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "3 to 5 years",
    "Domain": "Language Structure",
    "Participating": "1",
    "Assessments": "CELF:5"
  },
  {
    "Id": "103",
    "KeyWord": "Simple Choices",
    "Assessment": "CDI",
    "Seq": "103",
    "Question": "Does the child make simple choices when given options (e.g., choosing between two toys)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "18-35 months",
    "Domain": "Responsible Decision-Making",
    "Participating": "2",
    "Assessments": "CDI:15;SSIS:8"
  },
  {
    "Id": "104",
    "KeyWord": "Describe Actions",
    "Assessment": "CDI",
    "Seq": "104",
    "Question": "Does the child describe actions (e.g., I jump, Mom eat)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "2 to 7 years",
    "Domain": "Sentence and Phrase Complexity",
    "Participating": "1",
    "Assessments": "CDI:20"
  },
  {
    "Id": "105",
    "KeyWord": "Descriptive Words",
    "Assessment": "CDI",
    "Seq": "105",
    "Question": "Can the child use descriptive words (e.g., big, fast)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "12 months to 4 years",
    "Domain": "Early Words and Phrases",
    "Participating": "1",
    "Assessments": "CDI:12"
  },
  {
    "Id": "106",
    "KeyWord": "Refer To Things",
    "Assessment": "CDI",
    "Seq": "106",
    "Question": "Does the child refer to family members or pets by name?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "12 months to 4 years",
    "Domain": "Early Words and Phrases",
    "Participating": "1",
    "Assessments": "CDI:14"
  },
  {
    "Id": "107",
    "KeyWord": "Say Names",
    "Assessment": "CDI",
    "Seq": "107",
    "Question": "Does the child recognize or say names of family members (e.g., mama, dada)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "6 months to 3 years",
    "Domain": "Vocabulary Comprehension and Expression",
    "Participating": "1",
    "Assessments": "CDI:3"
  },
  {
    "Id": "108",
    "KeyWord": "Say Names",
    "Assessment": "CDI",
    "Seq": "108",
    "Question": "Can the child identify or say names of animals (e.g., dog, cat)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "6 months to 3 years",
    "Domain": "Vocabulary Comprehension and Expression",
    "Participating": "1",
    "Assessments": "CDI:5"
  },
  {
    "Id": "109",
    "KeyWord": "Say Words",
    "Assessment": "CDI",
    "Seq": "109",
    "Question": "Can the child identify or say words for body parts (e.g., nose, hand)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "6 months to 3 years",
    "Domain": "Vocabulary Comprehension and Expression",
    "Participating": "1",
    "Assessments": "CDI:2"
  },
  {
    "Id": "110",
    "KeyWord": "Say Words",
    "Assessment": "CDI",
    "Seq": "110",
    "Question": "Can the child recognize or say words for food items (e.g., apple, juice)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "6 months to 3 years",
    "Domain": "Vocabulary Comprehension and Expression",
    "Participating": "1",
    "Assessments": "CDI:4"
  },
  {
    "Id": "111",
    "KeyWord": "Shared Activities",
    "Assessment": "CDI",
    "Seq": "111",
    "Question": "Does the child show interest in shared activities?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "6 months to 7 years",
    "Domain": "Joint Attention",
    "Participating": "1",
    "Assessments": "CDI:24"
  },
  {
    "Id": "112",
    "KeyWord": "Short Sentences",
    "Assessment": "CDI",
    "Seq": "112",
    "Question": "Can the child say short sentences (e.g., I want toy)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "2 to 7 years",
    "Domain": "Sentence and Phrase Complexity",
    "Participating": "1",
    "Assessments": "CDI:17"
  },
  {
    "Id": "113",
    "KeyWord": "Simple Questions",
    "Assessment": "CDI",
    "Seq": "113",
    "Question": "Does the child ask simple questions (e.g., What’s that?)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "2 to 7 years",
    "Domain": "Sentence and Phrase Complexity",
    "Participating": "1",
    "Assessments": "CDI:18"
  },
  {
    "Id": "114",
    "KeyWord": "Simple Words",
    "Assessment": "CDI",
    "Seq": "114",
    "Question": "Does the child use simple words to make requests (e.g., want, mine)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "12 months to 4 years",
    "Domain": "Early Words and Phrases",
    "Participating": "1",
    "Assessments": "CDI:13"
  },
  {
    "Id": "115",
    "KeyWord": "Focus",
    "Assessment": "NEPSY",
    "Seq": "115",
    "Question": "Does the child focus on a toy or person for at least 10 seconds?",
    "OptionWeightage": "No Attention{#}0,Brief attention{#}1,Focused attention{#}2",
    "AgeGroup": "12-24 months",
    "Domain": "Attention and Inhibition",
    "Participating": "1",
    "Assessments": "NEPSY:2"
  },
  {
    "Id": "116",
    "KeyWord": "Location Memory ",
    "Assessment": "NEPSY",
    "Seq": "116",
    "Question": "Can the child remember the location of a toy after a brief delay?",
    "OptionWeightage": "No recall{#}0,Partial{#}1,Full recall{#}2",
    "AgeGroup": "18-24 months",
    "Domain": "Working Memory",
    "Participating": "1",
    "Assessments": "NEPSY:3"
  },
  {
    "Id": "117",
    "KeyWord": "Look for Object",
    "Assessment": "NEPSY",
    "Seq": "117",
    "Question": "Does the child look for an object hidden under a cloth?",
    "OptionWeightage": "No Search{#}0,Some search{#}1,Complete search{#}2",
    "AgeGroup": "8-12 months",
    "Domain": "Object Permanence",
    "Participating": "1",
    "Assessments": "NEPSY:7"
  },
  {
    "Id": "118",
    "KeyWord": "Multistep Directions",
    "Assessment": "NEPSY",
    "Seq": "118",
    "Question": "Can the child follow multi-step directions?",
    "OptionWeightage": "Unable{#}0,Partially follows{#}1,Follows fully{#}2",
    "AgeGroup": "4-7 years",
    "Domain": "Language Processing",
    "Participating": "1",
    "Assessments": "NEPSY:8"
  },
  {
    "Id": "119",
    "KeyWord": "Pressing Button",
    "Assessment": "NEPSY",
    "Seq": "119",
    "Question": "Does the child understand that pressing a button activates a toy?",
    "OptionWeightage": "No Response{#}0,Limited{#}1,Full understanding{#}2",
    "AgeGroup": "6-12 months",
    "Domain": "Cause and Effect",
    "Participating": "1",
    "Assessments": "NEPSY:4"
  },
  {
    "Id": "120",
    "KeyWord": "Repeat Action",
    "Assessment": "NEPSY",
    "Seq": "120",
    "Question": "Does the child repeat an action, like shaking a rattle, to get a response?",
    "OptionWeightage": "No Repetation{#}0,Some{#}1,Repeats consistently{#}2",
    "AgeGroup": "12-18 months",
    "Domain": "Cause and Effect",
    "Participating": "1",
    "Assessments": "NEPSY:5"
  },
  {
    "Id": "121",
    "KeyWord": "Frustration, Observable",
    "Assessment": "SSIS",
    "Seq": "121",
    "Question": "Does the child express frustration in an observable way (e.g., crying, withdrawing)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "1-3 years",
    "Domain": "Self-Awareness",
    "Participating": "1",
    "Assessments": "SSIS:3"
  },
  {
    "Id": "122",
    "KeyWord": "Noticing, Upset",
    "Assessment": "SSIS",
    "Seq": "122",
    "Question": "Does the child notice when someone nearby is upset (e.g., looks at a crying peer)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "1-3 years",
    "Domain": "Social Awareness",
    "Participating": "1",
    "Assessments": "SSIS:5"
  },
  {
    "Id": "123",
    "KeyWord": "Responding, Emotions",
    "Assessment": "SSIS",
    "Seq": "123",
    "Question": "Does the child respond to familiar people’s emotions (e.g., smiling back)?",
    "OptionWeightage": "No{#}0,Rarely{#}1,Sometimes{#}2,Often{#}3,Always{#}4",
    "AgeGroup": "1-3 years",
    "Domain": "Social Awareness",
    "Participating": "1",
    "Assessments": "SSIS:6"
  },
  {
    "Id": "124",
    "KeyWord": "Attention",
    "Assessment": "PSI",
    "Seq": "124",
    "Question": "Demandingness : Does the child often demand constant attention?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Child Characteristics",
    "Participating": "1",
    "Assessments": "PSI:1"
  },
  {
    "Id": "125",
    "KeyWord": "Child Health",
    "Assessment": "PSI",
    "Seq": "125",
    "Question": "Health Concerns : Are you often worried about your child’s health or physical well-being?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Child Characteristics",
    "Participating": "1",
    "Assessments": "PSI:15"
  },
  {
    "Id": "126",
    "KeyWord": "Confidence",
    "Assessment": "PSI",
    "Seq": "126",
    "Question": "Competence : Do you feel confident in managing your child’s behavior?",
    "OptionWeightage": "Very Confident{#}0,Somewhat Confident{#}1,Not Confident{#}2",
    "AgeGroup": "All",
    "Domain": "Parent Characteristics",
    "Participating": "1",
    "Assessments": "PSI:6"
  },
  {
    "Id": "127",
    "KeyWord": "Daily Interaction",
    "Assessment": "PSI",
    "Seq": "127",
    "Question": "Temperament : Does your child’s temperament make daily interactions challenging?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Child Characteristics",
    "Participating": "1",
    "Assessments": "PSI:16"
  },
  {
    "Id": "128",
    "KeyWord": "Develomental Expectations",
    "Assessment": "PSI",
    "Seq": "128",
    "Question": "Expectations : Do you feel disappointed if your child doesn’t meet developmental expectations?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Parent Characteristics",
    "Participating": "1",
    "Assessments": "PSI:17"
  },
  {
    "Id": "129",
    "KeyWord": "Emotional",
    "Assessment": "PSI",
    "Seq": "129",
    "Question": "Attachment : Do you feel emotionally connected to your child?",
    "OptionWeightage": "Very Connected{#}0,Somewhat Connected{#}1,Not Connected{#}2",
    "AgeGroup": "All",
    "Domain": "Parent Characteristics",
    "Participating": "1",
    "Assessments": "PSI:8"
  },
  {
    "Id": "130",
    "KeyWord": "Excessive Energy",
    "Assessment": "PSI",
    "Seq": "130",
    "Question": "Hyperactivity : Does the child exhibit excessive energy or have trouble sitting still?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Child Characteristics",
    "Participating": "1",
    "Assessments": "PSI:4"
  },
  {
    "Id": "131",
    "KeyWord": "Financially Strained",
    "Assessment": "PSI",
    "Seq": "131",
    "Question": "Financial Stress : Do you feel financially strained in providing for your child’s needs?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Situational Factors",
    "Participating": "1",
    "Assessments": "PSI:11"
  },
  {
    "Id": "132",
    "KeyWord": "Focus",
    "Assessment": "PSI",
    "Seq": "132",
    "Question": "Attention : Is it difficult to engage the child in activities that require focus?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Child Characteristics",
    "Participating": "1",
    "Assessments": "PSI:5"
  },
  {
    "Id": "133",
    "KeyWord": "Isolated",
    "Assessment": "PSI",
    "Seq": "133",
    "Question": "Isolation : Do you feel isolated or without adequate support in raising your child?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Parent Characteristics",
    "Participating": "1",
    "Assessments": "PSI:7"
  },
  {
    "Id": "134",
    "KeyWord": "Mood",
    "Assessment": "PSI",
    "Seq": "134",
    "Question": "Mood : Does the child often seem irritable or unhappy?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Child Characteristics",
    "Participating": "1",
    "Assessments": "PSI:2"
  },
  {
    "Id": "135",
    "KeyWord": "Parenting",
    "Assessment": "PSI",
    "Seq": "135",
    "Question": "Role Restriction : Do you feel restricted by the demands of parenting (e.g., limited personal time)?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Parent Characteristics",
    "Participating": "1",
    "Assessments": "PSI:10"
  },
  {
    "Id": "136",
    "KeyWord": "Relationship with Others",
    "Assessment": "PSI",
    "Seq": "136",
    "Question": "Family Relationships : Has parenting affected your relationship with other family members (e.g., siblings or extended family)?",
    "OptionWeightage": "No Impact{#}0,Some Impact{#}1,Significant Impact{#}2",
    "AgeGroup": "All",
    "Domain": "Situational Factors",
    "Participating": "1",
    "Assessments": "PSI:20"
  },
  {
    "Id": "137",
    "KeyWord": "Role as Parent",
    "Assessment": "PSI",
    "Seq": "137",
    "Question": "Role Satisfaction : Do you feel satisfied with your role as a parent?",
    "OptionWeightage": "Very Satisfied{#}0,Somewhat Satisfied{#}1,Not Satisfied{#}2",
    "AgeGroup": "All",
    "Domain": "Parent Characteristics",
    "Participating": "1",
    "Assessments": "PSI:18"
  },
  {
    "Id": "138",
    "KeyWord": "Routine",
    "Assessment": "PSI",
    "Seq": "138",
    "Question": "Adaptability : Does the child have difficulty adapting to changes in routine?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Child Characteristics",
    "Participating": "1",
    "Assessments": "PSI:3"
  },
  {
    "Id": "139",
    "KeyWord": "Sad or Overwhelmed",
    "Assessment": "PSI",
    "Seq": "139",
    "Question": "Depression : Do you often feel sad or overwhelmed as a parent?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Parent Characteristics",
    "Participating": "1",
    "Assessments": "PSI:9"
  },
  {
    "Id": "140",
    "KeyWord": "Social or Community",
    "Assessment": "PSI",
    "Seq": "140",
    "Question": "Social Support : Do you have access to social or community support when needed?",
    "OptionWeightage": "Often{#}0,Sometimes{#}1,Rarely{#}2",
    "AgeGroup": "All",
    "Domain": "Situational Factors",
    "Participating": "1",
    "Assessments": "PSI:12"
  },
  {
    "Id": "141",
    "KeyWord": "Stress in Relationship",
    "Assessment": "PSI",
    "Seq": "141",
    "Question": "Marital/Partner Stress : Has parenting led to increased stress in your relationship with your partner?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Situational Factors",
    "Participating": "1",
    "Assessments": "PSI:13"
  },
  {
    "Id": "142",
    "KeyWord": "Time management",
    "Assessment": "PSI",
    "Seq": "142",
    "Question": "Time Management : Do you find it challenging to manage time between parenting and other responsibilities?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Situational Factors",
    "Participating": "1",
    "Assessments": "PSI:14"
  },
  {
    "Id": "143",
    "KeyWord": "Work Balance",
    "Assessment": "PSI",
    "Seq": "143",
    "Question": "Work-Life Balance : Do you struggle to balance work responsibilities with parenting?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Situational Factors",
    "Participating": "1",
    "Assessments": "PSI:19"
  },
  {
    "Id": "144",
    "KeyWord": "Conflict Resolution",
    "Assessment": "FES",
    "Seq": "144",
    "Question": "Conflict Resolution : When disagreements arise, do family members work together to resolve them calmly?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Communication",
    "Participating": "1",
    "Assessments": "FES:5"
  },
  {
    "Id": "145",
    "KeyWord": "Daily Routines",
    "Assessment": "FES",
    "Seq": "145",
    "Question": "Daily Routines : Are daily routines (e.g., mealtimes, bedtime) consistent for the child?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Organization",
    "Participating": "1",
    "Assessments": "FES:10"
  },
  {
    "Id": "146",
    "KeyWord": "Discipline",
    "Assessment": "FES",
    "Seq": "146",
    "Question": "Discipline : Is positive discipline (e.g., explanations rather than punishment) used to manage behavior?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Family Values",
    "Participating": "1",
    "Assessments": "FES:22"
  },
  {
    "Id": "147",
    "KeyWord": "Emotional Support",
    "Assessment": "FES",
    "Seq": "147",
    "Question": "Emotional Support : Do family members provide emotional support when someone is feeling down?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Support",
    "Participating": "1",
    "Assessments": "FES:13"
  },
  {
    "Id": "148",
    "KeyWord": "Encouragement",
    "Assessment": "FES",
    "Seq": "148",
    "Question": "Encouragement : Do family members encourage each other to try new things?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Support",
    "Participating": "1",
    "Assessments": "FES:15"
  },
  {
    "Id": "149",
    "KeyWord": "Express Affection",
    "Assessment": "FES",
    "Seq": "149",
    "Question": "Emotional Closeness : Do family members express affection openly and frequently?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Cohesion",
    "Participating": "1",
    "Assessments": "FES:3"
  },
  {
    "Id": "150",
    "KeyWord": "Feeling Sharing",
    "Assessment": "FES",
    "Seq": "150",
    "Question": "Openness : Are family members comfortable sharing their feelings and thoughts with each other?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Communication",
    "Participating": "1",
    "Assessments": "FES:4"
  },
  {
    "Id": "151",
    "KeyWord": "Goal Setting",
    "Assessment": "FES",
    "Seq": "151",
    "Question": "Goal Setting : Does the family set and work toward shared goals (e.g., education, savings, travel)?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Achievement Orientation",
    "Participating": "1",
    "Assessments": "FES:16"
  },
  {
    "Id": "152",
    "KeyWord": "Health & Wellness",
    "Assessment": "FES",
    "Seq": "152",
    "Question": "Health & Wellness : Does the family engage in activities that promote health (e.g., exercise, outdoor play)?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Family Values",
    "Participating": "1",
    "Assessments": "FES:24"
  },
  {
    "Id": "153",
    "KeyWord": "Independence",
    "Assessment": "FES",
    "Seq": "153",
    "Question": "Independence : Are family members encouraged to pursue individual interests and hobbies?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Autonomy",
    "Participating": "1",
    "Assessments": "FES:19"
  },
  {
    "Id": "154",
    "KeyWord": "Personal Decision-Making",
    "Assessment": "FES",
    "Seq": "154",
    "Question": "Personal Decision-Making : Do family members allow each other to make personal decisions (appropriate to age)?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Autonomy",
    "Participating": "1",
    "Assessments": "FES:20"
  },
  {
    "Id": "155",
    "KeyWord": "Planning",
    "Assessment": "FES",
    "Seq": "155",
    "Question": "Planning : Do family members plan activities or outings together?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Organization",
    "Participating": "1",
    "Assessments": "FES:12"
  },
  {
    "Id": "156",
    "KeyWord": "Practical Support",
    "Assessment": "FES",
    "Seq": "156",
    "Question": "Practical Support : Do family members help each other with daily tasks (e.g., chores, childcare)?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Support",
    "Participating": "1",
    "Assessments": "FES:14"
  },
  {
    "Id": "157",
    "KeyWord": "Quality Time",
    "Assessment": "FES",
    "Seq": "157",
    "Question": "Family Bonding : Do family members spend quality time together daily?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Cohesion",
    "Participating": "1",
    "Assessments": "FES:1"
  },
  {
    "Id": "158",
    "KeyWord": "Resolution of Conflicts",
    "Assessment": "FES",
    "Seq": "158",
    "Question": "Resolution of Conflicts : Do family members try to resolve conflicts without raising their voices?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Conflict",
    "Participating": "1",
    "Assessments": "FES:9"
  },
  {
    "Id": "159",
    "KeyWord": "Respect for Privacy",
    "Assessment": "FES",
    "Seq": "159",
    "Question": "Respect for Privacy : Do family members respect each other’s privacy?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Autonomy",
    "Participating": "1",
    "Assessments": "FES:21"
  },
  {
    "Id": "160",
    "KeyWord": "Responsibility",
    "Assessment": "FES",
    "Seq": "160",
    "Question": "Responsibility : Are children encouraged to take on age-appropriate responsibilities?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Achievement Orientation",
    "Participating": "1",
    "Assessments": "FES:18"
  },
  {
    "Id": "161",
    "KeyWord": "Stress",
    "Assessment": "FES",
    "Seq": "161",
    "Question": "Supportive Relationships : Do family members support each other during stressful times?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Cohesion",
    "Participating": "1",
    "Assessments": "FES:2"
  },
  {
    "Id": "162",
    "KeyWord": "Success Recognition",
    "Assessment": "FES",
    "Seq": "162",
    "Question": "Success Recognition : Do family members celebrate each other’s achievements?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Achievement Orientation",
    "Participating": "1",
    "Assessments": "FES:17"
  },
  {
    "Id": "163",
    "KeyWord": "Tension",
    "Assessment": "FES",
    "Seq": "163",
    "Question": "Tension : Is there tension between family members on a regular basis?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Conflict",
    "Participating": "1",
    "Assessments": "FES:8"
  },
  {
    "Id": "164",
    "KeyWord": "Time Management",
    "Assessment": "FES",
    "Seq": "164",
    "Question": "Time Management : Is family time structured effectively to balance work, play, and rest?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Organization",
    "Participating": "1",
    "Assessments": "FES:11"
  },
  {
    "Id": "165",
    "KeyWord": "Traditions",
    "Assessment": "FES",
    "Seq": "165",
    "Question": "Traditions : Does the family have regular traditions or rituals that everyone participates in?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Family Values",
    "Participating": "1",
    "Assessments": "FES:23"
  },
  {
    "Id": "166",
    "KeyWord": "Understanding",
    "Assessment": "FES",
    "Seq": "166",
    "Question": "Understanding : Do family members try to understand each other’s perspectives?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Communication",
    "Participating": "1",
    "Assessments": "FES:6"
  },
  {
    "Id": "167",
    "KeyWord": "Verbal Disputes",
    "Assessment": "FES",
    "Seq": "167",
    "Question": "Verbal Disputes : Are arguments or loud disagreements common in the family?",
    "OptionWeightage": "Rarely{#}0,Sometimes{#}1,Frequently{#}2",
    "AgeGroup": "All",
    "Domain": "Conflict",
    "Participating": "1",
    "Assessments": "FES:7"
  }
];

export var assessmentLiners = [
  {
    "ShortName": "M-CHAT-R",
    "FullName": "Modified Checklist for Autism in Toddlers, Revised (M-CHAT-R)",
    "Description": "Screens for early signs of autism spectrum disorder in toddlers, enabling prompt evaluation and early interventions that support optimal developmental outcomes."
  },
  {
    "ShortName": "ADOS-T",
    "FullName": "Autism Diagnostic Observation Schedule, Toddler (ADOS-T)",
    "Description": "Provides a standardized assessment of social interaction, communication, and play behaviors, assisting in diagnosing autism spectrum disorders and tailoring individualized support."
  },
  {
    "ShortName": "VABS",
    "FullName": "Vineland Adaptive Behavior Scales (VABS)",
    "Description": "Evaluates adaptive behaviors including communication, daily living skills, and socialization, helping to develop goals that promote independence and functional abilities."
  },
  {
    "ShortName": "ABAS",
    "FullName": "Adaptive Behavior Assessment System (ABAS)",
    "Description": "Measures adaptive skills across conceptual, social, and practical domains, informing interventions to improve functional independence and social participation."
  },
  {
    "ShortName": "BASC",
    "FullName": "Behavior Assessment System for Children (BASC)",
    "Description": "Evaluates a wide range of behavioral and emotional aspects, enabling the development of strategies to support emotional well-being and behavioral adjustment."
  },
  {
    "ShortName": "PEDI",
    "FullName": "Pediatric Evaluation of Disability Inventory (PEDI)",
    "Description": "Assesses functional capabilities in self-care, mobility, and social function, identifying areas needing support and guiding interventions that encourage independence."
  },
  {
    "ShortName": "DUNNS",
    "FullName": "Developmental Understanding of the Needs of Sensory and Social (DUNNS)",
    "Description": "Assesses sensory processing patterns, aiding in understanding sensory preferences and challenges to design interventions that improve focus and engagement."
  },
  {
    "ShortName": "CELF",
    "FullName": "Clinical Evaluation of Language Fundamentals (CELF)",
    "Description": "Identifies specific language comprehension and expression difficulties, allowing for targeted language interventions to support effective communication."
  },
  {
    "ShortName": "CDI",
    "FullName": "Communicative Development Inventories (CDI)",
    "Description": "Assesses language and communication milestones, identifying strengths and delays to guide interventions that enhance language development."
  },
  {
    "ShortName": "NEPSY",
    "FullName": "Neuropsychological Evaluation of Kids (NEPSY)",
    "Description": "Evaluates cognitive functions such as memory, attention, and executive skills, helping to create personalized goals for cognitive development."
  },
  {
    "ShortName": "SSIS",
    "FullName": "Social Skills Improvement System (SSIS)",
    "Description": "Assesses social skills, problem behaviors, and academic competence, guiding interventions that enhance peer relationships and communication abilities."
  },
  {
    "ShortName": "PSI",
    "FullName": "Parenting Stress Index (PSI)",
    "Description": "Measures stress levels within the parent-child relationship, allowing us to support your family in fostering a balanced and nurturing environment."
  },
  {
    "ShortName": "FES",
    "FullName": "Family Environment Scale (FES)",
    "Description": "Examines family interactions and dynamics, helping to create a supportive home environment that enhances therapeutic progress."
  }
];


export var LanguageLabels = [
  { "Id": 1, "OT": "Credit Balance", "TT": "", "CN": "Hero" },
  { "Id": 2, "OT": "Abilities", "TT": "", "CN": "Hero" },
  { "Id": 3, "OT": "Skills", "TT": "", "CN": "Hero" },
  { "Id": 4, "OT": "AbilityScore", "TT": "", "CN": "Dashboard" },
  { "Id": 5, "OT": "To-Do", "TT": "", "CN": "Dashboard" },
  { "Id": 6, "OT": "TherapeuticAI", "TT": "", "CN": "Dashboard" },
  { "Id": 7, "OT": "Readiness", "TT": "", "CN": "AbilityScore" },
  { "Id": 8, "OT": "Conditions", "TT": "", "CN": "AbilityScore" },
  { "Id": 9, "OT": "Behaviours", "TT": "", "CN": "AbilityScore" },
  { "Id": 10, "OT": "Speech Therapy", "TT": "", "CN": "AbilityScore" },
  { "Id": 11, "OT": "Behavioral Modification", "TT": "", "CN": "AbilityScore" },
  { "Id": 12, "OT": "Special Education", "TT": "", "CN": "AbilityScore" },
  { "Id": 13, "OT": "Occupational Therapy", "TT": "", "CN": "AbilityScore" },
  { "Id": 14, "OT": "KnowYourChild", "TT": "", "CN": "AbilityScore" },
  { "Id": 15, "OT": "Deficits", "TT": "", "CN": "TODO" },
  { "Id": 16, "OT": "Immediate", "TT": "", "CN": "TODO" },
  { "Id": 17, "OT": "Enroll", "TT": "", "CN": "TODO" },
  { "Id": 18, "OT": "Training", "TT": "", "CN": "TODO" },
  { "Id": 19, "OT": "Bookings", "TT": "", "CN": "TODO" },
  { "Id": 20, "OT": "Connect", "TT": "", "CN": "TODO" },
  { "Id": 21, "OT": "JoinCause", "TT": "", "CN": "TODO" },
  { "Id": 22, "OT": "Inclusive", "TT": "", "CN": "TODO" },
  { "Id": 23, "OT": "Fullfillment", "TT": "", "CN": "TODO" },
  { "Id": 24, "OT": "Remote", "TT": "", "CN": "TherapeuticAI" },
  { "Id": 25, "OT": "Goals", "TT": "", "CN": "TherapeuticAI" },
  { "Id": 26, "OT": "Upcoming", "TT": "", "CN": "TherapeuticAI" },
  { "Id": 27, "OT": "Today", "TT": "", "CN": "TherapeuticAI" },
  { "Id": 28, "OT": "Completed", "TT": "", "CN": "TherapeuticAI" },
  { "Id": 29, "OT": "Updates", "TT": "", "CN": "Dashboard" },
  { "Id": 30, "OT": "Assessments", "TT": "", "CN": "Dashboard" },
  { "Id": 31, "OT": "University", "TT": "", "CN": "Dashboard" },
  { "Id": 32, "OT": "More", "TT": "", "CN": "Dashboard" },
  { "Id": 33, "OT": "Account", "TT": "", "CN": "More" },
  { "Id": 34, "OT": "Patents", "TT": "", "CN": "More" },
  { "Id": 35, "OT": "Resources", "TT": "", "CN": "More" },
  { "Id": 36, "OT": "Pinnacle", "TT": "", "CN": "More" },
  { "Id": 37, "OT": "Pinnacle Platform", "TT": "", "CN": "More" },
  { "Id": 38, "OT": "Pinnacle of Bharathcare", "TT": "", "CN": "More" },
  { "Id": 39, "OT": "Speech", "TT": "", "CN": "More" },
  { "Id": 40, "OT": "Motor", "TT": "", "CN": "More" },
  { "Id": 41, "OT": "Behaviour", "TT": "", "CN": "More" },
  { "Id": 42, "OT": "Study/IQ", "TT": "", "CN": "More" },
  { "Id": 43, "OT": "Self Sufficiency", "TT": "", "CN": "More" },
  { "Id": 44, "OT": "Mainstream", "TT": "", "CN": "More" },
  { "Id": 45, "OT": "School", "TT": "", "CN": "More" },
  { "Id": 46, "OT": "Boy", "TT": "", "CN": "More" },
  { "Id": 47, "OT": "Girl", "TT": "", "CN": "More" },
  { "Id": 48, "OT": "Inclusion", "TT": "", "CN": "More" },
  { "Id": 49, "OT": "Readiness", "TT": "", "CN": "More" },
  { "Id": 50, "OT": "Index", "TT": "", "CN": "More" },
  { "Id": 51, "OT": "Prognosis", "TT": "" },
  { "Id": 52, "OT": "Diagnosis", "TT": "" },
  { "Id": 53, "OT": "Demo Vishwanath", "TT": "" }
];

export function GetUniqRecords(records, key) {
  if (!records || !key) return [];

  var arrayUniqueByKey = [...new Map(records.map(item => [item[key], item])).values()];
  return arrayUniqueByKey;
}
export function getLabel(termOT, LangLabels) {
  //console.log("GET LABEL CALLED: " + termOT);
  // console.log("LangLabels",LangLabels);

  LangLabels = LangLabels ? LangLabels : LanguageLabels;

  //console.log(LangLabels);
  const termObj = LangLabels ? (LangLabels || []).find(t => termOT && t.OT === termOT) : "";
  // Return TT if exists, otherwise OT
  return termObj ? (termObj.TT || termObj.OT) : termOT;
}

export var organTOSkillMapped = [
  {
    "OrganId": 1,
    "SkillId": 1631,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1633,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1637,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1639,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1640,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1653,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1654,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1655,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1656,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1662,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1674,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1676,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1677,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1678,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1684,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1700,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1703,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1704,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1705,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1633,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1639,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1684,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1685,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1686,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1687,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1688,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1689,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1690,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1691,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1709,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1738,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1769,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1795,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1796,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1797,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1802,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1808,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1809,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1810,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1814,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1815,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1635,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1636,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1637,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1658,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1659,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1660,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1743,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1744,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1745,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1746,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1748,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1749,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1750,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1751,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1752,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1757,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1634,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1636,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1637,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1659,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1660,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1699,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1743,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1744,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1745,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1746,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1748,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1749,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1750,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1751,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1752,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1757,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1763,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1764,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1765,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1775,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 1629,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 1630,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 1707,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2042,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2043,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2045,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2046,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2047,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2048,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2049,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2051,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2052,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2053,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2070,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2071,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2073,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2082,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2083,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1666,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1683,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1996,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1997,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1998,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1999,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 2014,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 2015,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 2016,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 2091,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1699,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1725,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1726,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1745,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1792,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1793,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1798,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 2013,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 2046,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 2064,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1629,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1630,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1707,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2042,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2043,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2045,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2046,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2047,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2048,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2049,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2051,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2052,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2053,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2070,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2071,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2073,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2082,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2083,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1663,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1664,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1665,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1666,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1682,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1697,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1715,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1716,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1732,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1637,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1640,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1653,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1654,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1655,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1656,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1662,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1663,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1664,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1665,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1666,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1633,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1639,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1684,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1690,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1709,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1769,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1795,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1796,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1797,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1802,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1808,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1809,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1810,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1824,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1825,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1990,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1666,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1683,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1685,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1686,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1687,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1688,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1689,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1690,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1691,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1814,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1996,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1997,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1998,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1674,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1734,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1817,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 2036,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 2038,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 2060,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 2080,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2098,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2099,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2100,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2101,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 1728,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 1745,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 1792,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 1793,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2098,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2099,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2100,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2101,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 1629,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 1630,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 1707,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 1729,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2042,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2043,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2045,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2046,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2047,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2048,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2049,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2051,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2052,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1697,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1819,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1986,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 2009,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1666,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1682,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1683,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1715,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1996,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1997,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1998,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1999,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 2014,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1679,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1716,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1754,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1726,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1744,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1792,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1793,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1798,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1991,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 2013,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 2062,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 2064,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 1726,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 1792,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 1793,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 1798,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 2013,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 2043,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 2064,
    "Type": "CHILD"
  },
  {
    "OrganId": 25,
    "SkillId": 1699,
    "Type": "CHILD"
  },
  {
    "OrganId": 25,
    "SkillId": 1725,
    "Type": "CHILD"
  },
  {
    "OrganId": 25,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1699,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1725,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 1728,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 1745,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 1792,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 1793,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2091,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2098,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2099,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2100,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2101,
    "Type": "CHILD"
  },
  {
    "OrganId": 28,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1682,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1715,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 2017,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 2035,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 1682,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 1715,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 2017,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 2035,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1682,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1715,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 2017,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 2035,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 33,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1754,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 2075,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 36,
    "SkillId": 1699,
    "Type": "CHILD"
  },
  {
    "OrganId": 36,
    "SkillId": 1725,
    "Type": "CHILD"
  },
  {
    "OrganId": 36,
    "SkillId": 1805,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 42,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 42,
    "SkillId": 1697,
    "Type": "CHILD"
  },
  {
    "OrganId": 42,
    "SkillId": 1811,
    "Type": "CHILD"
  },
  {
    "OrganId": 43,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 43,
    "SkillId": 1814,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1663,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1664,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1665,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1666,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1692,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1993,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1994,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1995,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2018,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2019,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2034,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2036,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2037,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2038,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2039,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 45,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 46,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 47,
    "SkillId": 1734,
    "Type": "CHILD"
  },
  {
    "OrganId": 49,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 1801,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 1803,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2098,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2099,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2100,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 2101,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1629,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1630,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1640,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1653,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1678,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1679,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1705,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1707,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1710,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1713,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1714,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1716,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1718,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1720,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1740,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1765,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1777,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1663,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1664,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1665,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1666,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1692,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1993,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1994,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1995,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 2018,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 2019,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 2034,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 2036,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 2037,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 2038,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 2039,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 1692,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 1693,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 1740,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 2054,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1631,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1674,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1676,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1677,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1679,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1703,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1716,
    "Type": "CHILD"
  },
  {
    "OrganId": 56,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 56,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 1682,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 1715,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 2017,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 2035,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 1682,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 1715,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 1747,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 2017,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 2035,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 59,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 60,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 62,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1811,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1812,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1811,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1812,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 2088,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 65,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 65,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 65,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1811,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1812,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1741,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1811,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1812,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1811,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1812,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 2088,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1704,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1720,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1722,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1740,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1821,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1822,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1989,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2008,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2022,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2023,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2024,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2088,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 2091,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1697,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1740,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1819,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1986,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 2009,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1697,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1721,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1819,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1986,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 2009,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 2091,
    "Type": "CHILD"
  },
  {
    "OrganId": 73,
    "SkillId": 1703,
    "Type": "CHILD"
  },
  {
    "OrganId": 73,
    "SkillId": 1734,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 2088,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1679,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1716,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1740,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1754,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1819,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1986,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1989,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2098,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2099,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2100,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 2101,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1679,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1716,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1740,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1754,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1819,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1986,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1989,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 2008,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1632,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1679,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1716,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1719,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1735,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1754,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1819,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1986,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1685,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1686,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1687,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1688,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1689,
    "Type": "CHILD"
  },
  {
    "OrganId": 17,
    "SkillId": 1654,
    "Type": "CHILD"
  },
  {
    "OrganId": 17,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 17,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 17,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 17,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1681,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1760,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 48,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 1740,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 2088,
    "Type": "CHILD"
  },
  {
    "OrganId": 75,
    "SkillId": 1667,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1685,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1816,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1809,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1686,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1687,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1688,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1761,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1748,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1746,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1699,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 1629,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 1630,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1745,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1699,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1798,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1772,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1991,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 2048,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1707,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 2056,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1707,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1654,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1668,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1670,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1671,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1795,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1992,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1799,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1802,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1745,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1814,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1794,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1693,
    "Type": "CHILD"
  },
  {
    "OrganId": 13,
    "SkillId": 1702,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1685,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1686,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1687,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1688,
    "Type": "CHILD"
  },
  {
    "OrganId": 15,
    "SkillId": 1689,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 16,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 17,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 17,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 1629,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 1630,
    "Type": "CHILD"
  },
  {
    "OrganId": 19,
    "SkillId": 2100,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 20,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 21,
    "SkillId": 2075,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 22,
    "SkillId": 1754,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1798,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1991,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1772,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 2043,
    "Type": "CHILD"
  },
  {
    "OrganId": 24,
    "SkillId": 1798,
    "Type": "CHILD"
  },
  {
    "OrganId": 25,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 25,
    "SkillId": 1725,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 26,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 27,
    "SkillId": 2092,
    "Type": "CHILD"
  },
  {
    "OrganId": 28,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 28,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1731,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 29,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 31,
    "SkillId": 2075,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 32,
    "SkillId": 2075,
    "Type": "CHILD"
  },
  {
    "OrganId": 33,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 33,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 33,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 34,
    "SkillId": 1754,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 35,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 36,
    "SkillId": 1762,
    "Type": "CHILD"
  },
  {
    "OrganId": 36,
    "SkillId": 1725,
    "Type": "CHILD"
  },
  {
    "OrganId": 37,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 37,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 38,
    "SkillId": 1759,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1695,
    "Type": "CHILD"
  },
  {
    "OrganId": 39,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 40,
    "SkillId": 1758,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1672,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 41,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 42,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 42,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 42,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 43,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 43,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 44,
    "SkillId": 1696,
    "Type": "CHILD"
  },
  {
    "OrganId": 45,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 45,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 46,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 46,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 47,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 47,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 48,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 48,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 49,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 49,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 50,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 51,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1669,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 52,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 53,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 2050,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 2072,
    "Type": "CHILD"
  },
  {
    "OrganId": 54,
    "SkillId": 2090,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 55,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 56,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 56,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 56,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 1730,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 57,
    "SkillId": 2075,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 58,
    "SkillId": 2075,
    "Type": "CHILD"
  },
  {
    "OrganId": 59,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 59,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 60,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 60,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 61,
    "SkillId": 2044,
    "Type": "CHILD"
  },
  {
    "OrganId": 62,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 62,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 63,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 75,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 75,
    "SkillId": 2078,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 64,
    "SkillId": 2100,
    "Type": "CHILD"
  },
  {
    "OrganId": 65,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 65,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 66,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 67,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 68,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 69,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 70,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 71,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 72,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 73,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 73,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 1675,
    "Type": "CHILD"
  },
  {
    "OrganId": 74,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 76,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 77,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1701,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 78,
    "SkillId": 1694,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1712,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1673,
    "Type": "CHILD"
  },
  {
    "OrganId": 79,
    "SkillId": 1818,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1638,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1638,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1641,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1641,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1642,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1642,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1643,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1643,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1644,
    "Type": "CHILD"
  },
  {
    "OrganId": 18,
    "SkillId": 1644,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1645,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1645,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1646,
    "Type": "CHILD"
  },
  {
    "OrganId": 23,
    "SkillId": 1646,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1647,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1648,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1648,
    "Type": "CHILD"
  },
  {
    "OrganId": 10,
    "SkillId": 1649,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1650,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1650,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1651,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1651,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1652,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 1652,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1657,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1661,
    "Type": "CHILD"
  },
  {
    "OrganId": 30,
    "SkillId": 1661,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1680,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1698,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1698,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1706,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1708,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1708,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1711,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1717,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1723,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1723,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1724,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1724,
    "Type": "CHILD"
  },
  {
    "OrganId": 6,
    "SkillId": 1727,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1733,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1736,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1737,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1737,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1739,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1742,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1753,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1753,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1755,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1755,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1766,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1766,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1767,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1768,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1770,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1771,
    "Type": "CHILD"
  },
  {
    "OrganId": 8,
    "SkillId": 1772,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1773,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1774,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1776,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1778,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1778,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1788,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1789,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1790,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1791,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1799,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1800,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1820,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1823,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 1826,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1977,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 1978,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1979,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1980,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 1981,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1982,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 1983,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 1984,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1985,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 1987,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1988,
    "Type": "CHILD"
  },
  {
    "OrganId": 12,
    "SkillId": 1992,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2000,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2000,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2001,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 2002,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2004,
    "Type": "CHILD"
  },
  {
    "OrganId": 7,
    "SkillId": 2005,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2006,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 2007,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 2010,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2011,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 2011,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2012,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2021,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2025,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 2025,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 2026,
    "Type": "CHILD"
  },
  {
    "OrganId": 14,
    "SkillId": 2026,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2027,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2028,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2029,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2030,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 2031,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 2032,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2033,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2040,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 2041,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 2056,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2057,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2058,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2059,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 2066,
    "Type": "CHILD"
  },
  {
    "OrganId": 4,
    "SkillId": 2067,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2068,
    "Type": "CHILD"
  },
  {
    "OrganId": 3,
    "SkillId": 2069,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2074,
    "Type": "CHILD"
  },
  {
    "OrganId": 11,
    "SkillId": 2076,
    "Type": "CHILD"
  },
  {
    "OrganId": 2,
    "SkillId": 2079,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 2081,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2084,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2085,
    "Type": "CHILD"
  },
  {
    "OrganId": 5,
    "SkillId": 2086,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2087,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2089,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2093,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2094,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2095,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2096,
    "Type": "CHILD"
  },
  {
    "OrganId": 9,
    "SkillId": 2097,
    "Type": "CHILD"
  },
  {
    "OrganId": 1,
    "SkillId": 1217,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1224,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1234,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1235,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1254,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1257,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1258,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1297,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1299,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1300,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1305,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1312,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1316,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1317,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1320,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1321,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1323,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1332,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1333,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1334,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1335,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1336,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1337,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1338,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1360,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1362,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1373,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1379,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1383,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1389,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1392,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1399,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1400,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1402,
    "Type": "TODDLER"
  },
  {
    "OrganId": 1,
    "SkillId": 1404,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1217,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1257,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1360,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1361,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1362,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1372,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1373,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1375,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1379,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1386,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1387,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1394,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1403,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1404,
    "Type": "TODDLER"
  },
  {
    "OrganId": 2,
    "SkillId": 1405,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1215,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1229,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1254,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1313,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1357,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1363,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1371,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 3,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1214,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1230,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1249,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1250,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1294,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1304,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1312,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1313,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1353,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1355,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1363,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1371,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 4,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1200,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1204,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1206,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1207,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1209,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1210,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1211,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1212,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1219,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1220,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1221,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1227,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1228,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1231,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1232,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1256,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1261,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1262,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1287,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1298,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1319,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1326,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1365,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1366,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1367,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1368,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 5,
    "SkillId": 1377,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1343,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1397,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1291,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1246,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1239,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1220,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1365,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1366,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1377,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 6,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1339,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1380,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1294,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1304,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1313,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1353,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1355,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1359,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 7,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1233,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1340,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1374,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1299,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1301,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1306,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1352,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1382,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1388,
    "Type": "TODDLER"
  },
  {
    "OrganId": 8,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1200,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1204,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1206,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1207,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1209,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1210,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1211,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1212,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1227,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1232,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1256,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1262,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1266,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1287,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1298,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1319,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1320,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1365,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1366,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1367,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1368,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1377,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1397,
    "Type": "TODDLER"
  },
  {
    "OrganId": 9,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1206,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1219,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1220,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1221,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1227,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1257,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1360,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1389,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1399,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1400,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1335,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1392,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1320,
    "Type": "TODDLER"
  },
  {
    "OrganId": 10,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1224,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1258,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1295,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1296,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1299,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1300,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1311,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1333,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1337,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1336,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1383,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1389,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1399,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1222,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1223,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1234,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1237,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1243,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1244,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1288,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1305,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1317,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1327,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1328,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1333,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1336,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1337,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1383,
    "Type": "TODDLER"
  },
  {
    "OrganId": 11,
    "SkillId": 1406,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1293,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1312,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1321,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1361,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1371,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1376,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1378,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1394,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1292,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1364,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1380,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1379,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1320,
    "Type": "TODDLER"
  },
  {
    "OrganId": 12,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1257,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1360,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1386,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1402,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1397,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1339,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1340,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1343,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1374,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1363,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 13,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1258,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1295,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1300,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1311,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1335,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1389,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1224,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 14,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1210,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1233,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1301,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1306,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1340,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1366,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1367,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 15,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1204,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1256,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1266,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 16,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1204,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1256,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 17,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1200,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1204,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1206,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1207,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1209,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1210,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1211,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1212,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1266,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1365,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1366,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1367,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1368,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 18,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1200,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1204,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1206,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1207,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1209,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1210,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1211,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1212,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1227,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1232,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1256,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1262,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1287,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1298,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1319,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1320,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1365,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1366,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1367,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1368,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 19,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1353,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 20,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1220,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1339,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1312,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 21,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1220,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1222,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1234,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1237,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1295,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1311,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1293,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1333,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1336,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1337,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 22,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1233,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1340,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1374,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1301,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1306,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1299,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1234,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1352,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1382,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1388,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1364,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1223,
    "Type": "TODDLER"
  },
  {
    "OrganId": 23,
    "SkillId": 1222,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1233,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1340,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1374,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1301,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1306,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1299,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1223,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1364,
    "Type": "TODDLER"
  },
  {
    "OrganId": 24,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1339,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1294,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1304,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1313,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1353,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1355,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1359,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 25,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1339,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1380,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1294,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1304,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1353,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1355,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1359,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 26,
    "SkillId": 1313,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1200,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1201,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1202,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1204,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1206,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1207,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1209,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1210,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1211,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1212,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1213,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1266,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1342,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1365,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1366,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1367,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1368,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 27,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1224,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1300,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1295,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 28,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 29,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1353,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1339,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 30,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1300,
    "Type": "TODDLER"
  },
  {
    "OrganId": 31,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 32,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 33,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1234,
    "Type": "TODDLER"
  },
  {
    "OrganId": 34,
    "SkillId": 1333,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 35,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1339,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1353,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1355,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1359,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1391,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1407,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1313,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 36,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1345,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1358,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 37,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 38,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 39,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 40,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1290,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 41,
    "SkillId": 1377,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1258,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 42,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 43,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1369,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 44,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 45,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 46,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 47,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 48,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 49,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 50,
    "SkillId": 1320,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 51,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1258,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 52,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 53,
    "SkillId": 1402,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1203,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1205,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1208,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1370,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1377,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1262,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 54,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1258,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 55,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1320,
    "Type": "TODDLER"
  },
  {
    "OrganId": 56,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1341,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1354,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1356,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1248,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1302,
    "Type": "TODDLER"
  },
  {
    "OrganId": 57,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 58,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 59,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1380,
    "Type": "TODDLER"
  },
  {
    "OrganId": 60,
    "SkillId": 1371,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 61,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1344,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 62,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 63,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 64,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 65,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 66,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 67,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 68,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 69,
    "SkillId": 1390,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 70,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 71,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 72,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 73,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1253,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 74,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1324,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 75,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 76,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 77,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1384,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1385,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 78,
    "SkillId": 1401,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1325,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1259,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1260,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1300,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1255,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1226,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1381,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1393,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1395,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1398,
    "Type": "TODDLER"
  },
  {
    "OrganId": 79,
    "SkillId": 1401,
    "Type": "TODDLER"
  }
];


export var Organs = [
  {
    "id": 1,
    "name": "Prefrontal Cortex",
    "system": "Nervous",
    "subsystem": "Frontal Lobe – Executive Function and Behavioral Control",
    "icd11_code": "XA0D0",
    "icf_structure_code": "s110",
    "icf_function_code": "b164",
    "snomeD_code": "37372002",
    "loinc_param": null,
    "growth": {
      "formation_week": 8,
      "maturation_age_years": 25,
      "critical_periods": ["0–3y", "12–18y"]
    },
    "functions": [
      "Executive planning and goal setting",
      "Impulse control and decision making",
      "Working memory and problem solving",
      "Social judgment and moral reasoning",
      "Emotional regulation and foresight"
    ],
    "developmental_domains": [
      "Cognitive Readiness",
      "Behavioral Regulation",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Verbal Reasoning", "id": 1752 },
      { "name": "Impulse Control", "id": 1768 },
      { "name": "Perspective Taking", "id": 2030 },
      { "name": "Planning & Organization", "id": 1815 },
      { "name": "Task Completion", "id": 1813 },
      { "name": "Self-Monitoring", "id": 1821 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 5,
      "behavior": 25,
      "cognitive": 40,
      "social": 15,
      "self_sufficiency": 10,
      "mainstream": 25
    },
    "connectivity": {
      "afferent_from": [
        "Amygdala",
        "Hippocampus",
        "Thalamus",
        "Posterior Parietal Cortex",
        "Basal Ganglia",
        "Cerebellum"
      ],
      "efferent_to": [
        "Primary Motor Cortex (M1)",
        "Broca’s Area",
        "Basal Ganglia",
        "Anterior Cingulate Cortex"
      ]
    },
    "measurement": {
      "preferred_modality": ["fMRI", "EEG", "fNIRS"],
      "key_parameters": [
        "BOLD activation index during executive tasks",
        "EEG theta/beta ratio (attention–control index)",
        "Functional connectivity with anterior cingulate and parietal regions"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Cognitive flexibility exercises",
        "Impulse control games",
        "Planning and reasoning tasks",
        "Working-memory training",
        "Mindfulness and self-regulation drills"
      ],
      "energy_axis": "Frontal–Executive",
      "dependencies": [
        "Cerebellum",
        "Amygdala",
        "Anterior Cingulate Cortex"
      ]
    },
    "genetic_regulators": ["DRD4", "COMT", "BDNF", "MAOA"],
    "weight": 1
  },
  {
    "id": 2,
    "name": "Dorsolateral Prefrontal Cortex",
    "system": "Nervous",
    "subsystem": "Frontal Lobe – Executive Planning and Working Memory Integration",
    "icd11_code": "XA0D1",
    "icf_structure_code": "s110",
    "icf_function_code": "b164",
    "snomeD_code": "372112007",
    "loinc_param": null,
    "growth": {
      "formation_week": 9,
      "maturation_age_years": 24,
      "critical_periods": ["2–6y", "12–18y"]
    },
    "functions": [
      "Working memory maintenance and manipulation",
      "Cognitive flexibility and mental shifting",
      "Complex decision-making and reasoning",
      "Sustained attention and problem solving",
      "Integration of sensory inputs into executive control"
    ],
    "developmental_domains": [
      "Cognitive Readiness",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Task Completion", "id": 1813 },
      { "name": "Attention Control", "id": 1801 },
      { "name": "Problem Solving", "id": 1802 },
      { "name": "Planning & Organization", "id": 1815 },
      { "name": "Cognitive Flexibility", "id": 1803 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 5,
      "behavior": 20,
      "cognitive": 45,
      "social": 10,
      "self_sufficiency": 15,
      "mainstream": 25
    },
    "connectivity": {
      "afferent_from": [
        "Thalamus",
        "Hippocampus",
        "Posterior Parietal Cortex",
        "Cerebellum"
      ],
      "efferent_to": [
        "Premotor Cortex",
        "Anterior Cingulate Cortex",
        "Basal Ganglia",
        "Broca’s Area"
      ]
    },
    "measurement": {
      "preferred_modality": ["fMRI", "EEG", "TMS–EEG Connectivity"],
      "key_parameters": [
        "Fronto-parietal network activation strength",
        "Working-memory task BOLD amplitude",
        "Frontal midline theta coherence"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Working memory and cognitive shifting tasks",
        "Problem-solving and reasoning drills",
        "Attention control training",
        "Planning and executive games"
      ],
      "energy_axis": "Frontal–Executive",
      "dependencies": [
        "Prefrontal Cortex",
        "Cerebellum",
        "Basal Ganglia",
        "Thalamus"
      ]
    },
    "genetic_regulators": ["COMT", "DRD2", "BDNF", "HTR2A"],
    "weight": 2
  },
  {
    "id": 3,
    "name": "Broca’s Area (Inferior Frontal Gyrus)",
    "system": "Nervous",
    "subsystem": "Frontal Lobe – Speech Production and Language Expression",
    "icd11_code": "XA0E1",
    "icf_structure_code": "s110",
    "icf_function_code": "b320",
    "snomeD_code": "372126007",
    "loinc_param": null,
    "growth": {
      "formation_week": 10,
      "maturation_age_years": 20,
      "critical_periods": ["0–5y", "11–15y"]
    },
    "functions": [
      "Speech articulation and motor planning for phonation",
      "Syntactic and grammatical language structuring",
      "Verbal fluency and expressive communication",
      "Integration of auditory feedback during speech",
      "Coordination of oral and facial muscle movements for articulation"
    ],
    "developmental_domains": [
      "Language Expression",
      "Language Expression",
      "Language Expression"
    ],
    "abilities_linked": [
      { "name": "Expressive Language", "id": 1635 },
      { "name": "Sentence Formation", "id": 1661 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Pronunciation Skills", "id": 1759 },
      { "name": "Verbal Reasoning", "id": 1752 }
    ],
    "readiness_contribution": {
      "speech": 50,
      "motor": 10,
      "behavior": 5,
      "cognitive": 15,
      "social": 10,
      "self_sufficiency": 5,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Wernicke’s Area (Language Comprehension)",
        "Auditory Cortex",
        "Prefrontal Cortex",
        "Basal Ganglia"
      ],
      "efferent_to": [
        "Primary Motor Cortex (Speech Musculature Control)",
        "Cerebellum (Timing and Coordination)",
        "Larynx / Voice Box",
        "Facial and Hypoglossal Nerves"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "fMRI (Language Activation Mapping)",
        "DTI (Arcuate Fasciculus Integrity)",
        "EEG (Event-Related Potentials)"
      ],
      "key_parameters": [
        "BOLD activation during speech tasks",
        "N400 / P600 latency in verbal processing",
        "Functional coupling with Wernicke’s Area"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Speech articulation drills and phonemic awareness tasks",
        "Sentence construction and repetition therapy",
        "Expressive language expansion exercises",
        "Fluency and pacing regulation for stuttering control"
      ],
      "energy_axis": "Frontal–Phonatory",
      "dependencies": [
        "Wernicke’s Area",
        "Larynx / Voice Box",
        "Facial Nerve (CN VII)",
        "Primary Motor Cortex (M1)"
      ]
    },
    "genetic_regulators": ["FOXP2", "CNTNAP2", "SRPX2", "ATP2C2"],
    "weight": 3
  },
  {
    "id": 4,
    "name": "Wernickes Area (Posterior STG)",
    "system": "Nervous",
    "subsystem": "Temporal Lobe – Language Comprehension and Semantic Processing",
    "icd11_code": "XA0E2",
    "icf_structure_code": "s110",
    "icf_function_code": "b310",
    "snomeD_code": "372129000",
    "loinc_param": null,
    "growth": {
      "formation_week": 12,
      "maturation_age_years": 18,
      "critical_periods": ["0–6y", "10–14y"]
    },
    "functions": [
      "Comprehension and interpretation of spoken language",
      "Processing of auditory information and word meaning",
      "Phonological decoding and lexical access",
      "Integration of semantic and grammatical understanding",
      "Auditory–visual mapping for reading and listening comprehension"
    ],
    "developmental_domains": [
      "Language Expression",
      "Language Expression",
      "Language Expression"
    ],
    "abilities_linked": [
      { "name": "Receptive Language", "id": 1660 },
      { "name": "Receptive Vocabulary", "id": 1747 },
      { "name": "Listening Skills", "id": 1699 },
      { "name": "Question Comprehension", "id": 1746 },
      { "name": "Topic Maintenance", "id": 1982 }
    ],
    "readiness_contribution": {
      "speech": 45,
      "motor": 5,
      "behavior": 5,
      "cognitive": 20,
      "social": 10,
      "self_sufficiency": 5,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Primary Auditory Cortex",
        "Thalamus (Medial Geniculate Nucleus)",
        "Hippocampus (Contextual Memory)",
        "Visual Association Cortex (for Reading Integration)"
      ],
      "efferent_to": [
        "Broca’s Area (Speech Production Link)",
        "Angular Gyrus (Semantic Association)",
        "Prefrontal Cortex (Language Planning)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "fMRI (Language Comprehension Tasks)",
        "EEG / MEG (Auditory Evoked Potentials)",
        "DTI (Arcuate Fasciculus Mapping)"
      ],
      "key_parameters": [
        "N400 response latency (semantic processing)",
        "Functional connectivity with Broca’s and Auditory Cortex",
        "Activation amplitude during comprehension tasks"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Auditory comprehension drills",
        "Receptive vocabulary enrichment activities",
        "Listening and following-instruction games",
        "Reading and auditory processing integration therapy"
      ],
      "energy_axis": "Temporal–Auditory",
      "dependencies": [
        "Broca’s Area",
        "Auditory Cortex",
        "Angular Gyrus",
        "Hippocampus"
      ]
    },
    "genetic_regulators": ["FOXP2", "ATP2C2", "KIAA0319", "DCDC2"],
    "weight": 4
  },
  {
    "id": 5,
    "name": "Primary Motor Cortex (M1)",
    "system": "Nervous",
    "subsystem": "Frontal Lobe – Voluntary Motor Control",
    "icd11_code": "XA0E4",
    "icf_structure_code": "s110",
    "icf_function_code": "b760",
    "snomeD_code": "372124009",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 18,
      "critical_periods": ["0–2y", "5–12y"]
    },
    "functions": [
      "Initiation and coordination of voluntary muscle movement",
      "Control of fine and gross motor skills",
      "Integration of motor commands from premotor and sensory cortices",
      "Execution of speech, hand, and limb motor patterns",
      "Adaptation and refinement of movement through feedback"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Language Expression",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Gross Motor Coordination", "id": 1804 },
      { "name": "Fine Motor Skills", "id": 1805 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Task Execution", "id": 1814 },
      { "name": "Hand-Eye Coordination", "id": 1806 }
    ],
    "readiness_contribution": {
      "speech": 20,
      "motor": 45,
      "behavior": 5,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 15,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Premotor Cortex",
        "Primary Somatosensory Cortex (S1)",
        "Basal Ganglia",
        "Cerebellum"
      ],
      "efferent_to": [
        "Spinal Cord (Corticospinal Tract)",
        "Facial Nerve (CN VII)",
        "Cranial and Peripheral Motor Neurons",
        "Cerebellum (Feedback Loop)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Functional MRI (Motor Task Mapping)",
        "Transcranial Magnetic Stimulation (TMS)",
        "Electromyography (EMG)"
      ],
      "key_parameters": [
        "Motor evoked potential latency and amplitude",
        "Cortical activation symmetry",
        "Motor threshold and reaction time"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Fine and gross motor coordination drills",
        "Handwriting and grasp-strength activities",
        "Speech and oral-motor integration exercises",
        "Proprioceptive and balance training"
      ],
      "energy_axis": "Motor–Execution",
      "dependencies": [
        "Cerebellum",
        "Basal Ganglia",
        "Somatosensory Cortex (S1)",
        "Spinal Cord"
      ]
    },
    "genetic_regulators": ["DYNC1H1", "TUBA1A", "CNTNAP1", "CACNA1A"],
    "weight": 5
  },
  {
    "id": 6,
    "name": "Primary Somatosensory Cortex (S1)",
    "system": "Nervous",
    "subsystem": "Parietal Lobe – Sensory Perception and Body Awareness",
    "icd11_code": "XA0E5",
    "icf_structure_code": "s110",
    "icf_function_code": "b260",
    "snomeD_code": "372125005",
    "loinc_param": null,
    "growth": {
      "formation_week": 8,
      "maturation_age_years": 18,
      "critical_periods": ["0–3y", "6–12y"]
    },
    "functions": [
      "Processing of tactile, proprioceptive, and kinesthetic input",
      "Integration of sensory information from skin, muscles, and joints",
      "Localization and discrimination of touch, pain, and temperature",
      "Support for fine motor precision through sensory feedback",
      "Contribution to spatial awareness and body mapping"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Motor Coordination",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Touch Discrimination", "id": 1990 },
      { "name": "Body Awareness & Spatial Orientation", "id": 1807 },
      { "name": "Sensory Processing", "id": 2078 },
      { "name": "Fine Motor Skills", "id": 1805 },
      { "name": "Reflex Integration", "id": 1998 }
    ],
    "readiness_contribution": {
      "speech": 10,
      "motor": 35,
      "behavior": 5,
      "cognitive": 15,
      "social": 5,
      "self_sufficiency": 20,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Thalamus (Ventral Posterior Nucleus)",
        "Spinal Cord (Dorsal Column Pathways)",
        "Peripheral Sensory Receptors (Skin, Muscles, Joints)"
      ],
      "efferent_to": [
        "Primary Motor Cortex (M1)",
        "Posterior Parietal Cortex",
        "Cerebellum",
        "Basal Ganglia"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "fMRI (Tactile Stimulation)",
        "Somatosensory Evoked Potentials (SEP)",
        "EEG (Cortical Response Mapping)"
      ],
      "key_parameters": [
        "Latency and amplitude of sensory evoked responses",
        "Somatotopic representation clarity",
        "Interhemispheric sensory synchronization"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Sensory integration activities (textures, temperatures, vibrations)",
        "Proprioceptive and balance-based exercises",
        "Fine motor coordination and handwriting training",
        "Tactile discrimination and feedback enhancement"
      ],
      "energy_axis": "Parietal–Sensory",
      "dependencies": [
        "Primary Motor Cortex (M1)",
        "Thalamus",
        "Cerebellum",
        "Spinal Cord"
      ]
    },
    "genetic_regulators": ["SCN9A", "PIEZO2", "GRIN2B", "CACNA1A"],
    "weight": 6
  },
  {
    "id": 7,
    "name": "Primary Auditory Cortex",
    "system": "Nervous",
    "subsystem": "Temporal Lobe – Auditory Signal Processing and Speech Perception",
    "icd11_code": "XA0E6",
    "icf_structure_code": "s110",
    "icf_function_code": "b230",
    "snomeD_code": "372127003",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 16,
      "critical_periods": ["0–5y", "11–14y"]
    },
    "functions": [
      "Detection and decoding of sound frequency and intensity",
      "Discrimination of speech and environmental sounds",
      "Processing of pitch, tone, and temporal rhythm",
      "Integration of auditory input with memory and language centers",
      "Contribution to phonological awareness and receptive language"
    ],
    "developmental_domains": [
      "Language Expression",
      "Language Expression",
      "Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Listening Skills", "id": 1699 },
      { "name": "Sound Discrimination", "id": 2061 },
      { "name": "Speech Perception", "id": 1757 },
      { "name": "Auditory Processing & Discrimination", "id": 2078 },
      { "name": "Phonological Awareness", "id": 2062 }
    ],
    "readiness_contribution": {
      "speech": 50,
      "motor": 5,
      "behavior": 5,
      "cognitive": 15,
      "social": 10,
      "self_sufficiency": 5,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Cochlea (via Auditory Nerve CN VIII)",
        "Medial Geniculate Body (Thalamus)",
        "Inferior Colliculus"
      ],
      "efferent_to": [
        "Wernicke’s Area (Language Comprehension)",
        "Broca’s Area (Speech Coordination)",
        "Prefrontal Cortex (Attention Modulation)",
        "Amygdala (Emotional Sound Processing)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Auditory Brainstem Response (ABR)",
        "fMRI (Sound Discrimination Tasks)",
        "EEG (Auditory Evoked Potentials)",
        "MEG (Auditory Localization)"
      ],
      "key_parameters": [
        "N1–P2 auditory response amplitude",
        "Mismatch negativity (MMN) latency",
        "BOLD activation during phonemic tasks"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Auditory discrimination and listening exercises",
        "Speech sound and rhythm imitation tasks",
        "Music-based auditory training",
        "Sound localization and sequencing games"
      ],
      "energy_axis": "Temporal–Auditory",
      "dependencies": [
        "Cochlea",
        "Wernicke’s Area",
        "Broca’s Area",
        "Prefrontal Cortex"
      ]
    },
    "genetic_regulators": ["OTOF", "KCNQ4", "POU4F3", "FOXP2"],
    "weight": 7
  },
  {
    "id": 8,
    "name": "Primary Visual Cortex (V1)",
    "system": "Nervous",
    "subsystem": "Occipital Lobe – Visual Processing and Spatial Perception",
    "icd11_code": "XA0E7",
    "icf_structure_code": "s110",
    "icf_function_code": "b210",
    "snomeD_code": "372128008",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 15,
      "critical_periods": ["0–3y", "8–12y"]
    },
    "functions": [
      "Initial reception and processing of visual stimuli",
      "Detection of color, contrast, and shape",
      "Spatial mapping and motion tracking",
      "Visual recognition and coordination with eye movements",
      "Integration with other sensory inputs for perceptual awareness"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Cognitive Readiness",
      "Motor Coordination"
    ],
    "abilities_linked": [
      { "name": "Visual Tracking", "id": 2077 },
      { "name": "Object Recognition", "id": 2049 },
      { "name": "Visual-Spatial Reasoning", "id": 1808 },
      { "name": "Reading Readiness", "id": 2048 },
      { "name": "Attention Control", "id": 1801 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 15,
      "behavior": 5,
      "cognitive": 35,
      "social": 10,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Retina (via Optic Nerve and Optic Tract)",
        "Lateral Geniculate Nucleus (Thalamus)"
      ],
      "efferent_to": [
        "Visual Association Areas (V2–V5)",
        "Parietal Cortex (Dorsal Stream – Spatial Mapping)",
        "Temporal Cortex (Ventral Stream – Object Identification)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Visual Evoked Potentials (VEP)",
        "fMRI (Visual Stimulus Mapping)",
        "OCT (Retinocortical Integrity)"
      ],
      "key_parameters": [
        "P100 latency and amplitude",
        "Cortical activation symmetry under visual tasks",
        "Contrast sensitivity function and field mapping"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Visual scanning and tracking exercises",
        "Shape and color discrimination tasks",
        "Eye-hand coordination activities",
        "Visual-motor integration games"
      ],
      "energy_axis": "Occipital–Visual",
      "dependencies": [
        "Retina",
        "Thalamus (LGN)",
        "Parietal Cortex",
        "Temporal Cortex"
      ]
    },
    "genetic_regulators": ["PAX6", "NR2F1", "OPA1", "CRX"],
    "weight": 8
  },
  {
    "id": 9,
    "name": "Cerebellum",
    "system": "Nervous",
    "subsystem": "Cerebellar System – Coordination and Balance Control",
    "icd11_code": "XA0F0",
    "icf_structure_code": "s120",
    "icf_function_code": "b765",
    "snomeD_code": "372120006",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 20,
      "critical_periods": ["0–6y", "10–18y"]
    },
    "functions": [
      "Coordination of voluntary movements and postural control",
      "Fine-tuning of motor activity and timing",
      "Maintenance of balance and equilibrium",
      "Integration of sensory input for motor adaptation",
      "Support for cognitive, language, and emotional regulation"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Behavioral Regulation",
      "Cognitive Readiness"
    ],
    "abilities_linked": [
      { "name": "Balance Control", "id": 1996 },
      { "name": "Hand-Eye Coordination", "id": 1806 },
      { "name": "Motor Sequencing", "id": 1809 },
      { "name": "Fine Motor Skills", "id": 1805 },
      { "name": "Emotional Regulation", "id": 1754 }
    ],
    "readiness_contribution": {
      "speech": 10,
      "motor": 50,
      "behavior": 10,
      "cognitive": 15,
      "social": 5,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Spinal Cord (Proprioceptive Pathways)",
        "Vestibular Nuclei (Balance Input)",
        "Primary Motor Cortex (Movement Plan)",
        "Sensory Cortex (Feedback Integration)"
      ],
      "efferent_to": [
        "Motor Cortex (via Thalamus)",
        "Brainstem (Motor Coordination)",
        "Basal Ganglia (Motor Refinement)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "MRI (Structural and Volumetric Analysis)",
        "Balance Platform or Posturography",
        "Functional Near-Infrared Spectroscopy (fNIRS)"
      ],
      "key_parameters": [
        "Cerebellar volume and symmetry",
        "Postural sway index and stability ratio",
        "Coordination precision and timing variability"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Balance and coordination training",
        "Rhythmic movement therapy",
        "Fine motor sequencing and handwriting tasks",
        "Cognitive-motor integration exercises"
      ],
      "energy_axis": "Cerebellar–Motor",
      "dependencies": [
        "Motor Cortex",
        "Vestibular Apparatus",
        "Spinal Cord",
        "Basal Ganglia"
      ]
    },
    "genetic_regulators": ["CACNA1A", "ATXN1", "ITPR1", "GRID2"],
    "weight": 9
  },
  {
    "id": 10,
    "name": "Basal Ganglia",
    "system": "Nervous",
    "subsystem": "Subcortical Nuclei – Movement Regulation and Habit Formation",
    "icd11_code": "XA0F1",
    "icf_structure_code": "s110",
    "icf_function_code": "b765",
    "snomeD_code": "372119005",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 22,
      "critical_periods": ["0–3y", "10–20y"]
    },
    "functions": [
      "Regulation of voluntary motor control and initiation of movement",
      "Inhibition of involuntary or excess motion",
      "Procedural and habit learning through repetition and reward",
      "Cognitive–motor integration for adaptive behavior",
      "Coordination between motivation and motor execution"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Behavioral Regulation",
      "Cognitive Readiness"
    ],
    "abilities_linked": [
      { "name": "Impulse Control", "id": 1768 },
      { "name": "Motor Planning & Sequencing", "id": 1809 },
      { "name": "Behavioral Regulation", "id": 1720 },
      { "name": "Task Sequencing", "id": 1816 },
      { "name": "Frustration Tolerance", "id": 1670 }
    ],
    "readiness_contribution": {
      "speech": 10,
      "motor": 40,
      "behavior": 20,
      "cognitive": 15,
      "social": 5,
      "self_sufficiency": 10,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Prefrontal Cortex (Decision Planning)",
        "Primary Motor Cortex (Motor Commands)",
        "Thalamus (Feedback Loop)",
        "Substantia Nigra (Dopaminergic Input)"
      ],
      "efferent_to": [
        "Thalamus (Motor Relay)",
        "Motor Cortex (Action Execution)",
        "Brainstem (Postural and Reflex Pathways)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "fMRI (Motor Activation Mapping)",
        "DTI (Subcortical Connectivity)",
        "PET (Dopamine Receptor Activity)"
      ],
      "key_parameters": [
        "Resting-state connectivity with motor cortex",
        "Dopaminergic activity and receptor density",
        "Reaction time variability and task inhibition latency"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Motor sequencing and rhythm exercises",
        "Impulse control and inhibition games",
        "Habit learning through structured routines",
        "Cognitive-behavioral motor integration tasks"
      ],
      "energy_axis": "Subcortical–Motor",
      "dependencies": [
        "Cerebellum",
        "Motor Cortex",
        "Prefrontal Cortex",
        "Thalamus"
      ]
    },
    "genetic_regulators": ["DRD1", "DRD2", "TH", "SLC6A3"],
    "weight": 10
  },
  {
    "id": 11,
    "name": "Amygdala",
    "system": "Nervous",
    "subsystem": "Limbic System – Emotional Regulation and Social Behavior",
    "icd11_code": "XA0F2",
    "icf_structure_code": "s110",
    "icf_function_code": "b152",
    "snomeD_code": "372117007",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 25,
      "critical_periods": ["0–5y", "12–18y"]
    },
    "functions": [
      "Recognition and regulation of emotional responses",
      "Processing of fear, threat, and reward cues",
      "Social–emotional learning and empathy development",
      "Modulation of memory with emotional significance",
      "Activation of autonomic responses during stress"
    ],
    "developmental_domains": [

      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Emotional Expression", "id": 1754 },
      { "name": "Empathy & Emotional Reciprocity", "id": 2068 },
      { "name": "Social Responsiveness", "id": 1766 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Perspective Taking", "id": 2030 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 5,
      "behavior": 35,
      "cognitive": 10,
      "social": 30,
      "self_sufficiency": 10,
      "mainstream": 25
    },
    "connectivity": {
      "afferent_from": [
        "Thalamus (Sensory Relay)",
        "Prefrontal Cortex (Regulation Input)",
        "Hippocampus (Memory Context)",
        "Sensory Association Areas (Visual and Auditory Emotional Cues)"
      ],
      "efferent_to": [
        "Hypothalamus (Autonomic and Endocrine Response)",
        "Prefrontal Cortex (Emotion Regulation and Judgment)",
        "Hippocampus (Emotional Memory Consolidation)",
        "Brainstem (Fight-or-Flight Activation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "fMRI (Emotional Stimulus Response)",
        "DTI (Amygdala–Prefrontal Connectivity)",
        "Galvanic Skin Response (GSR)",
        "Heart Rate Variability (HRV)"
      ],
      "key_parameters": [
        "Amygdala reactivity to facial emotions",
        "Functional connectivity with prefrontal cortex",
        "Autonomic arousal (HRV and GSR patterns)"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Emotion recognition and labeling exercises",
        "Social–emotional role-play therapy",
        "Mindfulness and relaxation training",
        "Cognitive-behavioral therapy for anxiety control"
      ],
      "energy_axis": "Limbic–Emotional",
      "dependencies": [
        "Prefrontal Cortex",
        "Hippocampus",
        "Hypothalamus",
        "Thalamus"
      ]
    },
    "genetic_regulators": ["SLC6A4", "OXTR", "BDNF", "MAOA"],
    "weight": 11
  },
  {
    "id": 12,
    "name": "Hippocampus",
    "system": "Nervous",
    "subsystem": "Limbic System – Learning, Memory, and Spatial Navigation",
    "icd11_code": "XA0F3",
    "icf_structure_code": "s110",
    "icf_function_code": "b144",
    "snomeD_code": "372118002",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 22,
      "critical_periods": ["0–6y", "10–16y"]
    },
    "functions": [
      "Formation and consolidation of short-term and long-term memory",
      "Spatial navigation and environmental mapping",
      "Learning of contextual and sequential information",
      "Integration of emotional and sensory inputs for memory encoding",
      "Stress adaptation and cognitive flexibility"
    ],
    "developmental_domains": [
      "Cognitive Readiness",
      "Cognitive Readiness",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Short-Term Memory", "id": 1809 },
      { "name": "Long-Term Memory", "id": 1810 },
      { "name": "Task Learning", "id": 1811 },
      { "name": "Problem Solving", "id": 1802 },
      { "name": "Spatial Orientation", "id": 2063 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 40,
      "social": 10,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Entorhinal Cortex (Sensory Input Gateway)",
        "Amygdala (Emotional Context)",
        "Thalamus (Sensory Relay)",
        "Neocortex (Cognitive Integration)"
      ],
      "efferent_to": [
        "Prefrontal Cortex (Executive Memory Retrieval)",
        "Amygdala (Emotional Memory Association)",
        "Hypothalamus (Stress and Hormonal Regulation)",
        "Cingulate Cortex (Learning and Attention Feedback)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "MRI (Hippocampal Volume)",
        "fMRI (Memory Encoding Tasks)",
        "EEG (Theta Activity During Learning)"
      ],
      "key_parameters": [
        "Hippocampal volume symmetry",
        "Activation strength during memory tasks",
        "Theta-gamma coupling during encoding and retrieval"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Memory recall and sequencing exercises",
        "Spatial navigation games and maze-solving",
        "Stress reduction and resilience training",
        "Learning through storytelling and contextual play"
      ],
      "energy_axis": "Limbic–Cognitive",
      "dependencies": [
        "Amygdala",
        "Prefrontal Cortex",
        "Thalamus",
        "Cerebellum"
      ]
    },
    "genetic_regulators": ["BDNF", "NR3C1", "APOE", "COMT"],
    "weight": 12
  },
  {
    "id": 13,
    "name": "Thalamus",
    "system": "Nervous",
    "subsystem": "Diencephalon – Central Sensory Relay and Integration Hub",
    "icd11_code": "XA0F4",
    "icf_structure_code": "s110",
    "icf_function_code": "b156",
    "snomeD_code": "372122003",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 18,
      "critical_periods": ["0–3y", "8–14y"]
    },
    "functions": [
      "Relay and processing center for sensory and motor information to the cortex",
      "Regulation of attention, arousal, and consciousness",
      "Coordination of sensory-motor integration and feedback loops",
      "Filtering and prioritizing sensory input to maintain focus",
      "Synchronization of cortical activity for learning and awareness"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Cognitive Readiness",
      "Motor Coordination"
    ],
    "abilities_linked": [
      { "name": "Sensory Processing", "id": 2078 },
      { "name": "Attention Control", "id": 1801 },
      { "name": "Visual-Motor Integration", "id": 2065 },
      { "name": "Task Focus", "id": 1812 },
      { "name": "Arousal Regulation", "id": 2052 }
    ],
    "readiness_contribution": {
      "speech": 10,
      "motor": 20,
      "behavior": 10,
      "cognitive": 25,
      "social": 5,
      "self_sufficiency": 10,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Spinal Cord (Sensory Pathways)",
        "Brainstem (Reticular Formation)",
        "Basal Ganglia (Motor Input)",
        "Cerebellum (Movement Coordination)"
      ],
      "efferent_to": [
        "Primary Sensory Cortex (S1)",
        "Primary Motor Cortex (M1)",
        "Prefrontal Cortex",
        "Amygdala (Emotional Relay)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "fMRI (Sensory Integration Tasks)",
        "EEG (Thalamocortical Oscillation Mapping)",
        "DTI (Thalamocortical Pathways)"
      ],
      "key_parameters": [
        "Thalamocortical synchronization index",
        "Sensory transmission latency",
        "Resting-state connectivity strength"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Sensory integration and attention modulation tasks",
        "Visual and auditory discrimination games",
        "Cognitive regulation and focus training",
        "Mindfulness and body-awareness practices"
      ],
      "energy_axis": "Thalamic–Sensory",
      "dependencies": [
        "Sensory Cortex (S1)",
        "Prefrontal Cortex",
        "Motor Cortex (M1)",
        "Cerebellum"
      ]
    },
    "genetic_regulators": ["GRIN2B", "CACNA1A", "SLC17A7", "GAD1"],
    "weight": 13
  },
  {
    "id": 14,
    "name": "Hypothalamus",
    "system": "Nervous/Endocrine",
    "subsystem": "Diencephalon – Autonomic, Hormonal, and Homeostatic Regulation",
    "icd11_code": "XA0F5",
    "icf_structure_code": "s110",
    "icf_function_code": "b555",
    "snomeD_code": "372123008",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 16,
      "critical_periods": ["0–3y", "8–14y"]
    },
    "functions": [
      "Regulation of autonomic functions including hunger, thirst, and temperature",
      "Control of endocrine secretions through pituitary communication",
      "Integration of emotional and physiological responses to stress",
      "Regulation of circadian rhythms and sleep–wake cycles",
      "Coordination of growth, metabolism, and reproductive hormone release"
    ],
    "developmental_domains": [
      "Behavioral Regulation",
      "Self-Sufficiency",
      "Health Readiness and Endocrine Regulation"
    ],
    "abilities_linked": [
      { "name": "Sleep Regulation", "id": 1700 },
      { "name": "Appetite Control", "id": 2049 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 30,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Amygdala (Emotional Signals)",
        "Hippocampus (Memory Context)",
        "Thalamus (Sensory Integration)",
        "Brainstem (Autonomic Input)"
      ],
      "efferent_to": [
        "Pituitary Gland (Hormonal Regulation)",
        "Autonomic Nervous System (Sympathetic and Parasympathetic Pathways)",
        "Amygdala (Stress Feedback)",
        "Prefrontal Cortex (Behavioral Modulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "MRI (Structural and Functional Mapping)",
        "Hormonal Profile (Cortisol, ACTH, TSH)",
        "Polysomnography (Sleep Regulation)"
      ],
      "key_parameters": [
        "Cortisol circadian rhythm",
        "Body temperature regulation index",
        "Sleep efficiency and melatonin rhythm"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Relaxation and mindfulness training",
        "Sleep hygiene and circadian rhythm optimization",
        "Stress and emotion regulation therapy",
        "Nutritional and hydration management for metabolic stability"
      ],
      "energy_axis": "Hypothalamic–Autonomic",
      "dependencies": [
        "Pituitary Gland",
        "Amygdala",
        "Brainstem",
        "Adrenal Glands"
      ]
    },
    "genetic_regulators": ["CRH", "AVP", "OXTR", "NPY"],
    "weight": 14
  },
  {
    "id": 15,
    "name": "Midbrain",
    "system": "Nervous",
    "subsystem": "Brainstem – Mesencephalon, Visual and Auditory Reflex Center",
    "icd11_code": "XA0G0",
    "icf_structure_code": "s110",
    "icf_function_code": "b760",
    "snomeD_code": "372114009",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 16,
      "critical_periods": ["0–2y", "8–12y"]
    },
    "functions": [
      "Coordination of visual and auditory reflexes (orienting responses)",
      "Control of eye movements through oculomotor and trochlear nuclei",
      "Regulation of motor tone via dopaminergic pathways (substantia nigra)",
      "Pain inhibition and defensive reflex control via periaqueductal gray",
      "Maintenance of alertness and arousal through reticular activation"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Sensory Integration",
      "Attention Regulation and Attention Regulation"
    ],
    "abilities_linked": [
      { "name": "Eye Movement Coordination", "id": 2059 },
      { "name": "Startle Reflex Modulation", "id": 1998 },
      { "name": "Alertness Maintenance", "id": 2053 },
      { "name": "Auditory–Visual Integration", "id": 2065 },
      { "name": "Motor Inhibition", "id": 1768 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 25,
      "behavior": 10,
      "cognitive": 15,
      "social": 5,
      "self_sufficiency": 10,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Visual Cortex (V1)",
        "Inferior Colliculus (Auditory Pathway)",
        "Basal Ganglia (Motor Input)",
        "Cerebellum (Coordination Feedback)"
      ],
      "efferent_to": [
        "Pons (Descending Motor Integration)",
        "Thalamus (Sensory Relay)",
        "Spinal Cord (Reticulospinal Tract)",
        "Oculomotor Nuclei (CN III, CN IV)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Eye-Tracking (Reflex Response)",
        "Brainstem Auditory Evoked Response (BAER)",
        "MRI (Midbrain Structural Assessment)"
      ],
      "key_parameters": [
        "Reflex latency and orientation accuracy",
        "Dopaminergic signal intensity (substantia nigra)",
        "Pupil and saccadic movement synchronization"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Eye-tracking and visual scanning exercises",
        "Auditory–visual reflex training",
        "Balance and movement coordination games",
        "Reflex inhibition and postural alignment therapy"
      ],
      "energy_axis": "Midbrain–Reflexive",
      "dependencies": [
        "Cerebellum",
        "Visual Cortex",
        "Pons",
        "Basal Ganglia"
      ]
    },
    "genetic_regulators": ["PARK2", "LRRK2", "SNCA", "TH"],
    "weight": 15
  },
  {
    "id": 16,
    "name": "Pons",
    "system": "Nervous",
    "subsystem": "Brainstem – Pontine Region, Communication and Respiratory Regulation",
    "icd11_code": "XA0G1",
    "icf_structure_code": "s110",
    "icf_function_code": "b440",
    "snomeD_code": "372115005",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 15,
      "critical_periods": ["0–3y", "7–12y"]
    },
    "functions": [
      "Bridge between cerebrum and cerebellum for motor coordination",
      "Regulation of respiration rhythm and depth",
      "Control of sleep and dreaming cycles (REM initiation)",
      "Integration of facial and eye movements",
      "Coordination of swallowing, posture, and balance"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Language Expression",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Facial Coordination", "id": 2055 },
      { "name": "Eye Movement Control", "id": 2059 },
      { "name": "Balance Control", "id": 1996 },
      { "name": "Sleep Regulation", "id": 1700 }
    ],
    "readiness_contribution": {
      "speech": 15,
      "motor": 30,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 15,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Cerebral Cortex (Motor Input)",
        "Cerebellum (Coordination Feedback)",
        "Medulla Oblongata (Autonomic Input)",
        "Vestibular Nuclei (Balance Signals)"
      ],
      "efferent_to": [
        "Cerebellum (via Middle Cerebellar Peduncles)",
        "Facial Nerve (CN VII)",
        "Trigeminal Nerve (CN V)",
        "Respiratory Centers in Medulla"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "MRI (Brainstem Mapping)",
        "Polysomnography (Sleep Study)",
        "Respiratory Function Testing"
      ],
      "key_parameters": [
        "Pontine activation during REM sleep",
        "Respiratory rhythm stability index",
        "Facial and oculomotor coordination rate"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Breathing rhythm and control exercises",
        "Facial movement coordination drills",
        "Balance and postural control training",
        "Sleep hygiene and relaxation techniques"
      ],
      "energy_axis": "Pontine–Respiratory",
      "dependencies": [
        "Medulla Oblongata",
        "Cerebellum",
        "Facial Nerve (CN VII)",
        "Trigeminal Nerve (CN V)"
      ]
    },
    "genetic_regulators": ["PHOX2B", "ASCL1", "SLC6A4", "BDNF"],
    "weight": 16
  },
  {
    "id": 17,
    "name": "Medulla Oblongata",
    "system": "Nervous",
    "subsystem": "Brainstem – Autonomic Regulation and Vital Reflex Control",
    "icd11_code": "XA0G2",
    "icf_structure_code": "s110",
    "icf_function_code": "b435",
    "snomeD_code": "372116006",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0–3y"]
    },
    "functions": [
      "Regulation of vital autonomic functions such as heart rate, breathing, and digestion",
      "Coordination of swallowing, gag, cough, and sneeze reflexes",
      "Maintenance of blood pressure and respiratory rhythm",
      "Relay of motor and sensory signals between brain and spinal cord",
      "Integration of protective and survival reflexes"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Language Expression",
      "Autonomic Coordination"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Swallowing Control", "id": 2046 },
      { "name": "Heart Rate Regulation", "id": 2048 },
      { "name": "Postural Stability", "id": 1702 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 15,
      "motor": 25,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 10
    },
    "connectivity": {
      "afferent_from": [
        "Spinal Cord (Sensory and Motor Pathways)",
        "Vagus Nerve (CN X)",
        "Glossopharyngeal Nerve (CN IX)",
        "Pons and Cerebellum"
      ],
      "efferent_to": [
        "Heart (Cardiac Centers)",
        "Lungs (Respiratory Centers)",
        "Digestive Tract (Autonomic Control)",
        "Spinal Cord (Motor Reflex Pathways)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "MRI (Brainstem Visualization)",
        "EEG (Autonomic Pattern Detection)",
        "Respiratory and Cardiovascular Monitoring"
      ],
      "key_parameters": [
        "Autonomic tone and heart rate variability",
        "Respiratory cycle synchronization",
        "Reflex latency for gag and swallow responses"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Breathing pattern training and regulation",
        "Feeding and swallowing therapy",
        "Autonomic calming and HRV biofeedback",
        "Reflex integration and postural control activities"
      ],
      "energy_axis": "Medullary–Autonomic",
      "dependencies": [
        "Pons",
        "Vagus Nerve (CN X)",
        "Diaphragm",
        "Spinal Cord"
      ]
    },
    "genetic_regulators": ["PHOX2B", "RET", "GATA2", "DBH"],
    "weight": 17
  },
  {
    "id": 18,
    "name": "Vestibular Nuclei",
    "system": "Nervous",
    "subsystem": "Brainstem – Balance, Spatial Orientation, and Postural Reflexes",
    "icd11_code": "XA0G4",
    "icf_structure_code": "s110",
    "icf_function_code": "b235",
    "snomeD_code": "372121005",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 15,
      "critical_periods": ["0–5y", "10–14y"]
    },
    "functions": [
      "Integration of balance and motion signals from inner ear and eyes",
      "Regulation of posture, head position, and equilibrium",
      "Coordination of eye movement through vestibulo-ocular reflex (VOR)",
      "Contribution to spatial orientation and navigation",
      "Sensory calibration for coordinated motor planning"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Sensory Integration",
      "Spatial Awareness"
    ],
    "abilities_linked": [
      { "name": "Balance Control", "id": 1996 },
      { "name": "Spatial Orientation", "id": 2063 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Postural Stability", "id": 1702 },
      { "name": "Sensory Processing", "id": 2078 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 45,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 15,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Vestibular Apparatus (Semicircular Canals and Otolith Organs)",
        "Cerebellum (Flocculonodular Lobe)",
        "Spinal Cord (Proprioceptive Input)",
        "Visual Cortex (for Spatial Integration)"
      ],
      "efferent_to": [
        "Oculomotor and Trochlear Nuclei (Eye Movement Coordination)",
        "Spinal Cord (Vestibulospinal Reflex Pathways)",
        "Cerebellum (Motor Adjustment)",
        "Thalamus (Sensory Relay to Cortex)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Videonystagmography (VNG)",
        "Rotational Chair Test",
        "Posturography and Balance Assessment"
      ],
      "key_parameters": [
        "Vestibulo-ocular reflex gain and latency",
        "Postural sway amplitude and velocity",
        "Nystagmus direction and symmetry"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Balance and postural control exercises",
        "Head–eye coordination and tracking drills",
        "Vestibular stimulation therapy (swings, spins)",
        "Spatial orientation and proprioceptive games"
      ],
      "energy_axis": "Vestibular–Motor",
      "dependencies": [
        "Cerebellum",
        "Visual Cortex",
        "Spinal Cord",
        "Vestibular Apparatus"
      ]
    },
    "genetic_regulators": ["PCDH15", "MYO7A", "USH1C", "TMC1"],
    "weight": 18
  },
  {
    "id": 19,
    "name": "Spinal Cord",
    "system": "Nervous",
    "subsystem": "Spinal Axis – Motor, Sensory, and Reflex Integration Pathways",
    "icd11_code": "XA0100",
    "icf_structure_code": "s120",
    "icf_function_code": "b750",
    "snomeD_code": "372130005",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0–6y"]
    },
    "functions": [
      "Transmission of sensory and motor signals between body and brain",
      "Reflex coordination and posture maintenance",
      "Conduction of pain, temperature, and touch sensations",
      "Autonomic regulation of organ functions (bladder, bowel, heart)",
      "Integration of proprioceptive input for movement control"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Sensory Integration",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Postural Stability", "id": 1702 },
      { "name": "Reflex Integration", "id": 1998 },
      { "name": "Gross Motor Coordination", "id": 1804 },
      { "name": "Body Awareness & Spatial Orientation", "id": 1807 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 50,
      "behavior": 10,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Peripheral Nerves (Sensory Fibers)",
        "Muscle Spindles and Tendon Organs",
        "Autonomic Ganglia"
      ],
      "efferent_to": [
        "Skeletal Muscles (Motor Output)",
        "Autonomic Organs (Sympathetic and Parasympathetic Pathways)",
        "Cerebellum and Thalamus (Ascending Sensory Tracts)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "MRI (Spinal Imaging)",
        "Somatosensory Evoked Potentials (SEP)",
        "Reflex and Tone Assessment"
      ],
      "key_parameters": [
        "Conduction velocity and reflex latency",
        "Sensory–motor response timing",
        "Spinal integrity and motor coordination index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Reflex integration therapy (ATNR, STNR, TLR)",
        "Postural correction and strengthening exercises",
        "Sensory–motor play for proprioceptive feedback",
        "Balance and movement sequencing activities"
      ],
      "energy_axis": "Spinal–Motor",
      "dependencies": [
        "Cerebellum",
        "Motor Cortex",
        "Peripheral Nerves",
        "Vestibular System"
      ]
    },
    "genetic_regulators": ["SMN1", "PLP1", "SOD1", "GFAP"],
    "weight": 19
  },
  {
    "id": 20,
    "name": "Vagus Nerve (CN X)",
    "system": "Nervous",
    "subsystem": "Cranial Nerves – Parasympathetic Regulation and Sensory Feedback",
    "icd11_code": "XA0110",
    "icf_structure_code": "s120",
    "icf_function_code": "b435",
    "snomeD_code": "372135000",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0–5y"]
    },
    "functions": [
      "Regulation of parasympathetic control over heart, lungs, and digestive organs",
      "Control of swallowing and vocalization through motor innervation",
      "Modulation of heart rate, breathing, and digestion",
      "Transmission of sensory input from internal organs to the brain",
      "Influence on mood and calmness via gut–brain communication"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Language Expression",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Swallowing Control", "id": 2046 },
      { "name": "Heart Rate Regulation", "id": 2048 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 20,
      "motor": 10,
      "behavior": 20,
      "cognitive": 5,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Visceral Organs (Heart, Lungs, Gut)",
        "Medulla Oblongata (Nucleus Tractus Solitarius)",
        "Diaphragm (Respiratory Feedback)"
      ],
      "efferent_to": [
        "Heart (Parasympathetic Modulation)",
        "Lungs (Bronchoconstriction Control)",
        "Digestive Tract (Motility and Enzyme Secretion)",
        "Larynx / Pharynx (Speech and Swallowing Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Heart Rate Variability (HRV)",
        "EEG (Parasympathetic Tone)",
        "Respiratory Sinus Arrhythmia (RSA) Analysis"
      ],
      "key_parameters": [
        "High-frequency HRV component (parasympathetic activity)",
        "Vagal tone index (rest–stress modulation)",
        "Vocal frequency variability and resonance quality"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Deep diaphragmatic breathing and exhalation training",
        "Humming, chanting, and vocal vibration exercises",
        "Cold stimulation for vagal activation",
        "Biofeedback and mindfulness-based relaxation"
      ],
      "energy_axis": "Vagal–Autonomic",
      "dependencies": [
        "Medulla Oblongata",
        "Heart",
        "Larynx / Voice Box",
        "Diaphragm"
      ]
    },
    "genetic_regulators": ["CHRNA7", "HTR1A", "SLC6A4", "BDNF"],
    "weight": 20
  },
  {
    "id": 21,
    "name": "Trigeminal Nerve (CN V)",
    "system": "Nervous",
    "subsystem": "Cranial Nerves – Facial Sensation and Mastication Control",
    "icd11_code": "XA0115",
    "icf_structure_code": "s120",
    "icf_function_code": "b265",
    "snomeD_code": "372133007",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0–4y"]
    },
    "functions": [
      "Transmission of touch, pain, and temperature sensations from the face and mouth",
      "Motor control of chewing and jaw movement (mastication)",
      "Regulation of oral proprioception for speech and feeding",
      "Coordination of facial reflexes such as blink and corneal protection",
      "Integration of oral–facial sensory feedback with motor planning"
    ],
    "developmental_domains": [
      "Language Expression",
      "Motor Coordination",
      "Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Chewing and Mastication", "id": 1709 },
      { "name": "Facial Sensation", "id": 2055 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Tactile Perception & Integration", "id": 2079 },
      { "name": "Speech Intelligibility", "id": 1758 }
    ],
    "readiness_contribution": {
      "speech": 25,
      "motor": 25,
      "behavior": 5,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 20,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Facial Skin and Mucosa (Sensory Receptors)",
        "Teeth and Gums (Oral Feedback)",
        "Tongue (Anterior 2/3 Sensation)",
        "Temporomandibular Joint (Proprioception)"
      ],
      "efferent_to": [
        "Muscles of Mastication (Masseter, Temporalis, Pterygoids)",
        "Facial Sensory Nucleus (Brainstem Relay)",
        "Somatosensory Cortex (S1)",
        "Cerebellum (Motor Feedback Integration)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Electromyography (Jaw Reflex)",
        "Quantitative Sensory Testing (QST)",
        "MRI (Cranial Nerve Mapping)"
      ],
      "key_parameters": [
        "Corneal and jaw-jerk reflex latency",
        "Tactile threshold sensitivity across trigeminal zones",
        "Jaw-opening and closing coordination index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Oral-motor sensory stimulation and massage",
        "Chewing coordination and jaw mobility exercises",
        "Speech articulation and resonance control tasks",
        "Facial sensory brushing and tactile feedback games"
      ],
      "energy_axis": "Trigeminal–Somatosensory",
      "dependencies": [
        "Facial Nerve (CN VII)",
        "Larynx / Voice Box",
        "Oral Cavity",
        "Pharynx"
      ]
    },
    "genetic_regulators": ["SCN9A", "TRPV1", "PRPH", "GFRA3"],
    "weight": 21
  },
  {
    "id": 22,
    "name": "Facial Nerve (CN VII)",
    "system": "Nervous",
    "subsystem": "Cranial Nerves – Facial Expression, Taste, and Parasympathetic Control",
    "icd11_code": "XA0117",
    "icf_structure_code": "s120",
    "icf_function_code": "b760",
    "snomeD_code": "372134001",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0–6y"]
    },
    "functions": [
      "Motor control of facial expression, including lips, cheeks, and eyelids",
      "Facilitation of nonverbal communication through expressions",
      "Taste sensation from anterior two-thirds of the tongue via chorda tympani",
      "Parasympathetic regulation of salivary and lacrimal glands",
      "Integration of emotional and social signaling with facial movement"
    ],
    "developmental_domains": [
      "Language Expression",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Facial Expression", "id": 2035 },
      { "name": "Emotional Expression", "id": 1754 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Social Responsiveness", "id": 1766 }
    ],
    "readiness_contribution": {
      "speech": 35,
      "motor": 20,
      "behavior": 10,
      "cognitive": 5,
      "social": 25,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Trigeminal Nerve (Sensory Input)",
        "Amygdala (Emotional Regulation)",
        "Pons (Facial Motor Nucleus)",
        "Cerebellum (Motor Feedback)"
      ],
      "efferent_to": [
        "Facial Muscles (Expression and Articulation)",
        "Salivary and Lacrimal Glands (Parasympathetic Output)",
        "Oral Cavity (Speech Articulation Coordination)",
        "Broca’s Area (Feedback Loop for Prosody)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Facial Electromyography (EMG)",
        "Motion Capture for Expression Dynamics",
        "MRI (Cranial Nerve Mapping)"
      ],
      "key_parameters": [
        "Facial symmetry index during expressions",
        "Response latency to emotional stimuli",
        "Facial EMG amplitude variability and coordination"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Facial expression imitation and mirror therapy",
        "Speech articulation and lip movement training",
        "Emotional mimicry and resonance games",
        "Sensory feedback and relaxation exercises"
      ],
      "energy_axis": "Facial–Emotional",
      "dependencies": [
        "Trigeminal Nerve (CN V)",
        "Amygdala",
        "Oral Cavity",
        "Broca’s Area"
      ]
    },
    "genetic_regulators": ["HOXA1", "FGF10", "TUBB3", "BDNF"],
    "weight": 22
  },
  {
    "id": 23,
    "name": "Eyes / Globe",
    "system": "Sensory",
    "subsystem": "Ocular System – Visual Reception and Focusing Mechanism",
    "icd11_code": "XA0230",
    "icf_structure_code": "s220",
    "icf_function_code": "b210",
    "snomeD_code": "81745001",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 12,
      "critical_periods": ["0–3y", "8–10y"]
    },
    "functions": [
      "Reception of light and image projection onto the retina",
      "Accommodation and focusing for clear vision at varying distances",
      "Regulation of light entry through pupil constriction and dilation",
      "Coordination of ocular movements for visual tracking and convergence",
      "Support for spatial awareness, balance, and hand–eye coordination"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Cognitive Readiness",
      "Motor Coordination"
    ],
    "abilities_linked": [
      { "name": "Visual Tracking", "id": 2077 },
      { "name": "Object Recognition", "id": 2049 },
      { "name": "Visual-Spatial Reasoning", "id": 1808 },
      { "name": "Attention Control", "id": 1801 },
      { "name": "Hand-Eye Coordination", "id": 1806 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 20,
      "behavior": 5,
      "cognitive": 25,
      "social": 10,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Retina (Photoreceptors)",
        "Extraocular Muscles (Proprioceptive Feedback)",
        "Pupil Reflex Arc (Optic and Oculomotor Nerves)"
      ],
      "efferent_to": [
        "Lateral Geniculate Nucleus (Thalamus)",
        "Superior Colliculus (Midbrain Reflex Pathway)",
        "Primary Visual Cortex (V1)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Visual Acuity Testing (Snellen / LogMAR)",
        "Ophthalmoscopy and Retinal Imaging",
        "Eye-Tracking and Vergence Measurement",
        "Optical Coherence Tomography (OCT)"
      ],
      "key_parameters": [
        "Visual acuity and focusing accuracy",
        "Eye alignment and convergence symmetry",
        "Saccadic speed and tracking latency",
        "Contrast sensitivity and field mapping"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Visual tracking and scanning exercises",
        "Eye-hand coordination and depth perception games",
        "Convergence and divergence strengthening",
        "Light sensitivity and accommodation training"
      ],
      "energy_axis": "Ocular–Visual",
      "dependencies": [
        "Retina",
        "Optic Nerve",
        "Primary Visual Cortex (V1)",
        "Midbrain (Superior Colliculus)"
      ]
    },
    "genetic_regulators": ["PAX6", "OTX2", "CRYAA", "VSX2"],
    "weight": 23
  },
  {
    "id": 24,
    "name": "Retina",
    "system": "Sensory",
    "subsystem": "Ocular Sensory Layer – Photoreception and Signal Transduction",
    "icd11_code": "XA0235",
    "icf_structure_code": "s2200",
    "icf_function_code": "b2100",
    "snomeD_code": "28032008",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 10,
      "critical_periods": ["0–3y", "6–8y"]
    },
    "functions": [
      "Conversion of light energy into electrical impulses via photoreceptors",
      "Color, contrast, and motion detection for visual clarity",
      "Transmission of neural signals to the optic nerve and brain",
      "Adaptation to light and darkness (visual accommodation)",
      "Initial stage of visual perception and spatial mapping"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Sensory Integration",
      "Cognitive Readiness"
    ],
    "abilities_linked": [
      { "name": "Visual Acuity", "id": 2077 },
      { "name": "Color Discrimination", "id": 2051 },
      { "name": "Visual Tracking", "id": 2077 },
      { "name": "Peripheral Awareness", "id": 2057 },
      { "name": "Attention Control", "id": 1801 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 5,
      "cognitive": 30,
      "social": 5,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Photoreceptors (Rods and Cones)",
        "Retinal Pigment Epithelium (Support Layer)"
      ],
      "efferent_to": [
        "Optic Nerve (CN II)",
        "Lateral Geniculate Nucleus (Thalamus)",
        "Superior Colliculus (Midbrain Visual Reflex Center)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Optical Coherence Tomography (OCT)",
        "Electroretinography (ERG)",
        "Fundus Photography and Retinal Mapping"
      ],
      "key_parameters": [
        "Retinal layer thickness and integrity",
        "Photoreceptor response amplitude and latency",
        "Macular pigment density and visual field sensitivity"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Visual stimulation and light tracking exercises",
        "Contrast and pattern recognition activities",
        "Color and brightness discrimination training",
        "Peripheral vision awareness tasks"
      ],
      "energy_axis": "Retinal–Visual",
      "dependencies": [
        "Eyes / Globe",
        "Optic Nerve",
        "Primary Visual Cortex (V1)",
        "Thalamus (LGN)"
      ]
    },
    "genetic_regulators": ["RHO", "NR2E3", "CRX", "RPGR"],
    "weight": 24
  },
  {
    "id": 25,
    "name": "Middle Ear",
    "system": "Sensory",
    "subsystem": "Auditory System – Sound Transmission and Pressure Equalization",
    "icd11_code": "XA0210",
    "icf_structure_code": "s2500",
    "icf_function_code": "b2300",
    "snomeD_code": "297168005",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 8,
      "critical_periods": ["0–3y", "6–8y"]
    },
    "functions": [
      "Mechanical transmission of sound waves from tympanic membrane to inner ear",
      "Amplification of acoustic signals via ossicular chain (malleus, incus, stapes)",
      "Equalization of air pressure across the tympanic membrane through Eustachian tube",
      "Protection of cochlea from excessive sound via acoustic reflex",
      "Support of auditory clarity essential for speech and language development"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Language Expression",
      "Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Sound Localization", "id": 2060 },
      { "name": "Auditory Processing & Discrimination", "id": 2078 },
      { "name": "Speech Perception", "id": 1757 },
      { "name": "Listening Skills", "id": 1699 },
      { "name": "Hearing Sensitivity", "id": 2050 }
    ],
    "readiness_contribution": {
      "speech": 40,
      "motor": 10,
      "behavior": 5,
      "cognitive": 15,
      "social": 10,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "External Ear (Tympanic Membrane Vibrations)",
        "Eustachian Tube (Pressure Regulation)"
      ],
      "efferent_to": [
        "Cochlea (Oval Window Transmission)",
        "Auditory Nerve (Cochlear Input)",
        "Vestibular Nuclei (Balance Integration)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Tympanometry",
        "Otoacoustic Emissions (OAE)",
        "Pure Tone Audiometry"
      ],
      "key_parameters": [
        "Middle ear compliance curve",
        "Stapedial reflex threshold",
        "Hearing sensitivity across speech frequencies"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Auditory discrimination and sequencing tasks",
        "Sound localization and listening games",
        "Speech-in-noise recognition exercises",
        "Rhythmic auditory–motor coordination activities"
      ],
      "energy_axis": "Auditory–Conductive",
      "dependencies": [
        "Cochlea",
        "Eustachian Tube",
        "Auditory Cortex",
        "Vestibular Apparatus"
      ]
    },
    "genetic_regulators": ["OTOF", "POU3F4", "COL2A1", "GJB2"],
    "weight": 25
  },
  {
    "id": 26,
    "name": "Cochlea",
    "system": "Sensory",
    "subsystem": "Inner Ear – Sound Transduction and Frequency Mapping",
    "icd11_code": "XA0213",
    "icf_structure_code": "s2501",
    "icf_function_code": "b2301",
    "snomeD_code": "371195005",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 7,
      "critical_periods": ["0–4y", "8–10y"]
    },
    "functions": [
      "Conversion of sound vibrations into neural signals via hair cells",
      "Discrimination of frequency and amplitude for pitch and tone recognition",
      "Encoding of speech and environmental sounds through tonotopic mapping",
      "Transmission of auditory information to brain through the cochlear nerve",
      "Support for phonological awareness, rhythm, and language development"
    ],
    "developmental_domains": [
      "Language Expression",
      "Sensory Integration",
      "Language Expression"
    ],
    "abilities_linked": [
      { "name": "Listening Skills", "id": 1699 },
      { "name": "Speech Perception", "id": 1757 },
      { "name": "Phonological Awareness", "id": 2062 },
      { "name": "Sound Discrimination", "id": 2061 },
      { "name": "Auditory Processing & Discrimination", "id": 2078 }
    ],
    "readiness_contribution": {
      "speech": 55,
      "motor": 5,
      "behavior": 5,
      "cognitive": 20,
      "social": 10,
      "self_sufficiency": 5,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Middle Ear (Ossicular Chain and Oval Window Vibrations)"
      ],
      "efferent_to": [
        "Auditory Nerve (Cochlear Branch of CN VIII)",
        "Superior Olivary Complex (Sound Localization)",
        "Inferior Colliculus and Auditory Cortex"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Otoacoustic Emissions (OAE)",
        "Auditory Brainstem Response (ABR)",
        "Pure Tone Audiometry"
      ],
      "key_parameters": [
        "Cochlear microphonics and outer hair cell function",
        "Latency of Wave V in ABR (Neural Conduction Speed)",
        "Threshold of frequency detection across 250–8000 Hz"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Auditory–verbal therapy and phonemic listening",
        "Speech sound discrimination drills",
        "Music and rhythm-based auditory training",
        "Frequency modulation and listening comprehension exercises"
      ],
      "energy_axis": "Cochlear–Auditory",
      "dependencies": [
        "Middle Ear",
        "Auditory Nerve",
        "Auditory Cortex",
        "Wernicke’s Area"
      ]
    },
    "genetic_regulators": ["GJB2", "OTOF", "MYO7A", "TMC1"],
    "weight": 26
  },
  {
    "id": 27,
    "name": "Vestibular Apparatus",
    "system": "Sensory",
    "subsystem": "Inner Ear – Equilibrium and Spatial Orientation",
    "icd11_code": "XA0214",
    "icf_structure_code": "s2502",
    "icf_function_code": "b235",
    "snomeD_code": "371196006",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 10,
      "critical_periods": ["0–5y", "9–12y"]
    },
    "functions": [
      "Detection of head position, rotation, and linear acceleration",
      "Maintenance of balance and body equilibrium",
      "Coordination of eye movements via vestibulo-ocular reflex (VOR)",
      "Contribution to posture and gait control",
      "Integration of gravity and motion signals for spatial orientation"
    ],
    "developmental_domains": [
      "Motor Coordination",
      "Sensory Integration",
      "Spatial Awareness"
    ],
    "abilities_linked": [
      { "name": "Balance Control", "id": 1996 },
      { "name": "Spatial Orientation", "id": 2063 },
      { "name": "Body Awareness & Spatial Orientation", "id": 1807 },
      { "name": "Postural Stability", "id": 1702 },
      { "name": "Sensory Processing", "id": 2078 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 50,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 15,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Semicircular Canals (Rotational Motion Sensors)",
        "Utricle and Saccule (Linear Acceleration Sensors)"
      ],
      "efferent_to": [
        "Vestibular Nuclei (Brainstem Processing)",
        "Cerebellum (Flocculonodular Coordination)",
        "Oculomotor Nuclei (Eye Movement Control)",
        "Spinal Cord (Postural Adjustments)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Videonystagmography (VNG)",
        "Rotational Chair Test",
        "Posturography and Balance Assessment"
      ],
      "key_parameters": [
        "Vestibulo-ocular reflex (VOR) gain and phase",
        "Postural sway and stability index",
        "Nystagmus directionality and latency"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Balance and coordination exercises",
        "Vestibular stimulation activities (swing, tilt board)",
        "Eye-head coordination drills",
        "Proprioceptive and motor planning tasks"
      ],
      "energy_axis": "Vestibular–Motor",
      "dependencies": [
        "Cerebellum",
        "Visual Cortex",
        "Spinal Cord",
        "Vestibular Nuclei"
      ]
    },
    "genetic_regulators": ["PCDH15", "MYO15A", "USH2A", "TMC1"],
    "weight": 27
  },
  {
    "id": 28,
    "name": "Olfactory Epithelium",
    "system": "Sensory",
    "subsystem": "Nasal Cavity – Smell Reception and Sensory Integration",
    "icd11_code": "XA0221",
    "icf_structure_code": "s260",
    "icf_function_code": "b255",
    "snomeD_code": "181744008",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 10,
      "critical_periods": ["Prenatal", "0–4y"]
    },
    "functions": [
      "Detection and identification of odor molecules in inhaled air",
      "Transmission of olfactory signals to the brain for perception",
      "Influence on appetite, memory, and emotional regulation",
      "Integration of smell with taste for flavor recognition",
      "Contribution to early bonding, environment awareness, and safety"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Behavioral Regulation",
      "Behavioral Regulation and Feeding & Swallowing"
    ],
    "abilities_linked": [
      { "name": "Smell Identification", "id": 2039 },
      { "name": "Appetite Control", "id": 2049 },
      { "name": "Emotional Expression", "id": 1754 },
      { "name": "Taste Differentiation", "id": 2020 },
      { "name": "Sensory Exploration", "id": 2056 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 5,
      "behavior": 20,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 15,
      "mainstream": 10
    },
    "connectivity": {
      "afferent_from": [
        "Olfactory Receptor Neurons (Nasal Mucosa)",
        "Respiratory Airflow Pathway"
      ],
      "efferent_to": [
        "Olfactory Bulb (Signal Relay)",
        "Amygdala (Emotional Processing)",
        "Hippocampus (Olfactory Memory)",
        "Orbitofrontal Cortex (Conscious Odor Perception)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Olfactory Threshold Test",
        "UPSIT (Smell Identification Test)",
        "Functional MRI (Olfactory Cortex Activation)"
      ],
      "key_parameters": [
        "Odor detection and identification accuracy",
        "Threshold sensitivity for specific odorants",
        "Olfactory bulb activation amplitude"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Olfactory stimulation and scent recognition activities",
        "Smell-memory association exercises",
        "Aroma-based relaxation and mindfulness therapy",
        "Taste–smell integration through feeding and flavor play"
      ],
      "energy_axis": "Olfactory–Limbic",
      "dependencies": [
        "Amygdala",
        "Hippocampus",
        "Orbitofrontal Cortex",
        "Nasal Cavity"
      ]
    },
    "genetic_regulators": ["OR2J3", "CNGA2", "ADCY3", "GNAL"],
    "weight": 28
  },
  {
    "id": 29,
    "name": "Tongue / Taste Buds",
    "system": "Sensory",
    "subsystem": "Oral Cavity – Taste Reception and Oral-Motor Integration",
    "icd11_code": "XA0225",
    "icf_structure_code": "s320",
    "icf_function_code": "b250",
    "snomeD_code": "21974007",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 12,
      "critical_periods": ["0–3y", "6–9y"]
    },
    "functions": [
      "Perception of taste qualities including sweet, salty, sour, bitter, and umami",
      "Coordination of oral movements for chewing, swallowing, and articulation",
      "Integration of taste, temperature, and texture sensations",
      "Reflex initiation for swallowing and salivation",
      "Contribution to speech articulation and feeding efficiency"
    ],
    "developmental_domains": [
      "Language Expression",
      "Feeding & Swallowing and Self-Sufficiency",
      "Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Taste Differentiation", "id": 2020 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Texture Tolerance", "id": 2040 }
    ],
    "readiness_contribution": {
      "speech": 40,
      "motor": 15,
      "behavior": 5,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 15,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Taste Buds (via Facial and Glossopharyngeal Nerves)",
        "Trigeminal Nerve (Tactile Sensation)",
        "Salivary Glands (Lubrication Feedback)"
      ],
      "efferent_to": [
        "Medulla Oblongata (Swallowing Control Centers)",
        "Thalamus (Taste Relay)",
        "Gustatory Cortex (Insula and Frontal Operculum)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Taste Threshold Testing",
        "Electrogustometry",
        "Videofluoroscopic Swallow Study (VFSS)"
      ],
      "key_parameters": [
        "Taste sensitivity thresholds",
        "Oral-motor coordination speed",
        "Swallow timing and safety index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Taste and flavor exploration therapy",
        "Oral-motor strengthening and coordination drills",
        "Speech articulation and resonance training",
        "Feeding and texture desensitization routines"
      ],
      "energy_axis": "Gustatory–Oral",
      "dependencies": [
        "Trigeminal Nerve (CN V)",
        "Facial Nerve (CN VII)",
        "Pharynx",
        "Salivary Glands"
      ]
    },
    "genetic_regulators": ["TAS1R2", "TAS2R38", "GNAT3", "SCNN1A"],
    "weight": 29
  },
  {
    "id": 30,
    "name": "Larynx / Voice Box",
    "system": "Respiratory / Speech",
    "subsystem": "Upper Airway – Sound Production and Airflow Regulation",
    "icd11_code": "XA0300",
    "icf_structure_code": "s340",
    "icf_function_code": "b310",
    "snomeD_code": "4596009",
    "loinc_param": null,
    "growth": {
      "formation_week": 8,
      "maturation_age_years": 16,
      "critical_periods": ["0–6y", "Puberty"]
    },
    "functions": [
      "Generation of voice through vibration of the vocal folds",
      "Regulation of airflow for phonation and respiration",
      "Protection of the lower airway during swallowing",
      "Modulation of pitch, volume, and tone for expressive speech",
      "Coordination of breathing, resonance, and articulation for communication"
    ],
    "developmental_domains": [
      "Language Expression",
      "Autonomic Coordination",
      "Language Expression"
    ],
    "abilities_linked": [
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Pronunciation Skills", "id": 1759 },
      { "name": "Voice Modulation", "id": 2054 },
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Social Expression through Voice", "id": 2055 }
    ],
    "readiness_contribution": {
      "speech": 45,
      "motor": 10,
      "behavior": 5,
      "cognitive": 5,
      "social": 10,
      "self_sufficiency": 10,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Motor Cortex (Speech Motor Commands)",
        "Brainstem (Nucleus Ambiguus)",
        "Vagus Nerve (CN X)",
        "Respiratory Centers (Medulla and Pons)"
      ],
      "efferent_to": [
        "Pharynx (Resonance and Airflow Control)",
        "Respiratory Muscles (Breathing Synchronization)",
        "Facial Muscles (Articulation Support)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Acoustic Analysis (F0, Jitter, Shimmer)",
        "Laryngoscopy / Stroboscopy",
        "Voice Range Profile (Phonogram)"
      ],
      "key_parameters": [
        "Fundamental frequency and harmonic range",
        "Voice onset and resonance balance",
        "Maximum phonation time and breath control"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Speech and voice therapy (phonation control)",
        "Breath–voice coordination drills",
        "Pitch modulation and resonance exercises",
        "Voice hygiene and relaxation programs"
      ],
      "energy_axis": "Phonatory–Respiratory",
      "dependencies": [
        "Broca’s Area",
        "Respiratory Muscles",
        "Pharynx",
        "Vagus Nerve"
      ]
    },
    "genetic_regulators": ["FOXP2", "SRPX2", "TBX1", "GATA3"],
    "weight": 30
  },
  {
    "id": 31,
    "name": "Pharynx",
    "system": "Respiratory / Digestive",
    "subsystem": "Upper Airway – Resonance and Swallowing Coordination",
    "icd11_code": "XA0301",
    "icf_structure_code": "s330",
    "icf_function_code": "b510",
    "snomeD_code": "54066008",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["0-4y", "7-12y"]
    },
    "functions": [
      "Regulation of airflow between nasal, oral, and laryngeal cavities",
      "Resonance and vocal quality shaping for speech",
      "Swallowing and deglutition coordination",
      "Airway protection during feeding",
      "Equalization of pressure across Eustachian tube and middle ear"
    ],
    "developmental_domains": [
      "Language Expression",
      "Feeding & Swallowing",
      "Autonomic Coordination"
    ],
    "abilities_linked": [
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Pronunciation Skills", "id": 1759 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Breathing Coordination", "id": 2003 }
    ],
    "readiness_contribution": {
      "speech": 35,
      "motor": 15,
      "behavior": 5,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 15,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Tongue / Taste Buds",
        "Soft Palate / Velum",
        "Larynx / Voice Box",
        "Trigeminal and Glossopharyngeal Nerves"
      ],
      "efferent_to": [
        "Larynx / Voice Box (for phonation control)",
        "Esophagus (for swallowing transfer)",
        "Facial and Respiratory Muscles (for resonance support)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Videofluoroscopic Swallowing Study (VFSS)",
        "Nasopharyngoscopy",
        "Acoustic Resonance Analysis"
      ],
      "key_parameters": [
        "Swallow timing and coordination",
        "Velopharyngeal closure ratio",
        "Resonance pattern and nasal airflow control"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Swallowing and oral-motor exercises",
        "Resonance therapy and nasal airflow control",
        "Speech sound shaping (nasal vs oral balance)",
        "Breathing–phonation coordination tasks"
      ],
      "energy_axis": "Pharyngeal-Resonance",
      "dependencies": [
        "Larynx / Voice Box",
        "Soft Palate / Velum",
        "Trigeminal and Facial Nerves"
      ]
    },
    "genetic_regulators": ["FOXP2", "TBX1", "PAX9", "FGF8"],
    "weight": 31
  },
  {
    "id": 32,
    "name": "Oral Cavity",
    "system": "Digestive / Speech",
    "subsystem": "Mouth – Articulation, Feeding, and Resonance",
    "icd11_code": "XA0226",
    "icf_structure_code": "s320",
    "icf_function_code": "b510",
    "snomeD_code": "123851003",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 15,
      "critical_periods": ["0-3y", "6-10y"]
    },
    "functions": [
      "Primary site for articulation and speech sound formation",
      "Chewing and food preparation for swallowing",
      "Integration of taste, touch, and temperature sensations",
      "Regulation of airflow for oral resonance and phonation",
      "Facilitation of feeding and oral hygiene behaviors"
    ],
    "developmental_domains": [
      "Language Expression",
      "Feeding & Swallowing and Self-Sufficiency",
      "Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Pronunciation Skills", "id": 1759 },
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Taste Differentiation", "id": 2020 }
    ],
    "readiness_contribution": {
      "speech": 40,
      "motor": 20,
      "behavior": 5,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 15,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Tongue / Taste Buds",
        "Teeth and Mandible",
        "Facial and Trigeminal Nerves",
        "Soft Palate / Velum"
      ],
      "efferent_to": [
        "Pharynx (Swallowing Coordination)",
        "Larynx / Voice Box (Airflow Regulation)",
        "Primary Motor Cortex (Speech Articulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Oral Motor Assessment (OMA)",
        "Videofluoroscopic Swallowing Study (VFSS)",
        "Acoustic Analysis of Speech"
      ],
      "key_parameters": [
        "Articulation accuracy and clarity",
        "Oral pressure and movement range",
        "Swallow safety and oral transit time"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Oral-motor strengthening exercises",
        "Speech sound shaping drills",
        "Chewing and feeding desensitization therapy",
        "Airflow and breath coordination activities"
      ],
      "energy_axis": "Oral-Motor",
      "dependencies": [
        "Lips",
        "Tongue / Taste Buds",
        "Pharynx",
        "Larynx / Voice Box"
      ]
    },
    "genetic_regulators": ["FOXP2", "TCOF1", "BMP4", "PAX9"],
    "weight": 32
  },
  {
    "id": 33,
    "name": "Mandible / Teeth",
    "system": "Musculoskeletal / Digestive / Speech",
    "subsystem": "Craniofacial – Jaw Structure and Oral Mechanics",
    "icd11_code": "XA0227",
    "icf_structure_code": "s320",
    "icf_function_code": "b510",
    "snomeD_code": "181768009",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 18,
      "critical_periods": ["0-5y", "6-12y"]
    },
    "functions": [
      "Jaw movement and mastication control",
      "Support for articulation and resonance",
      "Facilitation of oral-motor and feeding functions",
      "Alignment and occlusion for speech and swallowing",
      "Structural foundation for teeth and orofacial balance"
    ],
    "developmental_domains": [
      "Language Expression",
      "Motor Coordination",
      "Feeding & Swallowing and Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Chewing and Mastication", "id": 1709 },
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Pronunciation Skills", "id": 1759 }
    ],
    "readiness_contribution": {
      "speech": 35,
      "motor": 25,
      "behavior": 5,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 15,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Trigeminal Nerve (CN V)",
        "Facial Nerve (CN VII)",
        "Temporomandibular Joint (Proprioceptive Input)",
        "Oral Cavity (Tactile Feedback)"
      ],
      "efferent_to": [
        "Muscles of Mastication (Masseter, Temporalis, Pterygoids)",
        "Tongue and Pharynx (for coordinated swallowing)",
        "Primary Motor Cortex (for articulation control)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Jaw Kinematic Analysis",
        "Bite Force Assessment",
        "EMG of Mastication Muscles"
      ],
      "key_parameters": [
        "Jaw opening and closing velocity",
        "Chewing rhythm and amplitude",
        "Occlusal alignment and bite strength"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Oral-motor and jaw stability exercises",
        "Chewing and biting practice with graded textures",
        "Speech articulation and resonance therapy",
        "Facial muscle relaxation and strengthening"
      ],
      "energy_axis": "Mandibular-Oral",
      "dependencies": [
        "Trigeminal Nerve (CN V)",
        "Facial Nerve (CN VII)",
        "Oral Cavity",
        "Pharynx"
      ]
    },
    "genetic_regulators": ["MSX1", "PAX9", "BMP4", "FGF8"],
    "weight": 33
  },
  {
    "id": 34,
    "name": "Lips",
    "system": "Speech",
    "subsystem": "Oral-Facial Musculature – Articulation and Expression",
    "icd11_code": "XA0228",
    "icf_structure_code": "s320",
    "icf_function_code": "b320",
    "snomeD_code": "45206002",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["0-4y", "6-10y"]
    },
    "functions": [
      "Formation of speech sounds and articulation control",
      "Seal for feeding and swallowing functions",
      "Expression of emotions and social cues",
      "Control of oral airflow and resonance shaping",
      "Coordination with facial and jaw muscles for communication"
    ],
    "developmental_domains": [
      "Language Expression",
      "Feeding & Swallowing and Self-Sufficiency",
      "Language Expression"
    ],
    "abilities_linked": [
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Pronunciation Skills", "id": 1759 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Facial Expression", "id": 2035 },
      { "name": "Feeding Independence", "id": 1707 }
    ],
    "readiness_contribution": {
      "speech": 40,
      "motor": 15,
      "behavior": 5,
      "cognitive": 5,
      "social": 15,
      "self_sufficiency": 15,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Facial Nerve (CN VII)",
        "Trigeminal Nerve (CN V)",
        "Oral Cavity (Somatosensory Feedback)"
      ],
      "efferent_to": [
        "Motor Cortex (Lip Articulation Zone)",
        "Pharynx (for resonance shaping)",
        "Facial Muscles (Orbicularis Oris, Buccinator)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Speech Articulation Analysis",
        "Facial EMG",
        "Kinematic Lip Movement Tracking"
      ],
      "key_parameters": [
        "Lip closure and strength metrics",
        "Articulation accuracy (bilabial, labiodental)",
        "Speech clarity and resonance balance"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Lip strength and coordination exercises",
        "Blowing, sucking, and kissing tasks",
        "Speech articulation drills",
        "Facial expression imitation games"
      ],
      "energy_axis": "Oral-Facial",
      "dependencies": [
        "Facial Nerve (CN VII)",
        "Trigeminal Nerve (CN V)",
        "Oral Cavity",
        "Pharynx"
      ]
    },
    "genetic_regulators": ["IRF6", "MSX1", "FGF8", "PAX9"],
    "weight": 34
  },
  {
    "id": 35,
    "name": "Soft Palate / Velum",
    "system": "Digestive / Speech",
    "subsystem": "Velopharyngeal Mechanism – Resonance and Airflow Control",
    "icd11_code": "XA0229",
    "icf_structure_code": "s320",
    "icf_function_code": "b320",
    "snomeD_code": "91537007",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 14,
      "critical_periods": ["0-6y", "9-12y"]
    },
    "functions": [
      "Regulation of airflow between oral and nasal cavities during speech and swallowing",
      "Production of oral vs nasal resonance balance",
      "Prevention of nasal regurgitation during swallowing",
      "Consonant articulation requiring oral pressure (e.g., /p/, /b/, /t/)",
      "Coordination with pharynx and tongue for resonance control"
    ],
    "developmental_domains": [
      "Language Expression",
      "Feeding & Swallowing",
      "Autonomic Coordination"
    ],
    "abilities_linked": [
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Pronunciation Skills", "id": 1759 },
      { "name": "Resonance Control", "id": 2004 },
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Breathing Coordination", "id": 2003 }
    ],
    "readiness_contribution": {
      "speech": 45,
      "motor": 15,
      "behavior": 5,
      "cognitive": 5,
      "social": 10,
      "self_sufficiency": 10,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Pharynx",
        "Tongue / Taste Buds",
        "Trigeminal and Glossopharyngeal Nerves"
      ],
      "efferent_to": [
        "Pharynx (for swallowing coordination)",
        "Larynx / Voice Box (for resonance)",
        "Facial Nerve (for oral pressure control)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Nasopharyngoscopy",
        "Speech Nasometry",
        "Videofluoroscopic Swallowing Study (VFSS)"
      ],
      "key_parameters": [
        "Velopharyngeal closure ratio",
        "Nasal airflow vs oral pressure balance",
        "Resonance profile during phoneme production"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Resonance and oral pressure exercises",
        "Nasal airflow control drills",
        "Speech sound shaping for plosives and fricatives",
        "Swallow and suction coordination activities"
      ],
      "energy_axis": "Velopharyngeal-Resonance",
      "dependencies": [
        "Pharynx",
        "Larynx / Voice Box",
        "Facial Nerve",
        "Oral Cavity"
      ]
    },
    "genetic_regulators": ["TBX22", "IRF6", "FGF8", "BMP4"],
    "weight": 35
  },
  {
    "id": 36,
    "name": "Eustachian Tube",
    "system": "Respiratory / Speech",
    "subsystem": "Middle Ear Link – Pressure Equalization and Drainage",
    "icd11_code": "XA0216",
    "icf_structure_code": "s250",
    "icf_function_code": "b230",
    "snomeD_code": "41695006",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 10,
      "critical_periods": ["0-4y", "6-9y"]
    },
    "functions": [
      "Equalization of air pressure between the middle ear and nasopharynx",
      "Drainage of mucus and fluid from the middle ear cavity",
      "Protection of the middle ear from nasopharyngeal secretions",
      "Regulation of tympanic membrane tension for sound conduction",
      "Contribution to auditory clarity and balance function"
    ],
    "developmental_domains": [
      "Sensory Integration",
      "Language Expression",
      "Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Hearing Sensitivity", "id": 2050 },
      { "name": "Auditory Processing & Discrimination", "id": 2078 },
      { "name": "Speech Perception", "id": 1757 },
      { "name": "Sound Localization", "id": 2060 },
      { "name": "Listening Skills", "id": 1699 }
    ],
    "readiness_contribution": {
      "speech": 35,
      "motor": 10,
      "behavior": 5,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 10,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Pharynx (Opening Mechanism)",
        "Tensor Veli Palatini and Levator Veli Palatini Muscles"
      ],
      "efferent_to": [
        "Middle Ear (Pressure Balance)",
        "Tympanic Membrane (Tension Regulation)",
        "Cochlea (Indirect Sound Transmission Stability)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Tympanometry",
        "Otoscopy",
        "Acoustic Reflex Testing"
      ],
      "key_parameters": [
        "Middle-ear pressure gradient",
        "Compliance of tympanic membrane",
        "Eustachian tube opening function (Toynbee/Valsalva maneuver)"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Blowing and swallowing exercises (autoinflation)",
        "Auditory attention training",
        "Breath control for pressure regulation",
        "Sound discrimination and echo exercises"
      ],
      "energy_axis": "Eustachian-Auditory",
      "dependencies": [
        "Middle Ear (Ossicles)",
        "Pharynx",
        "Cochlea",
        "Soft Palate / Velum"
      ]
    },
    "genetic_regulators": ["EYA1", "SIX1", "GJB2", "COL2A1"],
    "weight": 36
  },
  {
    "id": 37,
    "name": "Nasal Cavity & Paranasal Sinuses",
    "system": "Respiratory",
    "subsystem": "Upper Airway – Filtration, Resonance, and Airflow Regulation",
    "icd11_code": "XA0302",
    "icf_structure_code": "s330",
    "icf_function_code": "b440",
    "snomeD_code": "32062004",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 16,
      "critical_periods": ["0-6y", "8-14y"]
    },
    "functions": [
      "Filtration, humidification, and warming of inhaled air",
      "Regulation of nasal airflow and pressure",
      "Contribution to resonance and vocal tone quality",
      "Olfactory support for smell perception",
      "Immune defense through mucosal protection"
    ],
    "developmental_domains": [
      "Autonomic Coordination",
      "Language Expression",
      "Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Resonance Control", "id": 2004 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Smell Identification", "id": 2039 },
      { "name": "Oral-Nasal Airflow Balance", "id": 2040 }
    ],
    "readiness_contribution": {
      "speech": 30,
      "motor": 10,
      "behavior": 5,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 15,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "External Nasal Airflow",
        "Olfactory Epithelium",
        "Pharynx",
        "Paranasal Sinuses (Frontal, Maxillary, Ethmoid, Sphenoid)"
      ],
      "efferent_to": [
        "Pharynx and Larynx (Airflow and Resonance)",
        "Eustachian Tube (Pressure Balance)",
        "Olfactory Bulb (Sensory Transmission)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Rhinomanometry",
        "Nasal Endoscopy",
        "Acoustic Rhinometry"
      ],
      "key_parameters": [
        "Airflow resistance and nasal patency",
        "Resonance frequency profile",
        "Mucosal health and sinus drainage function"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Nasal breathing exercises",
        "Resonance training for speech clarity",
        "Smell re-education programs",
        "Airflow regulation and sinus clearing routines"
      ],
      "energy_axis": "Nasal-Respiratory",
      "dependencies": [
        "Pharynx",
        "Larynx / Voice Box",
        "Olfactory Epithelium",
        "Eustachian Tube"
      ]
    },
    "genetic_regulators": ["CFTR", "IRF6", "FGF8", "TBX22"],
    "weight": 37
  },
  {
    "id": 38,
    "name": "Trachea",
    "system": "Respiratory",
    "subsystem": "Lower Airway – Conduction Pathway for Respiration",
    "icd11_code": "XA0310",
    "icf_structure_code": "s430",
    "icf_function_code": "b440",
    "snomeD_code": "45206001",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0-6y"]
    },
    "functions": [
      "Conducting air between larynx and bronchi",
      "Maintaining airway patency through cartilaginous support",
      "Filtering, humidifying, and warming inspired air",
      "Cough reflex initiation and protection of lower airways",
      "Pressure regulation for phonation and breathing"
    ],
    "developmental_domains": [
      "Autonomic Coordination",
      "Language Expression",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Respiratory Endurance", "id": 2036 },
      { "name": "Cough and Airway Protection", "id": 2037 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 25,
      "motor": 15,
      "behavior": 5,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Larynx / Voice Box (Superior Airway Feedback)",
        "Vagus Nerve (CN X)",
        "Pharynx and Nasal Airflow Sensors"
      ],
      "efferent_to": [
        "Bronchi (Air Distribution)",
        "Lungs (Respiratory Exchange)",
        "Medulla Oblongata (Respiratory Centers)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Spirometry",
        "Airflow and Volume Measurement",
        "Bronchoscopy"
      ],
      "key_parameters": [
        "Airflow rate and resistance",
        "Cough reflex latency",
        "Tracheal patency and mucosal integrity"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Breath control and pacing exercises",
        "Cough and airway clearance training",
        "Speech breathing coordination tasks",
        "Respiratory strength and endurance drills"
      ],
      "energy_axis": "Tracheal-Respiratory",
      "dependencies": [
        "Larynx / Voice Box",
        "Bronchi",
        "Lungs",
        "Diaphragm"
      ]
    },
    "genetic_regulators": ["FGF10", "NKX2-1", "SOX2", "TBX4"],
    "weight": 38
  },
  {
    "id": 39,
    "name": "Bronchi",
    "system": "Respiratory",
    "subsystem": "Lower Airway – Pulmonary Air Distribution",
    "icd11_code": "XA0312",
    "icf_structure_code": "s430",
    "icf_function_code": "b440",
    "snomeD_code": "955009",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0-6y"]
    },
    "functions": [
      "Conduction of air between trachea and lungs",
      "Regulation of airflow resistance via smooth muscle contraction",
      "Distribution of oxygen to both lungs through bronchial branching",
      "Defense against inhaled particles via mucociliary clearance",
      "Integration with autonomic control for breathing rate and depth"
    ],
    "developmental_domains": [
      "Autonomic Coordination",
      "Motor Coordination",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Respiratory Endurance", "id": 2036 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Cough and Airway Protection", "id": 2037 },
      { "name": "Energy Management", "id": 2038 }
    ],
    "readiness_contribution": {
      "speech": 15,
      "motor": 15,
      "behavior": 5,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Trachea (Air Inflow)",
        "Vagus Nerve (Autonomic Control)",
        "Larynx / Voice Box (Air Pressure Feedback)"
      ],
      "efferent_to": [
        "Lungs (Alveolar Gas Exchange)",
        "Diaphragm (Respiratory Coordination)",
        "Medulla Oblongata (Breathing Rhythm Control)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Spirometry",
        "Bronchoscopy",
        "Peak Flow Measurement",
        "Pulmonary Function Testing (PFT)"
      ],
      "key_parameters": [
        "Forced Expiratory Volume (FEV1)",
        "Peak Expiratory Flow Rate (PEFR)",
        "Airway resistance and compliance"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Breathing control and pacing exercises",
        "Airway clearance and exhalation training",
        "Respiratory strength and endurance tasks",
        "Postural and diaphragmatic breathing drills"
      ],
      "energy_axis": "Bronchial-Respiratory",
      "dependencies": [
        "Trachea",
        "Lungs",
        "Diaphragm",
        "Vagus Nerve"
      ]
    },
    "genetic_regulators": ["NKX2-1", "FGF10", "TP63", "GATA6"],
    "weight": 39
  },
  {
    "id": 40,
    "name": "Lungs",
    "system": "Respiratory",
    "subsystem": "Pulmonary System – Gas Exchange and Respiratory Regulation",
    "icd11_code": "XA0313",
    "icf_structure_code": "s430",
    "icf_function_code": "b440",
    "snomeD_code": "39607008",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Alveolarization)", "0-3y", "8-14y"]
    },
    "functions": [
      "Exchange of oxygen and carbon dioxide through alveoli",
      "Maintenance of acid-base balance and pH homeostasis",
      "Support of speech through controlled airflow and subglottic pressure",
      "Respiratory rhythm and volume regulation in coordination with brainstem",
      "Immunologic defense via mucociliary and alveolar macrophage function"
    ],
    "developmental_domains": [
      "Autonomic Coordination",
      "Language Expression",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Respiratory Endurance", "id": 2036 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 }
    ],
    "readiness_contribution": {
      "speech": 30,
      "motor": 15,
      "behavior": 5,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Bronchi (Air Supply)",
        "Medulla Oblongata (Respiratory Centers)",
        "Vagus Nerve (Autonomic Feedback)"
      ],
      "efferent_to": [
        "Heart (Gas Exchange Feedback Loop)",
        "Diaphragm (Mechanical Regulation)",
        "Trachea (Air Expulsion)",
        "Blood / Circulatory System (Oxygen Transport)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Spirometry",
        "Pulse Oximetry",
        "Capnography",
        "Chest Radiography"
      ],
      "key_parameters": [
        "Forced Vital Capacity (FVC)",
        "Tidal Volume and Respiratory Rate",
        "Oxygen Saturation (SpO2)",
        "Alveolar Gas Exchange Efficiency"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Breathing and lung expansion exercises",
        "Diaphragmatic breathing control",
        "Speech breathing coordination drills",
        "Aerobic and endurance training"
      ],
      "energy_axis": "Pulmonary-Respiratory",
      "dependencies": [
        "Trachea",
        "Bronchi",
        "Diaphragm",
        "Heart"
      ]
    },
    "genetic_regulators": ["NKX2-1", "SFTPB", "SFTPC", "ABCA3"],
    "weight": 40
  },
  {
    "id": 41,
    "name": "Diaphragm",
    "system": "Musculoskeletal / Respiratory",
    "subsystem": "Respiratory Musculature – Primary Breathing Muscle",
    "icd11_code": "XA0400",
    "icf_structure_code": "s4301",
    "icf_function_code": "b4401",
    "snomeD_code": "181283003",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0-6y"]
    },
    "functions": [
      "Primary muscle of respiration enabling inhalation and exhalation",
      "Regulation of intra-thoracic and abdominal pressure",
      "Coordination with larynx and chest wall for speech breathing",
      "Support for coughing, swallowing, and postural stability",
      "Facilitation of relaxation and parasympathetic activation"
    ],
    "developmental_domains": [
      "Autonomic Coordination",
      "Language Expression",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Respiratory Endurance", "id": 2036 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Postural Stability", "id": 1702 }
    ],
    "readiness_contribution": {
      "speech": 30,
      "motor": 20,
      "behavior": 5,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Medulla Oblongata (Respiratory Center)",
        "Vagus Nerve (Autonomic Feedback)",
        "Phrenic Nerve (C3–C5 Spinal Roots)"
      ],
      "efferent_to": [
        "Lungs (Expansion and Contraction)",
        "Abdominal Organs (Pressure Regulation)",
        "Thoracic Cage (Rib Elevation Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Spirometry",
        "Ultrasound (Diaphragmatic Excursion)",
        "Respiratory Inductance Plethysmography"
      ],
      "key_parameters": [
        "Diaphragmatic excursion amplitude",
        "Inspiratory capacity",
        "Respiratory cycle synchronization"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Diaphragmatic breathing training",
        "Core stabilization exercises",
        "Speech breathing synchronization tasks",
        "Relaxation and parasympathetic activation therapy"
      ],
      "energy_axis": "Diaphragmatic-Respiratory",
      "dependencies": [
        "Lungs",
        "Bronchi",
        "Medulla Oblongata",
        "Vagus Nerve"
      ]
    },
    "genetic_regulators": ["MYOD1", "NKX2-1", "GATA4", "TBX4"],
    "weight": 41
  },
  {
    "id": 42,
    "name": "Heart",
    "system": "Cardiovascular",
    "subsystem": "Central Pump – Circulatory and Autonomic Regulation",
    "icd11_code": "XA0500",
    "icf_structure_code": "s410",
    "icf_function_code": "b410",
    "snomeD_code": "80891009",
    "loinc_param": null,
    "growth": {
      "formation_week": 3,
      "maturation_age_years": 1,
      "critical_periods": ["Prenatal", "0-2y"]
    },
    "functions": [
      "Circulatory pump maintaining oxygen and nutrient supply to tissues",
      "Regulation of blood pressure and cardiac rhythm",
      "Coordination with respiratory and autonomic systems",
      "Support of energy metabolism for motor and cognitive activity",
      "Heart–brain communication influencing emotion and arousal"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Motor Coordination",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Physical Endurance", "id": 2041 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 25,
      "behavior": 10,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Medulla Oblongata (Cardiac Control Centers)",
        "Vagus Nerve (Parasympathetic Regulation)",
        "Sympathetic Chain (T1–T5)"
      ],
      "efferent_to": [
        "Lungs (Gas Exchange Feedback Loop)",
        "Arteries and Veins (Circulatory Distribution)",
        "Brainstem (Baroreceptor Feedback)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Electrocardiography (ECG)",
        "Echocardiography",
        "Heart Rate Variability (HRV) Monitoring"
      ],
      "key_parameters": [
        "Heart rate and rhythm regularity",
        "Heart rate variability (RMSSD, SDNN)",
        "Cardiac output and ejection fraction"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Cardiorespiratory endurance training",
        "Biofeedback and HRV regulation exercises",
        "Relaxation and breathing control",
        "Emotional regulation and mindfulness therapy"
      ],
      "energy_axis": "Cardiac-Autonomic",
      "dependencies": [
        "Lungs",
        "Diaphragm",
        "Vagus Nerve",
        "Medulla Oblongata"
      ]
    },
    "genetic_regulators": ["NKX2-5", "GATA4", "TBX5", "MYH6"],
    "weight": 42
  },
  {
    "id": 43,
    "name": "Arteries",
    "system": "Cardiovascular",
    "subsystem": "Vascular Network – Oxygenated Blood Distribution",
    "icd11_code": "XA0510",
    "icf_structure_code": "s4101",
    "icf_function_code": "b4101",
    "snomeD_code": "51114001",
    "loinc_param": null,
    "growth": {
      "formation_week": 3,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0-6y"]
    },
    "functions": [
      "Transport of oxygen-rich blood from heart to tissues and organs",
      "Maintenance of systemic blood pressure through vascular tone",
      "Distribution of nutrients and hormones",
      "Assistance in thermoregulation via peripheral dilation and constriction",
      "Support of brain and muscle perfusion for cognitive and motor activity"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Motor Coordination",
      "Cognitive Readiness"
    ],
    "abilities_linked": [
      { "name": "Energy Management", "id": 2038 },
      { "name": "Physical Endurance", "id": 2041 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Attention Control", "id": 1801 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 25,
      "behavior": 10,
      "cognitive": 15,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Heart (Aortic Output)",
        "Autonomic Nervous System (Sympathetic Regulation)",
        "Endothelial Baroreceptors"
      ],
      "efferent_to": [
        "Brain (Cerebral Arteries)",
        "Muscles (Peripheral Perfusion)",
        "Organs (Oxygen Supply)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Blood Pressure Measurement",
        "Doppler Ultrasonography",
        "Angiography"
      ],
      "key_parameters": [
        "Systolic and diastolic pressure",
        "Vascular compliance and flow velocity",
        "Endothelial function and oxygen delivery index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Cardiovascular endurance training",
        "Deep breathing for vascular tone regulation",
        "Relaxation and biofeedback therapy",
        "Postural exercises to improve circulation"
      ],
      "energy_axis": "Arterial-Circulatory",
      "dependencies": [
        "Heart",
        "Veins",
        "Lungs",
        "Autonomic Nervous System"
      ]
    },
    "genetic_regulators": ["NOS3", "ACE", "AGT", "EDN1"],
    "weight": 43
  },
  {
    "id": 44,
    "name": "Veins",
    "system": "Cardiovascular",
    "subsystem": "Vascular Network – Deoxygenated Blood Return",
    "icd11_code": "XA0520",
    "icf_structure_code": "s4102",
    "icf_function_code": "b4102",
    "snomeD_code": "181268008",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0-6y"]
    },
    "functions": [
      "Return of deoxygenated blood from tissues to the heart",
      "Storage and regulation of blood volume",
      "Maintenance of venous pressure and capacitance",
      "Facilitation of thermoregulation and venous return via muscle pump",
      "Support for lymphatic and circulatory equilibrium"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Motor Coordination",
      "Energy Management"
    ],
    "abilities_linked": [
      { "name": "Energy Management", "id": 2038 },
      { "name": "Physical Endurance", "id": 2041 },
      { "name": "Postural Stability", "id": 1702 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Stress Coping Mechanisms", "id": 1701 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 20,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Peripheral Tissues (Venous Capillary Network)",
        "Skeletal Muscles (Muscle Pump)",
        "Autonomic Nervous System (Sympathetic Feedback)"
      ],
      "efferent_to": [
        "Heart (Right Atrium via Vena Cava)",
        "Lungs (for Reoxygenation)",
        "Lymphatic System (Fluid Balance Support)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Venous Doppler Ultrasonography",
        "Plethysmography",
        "Venous Pressure Monitoring"
      ],
      "key_parameters": [
        "Venous return efficiency",
        "Valve competence and reflux index",
        "Peripheral perfusion time"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Postural and circulation exercises",
        "Leg elevation and movement therapy",
        "Breathing and relaxation techniques",
        "Endurance training for vascular return"
      ],
      "energy_axis": "Venous-Circulatory",
      "dependencies": [
        "Heart",
        "Arteries",
        "Lungs",
        "Musculoskeletal System"
      ]
    },
    "genetic_regulators": ["F5", "F2", "VEGFA", "NOS3"],
    "weight": 44
  },
  {
    "id": 45,
    "name": "Blood",
    "system": "Immune",
    "subsystem": "Circulatory Medium – Oxygen Transport and Immune Defense",
    "icd11_code": "XA0530",
    "icf_structure_code": "s4103",
    "icf_function_code": "b430",
    "snomeD_code": "23451007",
    "loinc_param": null,
    "growth": {
      "formation_week": 3,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Hematopoiesis)", "0-3y", "8-14y"]
    },
    "functions": [
      "Transport of oxygen, carbon dioxide, nutrients, and hormones",
      "Maintenance of acid-base and fluid balance",
      "Immune surveillance via leukocytes and antibodies",
      "Coagulation and wound healing",
      "Temperature regulation and homeostasis"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Energy Management",
      "Health Readiness and Immune Regulation"
    ],
    "abilities_linked": [
      { "name": "Energy Management", "id": 2038 },
      { "name": "Physical Endurance", "id": 2041 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Immunity and Healing", "id": 2042 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 15,
      "behavior": 5,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Bone Marrow (Erythropoiesis)",
        "Spleen (RBC Recycling)",
        "Lungs (Oxygenation)",
        "Digestive Tract (Nutrient Absorption)"
      ],
      "efferent_to": [
        "Heart (Circulatory Distribution)",
        "All Body Organs (Oxygen and Nutrient Delivery)",
        "Kidneys (Erythropoietin Regulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Complete Blood Count (CBC)",
        "Hemoglobin and Hematocrit Levels",
        "Blood Oxygen Saturation (SpO2)"
      ],
      "key_parameters": [
        "Hemoglobin concentration",
        "White blood cell and platelet count",
        "Oxygen-carrying capacity and blood viscosity"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Aerobic endurance activities",
        "Nutritional and hydration optimization",
        "Stress reduction for immune regulation",
        "Breathing and relaxation therapy for oxygen efficiency"
      ],
      "energy_axis": "Hematologic-Circulatory",
      "dependencies": [
        "Heart",
        "Lungs",
        "Bone Marrow",
        "Spleen"
      ]
    },
    "genetic_regulators": ["HBB", "G6PD", "EPO", "HBA1"],
    "weight": 45
  },
  {
    "id": 46,
    "name": "Spleen",
    "system": "Lymphatic / Immune",
    "subsystem": "Secondary Lymphoid Organ – Filtration and Immune Response",
    "icd11_code": "XA0600",
    "icf_structure_code": "s420",
    "icf_function_code": "b435",
    "snomeD_code": "78961009",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 15,
      "critical_periods": ["0-5y", "10-14y"]
    },
    "functions": [
      "Filtration of blood and removal of old or damaged red blood cells",
      "Immune surveillance and antibody production",
      "Storage and release of lymphocytes and platelets",
      "Support for hematopoietic and immune system maturation",
      "Maintenance of fluid and infection defense balance"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Self-Sufficiency",
      "Health Readiness"
    ],
    "abilities_linked": [
      { "name": "Immunity and Healing", "id": 2042 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Blood / Circulatory System",
        "Lymphatic Vessels",
        "Bone Marrow (Immune Cell Supply)"
      ],
      "efferent_to": [
        "Immune System (Lymphocytes, Antibodies)",
        "Liver (RBC Recycling Coordination)",
        "Bone Marrow (Hematologic Feedback)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Ultrasound",
        "MRI (Splenic Volume Assessment)",
        "Complete Blood Count (CBC) with Differential"
      ],
      "key_parameters": [
        "Spleen size and vascularity",
        "Lymphocyte and monocyte counts",
        "Immune response activation rate"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Immunity strengthening routines",
        "Stress reduction and relaxation training",
        "Nutrition and hydration balance for immunity",
        "Mild aerobic exercise for lymphatic circulation"
      ],
      "energy_axis": "Lymphatic-Immune",
      "dependencies": [
        "Blood / Hematologic System",
        "Liver",
        "Thymus",
        "Lymph Nodes"
      ]
    },
    "genetic_regulators": ["IL6", "HLA-DQB1", "TNF", "CXCL13"],
    "weight": 46
  },
  {
    "id": 47,
    "name": "Thymus",
    "system": "Lymphatic / Endocrine",
    "subsystem": "Primary Lymphoid Organ – Immune Maturation Center",
    "icd11_code": "XA0601",
    "icf_structure_code": "s420",
    "icf_function_code": "b435",
    "snomeD_code": "69748006",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 12,
      "critical_periods": ["0-10y (Peak Function)", "Puberty (Involution Phase)"]
    },
    "functions": [
      "Maturation and differentiation of T-lymphocytes (T cells)",
      "Regulation of adaptive immune response",
      "Development of immune tolerance to self-antigens",
      "Support for endocrine and immune cross-talk",
      "Critical role in early-life immune system programming"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Health Readiness",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Immunity and Healing", "id": 2042 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 20
    },
    "connectivity": {
      "afferent_from": [
        "Bone Marrow (Immature T-Cells)",
        "Endocrine System (Cortisol, Growth Hormones)",
        "Blood / Circulation (Antigen Presentation)"
      ],
      "efferent_to": [
        "Lymph Nodes (Mature T-Cell Distribution)",
        "Spleen (Immune Activation)",
        "Peripheral Blood (T-Cell Circulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "MRI (Thymic Volume)",
        "T-Cell Count (CD4/CD8 Ratio)",
        "Flow Cytometry"
      ],
      "key_parameters": [
        "Thymic size and signal intensity",
        "CD4/CD8 T-cell balance",
        "Markers of immune maturity (Naïve vs Memory T-Cells)"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Immune modulation through balanced nutrition",
        "Stress-reduction and mindfulness therapy",
        "Controlled physical activity for immune support",
        "Sleep and circadian rhythm optimization"
      ],
      "energy_axis": "Thymic-Immune",
      "dependencies": [
        "Spleen",
        "Lymph Nodes",
        "Endocrine System (Cortisol / Growth Hormones)"
      ]
    },
    "genetic_regulators": ["FOXN1", "IL7R", "AIRE", "PTPN22"],
    "weight": 47
  },
  {
    "id": 48,
    "name": "Tonsils",
    "system": "Lymphatic / Immune",
    "subsystem": "Lymphoid Tissue – Immune Barrier for Upper Airway and Digestive Tract",
    "icd11_code": "XA0602",
    "icf_structure_code": "s4201",
    "icf_function_code": "b435",
    "snomeD_code": "23486003",
    "loinc_param": null,
    "growth": {
      "formation_week": 9,
      "maturation_age_years": 10,
      "critical_periods": ["0-8y", "10-14y"]
    },
    "functions": [
      "First line of immune defense for respiratory and digestive tracts",
      "Production of antibodies against inhaled or ingested pathogens",
      "Sampling of antigens entering via oral and nasal routes",
      "Support for immune memory formation",
      "Contribution to vocal resonance and airway protection"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Health Readiness",
      "Language Expression"
    ],
    "abilities_linked": [
      { "name": "Immunity and Healing", "id": 2042 },
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Resonance Control", "id": 2004 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Stress Coping Mechanisms", "id": 1701 }
    ],
    "readiness_contribution": {
      "speech": 25,
      "motor": 10,
      "behavior": 10,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 20,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Oral Cavity",
        "Pharynx",
        "Nasal Cavity & Paranasal Sinuses",
        "Lymphatic Vessels"
      ],
      "efferent_to": [
        "Lymph Nodes (Immune Signaling)",
        "Spleen (Antibody Coordination)",
        "Immune System (Systemic Response)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Oropharyngeal Examination",
        "Ultrasound or MRI (Tonsillar Volume)",
        "CBC with Differential (Immune Response)"
      ],
      "key_parameters": [
        "Tonsil size and symmetry",
        "Inflammation index (Tonsillitis Frequency)",
        "Antibody activity and immune cell count"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Respiratory and resonance exercises",
        "Immunity-boosting nutrition and hydration programs",
        "Speech and airflow control therapy",
        "Breathing and nasal hygiene routines"
      ],
      "energy_axis": "Pharyngeal-Immune",
      "dependencies": [
        "Pharynx",
        "Nasal Cavity & Sinuses",
        "Lymph Nodes",
        "Spleen"
      ]
    },
    "genetic_regulators": ["HLA-DQB1", "IL6", "TNF", "FOXP3"],
    "weight": 48
  },
  {
    "id": 49,
    "name": "Lymph Nodes",
    "system": "Lymphatic / Immune",
    "subsystem": "Peripheral Lymphoid Organs – Filtration and Immune Activation",
    "icd11_code": "XA0603",
    "icf_structure_code": "s4200",
    "icf_function_code": "b435",
    "snomeD_code": "85756007",
    "loinc_param": null,
    "growth": {
      "formation_week": 8,
      "maturation_age_years": 16,
      "critical_periods": ["0-10y", "Adolescence"]
    },
    "functions": [
      "Filtration of lymphatic fluid for pathogen and debris removal",
      "Activation and proliferation of lymphocytes during immune response",
      "Maintenance of fluid balance and waste clearance",
      "Facilitation of antigen presentation and immune memory formation",
      "Drainage and defense network across body systems"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Health Readiness",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Immunity and Healing", "id": 2042 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Lymphatic Vessels (Peripheral Lymph Flow)",
        "Tonsils (Head and Neck Immune Input)",
        "Spleen (Immune Coordination)"
      ],
      "efferent_to": [
        "Thoracic Duct (Central Lymph Drainage)",
        "Bloodstream (Via Venous Angle)",
        "Immune Cells (Systemic Activation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Ultrasound (Node Size and Vascularity)",
        "MRI (Lymphatic Mapping)",
        "CBC and Lymphocyte Profile"
      ],
      "key_parameters": [
        "Node size, number, and distribution",
        "Reactive vs normal morphology",
        "Lymphocyte activation and cytokine markers"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Lymphatic drainage massage and mobilization",
        "Mild aerobic activity for fluid circulation",
        "Immunity and hydration support routines",
        "Stress management and relaxation therapies"
      ],
      "energy_axis": "Lymphatic-Immune",
      "dependencies": [
        "Spleen",
        "Thymus",
        "Lymphatic Vessels",
        "Thoracic Duct"
      ]
    },
    "genetic_regulators": ["LYVE1", "VEGFC", "PROX1", "CCL21"],
    "weight": 49
  },
  {
    "id": 50,
    "name": "Lymphatic Vessels & Thoracic Duct",
    "system": "Lymphatic / Immune",
    "subsystem": "Lymph Transport Network – Fluid Balance and Immune Circulation",
    "icd11_code": "XA0604",
    "icf_structure_code": "s4202",
    "icf_function_code": "b435",
    "snomeD_code": "181263009",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 15,
      "critical_periods": ["Prenatal", "0-10y"]
    },
    "functions": [
      "Transport of lymph fluid from tissues to bloodstream",
      "Removal of waste, toxins, and cellular debris",
      "Circulation of immune cells throughout the body",
      "Maintenance of tissue fluid balance and edema prevention",
      "Integration with cardiovascular system for homeostasis"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Health Readiness",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Immunity and Healing", "id": 2042 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Peripheral Lymphatic Capillaries",
        "Lymph Nodes (Regional Drainage)",
        "Tonsils and Thymus (Immune Components)"
      ],
      "efferent_to": [
        "Thoracic Duct (Main Lymphatic Conduit)",
        "Venous Angle (Left Subclavian Vein)",
        "Spleen (Immune Cell Distribution)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Lymphoscintigraphy",
        "MRI Lymphangiography",
        "Bioimpedance Analysis (Fluid Balance)"
      ],
      "key_parameters": [
        "Lymph flow rate and clearance time",
        "Presence of lymphatic obstruction or reflux",
        "Thoracic duct patency and diameter"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Manual lymphatic drainage (MLD)",
        "Whole-body mobility and stretching",
        "Hydration and nutrition therapy",
        "Deep breathing and thoracic expansion exercises"
      ],
      "energy_axis": "Lymphatic-Circulatory",
      "dependencies": [
        "Lymph Nodes",
        "Spleen",
        "Veins",
        "Diaphragm"
      ]
    },
    "genetic_regulators": ["FLT4", "VEGFC", "PROX1", "FOXC2"],
    "weight": 50
  },
  {
    "id": 51,
    "name": "Pituitary Gland",
    "system": "Endocrine",
    "subsystem": "Hypophyseal Complex – Master Hormonal Regulator",
    "icd11_code": "XA0700",
    "icf_structure_code": "s5550",
    "icf_function_code": "b555",
    "snomeD_code": "181261006",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal", "0-2y", "Puberty"]
    },
    "functions": [
      "Secretion of growth hormone (GH), thyroid-stimulating hormone (TSH), and adrenocorticotropic hormone (ACTH)",
      "Regulation of metabolism, reproduction, and stress response",
      "Coordination of endocrine organ activities across body systems",
      "Control of physical growth and sexual maturation",
      "Integration with hypothalamus for homeostatic balance"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Energy Management", "id": 2038 },
      { "name": "Growth Regulation", "id": 2044 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 15,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Hypothalamus (Releasing Hormones)",
        "Bloodstream (Hormonal Feedback)",
        "Limbic System (Stress and Emotion Signals)"
      ],
      "efferent_to": [
        "Thyroid Gland",
        "Adrenal Glands",
        "Gonads (Testes / Ovaries)",
        "Liver (Growth Hormone Regulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Hormone Panel (GH, ACTH, TSH, LH, FSH, Prolactin)",
        "MRI (Pituitary Volume and Morphology)",
        "Endocrine Function Tests"
      ],
      "key_parameters": [
        "Growth hormone and cortisol levels",
        "Pituitary size and stalk integrity",
        "Feedback loop response to releasing hormones"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Hormonal regulation and supplementation (if deficient)",
        "Stress-reduction and circadian rhythm training",
        "Balanced nutrition and physical activity",
        "Biofeedback and mindfulness for endocrine stability"
      ],
      "energy_axis": "Pituitary-Endocrine",
      "dependencies": [
        "Hypothalamus",
        "Thyroid Gland",
        "Adrenal Glands",
        "Gonads"
      ]
    },
    "genetic_regulators": ["PROP1", "POU1F1", "HESX1", "GH1"],
    "weight": 51
  },
  {
    "id": 52,
    "name": "Pineal Gland",
    "system": "Endocrine",
    "subsystem": "Epithalamus – Circadian and Neuroendocrine Regulation",
    "icd11_code": "XA0701",
    "icf_structure_code": "s5551",
    "icf_function_code": "b134",
    "snomeD_code": "181262004",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 10,
      "critical_periods": ["Prenatal", "0-5y", "Puberty"]
    },
    "functions": [
      "Secretion of melatonin to regulate sleep–wake cycles",
      "Integration of light exposure with biological rhythms",
      "Support of growth and immune regulation via circadian control",
      "Modulation of emotional stability through serotonin–melatonin pathways",
      "Influence on puberty timing and hormonal rhythm"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Sleep Regulation", "id": 1700 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 15,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Retina (Light Input via Retinohypothalamic Tract)",
        "Suprachiasmatic Nucleus (Circadian Control)",
        "Hypothalamus (Endocrine Regulation)"
      ],
      "efferent_to": [
        "Pituitary Gland",
        "Hypothalamus",
        "Limbic System (Mood Modulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Melatonin Level Testing (Salivary / Serum)",
        "Polysomnography (Sleep Study)",
        "Actigraphy (Circadian Rhythm Assessment)"
      ],
      "key_parameters": [
        "Melatonin secretion onset and amplitude",
        "Sleep efficiency and total duration",
        "Light exposure vs. hormonal rhythm correlation"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Sleep hygiene routines",
        "Light exposure therapy (morning light / blue-blocking at night)",
        "Circadian rhythm regulation programs",
        "Relaxation and mindfulness exercises"
      ],
      "energy_axis": "Pineal-Circadian",
      "dependencies": [
        "Hypothalamus",
        "Pituitary Gland",
        "Retina (Light Perception Pathway)"
      ]
    },
    "genetic_regulators": ["AANAT", "ASMT", "MTNR1A", "MTNR1B"],
    "weight": 52
  },
  {
    "id": 53,
    "name": "Thyroid Gland",
    "system": "Endocrine",
    "subsystem": "Cervical Region – Metabolic and Growth Regulator",
    "icd11_code": "XA0702",
    "icf_structure_code": "s5552",
    "icf_function_code": "b555",
    "snomeD_code": "69748002",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 16,
      "critical_periods": ["Prenatal", "0-2y", "Puberty"]
    },
    "functions": [
      "Production of thyroid hormones (T3 and T4) regulating metabolism and growth",
      "Maintenance of basal metabolic rate and oxygen consumption",
      "Support of brain and nervous system development in early life",
      "Regulation of temperature, energy, and weight balance",
      "Coordination with pituitary and hypothalamus via hormonal feedback loops"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Cognitive Readiness",
      "Energy Management"
    ],
    "abilities_linked": [
      { "name": "Energy Management", "id": 2038 },
      { "name": "Growth Regulation", "id": 2044 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Attention Control", "id": 1801 },
      { "name": "Stress Coping Mechanisms", "id": 1701 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 20,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Pituitary Gland (Thyroid-Stimulating Hormone, TSH)",
        "Hypothalamus (Thyrotropin-Releasing Hormone, TRH)",
        "Circulatory System (Iodine and Nutrient Delivery)"
      ],
      "efferent_to": [
        "Brain (Cognitive Development and Neural Activity)",
        "Heart (Metabolic Rate Regulation)",
        "Muscles (Energy Utilization)",
        "Liver (Metabolic Conversion)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Thyroid Function Tests (TSH, T3, T4)",
        "Ultrasound (Thyroid Volume and Nodules)",
        "Metabolic Rate Evaluation"
      ],
      "key_parameters": [
        "Serum TSH, Free T3, Free T4 levels",
        "Thyroid volume and vascularity",
        "Basal metabolic rate index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Hormonal supplementation or regulation therapy (if deficient)",
        "Nutritional optimization (iodine, selenium)",
        "Stress reduction and circadian balance training",
        "Energy management and mindfulness routines"
      ],
      "energy_axis": "Thyroid-Endocrine",
      "dependencies": [
        "Pituitary Gland",
        "Hypothalamus",
        "Heart",
        "Liver"
      ]
    },
    "genetic_regulators": ["FOXE1", "TG", "TPO", "TSHR"],
    "weight": 53
  },
  {
    "id": 54,
    "name": "Parathyroid Glands",
    "system": "Endocrine",
    "subsystem": "Cervical Region – Calcium and Bone Metabolism Control",
    "icd11_code": "XA0703",
    "icf_structure_code": "s5553",
    "icf_function_code": "b555",
    "snomeD_code": "181265001",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0-5y", "Adolescence"]
    },
    "functions": [
      "Regulation of calcium and phosphate balance in blood and tissues",
      "Stimulation of bone resorption and calcium mobilization through PTH secretion",
      "Coordination with kidneys and intestines for calcium absorption",
      "Maintenance of neuromuscular excitability and muscle contraction",
      "Support for skeletal development and bone mineralization"
    ],
    "developmental_domains": [
      "Health Readiness and Self-Sufficiency",
      "Motor Coordination",
      "Health Readiness and Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Postural Stability", "id": 1702 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Physical Endurance", "id": 2041 },
      { "name": "Stress Coping Mechanisms", "id": 1701 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 20,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Thyroid Gland (Shared Blood Supply)",
        "Bone (Calcium Feedback)",
        "Kidneys (Calcium and Vitamin D Regulation)"
      ],
      "efferent_to": [
        "Bones (Calcium Release)",
        "Kidneys (Calcium Reabsorption)",
        "Intestines (Vitamin D Activation for Absorption)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Serum PTH Measurement",
        "Calcium and Phosphate Levels",
        "DEXA Scan (Bone Mineral Density)"
      ],
      "key_parameters": [
        "Parathyroid hormone concentration",
        "Serum calcium and phosphate ratio",
        "Bone density and mineral content"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Nutritional and calcium–vitamin D regulation",
        "Muscle tone and postural training",
        "Stress and endocrine balance management",
        "Physical activity for bone strengthening"
      ],
      "energy_axis": "Parathyroid-Endocrine",
      "dependencies": [
        "Thyroid Gland",
        "Bones",
        "Kidneys",
        "Liver (Vitamin D Metabolism)"
      ]
    },
    "genetic_regulators": ["GCM2", "CASR", "PTH", "VDR"],
    "weight": 54
  },
  {
    "id": 55,
    "name": "Adrenal Glands",
    "system": "Endocrine",
    "subsystem": "Suprarenal System – Stress and Metabolic Regulation",
    "icd11_code": "XA0704",
    "icf_structure_code": "s5554",
    "icf_function_code": "b555",
    "snomeD_code": "181264002",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal", "0-5y", "Puberty"]
    },
    "functions": [
      "Secretion of cortisol, adrenaline, and aldosterone for stress and metabolic control",
      "Regulation of blood pressure, glucose, and electrolyte balance",
      "Activation of fight-or-flight and recovery mechanisms",
      "Support for energy distribution and physical endurance",
      "Integration of emotional and physiological stress responses"
    ],
    "developmental_domains": [
      "Behavioral Regulation",
      "Energy Management and Health Readiness",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Motivational Drive", "id": 1705 },
      { "name": "Emotional Expression", "id": 1754 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 15,
      "behavior": 30,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 20,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Hypothalamus (CRH Signal)",
        "Pituitary Gland (ACTH Stimulation)",
        "Autonomic Nervous System (Sympathetic Input)"
      ],
      "efferent_to": [
        "Heart (Cardiac Output Control)",
        "Liver (Glucose Regulation)",
        "Kidneys (Sodium and Water Balance)",
        "Immune System (Anti-inflammatory Modulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Cortisol and ACTH Hormone Panel",
        "Electrolyte and Glucose Profiling",
        "Blood Pressure and HRV Analysis"
      ],
      "key_parameters": [
        "Serum cortisol rhythm (morning/evening)",
        "ACTH stimulation test results",
        "Sympathetic tone and adrenal response index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Stress management and relaxation training",
        "Mindfulness and resilience programs",
        "Balanced nutrition and hydration routines",
        "Cardiorespiratory regulation and energy optimization"
      ],
      "energy_axis": "Adrenal-Stress",
      "dependencies": [
        "Hypothalamus",
        "Pituitary Gland",
        "Heart",
        "Kidneys"
      ]
    },
    "genetic_regulators": ["MC2R", "CYP11B1", "STAR", "NR5A1"],
    "weight": 55
  },
  {
    "id": 56,
    "name": "Pancreas",
    "system": "Endocrine / Digestive",
    "subsystem": "Abdominal Gland – Metabolic and Digestive Enzyme Regulation",
    "icd11_code": "XA0705",
    "icf_structure_code": "s540",
    "icf_function_code": "b540",
    "snomeD_code": "15776009",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 15,
      "critical_periods": ["Prenatal", "0-6y", "Puberty"]
    },
    "functions": [
      "Secretion of insulin and glucagon to regulate blood glucose levels",
      "Production of digestive enzymes (amylase, lipase, trypsin)",
      "Coordination of metabolism and nutrient absorption",
      "Regulation of energy utilization and storage",
      "Integration of endocrine and digestive system signaling"
    ],
    "developmental_domains": [
      "Energy Management",
      "Energy Management",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Routine Following", "id": 1674 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Hypothalamus (Energy Demand Signals)",
        "Liver (Glucose Feedback)",
        "Digestive Tract (Hormonal Input – Incretins)"
      ],
      "efferent_to": [
        "Liver (Glycogen Metabolism)",
        "Muscles (Glucose Uptake)",
        "Adipose Tissue (Energy Storage)",
        "Digestive System (Enzyme Release Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Fasting Blood Glucose and Insulin Levels",
        "HbA1c Test",
        "C-Peptide and Lipase Assays"
      ],
      "key_parameters": [
        "Insulin sensitivity index",
        "Pancreatic enzyme activity levels",
        "Postprandial glucose variation"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Balanced nutrition and glycemic control routines",
        "Physical activity for insulin sensitivity",
        "Stress management and mindfulness practices",
        "Hydration and digestive health maintenance"
      ],
      "energy_axis": "Pancreatic-Metabolic",
      "dependencies": [
        "Liver",
        "Hypothalamus",
        "Adrenal Glands",
        "Digestive Tract"
      ]
    },
    "genetic_regulators": ["INS", "GCK", "PDX1", "HNF1A"],
    "weight": 56
  },
  {
    "id": 57,
    "name": "Salivary Glands",
    "system": "Digestive",
    "subsystem": "Accessory Glands – Oral Lubrication and Enzyme Secretion",
    "icd11_code": "XA0800",
    "icf_structure_code": "s3201",
    "icf_function_code": "b510",
    "snomeD_code": "181771001",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 10,
      "critical_periods": ["0-5y", "7-12y"]
    },
    "functions": [
      "Secretion of saliva to lubricate food and facilitate swallowing",
      "Initiation of digestion through amylase and lipase enzymes",
      "Maintenance of oral hygiene and pH balance",
      "Moistening of vocal tract for speech production",
      "Contribution to taste perception and oral comfort"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Language Expression",
      "Feeding & Swallowing"
    ],
    "abilities_linked": [
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Speech Intelligibility", "id": 1758 },
      { "name": "Taste Differentiation", "id": 2020 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 30,
      "motor": 10,
      "behavior": 5,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Facial Nerve (CN VII)",
        "Glossopharyngeal Nerve (CN IX)",
        "Oral Cavity (Mechanical Stimulation)",
        "Tongue / Taste Buds (Chemosensory Feedback)"
      ],
      "efferent_to": [
        "Oral Cavity (Lubrication)",
        "Pharynx (Swallowing Coordination)",
        "Esophagus (Food Transit)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Sialometry (Salivary Flow Rate)",
        "Salivary pH Measurement",
        "Ultrasound or MRI (Gland Volume)"
      ],
      "key_parameters": [
        "Resting and stimulated salivary flow rate",
        "Saliva viscosity and enzyme content",
        "pH balance and antibacterial activity"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Chewing and oral stimulation activities",
        "Hydration and swallowing therapy",
        "Speech resonance and oral pressure exercises",
        "Sensory oral desensitization programs"
      ],
      "energy_axis": "Salivary-Oral",
      "dependencies": [
        "Oral Cavity",
        "Pharynx",
        "Tongue / Taste Buds",
        "Facial Nerve (CN VII)"
      ]
    },
    "genetic_regulators": ["AQP5", "MUC7", "PRB1", "AMY1A"],
    "weight": 57
  },
  {
    "id": 58,
    "name": "Esophagus",
    "system": "Digestive",
    "subsystem": "Upper Digestive Tract – Swallowing and Food Transit",
    "icd11_code": "XA0810",
    "icf_structure_code": "s330",
    "icf_function_code": "b5102",
    "snomeD_code": "32849002",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0-4y"]
    },
    "functions": [
      "Transportation of food and liquids from pharynx to stomach",
      "Coordination of peristaltic muscle contractions for swallowing",
      "Prevention of reflux through upper and lower esophageal sphincters",
      "Support for safe feeding and airway protection",
      "Integration of sensory and motor feedback during swallowing"
    ],
    "developmental_domains": [
      "Feeding & Swallowing",
      "Self-Sufficiency",
      "Motor Coordination"
    ],
    "abilities_linked": [
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Swallowing Control", "id": 2046 },
      { "name": "Breathing Coordination", "id": 2003 },
      { "name": "Oral Motor Control", "id": 1756 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 15,
      "motor": 15,
      "behavior": 5,
      "cognitive": 5,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Pharynx (Swallowing Initiation)",
        "Vagus Nerve (CN X)",
        "Glossopharyngeal Nerve (CN IX)"
      ],
      "efferent_to": [
        "Stomach (Bolus Entry)",
        "Medulla Oblongata (Swallowing Reflex Centers)",
        "Respiratory System (Airway Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Videofluoroscopic Swallow Study (VFSS)",
        "Esophageal Manometry",
        "Endoscopy"
      ],
      "key_parameters": [
        "Swallow timing and bolus transit speed",
        "Esophageal peristaltic amplitude",
        "Sphincter opening coordination and reflux index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Swallowing rehabilitation and posture training",
        "Oral-motor and feeding therapy",
        "Respiratory–swallow coordination exercises",
        "Texture and bolus control programs"
      ],
      "energy_axis": "Esophageal-Digestive",
      "dependencies": [
        "Pharynx",
        "Larynx / Voice Box",
        "Stomach",
        "Vagus Nerve"
      ]
    },
    "genetic_regulators": ["FGF10", "SOX2", "NKX2-1", "GDNF"],
    "weight": 58
  },
  {
    "id": 59,
    "name": "Stomach",
    "system": "Digestive",
    "subsystem": "Upper Digestive Tract – Gastric Processing and Enzymatic Breakdown",
    "icd11_code": "XA0820",
    "icf_structure_code": "s4104",
    "icf_function_code": "b515",
    "snomeD_code": "69695003",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0-5y", "Adolescence"]
    },
    "functions": [
      "Mechanical and chemical digestion of ingested food",
      "Secretion of gastric acid and digestive enzymes",
      "Regulation of gastric emptying into small intestine",
      "Coordination with autonomic system for hunger and satiety",
      "Maintenance of microbiome balance and immune defense"
    ],
    "developmental_domains": [
      "Feeding & Swallowing and Self-Sufficiency",
      "Energy Management",
      "Health Readiness"
    ],
    "abilities_linked": [
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Stress Coping Mechanisms", "id": 1701 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Esophagus (Bolus Input)",
        "Vagus Nerve (Autonomic Feedback)",
        "Hypothalamus (Hunger and Satiety Control)"
      ],
      "efferent_to": [
        "Small Intestine (Chyme Delivery)",
        "Liver and Pancreas (Digestive Coordination)",
        "Autonomic Centers (Digestive Reflex Regulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Endoscopy",
        "Gastric Emptying Study",
        "pH and Enzyme Analysis"
      ],
      "key_parameters": [
        "Gastric acid output and pH range",
        "Peristaltic motility rhythm",
        "Emptying rate and nutrient absorption efficiency"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Nutritional regulation and meal-timing training",
        "Breathing and relaxation for digestion control",
        "Proprioceptive and mindfulness feeding routines",
        "Stress-reduction and gut–brain axis therapy"
      ],
      "energy_axis": "Gastric-Metabolic",
      "dependencies": [
        "Esophagus",
        "Small Intestine",
        "Liver",
        "Pancreas",
        "Vagus Nerve"
      ]
    },
    "genetic_regulators": ["GHRL", "CCK", "ATP4A", "PGA5"],
    "weight": 59
  },
  {
    "id": 60,
    "name": "Liver",
    "system": "Digestive",
    "subsystem": "Hepatobiliary System – Metabolism, Detoxification, and Energy Regulation",
    "icd11_code": "XA0830",
    "icf_structure_code": "s4105",
    "icf_function_code": "b540",
    "snomeD_code": "10200004",
    "loinc_param": null,
    "growth": {
      "formation_week": 4,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal", "0-6y", "Adolescence"]
    },
    "functions": [
      "Metabolism of carbohydrates, proteins, and fats for energy regulation",
      "Detoxification of metabolic waste and environmental toxins",
      "Synthesis of essential plasma proteins and clotting factors",
      "Storage and release of glycogen, vitamins, and minerals",
      "Regulation of hormones and immune mediators for systemic balance"
    ],
    "developmental_domains": [
      "Energy Management",
      "Health Readiness",
      "Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Growth Regulation", "id": 2044 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Immunity and Healing", "id": 2042 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Digestive Tract (Nutrient Input via Portal Vein)",
        "Pancreas (Insulin and Glucagon Signaling)",
        "Hypothalamus (Energy Demand Signals)"
      ],
      "efferent_to": [
        "Bloodstream (Metabolite Distribution)",
        "Gallbladder (Bile Storage)",
        "Small Intestine (Bile Secretion for Digestion)",
        "Kidneys (Waste Excretion Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Liver Function Tests (ALT, AST, ALP, Bilirubin)",
        "Ultrasound / Elastography",
        "Serum Albumin and Protein Profile"
      ],
      "key_parameters": [
        "Transaminase enzyme activity",
        "Bilirubin levels and bile flow rate",
        "Liver stiffness (fibrosis index)"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Nutritional and hydration management",
        "Detoxification and metabolic regulation programs",
        "Breathing and energy-balancing exercises",
        "Relaxation and stress reduction to lower hepatic load"
      ],
      "energy_axis": "Hepatic-Metabolic",
      "dependencies": [
        "Pancreas",
        "Gallbladder",
        "Small Intestine",
        "Kidneys"
      ]
    },
    "genetic_regulators": ["ALB", "CYP3A4", "HNF4A", "G6PC"],
    "weight": 60
  },
  {
    "id": 61,
    "name": "Gallbladder",
    "system": "Digestive",
    "subsystem": "Hepatobiliary System – Bile Storage and Fat Digestion",
    "icd11_code": "XA0840",
    "icf_structure_code": "s4106",
    "icf_function_code": "b515",
    "snomeD_code": "28231008",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 12,
      "critical_periods": ["Prenatal", "0-5y", "Adolescence"]
    },
    "functions": [
      "Storage and controlled release of bile produced by the liver",
      "Facilitation of fat emulsification and lipid digestion",
      "Regulation of bile flow through coordination with pancreas and intestine",
      "Support for nutrient absorption in the small intestine",
      "Detoxification support and digestive efficiency"
    ],
    "developmental_domains": [
      "Feeding & Swallowing and Self-Sufficiency",
      "Energy Management",
    ],
    "abilities_linked": [
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Stress Coping Mechanisms", "id": 1701 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 5,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Liver (Bile Production via Hepatic Ducts)",
        "Vagus Nerve (Autonomic Control)",
        "Digestive Tract Hormones (CCK Feedback)"
      ],
      "efferent_to": [
        "Small Intestine (Bile Release via Common Bile Duct)",
        "Liver (Feedback Regulation of Bile Secretion)",
        "Pancreas (Digestive Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Ultrasound (Biliary Tract Imaging)",
        "HIDA Scan (Bile Flow Assessment)",
        "Liver Function Tests (Bilirubin, ALP)"
      ],
      "key_parameters": [
        "Gallbladder ejection fraction",
        "Bile duct patency and flow rate",
        "Biliary enzyme activity"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Nutritional and fat-digestion training",
        "Postural exercises for digestion",
        "Hydration and detox routines",
        "Dietary regulation with healthy fat inclusion"
      ],
      "energy_axis": "Hepatobiliary-Digestive",
      "dependencies": [
        "Liver",
        "Pancreas",
        "Small Intestine",
        "Vagus Nerve"
      ]
    },
    "genetic_regulators": ["ABCB4", "ABCB11", "FXR (NR1H4)", "UGT1A1"],
    "weight": 61
  },
  {
    "id": 62,
    "name": "Small Intestine",
    "system": "Digestive",
    "subsystem": "Intestinal Tract – Nutrient Absorption and Enzymatic Digestion",
    "icd11_code": "XA0850",
    "icf_structure_code": "s5400",
    "icf_function_code": "b515",
    "snomeD_code": "30315005",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0-6y", "Adolescence"]
    },
    "functions": [
      "Absorption of nutrients, vitamins, and minerals from digested food",
      "Completion of enzymatic digestion of proteins, fats, and carbohydrates",
      "Coordination with pancreas and liver for bile and enzyme regulation",
      "Maintenance of gut microbiome balance and immune defense",
      "Regulation of peristalsis and intestinal motility"
    ],
    "developmental_domains": [
      "Feeding & Swallowing and Self-Sufficiency",
      "Energy Management",
      "Health Readiness"
    ],
    "abilities_linked": [
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Immunity and Healing", "id": 2042 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Stomach (Chyme Delivery)",
        "Pancreas (Digestive Enzymes)",
        "Liver and Gallbladder (Bile Secretion)"
      ],
      "efferent_to": [
        "Large Intestine (Residual Waste Transfer)",
        "Lymphatic System (Nutrient Transport via Lacteals)",
        "Portal Circulation (Nutrient Absorption Feedback)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Endoscopy / Enteroscopy",
        "Breath Test (Malabsorption Studies)",
        "Stool Analysis (Fat, Microbiome Profile)"
      ],
      "key_parameters": [
        "Nutrient absorption efficiency (glucose, iron, B12)",
        "Digestive enzyme levels (amylase, lipase)",
        "Microbiome diversity and gut integrity markers"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Nutritional balance and feeding routines",
        "Probiotic and gut-health management",
        "Hydration and digestion training",
        "Stress reduction to optimize gut–brain communication"
      ],
      "energy_axis": "Intestinal-Metabolic",
      "dependencies": [
        "Stomach",
        "Pancreas",
        "Liver",
        "Large Intestine"
      ]
    },
    "genetic_regulators": ["LCT", "SLC5A1", "APOA1", "CFTR"],
    "weight": 62
  },
  {
    "id": 63,
    "name": "Large Intestine",
    "system": "Digestive",
    "subsystem": "Intestinal Tract – Water Absorption and Waste Formation",
    "icd11_code": "XA0851",
    "icf_structure_code": "s5401",
    "icf_function_code": "b525",
    "snomeD_code": "71854001",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["0-6y", "Adolescence"]
    },
    "functions": [
      "Absorption of water and electrolytes from digested material",
      "Formation and storage of fecal waste for elimination",
      "Maintenance of gut microbiome and immune homeostasis",
      "Fermentation of undigested carbohydrates by beneficial bacteria",
      "Regulation of bowel movement and digestive rhythm"
    ],
    "developmental_domains": [
      "Health Readiness and Self-Sufficiency",
      "Feeding & Swallowing",
      "Routine Regulation and Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Feeding Independence", "id": 1707 },
      { "name": "Toileting Independence", "id": 1675 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 35,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Small Intestine (Chyme Residue)",
        "Enteric Nervous System (Peristaltic Feedback)",
        "Autonomic Nervous System (Parasympathetic Control)"
      ],
      "efferent_to": [
        "Rectum (Fecal Storage and Elimination)",
        "Liver (Microbial Metabolite Feedback)",
        "Immune System (Microbiome Signaling)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Colonoscopy",
        "Stool Microbiome Analysis",
        "Abdominal X-Ray or Transit Study"
      ],
      "key_parameters": [
        "Transit time and bowel motility",
        "Water absorption efficiency",
        "Microbial composition and diversity index"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Dietary fiber and hydration management",
        "Routine bowel training for toileting skills",
        "Probiotic therapy for microbiome regulation",
        "Stress and anxiety management for gut–brain balance"
      ],
      "energy_axis": "Colonic-Digestive",
      "dependencies": [
        "Small Intestine",
        "Rectum",
        "Autonomic Nervous System",
        "Liver"
      ]
    },
    "genetic_regulators": ["MUC2", "SLC26A3", "CFTR", "IL10"],
    "weight": 63
  },
  {
    "id": 64,
    "name": "Rectum",
    "system": "Digestive",
    "subsystem": "Lower Intestinal Tract – Fecal Storage and Expulsion Control",
    "icd11_code": "XA0860",
    "icf_structure_code": "s5403",
    "icf_function_code": "b525",
    "snomeD_code": "34402009",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 10,
      "critical_periods": ["0-5y (Toileting Skill Development)", "Adolescence"]
    },
    "functions": [
      "Temporary storage of fecal material before elimination",
      "Coordination of voluntary and involuntary sphincter control",
      "Integration of sensory feedback for defecation reflexes",
      "Maintenance of continence and hygiene",
      "Support for digestive rhythm and bodily awareness"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Routine Regulation",
      "Motor Coordination and Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Toileting Independence", "id": 1675 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Adaptive Daily Living Skills", "id": 2047 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 35,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Large Intestine (Fecal Transit)",
        "Autonomic Nervous System (Rectal Sensory Receptors)",
        "Pelvic Floor Muscles"
      ],
      "efferent_to": [
        "Anal Canal / Anus (Sphincter Control)",
        "Spinal Cord (Defecation Reflex Pathways)",
        "Brainstem (Autonomic Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Manometry (Rectal Pressure and Reflex Testing)",
        "Defecography (Functional Imaging)",
        "Sensory Threshold and Tone Assessment"
      ],
      "key_parameters": [
        "Rectal compliance and capacity",
        "Sphincter tone and reflex response",
        "Coordination of abdominal and pelvic muscle activity"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Toilet training and schedule establishment",
        "Pelvic floor muscle strengthening",
        "Sensory awareness and regulation exercises",
        "Behavioral reinforcement for continence"
      ],
      "energy_axis": "Rectal-Autonomic",
      "dependencies": [
        "Large Intestine",
        "Anal Canal / Anus",
        "Pelvic Floor Muscles",
        "Autonomic Nervous System"
      ]
    },
    "genetic_regulators": ["RET", "EDNRB", "NRTN", "PHOX2B"],
    "weight": 65
  },
  {
    "id": 65,
    "name": "Anus",
    "system": "Digestive",
    "subsystem": "Terminal Digestive Tract – Elimination and Sphincter Control",
    "icd11_code": "XA0861",
    "icf_structure_code": "s5404",
    "icf_function_code": "b5250",
    "snomeD_code": "34402008",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 8,
      "critical_periods": ["0-5y (Toileting Skill Development)"]
    },
    "functions": [
      "Regulation of defecation through internal and external sphincter control",
      "Coordination of sensory awareness for toileting and cleanliness",
      "Maintenance of continence and voluntary elimination",
      "Integration with pelvic muscles for posture and excretion",
      "Support for digestive completion and self-care routines"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Motor Coordination",
      "Routine Regulation and Self-Sufficiency"
    ],
    "abilities_linked": [
      { "name": "Toileting Independence", "id": 1675 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Adaptive Daily Living Skills", "id": 2047 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 40,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Rectum (Fecal Storage and Reflex Input)",
        "Pelvic Floor Muscles (Motor and Sensory Feedback)",
        "Autonomic Nervous System (Internal Sphincter Control)"
      ],
      "efferent_to": [
        "Spinal Cord (Reflex Arc)",
        "Somatic Motor Neurons (External Sphincter Control)",
        "Cerebral Cortex (Voluntary Control and Awareness)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Anorectal Manometry",
        "Electromyography (Pelvic Floor and Sphincter)",
        "Defecography or MRI Pelvic Floor Imaging"
      ],
      "key_parameters": [
        "Resting and squeeze pressure of sphincter muscles",
        "Recto-anal inhibitory reflex presence",
        "Sensory threshold and coordination timing"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Toileting training and routine establishment",
        "Pelvic floor and sphincter muscle strengthening",
        "Sensory feedback and awareness training",
        "Behavioral reinforcement for continence and hygiene"
      ],
      "energy_axis": "Anal-Autonomic",
      "dependencies": [
        "Rectum",
        "Pelvic Floor Muscles",
        "Spinal Cord",
        "Autonomic Nervous System"
      ]
    },
    "genetic_regulators": ["RET", "EDN3", "SOX10", "PHOX2B"],
    "weight": 66
  },
  {
    "id": 66,
    "name": "Kidneys",
    "system": "Urinary",
    "subsystem": "Renal System – Filtration and Homeostatic Regulation",
    "icd11_code": "XA0900",
    "icf_structure_code": "s610",
    "icf_function_code": "b610",
    "snomeD_code": "64033007",
    "loinc_param": null,
    "growth": {
      "formation_week": 5,
      "maturation_age_years": 14,
      "critical_periods": ["Prenatal", "0-5y", "Adolescence"]
    },
    "functions": [
      "Filtration of blood to remove waste, toxins, and excess water",
      "Regulation of electrolyte balance and blood pressure",
      "Maintenance of acid–base equilibrium in the body",
      "Secretion of erythropoietin for red blood cell production",
      "Activation of vitamin D for calcium and bone metabolism"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Self-Sufficiency",
      "Energy Management"
    ],
    "abilities_linked": [
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Immunity and Healing", "id": 2042 },
      { "name": "Routine Following", "id": 1674 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Blood / Circulatory System (Renal Arteries)",
        "Endocrine System (Aldosterone, ADH Regulation)",
        "Sympathetic Nervous System"
      ],
      "efferent_to": [
        "Urinary Bladder (Urine Excretion)",
        "Bloodstream (Reabsorbed Nutrients and Water)",
        "Bone Marrow (via Erythropoietin for RBC Production)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Serum Creatinine and BUN Tests",
        "Glomerular Filtration Rate (GFR) Calculation",
        "Ultrasound or CT (Renal Morphology)"
      ],
      "key_parameters": [
        "GFR and serum creatinine ratio",
        "Electrolyte concentration (Na⁺, K⁺, Cl⁻)",
        "Urine specific gravity and osmolality"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Hydration and electrolyte management",
        "Nutrition and detoxification support",
        "Relaxation and stress modulation to support renal flow",
        "Physical activity to enhance circulation and waste elimination"
      ],
      "energy_axis": "Renal-Metabolic",
      "dependencies": [
        "Heart",
        "Liver",
        "Adrenal Glands",
        "Urinary Bladder"
      ]
    },
    "genetic_regulators": ["PKD1", "UMOD", "NPHS1", "WT1"],
    "weight": 67
  },
  {
    "id": 67,
    "name": "Ureters",
    "system": "Urinary",
    "subsystem": "Renal Transport – Urine Conduction from Kidneys to Bladder",
    "icd11_code": "XA0910",
    "icf_structure_code": "s620",
    "icf_function_code": "b620",
    "snomeD_code": "181269000",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 10,
      "critical_periods": ["Prenatal", "0-4y"]
    },
    "functions": [
      "Transportation of urine from kidneys to urinary bladder",
      "Prevention of urine backflow via peristaltic movement and valve mechanisms",
      "Maintenance of one-way renal drainage to preserve kidney health",
      "Integration with autonomic nervous system for smooth muscle control",
      "Support for hydration and excretory balance"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Health Readiness",
      "Autonomic Coordination"
    ],
    "abilities_linked": [
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Toileting Independence", "id": 1675 },
      { "name": "Energy Management", "id": 2038 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 35,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Kidneys (Urine Formation)",
        "Autonomic Nervous System (Peristaltic Regulation)",
        "Adrenal Glands (Stress Response Feedback)"
      ],
      "efferent_to": [
        "Urinary Bladder (Storage and Pressure Control)",
        "Renal Pelvis (Upstream Drainage Feedback)",
        "Spinal Cord (Micturition Reflex Pathway)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Ultrasound (Ureteral Patency)",
        "Voiding Cystourethrogram (VCUG)",
        "CT Urography"
      ],
      "key_parameters": [
        "Ureteral peristalsis frequency and amplitude",
        "Reflux index and flow directionality",
        "Hydronephrosis or obstruction presence"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Hydration and urinary regulation programs",
        "Bladder training and timed voiding routines",
        "Biofeedback for autonomic control",
        "Pelvic relaxation and muscle coordination exercises"
      ],
      "energy_axis": "Ureteric-Autonomic",
      "dependencies": [
        "Kidneys",
        "Urinary Bladder",
        "Adrenal Glands",
        "Spinal Cord"
      ]
    },
    "genetic_regulators": ["PAX2", "GDNF", "RET", "EYA1"],
    "weight": 68
  },
  {
    "id": 68,
    "name": "Urinary Bladder",
    "system": "Urinary",
    "subsystem": "Storage Organ – Urine Collection and Micturition Control",
    "icd11_code": "XA0920",
    "icf_structure_code": "s630",
    "icf_function_code": "b6200",
    "snomeD_code": "89837001",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 8,
      "critical_periods": ["0-5y (Toileting Maturity)"]
    },
    "functions": [
      "Storage and controlled release of urine through coordinated sphincter activity",
      "Maintenance of urinary continence and bladder capacity regulation",
      "Sensory signaling for urge perception and voiding control",
      "Integration of somatic and autonomic pathways for micturition reflex",
      "Contribution to independence and self-care skills in daily routines"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Routine Regulation",
      "Motor Coordination and Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Toileting Independence", "id": 1675 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Adaptive Daily Living Skills", "id": 2047 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 40,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Ureters (Urine Inflow)",
        "Pelvic Floor Muscles (Pressure and Sensory Feedback)",
        "Autonomic Nervous System (Parasympathetic Control)"
      ],
      "efferent_to": [
        "Urethra (Urine Outflow)",
        "Spinal Cord (Micturition Reflex Pathway)",
        "Cerebral Cortex (Conscious Control)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Urodynamic Study (Bladder Pressure and Capacity)",
        "Ultrasound (Residual Volume)",
        "Urinalysis (Infection or Protein Levels)"
      ],
      "key_parameters": [
        "Bladder compliance and capacity",
        "Detrusor muscle contraction strength",
        "Coordination between bladder and sphincter activity"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Toilet training and routine establishment",
        "Pelvic floor and bladder control exercises",
        "Hydration and fluid intake regulation",
        "Biofeedback for sensory awareness and bladder reflex management"
      ],
      "energy_axis": "Bladder-Autonomic",
      "dependencies": [
        "Kidneys",
        "Ureters",
        "Urethra",
        "Spinal Cord"
      ]
    },
    "genetic_regulators": ["HPSE2", "LRIG2", "UPK3A", "ROBO2"],
    "weight": 69
  },
  {
    "id": 69,
    "name": "Urethra",
    "system": "Urinary",
    "subsystem": "Outflow Tract – Voluntary and Reflexive Urine Release Pathway",
    "icd11_code": "XA0930",
    "icf_structure_code": "s640",
    "icf_function_code": "b6201",
    "snomeD_code": "181270004",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 8,
      "critical_periods": ["0-5y (Toileting Development)"]
    },
    "functions": [
      "Conduction of urine from the bladder to the external environment",
      "Maintenance of continence through internal and external sphincter coordination",
      "Control of voluntary and reflexive voiding mechanisms",
      "Protection of urinary tract against infection through flow regulation",
      "Sexual and reproductive role in males as an ejaculatory duct"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Routine Regulation",
      "Motor Coordination and Sensory Integration"
    ],
    "abilities_linked": [
      { "name": "Toileting Independence", "id": 1675 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Adaptive Daily Living Skills", "id": 2047 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 40,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Urinary Bladder (Urine Flow Initiation)",
        "Autonomic Nervous System (Internal Sphincter Control)",
        "Pelvic Floor Muscles (Somatic Feedback)"
      ],
      "efferent_to": [
        "External Environment (Urine Outflow)",
        "Spinal Cord (Reflexive Voiding)",
        "Cerebral Cortex (Conscious Control of Micturition)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Urodynamic Study (Flow and Pressure Analysis)",
        "Uroflowmetry",
        "Cystoscopy (Structural Evaluation)"
      ],
      "key_parameters": [
        "Flow rate and duration",
        "Urethral resistance index",
        "Sphincter coordination and control timing"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Toileting and continence training",
        "Pelvic muscle strengthening exercises",
        "Sensory feedback and flow awareness tasks",
        "Behavioral routines for hydration and voiding timing"
      ],
      "energy_axis": "Urethral-Autonomic",
      "dependencies": [
        "Urinary Bladder",
        "Kidneys",
        "Spinal Cord",
        "Pelvic Floor Muscles"
      ]
    },
    "genetic_regulators": ["HOXA13", "FGF8", "BMP7", "SRY"],
    "weight": 70
  },
  {
    "id": 70,
    "name": "Testes",
    "system": "Reproductive",
    "subsystem": "Gonadal System – Sperm and Hormone Production",
    "icd11_code": "XA1000",
    "icf_structure_code": "s720",
    "icf_function_code": "b640",
    "snomeD_code": "40689003",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Descent)", "Puberty (Spermatogenesis Activation)"]
    },
    "functions": [
      "Production of sperm (spermatogenesis) for reproduction",
      "Secretion of testosterone regulating male sexual development",
      "Influence on muscle growth, bone density, and energy metabolism",
      "Support for motivation, drive, and assertive behavior through androgen signaling",
      "Contribution to secondary sexual characteristics during puberty"
    ],
    "developmental_domains": [
      "Health Readiness and Health Readiness",
      "Self-Sufficiency",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Motivational Drive", "id": 1705 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 20,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Pituitary Gland (LH and FSH Signaling)",
        "Hypothalamus (GnRH Control)",
        "Adrenal Glands (Hormonal Feedback)"
      ],
      "efferent_to": [
        "Seminal Vesicles (Semen Formation)",
        "Prostate Gland (Secretion Regulation)",
        "Endocrine System (Testosterone Feedback Loop)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Hormone Profile (Testosterone, LH, FSH)",
        "Scrotal Ultrasound",
        "Semen Analysis"
      ],
      "key_parameters": [
        "Serum testosterone concentration",
        "Sperm count and motility",
        "FSH/LH ratio and pituitary response"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Endocrine and hormonal regulation therapy",
        "Physical activity and strength-building programs",
        "Stress management and lifestyle modification",
        "Nutritional support for reproductive health"
      ],
      "energy_axis": "Testicular-Endocrine",
      "dependencies": [
        "Pituitary Gland",
        "Hypothalamus",
        "Adrenal Glands",
        "Prostate"
      ]
    },
    "genetic_regulators": ["SRY", "NR5A1", "AR", "FSHR"],
    "gender": "male",
    "weight": 71
  },
  {
    "id": 71,
    "name": "Prostate",
    "system": "Reproductive",
    "subsystem": "Accessory Gland – Seminal Fluid Production and Ejaculatory Regulation",
    "icd11_code": "XA1010",
    "icf_structure_code": "s730",
    "icf_function_code": "b6401",
    "snomeD_code": "41216001",
    "loinc_param": null,
    "growth": {
      "formation_week": 10,
      "maturation_age_years": 18,
      "critical_periods": ["Puberty", "Adolescence (Hormonal Surge)"]
    },
    "functions": [
      "Production of seminal fluid for sperm nourishment and motility",
      "Regulation of ejaculatory and urinary flow via smooth muscle control",
      "Secretion of enzymes supporting fertility and pH balance",
      "Endocrine interaction with testosterone metabolism",
      "Contribution to reproductive reflexes and hormonal feedback"
    ],
    "developmental_domains": [
      "Health Readiness and Health Readiness",
      "Self-Sufficiency",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Motivational Drive", "id": 1705 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 15,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Testes (Hormonal Feedback via Testosterone)",
        "Pituitary Gland (LH and FSH Control)",
        "Autonomic Nervous System (Pelvic Plexus)"
      ],
      "efferent_to": [
        "Urethra (Ejaculatory Duct Junction)",
        "Seminal Vesicles (Fluid Coordination)",
        "Bladder Neck (Sphincter Regulation)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Prostate-Specific Antigen (PSA) Test",
        "Ultrasound / MRI (Prostate Volume)",
        "Hormonal Profile (Testosterone, DHT)"
      ],
      "key_parameters": [
        "PSA concentration and trend analysis",
        "Prostate volume and flow rate",
        "Androgen receptor activity and hormonal balance"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Pelvic floor strengthening exercises",
        "Hormonal regulation therapy",
        "Hydration and urinary flow management",
        "Stress reduction and relaxation routines"
      ],
      "energy_axis": "Prostatic-Endocrine",
      "dependencies": [
        "Testes",
        "Seminal Vesicles",
        "Urethra",
        "Pituitary Gland"
      ]
    },
    "genetic_regulators": ["SRD5A2", "AR", "KLK3", "HNF1B"],
    "gender": "male",
    "weight": 72
  },
  {
    "id": 72,
    "name": "Seminal Vesicles",
    "system": "Reproductive",
    "subsystem": "Accessory Glands – Seminal Fluid and Nutrient Secretion",
    "icd11_code": "XA1020",
    "icf_structure_code": "s731",
    "icf_function_code": "b6402",
    "snomeD_code": "24558003",
    "loinc_param": null,
    "growth": {
      "formation_week": 10,
      "maturation_age_years": 18,
      "critical_periods": ["Puberty", "Adolescence"]
    },
    "functions": [
      "Production of seminal fluid rich in fructose and proteins to nourish sperm",
      "Contribution to sperm motility and fertility via fluid secretion",
      "Storage and controlled release of seminal plasma during ejaculation",
      "Coordination with prostate and vas deferens for reproductive reflexes",
      "Maintenance of pH and enzymatic environment for sperm survival"
    ],
    "developmental_domains": [
      "Health Readiness and Health Readiness",
      "Self-Sufficiency",
      "Endocrine Regulation"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Motivational Drive", "id": 1705 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 15,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Testes (Sperm Input via Vas Deferens)",
        "Prostate (Hormonal and Secretory Coordination)",
        "Pituitary Gland (FSH/LH Regulation)"
      ],
      "efferent_to": [
        "Ejaculatory Ducts (Seminal Fluid Output)",
        "Urethra (Ejaculate Conduction)",
        "Autonomic Nervous System (Emission Reflex Control)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Transrectal Ultrasound (TRUS)",
        "Semen Analysis (Volume and Composition)",
        "Hormonal Panel (Testosterone, FSH, LH)"
      ],
      "key_parameters": [
        "Seminal fluid volume and fructose concentration",
        "Viscosity and sperm motility support index",
        "Gland size and structural symmetry"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Endocrine balance optimization (hormonal monitoring)",
        "Physical fitness and stress reduction for hormonal stability",
        "Nutritional support for male reproductive health",
        "Hydration and metabolic regulation exercises"
      ],
      "energy_axis": "Seminal-Endocrine",
      "dependencies": [
        "Testes",
        "Prostate",
        "Vas Deferens",
        "Pituitary Gland"
      ]
    },
    "genetic_regulators": ["AR", "FSHR", "LHB", "NR5A1"],
    "gender": "male",
    "weight": 73
  },
  {
    "id": 73,
    "name": "Bulbourethral Glands",
    "system": "Reproductive",
    "subsystem": "Accessory Glands – Pre-Ejaculate Secretion and Urethral Lubrication",
    "icd11_code": "XA1030",
    "icf_structure_code": "s732",
    "icf_function_code": "b6403",
    "snomeD_code": "24559009",
    "loinc_param": null,
    "growth": {
      "formation_week": 11,
      "maturation_age_years": 18,
      "critical_periods": ["Puberty", "Adolescence"]
    },
    "functions": [
      "Secretion of pre-ejaculate fluid to neutralize urethral acidity",
      "Lubrication of the urethra for sperm passage",
      "Protection of sperm from mechanical and chemical damage",
      "Support for smooth ejaculation reflex and flow control",
      "Maintenance of reproductive tract hygiene and function"
    ],
    "developmental_domains": [
      "Reproductive Readiness",
      "Self-Sufficiency",
      "Endocrine Regulation"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Motivational Drive", "id": 1705 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Prostate (Secretory Coordination)",
        "Testes (Hormonal Feedback via Testosterone)",
        "Autonomic Nervous System (Pelvic Reflex Centers)"
      ],
      "efferent_to": [
        "Urethra (Lubrication Secretion)",
        "Seminal Vesicles (Reproductive Synchronization)",
        "Prostate (Emission and Flow Coordination)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Transrectal Ultrasound (TRUS)",
        "Semen Analysis (pH and Viscosity)",
        "Hormonal Panel (Testosterone, LH, FSH)"
      ],
      "key_parameters": [
        "Pre-ejaculate volume and pH neutrality",
        "Gland size and secretion rate",
        "Hormonal response to pituitary signaling"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Endocrine system balancing through nutrition and lifestyle",
        "Stress modulation to normalize hormonal flow",
        "Pelvic floor strengthening for autonomic control",
        "Hydration and detoxification routines"
      ],
      "energy_axis": "Bulbourethral-Endocrine",
      "dependencies": [
        "Prostate",
        "Seminal Vesicles",
        "Urethra",
        "Pituitary Gland"
      ]
    },
    "genetic_regulators": ["AR", "NR5A1", "HNF1B", "LHB"],
    "gender": "male",
    "weight": 74
  },
  {
    "id": 74,
    "name": "Penis / Scrotum",
    "system": "Reproductive",
    "subsystem": "External Genitalia – Reproductive and Urinary Interface",
    "icd11_code": "XA1040",
    "icf_structure_code": "s740",
    "icf_function_code": "b6404",
    "snomeD_code": "181271000",
    "loinc_param": null,
    "growth": {
      "formation_week": 8,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Genital Differentiation)", "Puberty (Sexual Maturation)"]
    },
    "functions": [
      "Facilitation of urination and reproductive function through urethral passage",
      "Erection and ejaculation via vascular and neural regulation",
      "Protection and thermoregulation of testes within scrotal sac",
      "Contribution to sexual identity and reproductive readiness",
      "Integration of sensory and autonomic pathways for reflex control"
    ],
    "developmental_domains": [
      "Self-Sufficiency",
      "Reproductive Readiness",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Motivational Drive", "id": 1705 },
      { "name": "Adaptive Daily Living Skills", "id": 2047 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 15,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Testes (Hormonal and Neural Feedback)",
        "Pelvic Nerves (Somatic Sensory Input)",
        "Autonomic Nervous System (Sympathetic and Parasympathetic Control)"
      ],
      "efferent_to": [
        "Urethra (Urinary and Ejaculatory Flow)",
        "Brainstem (Reflexive Control)",
        "Spinal Cord (Sexual Reflex Pathways)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Physical Examination (Tanner Staging)",
        "Penile Doppler Ultrasound (Vascular Flow)",
        "Hormone Assay (Testosterone, LH, FSH)"
      ],
      "key_parameters": [
        "Blood flow velocity and erection quality index",
        "Hormonal maturation and secondary sexual characteristics",
        "Thermal regulation efficiency of scrotal environment"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Endocrine and reproductive health counseling",
        "Body awareness and self-regulation training",
        "Pelvic and postural strengthening exercises",
        "Lifestyle and nutritional optimization for hormonal health"
      ],
      "energy_axis": "Genital-Endocrine",
      "dependencies": [
        "Testes",
        "Prostate",
        "Urethra",
        "Autonomic Nervous System"
      ]
    },
    "genetic_regulators": ["SRY", "AR", "FGF8", "HOXA13"],
    "gender": "male",
    "weight": 75
  }, {
    "id": 75,
    "name": "Appendix",
    "system": "Digestive / Lymphatic",
    "subsystem": "Appendicular Structure – Immune and Microbiome Reservoir",
    "icd11_code": "XA0852",
    "icf_structure_code": "s5402",
    "icf_function_code": "b525",
    "snomeD_code": "66754008",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 12,
      "critical_periods": ["0-6y", "Adolescence"]
    },
    "functions": [
      "Maintenance of gut microbiota as a bio-reservoir during infection or dysbiosis",
      "Facilitation of immune response via lymphoid follicles",
      "Coordination between digestive and immune systems",
      "Support for recovery after gastrointestinal infections",
      "Potential contribution to regulation of mucosal immunity and tolerance"
    ],
    "developmental_domains": [
      "Health Readiness",
      "Feeding & Swallowing"
    ],
    "abilities_linked": [
      { "name": "Immunity and Healing", "id": 2042 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Routine Following", "id": 1674 },
      { "name": "Self-Regulation", "id": 1721 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 5,
      "behavior": 10,
      "cognitive": 10,
      "social": 5,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Large Intestine (Cecum)",
        "Lymphatic System (Immune Feedback)",
        "Microbiome Signals (Bacterial Communication)"
      ],
      "efferent_to": [
        "Lymph Nodes (Immune Activation)",
        "Colon (Microbial Repopulation)",
        "Bloodstream (Immune Signaling Molecules)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Ultrasound (Appendix Size and Inflammation)",
        "MRI / CT Scan (Appendiceal Health)",
        "Microbiome Profile Testing"
      ],
      "key_parameters": [
        "Appendiceal wall thickness",
        "Lymphoid activity level",
        "Microbial diversity correlation with immune state"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Gut microbiome restoration through probiotics",
        "Immune support nutrition and hydration",
        "Stress management to regulate gut–immune axis",
        "Post-infection digestive rehabilitation"
      ],
      "energy_axis": "Appendicular-Immune",
      "dependencies": [
        "Large Intestine",
        "Spleen",
        "Lymph Nodes",
        "Liver"
      ]
    },
    "genetic_regulators": ["IL6", "NOD2", "FUT2", "MUC2"],

    "weight": 64
  },
  {
    "id": 76,
    "name": "Ovaries",
    "system": "Reproductive",
    "subsystem": "Gonadal System – Hormonal and Reproductive Regulation",
    "icd11_code": "XA1050",
    "icf_structure_code": "s750",
    "icf_function_code": "b650",
    "snomeD_code": "15497006",
    "loinc_param": null,
    "growth": {
      "formation_week": 6,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Follicle Formation)", "Puberty (Menstrual Onset)"]
    },
    "functions": [
      "Production of ova (egg cells) for reproduction",
      "Secretion of estrogen and progesterone for menstrual regulation",
      "Control of puberty, growth, and secondary sexual characteristics",
      "Regulation of bone density, mood, and energy metabolism",
      "Coordination with pituitary and hypothalamic hormonal feedback loops"
    ],
    "developmental_domains": [
      "Health Readiness and Health Readiness",
      "Health Readiness",
      "Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Stress Coping Mechanisms", "id": 1701 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 15,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 30,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Pituitary Gland (LH and FSH Hormones)",
        "Hypothalamus (GnRH Signaling)",
        "Adrenal Glands (Androgen Modulation)"
      ],
      "efferent_to": [
        "Uterus (Menstrual and Reproductive Coordination)",
        "Fallopian Tubes (Ovulation Pathway)",
        "Endocrine System (Estrogen / Progesterone Feedback)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Hormone Profile (Estrogen, Progesterone, LH, FSH)",
        "Pelvic Ultrasound",
        "Ovarian Reserve Tests (AMH Levels)"
      ],
      "key_parameters": [
        "Hormonal cycle regulation and balance",
        "Follicular development and ovulation frequency",
        "Ovarian volume and structural health"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Hormonal balance and nutritional regulation",
        "Stress and mood regulation through mindfulness",
        "Physical activity to improve endocrine health",
        "Lifestyle therapy for menstrual rhythm and fertility support"
      ],
      "energy_axis": "Ovarian-Endocrine",
      "dependencies": [
        "Pituitary Gland",
        "Hypothalamus",
        "Uterus",
        "Adrenal Glands"
      ]
    },
    "genetic_regulators": ["FSHR", "LHR", "CYP19A1", "ESR1"],
    "gender": "female",
    "weight": 76
  },
  {
    "id": 77,
    "name": "Fallopian Tubes",
    "system": "Reproductive",
    "subsystem": "Duct System – Ovum Transport and Fertilization Site",
    "icd11_code": "XA1060",
    "icf_structure_code": "s751",
    "icf_function_code": "b6501",
    "snomeD_code": "31435000",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Duct Formation)", "Puberty (Reproductive Maturity)"]
    },
    "functions": [
      "Transport of ovum from ovary to uterus via ciliary motion and peristalsis",
      "Site of fertilization and early embryonic development",
      "Coordination of hormonal environment for implantation readiness",
      "Facilitation of communication between ovaries and uterus",
      "Maintenance of pelvic and reproductive health"
    ],
    "developmental_domains": [
      "Reproductive Readiness",
      "Health Readiness and Maturation",
      "Health Readiness and Hormonal Balance"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Immunity and Healing", "id": 2042 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Ovaries (Ovum and Hormonal Input)",
        "Uterus (Hormonal Feedback)",
        "Autonomic Nervous System (Peristaltic Control)"
      ],
      "efferent_to": [
        "Uterus (Zygote / Embryo Transport)",
        "Peritoneal Cavity (Ciliary Drainage Pathway)",
        "Endocrine System (Hormonal Signaling Feedback)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Hysterosalpingography (Tubal Patency)",
        "Pelvic Ultrasound / Sonohysterography",
        "Laparoscopy (Structural Visualization)"
      ],
      "key_parameters": [
        "Tubal patency and ciliary motility",
        "Lumen diameter and muscular coordination",
        "Hormonal synchronization during ovulation"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Reproductive system strengthening through yoga and pelvic exercises",
        "Hormonal balance and stress reduction routines",
        "Nutritional and hydration support for reproductive wellness",
        "Circulatory and detoxification therapy for pelvic health"
      ],
      "energy_axis": "Tubal-Reproductive",
      "dependencies": [
        "Ovaries",
        "Uterus",
        "Pituitary Gland",
        "Hypothalamus"
      ]
    },
    "genetic_regulators": ["WNT4", "ESR1", "FSHR", "CYP19A1"],
    "gender": "female",
    "weight": 77
  },
  {
    "id": 78,
    "name": "Uterus / Cervix",
    "system": "Reproductive",
    "subsystem": "Pelvic Organ – Gestation, Menstrual Regulation, and Hormonal Integration",
    "icd11_code": "XA1070",
    "icf_structure_code": "s760",
    "icf_function_code": "b6502",
    "snomeD_code": "35039007",
    "loinc_param": null,
    "growth": {
      "formation_week": 7,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Formation)", "Puberty (Menstrual Onset)", "Reproductive Years"]
    },
    "functions": [
      "Facilitation of embryo implantation and fetal development",
      "Regulation of menstrual cycle through hormonal feedback",
      "Coordination of uterine contractions during labor and menstruation",
      "Protection and nourishment of embryo via endometrial lining",
      "Integration with cervix for barrier, support, and childbirth readiness"
    ],
    "developmental_domains": [
      "Reproductive Readiness",
      "Endocrine Regulation",
      "Health Readiness and Health Readiness"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Body Awareness & Protection", "id": 2043 },
      { "name": "Immunity and Healing", "id": 2042 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 10,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Ovaries (Hormonal and Ovulatory Input)",
        "Pituitary Gland (LH/FSH Signaling)",
        "Hypothalamus (GnRH Control)",
        "Autonomic Nervous System (Parasympathetic Regulation)"
      ],
      "efferent_to": [
        "Vagina (Menstrual Flow and Childbirth Pathway)",
        "Endocrine System (Feedback Hormone Regulation)",
        "Cervix (Barrier and Structural Support)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Ultrasound (Endometrial Thickness)",
        "Hormone Profile (Estrogen, Progesterone, LH, FSH)",
        "MRI Pelvis (Structural Evaluation)"
      ],
      "key_parameters": [
        "Endometrial growth and cyclic variation",
        "Uterine volume and muscle tone",
        "Hormonal phase synchronization"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Hormonal cycle regulation and awareness training",
        "Nutrition and lifestyle optimization for reproductive balance",
        "Pelvic floor strengthening and yoga-based therapy",
        "Mindfulness and stress management for hormonal stability"
      ],
      "energy_axis": "Uterine-Reproductive",
      "dependencies": [
        "Ovaries",
        "Pituitary Gland",
        "Hypothalamus",
        "Vagina / Mammary Glands / Placenta"
      ]
    },
    "genetic_regulators": ["ESR1", "PGR", "WNT7A", "HOXA10"],
    "gender": "female",
    "weight": 78
  },
  {
    "id": 79,
    "name": "Vagina / Mammary Glands / Placenta",
    "system": "Reproductive",
    "subsystem": "External and Supportive Structures – Birth Canal, Nourishment, and Maternal Interface",
    "icd11_code": "XA1080",
    "icf_structure_code": "s770",
    "icf_function_code": "b6503",
    "snomeD_code": "76784001",
    "loinc_param": null,
    "growth": {
      "formation_week": 8,
      "maturation_age_years": 18,
      "critical_periods": ["Prenatal (Formation)", "Puberty (Functional Maturation)", "Pregnancy (Placental Development)"]
    },
    "functions": [
      "Acts as the birth canal and conduit for menstrual flow and reproduction",
      "Provides microbial and immunologic protection for the reproductive tract",
      "Supports breastfeeding through mammary gland development and lactation",
      "Placenta enables nutrient and gas exchange between mother and fetus",
      "Facilitates maternal–fetal hormonal communication and bonding"
    ],
    "developmental_domains": [
      "Reproductive Readiness",
      "Health Readiness and Nurturing Readiness",
      "Hormonal and Behavioral Regulation"
    ],
    "abilities_linked": [
      { "name": "Hormonal Balance and Puberty Readiness", "id": 2045 },
      { "name": "Self-Regulation", "id": 1721 },
      { "name": "Energy Management", "id": 2038 },
      { "name": "Empathy & Emotional Reciprocity", "id": 2068 },
      { "name": "Body Awareness & Protection", "id": 2043 }
    ],
    "readiness_contribution": {
      "speech": 5,
      "motor": 10,
      "behavior": 10,
      "cognitive": 10,
      "social": 15,
      "self_sufficiency": 25,
      "mainstream": 15
    },
    "connectivity": {
      "afferent_from": [
        "Uterus / Cervix (Reproductive Output)",
        "Endocrine System (Estrogen, Progesterone, Prolactin)",
        "Autonomic Nervous System (Pelvic Innervation)"
      ],
      "efferent_to": [
        "External Environment (Birth and Lactation Pathways)",
        "Infant (Through Placental and Mammary Bonding)",
        "Hypothalamus (Oxytocin and Prolactin Feedback)"
      ]
    },
    "measurement": {
      "preferred_modality": [
        "Pelvic Examination and Ultrasound",
        "Hormonal Profile (Estrogen, Progesterone, Prolactin, hCG)",
        "Placental Function and Blood Flow Assessment (Doppler)"
      ],
      "key_parameters": [
        "Hormonal synchronization during menstrual and reproductive cycles",
        "Mammary gland lactation volume and composition",
        "Placental perfusion and nutrient transfer efficiency"
      ]
    },
    "therapy": {
      "stimulus_type": [
        "Hormonal health and reproductive awareness programs",
        "Pelvic and core strengthening exercises",
        "Maternal wellness and bonding therapy",
        "Lactation support and stress management for hormonal balance"
      ],
      "energy_axis": "Reproductive-Nurturing",
      "dependencies": [
        "Uterus / Cervix",
        "Ovaries",
        "Pituitary Gland",
        "Hypothalamus"
      ]
    },
    "genetic_regulators": ["ESR1", "PGR", "OXTR", "GCM1"],
    "gender": "female",
    "weight": 79
  }
];

const scoreToColor = (s) => {
  const v = Number.isFinite(s) ? s : 0;
  if (v >= 70) return "green";
  if (v >= 40) return "yellow";
  return "red";
};

// For the left dot indicator on each row:
// compute the average of that system and return a color class.
export const getMasterColor = (items) => {
  const scores = items.map(m => m.finalScore).filter(Number.isFinite);
  const avg =
    scores.length > 0
      ? scores.reduce((a, b) => a + b, 0) / scores.length
      : 0;
  return scoreToColor(avg); // "red" | "yellow" | "green"
};

export function getOrgangsWihAbilities(userdata, assessment, organId = null, skills = []) {
  // Step 1: Prepare abilities
  var { Skills, Abilities } = SkillsAndAbilities(userdata, null, true, assessment);
  var kid = null;
  if (assessment && assessment.KidId) {
    kid = (userdata.People || []).find(f => f.Id == assessment.KidId);
  }
  // var skillsMaster = groupBy(
  //   userdata.Types.filter(f => f.Category === "THERAPEUTICEIPASSESSMENTS"),
  //   "Id"
  // );

  // var abilitiesMaster = groupBy(
  //   userdata.Types.filter(f => f.Category === "ASABILITIES"),
  //   "Name"
  // );
  //console.log("getOrgangsWihAbilities");


  var abilitiesGroup = groupBy(Abilities || [], "DK");
  // Abilities.forEach(e => {
  //   const master = abilitiesMaster[e.DK]?.[0];
  //   if (master) e.Id = master.Id;
  // });

  var organs = organId ? Organs.filter(f => f.id == organId) : Organs;

  var gender = "male";
  if (kid && kid.Gender && kid.Gender.toLowerCase() == "female") {
    gender = "female";
  }

  // Step 2: Process organs
  var filtered = organs.filter(m => !m.gender || m.gender.toLowerCase() == gender).map(org => {

    let totalScore = 0;
    let actualScore = 0;
    let organColor = "Green"; // default
    let organFirstSplit = (org.name || "").split("(")[0].trim();
    let isSkillsExist = skills && skills.length > 0;


    var typeOfConfig = assessment?.Type && assessment?.Type == "CHILD" ? "CHILD" : "TODDLER";

    var skillsLinked = organTOSkillMapped.filter(f => f.OrganId == org.id + "" && f.Type == typeOfConfig && (isSkillsExist ? skills.includes(f.SkillId) : true));
    if (isSkillsExist && (!skillsLinked || skillsLinked.length == 0)) {
      return;
    }

    skillsLinked = skillsLinked || [];
    const updatedSkills = skillsLinked.map(a => {
      const skill = Skills.find(ab => ab.DId && (ab.DId + "" == a.SkillId + ""));
      const ability = skill && skill["DK"] && abilitiesGroup ? (abilitiesGroup[skill["DK"]] || [])[0] : {};
      const color = skill?.C || "Grey";
      const score = skill?.DS || 0;
      const Ascore = skill?.TS || 0;
      totalScore += score;
      actualScore += Ascore;

      // determine organ color priority
      if (color === "Red") organColor = "Red";
      else if (color === "Yellow" && organColor !== "Red") organColor = "Yellow";
      else if (color === "Green" && organColor !== "Red" && organColor !== "Yellow") organColor = "Green";

      return { ...a, color, score, SkillName: skill?.DN, Ability: skill?.DK, AbilityColor: ability?.C,Sessions:skill?.Sessions };
    });

    var finalScore = (totalScore / actualScore) * 100;
    var finalColor = "Red";
    if (finalScore >= 70) {
      finalColor = "Green";
    } else if (finalScore >= 30) {
      finalColor = "Yellow";
    }


    return {
      ...org,
      skills_linked: updatedSkills,
      organColor: finalColor, // 🔴🟡🟢
      totalScore,
      FirstName: organFirstSplit,
      finalScore
    };
  });
  //console.log(filtered.filter(f=> !!f));
  return filtered.filter(f => !!f);

}

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

export function deepMergeObjects(objects) {
  if (!Array.isArray(objects) || objects.length === 0) return {};

  const toNum = (v) => {
    const n = Number(String(v).replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : null;
  };

  // parses "0–3y", "12-18 y", "8", "8wk" → [start, end] (numbers)
  const parsePeriod = (s) => {
    if (Array.isArray(s)) return s; // already [from,to]
    const str = String(s).trim();
    const m = str.match(/(-?\d+\.?\d*)\s*[–-]\s*(-?\d+\.?\d*)/); // range
    if (m) return [toNum(m[1]), toNum(m[2])];
    const single = toNum(str);
    return single != null ? [single, single] : [null, null];
  };

  // parse "6", "6wk", "6–8", "6-8", "6.5–7.2" → [min,max] as numbers
const parseRange = (v) => {
  if (v == null) return [null, null];
  const s = String(v).trim();

  // explicit range first
  const m = s.match(/(-?\d+(?:\.\d+)?)\s*[–-]\s*(-?\d+(?:\.\d+)?)/);
  if (m) return [parseFloat(m[1]), parseFloat(m[2])];

  // single number with possible units
  const n = parseFloat(s.replace(/[^\d.-]/g, ""));
  return Number.isFinite(n) ? [n, n] : [null, null];
};

const fmtInt = (x) => String(Math.round(x)); // weeks → whole numbers

  const joinUnique = (arr) => Array.from(new Set(arr.filter(Boolean)));

  const mergeRecursively = (target, source, path = []) => {
    for (const key of Object.keys(source)) {
      const sourceValue = source[key];
      const targetValue = target[key];
      const here = [...path, key].join(".");

      // --- SPECIAL CASES (growth.*) ---
      if (here === "growth.formation_week") {
  const [amin, amax] = parseRange(targetValue);
  const [bmin, bmax] = parseRange(sourceValue);

  const mins = [amin, bmin].filter((x) => x != null);
  const maxs = [amax, bmax].filter((x) => x != null);

  if (mins.length && maxs.length) {
    const lo = Math.min(...mins);
    const hi = Math.max(...maxs);
    target[key] = lo === hi ? fmtInt(lo) : `${fmtInt(lo)}–${fmtInt(hi)}`;
  }
  // else keep it as-is if neither side has a valid number
  continue;
}

      if (here === "growth.maturation_age_years") {
        const a = toNum(targetValue);
        const b = toNum(sourceValue);
        const mx = [a, b].filter((x) => x != null).reduce((m, x) => Math.max(m, x), -Infinity);
        if (mx !== -Infinity) target[key] = mx;
        continue;
      }

     if (here === "growth.critical_periods") {
  // helper to turn text or object into [from,to]
  const parsePeriod = (v) => {
    if (!v) return [null, null];
    const s = String(v).trim();
    const m = s.match(/(-?\d+(?:\.\d+)?)\s*[–-]\s*(-?\d+(?:\.\d+)?)/);
    if (m) return [parseFloat(m[1]), parseFloat(m[2])];
    const single = parseFloat(s.replace(/[^\d.-]/g, ""));
    return Number.isFinite(single) ? [single, single] : [null, null];
  };

  const collect = (v) => {
    if (!v) return [];
    if (Array.isArray(v)) return v.flatMap(collect);
    if (typeof v === "object" && "from" in v && "to" in v)
      return [[v.from, v.to]];
    return [parsePeriod(v)];
  };

  const all = [...collect(targetValue), ...collect(sourceValue)].filter(
    ([f, t]) => f != null && t != null
  );

  if (all.length) {
    const from = Math.min(...all.map(([f]) => f));
    const to = Math.max(...all.map(([, t]) => t));
    // 🧠 Output array with formatted readable range string(s)
    target[key] = [`${from}–${to}y`];
  }
  continue;
}
      // --- END SPECIAL CASES ---

      // Arrays → merge & dedupe
      if (Array.isArray(sourceValue)) {
        const mergedArray = Array.isArray(targetValue)
          ? [...targetValue, ...sourceValue]
          : [...sourceValue];
        target[key] = joinUnique(mergedArray);
        continue;
      }

      // Objects → recurse
      if (
        typeof sourceValue === "object" &&
        sourceValue !== null &&
        !Array.isArray(sourceValue)
      ) {
        target[key] = mergeRecursively(targetValue || {}, sourceValue, [...path, key]);
        continue;
      }

      // Primitives → comma-separated uniques
      const mergedValues = [
        ...(targetValue ? String(targetValue).split(",").map(v => v.trim()) : []),
        String(sourceValue).trim(),
      ];
      target[key] = joinUnique(mergedValues).join(", ");
    }
    return target;
  };

  return objects.reduce((acc, obj) => mergeRecursively(acc, obj), {});
}



export const scoreData = [
  { category: 'Emergency Action', parentcategory: "Critical Danger", parentdescription: "🚨 No therapy = No progress. Immediate full intervention is a MUST. Every day lost is irreversible!", range: '0–24', from: 0, to: 24, color: '#f13f48', description: '🚨 Child is in severe danger of lifelong disability if full intervention doesn’t start immediately. No time to wait—act NOW!', RightNow: "Your child is in the Critical Red Zone, facing profound developmental gaps that require urgent attention.", HowLong: "Progress may be extremely slow, and delays in intervention can cause long-term setbacks.", Improvement: "With prompt and intensive therapy, your child may develop basic skills over time. Delayed action can lead to permanent deficits." },

  { category: 'Critical Push Needed', parentcategory: "High Risk", parentdescription: "⚠️ One therapy is NOT enough! Missing interventions = Lifelong struggles. Take full action NOW!", range: '25–32', from: 25, to: 32, color: '#f13f48', description: '⚠️ Partial therapy = partial future. Parents must act urgently, or the child will struggle for life. Push hard for full intervention!', RightNow: "Your child has begun some therapy but still faces substantial developmental challenges.", HowLong: "Progress may take longer than expected if additional interventions are not implemented soon.", Improvement: "Adding recommended therapies can significantly enhance communication, motor, and social skills." },

  { category: 'Severe Gaps Exist', parentcategory: "Severe Delay", parentdescription: "❗ Major gaps remain! Without full therapy, delays will become permanent. Don’t let this happen!", range: '33–49', from: 33, to: 49, color: '#fb9511', description: '❗ Major risk of permanent delay. Therapy gaps will soon become unfixable. Convince parents—this is their LAST CHANCE to correct course!', RightNow: "Your child has shown some progress but still struggles in multiple key areas.", HowLong: "Consistent efforts can lead to visible progress within a year.", Improvement: "Further intervention can boost language, behavior, and self-regulation skills." },

  { category: 'More Therapies Required', parentcategory: "Moderate Concern", parentdescription: "⏳ Half effort = Half life. Your child’s future depends on completing the needed interventions!", range: '50–65', from: 50, to: 65, color: '#fb9511', description: '⏳ Half effort means half a life. Explain that stopping now could cause lifelong dependency. More therapy is NOT optional—it is mandatory.', RightNow: "Your child is on the right path but still requires significant intervention.", HowLong: "With consistent support, progress should be noticeable within 6–12 months.", Improvement: "Increasing therapy sessions can accelerate development in key areas." },

  { category: 'Final Interventions Needed', parentcategory: "Needs More Action", parentdescription: "🔄 Progress is good, but missing therapies are still hurting. Full intervention is the ONLY solution!", range: '66–74', from: 66, to: 74, color: '#fcc911', description: "🔄 They’re close—but close isn’t enough! The missing therapies are critical. Ensure parents understand the life-altering impact of delaying further.", HowLong: "Further improvement can be seen in 3–6 months with continued effort.", Improvement: "Fine-tuning support can enhance advanced language, social, and cognitive abilities." },

  { category: 'Last Mile Effort', parentcategory: "Near Success", parentdescription: "🏁 Almost there, but stopping now will leave lasting gaps. Push for FULL success!", range: '75–99', from: 75, to: 99, color: '#fcc911', description: '🏁 Final stretch, but the risks remain! Any missing intervention can mean lifelong limitations. Parents must complete all therapies without fail.', RightNow: "Your child is making noticeable progress and responding well to therapies.", HowLong: "Further progress can be expected in 2–4 months with ongoing support.", Improvement: "With sustained engagement, they can achieve even higher levels of independence and skill mastery." },

  { category: 'Sustained Success', parentcategory: "Optimal Readiness", parentdescription: "✅ Mission accomplished! Maintain consistency for lifelong success and full independence!", range: '100', from: 100, to: 100, color: '#08b147', description: '✅ Success—but never stop supporting! Continuous monitoring is the only way to secure lifelong independence. Don’t let progress slip away now!', RightNow: "Your child is receiving full support and is progressing toward their full potential.", HowLong: "Continued growth is expected within 1–2 months as they refine existing skills.", Improvement: "Ensuring consistent therapy and structured learning will maintain steady progress and long-term success." }
];

export function DownloadTherapyServiceLetter(id) {
  var $this = this;
  // SetBTNLoader(true);
  // setTimeout(function () {
  //     SetBTNLoader(false);
  // }, 6000);
  var downlaodUrl = 'https://www.pinnacleblooms.org/d/DownloadTherapyServiceLetter/' + id;
  const link = document.createElement('a');
  link.href = downlaodUrl;
  link.download = 'filename.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

}

export function getAttemptScore(UserData, KidId) {
  var latestEIP = UserData?.TherapeuticEipAssessments?.length ? UserData.TherapeuticEipAssessments.filter(e => e.KidId === KidId && e.F3 !== "PENDING" && e.RS !== "DELETEACTIVITY").sort((a, b) => new Date(b.CDT) - new Date(a.CDT))[0] : null;

  const totalNeeded = null == latestEIP ? 0 : ["STRI", "BTRI", "OTRI", "SERI"].reduce((count, key) => count + (latestEIP[key] <= 799 ? 1 : 0), 0);





  // Fetch services related to the child
  const totalTaken = new Set([...(UserData.Therapies || []), ...(UserData.FacilityTherapies || [])].filter(s => s.RS !== "DELETEACTIVITY" && [1, 3, 4, 6].includes(s.TypeId) && s.BossId === KidId).map(s => s.TypeId)).size;


  const percentage = totalNeeded > 0 ? (totalTaken / totalNeeded) * 100 : 0;
  var term = scoreData.find(f => f.from <= percentage && f.to >= percentage);
  return {
    EIP: latestEIP,
    Needed: totalNeeded,
    Taken: totalTaken,
    Percentage: percentage,
    Term: term

  }
}

export function randomColor() {
  var colors = ["#fa7226",

    "#e41f28",

    "#69973f",

    "#0079ae",

    "#411e75",

    "#ee3268"];


  var randomColor = getRandomInt(colors.length);

  return colors[randomColor];

}
export const NewCategories = [
  {
    Name: "Atten.",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle cx="8.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><circle cx="23.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><path d="M25,11H22a7,7,0,0,0-6,3.413A7,7,0,0,0,10,11H7a7.008,7.008,0,0,0-7,7V30a1,1,0,0,0,1,1H11V28L5.216,22.829a1.227,1.227,0,0,1-.48-.96,1.25,1.25,0,0,1,1.25-1.25,1.224,1.224,0,0,1,.768.288L13.147,26h5.706l6.393-5.093a1.224,1.224,0,0,1,.768-.288,1.25,1.25,0,0,1,1.25,1.25,1.227,1.227,0,0,1-.48.96L21,28v3H31a1,1,0,0,0,1-1V18A7.008,7.008,0,0,0,25,11ZM16,24a4,4,0,1,1,4-4A4,4,0,0,1,16,24Z" fill="#33c480" /></g></svg>

    ,
    URL: "/aipendingattendance",
    Role: "Therapist",
    Priority: 1

  },
  {
    Name: "Goals",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" style={{ width: '95%' }}><g transform="translate(0, 0)"><path d="M30,0H2A1,1,0,0,0,1,1V6a5.006,5.006,0,0,0,5,5,10,10,0,0,0,20,0,5.006,5.006,0,0,0,5-5V1A1,1,0,0,0,30,0ZM3,6V2H6V9A3,3,0,0,1,3,6ZM29,6a3,3,0,0,1-3,3V2h3Z" fill="#33c480" /> <path data-color="color-2" d="M17,27.033V23H15v4.033C11.377,27.243,8,28.6,8,31a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1C24,28.6,20.623,27.243,17,27.033Z" fill="#33c480" /></g></svg>


    ,
    URL: "/aigoalnotset",
    Role: "Therapist",
    Priority: 2

  },
  {
    Name: "Pollinate",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path fill="#33c480" d="M31,3c-4.60553,0-8.68616,2.24512-11.23907,5.68781c-0.24756-0.70685-0.68451-1.31671-1.25476-1.77991 c0.25873-1.98944,1.51825-4.20654,2.94012-5.04755c0.47559-0.28027,0.6333-0.89355,0.35205-1.36914 c-0.28076-0.47461-0.89355-0.63281-1.36963-0.35156c-1.80396,1.06573-3.32062,3.50439-3.80859,5.92303 c-0.4927-0.07758-0.72803-0.09304-1.30127,0.00623c-0.48669-2.42065-2.00458-4.86261-3.81006-5.92926 c-0.4751-0.28125-1.08838-0.12305-1.36963,0.35156c-0.28125,0.47559-0.12354,1.08887,0.35205,1.36914 c1.43323,0.84772,2.70081,3.09344,2.94519,5.09491c-0.54248,0.45746-0.95813,1.04962-1.19733,1.73254C9.68616,5.24512,5.60553,3,1,3 C0.44775,3,0,3.44727,0,4v9.58594c0,3.58154,2.55341,6.57782,5.93518,7.26526C4.18091,21.89941,3,23.81189,3,26 c0,3.30859,2.69141,6,6,6c1.86078,0,3.52625-0.85132,4.62762-2.18488C14.17639,30.53046,15.0307,31,16,31 s1.82361-0.46954,2.37238-1.18488C19.47375,31.14868,21.13922,32,23,32c3.30859,0,6-2.69141,6-6 c0-2.18811-1.18091-4.10059-2.93518-5.1488C29.44659,20.16376,32,17.16748,32,13.58594V4C32,3.44727,31.55225,3,31,3z M18,10 c0,1.10254-0.89697,2-2,2s-2-0.89746-2-2s0.89697-2,2-2C17.05006,8,18,8.85776,18,10z M17,28c0,0.55176-0.44873,1-1,1 s-1-0.44824-1-1V13.85797c0.7273,0.189,1.2727,0.189,2,0V28z" /></g></svg>
    ,
    URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=undefinedDDDDDD&FDT=&TDT=&range=",
    Role: "Therapist",
    Priority: 3

  },
  {
    Name: "SR",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M30.275,5.038l-14-4a1.008,1.008,0,0,0-.55,0l-14,4A1,1,0,0,0,1,6C1,25.479,15.517,30.89,15.664,30.941a.986.986,0,0,0,.672,0,21.293,21.293,0,0,0,7.383-5.122C27.041,22.38,31,16.148,31,6A1,1,0,0,0,30.275,5.038ZM20.224,21,16,18.779,11.776,21l.807-4.7L9.166,12.966l4.722-.686L16,8l2.112,4.28,4.722.686L19.417,16.3Z" fill="#33c480" /></g></svg>,
    URL: "/servicerequest",
    Role: "Therapist",
    Priority: 4

  },
  // {
  //     Name:"Feedback",
  //     Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polygon fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="16,2.686 20.326,11.45 30,12.856 23,19.679 24.652,29.314 16,24.767 7.348,29.314 9,19.679 2,12.856 11.674,11.45 " strokeLinejoin="miter" /></g></svg>,
  //     URL:"/attendancekpi?status=pending&month=&year=",
  //     Role:"Boss",
  //     Priority : 1

  // },

  // {
  //     Name:"SR",
  //     Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M21.243,3.757 c-2.343-2.343-6.142-2.343-8.485,0c-0.289,0.289-0.54,0.6-0.757,0.927c-0.217-0.327-0.469-0.639-0.757-0.927 c-2.343-2.343-6.142-2.343-8.485,0c-2.343,2.343-2.343,6.142,0,8.485L12,21.485l9.243-9.243C23.586,9.899,23.586,6.1,21.243,3.757z" strokeLinejoin="miter" /></g></svg>,
  //     URL:"/servicerequest",
  //     Role:"Therapist",
  //     Priority : 4

  // },
  {
    Name: "H/W",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M31,15a1,1,0,0,1-.625-.219L16,3.28,1.625,14.781a1,1,0,1,1-1.25-1.562h0l15-12a1,1,0,0,1,1.25,0l15,12A1,1,0,0,1,31,15Z" fill="#33c480" data-color="color-2" /><path d="M16,5.842l-12,9.6V30a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V15.442Zm5.041,15.94L16,27l-5.04-5.218a3.469,3.469,0,0,1,0-4.79A3.206,3.206,0,0,1,16,17.515a3.206,3.206,0,0,1,5.041-.523A3.469,3.469,0,0,1,21.041,21.782Z" fill="#33c480" /></g></svg>
    ,
    URL: "/therapeutichomework?kid=",
    Role: "Boss",
    Priority: 1

  },

  {
    Name: "SR",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M30.275,5.038l-14-4a1.008,1.008,0,0,0-.55,0l-14,4A1,1,0,0,0,1,6C1,25.479,15.517,30.89,15.664,30.941a.986.986,0,0,0,.672,0,21.293,21.293,0,0,0,7.383-5.122C27.041,22.38,31,16.148,31,6A1,1,0,0,0,30.275,5.038ZM20.224,21,16,18.779,11.776,21l.807-4.7L9.166,12.966l4.722-.686L16,8l2.112,4.28,4.722.686L19.417,16.3Z" fill="#33c480" /></g></svg>,
    URL: "/servicerequest",
    Role: "Boss",
    Priority: 2

  },
  {
    Name: "Leave",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M25.973,8.066A10.554,10.554,0,0,0,20.9,6.416L26.414,3.91a1,1,0,0,0,.194-1.7C26.434,2.072,22.293-1.051,18.6.4c-1.859.73-3.2,2.451-4.024,5.1a6.042,6.042,0,0,0-3.716-2.265c-3.839-.632-7.413,2.9-7.563,3.054A1,1,0,0,0,3.91,8l5.425.493a8.883,8.883,0,0,0-4.189,3.436c-1.321,2.215-1.349,5.05-.083,8.427a1,1,0,0,0,.8.638A.978.978,0,0,0,6,21a1,1,0,0,0,.8-.4L15.27,9.306,28.5,16.868A1,1,0,0,0,29,17a1,1,0,0,0,1-1.083C29.7,12.311,28.342,9.669,25.973,8.066Z" fill="#33c480" data-color="color-2" /><path d="M26.346,30.4a12.877,12.877,0,0,0-8.273-4.967A23.15,23.15,0,0,0,19,19a23.124,23.124,0,0,0-.716-5.669l-2.473-1.413-.028.037A21.207,21.207,0,0,1,17,19a21.114,21.114,0,0,1-.96,6.247l-.04,0A12.892,12.892,0,0,0,5.654,30.4a1,1,0,0,0,.8,1.6h19.1a1,1,0,0,0,.8-1.6Z" fill="#33c480" /></g></svg>


    ,
    URL: "/leaverequest",
    Role: "Boss",
    Priority: 3

  }
  ,
  {
    Name: "Receipt",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path fill="#444444" d="M28,0H4C3.448,0,3,0.448,3,1v31l5-3l4,3l4-3l4,3l4-3l5,3V1C29,0.448,28.552,0,28,0z M17,23H8v-2h9V23z M17,16H8v-2h9V16z M17,9H8V7h9V9z M24,23h-4v-2h4V23z M24,16h-4v-2h4V16z M24,9h-4V7h4V9z" /></g></svg>,
    URL: "/bossreceipts",
    Role: "Boss",
    Priority: 4

  },
  // {
  //     Name: "Offers",
  //     Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" style={{ width: '99%' }}><g transform="translate(0, 0)"><path data-color="color-2" d="M31,7H25.444A3.959,3.959,0,0,0,26,5a4,4,0,0,0-4-4c-3.13,0-5,2.386-6,4.323C15,3.386,13.13,1,10,1A4,4,0,0,0,6,5a3.959,3.959,0,0,0,.556,2H1A1,1,0,0,0,0,8v4a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V8A1,1,0,0,0,31,7ZM22,3a2,2,0,0,1,0,4H17.416C18.078,5.446,19.515,3,22,3ZM8,5a2,2,0,0,1,2-2c2.472,0,3.914,2.446,4.58,4H10A2,2,0,0,1,8,5Z" fill="#33c480" /> <path d="M18,31h7a4,4,0,0,0,4-4V15H18Z" fill="#33c480" /> <path d="M3,27a4,4,0,0,0,4,4h7V15H3Z" fill="#33c480" /></g></svg>


  //     ,
  //     URL: "/roffers",
  //     Role: "Boss",
  //     Priority: 4

  // },

  {
    Name: "Leads",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle cx="8.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><circle cx="23.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><path d="M25,11H22a7,7,0,0,0-6,3.413A7,7,0,0,0,10,11H7a7.008,7.008,0,0,0-7,7V30a1,1,0,0,0,1,1H11V28L5.216,22.829a1.227,1.227,0,0,1-.48-.96,1.25,1.25,0,0,1,1.25-1.25,1.224,1.224,0,0,1,.768.288L13.147,26h5.706l6.393-5.093a1.224,1.224,0,0,1,.768-.288,1.25,1.25,0,0,1,1.25,1.25,1.227,1.227,0,0,1-.48.96L21,28v3H31a1,1,0,0,0,1-1V18A7.008,7.008,0,0,0,25,11ZM16,24a4,4,0,1,1,4-4A4,4,0,0,1,16,24Z" fill="#33c480" /></g></svg>

    ,
    URL: "/createlead",
    Role: "Admin",
    Priority: 1

  },
  {
    Name: "Walkin",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M31.2,7.04A5.489,5.489,0,0,1,27.43,4.062,5.5,5.5,0,0,0,17,6.5,7.965,7.965,0,0,0,19.2,12L19.191,12C10.177,12,6,15,6,15L1.311,13.438A1,1,0,0,0,0,14.39L0,15H0l0,1.993C0,23.988,7,30,16,30c7,0,14-4,14-10,0-4-3.493-7-3.493-9.5A1.5,1.5,0,0,1,28,9h3a1,1,0,0,0,1-1A.985.985,0,0,0,31.2,7.04ZM13,25a1,1,0,0,1,0-2,6.006,6.006,0,0,0,6-6,1,1,0,0,1,2,0A8.009,8.009,0,0,1,13,25ZM22.5,6.5a1,1,0,1,1,1-1A1,1,0,0,1,22.5,6.5Z" fill="#33c480" /></g></svg>
    ,
    URL: "/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Walkins&rtype=walkinleads&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Admin",
    Priority: 2

  },
  {
    Name: "Admn",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle data-color="color-2" fill="#33c480" cx={16} cy={12} r={3} /> <path data-color="color-2" fill="#33c480" d="M22,22v-1.983c0-0.71-0.372-1.363-0.983-1.725C20.044,17.717,18.358,17,16,17 c-2.388,0-4.064,0.713-5.026,1.288C10.368,18.65,10,19.301,10,20.007V22H22z" /> <path fill="#33c480" d="M29.543,12.504C29.836,13.622,30,14.791,30,16c0,7.72-6.28,14-14,14S2,23.72,2,16S8.28,2,16,2 c2.744,0,5.304,0.797,7.466,2.166C23.178,4.718,23,5.336,23,6c0,2.206,1.794,4,4,4s4-1.794,4-4s-1.794-4-4-4 c-0.813,0-1.569,0.247-2.201,0.666C22.273,0.989,19.254,0,16,0C7.178,0,0,7.178,0,16s7.178,16,16,16s16-7.178,16-16 c0-1.572-0.249-3.083-0.678-4.517C30.787,11.907,30.189,12.25,29.543,12.504z" /></g></svg>

    ,
    URL: "/serviceland?type=create",
    Role: "Admin",
    Priority: 3

  },
  {
    Name: "Fee",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M22.282,10H9.718C7.312,12.75,3,18.325,3,23c0,2.111.938,9,13,9s13-6.889,13-9C29,18.325,24.688,12.75,22.282,10Z" fill="#33c480" /><polygon data-color="color-2" points="15 8 15 4 17 4 17 8 21.618 8 25.618 0 6.382 0 10.382 8 15 8" fill="#33c480" /></g></svg>

    ,
    URL: "/createinvoice",
    Role: "Admin",
    Priority: 4

  },
  {
    Name: "Admn",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle data-color="color-2" fill="#33c480" cx={16} cy={12} r={3} /> <path data-color="color-2" fill="#33c480" d="M22,22v-1.983c0-0.71-0.372-1.363-0.983-1.725C20.044,17.717,18.358,17,16,17 c-2.388,0-4.064,0.713-5.026,1.288C10.368,18.65,10,19.301,10,20.007V22H22z" /> <path fill="#33c480" d="M29.543,12.504C29.836,13.622,30,14.791,30,16c0,7.72-6.28,14-14,14S2,23.72,2,16S8.28,2,16,2 c2.744,0,5.304,0.797,7.466,2.166C23.178,4.718,23,5.336,23,6c0,2.206,1.794,4,4,4s4-1.794,4-4s-1.794-4-4-4 c-0.813,0-1.569,0.247-2.201,0.666C22.273,0.989,19.254,0,16,0C7.178,0,0,7.178,0,16s7.178,16,16,16s16-7.178,16-16 c0-1.572-0.249-3.083-0.678-4.517C30.787,11.907,30.189,12.25,29.543,12.504z" /></g></svg>

    ,
    URL: "/serviceland?type=create",
    Role: "Care",
    Priority: 3

  },
  {
    Name: "Fee",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M22.282,10H9.718C7.312,12.75,3,18.325,3,23c0,2.111.938,9,13,9s13-6.889,13-9C29,18.325,24.688,12.75,22.282,10Z" fill="#33c480" /><polygon data-color="color-2" points="15 8 15 4 17 4 17 8 21.618 8 25.618 0 6.382 0 10.382 8 15 8" fill="#33c480" /></g></svg>

    ,
    URL: "/createinvoice",
    Role: "Care",
    Priority: 4

  },


  {
    Name: "Leads",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle cx="8.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><circle cx="23.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><path d="M25,11H22a7,7,0,0,0-6,3.413A7,7,0,0,0,10,11H7a7.008,7.008,0,0,0-7,7V30a1,1,0,0,0,1,1H11V28L5.216,22.829a1.227,1.227,0,0,1-.48-.96,1.25,1.25,0,0,1,1.25-1.25,1.224,1.224,0,0,1,.768.288L13.147,26h5.706l6.393-5.093a1.224,1.224,0,0,1,.768-.288,1.25,1.25,0,0,1,1.25,1.25,1.227,1.227,0,0,1-.48.96L21,28v3H31a1,1,0,0,0,1-1V18A7.008,7.008,0,0,0,25,11ZM16,24a4,4,0,1,1,4-4A4,4,0,0,1,16,24Z" fill="#33c480" /></g></svg>


    ,
    URL: "/createlead",
    Role: "Care",
    Priority: 1

  },
  {
    Name: "Memo",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M31.707,9.08,22.92.293A1,1,0,0,0,22.213,0H9.787A1,1,0,0,0,9.08.293L.293,9.08A1,1,0,0,0,0,9.787V22.213a1,1,0,0,0,.293.707L9.08,31.707A1,1,0,0,0,9.787,32H22.213a1,1,0,0,0,.707-.293l8.787-8.787A1,1,0,0,0,32,22.213V9.787A1,1,0,0,0,31.707,9.08ZM17.929,7,17,19H15L14.071,7ZM16,25a2,2,0,1,1,2-2A2,2,0,0,1,16,25Z" fill="#33c480" /></g></svg>

    ,
    URL: "/publishscreen",
    Role: "Care",
    Priority: 2

  },
  // {
  //     Name: "Award",
  //     Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path fill="#33c480" d="M16,0C9.935,0,5,4.935,5,11s4.935,11,11,11s11-4.935,11-11S22.065,0,16,0z M16,15c-2.209,0-4-1.791-4-4 c0-2.209,1.791-4,4-4s4,1.791,4,4C20,13.209,18.209,15,16,15z" /> <path data-color="color-2" fill="#33c480" d="M5.787,19.017l-4.572,9.36l6.363-1.273l3.625,4.833l3.712-7.992 C11.216,23.637,7.959,21.777,5.787,19.017z" /> <path data-color="color-2" fill="#33c480" d="M26.213,19.017c-2.172,2.76-5.429,4.62-9.128,4.928l3.712,7.992l3.625-4.833l6.363,1.273 L26.213,19.017z" /></g></svg>


  //     ,
  //     URL: "/publishscreen",
  //     Role: "Care",
  //     Priority: 3

  // },
  // {
  //     Name: "Staff",
  //     Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle cx={6} cy={6} r={3} fill="#33c480" data-color="color-2" /><circle cx={16} cy={4} r={4} fill="#33c480" /><path d="M10,25c-1.654,0-3-1.346-3-3v-7c0-1.476,.462-2.845,1.245-3.975-.083-.005-.161-.025-.245-.025H4c-2.209,0-4,1.791-4,4v5c0,.552,.448,1,1,1h1v6c0,.552,.448,1,1,1h6c.552,0,1-.448,1-1v-2Z" fill="#33c480" data-color="color-2" /><circle cx={26} cy={6} r={3} fill="#33c480" data-color="color-2" /><path d="M22,25c1.654,0,3-1.346,3-3v-7c0-1.476-.462-2.845-1.245-3.975,.083-.005,.161-.025,.245-.025h2s2,0,2,0c2.209,0,4,1.791,4,4v5c0,.552-.448,1-1,1h-1s0,6,0,6c0,.552-.448,1-1,1h-3s-3,0-3,0c-.552,0-1-.448-1-1v-2Z" fill="#33c480" data-color="color-2" /><path d="M18,10h-4c-2.761,0-5,2.239-5,5v7c0,.552,.448,1,1,1h2v7c0,.552,.448,1,1,1h6c.552,0,1-.448,1-1v-7h2c.552,0,1-.448,1-1v-7c0-2.761-2.239-5-5-5Z" fill="#33c480" /></g></svg>


  //     ,
  //     URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&hname=Co-Workers&rtype=COWORKERS&isFromLocal=true&fatext=Entire%20Network&FDT=&TDT=&range=",
  //     Role: "Care",
  //     Priority: 4

  // },

  {
    Name: "Leads",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle cx="8.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><circle cx="23.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><path d="M25,11H22a7,7,0,0,0-6,3.413A7,7,0,0,0,10,11H7a7.008,7.008,0,0,0-7,7V30a1,1,0,0,0,1,1H11V28L5.216,22.829a1.227,1.227,0,0,1-.48-.96,1.25,1.25,0,0,1,1.25-1.25,1.224,1.224,0,0,1,.768.288L13.147,26h5.706l6.393-5.093a1.224,1.224,0,0,1,.768-.288,1.25,1.25,0,0,1,1.25,1.25,1.227,1.227,0,0,1-.48.96L21,28v3H31a1,1,0,0,0,1-1V18A7.008,7.008,0,0,0,25,11ZM16,24a4,4,0,1,1,4-4A4,4,0,0,1,16,24Z" fill="#33c480" /></g></svg>

    ,
    URL: "/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Active%20Leads&rtype=activeleads&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Finance",
    Priority: 1

  },
  {
    Name: "Walkin",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M31.2,7.04A5.489,5.489,0,0,1,27.43,4.062,5.5,5.5,0,0,0,17,6.5,7.965,7.965,0,0,0,19.2,12L19.191,12C10.177,12,6,15,6,15L1.311,13.438A1,1,0,0,0,0,14.39L0,15H0l0,1.993C0,23.988,7,30,16,30c7,0,14-4,14-10,0-4-3.493-7-3.493-9.5A1.5,1.5,0,0,1,28,9h3a1,1,0,0,0,1-1A.985.985,0,0,0,31.2,7.04ZM13,25a1,1,0,0,1,0-2,6.006,6.006,0,0,0,6-6,1,1,0,0,1,2,0A8.009,8.009,0,0,1,13,25ZM22.5,6.5a1,1,0,1,1,1-1A1,1,0,0,1,22.5,6.5Z" fill="#33c480" /></g></svg>
    ,
    URL: "/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Walkins&rtype=walkinleads&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Finance",
    Priority: 2

  },
  {
    Name: "Pollin",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path fill="#33c480" d="M31,3c-4.60553,0-8.68616,2.24512-11.23907,5.68781c-0.24756-0.70685-0.68451-1.31671-1.25476-1.77991 c0.25873-1.98944,1.51825-4.20654,2.94012-5.04755c0.47559-0.28027,0.6333-0.89355,0.35205-1.36914 c-0.28076-0.47461-0.89355-0.63281-1.36963-0.35156c-1.80396,1.06573-3.32062,3.50439-3.80859,5.92303 c-0.4927-0.07758-0.72803-0.09304-1.30127,0.00623c-0.48669-2.42065-2.00458-4.86261-3.81006-5.92926 c-0.4751-0.28125-1.08838-0.12305-1.36963,0.35156c-0.28125,0.47559-0.12354,1.08887,0.35205,1.36914 c1.43323,0.84772,2.70081,3.09344,2.94519,5.09491c-0.54248,0.45746-0.95813,1.04962-1.19733,1.73254C9.68616,5.24512,5.60553,3,1,3 C0.44775,3,0,3.44727,0,4v9.58594c0,3.58154,2.55341,6.57782,5.93518,7.26526C4.18091,21.89941,3,23.81189,3,26 c0,3.30859,2.69141,6,6,6c1.86078,0,3.52625-0.85132,4.62762-2.18488C14.17639,30.53046,15.0307,31,16,31 s1.82361-0.46954,2.37238-1.18488C19.47375,31.14868,21.13922,32,23,32c3.30859,0,6-2.69141,6-6 c0-2.18811-1.18091-4.10059-2.93518-5.1488C29.44659,20.16376,32,17.16748,32,13.58594V4C32,3.44727,31.55225,3,31,3z M18,10 c0,1.10254-0.89697,2-2,2s-2-0.89746-2-2s0.89697-2,2-2C17.05006,8,18,8.85776,18,10z M17,28c0,0.55176-0.44873,1-1,1 s-1-0.44824-1-1V13.85797c0.7273,0.189,1.2727,0.189,2,0V28z" /></g></svg>


    ,
    URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=0DDDDDD&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Finance",
    Priority: 3

  },
  {
    Name: "SR",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M30.275,5.038l-14-4a1.008,1.008,0,0,0-.55,0l-14,4A1,1,0,0,0,1,6C1,25.479,15.517,30.89,15.664,30.941a.986.986,0,0,0,.672,0,21.293,21.293,0,0,0,7.383-5.122C27.041,22.38,31,16.148,31,6A1,1,0,0,0,30.275,5.038ZM20.224,21,16,18.779,11.776,21l.807-4.7L9.166,12.966l4.722-.686L16,8l2.112,4.28,4.722.686L19.417,16.3Z" fill="#33c480" /></g></svg>
    ,
    URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Service%20Request%20Active&rtype=servicerequestactive&FilterType=ACTIVE&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Finance",
    Priority: 4

  },

  {
    Name: "Staff",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle cx={6} cy={6} r={3} fill="#33c480" data-color="color-2" /><circle cx={16} cy={4} r={4} fill="#33c480" /><path d="M10,25c-1.654,0-3-1.346-3-3v-7c0-1.476,.462-2.845,1.245-3.975-.083-.005-.161-.025-.245-.025H4c-2.209,0-4,1.791-4,4v5c0,.552,.448,1,1,1h1v6c0,.552,.448,1,1,1h6c.552,0,1-.448,1-1v-2Z" fill="#33c480" data-color="color-2" /><circle cx={26} cy={6} r={3} fill="#33c480" data-color="color-2" /><path d="M22,25c1.654,0,3-1.346,3-3v-7c0-1.476-.462-2.845-1.245-3.975,.083-.005,.161-.025,.245-.025h2s2,0,2,0c2.209,0,4,1.791,4,4v5c0,.552-.448,1-1,1h-1s0,6,0,6c0,.552-.448,1-1,1h-3s-3,0-3,0c-.552,0-1-.448-1-1v-2Z" fill="#33c480" data-color="color-2" /><path d="M18,10h-4c-2.761,0-5,2.239-5,5v7c0,.552,.448,1,1,1h2v7c0,.552,.448,1,1,1h6c.552,0,1-.448,1-1v-7h2c.552,0,1-.448,1-1v-7c0-2.761-2.239-5-5-5Z" fill="#33c480" /></g></svg>


    ,
    URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&hname=Co-Workers&rtype=COWORKERS&isFromLocal=true&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Harvest",
    Priority: 1

  },
  {
    Name: "Pollin",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path fill="#33c480" d="M31,3c-4.60553,0-8.68616,2.24512-11.23907,5.68781c-0.24756-0.70685-0.68451-1.31671-1.25476-1.77991 c0.25873-1.98944,1.51825-4.20654,2.94012-5.04755c0.47559-0.28027,0.6333-0.89355,0.35205-1.36914 c-0.28076-0.47461-0.89355-0.63281-1.36963-0.35156c-1.80396,1.06573-3.32062,3.50439-3.80859,5.92303 c-0.4927-0.07758-0.72803-0.09304-1.30127,0.00623c-0.48669-2.42065-2.00458-4.86261-3.81006-5.92926 c-0.4751-0.28125-1.08838-0.12305-1.36963,0.35156c-0.28125,0.47559-0.12354,1.08887,0.35205,1.36914 c1.43323,0.84772,2.70081,3.09344,2.94519,5.09491c-0.54248,0.45746-0.95813,1.04962-1.19733,1.73254C9.68616,5.24512,5.60553,3,1,3 C0.44775,3,0,3.44727,0,4v9.58594c0,3.58154,2.55341,6.57782,5.93518,7.26526C4.18091,21.89941,3,23.81189,3,26 c0,3.30859,2.69141,6,6,6c1.86078,0,3.52625-0.85132,4.62762-2.18488C14.17639,30.53046,15.0307,31,16,31 s1.82361-0.46954,2.37238-1.18488C19.47375,31.14868,21.13922,32,23,32c3.30859,0,6-2.69141,6-6 c0-2.18811-1.18091-4.10059-2.93518-5.1488C29.44659,20.16376,32,17.16748,32,13.58594V4C32,3.44727,31.55225,3,31,3z M18,10 c0,1.10254-0.89697,2-2,2s-2-0.89746-2-2s0.89697-2,2-2C17.05006,8,18,8.85776,18,10z M17,28c0,0.55176-0.44873,1-1,1 s-1-0.44824-1-1V13.85797c0.7273,0.189,1.2727,0.189,2,0V28z" /></g></svg>


    ,
    URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=0DDDDDD&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Harvest",
    Priority: 2

  },
  {
    Name: "Ranks",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsxlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M8,1V15H24V1a1,1,0,0,0-1-1H9A1,1,0,0,0,8,1Zm9.637,10H15.718V7.3q0-.673.029-1.234a4.373,4.373,0,0,1-.441.45l-.794.655-.981-1.206L15.933,4h1.7Z" fill="#33c480" data-color="color-2" /><path d="M0,18V31a1,1,0,0,0,1,1H15V17H1A1,1,0,0,0,0,18ZM10,28H4.921V26.756l1.708-1.728q.732-.765.957-1.045A2.292,2.292,0,0,0,7.9,23.5a1.033,1.033,0,0,0,.089-.421.548.548,0,0,0-.177-.431.724.724,0,0,0-.5-.158,1.357,1.357,0,0,0-.667.189,4.771,4.771,0,0,0-.763.558L4.844,22.023a5.669,5.669,0,0,1,.909-.691,3.228,3.228,0,0,1,.8-.318,3.93,3.93,0,0,1,.974-.11,2.931,2.931,0,0,1,1.213.239,1.885,1.885,0,0,1,.827.682,1.748,1.748,0,0,1,.295.993,2.672,2.672,0,0,1-.1.761,2.715,2.715,0,0,1-.318.686,4.826,4.826,0,0,1-.572.711q-.357.374-1.519,1.416v.048H10Z" fill="#33c480" /><path d="M17,17V32H31a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1Zm9.2,10.536a3.6,3.6,0,0,1-2.146.56,6.294,6.294,0,0,1-1.045-.082,5.468,5.468,0,0,1-1.041-.3v-1.57a4.123,4.123,0,0,0,.935.347,3.84,3.84,0,0,0,.878.112,1.8,1.8,0,0,0,.907-.174.6.6,0,0,0,.285-.548.621.621,0,0,0-.148-.443.971.971,0,0,0-.479-.234,3.8,3.8,0,0,0-.861-.079H23.05V23.708h.44q1.442,0,1.441-.737a.453.453,0,0,0-.213-.412,1.069,1.069,0,0,0-.572-.134,2.618,2.618,0,0,0-1.388.45l-.784-1.263a3.787,3.787,0,0,1,1.136-.546,4.979,4.979,0,0,1,1.332-.162,2.94,2.94,0,0,1,1.7.43,1.37,1.37,0,0,1,.617,1.187,1.664,1.664,0,0,1-.4,1.117,2.253,2.253,0,0,1-1.148.677v.029q1.751.22,1.751,1.656A1.8,1.8,0,0,1,26.2,27.536Z" fill="#33c480" /></g></svg>

    ,
    URL: "/wip",
    Role: "Harvest",
    Priority: 3

  },
  {
    Name: "EMI",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M12.9,21.057l-1.9-4.269v-.788c0-4.971-4.029-9-9-9-.673,.002-1.344,.079-2,.231V31H5v-3h3c1.657,0,3-1.343,3-3v-2l1.393-.625c.503-.225,.73-.814,.507-1.318Z" fill="#33c480" /><path d="M19.1,21.057l1.9-4.269v-.788c-.013-4.958,3.996-8.987,8.954-9,.689-.002,1.375,.076,2.046,.231V31h-5v-3h-3c-1.657,0-3-1.343-3-3v-2l-1.393-.625c-.503-.225-.73-.814-.507-1.318Z" fill="#33c480" /><circle cx={16} cy={12} r={1} fill="#33c480" data-color="color-2" /><path d="M23.071,5.929c-.256,0-.512-.098-.707-.293-3.51-3.509-9.219-3.509-12.729,0-.391,.391-1.023,.391-1.414,0s-.391-1.023,0-1.414C12.511-.067,19.489-.067,23.778,4.222c.391,.391,.391,1.023,0,1.414-.195,.195-.451,.293-.707,.293Z" fill="#33c480" data-color="color-2" /><path d="M20.243,7.757c-1.17-1.17-2.707-1.755-4.243-1.755-1.537,0-3.073,.585-4.243,1.755-.391,.391-.391,1.024,0,1.414,.195,.195,.451,.293,.707,.293s.512-.098,.707-.293c.78-.78,1.805-1.17,2.829-1.17s2.049,.39,2.829,1.17c.195,.195,.451,.293,.707,.293s.512-.098,.707-.293c.391-.39,.391-1.023,0-1.414Z" fill="#33c480" data-color="color-2" /></g></svg>


    ,
    URL: "/wip",
    Role: "Harvest",
    Priority: 4

  },


  {
    Name: "Ranks",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsxlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M8,1V15H24V1a1,1,0,0,0-1-1H9A1,1,0,0,0,8,1Zm9.637,10H15.718V7.3q0-.673.029-1.234a4.373,4.373,0,0,1-.441.45l-.794.655-.981-1.206L15.933,4h1.7Z" fill="#33c480" data-color="color-2" /><path d="M0,18V31a1,1,0,0,0,1,1H15V17H1A1,1,0,0,0,0,18ZM10,28H4.921V26.756l1.708-1.728q.732-.765.957-1.045A2.292,2.292,0,0,0,7.9,23.5a1.033,1.033,0,0,0,.089-.421.548.548,0,0,0-.177-.431.724.724,0,0,0-.5-.158,1.357,1.357,0,0,0-.667.189,4.771,4.771,0,0,0-.763.558L4.844,22.023a5.669,5.669,0,0,1,.909-.691,3.228,3.228,0,0,1,.8-.318,3.93,3.93,0,0,1,.974-.11,2.931,2.931,0,0,1,1.213.239,1.885,1.885,0,0,1,.827.682,1.748,1.748,0,0,1,.295.993,2.672,2.672,0,0,1-.1.761,2.715,2.715,0,0,1-.318.686,4.826,4.826,0,0,1-.572.711q-.357.374-1.519,1.416v.048H10Z" fill="#33c480" /><path d="M17,17V32H31a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1Zm9.2,10.536a3.6,3.6,0,0,1-2.146.56,6.294,6.294,0,0,1-1.045-.082,5.468,5.468,0,0,1-1.041-.3v-1.57a4.123,4.123,0,0,0,.935.347,3.84,3.84,0,0,0,.878.112,1.8,1.8,0,0,0,.907-.174.6.6,0,0,0,.285-.548.621.621,0,0,0-.148-.443.971.971,0,0,0-.479-.234,3.8,3.8,0,0,0-.861-.079H23.05V23.708h.44q1.442,0,1.441-.737a.453.453,0,0,0-.213-.412,1.069,1.069,0,0,0-.572-.134,2.618,2.618,0,0,0-1.388.45l-.784-1.263a3.787,3.787,0,0,1,1.136-.546,4.979,4.979,0,0,1,1.332-.162,2.94,2.94,0,0,1,1.7.43,1.37,1.37,0,0,1,.617,1.187,1.664,1.664,0,0,1-.4,1.117,2.253,2.253,0,0,1-1.148.677v.029q1.751.22,1.751,1.656A1.8,1.8,0,0,1,26.2,27.536Z" fill="#33c480" /></g></svg>

    ,
    URL: "/wip",
    Role: "Owner",
    Priority: 1

  },
  {
    Name: "Fee",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M22.282,10H9.718C7.312,12.75,3,18.325,3,23c0,2.111.938,9,13,9s13-6.889,13-9C29,18.325,24.688,12.75,22.282,10Z" fill="#33c480" /><polygon data-color="color-2" points="15 8 15 4 17 4 17 8 21.618 8 25.618 0 6.382 0 10.382 8 15 8" fill="#33c480" /></g></svg>

    ,
    URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Business&rtype=business&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role: "Owner",
    Priority: 2

  },
  {
    Name: "Leads",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><circle cx="8.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><circle cx="23.5" cy="4.5" r="4.5" fill="#33c480" data-color="color-2" /><path d="M25,11H22a7,7,0,0,0-6,3.413A7,7,0,0,0,10,11H7a7.008,7.008,0,0,0-7,7V30a1,1,0,0,0,1,1H11V28L5.216,22.829a1.227,1.227,0,0,1-.48-.96,1.25,1.25,0,0,1,1.25-1.25,1.224,1.224,0,0,1,.768.288L13.147,26h5.706l6.393-5.093a1.224,1.224,0,0,1,.768-.288,1.25,1.25,0,0,1,1.25,1.25,1.227,1.227,0,0,1-.48.96L21,28v3H31a1,1,0,0,0,1-1V18A7.008,7.008,0,0,0,25,11ZM16,24a4,4,0,1,1,4-4A4,4,0,0,1,16,24Z" fill="#33c480" /></g></svg>

    ,
    URL: "/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Active%20Leads&rtype=activeleads&fatext=Entire%20Network&FDT=&TDT=&range=",

    Role: "Owner",
    Priority: 3

  },
  {
    Name: "Pollin",
    Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path fill="#33c480" d="M31,3c-4.60553,0-8.68616,2.24512-11.23907,5.68781c-0.24756-0.70685-0.68451-1.31671-1.25476-1.77991 c0.25873-1.98944,1.51825-4.20654,2.94012-5.04755c0.47559-0.28027,0.6333-0.89355,0.35205-1.36914 c-0.28076-0.47461-0.89355-0.63281-1.36963-0.35156c-1.80396,1.06573-3.32062,3.50439-3.80859,5.92303 c-0.4927-0.07758-0.72803-0.09304-1.30127,0.00623c-0.48669-2.42065-2.00458-4.86261-3.81006-5.92926 c-0.4751-0.28125-1.08838-0.12305-1.36963,0.35156c-0.28125,0.47559-0.12354,1.08887,0.35205,1.36914 c1.43323,0.84772,2.70081,3.09344,2.94519,5.09491c-0.54248,0.45746-0.95813,1.04962-1.19733,1.73254C9.68616,5.24512,5.60553,3,1,3 C0.44775,3,0,3.44727,0,4v9.58594c0,3.58154,2.55341,6.57782,5.93518,7.26526C4.18091,21.89941,3,23.81189,3,26 c0,3.30859,2.69141,6,6,6c1.86078,0,3.52625-0.85132,4.62762-2.18488C14.17639,30.53046,15.0307,31,16,31 s1.82361-0.46954,2.37238-1.18488C19.47375,31.14868,21.13922,32,23,32c3.30859,0,6-2.69141,6-6 c0-2.18811-1.18091-4.10059-2.93518-5.1488C29.44659,20.16376,32,17.16748,32,13.58594V4C32,3.44727,31.55225,3,31,3z M18,10 c0,1.10254-0.89697,2-2,2s-2-0.89746-2-2s0.89697-2,2-2C17.05006,8,18,8.85776,18,10z M17,28c0,0.55176-0.44873,1-1,1 s-1-0.44824-1-1V13.85797c0.7273,0.189,1.2727,0.189,2,0V28z" /></g></svg>


    ,
    URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=0DDDDDD&fatext=Entire%20Network&FDT=&TDT=&range=",

    Role: "Owner",
    Priority: 4

  },
]





/**Local Data Table Enum */
export const KidStateCategoryEnum = {
  Condition: 398,
  Tantrum: 399
};
export const TherapyEnum = {
  Integrated: 396,
  Parent: 397
};
export const TableLastSyncDateTime = {
  Aggregates: window.tableVersion + "-Aggregates",
  Assessments: window.tableVersion + "-Assessments",
  Attendance: window.tableVersion + "-Attendance",
  CenterNotes: window.tableVersion + "-CenterNotes",
  Centers: window.tableVersion + "-Centers",
  Fee: window.tableVersion + "-Fee",
  Goals: window.tableVersion + "-Goals",
  Guru: window.tableVersion + "-Guru",
  Leads: window.tableVersion + "-Leads",
  //MirracleTypes: window.tableVersion + "-MirracleTypes",
  PeopleNotes: window.tableVersion + "-PeopleNotes",
  ServiceRequests: window.tableVersion + "-ServiceRequests",
  ServiceRequestsAnalytics: window.tableVersion + "-ServiceRequestsAnalytics",
  Therapies: window.tableVersion + "-Therapies",
  // Types: window.tableVersion + "-Types",
  // UserSettings: window.tableVersion + "-UserSettings",
  People: window.tableVersion + "-People",
  Types: window.tableVersion + "-Types",
  MirracleTypes: window.tableVersion + "-MirracleTypes",
  Feedback: window.tableVersion + "-Feedback",
  FeeReceipt: window.tableVersion + "-FeeReceipt",
  Responses: window.tableVersion + "-Responses",
  FacilityPeople: window.tableVersion + "-FacilityPeople",
  FacilityTherapies: window.tableVersion + "-FacilityTherapies",
  FacilityLeaves: window.tableVersion + "-FacilityLeaves",
  Biometric: window.tableVersion + "-Biometric",
  Offers: window.tableVersion + "-Offers",
  Mirracles: window.tableVersion + "-Mirracles",
  PinnacleClarity: window.tableVersion + "-PinnacleClarity",
  KidStates: window.tableVersion + "-KidStates",
  TherapeuticAI: window.tableVersion + "-TherapeuticAI",
  DemoGraphicAI: window.tableVersion + "-DemoGraphicAI",
  DemoGraphicAINotes: window.tableVersion + "-DemoGraphicAINotes",
  HelloPinnacle: window.tableVersion + "-HelloPinnacle",
  HyperLocal: window.tableVersion + "-HyperLocal",
  HyperLocalActions: window.tableVersion + "-HyperLocalActions",
  TherapeuticEipAssessments: window.tableVersion + "-TherapeuticEipAssessments",
  Incentives: window.tableVersion + "-Incentives",
  TherapeuticEipQuestions: window.tableVersion + "-TherapeuticEipQuestions",
  HopeBlocker: window.tableVersion + "-HopeBlocker",
  PayRollDetails: window.tableVersion + "-PayRollDetails",
  PayRoll: window.tableVersion + "-PayRoll",
  Consultations: window.tableVersion + "-Consultations",
  NetworkNotes: window.tableVersion + "-NetworkNotes",
  FulfillmentClarity: window.tableVersion + "-FulfillmentClarity"
}


export const PinnacleCategories = [
  {
    "Title": "Pendings",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><g class='nc-loop-clock-anim-icon-o' stroke-width='2'><circle cx='24' cy='24' fill='none' r='22' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='8' y2='12' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='40' x2='36' y1='24' y2='24' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='40' y2='36' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='8' x2='12' y1='24' y2='24' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='24' y2='8' data-color='color-2' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='24' y2='11' data-color='color-2' stroke-linejoin='miter'></line></g><style data-cap='butt' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'>.nc-loop-clock-anim-icon-o>*{--animation-duration:1s;transform-origin:50% 50%}.nc-loop-clock-anim-icon-o>:nth-last-child(2){animation:nc-loop-clock-anim-m calc(var(--animation-duration)/2) infinite linear}.nc-loop-clock-anim-icon-o>:nth-last-child(1){animation:nc-loop-clock-anim-h var(--animation-duration) infinite linear}@keyframes nc-loop-clock-anim-h{0%{transform:rotate(90deg)}100%{transform:rotate(450deg)}}@keyframes nc-loop-clock-anim-m{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style></g></svg>",
    "URL": "gptcategory?t=pendings",
    "Roles": "boss,therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/pendings.png",
    "Priority": 1
  },
  {
    "Title": "Renew",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M23.983,38H24A20,20,0,0,1,4,18a19.926,19.926,0,0,1,8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M5.7,34.993a14.651,14.651,0,0,0-2.654,1.986A14.459,14.459,0,0,0,23.983,38H24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M24,38h-.017a20,20,0,0,0,20-20,19.926,19.926,0,0,0-8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M24,38A23.9,23.9,0,0,0,24,4.2,23.9,23.9,0,0,0,24,38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M42.287,34.993a14.651,14.651,0,0,1,2.654,1.986A14.459,14.459,0,0,1,24,38h-.017' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "URL": "gptcategory?t=Renew",
    "Roles": "therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/renewal.png",
    "Priority": 2
  },
  {
    "Title": "Pollin",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='8' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='42' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='28' x2='24.001' y2='38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='32.163' y1='37.409' x2='27.486' y2='40.04' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='8' y1='19' x2='8' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='20.517' y1='22.041' x2='11.483' y2='16.959' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='22.039' x2='36.515' y2='16.961' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='36.517' y1='13.04' x2='31.839' y2='10.409' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><circle cx='8' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='24' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='10' x2='24.001' y2='20' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><circle cx='24.001' cy='6' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='15.838' y1='10.591' x2='20.515' y2='7.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='16.163' y1='37.591' x2='11.484' y2='34.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='40.001' y1='24' x2='40.001' y2='29' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='20.517' y1='25.959' x2='11.483' y2='31.041' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='25.961' x2='36.515' y2='31.039' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line></g></svg>",
    "URL": "gptcategory?t=Pollin",
    "Roles": "therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/pollination.png",
    "Priority": 3
  },
  {
    "Title": "Wins",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
    "URL": "gptcategory?t=Wins",
    "Roles": "boss,therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/wins.png",
    "Priority": 4
  },
  {
    "Title": "Inno",
    "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><line data-cap=\"butt\" x1=\"29.769\" y1=\"6.086\" x2=\"41.866\" y2=\"18.182\" fill=\"none\" stroke=\"#59696d\" strokeMiterlimit={10} strokeWidth={2} strokeLinecap=\"butt\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" d=\"M24.831,8.965C18.989,6.449,11.5,8,6,15l6.734,6.736\" fill=\"none\" stroke=\"#59696d\" strokeMiterlimit={10} strokeWidth={2} strokeLinecap=\"butt\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" d=\"M39.035,23.169C41.551,29.011,40,36.5,33,42l-6.736-6.734\" fill=\"none\" stroke=\"#59696d\" strokeMiterlimit={10} strokeWidth={2} strokeLinecap=\"butt\" strokeLinejoin=\"miter\" \/> <path d=\"M21,38,10,27S18.894,3.414,46,2C44.468,28.988,21,38,21,38Z\" fill=\"none\" stroke=\"#59696d\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/> <circle data-color=\"color-2\" cx={27} cy={21} r={4} fill=\"none\" stroke=\"#59696d\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/> <path data-color=\"color-2\" d=\"M4.464,36.464a5,5,0,0,1,7.072,7.072C9.583,45.488,2,46,2,46S2.512,38.417,4.464,36.464Z\" fill=\"none\" stroke=\"#59696d\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><\/g><\/svg>",
    "URL": "gptcategory?t=Inno",
    "Roles": "boss,therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/innovation.png",
    "Priority": 5
  },
  {
    "Title": "System",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><rect x='16' y='23' width='16' height='10' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></rect><path d='M20,23V17a4.012,4.012,0,0,1,4-4h0a4.012,4.012,0,0,1,4,4v6' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M42,27A18,18,0,0,1,6,27V7L24,3,42,7Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "URL": "gptcategory?t=System",
    "Roles": "boss,therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/system.png",
    "Priority": 6,
    "Description": ""
  },
  {
    "Title": "Empower",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polygon data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points=' 46,2 22,2 22,23 31,16 46,16 ' stroke-linejoin='miter'></polygon> <path fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' d='M20,43.672 c0-1.208-0.529-2.357-1.476-3.108C17.078,39.416,14.57,38,11,38s-6.078,1.416-7.524,2.564C2.529,41.315,2,42.464,2,43.672V46h18 V43.672z' stroke-linejoin='miter'></path> <circle fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='11' cy='28' r='5' stroke-linejoin='miter'></circle> <path fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' d='M46,43.672 c0-1.208-0.529-2.357-1.476-3.108C43.078,39.416,40.57,38,37,38s-6.078,1.416-7.524,2.564C28.529,41.315,28,42.464,28,43.672V46h18 V43.672z' stroke-linejoin='miter'></path> <circle fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='37' cy='28' r='5' stroke-linejoin='miter'></circle></g></svg>",
    "Roles": "therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "URL": "kpireport?hname=Empowring&rtype=EMPOWERINGKIDS",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/empower.png",
    "Priority": 7
  },
  {
    "Title": "Team",
    "Icon": " <svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M9,13L9,13 c-2.209,0-4-1.791-4-4v0c0-2.209,1.791-4,4-4h0c2.209,0,4,1.791,4,4v0C13,11.209,11.209,13,9,13z\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M12,43H6L5,32l-3-1v-9 c0-2.209,1.791-4,4-4h6c1.454,0,2.727,0.777,3.427,1.937\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M39,13 L39,13c2.209,0,4-1.791,4-4v0c0-2.209-1.791-4-4-4h0c-2.209,0-4,1.791-4,4v0C35,11.209,36.791,13,39,13z\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M36,43h6l1-11l3-1v-9 c0-2.209-1.791-4-4-4h-6c-1.454,0-2.727,0.777-3.427,1.937\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M24,14L24,14 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h0c3.314,0,6,2.686,6,6v0C30,11.314,27.314,14,24,14z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M29,46H19l-1-12l-4-1V23 c0-2.209,1.791-4,4-4h12c2.209,0,4,1.791,4,4v10l-4,1L29,46z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
    "Roles": "therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "URL": "kpireport?hname=Co-Workers&rtype=COWORKERS&isFromLocal=true",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/team.png",
    "Priority": 8
  },
  {
    "Title": "Leave",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='22' r='4' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><path d='M35.315,32.221a14,14,0,1,0-22.63,0' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M35.218,42.924a22,22,0,1,0-22.436,0' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M22.276,31h3.448a4,4,0,0,1,3.992,4.266L29,46H19l-.716-10.734A4,4,0,0,1,22.276,31Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path></g></svg>",
    "Roles": "therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "URL": "gptcategory?t=Leave",
    "ImageURL": "https://www.pinnacleblooms.org/images/discord/leaves.png",
    "Priority": 9
  },
  {
    "Title": "SR",
    "Icon": " <svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path d=\"M33.545,4A11.235,11.235,0,0,0,24,9.143,11.235,11.235,0,0,0,14.455,4,11.476,11.476,0,0,0,3,15.429C3,26.857,24,44,24,44S45,26.857,45,15.429A11.476,11.476,0,0,0,33.545,4Z\" fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><\/g><\/svg>",
    "Roles": "boss,therapist,senior,receptionist,manager,owner,bdc,ncc,ccc,harvestadmin,facilityowner",
    "URL": "gptcategory?t=sr",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/sr.png",
    "Priority": 10
  },
  {
    "Title": "Compo",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Roles": "boss,therapist",
    "URL": "gptcategory?t=Compo",
    "ImageURL": "https://www.pinnacleblooms.org/images/discord/absandcompo.png",
    "Priority": 11
  },
  {
    "Title": "Assessments",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points='37,9 42,9 42,46 6,46 6,9 11,9 ' stroke-linejoin='miter'></polyline> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points=' 17,28 22,33 31,24 ' stroke-linejoin='miter'></polyline> <path fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' d='M29,7c0-2.761-2.239-5-5-5 s-5,2.239-5,5h-4v6h18V7H29z' stroke-linejoin='miter'></path></g></svg>",
    "Roles": "boss,therapist",
    "URL": "gptcategory?t=assessments",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/assessments.png",
    "Priority": 12
  },
  {
    "Title": "Dues",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' points='27.081,31 3,31 3,11 45,11 45,31 40,31 ' stroke-linejoin='miter' stroke-linecap='butt'></polyline> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='23' cy='21' r='4' stroke-linejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' x1='13' y1='17' x2='9' y2='17' stroke-linejoin='miter'></line> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8' stroke-linejoin='miter' stroke-linecap='butt'></path></g></svg>",
    "URL": "gptcategory?t=dues",
    "Roles": "receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/dues.png",
    "Priority": 13
  },
  {
    "Title": "Proven Impro",
    "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M20,19c0-8.3,4-15,4-15 s4,6.7,4,15s-4,15-4,15S20,27.3,20,19z\" strokeLinejoin=\"miter\" \/> <path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M34.8,26.9 c3.8-3.8,9.1-4.8,9.1-4.8s-1,5.2-4.8,9.1S30,36,30,36S31,30.8,34.8,26.9z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M37,40c4.2,0,7.6,3,7.6,3 s-3.4,3-7.6,3s-7.6-3-7.6-3S32.8,40,37,40z\" strokeLinejoin=\"miter\" \/> <path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M13.2,26.9 c-3.8-3.8-9.1-4.8-9.1-4.8s1,5.2,4.8,9.1S18,36,18,36S17,30.8,13.2,26.9z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M11,40c-4.2,0-7.6,3-7.6,3 s3.4,3,7.6,3s7.6-3,7.6-3S15.2,40,11,40z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
    "Roles": "boss,therapist,senior,receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/proven.png",
    "URL": "pendingsgpt",
    "Priority": 14
  },
  {
    "Title": "Goals",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
    "Roles": "senior,receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/goals.png",
    "URL": "gptcategory?t=goals",
    "Priority": 14
  },
  {
    "Title": "Attendance",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Roles": "senior,receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner",
    "URL": "gptcategory?t=attendance",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/attendance.png",
    "Priority": 15
  },
  {
    "Title": "Homework",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><rect x='20' y='17' width='8' height='8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></rect><polyline data-cap='butt' data-color='color-2' points='2 21 24 3 46 21' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='19 45 19 33 29 33 29 45' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><path d='M7,24v17c0,2.209,1.791,4,4,4h26c2.209,0,4-1.791,4-4V24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-cap='butt' data-color='color-2' x1='9' y1='15.273' x2='9' y2='7' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></line></g></svg>",
    "Roles": "boss",
    "URL": "gptcategory?t=homework",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/homework.png",
    "Priority": 16
  },
  {
    "Title": "Feedback",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='31' r='1' fill='#444444' data-cap='butt' data-color='color-2' data-stroke='none' stroke-linecap='butt' stroke-linejoin='miter'></circle> <path d='M40.8,33.6A16.034,16.034,0,0,0,46,22c0-9.9-9.8-18-22-18S2,12.1,2,22s9.8,18,22,18a31.827,31.827,0,0,0,6.2-.7L42,44Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path> <line x1='24' y1='12' x2='24' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line> <circle cx='24' cy='31' r='1' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle></g></svg>",
    "Roles": "boss",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/feedback.png",
    "URL": "gptcategory?t=feedback",
    "Priority": 17
  },
  {
    "Title": "Fees",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' points='19.2 4.4 14 7 19 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='28.8 4.4 34 7 29 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline points='21 8 18 2 30 2 27 8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polyline><path d='M29,14H19S7,27,7,35c0,6,4.25,11,17,11s17-5,17-11C41,27,29,14,29,14Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-color='color-2' x1='24' y1='21' x2='24' y2='39' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><path data-color='color-2' d='M28.96,23.974c-2.273-1.181-9.574-2.072-9.574,1.992,0,4.865,9.091,3.148,9.091,7.441s-5.909,3.971-10,2.576' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Roles": "receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/invoices.png",
    "URL": "gptcategory?t=fees",
    "Priority": 18
  },
  {
    "Title": "Credits",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' points='27.081,31 3,31 3,11 45,11 45,31 40,31 ' stroke-linejoin='miter' stroke-linecap='butt'></polyline> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='23' cy='21' r='4' stroke-linejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' x1='13' y1='17' x2='9' y2='17' stroke-linejoin='miter'></line> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8' stroke-linejoin='miter' stroke-linecap='butt'></path></g></svg>",
    "Roles": "boss",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/credits.png",
    "URL": "pendingsgpt",
    "Priority": 19
  },

  {
    "Title": "Leads",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='11' r='9' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polygon points='14 34 34 34 32 46 16 46 14 34' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon><path d='M19.919,25A11.952,11.952,0,0,1,4.081,25,11.987,11.987,0,0,1,24,34' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M28.081,25a11.952,11.952,0,0,0,15.838,0A11.987,11.987,0,0,0,24,34' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><rect x='21.172' y='8.172' width='5.657' height='5.657' stroke-width='2' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' transform='translate(-0.749 20.192) rotate(-45)' data-color='color-2' stroke-linejoin='miter'></rect></g></svg>",
    "Roles": "receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/leads.png",
    "URL": "gptcategory?t=leads",
    "Priority": 21
  },
  {
    "Title": "Services",
    "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M26,9h8c4.418,0,8,3.582,8,8v1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 32,3 26,9 32,15 \" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M22,39h-8c-4.418,0-8-3.582-8-8 v-1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 16,45 22,39 16,33 \" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M20,23H2v-2.242 c0-1.775,1.164-3.334,2.866-3.838C6.46,16.448,8.604,16,11,16c2.356,0,4.514,0.456,6.125,0.932C18.83,17.436,20,18.994,20,20.773V23 z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M6,7c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S6,9.761,6,7z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M46,46H28v-2.242 c0-1.775,1.164-3.334,2.866-3.838C32.46,39.448,34.604,39,37,39c2.356,0,4.514,0.456,6.125,0.932C44.83,40.436,46,41.994,46,43.773 V46z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M32,30c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S32,32.761,32,30z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
    "Roles": "receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner,",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/services.png",
    "URL": "gptcategory?t=services",
    "Priority": 22
  },
  {
    "Title": "Memos",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polygon points='32.698 3 15.302 3 3 15.302 3 32.698 15.302 45 32.698 45 45 32.698 45 15.302 32.698 3' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon><line x1='24' y1='12' x2='24' y2='28' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><circle cx='24' cy='35' r='1' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle></g></svg>",
    "Roles": "therapist,receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner,",
    "ImageURL": "https://mobile.pinnacleblooms.org/images/discord/memo.png",
    "URL": "gptcategory?t=memos",
    "Priority": 23
  },
  {
    "Title": "Awards",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path data-cap='butt' data-color='color-2' d='M11.347,24C6,24,3,20,3,14V6h7' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></path> <path data-cap='butt' data-color='color-2' d='M38,6h7v8c0,6-3,10-8.347,10' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></path> <line data-cap='butt' data-color='color-2' x1='24' y1='40' x2='24' y2='32' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></line> <path d='M24,32h0A14,14,0,0,1,10,18V2H38V18A14,14,0,0,1,24,32Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path> <path d='M35,46H13a6,6,0,0,1,6-6H29a6,6,0,0,1,6,6Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Roles": "therapist,receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner,",
    "ImageURL": "https://www.pinnacleblooms.org/images/discord/wins.png",
    "URL": "gptcategory?t=awards",
    "Priority": 24
  },
  {
    "Title": "Empower2",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><ellipse fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='15' cy='7' rx='11' ry='5' stroke-linejoin='miter'></ellipse> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M26,7v7c0,2.761-4.925,5-11,5 S4,16.761,4,14V7' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,24.857 C20.098,25.571,17.659,26,15,26c-6.075,0-11-2.239-11-5v-7' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M21.999,31.857 C20.098,32.571,17.659,33,15,33c-6.075,0-11-2.239-11-5v-7' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,38.857 C20.098,39.571,17.659,40,15,40c-6.075,0-11-2.239-11-5v-7' stroke-linejoin='miter' stroke-linecap='butt'></path> <ellipse data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='33' cy='20' rx='11' ry='5' stroke-linejoin='miter'></ellipse> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M44,20v7c0,2.761-4.925,5-11,5 s-11-2.239-11-5v-7' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M44,27v7c0,2.761-4.925,5-11,5 s-11-2.239-11-5v-7' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M44,34v7c0,2.761-4.925,5-11,5 s-11-2.239-11-5v-7' stroke-linejoin='miter' stroke-linecap='butt'></path></g></svg>",
    "Roles": "receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner,",
    "ImageURL": "https://www.pinnacleblooms.org/images/discord/wins.png",
    "URL": "gptcategory?t=Empower2",
    "Priority": 25
  },
  {
    "Title": "Kubera",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M9.497,23c-.972,3.162-1.497,6.519-1.497,10,0,2.281,.227,4.508,.657,6.663' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M39.343,39.663c.429-2.154,.657-4.382,.657-6.663,0-3.481-.525-6.838-1.497-10' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M38.407,16c.376-.928,.593-1.937,.593-3,0-4.418-3.582-8-8-8-.568,0-1.121,.063-1.656,.176-1.461-1.918-3.746-3.176-6.344-3.176-3.786,0-6.94,2.638-7.77,6.171-.396-.101-.803-.171-1.23-.171-2.761,0-5,2.239-5,5,0,1.131,.39,2.162,1.023,3' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></path><rect x='6' y='16' width='36' height='7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></rect><circle cx='24.48' cy='9.48' r='1.48' fill='#444444' data-cap='butt' data-color='color-2' data-stroke='none' stroke-linecap='butt' stroke-linejoin='miter'></circle><path d='M37,37.959c2.96,1.472,5,4.511,5,8.041-7,0-11-1-18-1s-11,1-18,1c0-3.53,2.04-6.57,5-8.041' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><rect x='20' y='30' width='8' height='3' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></rect></g></svg>",
    "Roles": "receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner,",
    "ImageURL": "https://www.pinnacleblooms.org/images/discord/wins.png",
    "URL": "gptcategory?t=kubera",
    "Priority": 26
  },
  {
    "Title": "Seeta",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><line data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' x1='39.6' y1='8.4' x2='8.5' y2='39.5' stroke-linejoin='miter' stroke-linecap='butt'></line> <circle fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='24' cy='24' r='22' stroke-linejoin='miter'></circle></g></svg>",
    "Roles": "receptionist,manager,owner,ncc,bdc,ccc,harvestadmin,facilityowner,",
    "ImageURL": "https://www.pinnacleblooms.org/images/discord/wins.png",
    "URL": "gptcategory?t=Seeta",
    "Priority": 27
  }
]

export const PinnacleSubCategories = [

  //System

  {
    "Category": "Pendings",
    "Title": "Attendance",
    "URL": "/aipendingattendance",
    "Key": "AP",
    "Zone": "red",
    "Priority": 5,
    "Role": "Therapist",
    "Description": "You are stopping Parents, Families Inclusion in these many kid's empowerment."
  },
  {
    "Category": "Pendings",
    "Title": "Attendance",
    "URL": "/kpireport?hname=Pending&rtype=pendingattendance",
    "Key": "AP",
    "Zone": "red",
    "Priority": 5,
    "Role": "Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "pendingattendance",
    "Description": "You are stopping Parents, Families Inclusion in these many kid's empowerment."

  },
  {
    "Category": "Pendings",
    "Title": "Compos",
    "URL": "/kpireport?hname=Compos&rtype=compospending",
    "Key": "CPC",
    "Zone": "red",
    "Priority": 1,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "compospending",
    "Description": "These many kids, staff absentes to be compensated."

  },
  {
    "Category": "Pendings",
    "Title": "Pollination",
    "URL": "/kpireport?hname=Pollinate&rtype=pollinatebytherapy",
    "Key": "POL",
    "Zone": "red",
    "Priority": 2,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pollinatebytherapy",
    "Description": "These many kids are seeking your help to be Self-Sufficient, part of Mainstream."

  },
  {
    "Category": "Pendings",
    "Title": "Not Set",
    "URL": "/goalskpi?status=notset",
    "Key": "TGNS",
    "Zone": "red",
    "Priority": 3,
    "Role": "Therapist",
    "Description": "You are holding these many goal based therapies, Set goals along with parents."

  },
  {
    "Category": "Pendings",
    "Title": "Reviews",
    "URL": "/goalskpi?status=pending",
    "Key": "GP",
    "Zone": "red",
    "Priority": 4,
    "Role": "Therapist",
    "Description": "You ae holding these many Pinnacle 97%+ Proven Improvement."
  },
  {
    "Category": "Pendings",
    "Title": "Not Set",
    "URL": "/kpireport?hname=Not Set&rtype=goalsnotset",
    "Key": "TGNS",
    "Zone": "red",
    "Priority": 3,
    "Role": "Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "goalsnotset",
    "Description": "You ae holding these many goal based therapies, Set goals along with parents."
  },
  {
    "Category": "Pendings",
    "Title": "Reviews",
    "URL": "/kpireport?hname=Review&rtype=goalspending",
    "Key": "GP",
    "Zone": "red",
    "Priority": 4,
    "Role": "Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "goalspending",
    "Description": "You are holding these many Pinnacle 97%+ Proven Improvement."
  },
  {
    "Category": "Pendings",
    "Title": "Available",
    "URL": "/availableslots",
    "Key": "AVL",
    "Zone": "green",
    "Priority": 2,
    "Description": "You have opportunity to empower these many kids. Embrace - Contribute - Grow.",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner"
  },
  {
    "Category": "Pendings",
    "Title": "Mirracles",
    "URL": "/kpireport?hname=Mirracle Pending&rtype=mirraclepending",
    "Key": "MAC",
    "Zone": "red",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "mirraclepending",
    "Description": "These many  Mirracles knowledge by Pinnacle awaits you, Learn & Grow."
  },
  {
    "Category": "Pendings",
    "Title": "Courses",
    "URL": "/miraverse",
    "Key": "TCOP",
    "Priority": 5,
    "Zone": "red",
    "Description": "These many courses of knowledge by Pinnacle awaits you, Learn & Grow.",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner,boss"
  },
  {
    "Category": "Pendings",
    "Title": "Tantrums",
    "URL": "/miraverse",
    "Key": "TTP",
    "Zone": "red",
    "Priority": 5,
    "Description": "These many  Tantrums knowledge by Pinnacle awaits you, Learn & Grow.",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,boss"
  },
  {
    "Category": "Pendings",
    "Title": "Conditions",
    "URL": "/miraverse",
    "Key": "TCNP",
    "Priority": 5,
    "Zone": "red",
    "Description": "These many Conditions knowledge by Pinnacle awaits you, Learn & Grow.",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,boss"
  },
  {
    "Category": "Pendings",
    "Title": "Assessments",
    "URL": "/kpireport?hname=Assessment&rtype=assessmentpending",
    "Key": "ASP",
    "Zone": "red",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "assessmentpending",
    "Description": "Immediately complete your pending assessments."
  },
  {
    "Category": "Pendings",
    "Title": "Payment",
    "URL": "/kpireport?hname=Payment&rtype=paymentpending",
    "Key": "PP",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner, Owner",
    "Rkey": "paymentpending",
    "Description": "Clear fee on or before ETA. This indicates respect on Pinnacle."

  },
  {
    "Category": "Pendings",
    "Title": "Adv. Pending",
    "URL": "/kpireport?hname=Adv. Pending&rtype=advancepending",
    "Key": "APEN",
    "Priority": 5,
    "Zone": "red",
    "Role": "receptionist, FranciseOwner, Owner",
    "Rkey": "paymentpending",
    "Description": "Clear advance fee pending on or before ETA."
  },
  {
    "Category": "Pendings",
    "Title": "Leads",
    "URL": "/kpireport?hname=Leads Pending&rtype=pendingleads",
    "Key": "LEP",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner, BDC,NCC, Owner",
    "Rkey": "pendingleads",
    "Description": "Number or Kids, Parents, Families are Waiting on You."
  },
  {
    "Category": "Pendings",
    "Title": "Reviews",
    "URL": "/kpireport?hname=Goals Pending&rtype=goalspending",
    "Key": "GP",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Owner",
    "Rkey": "goalspending",
    "Description": "You ae holding these many Pinnacle 97%+ Proven Improvement."
  },
  {
    "Category": "Pendings",
    "Title": "Leaves",
    "URL": "/leaveapprovals",
    "Key": "SLPA",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Owner",
    "Description": "Approve/ Reject Leaves - Take care of Compo, enable planning."
  },
  {
    "Category": "Pendings",
    "Title": "SR",
    "URL": "/kpireport?hname=SR Pending&rtype=servicerequestpending",
    "Key": "SRIP",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner, BDC,NCC, Owner",
    "Rkey": "servicerequestpending",
    "Description": "These many concerns are pending on you."
  },
  {
    "Category": "Pendings",
    "Title": "WHI",
    "URL": "/kpireport?hname=WHI&rtype=proquery",
    "Key": "PROP",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Owner",
    "Rkey": "proquery",
    "Description": "These many co-worker responses pending on you."
  },
  {
    "Category": "Pendings",
    "Title": "CHI",
    "URL": "/kpireport?hname=CHI&rtype=ADMINPTI",
    "Key": "CPA",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Owner",
    "Rkey": "ADMINPTI",
    "Description": "These many parent, co-worker responses pending on you."
  },
  {
    "Category": "Pendings",
    "Title": "PISI",
    "URL": "/kpireport?hname=PISI&rtype=THERAPISTPTI",
    "Key": "TPA",
    "Priority": 5,
    "Zone": "red",
    "Role": "receptionist, FranciseOwner,BDC, NCC, Owner",
    "Rkey": "THERAPISTPTI",
    "Description": "These many parent responses pending on you."
  },
  {
    "Category": "Pendings",
    "Title": "Fees",
    "URL": "/bossreceipts",
    "Priority": 5,
    "Zone": "red",
    "Role": "Boss",
    "Description": "Clear fee on or before ETA. This indicates respect on Pinnacle."
  },
  {
    "Category": "Pendings",
    "Title": "Homework",
    "URL": "/attendancekpi?status=reviewspending",
    "Priority": 5,
    "Key": "HWP",
    "Zone": "red",
    "Role": "Boss",
    "Description": "These many homeworks are pending on you."
  },
  {
    "Category": "Renew",
    "Title": "All",
    "URL": "/kpireport?hname=All Renewal&rtype=renewalclarityall",
    "Key": "RCA",
    "Zone": "red",
    "Priority": 2,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "renewalclarityall",
    "Description": "This month renewals of all categories."
  },
  {
    "Category": "Renew",
    "Title": "Overdue",
    "URL": "/kpireport?hname=Overdue&rtype=renewalclarityoverdue",
    "Key": "RCOD",
    "Zone": "red",
    "Priority": 1,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclarityoverdue",
    "Description": "These many renewals you missed the timeline, Complete Today."
  },
  {
    "Category": "Renew",
    "Title": "Today",
    "URL": "/kpireport?hname=Today&rtype=renewalclaritytoday",
    "Key": "RCTD",
    "Zone": "red",
    "Priority": 3,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclaritytoday",
    "Description": "Let us complete these renewals pending today."
  },
  {
    "Category": "Renew",
    "Title": "Tommorow",
    "URL": "/kpireport?hname=Tommorow&rtype=renewalclaritytomorrow",
    "Key": "RCTR",
    "Zone": "red",
    "Priority": 4,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclaritytomorrow",
    "Description": "Speak to parents, Reaffirm completion of renewals tomorrow."
  },
  {
    "Category": "Renew",
    "Title": "This Week",
    "URL": "/kpireport?hname=This Week&rtype=renewalclaritythisweek",
    "Key": "RCTW",
    "Zone": "red",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "renewalclaritythisweek",
    "Description": "Speak to parents, Reaffirm completion of renewals this week."
  },
  {
    "Category": "Renew",
    "Title": "Next Week",
    "URL": "/kpireport?hname=Next Week&rtype=renewalclaritynextweek",
    "Key": "RCNW",
    "Zone": "red",
    "Priority": 6,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclaritynextweek",
    "Description": "Speak to parents, Reaffirm completion of renewals next week."
  },
  {
    "Category": "Renew",
    "Title": "This Month",
    "URL": "/kpireport?hname=This Month&rtype=renewalclaritythismonth",
    "Key": "RCTM",
    "Zone": "red",
    "Priority": 7,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclaritythismonth",
    "Description": "Speak to parents, Reaffirm completion of renewals this month."
  },
  {
    "Category": "Renew",
    "Title": "Next Month",
    "URL": "/kpireport?hname=Next Month&rtype=renewalclaritynextmonth",
    "Key": "RCNM",
    "Zone": "red",
    "Priority": 8,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclaritynextmonth",
    "Description": "Speak to parents, Reaffirm completion of renewals next month."
  },
  {
    "Category": "Renew",
    "Title": "Not Renewing",
    "URL": "/kpireport?hname=Not Renewing&rtype=renewalclarityothers",
    "Key": "RCOT",
    "Zone": "red",
    "Priority": 9,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "renewalclarityothers",
    "Description": "Speak to Parents, Renew Pinnacle Hope & Confidence."
  },
  {
    "Category": "Renew",
    "Title": "Tobe Renewed",
    "URL": "/kpireport?hname=Tobe Renewed&rtype=renewalclaritytoberenewed",
    "Key": "RCTBR",
    "Zone": "red",
    "Priority": 10,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclaritytoberenewed",
    "Description": "These many renewals are waiting on you to give ETA."
  },
  {
    "Category": "Renew",
    "Title": "Pending",
    "URL": "/kpireport?hname=Pending&rtype=renewalclaritypending",
    "Key": "RCP",
    "Zone": "red",
    "Priority": 11,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "renewalclaritypending",
    "Description": "Speak to Parents, Renew Pinnacle Hope & Confidence."
  },
  {
    "Category": "Renew",
    "Title": "Renewed",
    "URL": "/kpireport?hname=Renewed&rtype=renewalclarityrenewed",
    "Key": "RCR",
    "Zone": "red",
    "Priority": 12,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "renewalclarityrenewed",
    "Description": "Congratulations on renewing Pinnacle Hope & Confidence."
  },
  {
    "Category": "Pollin",
    "Title": "Promised",
    "URL": "/kpireport?hname=Promised&rtype=pollinationclaritypromised",
    "Key": "PCP",
    "Zone": "red",
    "Priority": 1,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "pollinationclaritypromised",
    "Description": "Deliver your promise of Kids, Parents, Families empowerment."

  },
  {
    "Category": "Pollin",
    "Title": "Completed",
    "URL": "/kpireport?hname=Completed&rtype=pollinationclaritycompleted",
    "Key": "PCC",
    "Zone": "red",
    "Priority": 2,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pollinationclaritycompleted",
    "Description": "Thank you on behalf of kids, parents, families."
  },
  {
    "Category": "Pollin",
    "Title": "YetTo",
    "URL": "/kpireport?hname=YetTo&rtype=pollinationclarityyetto",
    "Key": "PCYT",
    "Zone": "red",
    "Priority": 3,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pollinationclarityyetto",
    "Description": "These many kids are seeking your help to be Self-Sufficient, part of Mainstream."
  },
  {
    "Category": "Pollin",
    "Title": "Zero",
    "URL": "/kpireport?hname=Zero&rtype=pollinationclarityzero",
    "Key": "PCZ",
    "Zone": "red",
    "Priority": 4,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "pollinationclarityzero",
    "Description": "You are not caring, kids, parents, families, their lives. Observe & Contribute."
  },
  {
    "Category": "Pollin",
    "Title": "<3",
    "URL": "/kpireport?hname=Less than 3&rtype=pollinationclaritylessthanthree",
    "Key": "PCLT",
    "Zone": "red",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "pollinationclaritylessthanthree",
    "Description": "Understand concept of Integrated Autism Therapy, Contribute."
  },
  {
    "Category": "Pollin",
    "Title": ">=3",
    "URL": "/kpireport?hname=More than 3&rtype=pollinationclaritygreaterthanthree",
    "Key": "PCGT",
    "Zone": "red",
    "Priority": 6,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pollinationclaritygreaterthanthree",
    "Description": "Wishing you all the best in empowering kids, parents, families."
  },
  {
    "Category": "Pollin",
    "Title": "OPTY",
    "URL": "/kpireport?hname=Opprtunity&rtype=pollinatebytherapy",
    "Key": "POL",
    "Zone": "red",
    "Priority": 7,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Description": "These many kids are seeking your help to be Self-Sufficient, part of Mainstream."

  },
  {
    "Category": "Pollin",
    "Title": "ST",
    "URL": "/kpireport?hname=ST&rtype=pollinationoptyst",
    "Key": "PAST",
    "Zone": "red",
    "Priority": 8,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "pollinationoptyst",
    "Description": "These many kids are seeking ST help to be Self-Sufficient, part of Mainstream."
  },
  {
    "Category": "Pollin",
    "Title": "OT",
    "URL": "/kpireport?hname=OT&rtype=pollinationoptyot",
    "Key": "PAOT",
    "Zone": "red",
    "Priority": 9,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pollinationoptyot",
    "Description": "These many kids are seeking OT help to be Self-Sufficient, part of Mainstream."
  },
  {
    "Category": "Pollin",
    "Title": "ABA",
    "URL": "/kpireport?hname=ABA&rtype=pollinationoptyaba",
    "Key": "PAABA",
    "Zone": "red",
    "Priority": 10,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pollinationoptyaba",
    "Description": "These many kids are seeking ABA help to be Self-Sufficient, part of Mainstream."
  },
  {
    "Category": "Pollin",
    "Title": "SE",
    "URL": "/kpireport?hname=SE&rtype=pollinationoptyse",
    "Key": "PASE",
    "Zone": "red",
    "Priority": 11,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pollinationoptyse",
    "Description": "These many kids are seeking SE help to be Self-Sufficient, part of Mainstream."
  },
  {
    "Category": "Wins",
    "Title": "Walkins",
    "URL": "/kpireport?hname=Walkins&rtype=walkinleads",
    "Key": "OW",
    "Zone": "green",
    "Priority": 5,
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "walkinleads",
    "Description": "Congratulations, Every walk-in is a family trust on Pinnacle."
  },
  {
    "Category": "Wins",
    "Title": "Additions",
    "URL": "/kpireport?hname=Additions&rtype=additionleads",
    "Key": "ADD",
    "Zone": "green",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "additionleads",
    "Description": "Thank you on behalf of Kids, Parents, Families."
  },
  {
    "Category": "Wins",
    "Title": "Therapies",
    "URL": "/kpireport?hname=Therapies&rtype=activeservices",
    "Key": "AGP",
    "Zone": "green",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "activeservices",
    "Description": "Empowering these many kids, parents, families for Life."
  },
  {
    "Category": "Wins",
    "Title": "Rating",
    "URL": "/kpireport?hname=Rating&rtype=feedbacksgiven",
    "Key": "RAT",
    "Zone": "green",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "feedbacksgiven",
    "Description": "This is what Parents, Families feel about your therapies."
  },
  {
    "Category": "Wins",
    "Title": "Goals",
    "URL": "/kpireport?hname=Goals&rtype=goalreviewed",
    "Key": "GR",
    "Zone": "green",
    "Priority": 5,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "goalreviewed",
    "Description": "These many Pinnacle 97%+ Proven Empowerment you have delivered."
  },
  {
    "Category": "Wins",
    "Title": "Mirracles",
    "URL": "/mirracles",
    "Key": "MIRT",
    "Zone": "green",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "You have acquired these many Mirracles of Knowledge."
  },
  {
    "Category": "Wins",
    "Title": "Tantrums",
    "URL": "/miraverse",
    "Key": "MIRV",
    "Zone": "green",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "You have acquired knowledge to deal with these many tantrums."
  },
  {
    "Category": "Wins",
    "Title": "Admissions",
    "URL": "/kpireport?hname=Admissions&rtype=admissionleads",
    "Key": "ADM",
    "Zone": "green",
    "Priority": 5,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "admissionleads",
    "Description": "These many of walkins converted into admissions."
  },
  {
    "Category": "Wins",
    "Title": "InActive",
    "URL": "/kpireport?hname=InActive&rtype=inactiveservices",
    "Key": "TCS",
    "Priority": 5,
    "Zone": "green",
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "inactiveservices",
    "Description": "Speak to each parent, family member, reaffirm Pinnacle Hope, Confidence."
  },
  {
    "Category": "Wins",
    "Title": "Credits",
    "URL": "/AdvancedInvoices",
    "Key": "AC",
    "Priority": 5,
    "Zone": "green",
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "Every credit pack ease parents, family burden, Keep It Up."
  },
  {
    "Category": "Wins",
    "Title": "Therapies",
    "URL": "/attendancekpi?status=completed",
    "Key": "TBOT",
    "Priority": 5,
    "Zone": "green",
    "Role": "Boss, Therapist",
    "Description": "Congratulations for the life changing therapeutic empowerment."
  },
  {
    "Category": "Wins",
    "Title": "Goals",
    "URL": "/goalskpi?status=completed",
    "Key": "TBOG",
    "Priority": 5,
    "Zone": "red",
    "Role": "Boss",
    "Description": "Pinnacle 97%+ Proven Improvement Successfully Delivered."
  },
  {
    "Category": "Wins",
    "Title": "Goals",
    "URL": "/goalskpi?status=completed",
    "Key": "GR",
    "Priority": 5,
    "Zone": "red",
    "Role": "Therapist",
    "Description": "Pinnacle 97%+ Proven Improvement Successfully Delivered."
  },
  {
    "Category": "Wins",
    "Title": "Feedback",
    "URL": "/attendancekpi",
    "Key": "TBOF",
    "Priority": 5,
    "Zone": "green",
    "Role": "Boss",
    "Description": "Appreciate your therapist, Provide the feedback you want to."
  },
  {
    "Category": "Wins",
    "Title": "Credits",
    "URL": "/bossreceipts",
    "Key": "FCI",
    "Zone": "red",
    "Role": "Boss",
    "Priority": 5,
    "Description": "Hearty Congratulations upon availing the offer."
  },
  {
    "Category": "Wins",
    "Title": "Recommend.",
    "URL": "/kpireport?hname=Recommend&rtype=feedbacksgiven",
    "Key": "RG",
    "Zone": "green",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "feedbacksgiven",
    "Priority": 5,
    "Description": "Here is what Parents, Families are saying about you."
  },
  {
    "Category": "Wins",
    "Title": "Awards",
    "URL": "/kpireport?hname=awards&rtype=awards",
    "Key": "AWARDS",
    "Zone": "green",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "awards",
    "Priority": 5,
    "Description": "Congratulations, Every award counts in your career growth."
  },
  {
    "Category": "Wins",
    "Title": "Courses",
    "URL": "/miraverse",
    "Key": "MIRC",
    "Zone": "green",
    "Priority": 5,
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "You have acquired these many Courses of Knowledge."
  },
  {
    "Category": "Wins",
    "Title": "Conditions",
    "URL": "/miraverse",
    "Key": "MIRLC",
    "Priority": 5,
    "Zone": "green",
    "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "You have acquired Pinnacle Knowledge on these many conditions."
  },
  {
    "Category": "Dues",
    "Title": "Overdue",
    "URL": "/kpireport?hname=Overdue&rtype=dueoverdue",
    "Key": "DO",
    "Zone": "red",
    "Priority": 1,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "dueoverdue",
    "Description": "Every ETA given by you is the promise you have made, Fulfill it."
  },
  {
    "Category": "Dues",
    "Title": "All",
    "URL": "/kpireport?hname=All&rtype=dueall",
    "Key": "DA",
    "Zone": "red",
    "Priority": 2,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "dueall",
    "Description": "Overall fee amount due. Clear all that can be cleared."
  },
  {
    "Category": "Dues",
    "Title": "Today",
    "URL": "/kpireport?hname=Today&rtype=duetoday",
    "Key": "DT",
    "Zone": "red",
    "Priority": 3,
    "Role": "Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "duetoday",
    "Description": "Reaffirm every fee promise of today gets cleared, No overdue."
  },
  {
    "Category": "Dues",
    "Title": "Tomorrow",
    "URL": "/kpireport?hname=Tomorrow&rtype=duetomorrow",
    "Key": "DTM",
    "Zone": "red",
    "Priority": 4,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "duetomorrow",
    "Description": "Reaffirm every fee promise of tomorrow gets cleared, No overdue."
  },
  {
    "Category": "Dues",
    "Title": "ETA Pending",
    "URL": "/kpireport?hname=ETA Pending&rtype=etapending",
    "Key": "DEP",
    "Zone": "red",
    "Priority": 5,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "etapending",
    "Description": "These fee clearance ETA not provided yet, Provide."
  },
  {
    "Category": "Dues",
    "Title": "This Week",
    "URL": "/kpireport?hname=This Week&rtype=duethisweek",
    "Key": "DTW",
    "Zone": "red",
    "Priority": 6,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "duethisweek",
    "Description": "Reaffirm every fee promise of this week gets cleared, No overdue."
  },
  {
    "Category": "Dues",
    "Title": "Next Week",
    "URL": "/kpireport?hname=Next Week&rtype=duenextweek",
    "Key": "DNW",
    "Zone": "red",
    "Priority": 7,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "duenextweek",
    "Description": "Reaffirm every fee promise of next week gets cleared, No overdue."
  },
  {
    "Category": "Dues",
    "Title": "This Month",
    "URL": "/kpireport?hname=This Month&rtype=duethismonth",
    "Key": "DTMN",
    "Zone": "red",
    "Priority": 8,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "duethismonth",
    "Description": "Reaffirm every fee promise of this month gets cleared, No overdue."
  },
  {
    "Category": "Dues",
    "Title": "Next Month",
    "URL": "/kpireport?hname=Next Month&rtype=duenextmonth",
    "Key": "DNM",
    "Zone": "red",
    "Priority": 9,
    "Role": "Senior, Admin,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "duenextmonth",
    "Description": "Reaffirm every fee promise of next month gets cleared, No overdue."
  },
  {
    "Category": "Dues",
    "Title": "Future",
    "URL": "/kpireport?hname=Future&rtype=duefuture",
    "Key": "DF",
    "Zone": "red",
    "Priority": 10,
    "Role": "Senior, Admin,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "duefuture",
    "Description": "Reaffirm every fee promise of future gets cleared, No overdue."
  },
  {
    "Category": "Kubera",
    "Title": "18k",
    "URL": "/kpireport?hname=18K&rtype=kuberamonthlyfee",
    "Key": "KU18",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "kuberamonthlyfee",
    "Description": "Here are the parents taking therapies for 18k fee"
  },
  {
    "Category": "Kubera",
    "Title": "Missing",
    "URL": "/kpireport?hname=Missing&rtype=kuberamissing",
    "Key": "KUM",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "kuberamissing",
    "Description": "These many invoices missing, Correct the same in next 15 mins."
  },
  {
    "Category": "Kubera",
    "Title": "Abnormal",
    "URL": "/kpireport?hname=Abnormal&rtype=kuberaabnormal",
    "Key": "KUAB",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "kuberaabnormal",
    "Description": "These many fee amounts are looking abnormal, take action."
  },
  {
    "Category": "Kubera",
    "Title": "Rest",
    "URL": "/kpireport?hname=Rest&rtype=allinvoicesthismonth",
    "Key": "KUR",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "allinvoicesthismonth",
    "Description": "Check these invoices and reaffirm all are per the standards."
  },
  {
    "Category": "Empower2",
    "Title": "Monthly",
    "URL": "/kpireport?hname=Monthly&rtype=monthlypack",
    "Key": "EMPM",
    "Priority": 5,
    "Zone": "red",
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "monthlypack",
    "Description": "Empower these many parents to save through credit packs."
  },
  {
    "Category": "Empower2",
    "Title": "Single",
    "URL": "/kpireport?hname=Single&rtype=empwoer2single",
    "Key": "EMPS",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "empwoer2single",
    "Description": "Observe needs of kid, onboard needed therapies with parents."
  },
  {
    "Category": "Empower2",
    "Title": "Renew",
    "URL": "/kpireport?hname=Renew&rtype=allrenewals",
    "Key": "RWT",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "allrenewals",
    "Description": "Opportunity to renew Hope & Confidence of these many parents."
  },
  {
    "Category": "Empower2",
    "Title": "Lost Parents",
    "URL": "/kpireport?hname=Lost Parents&rtype=leftparents",
    "Key": "TLKIDS",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC,NCC, Harvest, Owner",
    "Rkey": "leftparents",
    "Description": "Bring back these parents by extending Pinnacle Hope & Confidence."
  },
  {
    "Category": "Seeta",
    "Title": "Pending",
    "URL": "/kpireport?hname=Pending&rtype=seetapending",
    "Key": "SETP",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "seetapending",
    "Description": "These many kids who haven't paid fee are not coming."
  },
  {
    "Category": "Seeta",
    "Title": "Partial",
    "URL": "/kpireport?hname=Partial&rtype=seetapartiallypaid",
    "Key": "SETPP",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "seetapartiallypaid",
    "Description": "These many kids who have pending fee are not coming."
  },
  {
    "Category": "Seeta",
    "Title": "Paid",
    "URL": "/kpireport?hname=Paid&rtype=seetapaid",
    "Key": "SETPA",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "seetapaid",
    "Description": "These many kids who have paid but not coming."
  },
  {
    "Category": "Seeta",
    "Title": "Kids",
    "URL": "/kpireport?hname=Kids&rtype=seetakids",
    "Key": "SETKI",
    "Zone": "red",
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "seetakids",
    "Description": "These many kids in total are not coming."
  },
  {
    "Category": "Attendance",
    "Title": "Total",
    "URL": "/kpireport?hname=Total&rtype=pendingattendance",
    "Key": "TOA",
    "Zone": "red",
    "Priority": 1,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pendingattendance",
    "Description": "These many therapies have been conducted."
  },
  {
    "Category": "Attendance",
    "Title": "Present",
    "URL": "/kpireport?hname=Present&rtype=attendancepresent",
    "Key": "AGP",
    "Zone": "red",
    "Priority": 2,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "attendancepresent",
    "Description": "These many kids were present."
  },
  {
    "Category": "Attendance",
    "Title": "Pending",
    "URL": "/kpireport?hname=Pending&rtype=pendingattendance",
    "Key": "AP",
    "Zone": "red",
    "Priority": 3,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pendingattendance",
    "Description": "These many therapy attendances are pending"
  },
  {
    "Category": "Attendance",
    "Title": "Absent",
    "URL": "/kpireport?hname=Absent&rtype=attendanceabsent",
    "Key": "ABS",
    "Zone": "red",
    "Priority": 4,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "attendanceabsent",
    "Description": "These many kids are absent, Create compo sessions."
  },
  {
    "Category": "Attendance",
    "Title": "Pending Compos",
    "URL": "/kpireport?hname=Pending Compos&rtype=compospending",
    "Key": "CPC",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "compospending",
    "Description": "These many compensations created are pending."
  },
  {
    "Category": "Attendance",
    "Title": "Parent Pending",
    "URL": "/kpireport?hname=Parent Pending&rtype=homeworkpending",
    "Key": "RP",
    "Zone": "red",
    "Priority": 6,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "homeworkpending",
    "Description": "These many therapies of yours are yet to be rated by parents."
  },
  {
    "Category": "Attendance",
    "Title": "Parent Given",
    "URL": "/kpireport?hname=Parent Given&rtype=feedbacksgiven",
    "Key": "RG",
    "Zone": "red",
    "Priority": 7,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "feedbacksgiven",
    "Description": "Here is what parents, families saying about your therapies."
  },
  {
    "Category": "Attendance",
    "Title": "Total Compos",
    "URL": "/kpireport?hname=Total Compos&rtype=compenstations",
    "Key": "CST",
    "Zone": "red",
    "Priority": 8,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "compenstations",
    "Description": "Here are the total compensations."
  },
  {
    "Category": "Attendance",
    "Title": "Compos Given",
    "URL": "/kpireport?hname=Compos Given&rtype=compenstations",
    "Key": "CSC",
    "Zone": "red",
    "Priority": 9,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "compenstations",
    "Description": "These are the compensation sessions successfully delivered."
  },
  {
    "Category": "Attendance",
    "Title": "Compos Future",
    "URL": "/kpireport?hname=Compos Given&rtype=compenstations",
    "Key": "CSF",
    "Zone": "red",
    "Priority": 10,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "compenstations",
    "Description": "These are the compos to be delivered in future."
  },
  {
    "Category": "Attendance",
    "Title": "Compos Not Accomplished",
    "URL": "/kpireport?hname=Compos Not&rtype=compenstations",
    "Key": "CSO",
    "Zone": "red",
    "Priority": 11,
    "Role": "receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "compenstations",
    "Description": "These many absent sessions are yet to be compensated."
  },
  {
    "Category": "Attendance",
    "Title": "Compos Cancelled",
    "URL": "/kpireport?hname=Compos Cancelled&rtype=Compensations",
    "Key": "CCL",
    "Zone": "red",
    "Priority": 12,
    "Role": "receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "Compensations",
    "Description": "These many compensation sessions are cancelled."
  },
  {
    "Category": "Goals",
    "Title": "Total",
    "URL": "/kpireport?hname=Total&rtype=totalgoals",
    "Key": "TGO",
    "Zone": "red",
    "Priority": 1,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "totalgoals",
    "Description": "Total number of goals."
  },
  {
    "Category": "Goals",
    "Title": "Active",
    "URL": "/kpireport?hname=Active&rtype=activegoals",
    "Key": "TAG",
    "Zone": "red",
    "Priority": 2,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "activegoals",
    "Description": "Goals in progress, therapists are empowering kids, families."
  },
  {
    "Category": "Goals",
    "Title": "Pending",
    "URL": "/kpireport?hname=Pending&rtype=goalspending",
    "Key": "GP",
    "Zone": "red",
    "Priority": 3,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "goalspending",
    "Description": "Pinnacle 97%+ Proven Improvement showcase goal review pending."
  },
  {
    "Category": "Goals",
    "Title": "Today Pending",
    "URL": "/kpireport?hname=Today Pending&rtype=todaygoalspending",
    "Key": "TGP",
    "Zone": "red",
    "Priority": 4,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "todaygoalspending",
    "Description": "Pinnacle 97%+ Proven Improvement showcase goal review pending."
  },
  {
    "Category": "Goals",
    "Title": "Not Set",
    "URL": "/kpireport?hname=Not Set&rtype=goalsnotset",
    "Key": "TGNS",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "goalsnotset",
    "Description": "These many kids, families empowerment is stopped by you."
  },
  {
    "Category": "Goals",
    "Title": "Reviewed",
    "URL": "/kpireport?hname=Reviewed&rtype=goalreviewed",
    "Key": "GR",
    "Zone": "red",
    "Priority": 6,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "goalreviewed",
    "Description": "Pinnacle 97%+ Proven Improvement Successfully Delivered."
  },
  {
    "Category": "Goals",
    "Title": "Met",
    "URL": "/GoalsInsights",
    "Key": "TGM",
    "Zone": "red",
    "Priority": 7,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "Pinnacle 97%+ Proven Improvement Successfully Delivered."
  },
  {
    "Category": "Goals",
    "Title": "Not Met",
    "URL": "/GoalsInsights",
    "Key": "GNM",
    "Zone": "red",
    "Priority": 8,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "These many goals, including stretch goals are not met, Review."
  },
  {
    "Category": "Leads",
    "Title": "Total",
    "URL": "/kpireport?hname=Total&rtype=totalleads",
    "Key": "LTO",
    "Zone": "red",
    "Priority": 1,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "totalleads",
    "Description": "Total opportunities you have to empower."
  },
  {
    "Category": "Leads",
    "Title": "Active",
    "URL": "/kpireport?hname=Leads&rtype=activeleads",
    "Key": "LA",
    "Zone": "red",
    "Priority": 2,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "activeleads",
    "Description": "These many parents, families are active."
  },
  {
    "Category": "Leads",
    "Title": "Pending",
    "URL": "/kpireport?hname=Pending&rtype=pendingleads",
    "Key": "LEP",
    "Zone": "red",
    "Priority": 3,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "pendingleads",
    "Description": "These many parents, families you need to call and speak."
  },
  {
    "Category": "Leads",
    "Title": "New",
    "URL": "/kpireport?hname=New&rtype=newleads",
    "Key": "LN",
    "Zone": "red",
    "Priority": 4,
    "Role": "receptionist, FranciseOwner,BDC,NCC, Harvest, Owner",
    "Rkey": "newleads",
    "Description": "Call and speak to these parents, families immediately."
  },
  {
    "Category": "Leads",
    "Title": "Closed",
    "URL": "/kpireport?hname=Closed&rtype=closedleads",
    "Key": "LC",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "closedleads",
    "Description": "These many parents, families you couldn't give Hope & confidence."
  },
  {
    "Category": "Leads",
    "Title": "Walkins",
    "URL": "/kpireport?hname=Walkins&rtype=walkinleads",
    "Key": "OW",
    "Zone": "red",
    "Priority": 6,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "walkinleads",
    "Description": "Wonderful, These many parents, families have come to Pinnacle."
  },
  {
    "Category": "Leads",
    "Title": "Assessments",
    "URL": "/kpireport?hname=Assessments&rtype=assessmentsleads",
    "Key": "LASM",
    "Zone": "red",
    "Priority": 7,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "assessmentsleads",
    "Description": "Wonderful, These many Pinnacle Scientific Assesments Carried."
  },
  {
    "Category": "Leads",
    "Title": "Admissions",
    "URL": "/kpireport?hname=Admissions&rtype=admissionleads",
    "Key": "LTA",
    "Zone": "red",
    "Priority": 8,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "admissionleads",
    "Description": "Wonderful, These many parents, families taken admissions."
  },
  {
    "Category": "Leads",
    "Title": "ElseWhere",
    "URL": "/kpireport?hname=ElseWhere&rtype=joinedelsewhere",
    "Key": "JSW",
    "Zone": "red",
    "Priority": 9,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "joinedelsewhere",
    "Description": "Psst. These many parents, families you couldn't give Hope & confidence."
  },
  {
    "Category": "Leave",
    "Title": "Total Staff Leaves",
    "URL": "/kpireport?hname=Staff Leaves&rtype=leaverequestnonparent",
    "Key": "TOSL",
    "Zone": "red",
    "Priority": 1,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestnonparent",
    "Description": "Total leaves from Co-Workers, Ensure compensations."
  },
  {
    "Category": "Leave",
    "Title": "<4 Compos",
    "URL": "/kpireport?hname=<4 Compos&rtype=leaverequestcomposlt4",
    "Key": "SLCLT4",
    "Zone": "red",
    "Priority": 2,
    "Role": "receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "leaverequestcomposlt4",
    "Description": "These therapists have applied leaves just with < 4 compos."
  },
  {
    "Category": "Leave",
    "Title": "Approval Pending",
    "URL": "/leaveapprovals",
    "Key": "SLAP",
    "Zone": "red",
    "Priority": 3,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Description": "These many leaves of Co-Workers are pending approval / rejection."
  },
  {
    "Category": "Leave",
    "Title": "Approved",
    "URL": "/kpireport?hname=Approved&rtype=leaverequestanalytic",
    "Key": "SLA",
    "Zone": "red",
    "Priority": 4,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestanalytic",
    "Description": "These many leaves of co-workers are approved. Ensure Compos."
  },
  {
    "Category": "Leave",
    "Title": "Unaproved",
    "URL": "/kpireport?hname=Unaproved&rtype=leaverequestanalyticunapproved",
    "Key": "SLUA",
    "Zone": "red",
    "Priority": 5,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestanalyticunapproved",
    "Description": "These many leaves of co-workers are unapproved. Double Deduction."
  },
  {
    "Category": "Leave",
    "Title": "Future",
    "URL": "/kpireport?hname=&rtype=",
    "Key": "SLF",
    "Zone": "red",
    "Priority": 6,
    "Role": "receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "leaverequestnonparentfuture",
    "Description": "These many leaves applied with future dates."
  },
  {
    "Category": "Leave",
    "Title": "Completed",
    "URL": "/kpireport?hname=&rtype=",
    "Key": "SLC",
    "Zone": "red",
    "Priority": 7,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestnonparentcompleted",
    "Description": "These many leaves applied are taken already."
  },
  {
    "Category": "Leave",
    "Title": "Canceled",
    "URL": "/kpireport?hname=Canceled&rtype=leaverequestnonparentcanceled",
    "Key": "SLCA",
    "Zone": "red",
    "Priority": 8,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestnonparentcanceled",
    "Description": "These many leaves are cancelled."
  },
  {
    "Category": "Leave",
    "Title": "Total Parent Leaves",
    "URL": "/kpireport?hname=Total Parent Leaves&rtype=leaverequestparent",
    "Key": "TOPL",
    "Zone": "red",
    "Priority": 9,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestparent",
    "Description": "These many leaves are taken by parents. Ensure Compos."
  },
  {
    "Category": "Leave",
    "Title": "Parent Completed",
    "URL": "/kpireport?hname=Completed&rtype=leaverequestparentcompleted",
    "Key": "PLC",
    "Zone": "red",
    "Priority": 10,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestparentcompleted",
    "Description": "These many leave requests of parents are completed."
  },
  {
    "Category": "Leave",
    "Title": "Parent Future",
    "URL": "/kpireport?hname=Future&rtype=leaverequestparentfuture",
    "Key": "PLF",
    "Zone": "red",
    "Priority": 11,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestparentfuture",
    "Description": "These many leave requests of parents are in Future."
  },
  {
    "Category": "Leave",
    "Title": "Canceled",
    "URL": "/kpireport?hname=Canceled&rtype=leaverequestparentcanceled",
    "Key": "PLCA",
    "Zone": "red",
    "Priority": 12,
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leaverequestparentcanceled",
    "Description": "These many leave requests of parents are cancelled."
  },

  {
    "Category": "Leave",
    "Title": "All",
    "URL": "/AllTherapistLeaves",
    "Key": "LVAL",
    "Zone": "red",
    "Priority": 1,
    "Role": "therapist",
    "Rkey": "allleaves",
    "Description": "Total leaves from Co-Workers, Ensure compensations."
  },
  {
    "Category": "Leave",
    "Title": "Approved",
    "URL": "/AllTherapistLeaves",
    "Key": "LVAP",
    "Zone": "red",
    "Priority": 2,
    "Role": "therapist",
    "Rkey": "leavesapproved",
    "Description": "These many leaves of co-workers are approved. Ensure Compos."
  },
  {
    "Category": "Leave",
    "Title": "UnApproved",
    "URL": "/AllTherapistLeaves",
    "Key": "LVUA",
    "Zone": "red",
    "Priority": 3,
    "Role": "therapist",
    "Rkey": "leavesunapproved",
    "Description": "These many leaves of co-workers are unapproved. Double Deduction."
  },
  {
    "Category": "Leave",
    "Title": "Pending",
    "URL": "/AllTherapistLeaves",
    "Key": "LVP",
    "Zone": "red",
    "Priority": 4,
    "Role": "therapist",
    "Rkey": "leavespending",
    "Description": "These many leaves of Co-Workers are pending approval / rejection."
  },
  {
    "Category": "Team",
    "Title": "Staff",
    "URL": "/kpireport?hname=Staff&rtype=activestaff",
    "Key": "TStaff",
    "Zone": "red",
    "Role": "receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "activestaff",
    "Description": "These many Co-Workers are empowering Kids, Parents, Families."
  },
  {
    "Category": "Team",
    "Title": "New Staff",
    "URL": "/kpireport?hname=New Staff&rtype=addedstaff",
    "Key": "ASTAFF",
    "Zone": "red",
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "addedstaff",
    "Description": "These many new co-workers are added."
  },
  {
    "Category": "Team",
    "Title": "Left Staff",
    "URL": "/kpireport?hname=Left Staff&rtype=leftstaff",
    "Key": "TLStaff",
    "Zone": "red",
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "leftstaff",
    "Description": "These many co-workers missed opportunity & left."
  },
  {
    "Category": "Team",
    "Title": "Parents",
    "URL": "/kpireport?hname=Parents&rtype=activeparents",
    "Key": "KIDS",
    "Zone": "red",
    "Role": "receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "activeparents",
    "Description": "These many parents, families, kids are being empowered."
  },
  {
    "Category": "Team",
    "Title": "New Parents",
    "URL": "/kpireport?hname=New Parents&rtype=addedparents",
    "Key": "AKIDs",
    "Zone": "red",
    "Role": "receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "addedparents",
    "Description": "These many new kids, parents, families have joined."
  },
  {
    "Category": "SR",
    "Title": "All",
    "URL": "/kpireport?hname=All&rtype=servicerequest",
    "Key": "SRT",
    "Zone": "red",
    "Priority": 1,
    "Role": "Therapist,Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,boss",
    "Rkey": "servicerequestall",
    "Description": ""
  },
  {
    "Category": "SR",
    "Title": "In Progress",
    "URL": "/kpireport?hname=In Progress&rtype=servicerequestpending",
    "Key": "SRIP",
    "Zone": "red",
    "Priority": 2,
    "Role": "Therapist,Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,boss",
    "Rkey": "servicerequestpending",
    "Description": "These many service requests are In-Process by NCC."
  },
  {
    "Category": "SR",
    "Title": "Resolved",
    "URL": "/kpireport?hname=Resolved&rtype=servicerequestresolved",
    "Key": "SRR",
    "Zone": "red",
    "Priority": 3,
    "Role": "Therapist,Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,boss",
    "Rkey": "servicerequestresolved",
    "Description": "These many service requests are completed and closed."
  },
  {
    "Category": "SR",
    "Title": "Closed",
    "URL": "/kpireport?hname=Closed&rtype=servicerequestwaiting",
    "Key": "SRW",
    "Zone": "red",
    "Priority": 4,
    "Role": "Therapist,Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,boss",
    "Rkey": "servicerequestwaiting",
    "Description": "These many service requests are resolved by NCC, Waiting at you."
  },
  {
    "Category": "SR",
    "Title": "Total",
    "Description": "Total Services Requests for everyone.",
    "URL": "/kpireport?rtype=servicerequest",
    "Role": "Therapist,Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SRT",
    "Zone": "red",
    "Priority": 1,
    "Rkey": "servicerequest"
  },
  {
    "Category": "SR",
    "Title": "Active",
    "Description": "Service Requests either In-Process, Re Open, Resolved & Waiting.",
    "URL": "/kpireport?rtype=servicerequestactive",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Zone": "red",
    "Priority": 2,
    "Rkey": "servicerequestactive"
  },
  {
    "Category": "SR",
    "Title": "In Process",
    "Description": "These many service requests are In-Process by NCC.",
    "URL": "/kpireport?rtype=servicerequestpending",
    "Role": "Therapist,Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SRIP",
    "Zone": "red",
    "Priority": 3,
    "Rkey": "servicerequestpending"
  },
  {
    "Category": "SR",
    "Title": "Waiting",
    "Description": "These many service requests are resolved by NCC, Waiting at you.",
    "URL": "/kpireport?rtype=servicerequestwaiting",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SRW",
    "Zone": "red",
    "Priority": 4,
    "Rkey": "servicerequestwaiting"
  },

  {
    "Category": "SR",
    "Title": "Reopen",
    "Description": "These many service requests are re-opened.",
    "URL": "/kpireport?rtype=servicerequestreopened",
    "Role": "Senior,receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Key": "SRRO",
    "Zone": "red",
    "Priority": 6,
    "Rkey": "servicerequestreopened"
  },
  {
    "Category": "SR",
    "Title": "5*",
    "Description": "These many service requests have gotten 5* Rating.",
    "URL": "/kpireport?rtype=servicerequestrating5",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SR5",
    "Zone": "red",
    "Priority": 7,
    "Rkey": "servicerequestrating5"
  },
  {
    "Category": "SR",
    "Title": "4*",
    "Description": "These many service requests have gotten 4* Rating.",
    "URL": "/kpireport?rtype=servicerequestrating4",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SR4",
    "Zone": "red",
    "Priority": 8,
    "Rkey": "servicerequestrating4"
  },
  {
    "Category": "SR",
    "Title": "3*",
    "Description": "These many service requests have gotten 3* Rating.",
    "URL": "/kpireport?rtype=servicerequestrating3",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SR3",
    "Zone": "red",
    "Priority": 9,
    "Rkey": "servicerequestrating3"
  },
  {
    "Category": "SR",
    "Title": "2*",
    "Description": "These many service requests have gotten 2* Rating.",
    "URL": "/kpireport?rtype=servicerequestrating2",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SR2",
    "Zone": "red",
    "Priority": 10,
    "Rkey": "servicerequestrating2"
  },
  {
    "Category": "SR",
    "Title": "1*",
    "Description": "These many service requests have gotten 1* Rating.",
    "URL": "/kpireport?rtype=servicerequestrating1",
    "Role": "Senior,receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "SR1",
    "Zone": "red",
    "Priority": 11,
    "Rkey": "servicerequestrating1"
  },


  {
    "Category": "Mirracles",
    "Title": "Total",
    "Desc": "These many Mirracles knowledge is acquired.",
    "URL": "/kpireport?rtype=mirraclestotal",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MIRT",
    "Zone": "red",
    "Priority": 1,
    "Rkey": "mirraclestotal"
  },
  {
    "Category": "Mirracles",
    "Title": "Contributed",
    "Desc": "These many Mirracles are contributed.",
    "URL": "/kpireport?rtype=mirraclescontributed",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MIRC",
    "Zone": "red",
    "Priority": 2,
    "Rkey": "mirraclescontributed"
  },
  {
    "Category": "Mirracles",
    "Title": "NContributed",
    "Desc": "These many co-workers have not contributed even 1 Mirracle.",
    "URL": "/kpireport?rtype=mnotcontributed",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MIRNC",
    "Zone": "red",
    "Priority": 3,
    "Rkey": "mnotcontributed"
  },
  {
    "Category": "Mirracles",
    "Title": "Views",
    "Desc": "These many people saw your Mirracles.",
    "URL": "/kpireport?rtype=allmirraclesviews",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MIRV",
    "Zone": "red",
    "Priority": 4,
    "Rkey": "allmirraclesviews"
  },
  {
    "Category": "Mirracles",
    "Title": "Top 100",
    "Desc": "Congratulations, Here are the Top 100 Mirracles.",
    "URL": "/kpireport?rtype=mirraclestop100",
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Key": "MIRT100",
    "Zone": "red",
    "Priority": 5,
    "Rkey": "mirraclestop100"
  },
  {
    "Category": "Mirracles",
    "Title": "Bottom 100",
    "Desc": "Make them better: Here are the Bottom 100 Mirracles.",
    "URL": "/kpireport?rtype=mirraclesbottom100",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MIRB100",
    "Zone": "red",
    "Priority": 6,
    "Rkey": "mirraclesbottom100"
  },
  {
    "Category": "Mirracles",
    "Title": "Languages Covered",
    "Desc": "Total languages covered by Mirracles by far.",
    "URL": "/kpireport?rtype=mirracleslc",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MIRLC",
    "Zone": "red",
    "Priority": 7,
    "Rkey": "mirracleslc"
  },
  {
    "Category": "Mirracles",
    "Title": "Languages NCovered",
    "Desc": "Total languages not covered by Mirracles by far.",
    "URL": "/kpireport?rtype=mirraclesnotcovered",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MIRLNC",
    "Zone": "red",
    "Priority": 8,
    "Rkey": "mirraclesnotcovered"
  },
  {
    "Category": "Mirracles",
    "Title": "Courses Pending",
    "Desc": "These many courses are assigned to you and waiting completion.",
    "URL": "/kpireport?rtype=coursespending",
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Key": "MACP",
    "Zone": "red",
    "Priority": 9,
    "Rkey": "coursespending"
  },
  {
    "Category": "Mirracles",
    "Title": "Courses Completed",
    "Desc": "These many courses are completed. Good Job.",
    "URL": "/kpireport?rtype=coursescompleted",
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Key": "MACC",
    "Zone": "red",
    "Priority": 10,
    "Rkey": "coursescompleted"
  },
  {
    "Category": "Compo",
    "Title": "Absents",
    "URL": "/kpireport?hname=Attendance&rtype=attendanceabsent",
    "Key": "AGA",
    "Zone": "red",
    "Priority": 4,
    "Role": "Therapist,Boss",
    "Rkey": "attendanceabsent"
  },
  {
    "Category": "Compo",
    "Title": "Compos",
    "URL": "/kpireport?hname=Compos&rtype=servicerequestwaiting",
    "Key": "CPC",
    "Zone": "red",
    "Priority": 4,
    "Role": "Therapist,Boss",
    "Rkey": "servicerequestwaiting"
  },
  {
    "Category": "Inno",
    "Title": "Kid Status",
    "URL": "/kpireport?hname=Kid Status&rtype=kidconditionsandbehaviours",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "receptionist,owner,Senior,BDC,NCC",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><circle cx=\"16\" cy=\"4\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></circle><path d=\"M21,12.683c-1.075-1.617-2.913-2.683-5-2.683-2.087,0-3.925,1.066-5,2.683\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></path><circle cx=\"7\" cy=\"19\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><path d=\"M7,25c-3.314,0-6,2.686-6,6H13c0-3.314-2.686-6-6-6Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><circle cx=\"25\" cy=\"19\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><path d=\"M25,25c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Conditions Stats",
    "URL": "/kpireport?hname=conditions stats&rtype=conditionsstats",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "receptionist,owner,Senior,BDC,NCC",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><circle cx=\"16\" cy=\"4\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></circle><path d=\"M21,12.683c-1.075-1.617-2.913-2.683-5-2.683-2.087,0-3.925,1.066-5,2.683\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></path><circle cx=\"7\" cy=\"19\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><path d=\"M7,25c-3.314,0-6,2.686-6,6H13c0-3.314-2.686-6-6-6Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><circle cx=\"25\" cy=\"19\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><path d=\"M25,25c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"

  },
  {
    "Category": "Inno",
    "Title": "Centers Emp",
    "URL": "/kpireport?hname=Centers Emp&rtype=centerexpenses",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "owner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={2}><g strokeWidth={2} transform='translate(0, 0)'><line x1={11} y1={11} x2={53} y2={11} fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /><line x1={11} y1={51} x2={53} y2={51} fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /><path d='M48,62H16a5,5,0,0,1-5-5V7a5,5,0,0,1,5-5H48a5,5,0,0,1,5,5V57A5,5,0,0,1,48,62Z' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /><line x1={32} y1={17} x2={32} y2={45} fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /><path d='M38.75,21.438C35.508,19.655,25.3,18.326,25.3,24.464c0,7.348,12.967,4.755,12.967,11.238S29.835,41.7,24,39.591' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /></g></svg>"

  },
  {
    "Category": "Inno",
    "Title": "Seva",
    "URL": "/kpireport?hname=Sevadocs&rtype=sevadocs",
    "Key": "",
    "Zone": "",
    "Priority": 2,
    "Role": "manager, owner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={1.5}><g strokeWidth={1.5} transform='translate(0.5, 0.5)'><path d='M54,10.5A7.5,7.5,0,0,0,40,6.769a7.495,7.495,0,1,0-11.485,9.323L40,27.607,51.485,16.092A7.47,7.47,0,0,0,54,10.5Z' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={1.5} data-color='color-2' strokeLinejoin='miter' /><path d='M48.986,40l6.331-3.8A4.415,4.415,0,0,1,61.3,37.6h0a4.413,4.413,0,0,1-1.014,5.875l-11.3,8.754a6,6,0,0,1-2.218,1.076L26.513,58.368a6,6,0,0,1-4.714-.783L6.986,48h-5V32l9.958-1.66a6,6,0,0,1,3.859.651L24.986,36l14.911.785a4.315,4.315,0,0,1,4.089,4.309h0a4.315,4.315,0,0,1-3.886,4.3L23.986,47' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={1.5} strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Offers",
    "URL": "/kpireport?hname=Offers&rtype=pinnaclegiveawayoffer",
    "Key": "",
    "Zone": "",
    "Priority": 3,
    "Role": "manager, owner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={1}><g strokeWidth={1} transform='translate(0.5, 0.5)'><polyline points='16 10 18 2 46 2 48 10' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={1} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /> <polyline points='16 54 18 62 46 62 48 54' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={1} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /> <path d='M54,49a5,5,0,0,1-5,5H15a5,5,0,0,1-5-5V15a5,5,0,0,1,5-5H49a5,5,0,0,1,5,5Z' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={1} strokeLinejoin='miter' /> <path d='M41.983,23.038A6.837,6.837,0,0,0,32,23.3a6.838,6.838,0,0,0-9.983-.26,7.03,7.03,0,0,0,0,9.857L32,43l9.983-10.1a7.03,7.03,0,0,0,0-9.857Z' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={1} data-color='color-2' strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Grace Compensation",
    "URL": "/kpireport?hname=Grace Compensation&rtype=gracecompensation",
    "Key": "",
    "Zone": "",
    "Priority": 4,
    "Role": "receptionist,manager, owner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><circle data-color=\"color-2\" cx=\"32\" cy=\"7.996\" r=\"6\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><path d=\"M34,41V58.827A3.115,3.115,0,0,0,36.839,62,3,3,0,0,0,40,59.161c0-.055,0-.11,0-.165V25l15.573-.865A2.57,2.57,0,0,0,58,21.565h0A2.569,2.569,0,0,0,55.431,19H8.569A2.569,2.569,0,0,0,6,21.565H6a2.57,2.57,0,0,0,2.427,2.566L24,25V58.827A3.115,3.115,0,0,0,26.839,62,3,3,0,0,0,30,59.161c0-.055,0-.11,0-.165V41Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Profile Pick Not Set",
    "URL": "/kpireport?hname=NO Profile Pics&rtype=noprofileusers",
    "Key": "",
    "Zone": "",
    "Priority": 5,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={1}><g strokeWidth={1} transform='translate(0.5, 0.5)'><path fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} d='M50,51H14v-4.483 c0-3.55,2.328-6.669,5.733-7.677C22.92,37.896,27.208,37,32,37c4.713,0,9.027,0.911,12.25,1.864c3.411,1.008,5.75,4.125,5.75,7.682 V51z' strokeLinejoin='miter' /> <path fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} d='M22,19 c0-5.523,4.477-10,10-10s10,4.477,10,10s-4.477,12-10,12S22,24.523,22,19z' strokeLinejoin='miter' /> <polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} points=' 2,14 2,2 14,2 ' strokeLinejoin='miter' /> <polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} points=' 50,2 62,2 62,14 ' strokeLinejoin='miter' /> <polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} points=' 2,50 2,62 14,62 ' strokeLinejoin='miter' /> <polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} points=' 50,62 62,62 62,50 ' strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Discount",
    "URL": "/kpireport?hname=Discount Docs&rtype=discountdocs",
    "Key": "",
    "Zone": "",
    "Priority": 6,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={1.5}><g strokeWidth={1.5} transform='translate(0.5, 0.5)'><polyline points='16.227 52.227 24 60 27 57 23.872 47.616' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={1.5} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /><polyline points='11.773 47.773 4 40 7 37 16.544 39.863' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={1.5} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /><polyline points='38.724 35.176 54 60 60 54 50 24' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={1.5} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /><polyline points='21.934 21.037 28.824 25.276 40.075 14.025 29.708 10.569' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={1.5} strokeLinejoin='miter' /><path d='M22.243,12.243a6,6,0,0,0-8.486-8.486L13,4.515l-.757-.758a6,6,0,0,0-8.486,8.486L4.515,13,13,21.485Z' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={1.5} data-color='color-2' strokeLinejoin='miter' /><path d='M57.95,15.95c2.733-2.734,4.733-9.166,2-11.9s-9.166-.733-11.9,2l-28,28L7.156,55.426a1.033,1.033,0,0,0,1.418,1.418L29.95,43.95Z' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={1.5} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Kubera",
    "URL": "/kpireport?hname=Kubera Missing&rtype=kuberamissing",
    "Key": "",
    "Zone": "",
    "Priority": 7,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' strokeWidth={2}><g strokeWidth={2} transform='translate(0, 0)'><polyline data-cap='butt' points='19.2 4.4 14 7 19 14' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={2} strokeLinecap='butt' strokeLinejoin='miter' /><polyline data-cap='butt' points='28.8 4.4 34 7 29 14' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={2} strokeLinecap='butt' strokeLinejoin='miter' /><polyline points='21 8 18 2 30 2 27 8' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /><path d='M29,14H19S7,27,7,35c0,6,4.25,11,17,11s17-5,17-11C41,27,29,14,29,14Z' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /><line data-color='color-2' x1={24} y1={21} x2={24} y2={39} fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /><path data-color='color-2' d='M28.96,23.974c-2.273-1.181-9.574-2.072-9.574,1.992,0,4.865,9.091,3.148,9.091,7.441s-5.909,3.971-10,2.576' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Locked Accounts",
    "URL": "/kpireport?hname=Locked Accounts&rtype=lockedaccounts",
    "Key": "",
    "Zone": "",
    "Priority": 8,
    "Role": "manager, owner,harvest",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><polyline points=\"2 46 2 21 38 21 38 36\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></polyline><path d=\"M30,21V12A10.029,10.029,0,0,0,20,2h0A10.029,10.029,0,0,0,10,12v9\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><circle cx=\"20\" cy=\"32\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"29\" cy=\"52\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"41\" cy=\"52\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"53\" cy=\"52\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"17\" cy=\"52\" r=\"3\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><rect x=\"8\" y=\"42\" width=\"54\" height=\"20\" rx=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Staff Util",
    "URL": "/kpireport?hname=Staff Util&rtype=staffutil",
    "Key": "",
    "Zone": "",
    "Priority": 9,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><line x1=\"24\" y1=\"41\" x2=\"24\" y2=\"34.247\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><line x1=\"40\" y1=\"41\" x2=\"40\" y2=\"34.247\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><path d=\"M45,17v7A13,13,0,0,1,32,37h0A13,13,0,0,1,19,24V17\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></path><path d=\"M40,41c0,2.209-3.582,4-8,4s-8-1.791-8-4L6.636,48.442A6,6,0,0,0,3,53.956V61H61V53.956a6,6,0,0,0-3.636-5.514Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></path><path d=\"M44.576,27.242C41.853,25.471,37.138,23,32,23s-9.853,2.471-12.576,4.242\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></path><path d=\"M36,28.469a17.292,17.292,0,0,0-8,0\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-color=\"color-2\" stroke-linejoin=\"miter\"></path><line x1=\"39\" y1=\"54\" x2=\"48\" y2=\"54\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-color=\"color-2\" stroke-linejoin=\"miter\"></line><path d=\"M19,17V6s3.714-3,13-3c8.357,0,13,3,13,3V17s-4.643-3-13-3C22.714,14,19,17,19,17Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-color=\"color-2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "SEVA Tenure Completion",
    "URL": "/kpireport?hname=SEVA Tenure Completion&rtype=sevatenurecompletion",
    "Key": "",
    "Zone": "",
    "Priority": 10,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><polygon points=\"43.598 4 20.402 4 4 20.402 4 43.598 20.402 60 43.598 60 60 43.598 60 20.402 43.598 4\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></polygon><line x1=\"32\" y1=\"14\" x2=\"32\" y2=\"39\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></line><circle cx=\"32\" cy=\"47\" r=\"1\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Parents ANU",
    "URL": "/kpireport?hname=Parents Not Using App&rtype=parentsnotusingapp",
    "Key": "",
    "Zone": "",
    "Priority": 11,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><line x1=\"9\" y1=\"9\" x2=\"39\" y2=\"9\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><line x1=\"9\" y1=\"37\" x2=\"39\" y2=\"37\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><path d=\"M9,18V6a4,4,0,0,1,4-4H35a4,4,0,0,1,4,4V42a4,4,0,0,1-4,4H13a4,4,0,0,1-4-4V28\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><line x1=\"3\" y1=\"23\" x2=\"24\" y2=\"23\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><polyline points=\"18 17 24 23 18 29\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></polyline></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "ID Card",
    "URL": "/pinnacleidcard",
    "Key": "",
    "Zone": "",
    "Priority": 12,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><polyline data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-miterlimit=\"10\" points=\"16.672,34.849 8,53 17,52 22,60 30.389,41.936 \" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></polyline> <polyline data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-miterlimit=\"10\" points=\"47.328,34.849 56,53 47,52 42,60 33.611,41.936 \" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></polyline> <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"32\" cy=\"22\" r=\"20\" stroke-linejoin=\"miter\"></circle> <polygon fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"22,19.655 28.917,18.704 32.055,12.466 35.098,18.751 42,19.807 36.963,24.643 38.091,31.534 31.935,28.238 25.73,31.44 26.963,24.567 \" stroke-linejoin=\"miter\"></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Play Ground",
    "URL": "/playground",
    "Key": "",
    "Zone": "",
    "Priority": 13,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><circle cx=\"12.576\" cy=\"15.638\" r=\"2\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><path d=\"M43.709,14.416l-.991-7.053a5,5,0,0,0-5.647-4.256L7.363,7.282a5,5,0,0,0-4.256,5.647L7.282,42.637A4.986,4.986,0,0,0,12.644,46.9\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></path><rect x=\"19\" y=\"19\" width=\"40\" height=\"40\" rx=\"5\" stroke-width=\"2\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" transform=\"translate(-5.048 72.193) rotate(-82)\" stroke-linejoin=\"miter\"></rect><circle cx=\"29.638\" cy=\"26.576\" r=\"2\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"51.424\" cy=\"29.638\" r=\"2\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"26.576\" cy=\"48.362\" r=\"2\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"48.362\" cy=\"51.424\" r=\"2\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"39\" cy=\"39\" r=\"2\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "TA",
    "URL": "/talentacquisition",
    "Key": "",
    "Zone": "",
    "Priority": 14,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path d=\"M13.279,17A7.967,7.967,0,0,1,2.721,17,7.991,7.991,0,0,1,16,23\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></path><path d=\"M18.721,17a7.967,7.967,0,0,0,10.558,0A7.991,7.991,0,0,0,16,23\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></path><circle cx=\"16\" cy=\"7\" r=\"6\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-color=\"color-2\" stroke-linejoin=\"miter\"></circle><line x1=\"16\" y1=\"5\" x2=\"16\" y2=\"9\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-color=\"color-2\" stroke-linejoin=\"miter\"></line><polygon points=\"10 23 22 23 21 31 11 31 10 23\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Royalty",
    "URL": "/royalty",
    "Key": "",
    "Zone": "",
    "Priority": 15,
    "Role": "manager, owner, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"27\" y1=\"6\" x2=\"5\" y2=\"6\" stroke-linejoin=\"miter\"></line> <rect data-color=\"color-2\" x=\"8\" y=\"18\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" width=\"6\" height=\"6\" stroke-linejoin=\"miter\"></rect> <polyline fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"4,13 4,31 18,31 18,22 24,22 24,31 28,31 28,13 \" stroke-linejoin=\"miter\"></polyline> <polygon fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"27,6 31,10 31,13 1,13 1,10 5,6 5,1 27,1 \" stroke-linejoin=\"miter\"></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Contributions",
    "URL": "/contributions",
    "Key": "",
    "Zone": "",
    "Priority": 16,
    "Role": "manager, owner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"27\" y1=\"6\" x2=\"5\" y2=\"6\" stroke-linejoin=\"miter\"></line> <rect data-color=\"color-2\" x=\"8\" y=\"18\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" width=\"6\" height=\"6\" stroke-linejoin=\"miter\"></rect> <polyline fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"4,13 4,31 18,31 18,22 24,22 24,31 28,31 28,13 \" stroke-linejoin=\"miter\"></polyline> <polygon fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"27,6 31,10 31,13 1,13 1,10 5,6 5,1 27,1 \" stroke-linejoin=\"miter\"></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Assessments",
    "URL": "/bookedassessments",
    "Key": "",
    "Zone": "",
    "Priority": 17,
    "Role": "therapist",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><rect x=\"5\" y=\"5\" width=\"54\" height=\"54\" rx=\"5\" ry=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect> <line data-cap=\"butt\" data-color=\"color-2\" x1=\"32\" y1=\"30\" x2=\"37\" y2=\"20\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line> <path data-color=\"color-2\" d=\"M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Pro",
    "URL": "/prosuggestions",
    "Key": "",
    "Zone": "",
    "Priority": 18,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={2}><g strokeWidth={2} transform='translate(0, 0)'><line x1={32} y1={35} x2={32} y2={25} fill='none' stroke='#444444' strokeWidth={2} data-cap='butt' data-color='color-2' strokeLinecap='butt' strokeLinejoin='miter' /> <path d='M22,4H15V9c0,6,3.2,9,7.2,9' fill='none' stroke='#444444' strokeWidth={2} data-cap='butt' data-color='color-2' strokeLinecap='butt' strokeLinejoin='miter' /> <path d='M42,4h7V9c0,6-3.2,9-7.2,9' fill='none' stroke='#444444' strokeWidth={2} data-cap='butt' data-color='color-2' strokeLinecap='butt' strokeLinejoin='miter' /> <path d='M22,2H42V15A10,10,0,0,1,32,25h0A10,10,0,0,1,22,15Z' fill='none' stroke='#444444' strokeLinecap='square' strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /> <line x1={25} y1={35} x2={39} y2={35} fill='none' stroke='#444444' strokeLinecap='square' strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /> <path d='M14,62V58L3.444,45.685A6,6,0,0,1,2,41.78V23.5A3.5,3.5,0,0,1,5.5,20h0A3.5,3.5,0,0,1,9,23.5V35.13' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={2} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /> <path d='M26,62V48.485a6,6,0,0,0-1.757-4.242L14.5,34.5a3.535,3.535,0,0,0-5,0h0a3.535,3.535,0,0,0,0,5L17,47' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={2} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /> <path d='M50,62V58L60.556,45.685A6,6,0,0,0,62,41.78V23.5A3.5,3.5,0,0,0,58.5,20h0A3.5,3.5,0,0,0,55,23.5V35.13' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={2} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /> <path d='M38,62V48.485a6,6,0,0,1,1.757-4.242L49.5,34.5a3.535,3.535,0,0,1,5,0h0a3.535,3.535,0,0,1,0,5L47,47' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={2} data-cap='butt' strokeLinecap='butt' strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Credits",
    "URL": "/credits",
    "Key": "",
    "Zone": "",
    "Priority": 19,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' points='27.081,31 3,31 3,11 45,11 45,31 40,31 ' stroke-linejoin='miter' stroke-linecap='butt'></polyline> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='23' cy='21' r='4' stroke-linejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' x1='13' y1='17' x2='9' y2='17' stroke-linejoin='miter'></line> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8' stroke-linejoin='miter' stroke-linecap='butt'></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Book Assessments",
    "URL": "/bookassessment",
    "Key": "",
    "Zone": "",
    "Priority": 20,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><rect x=\"5\" y=\"5\" width=\"54\" height=\"54\" rx=\"5\" ry=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect> <line data-cap=\"butt\" data-color=\"color-2\" x1=\"32\" y1=\"30\" x2=\"37\" y2=\"20\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line> <path data-color=\"color-2\" d=\"M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Book Assessments",
    "URL": "/bookassessment",
    "Key": "",
    "Zone": "",
    "Priority": 21,
    "Role": "therapist",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><rect x=\"5\" y=\"5\" width=\"54\" height=\"54\" rx=\"5\" ry=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect> <line data-cap=\"butt\" data-color=\"color-2\" x1=\"32\" y1=\"30\" x2=\"37\" y2=\"20\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line> <path data-color=\"color-2\" d=\"M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Extended Services",
    "URL": "/kpireport?hname=Extended Services&rtype=extendedservices",
    "Key": "",
    "Zone": "",
    "Priority": 22,
    "Role": "owner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path d=\"M30,10.728A7.624,7.624,0,0,0,16,6.445,7.753,7.753,0,0,0,9.653,3,7.7,7.7,0,0,0,2,10.728C2,18.455,16,30,16,30s.912-.752,2.269-2\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></path> <circle data-color=\"color-2\" cx=\"25\" cy=\"20\" r=\"6\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></circle> <line data-color=\"color-2\" x1=\"25\" y1=\"18\" x2=\"25\" y2=\"22\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" x1=\"23\" y1=\"20\" x2=\"27\" y2=\"20\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Assessments",
    "URL": "/bookedassessments",
    "Key": "",
    "Zone": "",
    "Priority": 23,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><rect x=\"5\" y=\"5\" width=\"54\" height=\"54\" rx=\"5\" ry=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect> <line data-cap=\"butt\" data-color=\"color-2\" x1=\"32\" y1=\"30\" x2=\"37\" y2=\"20\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line> <path data-color=\"color-2\" d=\"M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "New Lead",
    "URL": "/createlead",
    "Key": "",
    "Zone": "",
    "Priority": 24,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><polyline fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"22,30 2,30 2,2 42,2 42,15 \" stroke-linejoin=\"miter\"></polyline> <ellipse data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"37\" cy=\"24\" rx=\"9\" ry=\"4\" stroke-linejoin=\"miter\"></ellipse> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-miterlimit=\"10\" d=\"M28,24v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></path> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-miterlimit=\"10\" d=\"M28,30v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></path> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-miterlimit=\"10\" d=\"M28,36v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></path> <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"22\" cy=\"16\" r=\"4\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Services",
    "URL": "/serviceland",
    "Key": "",
    "Zone": "",
    "Priority": 25,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M24,8c0-3.3-2.7-6-6-6 c-2.6,0-4.8,1.7-5.6,4c-0.1,0-0.2,0-0.4,0C6.5,6,2,10.5,2,16c0,2.7,1.1,5.1,2.8,6.9C3.1,24,2,25.9,2,28c0,2,1,3.8,2.5,4.9 c-0.3,1-0.5,2-0.5,3.1c0,5.5,4.5,10,10,10s10-4.5,10-10V20\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M24,8c0-3.3,2.7-6,6-6 c2.6,0,4.8,1.7,5.6,4c0.1,0,0.2,0,0.4,0c5.5,0,10,4.5,10,10c0,2.7-1.1,5.1-2.8,6.9C44.9,24,46,25.9,46,28c0,2-1,3.8-2.5,4.9 c0.3,1,0.5,2,0.5,3.1c0,5.5-4.5,10-10,10s-10-4.5-10-10\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M12,26 c-2.8,0-5.4-1.2-7.2-3.1\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M36,26 c2.8,0,5.4-1.2,7.2-3.1\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M24,8c0,3.3-2.7,6-6,6\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M24,8c0,3.3,2.7,6,6,6\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M16,31.7 c-2.3-0.8-4-3-4-5.7c0-1.8,0.8-3.4,2-4.5\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M32,31.7c2.3-0.8,4-3,4-5.7 c0-1.8-0.8-3.4-2-4.5\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Staff",
    "URL": "/createstaff?type=create",
    "Key": "",
    "Zone": "",
    "Priority": 26,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeMiterlimit='10' d='M21.427,27.439 C20.464,25.41,18.395,24,16,24H8c-3.314,0-6,2.686-6,6v8l4,2l1,14h11' strokeLinejoin='miter' strokeLinecap='butt'></path> <circle data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' cx='12' cy='12' r='6' strokeLinejoin='miter'></circle> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeMiterlimit='10' d='M42.573,27.439 C43.536,25.41,45.605,24,48,24h8c3.314,0,6,2.686,6,6v8l-4,2l-1,14H46' strokeLinejoin='miter' strokeLinecap='butt'></path> <circle data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' cx='52' cy='12' r='6' strokeLinejoin='miter'></circle> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M38,62H26l-1-16l-5-1V32 c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v13l-5,1L38,62z' strokeLinejoin='miter'></path> <circle fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' cx='32' cy='10' r='8' strokeLinejoin='miter'></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Parent",
    "URL": "/createparent",
    "Key": "",
    "Zone": "",
    "Priority": 27,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><path data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M24,11 c0-4.971,4.029-9,9-9s9,4.029,9,9s-4.029,11-9,11S24,15.971,24,11z' strokeLinejoin='miter'></path> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeMiterlimit='10' d='M26,27.968 C27.905,27.398,30.227,27,33,27c4.986,0,8.258,1.286,10.273,2.553c1.719,1.082,2.727,3,2.727,5.031V46H33' strokeLinejoin='miter' strokeLinecap='butt'></path> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M6,23c0-4.418,3.582-8,8-8 s8,3.582,8,8s-3.582,9-8,9S6,27.418,6,23z' strokeLinejoin='miter'></path> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M26,42.494 c0-1.628-0.977-3.1-2.488-3.705C21.432,37.957,18.141,37,14,37s-7.432,0.957-9.512,1.789C2.977,39.394,2,40.867,2,42.494V46h24 V42.494z' strokeLinejoin='miter'></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Expenses",
    "URL": "/createexpense",
    "Key": "",
    "Zone": "",
    "Priority": 28,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><circle data-stroke='none' fill='#444444' cx='48' cy='40' r='2' strokeLinejoin='miter' strokeLinecap='square'></circle> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M7,18c-2.761,0-5-2.239-5-5 v0c0-2.761,2.239-5,5-5h4' strokeLinejoin='miter'></path> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M58,34V18H7 c-2.761,0-5-2.239-5-5v41c0,4.418,3.582,8,8,8h48V46' strokeLinejoin='miter'></path> <path data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M62,46H48 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h14V46z' strokeLinejoin='miter'></path> <polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' points=' 11,13 11,2 51,2 51,13 11,13 ' strokeLinejoin='miter'></polyline></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Create Invoices",
    "URL": "/createinvoice",
    "Key": "",
    "Zone": "",
    "Priority": 29,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='38' y1='22' x2='34' y2='22' strokeLinejoin='miter'></line> <line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='26' y1='22' x2='22' y2='22' strokeLinejoin='miter'></line> <line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='14' y1='22' x2='10' y2='22' strokeLinejoin='miter'></line> <line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='38' y1='52' x2='34' y2='52' strokeLinejoin='miter'></line> <line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='50' y1='22' x2='46' y2='22' strokeLinejoin='miter'></line> <line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='50' y1='52' x2='46' y2='52' strokeLinejoin='miter'></line> <line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='26' y1='52' x2='22' y2='52' strokeLinejoin='miter'></line> <line data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='14' y1='52' x2='10' y2='52' strokeLinejoin='miter'></line> <circle data-stroke='none' fill='#444444' cx='48' cy='37' r='2' strokeLinejoin='miter' strokeLinecap='square'></circle> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M7,15c-2.761,0-5-2.239-5-5 v0c0-2.761,2.239-5,5-5h40v4' strokeLinejoin='miter'></path> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M58,31V15H7 c-2.761,0-5-2.239-5-5v41c0,4.418,3.582,8,8,8h48V43' strokeLinejoin='miter'></path> <path data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M62,43H48 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h14V43z' strokeLinejoin='miter'></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Goal Setting",
    "URL": "/goalsetting",
    "Key": "",
    "Zone": "",
    "Priority": 30,
    "Role": "therapist",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><path data-cap='butt' fill='none' stroke='#000000' strokeWidth='1' strokeMiterlimit='10' d='M48.255,29 C49.38,31.779,50,34.817,50,38c0,13.255-10.745,24-24,24S2,51.255,2,38s10.745-24,24-24c3.182,0,6.22,0.619,8.999,1.744' strokeLinejoin='miter' strokeLinecap='butt'></path> <circle fill='none' stroke='#000000' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' cx='26' cy='38' r='13' strokeLinejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#000000' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='26' y1='38' x2='58' y2='6' strokeLinejoin='miter'></line> <polygon data-color='color-2' fill='none' stroke='#000000' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' points=' 51,13 49,3 41,11 43,21 53,23 61,15 ' strokeLinejoin='miter'></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Goal Review",
    "URL": "/goalskpi?status=pending&month=&year=",
    "Key": "",
    "Zone": "",
    "Priority": 31,
    "Role": "therapist",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><path data-cap='butt' fill='none' stroke='#000000' strokeWidth='1' strokeMiterlimit='10' d='M48.255,29 C49.38,31.779,50,34.817,50,38c0,13.255-10.745,24-24,24S2,51.255,2,38s10.745-24,24-24c3.182,0,6.22,0.619,8.999,1.744' strokeLinejoin='miter' strokeLinecap='butt'></path> <circle fill='none' stroke='#000000' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' cx='26' cy='38' r='13' strokeLinejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#000000' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='26' y1='38' x2='58' y2='6' strokeLinejoin='miter'></line> <polygon data-color='color-2' fill='none' stroke='#000000' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' points=' 51,13 49,3 41,11 43,21 53,23 61,15 ' strokeLinejoin='miter'></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Compensation",
    "URL": "/compensation",
    "Key": "",
    "Zone": "",
    "Priority": 32,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,boss",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><polyline fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' points='22,40 2,40 2,2 36,2 36,18 ' strokeLinejoin='miter'></polyline> <rect x='28' y='24' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' width='34' height='38' strokeLinejoin='miter'></rect> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeMiterlimit='10' d='M44,10h8c4.418,0,8,3.582,8,8v0' strokeLinejoin='miter' strokeLinecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' points=' 50,4 44,10 50,16 ' strokeLinejoin='miter'></polyline> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeMiterlimit='10' d='M20,54h-8c-4.418,0-8-3.582-8-8 v0' strokeLinejoin='miter' strokeLinecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' points=' 14,60 20,54 14,48 ' strokeLinejoin='miter'></polyline></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Touch Base",
    "URL": "/touchbase",
    "Key": "",
    "Zone": "",
    "Priority": 33,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M2,42h2 c2.209,0,4-1.791,4-4v-2l-4.451-2.318c-1.462-0.761-1.427-2.865,0.06-3.577L8,28v-4l4.573-1.143 c1.508-0.377,2.028-2.255,0.929-3.354L8,14V4' data-color='color-2' strokeLinejoin='miter'></path> <path fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' d='M16,32l6-8V12 c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16c0,2.209-1.791,4-4,4H28H16z' strokeLinejoin='miter'></path> <line fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='30' y1='16' x2='38' y2='16' strokeLinejoin='miter'></line> <line fill='none' stroke='#444444' strokeWidth='1' strokeLinecap='square' strokeMiterlimit='10' x1='30' y1='24' x2='38' y2='24' strokeLinejoin='miter'></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Therapist Leave",
    "URL": "/therapistleaverequest",
    "Key": "",
    "Zone": "",
    "Priority": 34,
    "Role": "receptionist",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='32px' height='32px' viewBox='0 0 32 32' strokeWidth='0.5'><g strokeWidth='0.5' transform='translate(0.5, 0.5)'><polyline data-color='color-2' points='16 13 16 19 22 19' fill='none' stroke='#484141' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='0.5' strokeLinejoin='miter'></polyline> <circle cx='16' cy='19' r='12' fill='none' stroke='#484141' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='0.5' strokeLinejoin='miter'></circle> <line data-color='color-2' x1='12' y1='1' x2='20' y2='1' fill='none' stroke='#484141' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='0.5' strokeLinejoin='miter'></line> <line data-cap='butt' data-color='color-2' x1='16' y1='1' x2='16' y2='4' fill='none' stroke='#484141' strokeMiterlimit='10' strokeWidth='0.5' strokeLinecap='butt' strokeLinejoin='miter'></line> <line data-color='color-2' x1='26' y1='7' x2='28' y2='9' fill='none' stroke='#484141' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='0.5' strokeLinejoin='miter'></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Config",
    "URL": "/mirraclesconfig",
    "Key": "",
    "Zone": "",
    "Priority": 35,
    "Role": "owner,facilityowner,BDC,NCC",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={2}><g strokeWidth={2} transform='translate(0, 0)'><path data-cap='butt' data-color='color-2' d='M24.933,31.439l-2.324-2.725A12.972,12.972,0,0,1,4.492,13.492l6.739,6.739,9-9L13.492,4.492A12.975,12.975,0,0,1,28.714,22.609L32,25.412' fill='none' stroke='#444444' strokeMiterlimit={10} strokeWidth={2} strokeLinecap='butt' strokeLinejoin='miter' /><path data-color='color-2' d='M43.474,35.2,58.588,48.089a4,4,0,0,1,.24,5.879l-4.86,4.86a4,4,0,0,1-5.879-.24l-12.277-14.4' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /><path d='M59.508,13.492l-6.739,6.739-9-9,6.739-6.739A12.975,12.975,0,0,0,35.286,22.609L5.412,48.089a4,4,0,0,0-.24,5.879l4.86,4.86a4,4,0,0,0,5.879-.24l25.48-29.874A12.972,12.972,0,0,0,59.508,13.492Z' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Available Slots",
    "URL": "/availableslots",
    "Key": "",
    "Zone": "",
    "Priority": 36,
    "Role": "owner,facilityowner,BDC,NCC,harvest,receptionist",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><polyline data-color=\"color-2\" points=\"16 16 32 32 43 21\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></polyline><circle cx=\"32\" cy=\"32\" r=\"29\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><line data-color=\"color-2\" x1=\"32\" y1=\"9\" x2=\"32\" y2=\"14\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line data-color=\"color-2\" x1=\"55\" y1=\"32\" x2=\"50\" y2=\"32\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line data-color=\"color-2\" x1=\"32\" y1=\"55\" x2=\"32\" y2=\"50\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line data-color=\"color-2\" x1=\"9\" y1=\"32\" x2=\"14\" y2=\"32\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Consecutive Leaves",
    "URL": "/kpireport?hname=Consecutive Leaves&rtype=consecutiveleaves",
    "Key": "",
    "Zone": "",
    "Priority": 37,
    "Role": "owner,facilityowner,harvest",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><line data-cap=\"butt\" x1=\"60\" y1=\"23\" x2=\"4\" y2=\"23\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><path d=\"M29,56H9a5,5,0,0,1-5-5V14A5,5,0,0,1,9,9H55a5,5,0,0,1,5,5V34\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><line x1=\"17\" y1=\"3\" x2=\"17\" y2=\"15\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"47\" y1=\"3\" x2=\"47\" y2=\"15\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><circle data-color=\"color-2\" cx=\"47\" cy=\"49\" r=\"12\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><polyline data-color=\"color-2\" points=\"42 50 45 53 52 46\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></polyline></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Impunctual",
    "URL": "/kpireport?hname=Impunctual&rtype=biometriclateearly",
    "Key": "",
    "Zone": "",
    "Priority": 38,
    "Role": "receptionist,owner,facilityowner,BDC,NCC",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><line data-cap=\"butt\" x1=\"7\" y1=\"60\" x2=\"14\" y2=\"52\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><line data-cap=\"butt\" x1=\"57\" y1=\"60\" x2=\"50\" y2=\"52\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><circle cx=\"32\" cy=\"36\" r=\"24\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><path data-color=\"color-2\" d=\"M26.756,6.563A13.567,13.567,0,0,0,5.411,22.568\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><path data-color=\"color-2\" d=\"M58.589,22.568A13.494,13.494,0,0,0,60,16.636,13.585,13.585,0,0,0,37.244,6.563\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><polyline data-color=\"color-2\" points=\"20 24 32 36 41 27\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></polyline></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Birthdays",
    "URL": "/kpireport?hname=Birthdays&rtype=birthdayreports",
    "Key": "",
    "Zone": "",
    "Priority": 39,
    "Role": "owner,facilityowner,receptionist,harvest",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='64px' height='64px' viewBox='0 0 64 64' strokeWidth={2}><g strokeWidth={2} transform='translate(0, 0)'><path data-color='color-2' fill='none' stroke='#444444' strokeWidth={2} strokeLinecap='square' strokeMiterlimit={10} d='M32,15 c2.209,0,4-1.791,4-4s-4-8-4-8s-4,5.791-4,8S29.791,15,32,15z' strokeLinejoin='miter' /> <path data-color='color-2' fill='none' stroke='#444444' strokeWidth={2} strokeLinecap='square' strokeMiterlimit={10} d='M14,17 c1.657,0,3-1.343,3-3s-3-6-3-6s-3,4.343-3,6S12.343,17,14,17z' strokeLinejoin='miter' /> <path data-color='color-2' fill='none' stroke='#444444' strokeWidth={2} strokeLinecap='square' strokeMiterlimit={10} d='M50,17 c-1.657,0-3-1.343-3-3s3-6,3-6s3,4.343,3,6S51.657,17,50,17z' strokeLinejoin='miter' /> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' strokeWidth={2} strokeMiterlimit={10} d='M2,42.862 c0,4.571,3.705,8.276,8.276,8.276c3.14,0,5.839-1.77,7.241-4.347c1.402,2.577,4.101,4.347,7.241,4.347s5.839-1.77,7.241-4.347 c1.402,2.577,4.101,4.347,7.241,4.347c3.14,0,5.839-1.77,7.241-4.347c1.402,2.577,4.101,4.347,7.241,4.347 c4.571,0,8.276-3.705,8.276-8.276' strokeLinecap='butt' strokeLinejoin='miter' /> <path fill='none' stroke='#444444' strokeWidth={2} strokeLinecap='square' strokeMiterlimit={10} d='M58,38H6 c-2.209,0-4,1.791-4,4v18h60V42C62,39.791,60.209,38,58,38z' strokeLinejoin='miter' /> <path fill='none' stroke='#444444' strokeWidth={2} strokeLinecap='square' strokeMiterlimit={10} d='M54,32v-4 c0-2.209-1.791-4-4-4H14c-2.209,0-4,1.791-4,4v4' strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Inactive Services",
    "URL": "/kpireport?hname=Inactive Services&rtype=inactiveservices",
    "Key": "",
    "Zone": "",
    "Priority": 40,
    "Role": "owner,facilityowner,receptionist,harvest",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"24\" y1=\"12\" x2=\"40\" y2=\"12\" stroke-linejoin=\"miter\"></line> <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"50\" cy=\"36\" r=\"6\" stroke-linejoin=\"miter\"></circle> <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"14\" cy=\"36\" r=\"6\" stroke-linejoin=\"miter\"></circle> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M26,60v-5.965 c0-1.42-0.745-2.726-1.967-3.449C22.088,49.435,18.716,48,14,48c-4.777,0-8.127,1.426-10.052,2.575C2.736,51.299,2,52.601,2,54.013 V60H26z\" stroke-linejoin=\"miter\"></path> <path fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M62,60v-5.965 c0-1.42-0.745-2.726-1.967-3.449C58.088,49.435,54.716,48,50,48c-4.777,0-8.127,1.426-10.052,2.575 C38.736,51.299,38,52.601,38,54.013V60H62z\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Salary Statement",
    "URL": "/salarystatement",
    "Key": "",
    "Zone": "",
    "Priority": 41,
    "Role": "owner,facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><line data-cap=\"butt\" x1=\"60\" y1=\"23\" x2=\"4\" y2=\"23\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><path d=\"M29,56H9a5,5,0,0,1-5-5V14A5,5,0,0,1,9,9H55a5,5,0,0,1,5,5V34\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path><line x1=\"17\" y1=\"3\" x2=\"17\" y2=\"15\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"47\" y1=\"3\" x2=\"47\" y2=\"15\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><circle data-color=\"color-2\" cx=\"47\" cy=\"49\" r=\"12\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><polyline data-color=\"color-2\" points=\"42 50 45 53 52 46\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></polyline></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "MiraReports",
    "URL": "/mirraclesreport",
    "Key": "",
    "Zone": "",
    "Priority": 42,
    "Role": "owner,facilityowner,BDC,NCC",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><rect x=\"4\" y=\"44\" width=\"8\" height=\"13\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><rect x=\"36\" y=\"43\" width=\"8\" height=\"14\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><rect x=\"20\" y=\"27\" width=\"8\" height=\"30\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><rect x=\"52\" y=\"27\" width=\"8\" height=\"30\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><circle cx=\"8\" cy=\"27\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"40\" cy=\"27\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"24\" cy=\"11\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"56\" cy=\"11\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><line x1=\"10.828\" y1=\"24.172\" x2=\"21.172\" y2=\"13.828\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><line x1=\"37.172\" y1=\"24.172\" x2=\"26.828\" y2=\"13.828\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><line x1=\"42.828\" y1=\"24.172\" x2=\"53.172\" y2=\"13.828\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "MiraVerse",
    "URL": "/miraverse",
    "Key": "",
    "Zone": "",
    "Priority": 43,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><rect x=\"4\" y=\"44\" width=\"8\" height=\"13\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><rect x=\"36\" y=\"43\" width=\"8\" height=\"14\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><rect x=\"20\" y=\"27\" width=\"8\" height=\"30\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><rect x=\"52\" y=\"27\" width=\"8\" height=\"30\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></rect><circle cx=\"8\" cy=\"27\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"40\" cy=\"27\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"24\" cy=\"11\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"56\" cy=\"11\" r=\"4\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><line x1=\"10.828\" y1=\"24.172\" x2=\"21.172\" y2=\"13.828\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><line x1=\"37.172\" y1=\"24.172\" x2=\"26.828\" y2=\"13.828\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line><line x1=\"42.828\" y1=\"24.172\" x2=\"53.172\" y2=\"13.828\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Award",
    "URL": "/trumpet",
    "Key": "",
    "Zone": "",
    "Priority": 44,
    "Role": "owner,facilityowner,BDC,NCC",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><path data-cap=\"butt\" d=\"M14.705,28C9.5,28,5,24,5,17V7h9\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></path> <path data-cap=\"butt\" d=\"M50,7h9V17c0,7-4.5,11-9.7,11\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></path> <line data-color=\"color-2\" x1=\"32\" y1=\"53\" x2=\"32\" y2=\"46\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line> <path d=\"M32,41h0A18,18,0,0,1,14,23V3H50V23A18,18,0,0,1,32,41Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path> <path data-color=\"color-2\" d=\"M18,61c0-4.418,3-8,10-8h8c7,0,10,3.582,10,8Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Memo",
    "URL": "/trumpet",
    "Key": "",
    "Zone": "",
    "Priority": 45,
    "Role": " manager, owner, ccc, harvest, facilityowner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><line x1=\"16\" y1=\"7\" x2=\"16\" y2=\"19\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" data-color=\"color-2\" stroke-linejoin=\"miter\"></line><circle cx=\"16\" cy=\"24.5\" r=\"1.5\" fill=\"#444444\" data-cap=\"butt\" data-color=\"color-2\" data-stroke=\"none\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><polygon points=\"22.213 1 9.787 1 1 9.787 1 22.213 9.787 31 22.213 31 31 22.213 31 9.787 22.213 1\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Guru",
    "URL": "/trumpet",
    "Key": "",
    "Zone": "",
    "Priority": 46,
    "Role": " manager, owner, ccc, harvest, facilityowner,therapist",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' strokeWidth='1'><g strokeWidth='1' transform='translate(0.5, 0.5)'><path d='M24,46A22,22,0,1,1,46,24' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='1' strokeLinejoin='miter'></path> <line x1='32' y1='45' x2='46' y2='45' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='1' data-color='color-2' strokeLinejoin='miter'></line> <line x1='32' y1='38' x2='46' y2='38' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='1' data-color='color-2' strokeLinejoin='miter'></line> <line x1='32' y1='31' x2='46' y2='31' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='1' data-color='color-2' strokeLinejoin='miter'></line> <polygon points='18 16 32 24 18 32 18 16' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit='10' strokeWidth='1' data-color='color-2' strokeLinejoin='miter'></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Fc-Rc",
    "URL": "/fcrc",
    "Key": "",
    "Zone": "",
    "Priority": 47,
    "Role": "owner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><circle cx=\"9\" cy=\"9\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle> <path d=\"M21,29c-7-3.583-7-10-13-10a6,6,0,0,0-6,6V43H14V31\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path> <path d=\"M27,29c7-3.583,7-10,13-10a6,6,0,0,1,6,6V43H34V31\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></path> <circle cx=\"39\" cy=\"9\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Genric Reports",
    "URL": "/genericreports",
    "Key": "",
    "Zone": "",
    "Priority": 48,
    "Role": "owner,facilityowner,BDC,NCC,harvest",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><circle cx=\"32.001\" cy=\"32\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" data-color=\"color-2\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"32.001\" cy=\"7\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"10\" cy=\"19\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><circle cx=\"54\" cy=\"19\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><circle cx=\"10\" cy=\"45\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"54\" cy=\"45\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-cap=\"butt\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\"></circle><circle cx=\"31.999\" cy=\"57\" r=\"5\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></circle><line x1=\"32\" y1=\"12\" x2=\"32\" y2=\"22\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"32\" y1=\"42\" x2=\"32\" y2=\"52\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"18.776\" y1=\"14.213\" x2=\"27.614\" y2=\"9.393\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"23.223\" y1=\"52.213\" x2=\"14.39\" y2=\"47.395\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"10\" y1=\"35\" x2=\"10\" y2=\"24\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"54\" y1=\"29\" x2=\"54\" y2=\"40\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"49.61\" y1=\"16.605\" x2=\"40.777\" y2=\"11.788\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"23.403\" y1=\"26.92\" x2=\"14.302\" y2=\"21.542\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"23.403\" y1=\"37.08\" x2=\"14.302\" y2=\"42.458\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"40.599\" y1=\"26.919\" x2=\"49.698\" y2=\"21.542\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"49.698\" y1=\"42.458\" x2=\"40.599\" y2=\"37.081\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line><line x1=\"45.224\" y1=\"49.787\" x2=\"36.389\" y2=\"54.605\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Adv. Invoices",
    "URL": "/advancedinvoices",
    "Key": "",
    "Zone": "",
    "Priority": 49,
    "Role": "owner,facilityowner,BDC,NCC,harvest",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><polygon fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"56,2 8,2 8,60 16,55 24,60 32,55 40,60 48,55 56,60 \" stroke-linejoin=\"miter\"></polygon> <line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"18\" y1=\"17\" x2=\"34\" y2=\"17\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"18\" y1=\"29\" x2=\"34\" y2=\"29\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"18\" y1=\"41\" x2=\"34\" y2=\"41\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"42\" y1=\"41\" x2=\"46\" y2=\"41\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"42\" y1=\"29\" x2=\"46\" y2=\"29\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"42\" y1=\"17\" x2=\"46\" y2=\"17\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "All Invoices",
    "URL": "/allinvoices",
    "Key": "",
    "Zone": "",
    "Priority": 50,
    "Role": "owner,facilityowner,BDC,NCC,harvest",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><path fill=\"#444444\" d=\"M28,0H4C3.448,0,3,0.448,3,1v31l5-3l4,3l4-3l4,3l4-3l5,3V1C29,0.448,28.552,0,28,0z M17,23H8v-2h9V23z M17,16H8v-2h9V16z M17,9H8V7h9V9z M24,23h-4v-2h4V23z M24,16h-4v-2h4V16z M24,9h-4V7h4V9z\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Vouchers",
    "URL": "/kpireport?hname=Gift Vouchers&rtype=voucherdocs",
    "Key": "",
    "Zone": "",
    "Priority": 51,
    "Role": "owner,manager",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><path fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M40,24c0-3.4,2.6-6,6-6V8H2 v10c3.4,0,6,2.6,6,6s-2.6,6-6,6v10h44V30C42.6,30,40,27.4,40,24z\" stroke-linejoin=\"miter\"></path> <line data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"30\" y1=\"18\" x2=\"18\" y2=\"30\" stroke-linejoin=\"miter\"></line> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"18\" cy=\"18\" r=\"3\" stroke-linejoin=\"miter\"></circle> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"30\" cy=\"30\" r=\"3\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Avail Vouchers",
    "URL": "/kpireport?hname=Available Vouchers&rtype=availvoucherdocs",
    "Key": "",
    "Zone": "",
    "Priority": 52,
    "Role": "owner,manager",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><rect data-color=\"color-2\" x=\"38\" y=\"21\" fill=\"#444444\" width=\"10\" height=\"2\"></rect> <rect data-color=\"color-2\" x=\"38\" y=\"59\" fill=\"#444444\" width=\"10\" height=\"2\"></rect> <rect data-color=\"color-2\" x=\"22\" y=\"59\" fill=\"#444444\" width=\"10\" height=\"2\"></rect> <rect data-color=\"color-2\" x=\"61\" y=\"36\" fill=\"#444444\" width=\"2\" height=\"10\"></rect> <path data-color=\"color-2\" fill=\"#444444\" d=\"M63,30h-2v-7h-7v-2h8c0.553,0,1,0.447,1,1V30z\"></path> <path data-color=\"color-2\" fill=\"#444444\" d=\"M62,61h-8v-2h7v-7h2v8C63,60.553,62.553,61,62,61z\"></path> <path data-color=\"color-2\" fill=\"#444444\" d=\"M16,61H8c-0.553,0-1-0.447-1-1v-8h2v7h7V61z\"></path> <path fill=\"#444444\" d=\"M22.795,26.933l9.734,9.734c3.844,3.843,9.81,4.578,14.471,1.781L28.18,22.317L22.795,26.933z\"></path> <path fill=\"#444444\" d=\"M47,3.552C42.339,0.755,36.373,1.49,32.529,5.333L21.376,16.486l-5.034-4.316C16.764,11.197,17,10.126,17,9 c0-4.411-3.589-8-8-8S1,4.589,1,9s3.589,8,8,8c1.135,0,2.214-0.241,3.193-0.669L16.862,21l-4.669,4.669 C11.214,25.241,10.135,25,9,25c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8c0-1.126-0.236-2.197-0.658-3.17L47,3.552z M9,15 c-3.309,0-6-2.691-6-6c0-3.309,2.691-6,6-6s6,2.691,6,6C15,12.309,12.309,15,9,15z M9,39c-3.309,0-6-2.691-6-6c0-3.309,2.691-6,6-6 s6,2.691,6,6C15,36.309,12.309,39,9,39z\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Send Message",
    "URL": "/sendmessagetotelegram",
    "Key": "",
    "Zone": "",
    "Priority": 53,
    "Role": "owner",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" stroke-width=\"2\"><g stroke-width=\"2\" transform=\"translate(0, 0)\"><path d=\"M29,15H17l-5,3V3a2,2,0,0,1,2-2H29a2,2,0,0,1,2,2V13A2,2,0,0,1,29,15Z\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></path><line x1=\"17\" y1=\"10\" x2=\"21\" y2=\"10\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></line><line x1=\"17\" y1=\"6\" x2=\"26\" y2=\"6\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" data-color=\"color-2\" stroke-linejoin=\"miter\"></line><path d=\"M8,3H6A3,3,0,0,0,3,6V28a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V19\" fill=\"none\" stroke=\"#444444\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Therapy Service Letter",
    "URL": "https://pinnacleblooms.org/d/DownloadTherapyServiceLetter/#ID#",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "boss",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='32px' height='32px' viewBox='0 0 32 32' strokeWidth={1}><g strokeWidth={1} transform='translate(0.5, 0.5)'><polyline data-color='color-2' fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} points=' 12,19 15,22 21,16 ' strokeLinejoin='miter' /> <path fill='none' stroke='#444444' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} d='M19,4c0-1.657-1.343-3-3-3 s-3,1.343-3,3h-3v4h12V4H19z' strokeLinejoin='miter' /> <polyline data-cap='butt' fill='none' stroke='#444444' strokeWidth={1} strokeMiterlimit={10} points='25,5 28,5 28,31 4,31 4,5 7,5 ' strokeLinejoin='miter' strokeLinecap='butt' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Digital Therapy  Record in Cloud",
    "URL": "/globalinnovation?type=digital",
    "Key": "",
    "Zone": "",
    "Priority": 61,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='32px' height='32px' viewBox='0 0 64 64' strokeWidth={1}><g strokeWidth={1} transform='translate(0.5, 0.5)'><path data-cap='butt' data-color='color-2' fill='none' stroke='#000000' strokeWidth={1} strokeMiterlimit={10} d='M21.761,34.075 c0-5.655,4.584-10.239,10.239-10.239c4.042,0,7.537,2.342,9.202,5.744' strokeLinejoin='miter' strokeLinecap='butt' /> <path data-cap='butt' data-color='color-2' fill='none' stroke='#000000' strokeWidth={1} strokeMiterlimit={10} d='M42.239,34.427 c0,5.655-4.584,10.239-10.239,10.239c-4.045,0-7.542-2.346-9.205-5.751' strokeLinejoin='miter' strokeLinecap='butt' /> <polyline data-color='color-2' fill='none' stroke='#000000' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} points=' 41.503,23.455 41.209,29.591 35.073,29.298 ' strokeLinejoin='miter' /> <polyline data-color='color-2' fill='none' stroke='#000000' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} points=' 22.759,45.054 22.791,38.911 28.934,38.943 ' strokeLinejoin='miter' /> <path fill='none' stroke='#000000' strokeWidth={1} strokeLinecap='square' strokeMiterlimit={10} d='M52,52 c5.606-0.506,10-5.263,10-11c0-5.771-4.446-10.495-10.099-10.954C50.918,19.917,42.386,12,32,12c-9.024,0-16.646,5.979-19.136,14.19 C6.703,27.211,2,32.55,2,39c0,6.842,5.289,12.488,12,13H52z' strokeLinejoin='miter' /></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Environment you Would Love",
    "URL": "/globalinnovation?type=env",
    "Key": "",
    "Zone": "",
    "Priority": 62,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" d=\"M53.702,37.439l3.505-3.504 c6.391-6.39,6.391-16.751,0-23.142c-6.39-6.39-16.751-6.39-23.142,0c-0.787,0.787-1.472,1.636-2.066,2.529 c-0.593-0.892-1.279-1.742-2.066-2.529c-6.39-6.39-16.751-6.39-23.142,0c-6.391,6.39-6.391,16.751,0,23.142L32,59.142l5.439-5.439\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></path> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"48\" cy=\"48\" r=\"12\" stroke-linejoin=\"miter\"></circle> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"48\" y1=\"44\" x2=\"48\" y2=\"52\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"44\" y1=\"48\" x2=\"52\" y2=\"48\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Responsive Management",
    "URL": "/globalinnovation?type=response",
    "Key": "",
    "Zone": "",
    "Priority": 63,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\" M35.6923065,14C34.1538429,14,32.7692299,14.7692308,32,16c-0.7692318-1.2307692-2.1538467-2-3.6923084-2 C25.8461533,14,24,16,24,18.4615383c0,4.3076916,8,10.9230766,8,10.9230766s8-6.6153851,8-10.9230766 C40,16,38.1538467,14,35.6923065,14z\" stroke-linejoin=\"miter\"></path> <polyline data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" points=\"12,22 2,27.7999992 2,62 62,62 62,27.7999992 52,22 \" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></polyline> <polyline data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" points=\"12,33.4000015 12,2 52,2 52,33.2000008 \" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></polyline> <line data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"2\" y1=\"27.7999992\" x2=\"62\" y2=\"62\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <line data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"62\" y1=\"27.7999992\" x2=\"31.2000008\" y2=\"44.4000015\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Live Stream of Therapy",
    "URL": "/globalinnovation?type=live",
    "Key": "",
    "Zone": "",
    "Priority": 64,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><line data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"24\" y1=\"6\" x2=\"32\" y2=\"16\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <line data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"32\" y1=\"16\" x2=\"44\" y2=\"2\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <path fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M58,62H6 c-2.209,0-4-1.791-4-4V20c0-2.209,1.791-4,4-4h52c2.209,0,4,1.791,4,4v38C62,60.209,60.209,62,58,62z\" stroke-linejoin=\"miter\"></path> <rect data-color=\"color-2\" x=\"10\" y=\"24\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" width=\"36\" height=\"30\" stroke-linejoin=\"miter\"></rect> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"54\" y1=\"24\" x2=\"54\" y2=\"28\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"54\" y1=\"36\" x2=\"54\" y2=\"54\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Patented Miracle System",
    "URL": "/globalinnovation?type=patented",
    "Key": "",
    "Zone": "",
    "Priority": 65,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><polyline data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\" 8,48 2,48 2,8 34,8 \" stroke-linejoin=\"miter\"></polyline> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"56,8 62,8 62,48 22,48 \" stroke-linejoin=\"miter\"></polyline> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"22\" y1=\"60\" x2=\"42\" y2=\"60\" stroke-linejoin=\"miter\"></line> <path fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M55,32H35c-0.6,0-1-0.4-1-1 V3c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1v28C56,31.6,55.6,32,55,32z\" stroke-linejoin=\"miter\"></path> <line fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"44\" y1=\"26\" x2=\"46\" y2=\"26\" stroke-linejoin=\"miter\"></line> <path fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M21,54H9c-0.6,0-1-0.4-1-1 V31c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v22C22,53.6,21.6,54,21,54z\" stroke-linejoin=\"miter\"></path> <line fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"14\" y1=\"48\" x2=\"16\" y2=\"48\" stroke-linejoin=\"miter\"></line> <rect data-color=\"color-2\" x=\"28\" y=\"56\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" width=\"8\" height=\"4\" stroke-linejoin=\"miter\"></rect></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Transparent  Therapies",
    "URL": "/globalinnovation?type=transparent",
    "Key": "",
    "Zone": "",
    "Priority": 66,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" d=\"M13.869,41.719L4.388,57.758 c-1.238,2.064,0.533,4.625,2.901,4.194L32,56l24.711,5.952c2.368,0.431,4.139-2.13,2.901-4.194l-9.477-16.039\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></path> <circle fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"32\" cy=\"26\" r=\"24\" stroke-linejoin=\"miter\"></circle> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"32\" cy=\"28\" r=\"14\" stroke-linejoin=\"miter\"></circle> <circle fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"32\" cy=\"28\" r=\"3\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Most affordable Therapy Price",
    "URL": "/globalinnovation?type=efford",
    "Key": "",
    "Zone": "",
    "Priority": 67,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\" M60.083,40.984C57.164,37.962,52.292,38.456,50,42.03c-2.294-3.578-7.167-4.065-10.083-1.047c-2.556,2.645-2.556,6.935,0,9.58 L49.999,61l10.084-10.436C62.639,47.918,62.639,43.629,60.083,40.984z\" stroke-linejoin=\"miter\"></path> <line data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"14\" y1=\"20\" x2=\"23.818\" y2=\"2\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <line data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"50\" y1=\"20\" x2=\"40.182\" y2=\"2\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <rect x=\"2\" y=\"20\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" width=\"60\" height=\"10\" stroke-linejoin=\"miter\"></rect> <path fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M35,62H12 c-2.209,0-4-1.791-4-4V30\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Goal Based Therapies",
    "URL": "/globalinnovation?type=goalbased",
    "Key": "",
    "Zone": "",
    "Priority": 68,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" d=\"M48.255,29 C49.38,31.779,50,34.817,50,38c0,13.255-10.745,24-24,24S2,51.255,2,38s10.745-24,24-24c3.182,0,6.22,0.619,8.999,1.744\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></path> <circle fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"26\" cy=\"38\" r=\"13\" stroke-linejoin=\"miter\"></circle> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"26\" y1=\"38\" x2=\"58\" y2=\"6\" stroke-linejoin=\"miter\"></line> <polygon data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\" 51,13 49,3 41,11 43,21 53,23 61,15 \" stroke-linejoin=\"miter\"></polygon></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Continual Feedback",
    "URL": "/globalinnovation?type=continual",
    "Key": "",
    "Zone": "",
    "Priority": 69,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><polyline fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"31,49.057 14.695,57.63 18,38.36 4,24.714 23.348,21.902 32,4.37 40.652,21.902 60,24.714 54,30.562 \" stroke-linejoin=\"miter\"></polyline> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"50\" cy=\"49\" r=\"12\" stroke-linejoin=\"miter\"></circle> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"50\" y1=\"45\" x2=\"50\" y2=\"53\" stroke-linejoin=\"miter\"></line> <line data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"46\" y1=\"49\" x2=\"54\" y2=\"49\" stroke-linejoin=\"miter\"></line></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Certified Therapists",
    "URL": "/globalinnovation?type=certified",
    "Key": "",
    "Zone": "",
    "Priority": 70,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><polyline data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" points=\"46,13 29,2 12,13 \" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></polyline> <polyline fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"34,47 8,47 8,19 50,19 \" stroke-linejoin=\"miter\"></polyline> <polyline fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" points=\"37,53 2,53 2,13 56,13 56,19 \" stroke-linejoin=\"miter\"></polyline> <line fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"16\" y1=\"29\" x2=\"31\" y2=\"29\" stroke-linejoin=\"miter\"></line> <line fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"16\" y1=\"37\" x2=\"27\" y2=\"37\" stroke-linejoin=\"miter\"></line> <polyline data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" points=\"57,46.747 57,61 50,57 43,61 43,46.747 \" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></polyline> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"50\" cy=\"37\" r=\"12\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "Overall Development",
    "URL": "/globalinnovation?type=overall",
    "Key": "",
    "Zone": "",
    "Priority": 71,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><path d=\"M40,15h8A12,12,0,0,1,60,27V50A12,12,0,0,1,48,62H16A12,12,0,0,1,4,50V27A12,12,0,0,1,16,15h8L40,4Z\" fill=\"none\" stroke=\"#000000\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></path> <path data-color=\"color-2\" d=\"M24,35a4,4,0,0,0-8,0\" fill=\"none\" stroke=\"#000000\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></path> <path data-color=\"color-2\" d=\"M48,35a4,4,0,0,0-8,0\" fill=\"none\" stroke=\"#000000\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></path> <path data-color=\"color-2\" d=\"M26,44v1.25a3.733,3.733,0,0,0,6,2.983,3.733,3.733,0,0,0,6-2.983V44\" fill=\"none\" stroke=\"#000000\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1\" stroke-linejoin=\"miter\"></path></g></svg>"
  },
  {
    "Category": "Inno",
    "Title": "World class International",
    "URL": "/globalinnovation?type=world",
    "Key": "",
    "Zone": "",
    "Priority": 61,
    "Role": "receptionist, manager, owner, ccc, harvest, facilityowner,therapist,ncc,lead,bdc,boss",
    "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 64 64\" stroke-width=\"1\"><g stroke-width=\"1\" transform=\"translate(0.5, 0.5)\"><line data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"32\" y1=\"54\" x2=\"32\" y2=\"62\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <line data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"13.234\" y1=\"46.766\" x2=\"8\" y2=\"52\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <line data-cap=\"butt\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-miterlimit=\"10\" x1=\"58\" y1=\"2\" x2=\"52.766\" y2=\"7.234\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></line> <path fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M48.002,3.02 C55.255,8.08,60,16.486,60,26c0,15.464-12.536,28-28,28c-10.363,0-19.412-5.63-24.253-13.999\" stroke-linejoin=\"miter\"></path> <line fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" x1=\"20\" y1=\"62\" x2=\"44\" y2=\"62\" stroke-linejoin=\"miter\"></line> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#000000\" stroke-width=\"1\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"32\" cy=\"26\" r=\"21\" stroke-linejoin=\"miter\"></circle></g></svg>"
  },
  {
    "Category": "Services",
    "Title": "Active",
    "URL": "/kpireport?hname=Services&rtype=activeservices",
    "Key": "SF",
    "Zone": "red",
    "Priority": 1,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "activeservices"
  },
  {
    "Category": "Services",
    "Title": "Future",
    "URL": "/kpireport?hname=Future Services&rtype=futureservices",
    "Key": "TFADD",
    "Zone": "red",
    "Priority": 2,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "futureservices"
  },
  {
    "Category": "Services",
    "Title": "Closed",
    "URL": "/kpireport?hname=Inactive Services&rtype=inactiveservices",
    "Key": "TCS",
    "Zone": "red",
    "Priority": 3,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "inactiveservices"
  },
  {
    "Category": "Services",
    "Title": "New",
    "URL": "/kpireport?hname=New Services&rtype=newservices",
    "Key": "ADDS",
    "Zone": "red",
    "Priority": 4,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "newservices"
  },
  {
    "Category": "Services",
    "Title": "ST",
    "URL": "/kpireport?hname=Speech Therapy&rtype=newservices&FilterType=Speech Therapy",
    "Key": "TSTS",
    "Zone": "red",
    "Priority": 5,
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "newservices"
  },
  {
    "Category": "Services",
    "Title": "OT",
    "URL": "/kpireport?hname=Occupational Therapy&rtype=newservices&FilterType=Occupational Therapy",
    "Key": "TOTS",
    "Zone": "red",
    "Priority": 6,
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "newservices"
  },
  {
    "Category": "Services",
    "Title": "BT",
    "URL": "/kpireport?hname=Behavioral Modification&rtype=newservices&FilterType=Behavioral Modification",
    "Key": "TBTS",
    "Zone": "red",
    "Priority": 7,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "newservices"
  },
  {
    "Category": "Services",
    "Title": "SE",
    "URL": "/kpireport?hname=Special Education&rtype=newservices&FilterType=Special Education",
    "Key": "TSES",
    "Zone": "red",
    "Priority": 8,
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "newservices"
  },
  {
    "Category": "Services",
    "Title": "Inactivation Cause",
    "URL": "/kpireport?hname=Pending Service Root Cause&rtype=inactivecausepending",
    "Key": "TCSR",
    "Zone": "red",
    "Priority": 9,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "inactivecausepending"
  },
  {
    "Category": "Assessments",
    "Title": "Completed",
    "URL": "/kpireport?rtype=assessmentcompleted",
    "Key": "AST",
    "Zone": "red",
    "Priority": 1,
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "assessmentcompleted"
  },
  {
    "Category": "Assessments",
    "Title": "Pending",
    "URL": "/kpireport?rtype=assessmentpending",
    "Key": "ASP",
    "Zone": "red",
    "Priority": 2,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "assessmentpending"
  },
  {
    "Category": "Awards",
    "Title": "Awards",
    "URL": "/kpireport?hname=Awards&rtype=awards",
    "Key": "AWARDS",
    "Zone": "green",
    "Priority": 1,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "awards"
  },
  {
    "Category": "Memos",
    "Title": "Active Memos",
    "URL": "/kpireport?hname=Activ Memos&rtype=activememos",
    "Key": "AMEMO",
    "Zone": "red",
    "Priority": 1,
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "activememos"
  },
  {
    "Category": "Memos",
    "Title": "Pending Memos",
    "URL": "/kpireport?hname=Activ Memos&rtype=pendingmemos",
    "Key": "PMEMO",
    "Zone": "red",
    "Priority": 1,
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": "pendingmemos"
  },
  {
    "Category": "Memos",
    "Title": "Closed Memos",
    "URL": "/kpireport?hname=Closed Memos&rtype=closedmemos",
    "Key": "CMEMO",
    "Zone": "red",
    "Priority": 2,
    "Role": "Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": "closedmemos"
  },
  {
    "Category": "System",
    "Title": "PRRA",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/Pinnacle-Raise-Against-Autism-Pinnacle-Blooms-Network.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/praa.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "ABC's for therapist",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/pinnacle_abc.jpg",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/pinnacle-abc.png",
    "Key": "",
    "Zone": "",
    "Priority": 2,
    "Role": "Therapist, Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Stakeholder Handbook",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/PinnacleBloomsNetwork-StakeHolder-Hand-Book.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/book.png",
    "Key": "",
    "Zone": "",
    "Priority": 3,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Holiday List",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/Assets/image/Pinnacle-Holiday-Calendar-2025.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/calender.png",
    "Key": "",
    "Zone": "",
    "Priority": 4,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Inbound Policy",
    "URL": "",

    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/NCC-CALL-Inbound-Outbound-PROTOCOL.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/inbound.png",
    "Key": "",
    "Zone": "",
    "Priority": 5,
    "Role": "Therapist, Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Outbound Policy",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/NCC-CALL-Inbound-Outbound-PROTOCOL.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/outbound.png",
    "Key": "",
    "Zone": "",
    "Priority": 6,
    "Role": "Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Walkin Policy",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/Parent-Customer-Walk-In-Protocol.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/walkin.png",
    "Key": "",
    "Zone": "",
    "Priority": 7,
    "Role": "Therapist, Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Pinnacle Pan",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/pinnacle-pan.jpeg",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/pan.png",
    "Key": "",
    "Zone": "",
    "Priority": 8,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Pinnacle TM",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/pinnacle-tm.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/tm.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Pinnacle GST",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/pinnacle-gst.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/gst.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "Startup India",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/startup-india.jpeg",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/startup.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },

  {
    "Category": "System",
    "Title": "Central Government Registration",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/BHCLPL-INCOPORATION.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/moa.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "DDW Hyderabad",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/hyderabad-ddw.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/hyderabad.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "DDW Kurnool",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/kurnool-ddw.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/kurnool.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "SEVA 80G",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/SEVA-80-G.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/seva.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Category": "System",
    "Title": "SEVA 12A",
    "URL": "",
    "PDFURL": "https://images.pinnacleblooms.org/assets/Policies/SEVA-12-A.pdf",
    "ImageURL": "https://www.pinnacleblooms.org/assets/policies/icons/seva.png",
    "Key": "",
    "Zone": "",
    "Priority": 1,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner",
    "Rkey": ""
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Kids",
    "Description": "Kids, parents, families are being empowered.",
    "URL": "/kpireport?hname=Parents&rtype=activeparents&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 1
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Therapies",
    "Description": "These many kids, parents, families are being empowered.",
    "URL": "/kpireport?hname=Services&rtype=activeservices&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='{2}'><g stroke-width='{2}' transform='translate(0, 0)'><path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M26,9h8c4.418,0,8,3.582,8,8v1' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' points=' 32,3 26,9 32,15 ' stroke-linejoin='miter'></polyline> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M22,39h-8c-4.418,0-8-3.582-8-8 v-1' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' points=' 16,45 22,39 16,33 ' stroke-linejoin='miter'></polyline> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M20,23H2v-2.242 c0-1.775,1.164-3.334,2.866-3.838C6.46,16.448,8.604,16,11,16c2.356,0,4.514,0.456,6.125,0.932C18.83,17.436,20,18.994,20,20.773V23 z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M6,7c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S6,9.761,6,7z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M46,46H28v-2.242 c0-1.775,1.164-3.334,2.866-3.838C32.46,39.448,34.604,39,37,39c2.356,0,4.514,0.456,6.125,0.932C44.83,40.436,46,41.994,46,43.773 V46z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M32,30c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S32,32.761,32,30z' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 2
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Co-workers",
    "Description": "These many Co-Workers are empowering Kids, Parents, Families.",
    "URL": "/kpireport?hname=Co-Workers&rtype=COWORKERS&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='{2}'><g stroke-width='{2}' transform='translate(0, 0)'><path data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M9,13L9,13 c-2.209,0-4-1.791-4-4v0c0-2.209,1.791-4,4-4h0c2.209,0,4,1.791,4,4v0C13,11.209,11.209,13,9,13z' stroke-linejoin='miter'></path> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M12,43H6L5,32l-3-1v-9 c0-2.209,1.791-4,4-4h6c1.454,0,2.727,0.777,3.427,1.937' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M39,13 L39,13c2.209,0,4-1.791,4-4v0c0-2.209-1.791-4-4-4h0c-2.209,0-4,1.791-4,4v0C35,11.209,36.791,13,39,13z' stroke-linejoin='miter'></path> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M36,43h6l1-11l3-1v-9 c0-2.209-1.791-4-4-4h-6c-1.454,0-2.727,0.777-3.427,1.937' stroke-linejoin='miter' stroke-linecap='butt'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M24,14L24,14 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h0c3.314,0,6,2.686,6,6v0C30,11.314,27.314,14,24,14z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M29,46H19l-1-12l-4-1V23 c0-2.209,1.791-4,4-4h12c2.209,0,4,1.791,4,4v10l-4,1L29,46z' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 3
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Leads",
    "Description": "Number or Kids, Parents, Families are Waiting on You.",
    "URL": "/kpireport?hname=Active%20Leads&rtype=activeleads&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='11' r='9' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polygon points='14 34 34 34 32 46 16 46 14 34' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon><path d='M19.919,25A11.952,11.952,0,0,1,4.081,25,11.987,11.987,0,0,1,24,34' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M28.081,25a11.952,11.952,0,0,0,15.838,0A11.987,11.987,0,0,0,24,34' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><rect x='21.172' y='8.172' width='5.657' height='5.657' stroke-width='2' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' transform='translate(-0.749 20.192) rotate(-45)' data-color='color-2' stroke-linejoin='miter'></rect></g></svg>",
    "Priority": 4
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Renewals",
    "Description": "This month renewals of all categories.",
    "URL": "/kpireport?hname=To%20Be%20Renewed&rtype=renewalclaritytoberenewed&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M23.983,38H24A20,20,0,0,1,4,18a19.926,19.926,0,0,1,8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M5.7,34.993a14.651,14.651,0,0,0-2.654,1.986A14.459,14.459,0,0,0,23.983,38H24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M24,38h-.017a20,20,0,0,0,20-20,19.926,19.926,0,0,0-8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M24,38A23.9,23.9,0,0,0,24,4.2,23.9,23.9,0,0,0,24,38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M42.287,34.993a14.651,14.651,0,0,1,2.654,1.986A14.459,14.459,0,0,1,24,38h-.017' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 5
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Walkins",
    "Description": "Congratulations, Every walk-in is a family trust on Pinnacle.",
    "URL": "/kpireport?hname=Walkins&rtype=walkinleads&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 6
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Additions",
    "Description": "Thank you on behalf of Kids, Parents, Families.",
    "URL": "/kpireport?hname=Additions&rtype=additionleads&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 7
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Inactivations",
    "Description": "Speak to each parent, family member, reaffirm Pinnacle Hope, Confidence.",
    "URL": "/kpireport?hname=Inactive%20Services&rtype=inactiveservices&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polygon fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points='3.5,3.5 9.5,21.5 13.5,13.5 21.5,9.5 ' stroke-linejoin='miter'></polygon> <line data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' x1='22.101' y1='22.101' x2='41.899' y2='41.899' stroke-linejoin='miter' stroke-linecap='butt'></line> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='32' cy='32' r='14' stroke-linejoin='miter'></circle></g></svg>",
    "Priority": 8
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Pollinations Done",
    "Description": "Thank you on behalf of kids, parents, families.",
    "URL": "/kpireport?hname=Completed&rtype=pollinationclaritycompleted&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Priority": 9
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Pollinations Pending",
    "Description": "These many kids are seeking your help to be Self-Sufficient, part of Mainstream.",
    "URL": "/kpireport?hname=YetTo&rtype=pollinationclarityyetto&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='8' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='42' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='28' x2='24.001' y2='38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='32.163' y1='37.409' x2='27.486' y2='40.04' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='8' y1='19' x2='8' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='20.517' y1='22.041' x2='11.483' y2='16.959' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='22.039' x2='36.515' y2='16.961' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='36.517' y1='13.04' x2='31.839' y2='10.409' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><circle cx='8' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='24' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='10' x2='24.001' y2='20' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><circle cx='24.001' cy='6' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='15.838' y1='10.591' x2='20.515' y2='7.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='16.163' y1='37.591' x2='11.484' y2='34.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='40.001' y1='24' x2='40.001' y2='29' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='20.517' y1='25.959' x2='11.483' y2='31.041' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='25.961' x2='36.515' y2='31.039' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line></g></svg>",
    "Priority": 10
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Lost Kids",
    "Description": "Bring back these parents by extending Pinnacle Hope & Confidence.",
    "URL": "/kpireport?hname=Lost%20Parents&rtype=leftparents&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 11
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Fee Due",
    "Description": "Clear fee on or before ETA. This indicates respect on Pinnacle.",
    "URL": "/kpireport?hname=Pending&rtype=paymentpending&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' points='19.2 4.4 14 7 19 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='28.8 4.4 34 7 29 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline points='21 8 18 2 30 2 27 8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polyline><path d='M29,14H19S7,27,7,35c0,6,4.25,11,17,11s17-5,17-11C41,27,29,14,29,14Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-color='color-2' x1='24' y1='21' x2='24' y2='39' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><path data-color='color-2' d='M28.96,23.974c-2.273-1.181-9.574-2.072-9.574,1.992,0,4.865,9.091,3.148,9.091,7.441s-5.909,3.971-10,2.576' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 12
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Advance Due",
    "Description": "Amount of credit pack balance fee pending, clear it ASAP.",
    "URL": "/kpireport?hname=Advance%20Pending&rtype=advancepending&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' points='19.2 4.4 14 7 19 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='28.8 4.4 34 7 29 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline points='21 8 18 2 30 2 27 8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polyline><path d='M29,14H19S7,27,7,35c0,6,4.25,11,17,11s17-5,17-11C41,27,29,14,29,14Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-color='color-2' x1='24' y1='21' x2='24' y2='39' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><path data-color='color-2' d='M28.96,23.974c-2.273-1.181-9.574-2.072-9.574,1.992,0,4.865,9.091,3.148,9.091,7.441s-5.909,3.971-10,2.576' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 13
  },
  {
    "Type": "EI",
    "Category": "EICENTER",
    "Title": "Credits Balance",
    "Description": "Every credit pack ease parents, family burden, Keep It Up.",
    "URL": "/AdvancedInvoices?facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' points='27.081,31 3,31 3,11 45,11 45,31 40,31 ' stroke-linejoin='miter' stroke-linecap='butt'></polyline> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='23' cy='21' r='4' stroke-linejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' x1='13' y1='17' x2='9' y2='17' stroke-linejoin='miter'></line> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8' stroke-linejoin='miter' stroke-linecap='butt'></path></g></svg>",
    "Priority": 14
  },

  ///PARENTS EI SUB CATEGORIES
  //    {
  //     "Type": "EI",
  //     "Category": "EIPARENT",
  //     "Title": "Person",
  //     "Description": "TBG",
  //     "URL": "/usercard?id=#PARENTID#",
  //     "Role": "Therapist, Receptionist, FranciseOwner, Manager, NCC, Harvest, Owner",
  //     "Key": "",
  //     "Icon": "",
  //     "Priority": 1
  //    },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Therapies",
    "Description": "View active therapy sessions enrolled by this parent across services.",
    "URL": "/kpireport?hname=Services&rtype=activeservices&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='{2}'><g stroke-width='{2}' transform='translate(0, 0)'><path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M26,9h8c4.418,0,8,3.582,8,8v1' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' points=' 32,3 26,9 32,15 ' stroke-linejoin='miter'></polyline> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M22,39h-8c-4.418,0-8-3.582-8-8 v-1' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' points=' 16,45 22,39 16,33 ' stroke-linejoin='miter'></polyline> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M20,23H2v-2.242 c0-1.775,1.164-3.334,2.866-3.838C6.46,16.448,8.604,16,11,16c2.356,0,4.514,0.456,6.125,0.932C18.83,17.436,20,18.994,20,20.773V23 z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M6,7c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S6,9.761,6,7z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M46,46H28v-2.242 c0-1.775,1.164-3.334,2.866-3.838C32.46,39.448,34.604,39,37,39c2.356,0,4.514,0.456,6.125,0.932C44.83,40.436,46,41.994,46,43.773 V46z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M32,30c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S32,32.761,32,30z' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 2
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Therapists",
    "Description": "Explore the team of therapists working with the enrolled child.",
    "URL": "/kpireport?hname=Co-Workers&rtype=COWORKERS&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='{2}'><g stroke-width='{2}' transform='translate(0, 0)'><path data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M9,13L9,13 c-2.209,0-4-1.791-4-4v0c0-2.209,1.791-4,4-4h0c2.209,0,4,1.791,4,4v0C13,11.209,11.209,13,9,13z' stroke-linejoin='miter'></path> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M12,43H6L5,32l-3-1v-9 c0-2.209,1.791-4,4-4h6c1.454,0,2.727,0.777,3.427,1.937' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M39,13 L39,13c2.209,0,4-1.791,4-4v0c0-2.209-1.791-4-4-4h0c-2.209,0-4,1.791-4,4v0C35,11.209,36.791,13,39,13z' stroke-linejoin='miter'></path> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M36,43h6l1-11l3-1v-9 c0-2.209-1.791-4-4-4h-6c-1.454,0-2.727,0.777-3.427,1.937' stroke-linejoin='miter' stroke-linecap='butt'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M24,14L24,14 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h0c3.314,0,6,2.686,6,6v0C30,11.314,27.314,14,24,14z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M29,46H19l-1-12l-4-1V23 c0-2.209,1.791-4,4-4h12c2.209,0,4,1.791,4,4v10l-4,1L29,46z' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 3
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Credits",
    "Description": "Review all advanced invoices and parent credit balances.",
    "URL": "/AdvancedInvoices?facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' points='27.081,31 3,31 3,11 45,11 45,31 40,31 ' stroke-linejoin='miter' stroke-linecap='butt'></polyline> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='23' cy='21' r='4' stroke-linejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' x1='13' y1='17' x2='9' y2='17' stroke-linejoin='miter'></line> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8' stroke-linejoin='miter' stroke-linecap='butt'></path></g></svg>",
    "Priority": 4
  },
  //    {
  //     "Type": "EI",
  //     "Category": "EIPARENT",
  //     "Title": "Center",
  //     "Description": "TBG",
  //     "URL": "/centers?facility=#CENTERID#&pId=#PARENTID#",
  //     "Role": "Therapist, Receptionist, FranciseOwner, Manager, NCC, Harvest, Owner",
  //     "Key": "_",
  //     "Icon": "_",
  //     "Priority": 5
  //    },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Renewal",
    "Description": "View and manage therapy package renewals linked to this parent.",
    "URL": "/kpireport?hname=Renewals&rtype=allrenewals&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M23.983,38H24A20,20,0,0,1,4,18a19.926,19.926,0,0,1,8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M5.7,34.993a14.651,14.651,0,0,0-2.654,1.986A14.459,14.459,0,0,0,23.983,38H24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M24,38h-.017a20,20,0,0,0,20-20,19.926,19.926,0,0,0-8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M24,38A23.9,23.9,0,0,0,24,4.2,23.9,23.9,0,0,0,24,38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M42.287,34.993a14.651,14.651,0,0,1,2.654,1.986A14.459,14.459,0,0,1,24,38h-.017' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 6
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Service Req",
    "Description": "Track service requests or support issues raised by this parent.",
    "URL": "/kpireport?hname=Serivice Requests&rtype=servicerequest&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": " <svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path d=\"M33.545,4A11.235,11.235,0,0,0,24,9.143,11.235,11.235,0,0,0,14.455,4,11.476,11.476,0,0,0,3,15.429C3,26.857,24,44,24,44S45,26.857,45,15.429A11.476,11.476,0,0,0,33.545,4Z\" fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><\/g><\/svg>",
    "Priority": 7
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Calls",
    "Description": "View call interactions made with or about this parent.",
    "URL": "/facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M30.041,29.939l-3.423,4.279A36.108,36.108,0,0,1,13.782,21.383l4.279-3.423a2.908,2.908,0,0,0,.84-3.45L15,5.727a2.908,2.908,0,0,0-3.39-1.635L4.186,6.018A2.926,2.926,0,0,0,2.028,9.249,43.142,43.142,0,0,0,38.751,45.972a2.924,2.924,0,0,0,3.23-2.158l1.926-7.425A2.911,2.911,0,0,0,42.273,33l-8.782-3.9A2.908,2.908,0,0,0,30.041,29.939Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line x1='36' y1='8' x2='36' y2='16' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='32' y1='12' x2='40' y2='12' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M36,2a9.949,9.949,0,0,0-9.037,14.219L26,22l5.781-.963A9.989,9.989,0,1,0,36,2Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 8
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Messages",
    "Description": "Access all internal messages exchanged about this parent.",
    "URL": "/messages?facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='1'><g stroke-width='1' transform='translate(0.5, 0.5)'><path d='M40.8,34.6A16.032,16.032,0,0,0,46,23c0-9.9-9.8-18-22-18S2,13.1,2,23s9.8,18,22,18a31.836,31.836,0,0,0,6.2-.7L42,45Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='1' stroke-linejoin='miter'></path><path d='M31.562,17.443A4.9,4.9,0,0,0,24,18.2a4.916,4.916,0,1,0-7.562,6.206L24,32l7.563-7.59A4.939,4.939,0,0,0,31.562,17.443Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='1' data-color='color-2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 9
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Feedbacks",
    "Description": "View all feedback entries submitted by the parent for services or staff.",
    "URL": "/kpireport?hname=Feedbacks&rtype=feedbacksgiven&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='31' r='1' fill='#444444' data-cap='butt' data-color='color-2' data-stroke='none' stroke-linecap='butt' stroke-linejoin='miter'></circle> <path d='M40.8,33.6A16.034,16.034,0,0,0,46,22c0-9.9-9.8-18-22-18S2,12.1,2,22s9.8,18,22,18a31.827,31.827,0,0,0,6.2-.7L42,44Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path> <line x1='24' y1='12' x2='24' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line> <circle cx='24' cy='31' r='1' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle></g></svg>",
    "Priority": 10
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Goals",
    "Description": "Monitor the child’s therapy goals and progress under this parent’s profile.",
    "URL": "/kpireport?hname=Goals&rtype=totalgoals&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
    "Priority": 11
  },
  // {
  //     "Type": "EI",
  //     "Category": "EIPARENT",
  //     "Title": "CHI",
  //     "Description": "TBG",
  //     "URL": "/kpireport?hname=CHI&rtype=adminpti&facility=#CENTERID#&pId=#PARENTID#",
  //     "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
  //     "Key": "",
  //     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
  //     "Priority": 12
  // },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Dues",
    "Description": "Review any pending payment dues or advances not yet cleared.",
    "URL": "/kpireport?hname=Advance%20Pending&rtype=advancepending&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' points='19.2 4.4 14 7 19 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='28.8 4.4 34 7 29 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline points='21 8 18 2 30 2 27 8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polyline><path d='M29,14H19S7,27,7,35c0,6,4.25,11,17,11s17-5,17-11C41,27,29,14,29,14Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-color='color-2' x1='24' y1='21' x2='24' y2='39' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><path data-color='color-2' d='M28.96,23.974c-2.273-1.181-9.574-2.072-9.574,1.992,0,4.865,9.091,3.148,9.091,7.441s-5.909,3.971-10,2.576' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 13
  },
  {
    "Type": "EI",
    "Category": "EIPARENT",
    "Title": "Attendance",
    "Description": "View attendance records of the child related to this parent.",
    "URL": "/attendancekpi?status=pending&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 14
  },


  ///THERAPIST EI SUB CATEGORIES
  //    {
  //     "Type": "EI",
  //     "Category": "EIPARENT",
  //     "Title": "Person",
  //     "Description": "TBG",
  //     "URL": "/usercard?id=#PARENTID#",
  //     "Role": "Therapist, Receptionist, FranciseOwner, Manager, NCC, Harvest, Owner",
  //     "Key": "",
  //     "Icon": "",
  //     "Priority": 1
  //    },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Kids",
    "Description": "Kids, parents, families are being empowered.",
    "URL": "/kpireport?hname=Parents&rtype=activeparents&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 1
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Therapies",
    "Description": "These many kids, parents, families are being empowered.",
    "URL": "/kpireport?hname=Services&rtype=activeservices&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='{2}'><g stroke-width='{2}' transform='translate(0, 0)'><path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M26,9h8c4.418,0,8,3.582,8,8v1' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' points=' 32,3 26,9 32,15 ' stroke-linejoin='miter'></polyline> <path data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-miterlimit='{10}' d='M22,39h-8c-4.418,0-8-3.582-8-8 v-1' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' points=' 16,45 22,39 16,33 ' stroke-linejoin='miter'></polyline> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M20,23H2v-2.242 c0-1.775,1.164-3.334,2.866-3.838C6.46,16.448,8.604,16,11,16c2.356,0,4.514,0.456,6.125,0.932C18.83,17.436,20,18.994,20,20.773V23 z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M6,7c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S6,9.761,6,7z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M46,46H28v-2.242 c0-1.775,1.164-3.334,2.866-3.838C32.46,39.448,34.604,39,37,39c2.356,0,4.514,0.456,6.125,0.932C44.83,40.436,46,41.994,46,43.773 V46z' stroke-linejoin='miter'></path> <path fill='none' stroke='#444444' stroke-width='{2}' stroke-linecap='square' stroke-miterlimit='{10}' d='M32,30c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S32,32.761,32,30z' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 2
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Goals",
    "Description": "Monitor the child’s therapy goals and progress under this parent’s profile.",
    "URL": "/kpireport?hname=Goals&rtype=totalgoals&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
    "Priority": 11
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Attendance",
    "Description": "Monitor services provided to children by therapists in your facility.",
    "URL": "/aipendingattendance?status=pending",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 14
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Assessment",
    "Description": "View upcoming or completed assessments for the therapist’s children.",
    "URL": "/bookedassessments?facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 14
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Feedbacks",
    "Description": "Access therapist-specific feedback given by parents.",
    "URL": "/kpireport?hname=Feedbacks&rtype=feedbacksgiven&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager,BDC, NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='31' r='1' fill='#444444' data-cap='butt' data-color='color-2' data-stroke='none' stroke-linecap='butt' stroke-linejoin='miter'></circle> <path d='M40.8,33.6A16.034,16.034,0,0,0,46,22c0-9.9-9.8-18-22-18S2,12.1,2,22s9.8,18,22,18a31.827,31.827,0,0,0,6.2-.7L42,44Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path> <line x1='24' y1='12' x2='24' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line> <circle cx='24' cy='31' r='1' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle></g></svg>",
    "Priority": 10
  },

  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Dues",
    "Description": "View therapist’s children with pending dues and financial clarity",
    "URL": "/kpireport?hname=Advance%20Pending&rtype=advancepending&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' points='19.2 4.4 14 7 19 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='28.8 4.4 34 7 29 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline points='21 8 18 2 30 2 27 8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polyline><path d='M29,14H19S7,27,7,35c0,6,4.25,11,17,11s17-5,17-11C41,27,29,14,29,14Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-color='color-2' x1='24' y1='21' x2='24' y2='39' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><path data-color='color-2' d='M28.96,23.974c-2.273-1.181-9.574-2.072-9.574,1.992,0,4.865,9.091,3.148,9.091,7.441s-5.909,3.971-10,2.576' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 13
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Additions",
    "Description": "Thank you on behalf of Kids, Parents, Families.",
    "URL": "/kpireport?hname=Additions&rtype=additionleads&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 7
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Inactivations",
    "Description": "Speak to each parent, family member, reaffirm Pinnacle Hope, Confidence.",
    "URL": "/kpireport?hname=Inactive%20Services&rtype=inactiveservices&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polygon fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points='3.5,3.5 9.5,21.5 13.5,13.5 21.5,9.5 ' stroke-linejoin='miter'></polygon> <line data-cap='butt' data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' x1='22.101' y1='22.101' x2='41.899' y2='41.899' stroke-linejoin='miter' stroke-linecap='butt'></line> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='32' cy='32' r='14' stroke-linejoin='miter'></circle></g></svg>",
    "Priority": 8
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Pollinations Done",
    "Description": "Thank you on behalf of kids, parents, families.",
    "URL": "/kpireport?hname=Completed&rtype=pollinationclaritycompleted&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='8' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='42' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='28' x2='24.001' y2='38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='32.163' y1='37.409' x2='27.486' y2='40.04' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='8' y1='19' x2='8' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='20.517' y1='22.041' x2='11.483' y2='16.959' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='22.039' x2='36.515' y2='16.961' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='36.517' y1='13.04' x2='31.839' y2='10.409' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><circle cx='8' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='24' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='10' x2='24.001' y2='20' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><circle cx='24.001' cy='6' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='15.838' y1='10.591' x2='20.515' y2='7.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='16.163' y1='37.591' x2='11.484' y2='34.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='40.001' y1='24' x2='40.001' y2='29' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='20.517' y1='25.959' x2='11.483' y2='31.041' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='25.961' x2='36.515' y2='31.039' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line></g></svg>",
    "Priority": 9
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Pollinations Pending",
    "Description": "These many kids are seeking your help to be Self-Sufficient, part of Mainstream.",
    "URL": "/kpireport?hname=YetTo&rtype=pollinationclarityyetto&facility=#CENTERID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='8' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='42' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='28' x2='24.001' y2='38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='32.163' y1='37.409' x2='27.486' y2='40.04' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='8' y1='19' x2='8' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='20.517' y1='22.041' x2='11.483' y2='16.959' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='22.039' x2='36.515' y2='16.961' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='36.517' y1='13.04' x2='31.839' y2='10.409' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><circle cx='8' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='24' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='10' x2='24.001' y2='20' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><circle cx='24.001' cy='6' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='15.838' y1='10.591' x2='20.515' y2='7.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='16.163' y1='37.591' x2='11.484' y2='34.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='40.001' y1='24' x2='40.001' y2='29' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='20.517' y1='25.959' x2='11.483' y2='31.041' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='25.961' x2='36.515' y2='31.039' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line></g></svg>",
    "Priority": 10
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Renewal",
    "Description": "Track therapy renewals facilitated by or linked to this therapist.",
    "URL": "/kpireport?hname=Renewals&rtype=renewalclarityall&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M23.983,38H24A20,20,0,0,1,4,18a19.926,19.926,0,0,1,8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M5.7,34.993a14.651,14.651,0,0,0-2.654,1.986A14.459,14.459,0,0,0,23.983,38H24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M24,38h-.017a20,20,0,0,0,20-20,19.926,19.926,0,0,0-8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M24,38A23.9,23.9,0,0,0,24,4.2,23.9,23.9,0,0,0,24,38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M42.287,34.993a14.651,14.651,0,0,1,2.654,1.986A14.459,14.459,0,0,1,24,38h-.017' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 6
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Service Req",
    "Description": "Access support/service requests initiated by the therapist’s parents.",
    "URL": "/kpireport?hname=Service Requests&rtype=servicerequest&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": " <svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path d=\"M33.545,4A11.235,11.235,0,0,0,24,9.143,11.235,11.235,0,0,0,14.455,4,11.476,11.476,0,0,0,3,15.429C3,26.857,24,44,24,44S45,26.857,45,15.429A11.476,11.476,0,0,0,33.545,4Z\" fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><\/g><\/svg>",
    "Priority": 7
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Leaves",
    "Description": "View and manage leave requests raised by parents for their child’s sessions.",
    "URL": "/kpireport?hname=Parent Leaves&rtype=leaverequestparent&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='22' r='4' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><path d='M35.315,32.221a14,14,0,1,0-22.63,0' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M35.218,42.924a22,22,0,1,0-22.436,0' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M22.276,31h3.448a4,4,0,0,1,3.992,4.266L29,46H19l-.716-10.734A4,4,0,0,1,22.276,31Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 7
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Calls",
    "Description": "TBG",
    "URL": "/wip?facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M30.041,29.939l-3.423,4.279A36.108,36.108,0,0,1,13.782,21.383l4.279-3.423a2.908,2.908,0,0,0,.84-3.45L15,5.727a2.908,2.908,0,0,0-3.39-1.635L4.186,6.018A2.926,2.926,0,0,0,2.028,9.249,43.142,43.142,0,0,0,38.751,45.972a2.924,2.924,0,0,0,3.23-2.158l1.926-7.425A2.911,2.911,0,0,0,42.273,33l-8.782-3.9A2.908,2.908,0,0,0,30.041,29.939Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line x1='36' y1='8' x2='36' y2='16' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='32' y1='12' x2='40' y2='12' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M36,2a9.949,9.949,0,0,0-9.037,14.219L26,22l5.781-.963A9.989,9.989,0,1,0,36,2Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 8
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Messages",
    "Description": "TBG",
    "URL": "/WIP?facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='1'><g stroke-width='1' transform='translate(0.5, 0.5)'><path d='M40.8,34.6A16.032,16.032,0,0,0,46,23c0-9.9-9.8-18-22-18S2,13.1,2,23s9.8,18,22,18a31.836,31.836,0,0,0,6.2-.7L42,45Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='1' stroke-linejoin='miter'></path><path d='M31.562,17.443A4.9,4.9,0,0,0,24,18.2a4.916,4.916,0,1,0-7.562,6.206L24,32l7.563-7.59A4.939,4.939,0,0,0,31.562,17.443Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='1' data-color='color-2' stroke-linejoin='miter'></path></g></svg>",
    "Priority": 9
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "PISI",
    "Description": "TBG",
    "URL": "/kpireport?hname=PISI&rtype=ADMINPTI&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
    "Priority": 12
  },

  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "WHI",
    "Description": "TBG",
    "URL": "/kpireport?hname=WHI completed&rtype=proquery&FilterType=completed&facility=#CENTERID#&pId=#PARENTID#",
    "Role": "Therapist, Receptionist, FranciseOwner, Manager, BDC,NCC, Harvest, Owner",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
    "Priority": 12
  },
  {
    "Type": "EI",
    "Category": "EITHERAPIST",
    "Title": "Biometric",
    "Description": "TBG",
    "URL": "/kpireport?hname=Biometric Report&rtype=biometricrepo&pId=#PARENTID#",
    "Role": "Harvest, Owner,BDC,NCC",
    "Key": "",
    "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' strokeWidth={2}><g strokeWidth={2} transform='translate(0, 0)'><polyline points='4 12 4 4 12 4' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /><polyline points='44 12 44 4 36 4' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /><polyline points='4 36 4 44 12 44' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /><polyline points='44 36 44 44 36 44' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} data-color='color-2' strokeLinejoin='miter' /><path d='M38,38l-6.275-2.092a4,4,0,0,1-2.735-3.781l-.006-1.974A13.576,13.576,0,0,0,34,20V18.342a10.227,10.227,0,0,0-9.335-10.32A10,10,0,0,0,14,18v2a13.559,13.559,0,0,0,5,10.153v1.964a4,4,0,0,1-2.735,3.8L10,38' fill='none' stroke='#444444' strokeLinecap='square' strokeMiterlimit={10} strokeWidth={2} strokeLinejoin='miter' /></g></svg>",
    "Priority": 13
  },


  //EI HELP SUB CATEGORIES
  {
    "Type": "EIH",
    "Category": "pollinationkids",
    "Title": "Pollination Parents",
    "Description": "Pollination Kids,Kids in Pollination",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "mykids",
    "Title": "My Kids",
    "Description": "My Kid,My Parents,My Parents",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Role": "Therapist"
  },
  //    {
  //     "Type": "EIH",
  //     "Category": "mykids",
  //     "Title": "My Kids",
  //     "URL": "/autismgpt",
  //     "Action": "PARENTDISPLAY",
  //     "Role": "Therapist"
  //    },
  {
    "Type": "EIH",
    "Category": "renewalkids",
    "Title": "Renewal Kids",
    "Description": "Renew Kid,Kids in Renewal",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Role": "Therapist"
  },
  //    {
  //     "Type": "EIH",
  //     "Category": "renewalkids",
  //     "Title": "Renew Kid",
  //     "URL": "/autismgpt",
  //     "Action": "PARENTDISPLAY",
  //     "Role": "Therapist"
  //    },
  {
    "Type": "EIH",
    "Category": "absentkids",
    "Title": "Absented Kids",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "Absent Kid,Kid Not Present",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "homeworkkids",
    "Title": "Homework Pending Kids",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "Pending Homework Kids",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "duekids",
    "Title": "Fee Due Kids",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "Fee Pending Kids",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "5starfeedback",
    "Title": "5 Star Feedbacks",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "5starfeedback,5 star feedback",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "4starfeedback",
    "Title": "4 Star Feedbacks",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "4starfeedback,4 star feedback,",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "3starfeedback",
    "Title": "3 Star Feedbacks",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "3starfeedback,3 star feedback",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "2starfeedback",
    "Title": "2 Star Feedbacks",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "2starfeedback,2 star feedback",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "1starfeedback",
    "Title": "1 Star Feedbacks",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "1starfeedback,1 star feedback",
    "Role": "Therapist"
  },
  {
    "Type": "EIH",
    "Category": "mytherapists",
    "Title": "Therapist",
    "URL": "/autismgpt",
    "Action": "PARENTDISPLAY",
    "Description": "my therapist,my therapists",
    "Role": "Boss"
  },
  //    {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Title": "#KIDNAME# Attendance",
  //     "Keyword": "attendance",
  //     "URL": "/attendancekpi?status=pending&month=9&year=2023",
  //     "Action": "OPENURL",
  //     "Role": "Therapist"
  //    },
  //    {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Title": "#KIDNAME# Goal Review",
  //     "Keyword": "goal review",
  //     "URL": "/goalskpi?status=pending",
  //     "Action": "OPENURL",
  //     "Role": "Therapist"
  //    },
  //    {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Title": "#KIDNAME# Goal Set",
  //     "Keyword": "goal set",
  //     "URL": "/goalskpi?status=pending",
  //     "Action": "OPENURL",
  //     "Role": "Therapist"
  //    },
  //    {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Title": "#KIDNAME# Assessment",
  //     "Keyword": "assessment",
  //     "URL": "/bookassessment",
  //     "Action": "OPENURL",
  //     "Role": "Therapist"
  //    },

  //    {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Title": "Book Compensation for #KIDNAME#",
  //     "URL": "/compensation?id=#KIDID#",
  //     "Action": "OPENURL",
  //     "Role": "Therapist",
  //     "Priority": 4
  //    },
  //
  {
    "Type": "EIC",
    "Category": "Creation",
    "Title": "Track",
    "URL": "/kidstatetracker",
    "Priority": 1,
    "Action": "OPENURL",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Description": "Track Kid"
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Title": "Kid Status",
    "URL": "/kpireport?hname=Kid Status&rtype=kidconditionsandbehaviours",
    "Priority": 1,
    "Action": "OPENURL",
    "Role": "Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Description": "Kid Conditions"
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Learn",
    "Description": "Learn Conditions,Learn Tantrums,Learn Materials,Pinnacle Wisdom,Pinnacle Knowledge,Pinnacle University",
    "Action": "OPENURL",
    "URL": "/miraverse",
    "Prority": 1
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss",
    "Title": "Home work",
    "Description": "Give Feedback,Pending Homework,Homework pending,Give Homework",
    "Action": "OPENURL",
    "URL": "/attendancekpi?status=reviewspending",
    "Prority": 2
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist,Boss",
    "Title": "Book Compo",
    "Description": "Book Compo,Book Compensation,Create Compensation",
    "Action": "OPENURL",
    "URL": "/compensation",
    "Prority": 3
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist,Boss",
    "Title": "Raise SR",
    "Description": "Raise SR,Raise Service Request,Create Service Request,Create SR,Open SR,View SR,Open Service Request,View Service Request",
    "Action": "OPENURL",
    "URL": "/servicerequest",
    "Prority": 4
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist,Boss",
    "Title": "Apply Leave",
    "Description": "Apply Leave,Apply Leave Today,Apply Leave Tomorrow",
    "Action": "OPENURL",
    "URL": "/leaverequest",
    "Prority": 5
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss",
    "Title": "Buy Credits",
    "Description": "Buy Credits,Buy 60 Credits,Buy 45 Credits,Buy 36 Credits,Buy 24 Credits,Buy 12 Credits,Buy 6 Credits,Buy 3 Credits,Buy 1 Credit",
    "Action": "OPENURL",
    "URL": "/d#boss-credit-block",
    "Prority": 6
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss",
    "Title": "Book Assessment",
    "Description": "Book Assessment",
    "Action": "OPENURL",
    "URL": "/sanjeevan",
    "Prority": 7
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "My Profile",
    "Description": "Profile,Update Profile",
    "Action": "OPENURL",
    "URL": "/profile",
    "Prority": 8
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "Give Attendance",
    "Description": "Give Attendance,Mark Attendance,Create Attendance,View Attendance",
    "Action": "OPENURL",
    "URL": "/aipendingattendance?status=pending",
    "Prority": 9
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "Request Feedback",
    "Description": "Ask Feedback,Get Feedback",
    "Action": "OPENURL",
    "URL": "/attendancekpi?status=reviewspending",
    "Prority": 10
  },
  // {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Role": "Therapist",
  //     "Title": "Bank Details",
  //     "Description": "Update Bank Details,Update Bank",
  //     "Action": "OPENURL",
  //     "URL": "/bankdetails",
  //     "Prority": 11
  // },
  // {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Role": "Therapist",
  //     "Title": "PF Details",
  //     "Description": "Update PF Details,Update PF",
  //     "Action": "OPENURL",
  //     "URL": "/pfdetails",
  //     "Prority": 12
  // },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "Basic Details",
    "Description": "update basic details,update basic",
    "Action": "OPENURL",
    "URL": "/basicdetails",
    "Prority": 13
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "Goal Set",
    "Description": "Goal Setting,Set Goal ,Goals Setting,Set Goals",
    "Action": "OPENURL",
    "URL": "/goalsetting",
    "Prority": 14
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "Goal Review",
    "Description": "Goal Review,Review Goal ,Goals Review,Review Goals,View Goals",
    "Action": "OPENURL",
    "URL": "/goalskpi?status=pending",
    "Prority": 15
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "Book Assessment",
    "Description": "Book Assessment",
    "Action": "OPENURL",
    "URL": "/bookassessment",
    "Prority": 16
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "Complete Assessment",
    "Description": "Complete Assessment",
    "Action": "OPENURL",
    "URL": "/bookedassessments",
    "Prority": 17
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "View Awards",
    "Description": "View Award,Open Award,Update Memo",
    "Action": "OPENURL",
    "URL": "/allawards",
    "Prority": 18
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Therapist",
    "Title": "View Memo",
    "Description": "View Memo,Open Memo,Update Memo",
    "Action": "OPENURL",
    "URL": "/allmemos",
    "Prority": 19
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Follow Up Leads",
    "Description": "Leads Follow Up,Pending Leads",
    "Action": "OPENURL",
    "URL": "/hermes",
    "Prority": 3
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Walkins",
    "Description": "Walkin",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Walkins&rtype=walkinleads",
    "Prority": 4
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Book Assessment",
    "Description": "Create Assessment",
    "Action": "OPENURL",
    "URL": "/bookassessment",
    "Prority": 5
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Book Compo",
    "Description": "Book Compensation,Create Compensation",
    "Action": "OPENURL",
    "URL": "/compensation",
    "Prority": 6
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Apply Leave",
    "Description": "Apply Leave,Apply Leave Today,Apply Leave Tomorrow",
    "Action": "OPENURL",
    "URL": "/leaverequest",
    "Prority": 7
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Raise SR",
    "Description": "Raise SR,Raise Service Request,Create Service Request,Create SR,Open SR,View SR,Open Service Request,View Service Request",
    "Action": "OPENURL",
    "URL": "/servicerequest",
    "Prority": 8
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Pending Attendance",
    "Description": "Attendance Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Attendance&rtype=pendingattendance",
    "Prority": 9
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Pending Goals",
    "Description": "Goals Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Goals%20Pending&rtype=goalspending",
    "Prority": 10
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Pending Profile",
    "Description": "Profile Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=NO%20Profile%20Pics&rtype=noprofileusers",
    "Prority": 11
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "View Memos",
    "Description": "View Memo",
    "Action": "OPENURL",
    "URL": "/allmemos",
    "Prority": 12
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Raise Memo",
    "Description": "Create Memo",
    "Action": "OPENURL",
    "URL": "/publishscreen?t=memo",
    "Prority": 13
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Approve Leaves",
    "Description": "Approve Leave,Approve Therapist Leave,Leave Approve,Therapist Leave approve,UnApprove Leave",
    "Action": "OPENURL",
    "URL": "/leaveapprovals",
    "Prority": 14
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "View Awards",
    "Description": "View Award",
    "Action": "OPENURL",
    "URL": "/allawards",
    "Prority": 15
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "BDC,NCC",
    "Title": "Follow Up Leads",
    "Description": "Leads Follow Up,Pending Leads",
    "Action": "OPENURL",
    "URL": "/hermes",
    "Prority": 4
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "Walkins",
    "Description": "Walkin",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Walkins&rtype=walkinleads",
    "Prority": 5
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "OnBoard Lead",
    "Description": "Create lead",
    "Action": "OPENURL",
    "URL": "/createlead",
    "Prority": 6
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "OnBoard Parent",
    "Description": "Create parent,Add Parent,View Parent",
    "Action": "OPENURL",
    "URL": "/createparent?type=create",
    "Prority": 7
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Book Assessment",
    "Description": "Create Assessment",
    "Action": "OPENURL",
    "URL": "/bookassessment",
    "Prority": 8
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Add Service",
    "Description": "Add Therapy,Update Therapy,Onboard new service,Create Service",
    "Action": "OPENURL",
    "URL": "/serviceland?type=create",
    "Prority": 9
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Create Invoice",
    "Description": "Create invoice,Create 60 MCP,Create 45 MCP,Create 36 MCP,Create 12 MCP,Create 6 MCP,Create 3 MCP,Create Monthly nvoice",
    "Action": "OPENURL",
    "URL": "/createinvoice",
    "Prority": 10
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Receive Fee",
    "Description": "Receive Payments",
    "Action": "OPENURL",
    "URL": "/pendinginvoices",
    "Prority": 11
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Fee Receipts",
    "Description": "Receipts,Payment Receipts",
    "Action": "OPENURL",
    "URL": "/allinvoices",
    "Prority": 12
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Book Compo",
    "Description": "Book Compensation,Create Compensation",
    "Action": "OPENURL",
    "URL": "/compensation",
    "Prority": 13
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,NCC,Harvest,Manager",
    "Title": "Apply Leave",
    "Description": "Apply Leave,Apply Leave Today,Apply Leave Tomorrow",
    "Action": "OPENURL",
    "URL": "/leaverequest",
    "Prority": 14
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Apply Therapist Leave",
    "Description": "Create Therapist Leave",
    "Action": "OPENURL",
    "URL": "/therapistleaverequest",
    "Prority": 15
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager",
    "Title": "Raise SR",
    "Description": "Raise Service Request,Create Service Request,Create SR",
    "Action": "OPENURL",
    "URL": "/servicerequest",
    "Prority": 16
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Pending SR",
    "Description": "Pending Service Request,Service Request Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Servicerequest%20Pending&rtype=servicerequestpending",
    "Prority": 17
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "Pending Attendance",
    "Description": "Attendance Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Attendance&rtype=pendingattendance",
    "Prority": 18
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "Pending Goals",
    "Description": "Goals Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Goals%20Pending&rtype=goalspending",
    "Prority": 19
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Manager",
    "Title": "Pending Profile",
    "Description": "Profile Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=NO%20Profile%20Pics&rtype=noprofileusers",
    "Prority": 20
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "View Memos",
    "Description": "View Memo",
    "Action": "OPENURL",
    "URL": "/allmemos",
    "Prority": 21
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "Raise Memo",
    "Description": "Create Memo",
    "Action": "OPENURL",
    "URL": "/publishscreen?t=memo",
    "Prority": 22
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "Give Awards",
    "Description": "Create Award,Raise Award",
    "Action": "OPENURL",
    "URL": "/publishscreen?t=award",
    "Prority": 23
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Manager",
    "Title": "Approve Leaves",
    "Description": "Approve Leave,Approved Staff Leave",
    "Action": "OPENURL",
    "URL": "/leaveapprovals",
    "Prority": 24
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC",
    "Title": "View Awards",
    "Description": "View Award",
    "Action": "OPENURL",
    "URL": "/allawards",
    "Prority": 25
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Create Expense",
    "Description": "Enter Expenses",
    "Action": "OPENURL",
    "URL": "/createexpense",
    "Prority": 26
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Consecutive Leaves",
    "Description": "Continuos Leaves",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Consecutive%20Leaves&rtype=consecutiveleaves",
    "Prority": 27
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Staff Util",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Staff%20Util&rtype=staffutil",
    "Prority": 28
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Harvest,Owner,BDC,NCC",
    "Title": "BioMetric Report",
    "Description": "Biometric",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Biometric Report&rtype=biometricrepo",
    "Prority": 28
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Harvest",
    "Title": "Staff",
    "Description": "Total Staff",
    "Action": "OPENURL",
    "URL": "/createstaff?type=create",
    "Prority": 29
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Harvest",
    "Title": "Co Workers",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Co-Workers&rtype=COWORKERS",
    "Prority": 30
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "BDC,NCC,Harvest,Manager",
    "Title": "Renewal",
    "Description": "Pending Renewals",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Pending&rtype=renewalclaritypending",
    "Prority": 31
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Manager",
    "Title": "Royalty",
    "Description": "View Royalty",
    "Action": "OPENURL",
    "URL": "/royalty",
    "Prority": 32
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Manager",
    "Title": "TA",
    "Description": "View TA",
    "Action": "OPENURL",
    "URL": "/talentacquisition",
    "Prority": 33
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Manager",
    "Title": "Expense",
    "Description": "View Expenses",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Expanses&rtype=expensesreport",
    "Prority": 34
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Manager",
    "Title": "Overdue Kids",
    "Description": "Due Kids",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Overdue&rtype=dueoverdue",
    "Prority": 35
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Manager",
    "Title": "Today due Kids",
    "Description": "Due Kids Today",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Today%20Due&rtype=duetoday",
    "Prority": 36
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Manager",
    "Title": "ETA Pending Kids",
    "Description": "Pending ETA,ETA Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Pending%20ETA&rtype=etapending",
    "Prority": 37
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Parent Not Using App",
    "Description": "Parents Not Using,PNUA",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Parents%20Not%20Using%20App&rtype=parentsnotusingapp",
    "Prority": 38
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Play Ground",
    "Action": "OPENURL",
    "URL": "/playground",
    "Prority": 39
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Available Slots",
    "Description": "Available",
    "Action": "OPENURL",
    "URL": "/availableslots",
    "Prority": 40
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Impunctual",
    "Description": "Impuntual Report",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Impunctual&rtype=biometriclateearly",
    "Prority": 41
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Grace Compensation",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Grace%20Compensation&rtype=gracecompensation",
    "Prority": 42
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Locked Accounts",
    "Description": "Blocked",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Locked%20Accounts&rtype=lockedaccounts",
    "Prority": 43
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Advanced Invoices",
    "Description": "Future Invoices",
    "Action": "OPENURL",
    "URL": "/advancedinvoices",
    "Prority": 44
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "All Invoices",
    "Action": "OPENURL",
    "URL": "/allinvoices?hname=All Invoices&rtype=allinvoices",
    "Prority": 45
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "FranciseOwner,Owner",
    "Title": "Salary Statement",
    "Action": "OPENURL",
    "URL": "/salarystatement",
    "Prority": 46
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist",
    "Title": "Payslip",
    "Description": "View Payslip",
    "Action": "OPENURL",
    "URL": "/payslip",
    "Prority": 47
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Profile",
    "Description": "My Profile,Update Profile",
    "Action": "OPENURL",
    "URL": "/profile",
    "Prority": 48
  },
  // {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
  //     "Title": "Bank Details",
  //     "Description": "Update Bank Details,Update Bank",
  //     "Action": "OPENURL",
  //     "URL": "/bankdetails",
  //     "Prority": 49
  // },
  // {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
  //     "Title": "PF Details",
  //     "Description": "Update PF Details,Update PF",
  //     "Action": "OPENURL",
  //     "URL": "/pfdetails",
  //     "Prority": 50
  // },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Basic Details",
    "Description": "update basic details,update basic",
    "Action": "OPENURL",
    "URL": "/basicdetails",
    "Prority": 51
  },
  {
    "Type": "EIC",
    "Category": "System",
    "Role": "Therapist,Receptionist,BDC,NCC,Harvest,Manager,FranciseOwner,Owner",
    "Title": "Id Card",
    "Description": "my id,id card",
    "Action": "OPENURL",
    "URL": "/idcard",
    "Prority": 52
  },
  {
    "Type": "EIC",
    "Category": "System",
    "Title": "Holiday List",
    "URL": "/pdfviewer?t=https://images.pinnacleblooms.org/Assets/image/Pinnacle-Holiday-Calendar-2025.pdf",
    "Description": "Holidays",
    "Action": "OPENURL",
    "Priority": 94,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,Senior,manager"
  },
  {
    "Type": "EIC",
    "Category": "System",
    "Title": "Stakeholder Handbook",
    "URL": "/pdfviewer?t=https://images.pinnacleblooms.org/assets/Policies/PinnacleBloomsNetwork-StakeHolder-Hand-Book.pdf",
    "Description": "Stake Holder Book",
    "Action": "OPENURL",
    "Priority": 95,
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,Senior,manager"
  },
  {
    "Type": "EIC",
    "Category": "System",
    "Title": "AbC's of Therapist",
    "Title": "AbC's of Therapist",
    "URL": "/pdfviewer?t=https://images.pinnacleblooms.org/assets/Policies/pinnacle_abc.jpg",
    "Description": "",
    "Action": "OPENURL",
    "Priority": 96,
    "Role": "Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,Senior,manager"
  },
  {
    "Type": "EIC",
    "Category": "System",
    "Title": "Inbound Policy",
    "URL": "/pdfviewer?t=https://images.pinnacleblooms.org/assets/Policies/NCC-CALL-Inbound-Outbound-PROTOCOL.pdf",
    "Description": "",
    "Action": "OPENURL",
    "Priority": 97,
    "Role": "Receptionist, FranciseOwner, BDC,NCC, Harvest, Owner,Senior,manager"

  },
  {
    "Type": "EIC",
    "Category": "System",
    "Title": "Outbound Policy",
    "URL": "/pdfviewer?t=https://images.pinnacleblooms.org/assets/Policies/NCC-CALL-Inbound-Outbound-PROTOCOL.pdf",
    "Priority": 98,
    "Description": "",
    "Action": "OPENURL",
    "Role": "Therapist, Receptionist"
  },
  {
    "Type": "EIC",
    "Category": "System",
    "Title": "Walkin Policy",
    "URL": "/pdfviewer?t=https://images.pinnacleblooms.org/assets/Policies/Parent-Customer-Walk-In-Protocol.pdf",
    "Priority": 99,
    "Description": "",
    "Action": "OPENURL",
    "Role": "Boss, Therapist, Receptionist, FranciseOwner,BDC, NCC, Harvest, Owner,Senior,manager"
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Lost Parents",
    "Description": "left parents,lost",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Lost%20Parents&rtype=leftparents",
    "Prority": 46
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Refer Parent",
    "Description": "Refer Kids,Help Parent,Help Kid",
    "Action": "OPENURL",
    "URL": "https://api.whatsapp.com/send?phone=919100181181&text=Hello%20Pinnacle%20NCC%0a%0aI%20am%20referring%20parent%20..%0a%0a#NAME#%0a#ID#",
    "Prority": 9999
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Moonlight",
    "Description": "Report Home Therapies",
    "Action": "OPENURL",
    "URL": "https://api.whatsapp.com/send?phone=919100181181&text=Hello%20Pinnacle%20NCC%0a%0aI%20am%20reporting%20you%20about%20moonlight%20of%20your%20employee%20..%0a%0a#NAME#%0a#ID#",
    "Prority": 9999
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Call Pinnacle",
    "Description": "Call NCC,Call 9100181181",
    "Action": "OPENURL",
    "URL": "tel:9100181181",
    "Prority": 9999
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Message Pinnacle",
    "Description": "Whats App Pinnacle,Message NCC,Message 9100181181",
    "Action": "OPENURL",
    "URL": "https://api.whatsapp.com/send?phone=919100181181&text=Hello%20Pinnacle%20NCC,%0a%0aNeed%20your%20support%20about%20..%0a%0a%0a%0a#NAME#%0a#ID#",
    "Prority": 9999
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Unregistered Therapies",
    "Description": "Illegal Therapies",
    "Action": "OPENURL",
    "URL": "https://api.whatsapp.com/send?phone=919100181181&text=Hello%20Pinnacle%20NCC%0a%0aI%20am%20reporting%20you%20about%20illegal%20therapies%20happening%20in%20Pinnacle%20without%20entry%20in%20Pinnacle%20app..%20%0a%0a#NAME#%0a#ID#",
    "Prority": 9999
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Follow Up Leads",
    "Description": "Leads Follow Up,Pending Leads",
    "Action": "OPENURL",
    "URL": "/hermes",
    "Prority": 2
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Walkins",
    "Description": "Walkin",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Walkins&rtype=walkinleads",
    "Prority": 3
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Book Assessment",
    "Description": "Create Assessment",
    "Action": "OPENURL",
    "URL": "/bookassessment",
    "Prority": 6
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Book Compo",
    "Description": "Book Compensation,Create Compensation",
    "Action": "OPENURL",
    "URL": "/compensation",
    "Prority": 11
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Apply Leave",
    "Description": "Apply Leave,Apply Leave Today,Apply Leave Tomorrow",
    "Action": "OPENURL",
    "URL": "/leaverequest",
    "Prority": 12
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Raise SR",
    "Description": "Raise SR,Raise Service Request,Create Service Request,Create SR,Open SR,View SR,Open Service Request,View Service Request",
    "Action": "OPENURL",
    "URL": "/servicerequest",
    "Prority": 14
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Pending Attendance",
    "Description": "Attendance Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Attendance&rtype=pendingattendance",
    "Prority": 15
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Pending Goals",
    "Description": "Goals Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=Goals%20Pending&rtype=goalspending",
    "Prority": 16
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Pending Profile",
    "Description": "Profile Pending",
    "Action": "OPENURL",
    "URL": "/kpireport?hname=NO%20Profile%20Pics&rtype=noprofileusers",
    "Prority": 17
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "View Memos",
    "Description": "View Memo",
    "Action": "OPENURL",
    "URL": "/allmemos",
    "Prority": 18
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Raise Memo",
    "Description": "Create Memo",
    "Action": "OPENURL",
    "URL": "/publishscreen?t=memo",
    "Prority": 19
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Approve Leaves",
    "Description": "Approve Leave,Approve Therapist Leave,Leave Approve,Therapist Leave approve,UnApprove Leave",
    "Action": "OPENURL",
    "URL": "/leaveapprovals",
    "Prority": 21
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "View Awards",
    "Description": "View Award",
    "Action": "OPENURL",
    "URL": "/allawards",
    "Prority": 22
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Profile",
    "Description": "My Profile,Update Profile",
    "Action": "OPENURL",
    "URL": "/profile",
    "Prority": 24
  },
  // {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Role": "senior",
  //     "Title": "Bank Details",
  //     "Description": "Update Bank Details,Update Bank",
  //     "Action": "OPENURL",
  //     "URL": "/bankdetails",
  //     "Prority": 25
  // },
  // {
  //     "Type": "EIC",
  //     "Category": "Creation",
  //     "Role": "senior",
  //     "Title": "PF Details",
  //     "Description": "Update PF Details,Update PF",
  //     "Action": "OPENURL",
  //     "URL": "/pfdetails",
  //     "Prority": 26
  // },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "senior",
    "Title": "Basic Details",
    "Description": "update basic details,update basic",
    "Action": "OPENURL",
    "URL": "/basicdetails",
    "Prority": 27
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Digital Therapy  Record in Cloud",
    "Description": "Digital Therapy",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=digital",
    "Prority": 50
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Environment you Would Love",
    "Description": "Environment",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=env",
    "Prority": 51
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Responsive Management",
    "Description": "Responsive",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=response",
    "Prority": 52
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Live Stream of Therapy",
    "Description": "Live Stream",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=live",
    "Prority": 53
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Patented Miracle System",
    "Description": "Patented Mirracle",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=patented",
    "Prority": 56
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Transparent  Therapies",
    "Description": "Transparent",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=transparent",
    "Prority": 57
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Most affordable Therapy Price",
    "Description": "Most Affordable",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=efford",
    "Prority": 58
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Goal Based Therapies",
    "Description": "Goal Based",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=goalbased",
    "Prority": 59
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Continual Feedback",
    "Description": "Continual",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=continual",
    "Prority": 60
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Certified Therapists",
    "Description": "Certified",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=certified",
    "Prority": 61
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "Overall Development",
    "Description": "Overall",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=overall",
    "Prority": 62
  },
  {
    "Type": "EIC",
    "Category": "Creation",
    "Role": "Boss,Therapist,Receptionist,Manager,BDC,NCC,Harvest,Owner,FranciseOwner,senior",
    "Title": "World class International",
    "Description": "World Class",
    "Action": "OPENURL",
    "URL": "/globalinnovation?type=world",
    "Prority": 63
  }
]


export const reasonsByRating = {
  1: [
    "Unclear goal",
    "Not child-focused",
    "Too advanced",
    "No measurable outcome",
    "Irrelevant goal",
    "Poor structure",
    "Doesn't fit concerns",
    "Not evidence-based",
    "No timeline",
  ],
  2: [
    "Partly relevant",
    "Too vague",
    "Outcomes unclear",
    "Hard to track",
    "Needs detail",
    "Misses key areas",
    "Timeline issues",
    "Lacks focus",
    "Limited benefits",
  ],
  3: [
    "Meets basics",
    "Moderately relevant",
    "Some outcomes defined",
    "Reasonable timeline",
    "Needs clarity",
    "Partly evidence-based",
    "Covers essentials",
    "Better structure needed",
    "Implementation unclear",
  ],
  4: [
    "Relevant goal",
    "Realistic & achievable",
    "Addresses concerns",
    "Clear outcomes",
    "Evidence-based",
    "Good timeline",
    "Focus on key areas",
    "Clear steps",
    "Covers most needs",
  ],
  5: [
    "Clear & realistic",
    "Highly relevant",
    "Fully evidence-based",
    "Well-structured",
    "Addresses all areas",
    "Meets expectations",
    "Good timelines",
    "Detailed steps",
    "Perfectly measurable",
  ],
};

export const goalReasons = {
  1: [
    "Above Kids Ability Currently",
    "Irrelevant for Kid",
    "Kid Isn’t Ready for this goal yet.",
    "Goal is too easy for kid",
    "Goal is too simple",
    "Goal / Given Achievement Criteria are wrong."
  ],
  2: [
    "Above Kids Ability Currently",
    "Irrelevant for Kid",
    "Kid Isn’t Ready for this goal yet.",
    "Goal is too easy for kid",
    "Goal is too simple",
    "Goal / Given Achievement Criteria are wrong."
  ],
  3: [
    "Goal could be better",
    "Goal is not clear",
    "Goal is neither good nor bad",
    "More important goals can be given"
  ],
  4: [
    "Most Needed For Kid",
    "Excellent Goal"
  ],
  5: [
    "Most Needed For Kid",
    "Excellent Goal"
  ]
}


export const sessionReasons = {
  1: [
    "Above Kids Ability Currently",
    "Irrelevant for Kid",
    "Kid Isn’t Ready for this technique yet.",
    "Technique is too easy for kid",
    "Technique is too simple",
    "Technique / Given Criteria are wrong."
  ],
  2: [
    "Above Kids Ability Currently",
    "Irrelevant for Kid",
    "Kid Isn’t Ready for this technique yet.",
    "Technique is too easy for kid",
    "Technique is too simple",
    "Technique / Given Criteria are wrong."
  ],
  3: [
    "Technique could be better",
    "Technique is not clear",
    "Technique is neither good nor bad",
    "More important techniques can be given"
  ],
  4: [
    "Most Needed For Kid",
    "Excellent Technique"
  ],
  5: [
    "Most Needed For Kid",
    "Excellent Technique"
  ],
  6: [
    "Highest Priority Technique",
    "Immediate Need"
  ]
}


function getMatchedTerm(actionsData, sTerm) {
  return actionsData.filter(f => ((f.Title && f.Title.toUpperCase() == sTerm.toUpperCase()) || (f.Description && f.Description.toUpperCase().split(",").indexOf(sTerm.toUpperCase()) > -1)));
}

export function getTitlesFromTitleandDescription(actionsData) {
  return ([].concat.apply([], actionsData.map(f => [(f.Title || "").toUpperCase(), ...(f.Description || "").toUpperCase().split(",")]))).filter(f => f)
}


export function HandleActions(sTerm, role, isNotfromSearch, user) {

  if (!sTerm || !role) {
    return null;
  }

  sTerm = (sTerm || "").toUpperCase();
  role = (role || "").toUpperCase();


  var actionsData = (PinnacleSubCategories.filter(f => f.Type && f.Type == 'EIC' && (f.Role && f.Role.toUpperCase().split(",").map(t => t.trim()).indexOf(role) > -1)) || []);




  var actions = getMatchedTerm(actionsData, sTerm);




  if (null == actions || actions.length == 0) {

    var terms = getTitlesFromTitleandDescription(actionsData);

    var actionTerm = PinnacleNLPProcess(sTerm.toUpperCase(), terms)

    if (actionTerm) {
      actions = getMatchedTerm(actionsData, actionTerm);
    }
    //PinnacleSubCategories.sle
    // PinnacleNLPProcess
  }


  if (isNotfromSearch && (!actions || actions.length == 0)) {

    window.historyInstance.push('autismgpt?q=' + sTerm.toLowerCase());
  }
  else if (actions && actions.length == 1) {

    var url = actions[0].URL;
    if (url && url.indexOf('api.whatsapp.com') > -1) {
      url = url.replace('#NAME#', user ? user.Name : "").replace('#ID#', user ? user.Code ? user.Code : user.Id : "");
      window.location.href = url;
    }
    if (url && url.indexOf('tel:') > -1) {
      window.location.href = url;
    }
    else {
      window.historyInstance.push(actions[0].URL);
    }
    SaveHelloPinnacleExceptionToSentry("HandleAction", sTerm + ",Handle Actions," + actions.length + "," + role + "," + user.Handle, "HELLOPINNACLE", role, "HELLOPINNACLE");
  }
  return actions;
}


export function GetEISubCategories(role, category, centerid, pid) {

  var values = PinnacleSubCategories.filter(t => (t.Type && t.Type == "EI") && (t.Role == 'All' || (t.Role && t.Role.toLowerCase().indexOf(role.toLowerCase()) > -1)) && t.Category.toLowerCase() == category.toLowerCase());
  if (!values || values.length == 0) {
    return [];
  }
  switch (category.toLowerCase()) {
    case "eicenter":

      values.forEach(function (m) { m.URL = m.URL.replace("#CENTERID#", centerid) });

      break;
    case "eiparent":

      values.forEach(function (m) { m.URL = m.URL.replace("#CENTERID#", centerid).replace("#PARENTID#", pid) });

      break;
    case "eitherapist":

      values.forEach(function (m) { m.URL = m.URL.replace("#CENTERID#", centerid).replace("#PARENTID#", pid) });

      break;
    default:
      break;


  }

  console.log(values);
  return values;

}

export function GetAllCreations(role) {

  try {
    console.log("GET CATEGORIES INFORMATION");

    var values = role && role.toUpperCase() == "BOSS" ? BossCreationsURL : AllCreationsURL.filter(t => t.Roles == 'All' || t.Roles.toLowerCase().indexOf(role.toLowerCase()) > -1);

    return values;

  }
  catch (e) {
    console.log("GetAllCreations", e)
  }
}

export function GetPinnacleCategories(role) {

  try {
    console.log("GET CATEGORIES INFORMATION");

    var values = PinnacleCategories.filter(t => t.Roles == 'All' || t.Roles.toLowerCase().indexOf(role.toLowerCase()) > -1);

    return values;

  }
  catch (e) {
    console.log("GetCategories", e)
  }
}

export function GetPinnacleEIHelp(role) {

  try {
    console.log("GetPinnacleEIHelp INFORMATION");

    var values = PinnacleSubCategories.filter(t => (t.Type && (t.Type == 'EIH' || t.Type == 'EIC')) && t.Role && (t.Role == 'All' || t.Role.toLowerCase().indexOf(role.toLowerCase()) > -1));

    return values;

  }
  catch (e) {
    console.log("GetPinnacleEIHelp", e)
  }
}

export function GetPinnacleHelpHints(role) {

  var toReturn = [];
  try {
    var allHelps = GetPinnacleEIHelp(role);

    var creations = allHelps.filter(t => t.Type == 'EIC' && t.Prority != 9999);
    toReturn.push(...creations);

    var ei = allHelps.filter(t => t.Type == 'EIH');
    toReturn.push(...ei);

    var creationsLast = allHelps.filter(t => t.Type == 'EIC' && t.Prority == 9999);
    toReturn.push(...creationsLast);

    var categories = GetPinnacleCategories(role);

    $.each(categories, function (key, val) {
      var currentSubCat = GetPinnacleSubCategories(role, val.Title)
      var allsubs = currentSubCat && currentSubCat.length > 0 ? currentSubCat.map(t => t.Title) : [];
      var allSubsSrting = allsubs && allsubs.length > 0 ? allsubs.join(", ") : '';
      val.Description = val.Description ? val.Description : allSubsSrting;
      // val.Type = 'Feature';
    });
    toReturn.push(...categories);
  }
  catch (e) {
    console.log(e)
  }

  return toReturn;

}

export function GetPinnacleSubCategories(role, category) {

  try {
    console.log("GetPinnacleSubCategories");

    var values = PinnacleSubCategories.filter(t => (!t.Type || (t.Type != "EI" && t.Type != "EIH" && t.Type != "EIC")) && (t.Role == 'All' || (t.Role && t.Role.toLowerCase().indexOf(role.toLowerCase()) > -1)) && t.Category.toLowerCase() == category.toLowerCase());

    return values;

  }
  catch (e) {
    console.log("GetPinnacleSubCategories", e)
  }
}

export function GetAllPinnacleSubCategories(role) {

  try {
    console.log("GetAllPinnacleSubCategories");

    var values = PinnacleSubCategories.filter(t => (!t.Type || (t.Type != "EI" && t.Type != "EIH" && t.Type != "EIC")) && (t.Role == 'All' || (t.Role && t.Role.toLowerCase().indexOf(role.toLowerCase()) > -1)));

    return values;

  }
  catch (e) {
    console.log("GetAllPinnacleSubCategories", e)
  }
}

export function GetPinnacleSubCategoriesByRole(role) {

  try {
    console.log("GetPinnacleSubCategoriesByRole");

    var values = PinnacleSubCategories.filter(t => (!t.Type || (t.Type != "EI" && t.Type != "EIH" && t.Type != "EIC")) && (t.Role == 'All' || (t.Role && t.Role.toLowerCase().indexOf(role.toLowerCase()) > -1)));

    return values;

  }
  catch (e) {
    console.log("GetPinnacleSubCategoriesByRole", e)
  }
}

//PinnacleSubCategories
export function GetPinnacleCategoryByName(name) {

  try {
    console.log("GetPinnacleCategoryByName");

    var values = PinnacleCategories.filter(t => t.Title.toLowerCase() == name.toLowerCase());

    return values && values.length > 0 ? values[0] : null;

  }
  catch (e) {
    console.log("GetCategories", e)
  }
}

export const PinnacleKPIUseCases = [
  {
    "Id": "dueoverdue",
    "Title": "OverDue ",
    "Math": "All Pending Payments which are not met ETA",
    "UseCases": "→ Admins, Leadership to know all fee which are missed day of clearance.<br\/>\n→ Pinnacle AI to remind Admins , Leadership about Overdue"
  },
  {
    "Id": "due",
    "Title": "All",
    "Math": "All Pending Payments which are having ETA ",
    "UseCases": "→ Admins, Leadership to know all fee which needs to be cleared by when.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about fee clearance"
  },
  {
    "Id": "duetoday",
    "Title": "Today",
    "Math": "All Pending Payments with today's ETA ",
    "UseCases": "→ Admins, Leadership to know all fee which are clearing today.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of today."
  },
  {
    "Id": "duetomorrow",
    "Title": "Tomorrow",
    "Math": "All Pending Payments with tomorrow's ETA ",
    "UseCases": "→ Admins, Leadership to know all fee which are clearing tomorrow.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of tomrrow."
  },
  {
    "Id": "etapending",
    "Title": "Pending",
    "Math": "All Pending Payments with out ETA",
    "UseCases": "→ Admins, Leadership to know all fee clearing date<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership to clear fee."
  },
  {
    "Id": "duethisweek",
    "Title": "This Week",
    "Math": "All Pending Payments where ETA is This Week and Not today and tomorrow",
    "UseCases": "→ Admins, Leadership to know all fee which are clearing this week.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of this week."
  },
  {
    "Id": "duenextweek",
    "Title": "Next Week ",
    "Math": "All Pending Payments where ETA is Next Week",
    "UseCases": "→ Admins, Leadership to know all fee which are clearing next week.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of next week."
  },
  {
    "Id": "duethismonth",
    "Title": "This Month",
    "Math": "All Pending Payments which are having this month ETA and greater than next week",
    "UseCases": "→ Admins, Leadership to know all fee which are clearing this month.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of this month."
  },
  {
    "Id": "duenextmonth",
    "Title": "Next Month",
    "Math": "All Pending Payments with next month ETA",
    "UseCases": "→ Admins, Leadership to know all fee which are clearing next month.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of next month."
  },
  {
    "Id": "duefuture",
    "Title": "Future",
    "Math": "All Pending Payments with ETA greaterthan next month",
    "UseCases": "→ Admins, Leadership to know all fee which are clearing after next month.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of after next month."
  },
  {
    "Id": "Achievements",
    "Title": "Achievements"
  },
  {
    "Id": "WalkIns",
    "Title": "Walkins",
    "Math": "All Walkins Marked in Pinnacle",
    "UseCases": "→ Admins, Leadership to know all walkins happened in current month.<br/>\r\n→ Pinnacle AI to remind Admin manger for Walkings."
  },
  {
    "Id": "Additions",
    "Title": "Additions",
    "Math": "All new services added in Current month",
    "UseCases": "→ Admins, Leadership to know all sevices added in current month.<br/>\r\n"
  },
  {
    "Id": "InActive",
    "Title": "Inactive",
    "Math": "All services Closed in current month",
    "UseCases": "→ Admins, Leadership to know all sevices added in current month.<br/>\r\n→ Pinnacle AI to conduct inactivation root cause\r\n→ Harvest to monitor uneven and high number of inactivations"
  },
  {
    "Id": "Therapies",
    "Title": "Therapies",
    "Math": "total number of therapies session provided in current month",
    "UseCases": "→ Admins, Leadership to know all sevices provided in current month.<br/>\r\n→ Therapist to know all sevices provided by them in current month.<br/>"
  },
  {
    "Id": "Credits",
    "Title": "Credits",
    "Math": "count of all future invoices",
    "UseCases": "→ Admins, Leadership to know all the future credits to be fullfilled<br/>\r\n→ Parents to know their Credits remaining"
  },
  {
    "Id": "Rating",
    "Title": "Rating",
    "Math": "Average Rating recieved from Parents",
    "UseCases": "→ Admins, Leadership to know all the ratings recieved<br/>\r\n→ Therapist to know their performance based on rating"
  },
  {
    "Id": "Recommend",
    "Title": "Recomendations",
    "Math": "Total number of feedbacks recieved from parents",
    "UseCases": "→ Admins, Leadership to know all recommendations recieved<br/>\r\n→ Therapist to know their performance based on reccomendations"
  },
  {
    "Id": "Goals",
    "Title": "Goals",
    "Math": "Total number of Goals Set in current month",
    "UseCases": "→ Admins, Leadership to know all Goals set in current month.<br/>\r\n→ Therapist to know all Goals set by them in current month.<br/>"
  },
  {
    "Id": "Awards",
    "Title": "Awards",
    "Math": "Total number of awards achieved in current month",
    "UseCases": "→ Admins, Leadership to know all Awards Issued current month.<br/>\r\n→ Therapist to know all Awards received by them in current month.<br/>"
  },
  {
    "Id": "Mirracles",
    "Title": "Mirracles",
    "Math": "Total number of mirracles recorded in current month",
    "UseCases": "→ Admins, Leadership to know all mirracles recorded current month.<br/>\r\n→ Therapist to know all mirracles contributed by them in current month.<br/>"
  },
  {
    "Id": "Courses",
    "Title": "Courses",
    "Math": "Total number of courses recorded in current month",
    "UseCases": "→ Admins, Leadership to know all courses completed in current month.<br/>\r\n→ Therapist to know courses completed by them in current month.<br/>"
  },
  {
    "Id": "Tantrums",
    "Title": "Tantrumns",
    "Math": "Total number of Tantrums recorded in current month",
    "UseCases": "→ Admins, Leadership to know all tantrums completed in current month.<br/>\r\n→ Therapist to know tantrums completed by them in current month.<br/>"
  },
  {
    "Id": "Conditions",
    "Title": "Conditios",
    "Math": "Total number of Conditions recorded in current month",
    "UseCases": "→ Admins, Leadership to know all conditions completed in current month.<br/>\r\n→ Therapist to know conditions completed by them in current month.<br/>"
  },
  {
    "Id": "pollinatebytherapy",
    "Title": "Pollination",
    "Math": "All services which are not being availed by Kid",
    "UseCases": "→ Therapist, Admins, Leadership to know all the pollination opportunity in kids empoerment. <br/>\r\n→ Harvest to know the opprtunities where therapists can be part of Kids empowerment."
  },
  {
    "Id": "paymentpending",
    "Title": "Payment",
    "Math": "All Fee Pending which are availed and raised in this month.",
    "UseCases": "→ Admins, Leadership to know all fee pending in the current month<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about fee pending in this month"
  },
  {
    "Id": "pendingleads",
    "Title": "Leads",
    "Math": "Total active leads which are need to be followed up on or before today",
    "UseCases": "→ Admins, Leadership to know ongoing leads <br/>\r\n→ Pinnacle AI to remind Admins and Leadership about Leads to be followed up"
  },
  {
    "Id": "goalsnotsetnew",
    "Title": "Not Set",
    "Math": "There is no active goal for ongoing service",
    "UseCases": "→ Therapists, Admins, Leadership to know who are not being part of kids empowerment <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about goals not set."
  },
  {
    "Id": "pendingattendance",
    "Title": "Attendance",
    "Math": "Total attendances to be given",
    "UseCases": "→ Therapists, Admins, Leadership to know all pending attendances in current month <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about pending attendances."
  },
  {
    "Id": "Conditions",
    "Title": "Available",
    "Math": "Total Sessions availble based on therapist slots",
    "UseCases": "→ Therapists, Admins, Leadership to know available slots<br/>\r\n→ Therapist to know available slots in current month."
  },
  {
    "Id": "newpayments",
    "Title": "Adv. Pending",
    "Math": "Total advance fees to be collected",
    "UseCases": "→ Admins, Leadership to know all advance pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all Adv Fee Clearance."
  },
  {
    "Id": "assessmentpending",
    "Title": "Assessements",
    "Math": "Total Assessments to be completed",
    "UseCases": "→ Therapist, Admins, Leadership to know all therapy Assessments in kids empowerment. <br/>\r\n→"
  },
  {
    "Id": "goalspending",
    "Title": "Goals",
    "Math": "Total Goals to be reviewed",
    "UseCases": "→ Therapist, Admins, Leadership to know all goal reviews. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goal reviews."
  },
  {
    "Id": "compospending",
    "Title": "Compos",
    "Math": "Total Componsations to be provided",
    "UseCases": "→ Therapist, Admins, Leadership to know compensation provided in this month. <br/>\r\n→ Pinnacle AI to remind Parents,Therapists, Admins , Leadership about all compensations."
  },
  {
    "Id": "leavespending",
    "Title": "Leaves",
    "Math": "Total Leaves pending for approval",
    "UseCases": "→ Therapist, Admins, Leadership to know all leaves approval pending <br/>\r\n→ Pinnacle AI to remind Therapists, Admins about all leaves approval pendings."
  },
  {
    "Id": "servicerequestpending",
    "Title": "SR",
    "Math": "Total Service Request to be resolved",
    "UseCases": "→ Therapist, Admins, Leadership to know all service requests pending <br/>\r\n"
  },
  {
    "Id": "WHI",
    "Title": "WHI",
    "Math": "Total number of WHI responses yet to be given",
    "UseCases": "→ Admins, Leadership to know all WHI pending responses in current month.<br/>\r\n→ Therapist, Admins to know WHI pending responses by them in current month.<br/>"
  },
  {
    "Id": "CHI",
    "Title": "CHI",
    "Math": "Total number of CHI responses yet to be given",
    "UseCases": "→ Admins, Leadership to know all CHI pending responses in current month.<br/>\r\n→ Therapist, Admins to know CHI pending responses by them in current month.<br/>"
  },
  {
    "Id": "PISI",
    "Title": "PISI",
    "Math": "Total number of PISI responses yet to be given",
    "UseCases": "→ Admins, Leadership to know all PISI pending responses in current month.<br/>\r\n→ Therapist, Admins to know PISI pending responses by them in current month.<br/>"
  },
  {
    "Id": "Courses",
    "Title": "Courses",
    "Math": "Total number of Courses to be completed",
    "UseCases": "→ Admins, Leadership to know all tantrums completed.<br/>\r\n→ Therapist to know tantrums completed by them.<br/>"
  },
  {
    "Id": "mirraclepending",
    "Title": "Mirracles",
    "Math": "Total number of Mirracles Assigned to be recorded",
    "UseCases": "→ Admins, Leadership to know allmirracles pending to be recorded.<br/>\r\n→ Therapist to know all mirracles pending for recording<br/>"
  },
  {
    "Id": "renewalclarityoverdue",
    "Title": "OverDue",
    "Math": "All Pending Renewals which are not met ETA",
    "UseCases": "→ Admins, Leadership to know all Renewals which are missed day of clearance.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about Overdue Renewals"
  },
  {
    "Id": "renewalclarityall",
    "Title": "All",
    "Math": "All Pending Renewals which are having ETA",
    "UseCases": "→ Admins, Leadership to know all Renewals which needs to be cleared by when.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals clearance"
  },
  {
    "Id": "renewalclaritytoday",
    "Title": "Today",
    "Math": "All Pending Renewals with today's ETA",
    "UseCases": "→ Admins, Leadership to know all Renewals which are clearing today.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of today."
  },
  {
    "Id": "renewalclaritytomorrow",
    "Title": "Tomorrow",
    "Math": "All Pending Renewals with tomorrow's ETA",
    "UseCases": "→ Admins, Leadership to know all Renewals which are clearing tomorrow.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of tomrrow."
  },
  {
    "Id": "renewalclaritypending",
    "Title": "Pending",
    "Math": "All Pending Renewals with out ETA",
    "UseCases": "→ Admins, Leadership to know all Renewals clearing date<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership to clear Renewals."
  },
  {
    "Id": "renewalclaritythisweek",
    "Title": "This Week",
    "Math": "All Pending Renewals where ETA is This Week and Not today and tomorrow",
    "UseCases": "→ Admins, Leadership to know all Renewals which are clearing this week.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of this week."
  },
  {
    "Id": "renewalclaritynextweek",
    "Title": "Next Week",
    "Math": "All Pending Renewals where ETA is Next Week",
    "UseCases": "→ Admins, Leadership to know all Renewals which are clearing next week.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of next week."
  },
  {
    "Id": "renewalclaritythismonth",
    "Title": "This Month",
    "Math": "All Pending Renewals which are having this month ETA and greater than next week",
    "UseCases": "→ Admins, Leadership to know all Renewals which are clearing this month.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of this month."
  },
  {
    "Id": "renewalclaritynextmonth",
    "Title": "Next Month",
    "Math": "All Pending Renewals with next month ETA",
    "UseCases": "→ Admins, Leadership to know all Renewals which are clearing next month.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of next month."
  },
  {
    "Id": "renewalclarityothers",
    "Title": "Future",
    "Math": "All Pending Renewals with ETA greaterthan next month",
    "UseCases": "→ Admins, Leadership to know all Renewals which are clearing after next month.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of after next month."
  },
  {
    "Id": "renewalclarityrenewed",
    "Title": "Renewed",
    "Math": "All Renewed kids for next month",
    "UseCases": "→ Admins, Leadership to know all Renewed kids for next month.<br/>\r\n→ Therapist,Admins,Leadership to know Renewals completed for next month.<br/>"
  },
  {
    "Id": "activestaff",
    "Title": "Active Staff",
    "Math": "All Active Staff",
    "UseCases": "→ Admins, Leadership to know all active staff.<br/>\r\n→ Pinnacle AI to remind how many staff are available.<br/>"
  },
  {
    "Id": "addedstaff",
    "Title": "Added Staff",
    "Math": "Newly Added Staff",
    "UseCases": "→ Admins, Leadership to know all newly added staff.<br/>\r\n→ Pinnacle AI to remind how many co-wrokers joined this month.<br/>"
  },
  {
    "Id": "leftstaff",
    "Title": "Left Staff",
    "Math": "All Left Staff",
    "UseCases": "→ Admins, Leadership to know all about left staff.<br/>\r\n→ Pinnacle AI to remind how many co-wrokers left.<br/>"
  },
  {
    "Id": "activeparents",
    "Title": "Active Parents",
    "Math": "All Active Parents Taking Services",
    "UseCases": "→ Admins, Leadership to know active parents Having active services.<br/>\r\n→ Pinnacle AI to remind how many kids Taking services Currently.<br/>"
  },
  {
    "Id": "addedparents",
    "Title": "Added Parents",
    "Math": "All Parents whose are Joined this month",
    "UseCases": "→ Admins, Leadership to know all about parents added this month.<br/>\r\n→ Pinnacle AI to remind parents added this month.<br/>"
  },
  {
    "Id": "activememos",
    "Title": "Active Memos",
    "Math": "All Active Memos this month",
    "UseCases": "→ Admins, Leadership to know all about active memos.<br/>\r\n→ Pinnacle AI to remind Remaning active memos this month.<br/>"
  },
  {
    "Id": "pendingmemos",
    "Title": "Pending Memos",
    "Math": "All Pending Memos this month",
    "UseCases": "→ Admins, Leadership to know all about pending memos.<br/>\r\n→ Pinnacle AI to remind Remaning pending memos this month.<br/>"
  },
  {
    "Id": "closedmemos",
    "Title": "Closes Memos",
    "Math": "All closed memos this month",
    "UseCases": "→ Admins, Leadership to know all about closed memos.<br/>\r\n→ Pinnacle AI to remind closed memos this month.<br/>"
  },
  {
    "Id": "awards",
    "Title": "Awards",
    "Math": "All Awards Raised this month",
    "UseCases": "→ Admins, Leadership to know all awards for this month.<br/>\r\n→ Pinnacle AI to remind awards issued this month.<br/>"
  },
  {
    "Id": "viewpayslips",
    "Title": "View Paylsip",
    "Math": "All paylip viewed this month",
    "UseCases": "→ Admins, Leadership to know all viewed payslips this month.<br/>\r\n→ Pinnacle AI to remind Co-worker who viewed his paylsip for this month.<br/>"
  },
  {
    "Id": "downloadpayslips",
    "Title": "Download Payslip",
    "Math": "All Payslips downloaded this month",
    "UseCases": "→ Admins, Leadership to know all paylsips downloaded this month.<br/>\r\n→ Pinnacle AI to remind Co-worker who downloaded his paylsip for this month<br/>"
  },
  {
    "Id": "pinnacleclaritypending",
    "Title": "Clarity Pending",
    "Math": "All Clarity pendings Remains",
    "UseCases": "→ Leadership to know all Pending Responses given by Co-Worker.<br/>\r\n→ Pinnacle AI to remind Co-worker who not Clarify the Leader doubts.<br/>"
  },
  {
    "Id": "renewalclaritytoberenewed",
    "Title": "To Be Renewed",
    "Math": "All Kids To be Renewed",
    "UseCases": "→ Admin,receptionist, Leadership to know all Pending Renewels to be Renewed.<br/>\r\n→ Pinnacle AI to remind kids to be Renewed.<br/>"
  },
  {
    "Id": "leaverequestnonparent",
    "Title": "Total Staff Leaves",
    "Math": "All Staff Leaves Applied this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all Staff Leaves Applied this month.<br/>\r\n→ Pinnacle AI to remind Staff who are applied leave this month.<br/>"
  },
  {
    "Id": "leaverequestcomposlt4",
    "Title": "< 4 compos",
    "Math": "All Compensations booked along with leave request",
    "UseCases": "→ Admin,receptionist, Leadership to know all Compensations booked along with leave request this month.<br/>\r\n→ Pinnacle AI to remind what compensations are booked this month.<br/>"
  },
  {
    "Id": "leaveapprovalpending",
    "Title": "Approval Pending",
    "Math": "All Leave Approval pendings",
    "UseCases": "→ Admin,receptionist, Leadership to know all Pending Leave Approvals for this month.<br/>\r\n→ Pinnacle AI to remind what are the pending leaves to be approved.<br/>"
  },
  {
    "Id": "leaverequestanalytic",
    "Title": "Approved",
    "Math": "All Approved leaves this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all Approved leaves for this month.<br/>\r\n→ Pinnacle AI to remind who have approved leaves for this month.<br/>"
  },
  {
    "Id": "leaverequestanalyticunapproved",
    "Title": "Unapproved",
    "Math": "All Unapproved leaves this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all Unapproved leaves for this month.<br/>\r\n→ Pinnacle AI to remind who have Unapproved leaves for this month.<br/>"
  },
  {
    "Id": "leaverequestnonparentfuture",
    "Title": "Future",
    "Math": "All Future leaves for this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all Future Leaves for this month.<br/>\r\n→ Pinnacle AI to remind who have future leaves.<br/>"
  },
  {
    "Id": "leaverequestnonparentcompleted",
    "Title": "Completed",
    "Math": "All Leaves Completed this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all Completed Leaves this month.<br/>\r\n→ Pinnacle AI to remind who completed their leaves this month.<br/>"
  },
  {
    "Id": "leaverequestnonparentcanceled",
    "Title": "Canceled",
    "Math": "All Canceled Leaves for this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all Canceled leaves for this month.<br/>\r\n→ Pinnacle AI to remind Who canceled their leaves for this month.<br/>"
  },
  {
    "Id": "leaverequestparent",
    "Title": "Total Parent Leaves",
    "Math": "All Parent Leave for this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all parent leaves applied for this month.<br/>\r\n→ Pinnacle AI to remind kids who not present on particular day.<br/>"
  },
  {
    "Id": "leaverequestparentcompleted",
    "Title": "Completed",
    "Math": "All Parent Leave Completed for this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all parent completed leaves for this month.<br/>\r\n→ Pinnacle AI to remind parents who already completed their leaves.<br/>"
  },
  {
    "Id": "leaverequestparentfuture",
    "Title": "Future",
    "Math": "All Parent Leave for future",
    "UseCases": "→ Admin,receptionist, Leadership to know all parent leaves applied for future.<br/>\r\n→ Pinnacle AI to remind kids who not present on future.<br/>"
  },
  {
    "Id": "leaverequestparentcanceled",
    "Title": "Cancelled",
    "Math": "All Parent Leave Cancelled this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all parent cancelled leaves for this month.<br/>\r\n→ Pinnacle AI to remind parents who cancelled their leaves for this month.<br/>"
  },
  {
    "Id": "assessmentall",
    "Title": "Total",
    "Math": "All Assessments for this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all assessments for this month.<br/>\r\n→ Pinnacle AI to remind kids who having assessments for this month.<br/>"
  },
  {
    "Id": "assessmentcompleted",
    "Title": "Completed",
    "Math": "All Completed this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all completed this month.<br/>\r\n→ Pinnacle AI to remind assessments completed this month.<br/>"
  },
  {
    "Id": "assessmentpending",
    "Title": "Pending",
    "Math": "All Assessments Pending for this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all assessments pending for this month.<br/>\r\n→ Pinnacle AI to remind pending assessment for this month.<br/>"
  },
  {
    "Id": "assessmentsfee",
    "Title": "Fee",
    "Math": "OverAll Assessment Fee for this month",
    "UseCases": "→ Admin,receptionist, Leadership to know Total assessment fee for this month.<br/>\r\n→ Pinnacle AI to remind overall assessment fee.<br/>"
  },
  {
    "Id": "totalservices",
    "Title": "Total",
    "Math": "All Services Taking",
    "UseCases": "→ Admin,receptionist, Leadership to know overall services.<br/>\r\n→ Pinnacle AI to remind taotal services.<br/>"
  },
  {
    "Id": "activeservices",
    "Title": "Active",
    "Math": "Total Active Services For this month",
    "UseCases": "→ Admin,receptionist, Leadership to know all active services for this month.<br/>\r\n→ Pinnacle AI to remind who taking services this month.<br/>"
  },
  {
    "Id": "futureservices",
    "Title": "Future",
    "Math": "All Future Services",
    "UseCases": "→ Admin,receptionist, Leadership to know all about future services.<br/>\r\n→ Pinnacle AI to remind upcoming services.<br/>"
  },
  {
    "Id": "inactiveservices",
    "Title": "Closed",
    "Math": "All Closed Services this month",
    "UseCases": "→ Admin,receptionist, Leadership to know closed services this month.<br/>\r\n→ Pinnacle AI to remind How many closed services this month.<br/>"
  },
  {
    "Id": "newservices",
    "Title": "New",
    "Math": "All New Services added with in the month",
    "UseCases": "→ Admin,receptionist, Leadership to know Newly Added services this month.<br/>\r\n→ Pinnacle AI to remind how many services added newly in this month.<br/>"
  },
  {
    "Id": "newservicesst",
    "Title": "ST",
    "Math": "All New ST Services added with in the month",
    "UseCases": "→ Admin,receptionist, Leadership to know Newly Added ST services this month.<br/>\r\n→ Pinnacle AI to remind how many ST services added newly in this month.<br/>"
  },
  {
    "Id": "newservicesot",
    "Title": "OT",
    "Math": "All New OT Services added with in the month",
    "UseCases": "→ Admin,receptionist, Leadership to know Newly Added OT services this month.<br/>\r\n→ Pinnacle AI to remind how many OT services added newly in this month.<br/>"
  },
  {
    "Id": "newservicesbt",
    "Title": "BT",
    "Math": "All New BT Services added with in the month",
    "UseCases": "→ Admin,receptionist, Leadership to know Newly Added BT services this month.<br/>\r\n→ Pinnacle AI to remind how many BT services added newly in this month.<br/>"
  },
  {
    "Id": "newservicesse",
    "Title": "SE",
    "Math": "All New SE Services added with in the month",
    "UseCases": "→ Admin,receptionist, Leadership to know Newly Added SE services this month.<br/>\r\n→ Pinnacle AI to remind how many SE services added newly in this month.<br/>"
  },
  {
    "Id": "inactivecausepending",
    "Title": "Inactivation  Cause",
    "Math": "All Inactivation Root Causes",
    "UseCases": "→ Admin,receptionist, Leadership to know about cause of inactivated service.<br/>\r\n→ Pinnacle AI to remind what is the root cause behind the Inactivation.<br/>"
  },
  {
    "Id": "coursescompleted",
    "Math": "All Courses Completed",
    "UseCases": "→ Admins, Leadership to know all courses completed.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all courses.",
    "Title": "Courses Completed"
  },
  {
    "Id": "coursespending",
    "Math": "All Courses Pending",
    "UseCases": "→ Admins, Leadership to know all courses pending.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all courses pending.",
    "Title": "Courses Pending"
  },
  {
    "Id": "mirraclesnotcovered",
    "Math": "All Mirracles not covered",
    "UseCases": "→ Admins, Leadership to know all mirracles not covered.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles not covered.",
    "Title": "Languages Not covered"
  },
  {
    "Id": "mirracleslc",
    "Math": "All Mirracles Languages covered",
    "UseCases": "→ Admins, Leadership to know all mirracles languages covered.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles languages covered.",
    "Title": "Languages Covered"
  },
  {
    "Id": "mirraclesbottom100",
    "Math": "All Bottom 100 Mirracles",
    "UseCases": "→ Admins, Leadership to know all bottom 100 mirracles.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all bottom 100 mirracles.",
    "Title": "Bottom 100"
  },
  {
    "Id": "mirraclestop100",
    "Math": "All Top 100 Mirracles",
    "UseCases": "→ Admins, Leadership to know all top 100 mirracles.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all top 100 mirracles..",
    "Title": "Top 100"
  },
  {
    "Id": "allmirraclesviews",
    "Math": "All views of Mirracles",
    "UseCases": "→ Admins, Leadership to know all mirracles views.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all views of mirracles.",
    "Title": "Views"
  },
  {
    "Id": "mirraclencontributed",
    "Math": "All Mirracles Not Contributed",
    "UseCases": "→ Admins, Leadership to know all mirracles which are not contributed.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles which are not contributed.",
    "Title": "Mirracles Not Contributed"
  },
  {
    "Id": "mirraclescontributed",
    "Math": "All Mirracles Contributed",
    "UseCases": "→ Admins, Leadership to know all mirracles contributed.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles contributed.",
    "Title": "Mirracles Contributed"
  },
  {
    "Id": "mirraclestotal",
    "Math": "All Total Mirracles",
    "UseCases": "→ Admins, Leadership to know all total mirracles.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all total mirracles.",
    "Title": "Total Mirracles"
  },
  {
    "Id": "dangpendingtoday",
    "Math": "All Dang Pending Today",
    "UseCases": "→ Leadership to know all today pending Dang.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all today pending Dang.",
    "Title": "Pending for Today"
  },
  {
    "Id": "dangoverallpending",
    "Math": "All Dang Overall Pending",
    "UseCases": "→ Leadership to know all overall pending Dang.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all overall pending Dang.",
    "Title": "Overall Pending"
  },
  {
    "Id": "dangdelayed",
    "Math": "All Dang Delayed",
    "UseCases": "→ Leadership to know all Dang delayed.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang delayed.",
    "Title": "Delayed"
  },
  {
    "Id": "dangontime",
    "Math": "All Dang Ontime",
    "UseCases": "→ Leadership to know all Dang ontime.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang ontime..",
    "Title": "Ontime"
  },
  {
    "Id": "dangunachieved",
    "Math": "All Dang Unachieved",
    "UseCases": "→ Leadership to know all Dang unachieved.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang unachieved.",
    "Title": "Unachieved"
  },
  {
    "Id": "dangachieved",
    "Math": "All Dang Achieved",
    "UseCases": "→ Leadership to know all Dang achieved.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang achieved.",
    "Title": "Achieved"
  },
  {
    "Id": "dangtotal",
    "Math": "All Dang Total",
    "UseCases": "→ Leadership to know all total Dang.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all total Dang.",
    "Title": "Total"
  },
  {
    "Id": "totalgoals",
    "Math": "All Total goals",
    "UseCases": "→ Therapists, Admins, Leadership to know all total goals<br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about all goals.",
    "Title": "Total"
  },
  {
    "Id": "activegoals",
    "Math": "All Active goals",
    "UseCases": "→ Therapists, Admins, Leadership to know all active goals<br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about all actove goals.",
    "Title": "Active"
  },
  {
    "Id": "goalspending",
    "Math": "All Pending goals",
    "UseCases": "→ Therapist, Admins, Leadership to know all pending goals. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all pending goals.",
    "Title": "Pending"
  },
  {
    "Id": "todaypendinggoals",
    "Math": "All Today Pending goals",
    "UseCases": "→ Therapist, Admins, Leadership to know all today goals pending. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all today goals pending.",
    "Title": "Today Pending"
  },
  {
    "Id": "goalsnotsetnew",
    "Math": "There is no active goal for ongoing service",
    "UseCases": "→ Therapists, Admins, Leadership to know who are not being part of kids empowerment <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about goals not set.",
    "Title": "Not Set"
  },
  {
    "Id": "goalreviewed",
    "Math": "Total Goals to be reviewed",
    "UseCases": "→ Therapist, Admins, Leadership to know all goal reviews. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goal reviews.",
    "Title": "Reviewed"
  },
  {
    "Id": "goalmet",
    "Math": "All Goals met",
    "UseCases": "→ Therapist, Admins, Leadership to know all goals met. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goals met.",
    "Title": "Met"
  },
  {
    "Id": "goalnotmet",
    "Math": "All Goals not met",
    "UseCases": "→ Therapist, Admins, Leadership to know all goals not met. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goals not met.",
    "Title": "Not Met"
  },
  {
    "Id": "composcancelled",
    "Math": "All Compos Cancelled",
    "UseCases": "→ Therapist, Admins, Leadership to know compensation cancelled in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all cancelled compensations.",
    "Title:": "Compos Cancelled"
  },
  {
    "Id": "composnotaccomplished",
    "Math": "All Compos not Accomplished",
    "UseCases": "→ Therapist, Admins, Leadership to know compensation not accomplished in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations not accomplished.",
    "Title:": "Compos Not Accomplished"
  },
  {
    "Id": "composfuture",
    "Math": "All Future Compos",
    "UseCases": "→ Therapist, Admins, Leadership to know Future compensation in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all Future compensations.",
    "Title": "Compos Future"
  },
  {
    "Id": "composgiven",
    "Math": "All Compos Given",
    "UseCases": "→ Therapist, Admins, Leadership to know compensation provided in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations.",
    "Title": "Compos Given"
  },
  {
    "Id": "totalcompos",
    "Math": "All Total Compos",
    "UseCases": "→ Therapist, Admins, Leadership to know total compensation in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations.",
    "Title": "Total Compos"
  },
  {
    "Id": "feedbacksgiven",
    "Math": "All Feedbacks Given",
    "UseCases": "→ Therapist, Admins, Leadership to know feedbacks given in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all feedbacks given.",
    "Title": "Parent Given"
  },
  {
    "Id": "homeworkpending",
    "Math": "All HomeWork Pending",
    "UseCases": "→ Therapist, Admins, Leadership to know homework pending in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all homework pending.",
    "Title": "Parent Pending"
  },
  {
    "Id": "compospending",
    "Math": "Total Componsations to be provided",
    "UseCases": "→ Therapist, Admins, Leadership to know compensation provided in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations.",
    "Title": "Pending Compos"
  },
  {
    "Id": "attendanceabsent",
    "Math": "Total Attendance Absent",
    "UseCases": "→ Therapist, Admins, Leadership to know attendances absent in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all attendances absent .",
    "Title": "Absent"
  },
  {
    "Id": "pendingattendance",
    "Math": "Total attendances to be given",
    "UseCases": "→ Therapists, Admins, Leadership to know all pending attendances in current month <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about pending attendances.",
    "Title": "Pending Attendance"
  },
  {
    "Id": "attendancepresent",
    "Math": "Total Attendence Present",
    "UseCases": "→ Therapist, Admins, Leadership to know attendances present in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all attendances present.",
    "Title": "Present"
  },
  {
    "Id": "totalattendance",
    "Math": "Total Attendance",
    "UseCases": "→ Therapist, Admins, Leadership to know all attendances in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all attendances.",
    "Title": "Total Attendance"
  },
  {
    "Id": "pollinationclaritypromised",
    "Title": "Promised",
    "Math": "All Promised Pollination",
    "UseCases": "→ Admins, Leadership to know all pollinations which are promised.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about promised pollinations."
  },
  {
    "Id": "pollinationclaritycompleted",
    "Title": "Completed",
    "Math": "Total Pollination Completed",
    "UseCases": "→ Admins, Leadership to know pollinations which are completed.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about total pollinations completed."
  },
  {
    "Id": "pollinationclarityyetto",
    "Title": "Yet To",
    "Math": "All Pollination Yet To",
    "UseCases": "→ Admins, Leadership to know pollinations yet to.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollination to be yet."
  },
  {
    "Id": "pollinationclarityzero",
    "Title": "Zero",
    "Math": "Zero Pollinations",
    "UseCases": "→ Admins, Leadership to know pollinations which are zero.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about zero pollinations."
  },
  {
    "Id": "pollinationclaritylessthanthree",
    "Title": "<3",
    "Math": "Pollinations Which are <3",
    "UseCases": "→ Admins, Leadership to know pollinations which are <3.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollinations which are <3."
  },
  {
    "Id": "pollinationclaritygreaterthanthree",
    "Title": ">=3",
    "Math": "Pollinations Which are >=3",
    "UseCases": "→ Admins, Leadership to know pollinations which are >=3.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollinations which are >=3."
  },
  {
    "Id": "pollinationopty",
    "Title": "Opty",
    "Math": "All Pollination Opty",
    "UseCases": "→ Admins, Leadership to know pollinations which are opty.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollinations which are opty."
  },
  {
    "Id": "pollinationoptyst",
    "Title": "ST",
    "Math": "Total ST Pollinations",
    "UseCases": "→ Admins, Leadership to know all speech therapy pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all speech therapy pollinations."
  },
  {
    "Id": "pollinationoptyot",
    "Title": "OT",
    "Math": "Total OT Pollinations",
    "UseCases": "→ Admins, Leadership to know all occupational therapy pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all occupational therapy pollinations."
  },
  {
    "Id": "pollinationoptyaba",
    "Title": "ABA",
    "Math": "Total ABA Pollinations",
    "UseCases": "→ Admins, Leadership to know all ABA therapy pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all ABA therapy pollinations."
  },
  {
    "Id": "pollinationoptyse",
    "Title": "SE",
    "Math": "Total SE Pollinations",
    "UseCases": "→ Admins, Leadership to know all special education pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all special education pollinations."
  }, {
    "Id": "totalleads",
    "Title": "Total",
    "Math": "Total Leads",
    "UseCases": "→ Admins, Leadership to know all total leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the total leads."
  },
  {
    "Id": "activeleadsnew",
    "Title": "Active",
    "Math": "All Active Leads",
    "UseCases": "→ Admins, Leadership to know all active leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all active leads."
  },
  {
    "Id": "pendingleads",
    "Title": "Pending",
    "Math": "All Pending Leads",
    "UseCases": "→ Admins, Leadership to know all about the all pending leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all pending leads."
  },
  {
    "Id": "newleadsnew",
    "Title": "New",
    "Math": "All New Leads",
    "UseCases": "→ Admins, Leadership to know all about thea all new leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all new leads."
  },
  {
    "Id": "closedleadsnew",
    "Title": "Closed",
    "Math": "All Closed Leads",
    "UseCases": "→ Admins, Leadership to know about the all closed leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all closed leads.."
  },
  {
    "Id": "walkinleads",
    "Title": "WalkIns",
    "Math": "Total WalkIn Leads",
    "UseCases": "→ Admins, Leadership to know about the total walkin leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the total walkin leads."
  },
  {
    "Id": "assessmentsleads",
    "Title": "Assessments",
    "Math": "All Assessments",
    "UseCases": "→ Admins, Leadership to know about the all assessments done .<br/>\r\n→ Pinnacle AI to remind Leadership,Admins the all assessments done."
  },
  {
    "Id": "admissionleads",
    "Title": "Addmissions",
    "Math": "All Admissions",
    "UseCases": "→ Admins, Leadership to know all about the admissions.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the admissions done."
  },
  {
    "Id": "joinedelsewhere",
    "Title": "ElseWhere",
    "Math": "All Admisions Joined Elsewhere",
    "UseCases": "→ Admins, Leadership to know all about the kids joined elsewhere.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the kids joined elsewhere."
  },
  {
    "Id": "servicerequest",
    "Title": "Total",
    "Math": "Total Service Requests",
    "UseCases": "→ Leadership to know all raised service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all service requests."
  },
  {
    "Id": "servicerequestactive",
    "Title": "Active",
    "Math": "All Active Service Requests",
    "UseCases": "→ Leadership to know all active service requests and resolved by in time.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all active requests."
  },
  {
    "Id": "servicerequestpending",
    "Title": "In Process",
    "Math": "All In Process Requests",
    "UseCases": "→ Leadership to know all service requests in process and resolved by in time.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all requests in process."
  },
  {
    "Id": "servicerequestwaiting",
    "Title": "Waiting",
    "Math": "All Waiting Requests",
    "UseCases": "→ Leadership to know all service requests in waiting and resolved by in time.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all requests in waiting process."
  },
  {
    "Id": "servicerequestresolved",
    "Title": "Resolved",
    "Math": "All Resolved Requests",
    "UseCases": "→ Leadership to know all service requests resolved.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all service requests resolved."
  },
  {
    "Id": "servicerequestreopened",
    "Title": "Reopen",
    "Math": "All Reopen Service Requests",
    "UseCases": "→ Leadership to know all service requests reopened.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all service requests reopened."
  },
  {
    "Id": "servicerequestrating5",
    "Title": 5,
    "Math": "All 5 * Service Requests",
    "UseCases": "→ Leadership to know all 5 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 5 * service requests."
  },
  {
    "Id": "servicerequestrating4",
    "Title": 4,
    "Math": "All 4 * Service Requests",
    "UseCases": "→ Leadership to know all 4 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 4 * service requests."
  },
  {
    "Id": "servicerequestrating3",
    "Title": 3,
    "Math": "All 3 * Service Requests",
    "UseCases": "→ Leadership to know all 3 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 3 * service requests."
  },
  {
    "Id": "servicerequestrating2",
    "Title": 2,
    "Math": "All 2 * Service Requests",
    "UseCases": "→ Leadership to know all 2 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 2 * service requests."
  },
  {
    "Id": "servicerequestrating1",
    "Title": 1,
    "Math": "All 1 * Service Requests",
    "UseCases": "→ Leadership to know all 1 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 1 * service requests."
  },
  {
    "Id": "profit",
    "Title": "Profit",
    "Math": "All Profits",
    "UseCases": "→ Leadership to know all Profits.<br/>\r\n"
  },
  {
    "Id": "business",
    "Title": "Business",
    "Math": "All Business",
    "UseCases": "→ Leadership to know all Business for current month.<br/>\r\n"
  },
  {
    "Id": "overallpending",
    "Title": "Pen. All",
    "Math": "All Pending",
    "UseCases": "→ Admins, Leadership to know all pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all pending Fee Clearance."
  },
  {
    "Id": "pastpending",
    "Title": "Pen. Past",
    "Math": "All Past Pending",
    "UseCases": "→ Admins, Leadership to know all past pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all past pending Fee Clearance."
  },
  {
    "Id": "paymentpending",
    "Title": "Pen. Month",
    "Math": "All Pending This Month",
    "UseCases": "→ Admins, Leadership to know all advance pending fee for current month .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all pending Fee Clearance for current month."
  },
  {
    "Id": "advancepending",
    "Title": "Pen. Adv",
    "Math": "All Advance Pending",
    "UseCases": "→ Admins, Leadership to know all advance pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all Adv Fee Clearance."
  },
  {
    "Id": "inflow",
    "Title": "In. All",
    "Math": "All Inflow",
    "UseCases": "→ Leadership to know all inflow for this month.<br/>\r\n"
  },
  {
    "Id": "pastpaid",
    "Title": "In. Past",
    "Math": "All Past Paid",
    "UseCases": "→ Leadership to know all past paid.<br/>\r\n"
  },
  {
    "Id": "paid",
    "Title": "In. Month",
    "Math": "All Paid",
    "UseCases": "→ Leadership to know all paid for thid current month.<br/>\r\n"
  },
  {
    "Id": "advancepaid",
    "Title": "In. Adv.",
    "Math": "All Advance Paid",
    "UseCases": "→ Leadership to know all Advance paid.<br/>\r\n"
  },
  {
    "Id": "outflowreport",
    "Title": "Out. All",
    "Math": "All Outflow Report",
    "UseCases": "→ Leadership to know all Outflow for current month.<br/>\r\n"
  },
  {
    "Id": "salary",
    "Title": "Out. Sal.",
    "Math": "All Salary",
    "UseCases": "→ Leadership to know all salaries for current month.<br/>\r\n"
  },
  {
    "Id": "fixedexpenses",
    "Title": "Out. Fix.",
    "Math": "All Fixed Expenses",
    "UseCases": "→ Leadership to know all fixed expenses.<br/>\r\n"
  },
  {
    "Id": "variableexpenses",
    "Title": "Out. Var",
    "Math": "All Variable Expenses",
    "UseCases": "→ Leadership to know all variable expenses.<br/>\r\n"
  },
  {
    "Id": "discountbusiness",
    "Title": "Discount",
    "Math": "All Discount Business",
    "UseCases": "→ Leadership to know all discount business.<br/>\r\n"
  },
  {
    "Id": "alreadypaid",
    "Title": "Adv. Cleared",
    "Math": "Already paid",
    "UseCases": "→ Leadership to know about already paid fee .<br/>\r\n"
  },
  {
    "Id": "tobefulfilled",
    "Title": "To-be fulfilled",
    "Math": "All To Be Fulfilled",
    "UseCases": "→ Leadership to know all to be fulfilled.<br/>\r\n"
  },
  {
    "Id": "expensesreport",
    "Title": "Expenses",
    "Math": "All Expenses Report",
    "UseCases": "→ Leadership to know all expenses spent for currenrt month.<br/>\r\n"
  },
  {
    "Id": "incentives",
    "Title": "Incentives",
    "Math": "All Incentives",
    "UseCases": "→ Leadership to know all incentives provided.<br/>\r\n"
  },
  {
    "Id": "benifits",
    "Title": "Benefits",
    "Math": "All Benifits",
    "UseCases": "→ Leadership to know all Benifits provoided.<br/>\r\n"
  }

]

export const IndianLanguages = [
  {
    "Lang": "Telugu",
    "Code": "te",
    "Name": "తెలుగు"
  },
  {
    "Lang": "Hindi",
    "Code": "hi",
    "Name": "हिन्दी"
  },
  {
    "Lang": "Tamil",
    "Code": "ta",
    "Name": "தமிழ்"
  },
  {
    "Lang": "Marathi",
    "Code": "mr",
    "Name": "मराठी"
  },
  {
    "Lang": "Kannada",
    "Code": "kn",
    "Name": "ಕನ್ನಡ"
  },
  {
    "Lang": "Malayalam",
    "Code": "ml",
    "Name": "മലയാളം"
  },
  {
    "Lang": "English",
    "Code": "en",
    "Name": "English"
  },
  {
    "Lang": "Sanskrit",
    "Code": "sa",
    "Name": "संस्कृतम्"
  },
  {
    "Lang": "Bengali",
    "Code": "bn",
    "Name": "বাংলা"
  },
  {
    "Lang": "Urdu",
    "Code": "ur",
    "Name": "اردو"
  },
  {
    "Lang": "Gujarati",
    "Code": "gu",
    "Name": "ગુજરાતી"
  },
  {
    "Lang": "Odia",
    "Code": "or",
    "Name": "ଓଡ଼ିଆ"
  },
  {
    "Lang": "Punjabi",
    "Code": "pa",
    "Name": "ਪੰਜਾਬੀ"
  },
  {
    "Lang": "Assamese",
    "Code": "as",
    "Name": "অসমীয়া"
  },
  {
    "Lang": "Maithili",
    "Code": "mai",
    "Name": "मैथिली"
  },
  {
    "Lang": "Bhojpuri",
    "Code": "bho",
    "Name": "भोजपुरी"
  },
  {
    "Lang": "Haryanvi",
    "Name": "हरियाणवी",
    "Code": ""
  },
  {
    "Lang": "Rajasthani",
    "Name": "राजस्थानी",
    "Code": ""
  },
  {
    "Lang": "Kashmiri",
    "Name": "کأشر",
    "Code": ""
  },
  {
    "Lang": "Nepali",
    "Code": "ne",
    "Name": "नेपाली"
  },
  {
    "Lang": "Sindhi",
    "Code": "sd",
    "Name": "سنڌي"
  },
  {
    "Lang": "Konkani",
    "Code": "gom",
    "Name": "कोंकणी"
  },
  {
    "Lang": "Dogri",
    "Code": "doi",
    "Name": "ڈوگری"
  },
  {
    "Lang": "Manipuri",
    "Code": "mni",
    "Name": "মৈতৈলোন"
  },
  {
    "Lang": "Santali",
    "Name": "संथाली",
    "Code": ""
  },
  {
    "Lang": "Chhattisgarhi",
    "Name": "छत्तीसगढ़ी",
    "Code": ""
  },
  {
    "Lang": "Garhwali",
    "Name": "गढ़वाली",
    "Code": ""
  },
  {
    "Lang": "Kumaoni",
    "Name": "कुमाँऊनी",
    "Code": ""
  },
  {
    "Lang": "Kutchi",
    "Name": "કચ્છી",
    "Code": ""
  },
  {
    "Lang": "Tulu",
    "Name": "ತುಳು",
    "Code": ""
  },
  {
    "Lang": "Magahi",
    "Name": "मगही",
    "Code": ""
  },
  {
    "Lang": "Angika",
    "Name": "अंगिका",
    "Code": ""
  },
  {
    "Lang": "Mizo",
    "Code": "lus",
    "Name": "Mizo"
  },
  {
    "Lang": "Garo",
    "Name": "Garo",
    "Code": ""
  },
  {
    "Lang": "Kokborok",
    "Name": "Kokborok",
    "Code": ""
  },
  {
    "Lang": "Bodo",
    "Name": "बड़",
    "Code": ""
  },
  {
    "Lang": "Khasi",
    "Name": "Khasi",
    "Code": ""
  },
  {
    "Lang": "Meitei",
    "Name": "Meitei",
    "Code": ""
  }
]

export const WorldLanguages = [
  {
    "Lang": "Afrikaans",
    "Code": "af",
    "Name": "Afrikaans"
  },
  {
    "Lang": "Albanian",
    "Code": "sq",
    "Name": "Shqip"
  },
  {
    "Lang": "Amharic",
    "Code": "am",
    "Name": "አማርኛ"
  },
  {
    "Lang": "Arabic",
    "Code": "ar",
    "Name": "العربية"
  },
  {
    "Lang": "Armenian",
    "Code": "hy",
    "Name": "Հայերեն"
  },
  {
    "Lang": "Aymara",
    "Code": "ay",
    "Name": "Aymar aru"
  },
  {
    "Lang": "Azerbaijani",
    "Code": "az",
    "Name": "Azərbaycan dili"
  },
  {
    "Lang": "Bambara",
    "Code": "bm",
    "Name": "Bamanankan"
  },
  {
    "Lang": "Basque",
    "Code": "eu",
    "Name": "Euskara"
  },
  {
    "Lang": "Belarusian",
    "Code": "be",
    "Name": "Беларуская мова"
  },
  {
    "Lang": "Bosnian",
    "Code": "bs",
    "Name": "Bosanski"
  },
  {
    "Lang": "Bulgarian",
    "Code": "bg",
    "Name": "Български"
  },
  {
    "Lang": "Catalan",
    "Code": "ca",
    "Name": "Català"
  },
  {
    "Lang": "Cebuano",
    "Code": "ceb",
    "Name": "Sinugboanong Binisaya"
  },
  {
    "Lang": "Chinese (Simplified)",
    "Code": "zh-CN",
    "Name": "中文"
  },
  {
    "Lang": "Corsican",
    "Code": "co",
    "Name": "Corsu"
  },
  {
    "Lang": "Croatian",
    "Code": "hr",
    "Name": "Hrvatski"
  },
  {
    "Lang": "Czech",
    "Code": "cs",
    "Name": "Čeština"
  },
  {
    "Lang": "Danish",
    "Code": "da",
    "Name": "Dansk"
  },
  {
    "Lang": "Dhivehi",
    "Code": "dv",
    "Name": "ދިވެހި"
  },
  {
    "Lang": "Dutch",
    "Code": "nl",
    "Name": "Nederlands"
  },
  {
    "Lang": "English",
    "Code": "en",
    "Name": "English"
  },
  {
    "Lang": "Esperanto",
    "Code": "eo",
    "Name": "Esperanto"
  },
  {
    "Lang": "Estonian",
    "Code": "et",
    "Name": "Eesti keel"
  },
  {
    "Lang": "Ewe",
    "Code": "ee",
    "Name": "Eʋegbe"
  },
  {
    "Lang": "Filipino (Tagalog)",
    "Code": "fil",
    "Name": "Filipino"
  },
  {
    "Lang": "Finnish",
    "Code": "fi",
    "Name": "Suomi"
  },
  {
    "Lang": "French",
    "Code": "fr",
    "Name": "Français"
  },
  {
    "Lang": "Frisian",
    "Code": "fy",
    "Name": "Frysk"
  },
  {
    "Lang": "Galician",
    "Code": "gl",
    "Name": "Galego"
  },
  {
    "Lang": "Georgian",
    "Code": "ka",
    "Name": "ქართული"
  },
  {
    "Lang": "German",
    "Code": "de",
    "Name": "Deutsch"
  },
  {
    "Lang": "Greek",
    "Code": "el",
    "Name": "Ελληνικά"
  },
  {
    "Lang": "Guarani",
    "Code": "gn",
    "Name": "Avañe'ẽ"
  },
  {
    "Lang": "Haitian Creole",
    "Code": "ht",
    "Name": "Kreyòl"
  },
  {
    "Lang": "Hausa",
    "Code": "ha",
    "Name": "هَوُسَ"
  },
  {
    "Lang": "Hawaiian",
    "Code": "haw",
    "Name": "ʻŌlelo Hawaiʻi"
  },
  {
    "Lang": "Hebrew",
    "Code": "he",
    "Name": "עברית"
  },
  {
    "Lang": "Hmong",
    "Code": "hmn",
    "Name": "Hmoob"
  },
  {
    "Lang": "Hungarian",
    "Code": "hu",
    "Name": "Magyar"
  },
  {
    "Lang": "Icelandic",
    "Code": "is",
    "Name": "Íslenska"
  },
  {
    "Lang": "Igbo",
    "Code": "ig",
    "Name": "Igbo"
  },
  {
    "Lang": "Ilocano",
    "Code": "ilo",
    "Name": "Ilokano"
  },
  {
    "Lang": "Indonesian",
    "Code": "id",
    "Name": "Bahasa Indonesia"
  },
  {
    "Lang": "Irish",
    "Code": "ga",
    "Name": "Gaeilge"
  },
  {
    "Lang": "Italian",
    "Code": "it",
    "Name": "Italiano"
  },
  {
    "Lang": "Japanese",
    "Code": "ja",
    "Name": "日本語"
  },
  {
    "Lang": "Javanese",
    "Code": "jv",
    "Name": "ꦧꦱꦗꦮ"
  },
  {
    "Lang": "Kazakh",
    "Code": "kk",
    "Name": "Қазақ"
  },
  {
    "Lang": "Khmer",
    "Code": "km",
    "Name": "ភាសាខ្មែរ"
  },
  {
    "Lang": "Kinyarwanda",
    "Code": "rw",
    "Name": "Kinyarwanda"
  },
  {
    "Lang": "Korean",
    "Code": "ko",
    "Name": "한국어"
  },
  {
    "Lang": "Krio",
    "Code": "kri",
    "Name": "Krio"
  },
  {
    "Lang": "Kurdish",
    "Code": "ku",
    "Name": "کوردی"
  },
  {
    "Lang": "Kurdish (Sorani)",
    "Code": "ckb",
    "Name": "کوردی"
  },
  {
    "Lang": "Kyrgyz",
    "Code": "ky",
    "Name": "Кыргызча"
  },
  {
    "Lang": "Lao",
    "Code": "lo",
    "Name": "ພາສາລາວ"
  },
  {
    "Lang": "Latin",
    "Code": "la",
    "Name": "Latine"
  },
  {
    "Lang": "Latvian",
    "Code": "lv",
    "Name": "Latviešu valoda"
  },
  {
    "Lang": "Lingala",
    "Code": "ln",
    "Name": "Lingála"
  },
  {
    "Lang": "Lithuanian",
    "Code": "lt",
    "Name": "Lietuvių kalba"
  },
  {
    "Lang": "Luganda",
    "Code": "lg",
    "Name": "Oluganda"
  },
  {
    "Lang": "Luxembourgish",
    "Code": "lb",
    "Name": "Lëtzebuergesch"
  },
  {
    "Lang": "Macedonian",
    "Code": "mk",
    "Name": "Македонски"
  },
  {
    "Lang": "Malagasy",
    "Code": "mg",
    "Name": "Malagasy"
  },
  {
    "Lang": "Malay",
    "Code": "ms",
    "Name": "Bahasa Melayu"
  },
  {
    "Lang": "Maltese",
    "Code": "mt",
    "Name": "Malti"
  },
  {
    "Lang": "Maori",
    "Code": "mi",
    "Name": "Te Reo Māori"
  },
  {
    "Lang": "Meiteilon (Manipuri)",
    "Code": "mni-Mtei",
    "Name": "ꯃꯤꯇꯩ "
  },
  {
    "Lang": "Mongolian",
    "Code": "mn",
    "Name": "Монгол"
  },
  {
    "Lang": "Myanmar (Burmese)",
    "Code": "my",
    "Name": "မြန်မာစာ"
  },
  {
    "Lang": "Norwegian",
    "Code": "no",
    "Name": "Norsk"
  },
  {
    "Lang": "Nyanja (Chichewa)",
    "Code": "ny",
    "Name": "Chi-Chewa"
  },
  {
    "Lang": "Oromo",
    "Code": "om",
    "Name": "Afaan Oromoo"
  },
  {
    "Lang": "Pashto",
    "Code": "ps",
    "Name": "پښتو"
  },
  {
    "Lang": "Persian",
    "Code": "fa",
    "Name": "فارسی"
  },
  {
    "Lang": "Polish",
    "Code": "pl",
    "Name": "Polski"
  },
  {
    "Lang": "Portuguese (Portugal, Brazil)",
    "Code": "pt",
    "Name": "Brazil)"
  },
  {
    "Lang": "Quechua",
    "Code": "qu",
    "Name": "Runa Simi"
  },
  {
    "Lang": "Romanian",
    "Code": "ro",
    "Name": "Română"
  },
  {
    "Lang": "Russian",
    "Code": "ru",
    "Name": "Русский"
  },
  {
    "Lang": "Samoan",
    "Code": "sm",
    "Name": "Gagana fa'a Sāmoa"
  },
  {
    "Lang": "Scots Gaelic",
    "Code": "gd",
    "Name": "Gàidhlig"
  },
  {
    "Lang": "Sepedi",
    "Code": "nso",
    "Name": "Sepedi"
  },
  {
    "Lang": "Serbian",
    "Code": "sr",
    "Name": "Српски"
  },
  {
    "Lang": "Sesotho",
    "Code": "st",
    "Name": "Sesotho"
  },
  {
    "Lang": "Shona",
    "Code": "sn",
    "Name": "ChiShona"
  },
  {
    "Lang": "Sinhala (Sinhalese)",
    "Code": "si",
    "Name": "=-සිංහල"
  },
  {
    "Lang": "Slovak",
    "Code": "sk",
    "Name": "Slovenčina"
  },
  {
    "Lang": "Slovenian",
    "Code": "sl",
    "Name": "Slovenščina"
  },
  {
    "Lang": "Somali",
    "Code": "so",
    "Name": "Af-Soomaali"
  },
  {
    "Lang": "Spanish",
    "Code": "es",
    "Name": "Español"
  },
  {
    "Lang": "Sundanese",
    "Code": "su",
    "Name": "Basa Sunda"
  },
  {
    "Lang": "Swahili",
    "Code": "sw",
    "Name": "Kiswahili"
  },
  {
    "Lang": "Swedish",
    "Code": "sv",
    "Name": "Svenska"
  },
  {
    "Lang": "Tagalog (Filipino)",
    "Code": "tl",
    "Name": "Tagalog"
  },
  {
    "Lang": "Tajik",
    "Code": "tg",
    "Name": "Тоҷикӣ"
  },
  {
    "Lang": "Tatar",
    "Code": "tt",
    "Name": "Татарча"
  },
  {
    "Lang": "Thai",
    "Code": "th",
    "Name": "ไทย"
  },
  {
    "Lang": "Tigrinya",
    "Code": "ti",
    "Name": "ትግርኛ"
  },
  {
    "Lang": "Tsonga",
    "Code": "ts",
    "Name": "Xitsonga"
  },
  {
    "Lang": "Turkish",
    "Code": "tr",
    "Name": "Türkçe"
  },
  {
    "Lang": "Turkmen",
    "Code": "tk",
    "Name": "Türkmençe"
  },
  {
    "Lang": "Twi (Akan)",
    "Code": "ak",
    "Name": "Twi"
  },
  {
    "Lang": "Ukrainian",
    "Code": "uk",
    "Name": "Українська"
  },
  {
    "Lang": "Uyghur",
    "Code": "ug",
    "Name": "ئۇيغۇرچە"
  },
  {
    "Lang": "Uzbek",
    "Code": "uz",
    "Name": "Oʻzbekcha"
  },
  {
    "Lang": "Vietnamese",
    "Code": "vi",
    "Name": "Tiếng"
  },
  {
    "Lang": "Welsh",
    "Code": "cy",
    "Name": "Cymraeg"
  },
  {
    "Lang": "Xhosa",
    "Code": "xh",
    "Name": "isiXhosa"
  },
  {
    "Lang": "Yiddish",
    "Code": "yi",
    "Name": "ייִדיש"
  },
  {
    "Lang": "Yoruba",
    "Code": "yo",
    "Name": "Yorùbá"
  },
  {
    "Lang": "Zulu",
    "Code": "zu",
    "Name": "isiZulu"
  }
]





function GetLocalStorageByKey(key) {
  try {


    var value = localStorage.getItem(key);

    return value ? JSON.parse(value) : null;

  }
  catch (e) {
    console.log(e);
  }
}

// const removeSpacesAndCapitalize = (() => {
//     const removeSpacesRegex = /\s+/g;
//     const capitalizeRegex = /(^|\.\s+)(\w)/g;

//     return (str) => {
//       const withoutSpaces = str.replace(removeSpacesRegex, '');
//       const capitalized = withoutSpaces.toUpperCase();
//       const sentenceCase = capitalized.replace(capitalizeRegex, (match) => match.toUpperCase());

//       return sentenceCase;
//     };
//   })();


const capitalizeWords = (sentence) => {

  try {
    if (!sentence || sentence == '') {
      return sentence;
    }
    sentence = sentence.trim();
    return sentence.replace(/\b\w/g, (match) => match.toUpperCase());
  }
  catch (e) {
    return sentence;
  }

};


const capitalizeFirstCharacter = (str) => {
  if (str.length === 0) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function GetTablesSyncDateTime() {

  try {

    var obj = {}
    Object.keys(TableLastSyncDateTime).forEach((key, index) => {

      var value = GetLocalStorageByKey(TableLastSyncDateTime[key]);
      if (value) {
        obj[key] = value;
      }

    });

    return obj;

  }
  catch (e) {
    console.log(e);
  }

}


/**Process Data of User Cache DB */
export function ProcessUserData(data, dataStore, aggregate, individualAggregates) {
  try {
    window.globalCacheData = data;
    individualAggregates = individualAggregates || [];

    // Store Aggregates to LOCAL STORAGE
    if (!aggregate) {
      aggregate = JSON.parse(localStorage.getItem("USERMASTERAGGREGATES"));
    }
    else {
      localStorage.setItem("USERMASTERAGGREGATES", JSON.stringify(aggregate));
    }

    //store indivudal aggregates
    if (!individualAggregates || individualAggregates.length == 0) {
      individualAggregates = JSON.parse(localStorage.getItem("USERINDIVIDUALAGGREGATES"));
    }
    else {
      localStorage.setItem("USERINDIVIDUALAGGREGATES", JSON.stringify(individualAggregates));
    }


    data.CurrentAggregateMaster = aggregate;
    data.IndividualAggregates = individualAggregates;

    try {


      if (dataStore) {
        //DispatchFromAppJs
        // Store data in React Store // THIS DOESN'T UPDATES UI
        //console.log("DISPATCH 1");
        dataStore.dispatch(StoreUserData(data));
        //console.log("DISPATCH 2");

        //DISPATCHING JUST TO UPDATE UI AS ACTUAL DATA PARSING IS TAKING TIME [~2 second], THIS PARSING TAKING 20MS
        var loggedinUser = data.CFUser ? data.CFUser : null
        if (loggedinUser) {
          dataStore.dispatch(StoreUser(JSON.parse(JSON.stringify(loggedinUser))));
        }
      }
      else {
        DispatchFromAppJs(data, data.CFUser)
      }

    } catch (e) {
      SaveCleintWaufli(e, "Dispatach Failed In ProcessUserData", " ProcessUserData ");
      //ProcessUserData
    }


  }
  catch (e) {
    SaveCleintWaufli(e, "ProcessUserData Failed", " ProcessUserData ");
  }

  // Assign to cache


}


///THIS METHOD IS MEANT TO HAVE THE CONFIGURATION READY
export function BuildConfiguration(UserData, GPTData, Role, CurrentUser, dataStore) {

  var dataToCheck = GPTData.AutismGPTConfig;
  var lsKey = localStorage.getItem("AutismGPTConfigRefresh");
  // if (lsKey && lsKey == "FALSE") {
  //     return;
  // }
  if (!dataToCheck || lsKey == "TRUE") {

    ///BUILD OVERALL DATA
    var data = GetPinnacleCategories(Role.toLowerCase());

    var subCatdata = GetAllPinnacleSubCategories(Role.toLowerCase());
    subCatdata.forEach(function (m) { m.FT = "Feature" });
    //TO PERFORM ACTUAL HELP
    var helpData = GetPinnacleEIHelp(Role.toLowerCase());
    var allCatNames = [];
    var overAllData = [];
    allCatNames = data.map(t => 'Try ' + '"' + t.Title + '"')
    var allSubsSrting = ""
    $.each(data, function (key, val) {

      var currentSubCat = GetPinnacleSubCategories(Role.toLowerCase(), val.Title)
      var allsubs = currentSubCat && currentSubCat.length > 0 ? currentSubCat.map(t => t.Title) : [];
      allSubsSrting = allsubs && allsubs.length > 0 ? allsubs.join(", ") : '';
      val.Description = val.Description ? val.Description : allSubsSrting;
      val.Type = "Feature"
      val.FT = "Feature";
    });
    if (data && data.length > 0) {
      overAllData = overAllData.concat(data);
    }
    if (subCatdata && subCatdata.length > 0) {
      overAllData = overAllData.concat(subCatdata);
    }
    // Start
    // People
    if (UserData.Centers) {

      var start = new Date();
      var people = UserData.People;
      people = people || [];
      if (UserData.FacilityPeople && UserData.FacilityPeople.length > 0) {

        var activeFP = UserData.FacilityPeople.filter(f => f.RS != "DELETEACTIVITY");
        activeFP = activeFP || [];
        people.push(...activeFP);
      }
      var centersData = groupBy(UserData.Centers, "Id");
      var allRoles = UserData.Types.filter(t => t.Category == "Role");
      var rolesData = groupBy(allRoles, "Id");
      //var peopleData = Object.entries(groupBy(people.filter(f => f.RS != "DELETEACTIVITY"), "Id")).map(function (m) { return { Title: m[1][0].Name, Description: (centersData[m[1][0].CenterId + ""] ? centersData[m[1][0].CenterId + ""][0].Name : "") + "," + m[1][0].Designation + (m[1][0].DOJ ? "," + GetDateFormat(m[1][0].DOJ) : ""), Role: (rolesData[m[1][0].RoleId + ""] ? rolesData[m[1][0].RoleId + ""][0].Name : ""), URL: "/autismgpt?q=" + m[1][0].Name + "&role=" + (rolesData[m[1][0].RoleId + ""] ? rolesData[m[1][0].RoleId + ""][0].Name.toLowerCase() : "boss"), CenterId: m[1][0].CenterId, Id: m[1][0].Id, Handle: m[1][0].Handle, Code: m[1][0].Code, ImageURL: "https://images.pinnacleblooms.org/images/ProfileImages/" + m[1][0].Id + ".jpg", Type: "People", FT: "People", Priority: 1 } });

      var peopleData = Object.entries(
        groupBy(people.filter(f => f.RS != "DELETEACTIVITY"), "Id")
      ).map(function (m) {
        const person = m[1][0];
        const centerName = centersData[person.CenterId + ""]
          ? centersData[person.CenterId + ""][0].Name
          : "";

        let therapistTitle = "";
        if (person.F1 && person.F1.indexOf('CT') >= 0) {
          therapistTitle = person.F1 === "CT"
            ? "Chief Therapist, "
            : "Deputy Chief Therapist, ";
        }

        const description =
          centerName +
          (therapistTitle ? ", " + therapistTitle : "") +
          person.Designation +
          (person.DOJ ? ", " + GetDateFormat(person.DOJ) : "");

        const roleName = rolesData[person.RoleId + ""]
          ? rolesData[person.RoleId + ""][0].Name
          : "";

        return {
          Title: (person.Name ? person.Name.trim() : person.Name),
          Description: description,
          Role: roleName,
          URL: "/autismgpt?q=" + person.Name + "&role=" + (roleName ? roleName.toLowerCase() : "boss"),
          CenterId: person.CenterId,
          Id: person.Id,
          Handle: person.Handle,
          F1: person.F1,
          NF: person.NF,
          Code: person.Code,
          ImageURL: "https://images.pinnacleblooms.org/images/ProfileImages/" + person.Id + ".jpg",
          Type: "People",
          FT: "People",
          Priority: 1
        };
      });

      var mirracleTData = UserData.MirracleTypes.filter(f => f.RS != "DELETEACTIVITY").map(function (m) {

        //IsBT,IsOT,IsSE,IsST

        return { Title: m.Title, Description: (m.IsBT == 1 ? "BT, " : "") + (m.IsOT == 1 ? "OT, " : "") + (m.IsSE == 1 ? "SE, " : "") + (m.IsST == 1 ? "ST, " : "") + (m.IsBT == 0 && m.IsOT == 0 && m.IsSE == 0 && m.IsST == 0 ? "TBG" : ""), URL: "/miraverse?id=" + m.Id + "&type=" + m.Category, ImageURL: "https://mobile.pinnacleblooms.org" + m.PUrl + "", Type: m.Category, FT: "University", Priority: 1 }
      });

      var assessmentData = UserData.Types.filter(f => f.RS != "DELETEACTIVITY" && f.Category == "ASSESSMENT" && (f.Name && f.Name.indexOf("Therapy Services") <= -1)).map(function (m) {

        return { Title: m.Name, Description: m.Description, URL: "/assessment/" + m.F1, ImageURL: m.F3, Type: "Assessment", FT: "Assessment", Priority: 1 }
      });
      var centersObject = UserData.Centers.filter(f => f.RS != "DELETEACTIVITY").map(function (m) {

        return { Title: m.Name, Description: m.Description, URL: "/centers/" + m.Id, ImageURL: "https://www.pinnacleblooms.org/Images/ProfileImages/" + m.F25 + ".jpg?v=1", Type: "Center", FT: "Center", Priority: 1, Id: m.Id }
      });



      peopleData = peopleData || [];
      mirracleTData = mirracleTData || [];
      assessmentData = assessmentData || [];
      overAllData.push(...peopleData);
      overAllData.push(...mirracleTData);
      overAllData.push(...assessmentData);
      overAllData.push(...centersObject);
      overAllData.push(...helpData);
    }
    ///DISPATCH TO STORE
    var dispatchData = {}
    dispatchData.AutismGPTConfig = overAllData;
    dispatchData.CategorySearchResults = data;
    dispatchData.SubCategorySearchResults = subCatdata;
    try {
      if (dataStore) {
        //DispatchFromAppJs
        // Store data in React Store // THIS DOESN'T UPDATES UI
        console.log("DISPATCH FOR AUTISM GPT 1");
        dataStore(StoreGPTData(dispatchData));

        //DISPATCHING JUST TO UPDATE UI, THIS PARSING TAKING 20MS
        var loggedinUser = CurrentUser ? CurrentUser : null
        if (loggedinUser) {
          dataStore(StoreUser(JSON.parse(JSON.stringify(loggedinUser))));
        }
      }

    } catch (e) {
      SaveCleintWaufli(e, "Dispatach Failed In ProcessUserData", " ProcessUserData ");
      //ProcessUserData
    }

    ///UPDATE LS KEY
    localStorage.setItem("AutismGPTConfigRefresh", "FALSE");
  }
}

export var allMonthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

export var commonMessageForShare = "";

export function GetSalCat(amount) {
  if (amount <= 15000) {
    return "<=15k";
  }

  var start = amount - (amount % 1000);
  var end = start + 1000;
  return (start / 1000) + "K";// + (end / 1000) + "K";
}

export function safeDivide(numerator, denominator, defaultValue = 0) {
  if (denominator === 0 || denominator === null || denominator === undefined) {
    return defaultValue;
  }
  const result = numerator / denominator;
  return Number.isFinite(result) ? result : defaultValue;
}

export function getLastMonthYear() {
  const now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth();

  if (month === 0) {
    month = 12;
    year = year - 1;
  }
  return { year, month };
}

export function toKFormat(num) {
  return num < 1000 ? num : (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
}

export function GetDateandMonthFormate(date) {
  if (!date) {
    return date;
  }

  var d = new Date(date);

  return (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) + "/" + (allMonthShortNames[d.getMonth()]).toUpperCase();
}

export function GetDateMonthandYearFormate(date) {
  if (!date) {
    return date;
  }

  var d = new Date(date);

  return (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) + "/" + (allMonthShortNames[d.getMonth()]).toUpperCase() + "/" + (d.getFullYear());
}


function GetRankRYBG(rank, start, second, third, last) {
  return rank <= start && rank != 0 ? "Green" : rank > start && rank <= second ? "Blue" : rank > second && rank <= third ? "Yellow" : "red";
}
export function GetGoalJsonString(text) {
  try {
    var parsedText = JSON.parse(text);
    return parsedText;
  } catch (error) {
    console.log("Error In GetGoalJsonString :" + error);
  }
}

/**#region algos */

function tokenize(sentence) {
  // Split the sentence by spaces and remove any punctuation.
  return sentence
    .toLowerCase() // Convert to lowercase for case-insensitive comparison
    .replace(/[^\w\s]|_/g, '') // Remove punctuation using regex
    .split(/\s+/); // Split by any whitespace
}

function tokenSimilarity(stringToCompare, strings) {
  let compareTokens = tokenize(stringToCompare);
  var model = [];
  var hightestValue = 0;
  var matchedText = "";
  strings.forEach((str) => {
    let strTokens = tokenize(str);
    let commonTokens = compareTokens.filter(token => strTokens.includes(token));
    let similarity = commonTokens.length / Math.max(compareTokens.length, strTokens.length);

    // console.log("Similarity between "+stringToCompare+" and "+str+" "+similarity.toFixed(2));
    if (similarity > hightestValue) {
      hightestValue = similarity;
      model = { Score: similarity, Text: str };
    }
  });

  return model;
}

function fuzzyMatchScore(str1, str2) {
  str1 = str1.toLowerCase();
  str2 = str2.toLowerCase();

  let score = 0;

  // Give a point for every character in str2 that is also in str1 in the same sequence
  let matchIndex = 0;

  for (let char of str2) {
    matchIndex = str1.indexOf(char, matchIndex);
    if (matchIndex === -1) break;
    score++;
    matchIndex++;
  }

  return score;
}

function compareStringsFuzzy(stringToCompare, collection) {
  var hightestValue = 0;
  var model;

  collection.forEach(str => {
    let score = fuzzyMatchScore(stringToCompare, str);


    if (score > hightestValue) {
      hightestValue = score;
      model = { Score: score, Text: str };
    }


  });

  return model;
}


function isSubsequence(s1, s2) {
  let i = 0, j = 0;
  while (i < s1.length && j < s2.length) {
    if (s1[i] === s2[j]) {
      i++;
    }
    j++;
  }
  return i === s1.length;
}

function compareStringsAsSubsequences(stringToCompare, collection) {

  const results = collection.map(str => {
    return {
      string: str,
      isSubsequence: isSubsequence(stringToCompare.toLowerCase(), str.toLowerCase())
    };
  });



  return results.filter(f => f.isSubsequence == true).map(m => m.string);

}


export function PinnacleNLPProcess(stringToCompare, collection) {
  var subSequesnce = compareStringsAsSubsequences(stringToCompare, collection);

  if (subSequesnce && subSequesnce.length == 1) {
    return subSequesnce[0];
  }

  var tokens = tokenSimilarity(stringToCompare, collection);
  if (tokens && tokens.Score >= 0.5) {
    return tokens.Text;
  }



  var fuzzy = compareStringsFuzzy(stringToCompare, collection);
  if (fuzzy && fuzzy.Text == tokens.Text) {
    console.log("returning from compareStringsFuzzy");
    return fuzzy.Text;
  }

  return "";



}


export function PinnacleNLP(stringToCompare, collection) {
  var subSequesnce = compareStringsAsSubsequences(stringToCompare, collection);

  if (subSequesnce && subSequesnce.length == 1) {
    console.log("%cfinalizer", "font-weight:bold");
    console.log("THERAPYPLAN: ", stringToCompare);
    console.log("MACHED GOAL: ", subSequesnce[0]);
    console.log("collection: ", JSON.stringify(collection));
    return subSequesnce[0];
  }



  var tokens = tokenSimilarity(stringToCompare, collection);
  if (tokens && tokens.Text) {
    console.log("%ctokenizer", "font-weight:bold");
    console.log("THERAPYPLAN: ", stringToCompare);
    console.log("MACHED GOAL: ", tokens.Text);
    console.log("collection: ", JSON.stringify(collection));
    //console.log("returning from tokenSimilarity");
    return tokens.Text;
  }


  var fuzzy = compareStringsFuzzy(stringToCompare, collection);
  if (fuzzy && fuzzy.Text == tokens.Text) {
    console.log("returning from compareStringsFuzzy");
    return tokens.Text;
  }


  // if no matches

  return "";
}

/** */





export function GetViewSession(goal, $this) {


  return <div>







    {

      <div>
        <div className="each-goal-data">


          <div className='content '>


            {goal && goal.SessionJson && goal.SessionJson.IntroductionToParent ?
              <div className={($this.IsExpanded("itp-" + goal.Id) ? 'expanded ' : 'collapse ') + 'streched inside-block-goals-ec'}>
                <div className="goalheading" onClick={this.ExpanderCollpase.bind(this, "itp-" + goal.Id, this.IsExpanded("itp-" + goal.Id) ? true : false)}><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><path d="M2,1H24c1.657,0,3,1.343,3,3V28c0,1.657-1.343,3-3,3H2V1Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line x1={31} y1={6} x2={31} y2={10} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={31} y1={14} x2={31} y2={18} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><circle cx={14} cy={11} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><path d="M14,17c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /></g></svg><span>Introduction To Parent</span>
                  <div className='ec'>
                    {

                      !$this.IsExpanded("itp-" + goal.Id) ? <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={16} r={15} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polyline data-color="color-2" points="22 14 16 20 10 14" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>


                        : <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={16} r={15} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polyline data-color="color-2" points="10 18 16 12 22 18" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>




                      // <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M16,0A16,16,0,1,0,32,16,16.047,16.047,0,0,0,16,0Zm6.7,14.7-6,6a.967.967,0,0,1-1.4,0l-6-6a.99.99,0,0,1,1.4-1.4L16,18.6l5.3-5.3a.99.99,0,0,1,1.4,1.4Z" fill="#29b37c" /></g></svg>


                    }
                  </div>
                </div>


                {$this.IsExpanded("itp-" + goal.Id) ?
                  <div className='insideconntent'>

                    {parse(goal.SessionJson.IntroductionToParent)}
                  </div> : ""
                }

              </div>
              : ""
            }

            {goal.SessionJson && goal.SessionJson.TherapySessionPlan ?
              <div className={($this.IsExpanded("therapysessionplan-" + goal.Id) ? 'expanded ' : 'collapse ') + 'committed inside-block-goals-ec'}>
                <div className="goalheading" onClick={this.ExpanderCollpase.bind(this, "therapysessionplan-" + goal.Id, $this.IsExpanded("therapysessionplan-" + goal.Id) ? true : false)}><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M21.88,2.157a3.738,3.738,0,0,0-5.287-.12,3.688,3.688,0,0,0-.593.73,3.74,3.74,0,0,0-5.881-.61,4.046,4.046,0,0,0,0,5.587L16,13.831l5.881-6.087A4.045,4.045,0,0,0,21.88,2.157Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M7,31V29L1.722,22.843A3,3,0,0,1,1,20.89V12a2,2,0,0,1,2-2H3a2,2,0,0,1,2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M14,31V24.243a3,3,0,0,0-.879-2.122L8.5,17.5a2.122,2.122,0,0,0-3,0h0a2.122,2.122,0,0,0,0,3L9,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M25,31V29l5.278-6.157A3,3,0,0,0,31,20.89V12a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M18,31V24.243a3,3,0,0,1,.879-2.122L23.5,17.5a2.122,2.122,0,0,1,3,0h0a2.122,2.122,0,0,1,0,3L23,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg><span>Therapies</span>
                  <div className='ec'>
                    {

                      !$this.IsExpanded("therapysessionplan-" + goal.Id) ? <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={16} r={15} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polyline data-color="color-2" points="22 14 16 20 10 14" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>


                        : <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={16} r={15} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polyline data-color="color-2" points="10 18 16 12 22 18" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>




                      // <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M16,0A16,16,0,1,0,32,16,16.047,16.047,0,0,0,16,0Zm6.7,14.7-6,6a.967.967,0,0,1-1.4,0l-6-6a.99.99,0,0,1,1.4-1.4L16,18.6l5.3-5.3a.99.99,0,0,1,1.4,1.4Z" fill="#29b37c" /></g></svg>


                    }
                  </div>


                </div>

                {$this.IsExpanded("therapysessionplan-" + goal.Id) ?
                  <>
                    <ul className={"committed-" + goal.Id}>
                      {goal.SessionJson.TherapySessionPlan && goal.SessionJson.TherapySessionPlan.map((eachG, index) => (

                        eachG && eachG.TherapyDetails ?

                          <li>
                            {

                              <div>
                                {eachG.TherapyDetails}
                                <div className='indent'>
                                  <>
                                    {

                                      eachG && eachG.GuidanceToTherapist ?

                                        <div className="goalheading" style={{ marginBottom: "0px" }}>
                                          <div className="individualGoal ef-q-block session"><div className="title">Guidance To Therapist: </div><div className="Content">{eachG.GuidanceToTherapist}</div></div>

                                        </div>
                                        :
                                        ""
                                    }


                                    {

                                      eachG && eachG.Goal ?

                                        <div className="goalheading">                                                             <div className="individualGoal ef-q-block session"><div className="title">Goal: </div>
                                          <div className="Content">{eachG.Goal}</div></div>

                                        </div>

                                        : ""
                                    }



                                    {

                                      eachG && eachG.TherapyMaterial ?

                                        <div className="goalheading">
                                          <div className="individualGoal ef-q-block session"><div className="title">Therapy Material: </div><div className="Content">{eachG.TherapyMaterial}</div></div>

                                        </div>

                                        : ""
                                    }
                                    {

                                      eachG && eachG.EstimatedTime ?

                                        <div className="goalheading">
                                          <div className="individualGoal ef-q-block session"><div className="title" style={{ width: 'auto', float: 'left' }}>Estimated Time: </div><div className="Content" style={{ width: 'auto', float: 'left', marginTop: "2px" }}>{eachG.EstimatedTime}</div></div>

                                        </div>

                                        : ""
                                    }

                                  </>
                                  {
                                    goal && eachG.Repetitions ?
                                      <>
                                        <div className="goalheading">
                                          <div className="individualGoal ef-q-block session"><div className="title" style={{ width: 'auto', float: 'left' }}>Repetitions: </div><div className="Content" style={{ width: 'auto', float: 'left', marginTop: "2px" }}>{eachG.Repetitions}</div></div>

                                        </div>
                                      </>

                                      : ""}

                                  {
                                    eachG.AchievementCriteria ?
                                      <>
                                        {GetAchivedString(eachG, goal, "committed", index, $this)}</>


                                      : ""
                                  }
                                </div>
                              </div>
                            }



                          </li> : ""

                      ))

                      }
                    </ul>

                  </>
                  : ""}


              </div>
              : ""
            }


            {
              goal.SessionJson && goal.SessionJson.ClosingthoughtsToTherapistAndParents ?
                <div className={($this.IsExpanded("conclusion-" + goal.Id) ? 'expanded ' : 'collapse ') + 'conclusion inside-block-goals-ec'}>
                  <div className="goalheading" style={{ textWrap: 'nowrap' }} onClick={this.ExpanderCollpase.bind(this, "conclusion-" + goal.Id, $this.IsExpanded("conclusion-" + goal.Id) ? true : false)}><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M21.88,2.157a3.738,3.738,0,0,0-5.287-.12,3.688,3.688,0,0,0-.593.73,3.74,3.74,0,0,0-5.881-.61,4.046,4.046,0,0,0,0,5.587L16,13.831l5.881-6.087A4.045,4.045,0,0,0,21.88,2.157Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M7,31V29L1.722,22.843A3,3,0,0,1,1,20.89V12a2,2,0,0,1,2-2H3a2,2,0,0,1,2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M14,31V24.243a3,3,0,0,0-.879-2.122L8.5,17.5a2.122,2.122,0,0,0-3,0h0a2.122,2.122,0,0,0,0,3L9,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M25,31V29l5.278-6.157A3,3,0,0,0,31,20.89V12a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v5.417" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M18,31V24.243a3,3,0,0,1,.879-2.122L23.5,17.5a2.122,2.122,0,0,1,3,0h0a2.122,2.122,0,0,1,0,3L23,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg><span style={{ width: '79%', overflowX: 'scroll' }}>Closing Thoughts to Therapist and Parents</span>
                    <div className='ec'>
                      {

                        !$this.IsExpanded("conclusion-" + goal.Id) ? <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={16} r={15} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polyline data-color="color-2" points="22 14 16 20 10 14" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>


                          : <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={16} r={15} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polyline data-color="color-2" points="10 18 16 12 22 18" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>




                        // <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M16,0A16,16,0,1,0,32,16,16.047,16.047,0,0,0,16,0Zm6.7,14.7-6,6a.967.967,0,0,1-1.4,0l-6-6a.99.99,0,0,1,1.4-1.4L16,18.6l5.3-5.3a.99.99,0,0,1,1.4,1.4Z" fill="#29b37c" /></g></svg>


                      }
                    </div>
                  </div>

                  {$this.IsExpanded("conclusion-" + goal.Id) ?
                    <div className='insideconntent'>

                      {parse(goal.SessionJson.ClosingthoughtsToTherapistAndParents)}
                    </div> : ""
                  }

                </div> : ''
            }

          </div>
          <div>

          </div>

        </div>
      </div>

    }

  </div>

}

const formatDayMonth = (date, LangLabels) => {
  date = new Date(date);
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const day = date.getDate();
  const monthName = getLabel(monthNames[date.getMonth()], LangLabels);
  return `${day}/${monthName}`;
}

export function GetNewAchivedString(eachG, goal, type, index, ConvertedLang, attachedString, LangLabels) {

  var goalMatched = eachG.AllGoals;
  var currentPercententage = eachG && eachG.CurrentPerCentage ? eachG.CurrentPerCentage : null;

  if (attachedString) {
    console.log("PERCENT");
  }

  var alreadyAchieved = (goalMatched?.Achieved || []).sort(function (a, b) { return parseInt(a.P) > parseInt(b.P) ? -1 : 1 });

  const groupedPercentage = groupBy(alreadyAchieved, "P");

  const checkIcon = <svg viewBox="0 0 18 18" width={23} height={23} style={{}}><path id="Star-2" fill="#007aff" d="M9 16l-1.9.9-1.3-1.7-2.1-.1-.3-2.1-1.9-1 .7-2.1-1.1-1.7 1.5-1.5-.2-2.1L4.5 4l.8-2 2.1.4L9 1.1l1.7 1.3 2-.4.9 2 2 .6-.1 2.1L17 8.2l-1.1 1.7.6 2.1-1.8 1-.4 2.1-2.1.1-1.3 1.7z" /><path id="Check-Icon" fill="#FFF" d="M13.1 7.3l-.9-.8-4.1 4.1-2.2-2.1-.9.9 3 3z" /></svg>;
  const achievedLang = "- " + getLabel("Achieved", LangLabels) + " ";
  const is100Achived = groupedPercentage && groupedPercentage[100] && groupedPercentage[100].length > 0 && (<>{achievedLang} {checkIcon} {formatDayMonth(groupedPercentage[100][0].D)}</>);
  const is90Achived = groupedPercentage && groupedPercentage[90] && groupedPercentage[90].length > 0 && (<>{achievedLang} {checkIcon} {formatDayMonth(groupedPercentage[90][0].D)}</>);
  const is70Achived = groupedPercentage && groupedPercentage[70] && groupedPercentage[70].length > 0 && (<>{achievedLang} {checkIcon} {formatDayMonth(groupedPercentage[70][0].D)}</>);
  const is45Achived = groupedPercentage && groupedPercentage[45] && groupedPercentage[45].length > 0 && (<>{achievedLang} {checkIcon} {formatDayMonth(groupedPercentage[45][0].D)}</>);
  const is25Achived = groupedPercentage && groupedPercentage[25] && groupedPercentage[25].length > 0 && (<>{achievedLang} {checkIcon} {formatDayMonth(groupedPercentage[25][0].D)}</>);
  const is10Achived = groupedPercentage && groupedPercentage[10] && groupedPercentage[10].length > 0 && (<>{achievedLang} {checkIcon} {formatDayMonth(groupedPercentage[10][0].D)}</>);
  try {

    var newHTMLString = <div className="goals-achievement">
      <div className="main-goal" style={{ paddingBottom: '20px' }}>
        {ConvertedLang && ConvertedLang.Goal ? ConvertedLang.Goal : goal}
      </div>
      <div className={"achievement " + (is100Achived ? "achieved" : "")}>
        <div className="header ">100% {currentPercententage && currentPercententage == 100 && attachedString ? attachedString : is100Achived} </div>
        <div className="footer" style={{ display: 'inline-block' }}>{ConvertedLang && ConvertedLang.CentPercent ? ConvertedLang.CentPercent : eachG.AllGoals.AchievementCriteria.CentPercent}</div>
      </div>
      <div className={"achievement " + (is90Achived ? "achieved" : "")}>
        <div className="header">90% {currentPercententage && currentPercententage == 90 && attachedString ? attachedString : is90Achived} </div>
        <div className="footer">{ConvertedLang && ConvertedLang.NinetyPercent ? ConvertedLang.NinetyPercent : eachG.AllGoals.AchievementCriteria.NinetyPercent}</div>
      </div>
      <div className={"achievement " + (is70Achived ? "achieved" : "")}>
        <div className="header">70% {currentPercententage && currentPercententage == 70 && attachedString ? attachedString : is70Achived} </div>
        <div className="footer">{ConvertedLang && ConvertedLang.SeventyPercent ? ConvertedLang.SeventyPercent : eachG.AllGoals.AchievementCriteria.SeventyPercent}</div>
      </div>
      <div className={"achievement " + (is45Achived ? "achieved" : "")}>
        <div className="header">45% {currentPercententage && currentPercententage == 45 && attachedString ? attachedString : is45Achived} </div>
        <div className="footer">{ConvertedLang && ConvertedLang.FortyFivePercent ? ConvertedLang.FortyFivePercent : eachG.AllGoals.AchievementCriteria.FortyFivePercent}</div>
      </div>
      <div className={"achievement " + (is25Achived ? "achieved" : "")}>
        <div className="header">25% {currentPercententage && currentPercententage == 25 && attachedString ? attachedString : is25Achived} </div>
        <div className="footer">{ConvertedLang && ConvertedLang.TwentyFivePercent ? ConvertedLang.TwentyFivePercent : eachG.AllGoals.AchievementCriteria.TwentyFivePercent}</div>
      </div>
      <div className={"achievement " + (is10Achived ? "achieved" : "")}>
        <div className="header">10% {currentPercententage && currentPercententage == 10 && attachedString ? attachedString : is10Achived} </div>
        <div className="footer">{ConvertedLang && ConvertedLang.TenPercent ? ConvertedLang.TenPercent : eachG.AllGoals.AchievementCriteria.TenPercent}</div>
      </div>
      <div className="achievement achieved" style={{ borderLeft: '0px', paddingBottom: '0px' }}>
        <div className="header">{getLabel("Started", LangLabels)} {getLabel("On", LangLabels)} {eachG && eachG.StartDate && formatPrettyDate(eachG.StartDate, LangLabels)}</div>
      </div>
    </div>


    return newHTMLString;

  } catch (error) {
    console.log("Error in GetNewAchivedString:" + error);
  }
}


export function GetGoalsByTherapyIds(goalsData = [], therapyIds = []) {
  try {
    const filteredGoalsData = goalsData.filter(
      (goal) =>
        (!goal.RS || goal.RS !== "DELETEACTIVITY") &&
        goal.TherapyId && therapyIds.indexOf(goal.TherapyId) > -1
    )
      .map((goal) => {
        let parsedGJ = null;
        try {
          parsedGJ = goal.Response
            ? JSON.parse(goal.Response)
            : null;
        } catch (e) {
          try {
            parsedGJ = goal.Response
              ? JSON.parse(goal.Response.replaceAll("\\", ""))
              : null;
          } catch {
            parsedGJ = null;
          }
        }
        return { ...goal, GJ: parsedGJ };
      });

    return filteredGoalsData
  } catch (error) {
    console.log("Error in GetGoalsByTherapyIds" + error.message);
    return [];
  }
}

export function GetAchivedString(each, goal, type, index, $selfGSuggestion) {

  try {
    var htmlString = <div >
      <div className="appip title" style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '-2px', float: 'left', marginBottom: '5px', marginLeft: "-3px" }}><svg style={{ width: "34px" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68" id="autism-affection"><path d="M3.4 31.7c2.8 1.7 6.1 2.6 10.1 2.6 7.7 0 12.5-2.4 15.7-3.1.7-.2 1.4-.2 2-.3L31 43.7c-1.3-.2-2.7-.7-4.3-.7-1.8 0-3.5 2.4-1.5 4.4-1 1-1.2 2.7 0 4-1.8 2 .2 4.3 2.5 5.6-1.1.9-1.4 2.2-.9 3.4 1.3 3.1 8.8 8.9 20.6 4.1.7-.3 2.3-.9 3.3-1.5 1.7 1.1 7.9 1.6 11.9 1.2.4 0 .7-.4.7-.8s-.4-.7-.8-.7c-2.7.3-5.4.2-8-.2 3.2-3 2.4-8.2.5-12.2 3.4.5 3.3.8 9.4 1.7.4.1.8-.2.9-.6.1-.4-.2-.8-.6-.9-5.5-.8-9.8-1.9-11-1.9-1.1-.7-2.5-.6-3.1.8-2.7-5-7.6-10.5-12.1-12.5-.4-.2-.8-.3-1.2-.4.7-10.4 1.5-21.3 1.4-31.7-.3-.6-.9-1.3-1-1.4-3.5-1.9-6.3-1.8-10.3-1-4 .6-7.4 2.1-11.1 2.8-3.5.8-8.3 0-11.4-1.8-.5-.3-1.1.1-1.1.6-.7 7.5-1 18.7-.7 27.1 0 .3.1.5.3.6zm33.9 12.1 1.5 1.5c-.1 0-.8-.1-1.5-.2v-1.3zm-2.4-7c-.7.7-1 1.8-.8 2.7.1.5.3.9.6 1.3l-.1 3.7c-.1 0-1.9-.5-2.1-.5l.2-13.2c.7 0 1.4.2 2.1.4 0 .1.1 6 .1 5.6zm15.2 15.4c.4.8 1.6.4 1.4-.5 0-.3-.1-2 .5-2.1.3 0 .6.1.9.4 2.3 2.4 3.2 10.6-.3 11.9-.4.2-.9.1-1.2-.2-.2-.2-.2-.6-.1-.8.9-.8-.1-1.9-.9-1.3-1.7 1.3-3.5 2.1-5.5 2.6C37.7 64 30.8 62 28.4 60c-.7-.6-.6-1.7 1.2-2.2.4.1.8.3 1.3.3 1 .2 1.2-1.3.3-1.5-.9-.2-1.6-.5-2.4-.7-.9-.2-3.9-2.7-2.3-3.7.7.2 3.1.8 4.7 1.2 1 .3 1.3-1.2.4-1.4-1.4-.4-4-1-4.6-1.2-1-.3-1.7-1.6-.4-2.6 2.8 1.2 3.4 1.1 4.2 1.2 1 .2 1.3-1.3.3-1.5-1.1-.2-4.1-.8-4.9-1.7-1-1 0-1.8.5-1.8 3.1.1 11 2.7 14 2.3.9.7 1.7-.6 1-1.2-1.7-1-3.7-3.1-5-4.5-.5-.5-1-1.2-1.1-1.8-.2-1 .3-1.9 2-1.1 3.7 1.6 9.3 7.1 12.5 14.1zM5.2 5.3c3.4 1.6 7.9 2.2 11.5 1.5 3.8-.8 7.1-2.2 10.8-3 3.6-.8 5.9-.9 8.8.6.2 8.4-.6 17.1-1.2 25.4-2-.5-4-.6-6.3 0-1.8.4-8.6 3.2-15.6 3.1-3 0-6-.6-8.7-2.1-.2-8.1 0-18.2.7-25.5z" /><path d="M19.4 28.5c.2.1.4.1.6 0 5.5-2.5 11.8-5.7 11-12.3-.4-2.9-2.7-5.5-5.6-6-2.3-.4-5.3.3-7 2.3-1.6-1.8-4.4-2.1-6.5-.9-2.2 1.3-3.4 4.2-3 7.1.9 5.2 5.7 7.9 10.5 9.8zm-6.6-15.7c1.6-1 4.2-.5 5 1.3.3.6 1.1.6 1.3 0 1.1-2.1 3.9-2.9 6.1-2.5 2.2.4 4 2.4 4.3 4.7.7 5.6-5.2 8.5-9.9 10.7-4.2-1.7-8.5-4.1-9.1-8.6-.3-2.3.6-4.6 2.3-5.6zm46.9 45c-1-.3-2 1.7-1 2.9 1.1 1.3 3.4.5 3.3-1.3-.1-.5-.3-1-.8-1.3-.4-.4-1-.5-1.5-.3zm.4 2c-.1 0-.3-.1-.3-.2.2-.2.1-.3.3-.4.5-.1.5.7 0 .6z" /></svg>

        Achievement Criteria: </div>
      <div className="consultations-sets gwall walltabs-profile goalssuggestion" style={{ marginTop: "0px" }}>
        <div className="wall-tabs ">

          <ul className="title-consult profile-ul" data-id="pending" style={{ paddingLeft: '0px', marginLeft: '0px', borderRadius: "10px 10px 0px 0px", width: "100%" }}>
            <li style={{ width: "16%", marginBottom: "0px" }} className={"selection-ac-set " + ((($selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "10-" + index + "-" + goal.Id) || !$selfGSuggestion.state.PercentageFilterType || !$selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index]) ? "active" : "")} onClick={$selfGSuggestion.PercentageFilter.bind(this, (type + "10-" + index + "-" + goal.Id), (goal.Id + "-" + index))}>

              <span> 10% <span style={{ width: "100%", display: "inline-block", paddingTop: "0px", marginTop: "-3px" }}></span></span>
            </li>
            <li style={{ width: "16%", marginBottom: "0px" }} data-Type={goal.Id + "-" + index} className={"selection-ac-set " + ($selfGSuggestion.state.PercentageFilterType && ($selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "25-" + index + "-" + goal.Id) ? "active" : "")} onClick={$selfGSuggestion.PercentageFilter.bind(this, (type + "25-" + index + "-" + goal.Id), (goal.Id + "-" + index))}>


              <span>25%<span style={{ width: "100%", display: "inline-block", paddingTop: "0px", marginTop: "-3px" }}></span></span>
            </li>
            <li style={{ width: "16%", marginBottom: "0px" }} className={"selection-ac-set " + ($selfGSuggestion.state.PercentageFilterType && ($selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "45-" + index + "-" + goal.Id) ? "active" : "")} onClick={$selfGSuggestion.PercentageFilter.bind(this, (type + "45-" + index + "-" + goal.Id), (goal.Id + "-" + index))}>


              <span>45%<span style={{ width: "100%", display: "inline-block", paddingTop: "0px", marginTop: "-3px" }}></span></span>
            </li>
            <li style={{ width: "17%", marginBottom: "0px" }} className={"selection-ac-set " + ($selfGSuggestion.state.PercentageFilterType && ($selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "70-" + index + "-" + goal.Id) ? "active" : "")} onClick={$selfGSuggestion.PercentageFilter.bind(this, (type + "70-" + index + "-" + goal.Id), (goal.Id + "-" + index))}>


              <span>70%<span style={{ width: "100%", display: "inline-block", paddingTop: "0px", marginTop: "-3px" }}></span></span>
            </li>
            <li style={{ width: "17%", marginBottom: "0px" }} className={"selection-ac-set " + ($selfGSuggestion.state.PercentageFilterType && ($selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "90-" + index + "-" + goal.Id) ? "active" : "")} onClick={$selfGSuggestion.PercentageFilter.bind(this, (type + "90-" + index + "-" + goal.Id), (goal.Id + "-" + index))}>


              <span>90%<span style={{ width: "100%", display: "inline-block", paddingTop: "0px", marginTop: "-3px" }}></span></span>
            </li>
            <li style={{ width: "18%", marginBottom: "0px", boxShadow: "none", borderRadius: "0px" }} className={"selection-ac-set " + ($selfGSuggestion.state.PercentageFilterType && ($selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "100-" + index + "-" + goal.Id) ? "active" : "")} onClick={$selfGSuggestion.PercentageFilter.bind(this, (type + "100-" + index + "-" + goal.Id), (goal.Id + "-" + index))}>


              <span>100%<span style={{ width: "100%", display: "inline-block", paddingTop: "0px", marginTop: "-3px" }}></span></span>
            </li>

            {/* <li className={"selection-n-set " + (this.state.wallFilterState && this.state.wallFilterState.toLowerCase() == "suggest"+goal.Id ? "active" : "")} onClick={this.WallTabsFilter.bind(this, "suggest"+goal.Id)}>

                    <span> Suggest <span style={{ width: "100%", display: "inline-block", paddingTop: "0px", marginTop: "-3px" }}></span></span>
                  </li> */}
          </ul>
        </div>
      </div>
      <div style={{ float: 'left', width: '100%', marginTop: '3px', boxShadow: '0px 2px 2px #c6c6c6', padding: '10px', borderRadius: '0px 0px 10px 10px' }}>
        {

          ($selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "10-" + index + "-" + goal.Id) || !$selfGSuggestion.state.PercentageFilterType || !$selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] ?
            each.AchievementCriteria.TenPercent : ''
        }
        {
          $selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "25-" + index + "-" + goal.Id ?
            each.AchievementCriteria.TwentyFivePercent : ''
        }
        {
          $selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "45-" + index + "-" + goal.Id ?
            each.AchievementCriteria.FortyFivePercent : ''
        }
        {
          $selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "70-" + index + "-" + goal.Id ?
            each.AchievementCriteria.SeventyPercent : ''
        }
        {
          $selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "90-" + index + "-" + goal.Id ?
            each.AchievementCriteria.NinetyPercent : ''
        }
        {
          $selfGSuggestion.state.PercentageFilterType && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index] && $selfGSuggestion.state.PercentageFilterType[goal.Id + "-" + index].toLowerCase() == type + "100-" + index + "-" + goal.Id ?
            each.AchievementCriteria.CentPercent : ''
        }

      </div>
    </div>

    return htmlString;

  } catch (error) {
    console.log("Error in GetAchivedString:" + error);
  }
}

export function getReepetionOpetions(text) {
  var length = fetchNumberOfIterations(text);
  var options = [];
  for (var i = 0; i < length; i++) {
    options.push({ Name: (i + 1), Val: (i + 1) })
  }
  return options;
}
export function fetchNumberFromText(text) {

  if (!text) {
    return 0;
  }

  var thenum = (text.match(/(\d+)/) || [])[0];
  if (isNaN(thenum)) {
    return 0;
  }
  return parseInt(thenum);
}

export function fetchNumberOfIterations(text) {

  if (!text) {
    return 4;
  }

  var thenum = (text.match(/(\d+)/) || [])[0];
  if (isNaN(thenum)) {
    return 4;
  }
  return parseInt(thenum);
}


export function GetGoalAchievement(session, goal) {
  console.log("GetGoalAchievement");
  console.log(session);
  console.log(goal);
  if (session.TherapySessionPlan && session.TherapySessionPlan.length > 0 && goal && goal.length > 0) {
    var response;
    try {
      response = JSON.parse(goal[0].Response);
    } catch (e) {
      response = JSON.parse(goal[0].Response.replaceAll("\\", ""));
    }
    //var goals = [];
    var goals = [];

    if (response.StretchGoals && response.StretchGoals.length > 0) {
      goals = [...response.CommittedGoals, ...response.StretchGoals];
    }
    else {
      goals = response.CommittedGoals;
    }

    var groupedGoals = groupBy(goals, "Goal", true);
    var groupedGoalId = groupBy(goals, "GoalId");

    var havingGS = [];

    goals.forEach(function (e) {
      e.SQ = e.SQ ? e.SQ : 0;
      havingGS.push(e);
    });

    var seQuenceGoals = groupBy(havingGS, "SQ", false);

    var goalTitles = goals.map(m => m.Goal.toLowerCase());

    for (var i = 0; i < session.TherapySessionPlan.length; i++) {


      // var tokens = tokenSimilarity(session.TherapySessionPlan[i].Goal.toLowerCase(),goalTitles);

      // console.log(tokens);

      //session.TherapySessionPlan[i].AchievementCriteria = groupedGoals[session.TherapySessionPlan[i].Goal.toLowerCase()] && groupedGoals[session.TherapySessionPlan[i].Goal.toLowerCase()][0].AchievementCriteria;

      // if(!session.TherapySessionPlan[i].AchievementCriteria)
      // {
      var matchedGoalData = session.TherapySessionPlan[i] && session.TherapySessionPlan[i].Goal ? (session.TherapySessionPlan[i].Goal.toLowerCase()) : (session.TherapySessionPlan[i].GS && session.TherapySessionPlan[i].GS > 0 && seQuenceGoals && seQuenceGoals[session.TherapySessionPlan[i].GS] && seQuenceGoals[session.TherapySessionPlan[i].GS].length > 0 ? seQuenceGoals[session.TherapySessionPlan[i].GS][0].Goal : "")
      if ((!matchedGoalData || matchedGoalData == "") && session.TherapySessionPlan[i].GoalId && groupedGoalId) {
        matchedGoalData = groupedGoalId && groupedGoalId[session.TherapySessionPlan[i].GoalId] && groupedGoalId[session.TherapySessionPlan[i].GoalId].length > 0 ? groupedGoalId[session.TherapySessionPlan[i].GoalId][0].Goal.toLowerCase() : "";
      }
      var matchedGoal = matchedGoalData ? PinnacleNLP(matchedGoalData, goalTitles) : "";
      var matchedSequence = havingGS.filter(e => e.Goal.toLowerCase() == matchedGoal.toLowerCase());
      if (matchedGoal) {
        console.log(matchedGoal);
        console.log(groupedGoals[matchedGoal]);
        session.TherapySessionPlan[i].Goal = matchedGoalData;
        session.TherapySessionPlan[i].Skills = groupedGoals[matchedGoal][0].Skills ? groupedGoals[matchedGoal][0].Skills : '';
        session.TherapySessionPlan[i].AchievementCriteria = groupedGoals[matchedGoal][0].AchievementCriteria;
        session.TherapySessionPlan[i].GoalMatched = matchedGoal;
        session.TherapySessionPlan[i].Conditions = groupedGoals[matchedGoal][0].Conditions;
        session.TherapySessionPlan[i].Behaviors = groupedGoals[matchedGoal][0].Behaviors;
        session.TherapySessionPlan[i].GId = goal[0].Id;
        session.TherapySessionPlan[i].GS = matchedSequence ? matchedSequence[0].SQ : 0;
      }

      // }

    }
  }

  return session;
}

/**#region Prognosis */

export function GetAllSkillPrognosis(allTypes, currentAblityScoreAssessmnts) {

  try {
    if (!currentAblityScoreAssessmnts) return;



    var currentType = currentAblityScoreAssessmnts.Type == "CHILD" ? "CHILD" : "TODDLER";

    var allSkills = allTypes.filter(e => e.Category == 'THERAPEUTICEIPASSESSMENTS' && e.F2 != 'Overall' && e.RS != 'DELETEACTIVITY' && e.F31 == currentType);
    console.log("allSkills", allSkills);

    var overallObjects = [];


    allSkills.forEach(skill => {


      var prognosis = GetSkillPrognosis(skill.F2, allTypes, currentAblityScoreAssessmnts);
      overallObjects.push(prognosis);


    });

    console.log("overallObjects", overallObjects);


  } catch (e) {
    console.log(e);
  }

}

export function GetPrognosisBySkills(skills, allTypes, currentAblityScoreAssessmnts) {
  try {
    var overallObjects = [];


    skills.forEach(skill => {
      var prognosis = GetSkillPrognosis(skill, allTypes, currentAblityScoreAssessmnts);
      overallObjects.push(prognosis);
    });

    //console.log("overallAbilitiesPrognosis", overallObjects);
    return overallObjects;
  } catch (e) {
    console.log(e)
  }

}


export function GetAllAbilityPrognosis(allTypes, currentAblityScoreAssessmnts) {

  try {
    if (!currentAblityScoreAssessmnts) return;



    var currentType = currentAblityScoreAssessmnts.Type == "CHILD" ? "CHILD" : "TODDLER";

    var allSkills = allTypes.filter(e => e.Category == 'ASABILITIES' && e.F2 != 'Overall' && e.RS != 'DELETEACTIVITY' && e.F31 == currentType);
    //console.log("allSkills", allSkills);

    var overallObjects = [];


    allSkills.forEach(skill => {


      var prognosis = GetAbilityPrognosis(skill.F2, allTypes, currentAblityScoreAssessmnts);
      overallObjects.push(prognosis);


    });

    //console.log("overallAbilitiesPrognosis", overallObjects);


  } catch (e) {
    console.log(e);
  }

}




function getPrognisValuesforskill(keys, prognosis, cStage) {

  var cValue = 0;
  Object.keys(keys).forEach(key => {

    try {
      var cKey = key == 'SchoolRI' ? 'SCRI' : key;
      if (key == 'F2') {
        cStage = (cStage - 1) <= 0 ? 1 : (cStage - 1);
      }
      cValue += ((prognosis[cKey][0]["S" + cStage] || 0) / 100) * keys[key];
    } catch (r) {

    }


  });

  return cValue;
}

export function GetSkillPrognosis(skillname, allTypes, currentAblityScoreAssessmnts) {

  // skillname = "Child Characteristics";

  try {
    if (!currentAblityScoreAssessmnts) return;



    currentAblityScoreAssessmnts.SP = currentAblityScoreAssessmnts.SP && currentAblityScoreAssessmnts.SP.length > 0 ? currentAblityScoreAssessmnts.SP : [];
    // find index for same skill
    let idx = currentAblityScoreAssessmnts.SP && currentAblityScoreAssessmnts.SP.length > 0 ? currentAblityScoreAssessmnts.SP.findIndex(x => x.Key == skillname) : -1;
    if (idx >= 0) {
    
        return currentAblityScoreAssessmnts.SP[idx];
    }

    var currentType = currentAblityScoreAssessmnts.Type == "CHILD" ? "CHILD" : "TODDLER";
    // var skill = allTypes.find(t => t.Id == skillid);
    // if (!skill) return;

    var currentPGNConfig = currentAblityScoreAssessmnts.PGN ? JSON.parse(currentAblityScoreAssessmnts.PGN) : [];
    var pgnGroup = groupBy(currentPGNConfig, "Key");

    // these are all band categories to include
    var PGNKeys = ["BTRI", "MSRI", "OTRI", "SchoolRI", "SERI", "SSRI", "STRI", "F2"];

    var skillsFromAssessment = currentAblityScoreAssessmnts.DomainResponse;



    var skillConfiguration = { Max: 0, Score: 0, Keys: {} };

    PGNKeys.forEach(key => {



      var skillsConfig = null;
      var currentSkill = {};
      var totalWeightage = 0;
      if (key == "F2") {
        skillsConfig = skillsFromAssessment ? JSON.parse(skillsFromAssessment) : [];
        var allSkillsFromAssessment = skillsConfig.filter(t => t.DN == skillname);
        currentSkill = allSkillsFromAssessment[0];
        currentSkill.Weightage = allSkillsFromAssessment.reduce((acc, curr) => acc + curr.W, 0);
        totalWeightage = skillsConfig.reduce((acc, curr) => acc + curr.W, 0);
      }
      else {
        var cfg = allTypes.find(e => e.Category == key && e.F1 == currentType);

        if (!cfg) return;
        skillsConfig = cfg.F4 ? JSON.parse(cfg.F4) : [];
        totalWeightage = skillsConfig.reduce((acc, curr) => acc + curr.Weightage, 0);

        currentSkill = skillsConfig.find(t => t.Name == skillname);
      }



      if (!currentSkill) return;


      var max1000Contribution = (currentSkill.Weightage / totalWeightage) * 100;
      var cKey = key == 'SchoolRI' ? 'SCRI' : key;

      skillConfiguration.Max += 10 * (max1000Contribution);
      skillConfiguration.Score += (currentAblityScoreAssessmnts[cKey] / 100) * max1000Contribution;
      skillConfiguration.Keys[key] = max1000Contribution;


    });

    var stageValue = skillConfiguration.Max / 10;
    var currentStage = skillConfiguration.Score / stageValue;


    var prognosisObject = {};
    prognosisObject.Key = skillname;
    prognosisObject.CS = currentStage;
    prognosisObject.MaxValue = skillConfiguration.Max;
    prognosisObject.Score = skillConfiguration.Score;
    prognosisObject.SValue = stageValue;
    for (let i = 1; i <= 10; i++) {



      if (currentStage >= i) {
        prognosisObject["S" + i] = null;
      } else {

        //keys, prognosis, cStage
        prognosisObject["S" + i] = getPrognisValuesforskill(skillConfiguration.Keys, pgnGroup, i);
      }
    }

    prognosisObject.CDT = currentAblityScoreAssessmnts.CDT;
    prognosisObject.KidId = currentAblityScoreAssessmnts.KidId;

    //console.log("prognosisObject", prognosisObject);


    if (idx >= 0) {
      currentAblityScoreAssessmnts.SP[idx] = prognosisObject; // replace
    } else {
      currentAblityScoreAssessmnts.SP.push(prognosisObject);  // add
    }
    return prognosisObject;

  } catch (e) {
    console.log(e);
  }

}

export function GetAbilityPrognosis(abilityname, allTypes, currentAblityScoreAssessmnts) {

  // skillname = "Child Characteristics";

  try {
    if (!currentAblityScoreAssessmnts) return;


    currentAblityScoreAssessmnts.AP = currentAblityScoreAssessmnts.AP && currentAblityScoreAssessmnts.AP.length > 0 ? currentAblityScoreAssessmnts.AP : [];
    // find index for same skill
    let idx = currentAblityScoreAssessmnts.AP && currentAblityScoreAssessmnts.AP.length > 0 ? currentAblityScoreAssessmnts.AP.findIndex(x => x.Key == abilityname) : -1;
    if (idx >= 0) {
    
        return currentAblityScoreAssessmnts.AP[idx];
    }

    var currentType = currentAblityScoreAssessmnts.Type == "CHILD" ? "CHILD" : "TODDLER";
    // var skill = allTypes.find(t => t.Id == skillid);
    // if (!skill) return;

    var currentPGNConfig = currentAblityScoreAssessmnts.PGN ? JSON.parse(currentAblityScoreAssessmnts.PGN) : [];
    var pgnGroup = groupBy(currentPGNConfig, "Key");

    // these are all band categories to include
    var PGNKeys = ["BTRI", "MSRI", "OTRI", "SchoolRI", "SERI", "SSRI", "STRI", "F2"];

    var abilitiesFromAssessment = currentAblityScoreAssessmnts.F1;



    var skillConfiguration = { Max: 0, Score: 0, Keys: {} };

    PGNKeys.forEach(key => {



      var skillsConfig = null;
      var currentSkill = {};
      var totalWeightage = 0;
      if (key == "F2") {
        skillsConfig = abilitiesFromAssessment ? JSON.parse(abilitiesFromAssessment) : [];
        var allSkillsFromAssessment = skillsConfig.filter(t => t.DK == abilityname);
        currentSkill = allSkillsFromAssessment[0];
        currentSkill.Weightage = allSkillsFromAssessment.reduce((acc, curr) => acc + curr.W, 0);
        totalWeightage = skillsConfig.reduce((acc, curr) => acc + curr.W, 0);
      }
      else {
        var cfg = allTypes.find(e => e.Category == key && e.F1 == currentType);

        if (!cfg) return;
        skillsConfig = cfg.F5 ? JSON.parse(cfg.F5) : [];
        totalWeightage = skillsConfig.reduce((acc, curr) => acc + curr.Weightage, 0);

        currentSkill = skillsConfig.find(t => t.Name == abilityname);
      }



      if (!currentSkill) return;


      var max1000Contribution = (currentSkill.Weightage / totalWeightage) * 100;
      var cKey = key == 'SchoolRI' ? 'SCRI' : key;

      skillConfiguration.Max += 10 * (max1000Contribution);
      skillConfiguration.Score += (currentAblityScoreAssessmnts[cKey] / 100) * max1000Contribution;
      skillConfiguration.Keys[key] = max1000Contribution;


    });

    var stageValue = skillConfiguration.Max / 10;
    var currentStage = skillConfiguration.Score / stageValue;


    var prognosisObject = {};
    prognosisObject.Key = abilityname;
    prognosisObject.CS = currentStage;
    prognosisObject.MaxValue = skillConfiguration.Max;
    prognosisObject.Score = skillConfiguration.Score;
    prognosisObject.SValue = stageValue;
    for (let i = 1; i <= 10; i++) {



      if (currentStage >= i) {
        prognosisObject["S" + i] = null;
      } else {

        //keys, prognosis, cStage
        prognosisObject["S" + i] = getPrognisValuesforskill(skillConfiguration.Keys, pgnGroup, i);
      }
    }

    //console.log("prognosisObject", prognosisObject);
    if (idx >= 0) {
      currentAblityScoreAssessmnts.AP[idx] = prognosisObject; // replace
    } else {
      currentAblityScoreAssessmnts.AP.push(prognosisObject);  // add
    }
    return prognosisObject;

  } catch (e) {
    console.log(e);
  }

}


export function GetDevelopmentalPrognosis(developmentalDomain, allTypes, currentAblityScoreAssessmnts) {
  try {
    console.log("GetDevelopmentalPrognosis");
    console.log(developmentalDomain);
    if (!developmentalDomain) return;

    currentAblityScoreAssessmnts.DP = currentAblityScoreAssessmnts.DP && currentAblityScoreAssessmnts.DP.length > 0 ? currentAblityScoreAssessmnts.DP : [];
    // find index for same skill
     let idx = currentAblityScoreAssessmnts.DP && currentAblityScoreAssessmnts.DP.length > 0 ? currentAblityScoreAssessmnts.DP.findIndex(x => x.Key == developmentalDomain.FirstName) : -1;
    // if (idx >= 0) {
    
    //     return currentAblityScoreAssessmnts.DP[idx];
    // }


    var organs = developmentalDomain.Organs;
    if(!organs){
      return;
    }


    var mappedSkills = organs.flatMap(t=> t.skills_linked);
    var groupdAbilites = groupBy(mappedSkills, "Ability");
    var abilities = Object.keys(groupdAbilites);
    var abilitiyPrognosis = GetPrognosisByAbilities(abilities, allTypes, currentAblityScoreAssessmnts);

    // var organsPrognosis = GetPrognosisByOrgans(organs, allTypes, currentAblityScoreAssessmnts);
    // console.log(organsPrognosis);
    var developmentPrognosis = {};
    developmentPrognosis.Key = developmentalDomain.FirstName;

    var currentStage = Math.floor(Math.min(...abilitiyPrognosis.map(a => a.CS)));
    developmentPrognosis.CS = currentStage;

    for (let i = 1; i <= 10; i++) {

      if (i <= currentStage) {
        developmentPrognosis["S" + i] = null;
      } else {
        let stg = "S" + i;
        let total = 0;

        abilitiyPrognosis.forEach(a => {
          let v = a[stg];
          if (v != null && !isNaN(v)) total += v;
        });

        developmentPrognosis[stg] = total;
      }
    }

    console.log("developmentPrognosis", developmentPrognosis);


    if (idx >= 0) {
      currentAblityScoreAssessmnts.DP[idx] = developmentPrognosis; // replace
    } else {
      currentAblityScoreAssessmnts.DP.push(developmentPrognosis);  // add
    }

    return developmentPrognosis;


  } catch (error) {
    console.log(error);
  }
}

export function getAssessmentColorCounts(UserData, kidId, organMapList) {
  console.log("D")
  const organs = organTOSkillMapped.reduce((m,o)=>(m[o.OrganId]=(m[o.OrganId]||[]).concat(String(o.SkillId)),m),{});
  const parse = v => typeof v==="string"?JSON.parse(v||"[]"):v||[];
  return (UserData?.TherapeuticEipAssessments||[])
    .filter(a=>a.KidId==kidId && a.RS!='DELETEACTIVITY' && a.F3 != "PENDING")
    .map(a=>{
      let r=0,y=0,g=0;
      const d=parse(a.DomainResponse);
      for(const k in organs){
        const f=d.filter(x=>organs[k].includes(String(x.DId)));
        const [ds,ts]=f.reduce(([s1,s2],x)=>[s1+(+x.DS||0),s2+(+x.TS||0)],[0,0]);
        if(!ts)continue;
        const p=(ds/ts)*100;
        p>=70?g++:p>=30?y++:r++;
      }
      const dt=new Date(a.CDT);
      return {AssessmentMonth:dt.toLocaleString("en",{month:"short"}),RedCount:r,YellowCount:y,GreenCount:g,date:dt};
    })
    .sort((a,b)=>a.date-b.date)
    .map(({date,...rest})=>rest);
}

export function getPrognosisProgress(lastDate, lastScore, totalSessions, assessmentsCount) {
  const clamp = (x, lo, hi) => Math.min(hi, Math.max(lo, x));
  const daysBetween = (a, b) => Math.max(0, Math.ceil((b - a) / 86400000));
  const addOneMonthSameDay = (d) => {
    const dom = d.getDate();
    const base = new Date(d.getFullYear(), d.getMonth() + 1, 1);
    const last = new Date(base.getFullYear(), base.getMonth() + 1, 0).getDate();
    base.setDate(Math.min(dom, last));
    return base;
  };

  const totalPoints = 9;
  const keptAssess = Math.min(Number(assessmentsCount) || 0, 6);
  const prognosisCount = Math.max(0, totalPoints - keptAssess);
  if (!prognosisCount) return [];

  const anchor = new Date(lastDate);
  const today = new Date();

  // Average gain per session (no F2 provided → use lastScore / totalSessions)
  const ts = Math.max(0, Number(totalSessions) || 0);
  const perSessionDelta = ts > 0 ? (Number(lastScore) || 0) / ts : 0;

  // Spread remaining sessions evenly across prognosis points
  const sessionsPerPoint = ts > 0 ? Math.ceil(ts / prognosisCount) : 0;
  const monthlyIncrement = perSessionDelta * sessionsPerPoint;

  const out = [];
  let prev = new Date(anchor);

  for (let i = 0; i < prognosisCount; i++) {
    const next = addOneMonthSameDay(prev);

    // Scale first month if the last assessment is fresh (≤30 days old)
    let scale = 1;
    if (i === 0 && daysBetween(anchor, today) <= 30) {
      const fullGap = Math.max(1, daysBetween(anchor, next));
      const partial = Math.max(0, daysBetween(today, next));
      scale = clamp(partial / fullGap, 0, 1);
    }

    const effectiveMonths = i === 0 ? scale : (i + scale); // s, 1+s, 2+s ...
    const predicted = clamp(Math.round((Number(lastScore) || 0) + monthlyIncrement * effectiveMonths), 0, 100);

    out.push({
      date: next.toISOString().slice(0, 10),
      month: next.toLocaleString("en", { month: "short" }),
      percent: predicted,
      source: "prognosis",
    });

    prev = next;
  }

  return out;
}

export function getKidDomainPercents(UserData, kidId, skillIds) {
  const ids = new Set(skillIds.map(String));
  return (UserData?.TherapeuticEipAssessments || [])
    .filter(a => a.KidId == kidId && a.RS!='DELETEACTIVITY' && a.F3 != "PENDING")
    .map(a => {
      const d = typeof a.DomainResponse === "string" ? JSON.parse(a.DomainResponse || "[]") : (a.DomainResponse || []);
      const f = d.filter(x => ids.has(String(x.DId)));
      const [ds, ts] = f.reduce(([s1, s2], x) => [s1 + (+x.DS || 0), s2 + (+x.TS || 0)], [0, 0]);
      const p = ts ? (ds / ts) * 100 : 0;
      const dt = new Date(a.CDT);
      return { date: dt.toISOString().slice(0,10), month: dt.toLocaleString("en",{month:"short"}), percent:+p.toFixed(2) };
    });
}


export function GetPrognosisByAbilities(abilities, allTypes, currentAblityScoreAssessmnts) {
  try {
    var overallObjects = [];


    abilities.forEach(ability => {


      var prognosis = GetAbilityPrognosis(ability, allTypes, currentAblityScoreAssessmnts);
      if(prognosis){
overallObjects.push(prognosis);
      }
      


    });

    //console.log("overallAbilitiesPrognosis", overallObjects);
    return overallObjects;
  } catch (e) {
    console.log(e)
  }

}

export function GetOrganPrognosis(organ, allTypes, currentAblityScoreAssessmnts) {
  try {
    // console.log("GetOrganPrognosis");
    // console.log(organ);

    if(organ.FirstName == "Cerebellum"){
       console.log("organ.FirstName",organ.FirstName)
    }
    if (!organ) return;
    if(organ.Organs && organ.Organs.length > 0)
    {
      return GetPrognosisByOrgans(organ.Organs,allTypes,currentAblityScoreAssessmnts);
    }

    currentAblityScoreAssessmnts.OP = currentAblityScoreAssessmnts.OP && currentAblityScoreAssessmnts.OP.length > 0 ? currentAblityScoreAssessmnts.OP : [];
    // find index for same skill
    let idx = currentAblityScoreAssessmnts.OP && currentAblityScoreAssessmnts.OP.length > 0 ? currentAblityScoreAssessmnts.OP.findIndex(x => x.Key == organ.FirstName) : -1;
    if (idx >= 0) {
    
        return currentAblityScoreAssessmnts.OP[idx];
    }



    var groupdAbilites = groupBy(organ.skills_linked, "Ability");
    var abilities = Object.keys(groupdAbilites);
    var abilitiyPrognosis = GetPrognosisByAbilities(abilities, allTypes, currentAblityScoreAssessmnts);
    //console.log(abilitiyPrognosis);
    var organPrognosis = {};
    organPrognosis.Key = organ.FirstName;

    var currentStage = Math.floor(Math.min(...abilitiyPrognosis.map(a => a.CS)));
    organPrognosis.CS = currentStage;

    for (let i = 1; i <= 10; i++) {

      if (i <= currentStage) {
        organPrognosis["S" + i] = null;
      } else {
        let stg = "S" + i;
        let total = 0;

        abilitiyPrognosis.forEach(a => {
          let v = a[stg];
          if (v != null && !isNaN(v)) total += v;
        });

        organPrognosis[stg] = total;
      }
    }

    //console.log("organPrognosis", organPrognosis);


    if (idx >= 0) {
      currentAblityScoreAssessmnts.OP[idx] = organPrognosis; // replace
    } else {
      currentAblityScoreAssessmnts.OP.push(organPrognosis);  // add
    }

    return organPrognosis;


  } catch (error) {
    console.log(error);
  }
}


export function GetPrognosisByOrgans(organs, allTypes, currentAblityScoreAssessmnts) {
  try {
    var overallObjects = [];


    organs.forEach(organ => {


      var prognosis = GetOrganPrognosis(organ, allTypes, currentAblityScoreAssessmnts);
      if(prognosis){
overallObjects.push(prognosis);
      }
      else{
         console.log("Organ Prognosis Faild",organ);
      }
      


    });

    console.log("overallAbilitiesOrgans", overallObjects);
    return overallObjects;
  } catch (e) {
    console.log(e)
  }

}

/**#endregion */

export function GetGoalsAIStringSeperator(text) {
  if (!text) {
    return null;
  }
  var obj = {};
  var tasks1 = text.split(/(?=Task \d+:)/gi);
  tasks1 = tasks1.filter(f => f.toLowerCase().indexOf("task") > -1);
  if (tasks1 && tasks1.length > 0) {


    var goals = tasks1[0].replace("Task 1: ", "").replace("task 1: ", "").replace("Task 1:", "").replace("task 1:", "").replace("Task 1 ", "").replace("task 1 ", "").replace("Task 1", "").replace("task 1", "");
    goals = goals.replace("Committed Goals for the Next 20 Sessions", "Committed Goals").replace("Stretch Goals for the Next 20 Sessions", "Stretch Goals").replace("Committed Goals for Speech Therapy:", "Committed Goals:").replace("Stretch Goals for Speech Therapy:", "Stretch Goals:")
      .replace("Committed Goals for Occupational Therapy:", "Committed Goals:").replace("Stretch Goals for Occupational Therapy:", "Stretch Goals:")
      .replace("Committed Goals for Behavioral Modification:", "Committed Goals:").replace("Stretch Goals for Behavioral Modification:", "Stretch Goals:")
      .replace("Committed Goals for Special Education:", "Committed Goals:").replace("Stretch Goals for Special Education:", "Stretch Goals:")
      .replace("Committed Goals for Psychological Counseling:", "Committed Goals:").replace("Stretch Goals for Psychological Counseling:", "Stretch Goals:")
      .replace("Committed Goals for Autism Therapy:", "Committed Goals:").replace("Stretch Goals for Autism Therapy:", "Stretch Goals:")
      .replace("Closing Comments for Therapist", "Closing Comments").replace("Closing Comments for a Therapist", "Closing Comments")
    var tasks = goals.split(/Committed Goals:|Stretch Goals:|Closing Comments/gi);


    if (tasks && tasks.length > 0) {
      obj.Brief = tasks[0];
    }
    if (tasks && tasks.length > 1) {
      obj.Commited = tasks[1];
    }
    if (tasks && tasks.length > 2) {
      obj.Strech = tasks[2];
    }
    if (tasks && tasks.length > 3) {
      obj.Conclusion = tasks[3];
    }
  }
  if (tasks1 && tasks1.length > 1) {
    var string2 = tasks1.length > 2 ? tasks1.filter(f => f.toLowerCase().indexOf("task 2") > -1)[0] : tasks1[1];
    obj.Review = string2.replace("Task 2: ", "").replace("task 2: ", "").replace("Task 2:", "").replace("task 2:", "").replace("Task 2 ", "").replace("task 2 ", "").replace("Task 2", "").replace("task 2", "");

  }
  return obj;
}

var services = ["ST", "BM", "SE", "OT"];
export function FetchLocalData(type, userdata, masterData, currentPersonDetails, completedAnalytics, status, fids, isAdmin, isOwner, isFacilityOwner, discipline, contributions, packagesFilters, responsibilitites, filtertherapists) {
  console.log("FetchLocalData");
  switch (type.toUpperCase()) {
    case "THERAPISTPTIASSESSMENT":
    case "THERAPISTPTIREPORT":
      if (userdata && userdata.Data) {

        var completed = status == "all" ? null : completedAnalytics ? completedAnalytics : $.grep(userdata.Data, function (e) { return e.AT == "ASSESSMENTCOMPLETED" && e.RS != "DELETEACTIVITY" });

        var completedAssessments = completed ? $.map(completed, function (e) { return (e.RDUId[0] + "") }) : [];
        var yesNeedToExecute = completedAssessments.length > 0 ? true : false;


        var data = $.grep(userdata.Data, function (e) { return e.AT == "BOOKASSESSMENT" && e.F23 == "THERAPISTPTI" && (yesNeedToExecute ? (status == "pending" ? completedAssessments.indexOf(e.UId + "") == -1 : completedAssessments.indexOf(e.UId + "") > -1) : true) });

        var mappedData = [];
        if (data) {
          data.forEach(function (e) {
            var bossDetails = e.F6 ? e.F6.split("{#}") : [];
            mappedData.push({
              'Category': 'Boss',
              'Name': (bossDetails.length > 2 ? bossDetails[2] : ''),
              'Call': (bossDetails.length > 3 ? bossDetails[3] : ''),
              'TOId': e.TOId,
            });

          });
        }

        var dataFinal = { "Data": mappedData };
        return dataFinal;
      }
      break;
    case "COWORKERS":

      var facilityData = userdata && userdata.Centers;
      var facilities = facilityData && facilityData.length > 0 ? $.grep(facilityData, function (e) { return fids && fids != 0 && fids.length > 0 ? fids.indexOf(e.Id) > -1 : true }) : [];
      var therapistsDataBlock = [];

      var kidsForTherapists = userdata && userdata.Therapies && userdata.Therapies.length > 0 ? $.grep(userdata.Therapies, function (r) { return r.Status != "INACTIVE" && r.Status != "InActive" && r.RS != "DELETEACTIVITY" && (fids && fids != 0 ? fids.indexOf(r.CenterId) > -1 : true) }) : [];

      /*var therapistRoleId = GetTypeIdByName(data.Types, "Therapist");*/

      /*var therapists = Object.entries(groupBy(userdata.People.filter(f => therapistRoleId == f.RoleId && fids.indexOf(f.CenterId) > -1), "Id")).map(m => m[1][0]);*/

      //var endingRank = Convert.ToInt64(therapists.Where(m => !string.IsNullOrEmpty(m.F30)).OrderByDescending(m => Convert.ToInt64(m.F30)).FirstOrDefault().F30);
      //var startingRank = Convert.ToInt64(therapists.Where(m => !string.IsNullOrEmpty(m.F30)).OrderBy(m => Convert.ToInt64(m.F30)).FirstOrDefault().F30);

      //var total = endingRank - startingRank;
      //var rankFirst = Math.Ceiling(startingRank + total + (total * 0.10));
      //var rankSecond = Math.Ceiling(startingRank + total + (total * 0.50));
      //var rankThird = Math.Ceiling(startingRank + total + (total * 0.90));
      //var facilities = GetAllFacilities();

      var therapists = GetAllTherapistsData(userdata, false, fids);
      var availableServices = getSlotsByData(kidsForTherapists, therapists);

      var datar = GetReportsData('pollinatedata', userdata, true, null, null, null);


      var chartData = {};
      var availableBydiscipline = {};
      var coworkersDes = [];
      if (discipline && discipline.length > 0) {
        coworkersDes = discipline.map(m => GetShortDesignation(m));
      }
      var availableTotal = 0;
      var pollinateTotal = 0;
      var totalEmployees = 0;
      var therapistIds = [];

      var highestsal = therapists.map(m => m.F7).reduce((partialSum, a) => partialSum + a, 0);
      var totalSal = highestsal / 4;
      //console.log(facilities);
      //console.log(highestsal);
      var allFinalFacilitites = [];
      for (var f = 0; f < facilities.length; f++) {
        var facility = JSON.parse(JSON.stringify(facilities[f]));

        facility.TS = therapists.filter(f => f.CenterId == facility.Id);


        var totalServicesOfCenter = 0;
        var totalSalariesByCenter = 0;
        var totalAvailableCountOfTheCenter = 0;
        if (facility && facility.TS) {
          facility.TS.sort((a, b) => (b.C < a.C ? -1 : 1));

          totalEmployees += facility.TS.length;
          for (var i = 0; i < facility.TS.length; i++) {
            var t = facility.TS[i];
            t.ASC = availableServices.filter(a => a.S == "available" && a.TherapistId == t.Id).length;
            discipline = discipline ? discipline.map(m => m.toLowerCase()) : null;

            if (discipline && discipline.length > 0 && t.Designation && discipline.indexOf(t.Designation.toLowerCase()) == -1) {
              continue;
            }

            var c = t.C > 11 ? ">11" : t.C;
            if (contributions && contributions.length > 0 && contributions.indexOf(c + "") == -1) {
              continue;
            }



            var therapist = {};
            therapist.Facility = facility.Name;
            therapist.Name = t.Name + (t.F2 ? " (" + t.F2 + ")" : "");

            therapist.Discipline = t.Designation;
            therapist.TOId = t.Id;
            therapistIds.push(t.Id);
            therapist.FId = facility.Id;
            therapist.Kids = t.C ? t.C : "0";
            var desc = GetShortDesignation(t.Designation);



            totalServicesOfCenter += parseInt(t.C);

            if (availableBydiscipline[desc]) {
              availableBydiscipline[desc] += parseInt(t.ASC);

            }
            else {
              availableBydiscipline[desc] = parseInt(t.ASC);
            }

            totalAvailableCountOfTheCenter += parseInt(t.ASC);

            totalSalariesByCenter += t.F7;
            //therapist.Available = t.ASC;
            if (isOwner || isFacilityOwner) {
              therapist.Sal = t.F7;

              therapist.SalCategoryId = GetSalCat(t.SAL);

              therapist.SalRYBG = t.F7 <= totalSal ? "Green" : t.F7 > totalSal && t.F7 <= totalSal * 2 ? "Blue" : t.F7 > totalSal * 2 && t.F7 <= totalSal * 3 ? "Yellow" : "Red";

              //   therapist.RankRYBG = t.RU;
            }
            therapist.DOJ = t.DOJ && t.DOJ.includes("T") ? t.D.split("T")[0] : t.DOJ;
            therapist.LID = t.LastHikeDate && t.LastHikeDate.includes("T") ? t.LastHikeDate.split("T")[0] : t.LastHikeDate;
            // therapist.Designation = t.F2;

            var kids = parseInt(t.C);
            // therapist.Kids = kids;
            therapist.Contribute = kids >= 11 ? "Green" : (kids >= 9 && kids < 11) ? "Blue" : (kids >= 7 && kids < 9) ? "Yellow" : "Red";



            // kids >= 11 ? "Above 11" : (kids >= 9 && kids < 11) ? "9 - 10" : (kids >= 7 && kids < 9) ? "7 - 8" : (kids >= 5 && kids < 7) ? "5 - 6" : (kids >= 3 && kids < 5) ? "3 - 4" : (kids >= 1 && kids < 3) ? "1 - 2" : "0";
            //therapist.Pollinate = therapist.
            // therapist.F1 = GetShortDesignation(t.F5) + ", " + t.C + " kids";
            //therapist.Pollinate = therapist.F6.split(',');
            var serv = t.Pollinate && t.Pollinate.includes(",") ? t.Pollinate.split(',') : t.Pollinate;
            if (serv) {
              for (var s = 0; s < services.length; s++) {
                var val = serv && serv.length > 0 ? $.grep(serv, function (e) { return e.indexOf(services[s]) > -1 })[0] : '';
                therapist[services[s]] = val && val != '' ? parseInt(val.split(":")[1]) : 0;
              }
              therapist.Call = t.Handle;
            }
            //therapist.F4 = therapist.ASC + " Available";
            therapistsDataBlock.push(therapist);


          }
          var tS = facility.TS ? facility.TS.length : 0;

          var averageService = totalServicesOfCenter / tS;
          facility.RYBG = averageService >= 11 ? "Green" : (averageService >= 9 && averageService < 11) ? "Blue" : (averageService >= 7 && averageService < 9) ? "Yellow" : "Red";

          var fPollinations = datar.filter(a => a.FId == facility.Id);
          var totalPollination = fPollinations.length;

          var pollinationsKeys = groupBy(fPollinations, "ShortName");

          for (var i = 0; i < Object.keys(pollinationsKeys).length; i++) {
            var key = Object.keys(pollinationsKeys)[i];
            chartData[key] = pollinationsKeys[key].length;
          }


          facility.P = "";
          var facilitiesPollination = facility.P.split(",");






          for (var jk = 0; jk < facilitiesPollination.length; jk++) {
            var se = facilitiesPollination[jk].split(":");
            if (coworkersDes && coworkersDes.length > 0 && coworkersDes.indexOf(se[0]) == -1) {
              continue;
            }
            // totalPollination += parseInt(se[1]);
            //if (chartData[se[0]]) {
            //    chartData[se[0]] += parseInt(se[1]);
            //}
            //else {
            //    chartData[se[0]] = parseInt(se[1]);
            //}
          }
        }
        totalAvailableCountOfTheCenter = isNaN(totalAvailableCountOfTheCenter) ? 0 : totalAvailableCountOfTheCenter;
        totalPollination = isNaN(totalPollination) ? 0 : totalPollination;
        facility.ASC = totalAvailableCountOfTheCenter;
        facility.PC = totalPollination;

        availableTotal += parseInt(facility.ASC);
        pollinateTotal += parseInt(facility.PC);
        facility.SalariesRYBG = facility.SAL <= totalSal ? "Green" : facility.SAL <= (2 * totalSal) && facility.SAL > (1 * totalSal) ? "Blue" : facility.SAL <= (3 * totalSal) && facility.SAL > (2 * totalSal) ? "Yellow" : "Red";

        allFinalFacilitites.push(facility);

      }

      //facility.sort((a, b) => (a.TSL < b.TSL ? -1 : 1))
      therapistsDataBlock.sort((a, b) => (a.C < b.C ? -1 : 1));
      kidsForTherapists = kidsForTherapists.filter(f => therapistIds.indexOf(f.TherapistId) > -1);
      var totals = { "Available": availableTotal, "Pollinate": pollinateTotal, "Services": kidsForTherapists.length, "Staff": totalEmployees };
      var dataFinal = { "Data": therapistsDataBlock, "Group": chartData, Services: kidsForTherapists, "AvailableDiscipline": availableBydiscipline, "Totals": totals, "Facilities": allFinalFacilitites };
      return dataFinal;



      break;
    case "EMPOWERINGKIDS":

      var kidsForTherapists = [];
      var facilityData = masterData.Facilities;
      if (userdata.FData) {
        kidsForTherapists = $.grep(userdata.FData, function (r) { return r.AT == "USERSERVICE" && r.S != "INACTIVE" && r.S != "InActive" && r.RS != "DELETEACTIVITY" && (fids && fids != 0 ? fids.indexOf(r.FId) > -1 : true) });
      }
      else {
        kidsForTherapists = $.grep(userdata.Data, function (r) { return r.AT == "USERSERVICE" && r.S != "INACTIVE" && r.S != "InActive" && r.RS != "DELETEACTIVITY" });

      }


      kidsForTherapists.sort((a, b) => (b.F1 < a.F1 ? 1 : -1));

      var dataFInal = [];
      for (var i = 0; i < kidsForTherapists.length; i++) {
        var kid = kidsForTherapists[i];
        var facility = $.grep(facilityData, function (e) { return e.GUId == kid.FId })[0];

        var already = $.grep(dataFInal, function (e) { return e.TOId == kid.TOId })[0];
        if (already) {
          already.Slots += ", " + kid.F2;
          already.Service += ", " + kid.RDT;
          already.Therapists += ", " + kid.F3;
        }
        else {

          var allServicesOfKids = $.grep(kidsForTherapists, function (e) { return e.TOId == kid.TOId });
          var d = {

            "Facility": facility ? facility.N : "",
            "Name": kid.F2,
            "TOId": kid.TOId,
            "Discipline": allServicesOfKids.map(m => m.RDT).join(","),
            "Slots": allServicesOfKids.map(m => m.F1).join(","),
            "Therapists": allServicesOfKids.map(m => m.F3).join(","),
            "Category": GetCurretnSlot(kid.F1),
            "Util": allServicesOfKids.length >= 4 ? " >= 4" : allServicesOfKids.length <= 4 && allServicesOfKids.length >= 3 ? "3" : allServicesOfKids.length < 3 && allServicesOfKids.length >= 2 ? "2" : allServicesOfKids.length < 2 && allServicesOfKids.length >= 0 ? "<=1" : ""
          }

          dataFInal.push(d);
        }
      }
      var dataSend = { "Data": dataFInal };
      return dataSend;
      break;

    case "PINNACLERENEWALOFFER":
      var array = status.split("DDDDDD");
      var date = array[0]
      var s = array.length > 1 ? array[1] : "";



      var AllOffers = $.grep(userdata.FData, function (e) {
        return e.AT && e.AT.toUpperCase() == "PINNACLEOFFER" && e.S == "RENEWALOFFER" && (!s || s == "pending" ? e.F22 != 'fulfilled' : e.F22 == 'fulfilled') && e.F4 == date && (fids && fids != 0 && fids.length > 0 ? fids.indexOf(e.FId) > -1 : true)
          && (packagesFilters && packagesFilters != 0 && packagesFilters.length > 0 ? packagesFilters.indexOf(e.F12) > -1 : true)
      });



      var mappedData = [];

      var therapists = groupByMultiple(AllOffers, "F17");
      //console.log(therapists);

      var keys = Object.keys(therapists);

      var lengthContributions = {};
      for (var i = 0; i < keys.length; i++) {

        if (!lengthContributions[therapists[keys[i]].length]) {
          lengthContributions[therapists[keys[i]].length] = [];
        }

        lengthContributions[therapists[keys[i]].length].push(keys[i]);

      }

      console.log(lengthContributions);

      var filterTherapistsByC = [];
      if (null != responsibilitites && responsibilitites.length > 0) {
        for (var i = 0; i < responsibilitites.length; i++) {
          filterTherapistsByC.push(...lengthContributions[responsibilitites[i]]);
        }
      }

      for (var i = 0; i < AllOffers.length; i++) {


        var d = {};
        var o = AllOffers[i];

        if (discipline && discipline != 0 && discipline.length > 0) {

          if (!o.F18 || !(o.F18.split(",").filter(f => discipline.indexOf(f.toLowerCase()) > -1)[0])) {
            continue;
          }
        }


        if (filterTherapistsByC && filterTherapistsByC.length > 0) {
          if (!o.F17 || !(o.F17.split(",").filter(f => filterTherapistsByC.indexOf(f) > -1)[0])) {
            continue;
          }
        }


        if (filtertherapists && filtertherapists.length > 0) {
          if (!o.F17 || !(o.F17.split(",").filter(f => filtertherapists.indexOf(f) > -1)[0])) {
            continue;
          }
        }


        d.Status = o.F22 == 'fulfilled' ? 'Renewed' : o.F25 ? o.F25 : "N/A";
        d.Facility = o.F13;
        d.Package = o.F12 + " Credits";
        d.Kid = o.F14;
        d.Call = o.TOId;
        d.Discipline = o.F18;
        d.Time = o.F23;
        try {
          d.Therapist = o.F17 ? o.F17.split(",").map(m => m + " [" + therapists[m].length + "]").join(",") : "";
        } catch (e) {
          d.Therapist = o.F17;
        }


        d.TOId = o.TOId;

        d.FId = o.FId;
        d.OId = o;
        mappedData.push(d);


      }

      var dataFinal = { "Data": mappedData, "Reponsible": lengthContributions, "Therapists": therapists };
      return dataFinal;



      break;
  }
}

export function GetFacilitiesByType(facilitites, type) {
  if (!facilitites) {
    return [];
  }

  var guids = [3, 14, 15];
  switch (type.toLowerCase()) {
    case "all centers":

      return facilitites.filter(m => m.Category == "Facility" && m.Name != "Kakinada" && m.Name != "Karimnagar" && m.Name != "NAD, Vizag" && m.Name != "Nellore" && m.Name != "Gajuwaka @ Vizag" && m.Name != "Marathahalli" && m.Name != "Hayathnagar" && m.Name != "BN Reddy Nagar" && m.Name != "Visakhapatnam" && m.Name != "Vanasthalipuram");
      break;
    case "all franchises":

      return facilitites.filter(m => m.Category == "Branch");
      break;
    case "all centers+":
      return facilitites.filter(m => m.Category == "Facility" || m.Category == "NoRoyality" || m.Name == "Kakinada" || m.Name == "Gajuwaka @ Vizag" || m.Name == "NAD, Vizag" || m.Name == "Marathahalli" || m.Name == "Hayathnagar" || m.Name == "BN Reddy Nagar" || m.Name == "Visakhapatnam" || m.Name == "Vanasthalipuram");
      break;
    case "all centers++":
      return facilitites.filter(m => m.Category == "Facility" || m.Category == "NoRoyality" || m.Category == "NoRoyalityFacility" || guids.indexOf(m.Id) > -1);
      break;
    case "region1":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 1");
      break;
    case "region2":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 2");
      break;
    case "region3":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 3");
      break;
    case "region4":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 4");
      break;
    case "region5":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 5");
      break;
    case "region6":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 6");
      break;
    case "region7":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 7");
      break;
    case "region8":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 8");
      break;
    case "region9":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 9");
      break;
    case "region10":
      return facilitites.filter(m => m.F6 && m.F6.toLowerCase() == "region 10");
      break;
  }

}

export function GetCOrrectDtaeFormat(dateString) {
  if (!dateString) {
    return "";
  }

  var d = dateString.split("-");
  if (d.length <= 2) {
    return "";
  }

  return new Date(d[2], parseInt(d[1]) - 1, d[0]);
}

export function GetPRRAData(masterdata, userdata, usersettings) {

  console.log("GetPRRAData");
  var dataToReturn = [];
  var CDNPath = "https://www.pinnacleblooms.org/";
  try {
    var userSettings = getUserSettingsValue("PRAACONFIG");
    if (userSettings) {
      dataToReturn = JSON.parse(userSettings);
      if (dataToReturn) {
        for (var i = 0; i < dataToReturn.length; i++) {
          dataToReturn[i].URLFORNAVIGATION = "https://www.pinnacleblooms.org/PRAA/" + dataToReturn[i].UId;
          dataToReturn[i].PUBLICURL = "https://www.pinnacleblooms.org/PRAA/" + dataToReturn[i].UId;
        }
      }
    }
    var tempData = [];
    var allCourses = userdata ? $.grep(userdata, function (e) { return (e.AT == "MIRAVERSETANTRUMS" || e.AT == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];

    if (allCourses && allCourses.length > 0) {
      tempData.push(...allCourses);
    }

    var allAssessments = masterdata && masterdata.MasterData
      ? $.grep(masterdata.MasterData, function (e) {
        return e.AT && e.AT == 'Assessment' && e.SN != null
      }) : [];
    if (allAssessments && allAssessments.length > 0) {
      tempData.push(...allAssessments);
    }

    $.each(tempData, function (key, data) {
      var objToPush = {};
      objToPush.AT = data.AT;
      objToPush.RDT = data.RDT;
      objToPush.RDD = data.RDD;
      if (data.AT == "MIRAVERSETANTRUMS" || "MIRAVERSECONDITIONS") {

        objToPush.F1 = CDNPath + "/Assets/Materials/" + data.UId + ".jpg";
        objToPush.F8 = 1;
        objToPush.UId = data.UId;
        objToPush.URLFORNAVIGATION = "/miraverse?id=" + data.UId + "&type=" + data.AT;
        objToPush.PUBLICURL = "https://www.pinnacleblooms.org/PRAA/" + data.UId;
      }
      ///ImgUrl
      if (data.AT == "Assessment") {

        objToPush.F1 = data.ImgUrl.indexOf('https') > -1 ? data.ImgUrl.replace("https://iqm-nkywabj.stackpathdns.com/", "https://www.internationalqualitymeasurers.org/") + "?v=22" : CDNPath + data.ImgUrl + "?v=12121";
        objToPush.F8 = 1;
        objToPush.URLFORNAVIGATION = "/assessment/" + (data.SN ? data.SN : data.RDT);
        objToPush.PUBLICURL = window.root + "/viewassessments/" + (data.SN ? data.SN : data.RDT) + "/" + data.RDId;
      }
      dataToReturn.push(objToPush);

    });


    return dataToReturn;

  }
  catch (e) {
    console.log(e);
  }
  return dataToReturn;
}

//#region charts
export function GetDistributionchat($currentState, dataFrom, type, byAmount, legendId, method, property, IsPercentage, displayname, isMulitple) {
  byAmount = byAmount || false;
  IsPercentage = IsPercentage || false; isMulitple = isMulitple || false;

  //if (null == data || null == data || typeof (data) == "undefined") {

  //    return;
  //}


  if (!dataFrom || !type) {

    return;
  }




  var $this = this;
  var keys = [];
  var values = [];



  property = property ? property : "Facility";

  var finaldata = $.grep(dataFrom, function (e) { return e[property] != "<b>Total" });

  var facilities = isMulitple ? groupByMultiple(finaldata, property) : groupBy(finaldata, property);
  // $this.clearPushtoReportFilterList("Facility", "Facilities", Object.keys(facilities));

  var data = Object.entries(facilities);// Object.keys(selfThis.state.Facilities);





  var totalAmount = 0;
  if (byAmount) {


    data.sort(function (a, b) {
      return $currentState.sumOfValuesPaid(a[1]) > $currentState.sumOfValuesPaid(b[1]) ? -1 : 1

    });

    var total = $currentState.sumOfValuesPaid(finaldata);
    totalAmount = total;
    for (var i = 0; i < data.length; i++) {

      if (IsPercentage) {

        var per = Math.round($currentState.sumOfValuesPaid(data[i][1]) * 100 / total, 2)
        if (per > 0) {
          keys.push(facilities[data[i][0]][0][property] + "[" + per + "%]");
          values.push(per);
        }
      }
      else {
        var amount = $currentState.sumOfValuesPaid(data[i][1]);
        keys.push(facilities[data[i][0]][0][property] + "[" + numbersafterthousand(amount) + "]");
        values.push(amount);
      }
    }
    //$this.clearPushtoReportFilterList("Header", "Headers", keys);
  }
  else {

    data.sort(function (a, b) {
      return a[1].length > b[1].length ? -1 : 1

    });

    //var facilitiesForComments = [];
    for (var i = 0; i < data.length; i++) {

      //if (this.props.MasterData.Facilities && this.props.currentPersonDetails) {
      //    var facilityData = this.props.MasterData.Facilities.filter(function (e) {
      //        return e.N == facilities[data[i][0]][0][property]


      //    })[0];
      //    if (facilityData) {
      //        facilityData["Count"] = data[i][1].length;

      //        facilitiesForComments.push(facilityData);
      //    }

      //}
      if (IsPercentage) {
        var per = Math.round(data[i][1].length * 100 / dataFrom.length, 2);
        if (per > 0) {
          keys.push(data[i][0] + "[" + per + "%]");
          values.push(per);
        }
      }
      else {
        var valuefromKey = data[i][1].length;


        keys.push(data[i][0] + "[" + valuefromKey + "]");
        values.push(valuefromKey);
      }
    }
    // CurrentFacilitites = facilitiesForComments;
  }
  // $this.setState({ CurrentFacilitites: facilitiesForComments})

  if (method) {
    method(property, (displayname ? displayname : "Facilities") + (byAmount ? " [ " + numbersafterthousand(totalAmount) + " ]" : ""), keys, null, $currentState);
  }


  //if (byAmount) {
  //    $("#total-counts-matchedrecords").html("[ " + numbersafterthousand(totalAmount) + " ]");
  //}






  var data2return = {
    labels: keys,
    datasets: [{
      label: type,
      data: values,
      backgroundColor: [
        'rgb(0,164,239)',



        'rgb(255,185,0)',
        'rgb(244,114,22)',
        'rgb(224,30,90)',
        'rgb(46, 182, 125)',

        'rgb(255,0,0)',

        'rgb(91,209,215)',
        'rgb(208,148,234)',
        'rgb(127,186,0)',
        'rgb(115,115,115)',
        'rgb(40, 40, 40)',
        'rgb(224,30,90)',
        'rgb(212,237,49)',
        'rgb(224, 30, 90)',
        'rgb(75, 107, 175)',
        'rgb(0, 0, 0)',
        'rgb(88,81,216)',
        'rgb(5, 10, 230)',
        'rgb(193, 53, 132)'
      ],
      borderColor: [
        'rgb(0,164,239)',



        'rgb(255,185,0)',
        'rgb(244,114,22)',
        'rgb(224,30,90)',
        'rgb(46, 182, 125)',

        'rgb(255,0,0)',

        'rgb(91,209,215)',
        'rgb(208,148,234)',
        'rgb(127,186,0)',
        'rgb(115,115,115)',
        'rgb(40, 40, 40)',
        'rgb(224,30,90)',
        'rgb(212,237,49)',
        'rgb(224, 30, 90)',
        'rgb(75, 107, 175)',
        'rgb(0, 0, 0)',
        'rgb(88,81,216)',
        'rgb(5, 10, 230)',
        'rgb(193, 53, 132)'
      ],
      borderWidth: 1
    }]
  }



  return data2return;

}
//#endregion

// #region change coverphoto
var cPLS = "selectedcoverphoto";
export function SetCoverPhoto(url) {
  localStorage.setItem(cPLS, url);
}


export function suffixnumbers(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return "st";
  }
  if (j == 2 && k != 12) {
    return "nd";
  }
  if (j == 3 && k != 13) {
    return "rd";
  }
  return "th";
}

export function Ratings(i) {

  if (i == 5) {
    return i + " *****"
  }
  if (i == 4) {
    return i + " ****"
  }
  if (i == 3) {
    return i + " ***"
  }
  if (i == 2) {
    return i + " **"
  }
  if (i == 1) {
    return i + " *"
  }

}

var expandCollpaseLSKey = "expandedcollpased";
function getTodaysDateString() {
  var dt = new Date();
  return dt.getDate() + "-" + dt.getMonth() + "-" + dt.getFullYear();
}
export function GetExpandCollpaseData(expand) {
  var lsValue = localStorage.getItem(expandCollpaseLSKey);
  //lsValue = lsValue ? lsValue : "{}";
  var items = lsValue ? JSON.parse(lsValue) : {};

  items = items ? items : {};
  var dateString = getTodaysDateString();
  var keys = Object.keys(items);
  keys = keys || [];
  for (var i = 0; i < keys.length; i++) {
    // if (items[keys[i]] && items[keys[i]].D != dateString) {
    //     items[keys[i]].S = expand ? true : false;
    // }
    // else {
    //     if (!expand) {
    //         items[keys[i]].S = false;

    //     }
    // }
  }
  return items;
}
export function ExpandCollapse(key, isItUpdate, isitOpened) {
  var items = GetExpandCollpaseData();
  items[key] = items && items[key] ? items[key] : { S: true };
  //var item = items.filter(function (f) { return f.Key == key })[0];
  //item = item ? item : { Key: key,S: true };

  if (isItUpdate) {
    isitOpened = isitOpened || false;
    items[key].S = isitOpened;

    items[key].D = getTodaysDateString();
    localStorage.setItem(expandCollpaseLSKey, JSON.stringify(items));
  }

  return items;




  return true;


}

export function GetCreditsBgColor(credits, activeServiceCount) {
  var score = credits / activeServiceCount;
  return score > 6 ? 'green' : score > 3 ? 'yellow' : 'red';
}


export function downloadPdf(latestEIP, assessment) {
  // If record already available
  if (latestEIP && latestEIP.Response) {
    const url = "https://images.pinnacleblooms.org/EIP/" + latestEIP.Response;
    window.open(url);
    return;
  }

  // Otherwise fetch from server
  const uReq = {
    AId: assessment?.Id,   // pass AId from latestEIP
    Type: "GetAllEIPPDFByAId",
  };

  GETUSERCUSTOMDATA(uReq, function (response, error) {
    if (error || !response) {
      showLockedBox(
        "We are yet to prepare your AbilityScore&trade; report, please try after sometime",
        false, "ok"
      );
    } else {
      const url = "https://images.pinnacleblooms.org/EIP/" + response.Response;
      window.open(url);
    }
  });
}


/**
 * Generalized PDF Downloader for all kid reports (Readiness, EIP, AbilityScore, etc.)
 * Handles:
 *  1. Direct file download from /Assets/
 *  2. API fallback if file not ready
 *  3. LocalStorage marker to avoid spamming API
 *
 * @param {Object} options
 * @param {Object} options.kid - Kid details (must have Id)
 * @param {Object} [options.assessment] - Assessment details (must have CDT, Id for some reports)
 * @param {Object} [options.reportData] - Report details (e.g., DS score for Readiness)
 * @param {string} options.reportType - Report type (e.g., "ReadinessMeter", "EIP", "AbilityScore")
 * @param {string} [options.currentType] - Optional type (like configIndex.N)
 * @param {Function} [options.onStart] - Called before download attempt
 * @param {Function} [options.onComplete] - Called after download (true=success, false=failure)
 */
export async function downloadKidReport({
  kid,
  assessment,
  score,
  reportType,
  currentType,
  onStart,
  onComplete,
}) {
  if (!kid?.Id) return;

  const guid = CreateNewGuid();

  // Format date if available
  const formattedDate = assessment?.CDT
    ? `${('0' + new Date(assessment.CDT).getDate()).slice(-2)}-${('0' + (new Date(assessment.CDT).getMonth() + 1)).slice(-2)}-${new Date(assessment.CDT).getFullYear()}`
    : "";

  // Construct filename
  let fileName = `${kid.Id}`;
  if (score) fileName += `-${Math.round(score)}`;
  if (formattedDate) fileName += `-${formattedDate}`;
  if (currentType) fileName += `-${currentType}`;

  // Primary file URL
  var url = "";
  if (!reportType) {
    url = `https://images.pinnacleblooms.org/EIP/${assessment.EIP}?v=${guid}`;
  } else {
    url = `https://images.pinnacleblooms.org/Assets/${reportType}/${fileName}.pdf?v=${guid}`;
  }

  try {
    if (onStart) onStart();

    const response = await fetch(url);
    if (response.ok) {
      window.open(url);
      if (onComplete) onComplete(true);
      return;
    }

    // LocalStorage flag to prevent repeated API calls
    const localKey = `${reportType}Pending`;
    if (localStorage.getItem(localKey)) {
      showLockedBox(
        `We are still preparing your ${reportType} report.<br/>Please check back later.`,
        "info",
        "okay"
      );
      if (onComplete) onComplete(false);
      return;
    }

    // 🔹 API fallback
    let altApi = "";
    if (reportType === "ReadinessMeter") {
      altApi = `https://www.pinnacleblooms.org/api/unsecuredapi/ReadinessMeterPDF?kidid=${kid.Id}&pwd=PinnacleSuccess9*`;
    } else if (reportType === "EIP") {
      altApi = `https://www.pinnacleblooms.org/api/unsecuredapi/EIPPDF?kidid=${kid.Id}&pwd=PinnacleSuccess9*`;
    } else if (reportType === "AbilityScore" && assessment?.Id) {
      // Server method for AbilityScore
      const uReq = { AId: assessment.Id, Type: "GetAllEIPPDFByAId" };
      return GETUSERCUSTOMDATA(uReq, function (response, error) {
        if (onComplete) onComplete(false);
        if (response && !error && response.Response) {
          const url = `https://images.pinnacleblooms.org/EIP/${response.Response}`;
          window.open(url);
        } else {
          showLockedBox("We are yet to prepare your AbilityScore™ report, please try later", false, "ok");
        }
      });
    }

    if (altApi) {
      try {
        const r = await fetch(altApi);
        if (r.ok) {
          console.log("Alternative document retrieved successfully.");
        } else {
          console.log("Alternative document not ready.");
        }
      } catch (e) {
        console.log("Error fetching alternative API:", e);
      }
    }

    showLockedBox(
      `We are currently preparing your ${reportType} report.<br/>Please check back in a short while.`,
      "info",
      "okay"
    );
    localStorage.setItem(localKey, "TRUE");
    if (onComplete) onComplete(false);

  } catch (err) {
    console.error("Error fetching report:", err);
    if (onComplete) onComplete(false);
  }
}


export function GetCoverPhoto(url, role, user) {
  var image = user && user.F16 ? user.F16 : localStorage.getItem(cPLS, url);
  return image ? image : role ? role.toLowerCase() == "therapist" ? "/images/coverimages/autism-9.jpg" :
    role.toLowerCase() == "facilityowner" ? "/images/coverimages/autism-17.jpg" :
      role.toLowerCase() == "ncc" ? "/images/coverimages/autism-21.jpg" :
        role.toLowerCase() == "owner" ? "/images/coverimages/autism-3.jpg" :
          role.toLowerCase() == "boss" ? "/images/coverimages/sanjeevani-400.jpg" :
            role.toLowerCase() == "receptionist" ? "/images/coverimages/autism-15.jpg" :
              "/images/mirracle-bg-ex2.jpg"
    : "/images/mirracle-bg-ex2.jpg";
}
// #endregion change cover photo


// #region online/offline

export function getPSDate(d) {
  return d.getFullYear() + "-" + (d.getMonth() > 8 ? (d.getMonth() + 1) : "0" + (d.getMonth() + 1)) +
    "-" + (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) + " " + (d.getHours() > 9 ? d.getHours() : "0" + d.getHours()) + ":" +
    (d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes()) + ":" +
    (d.getSeconds() > 9 ? d.getSeconds() : "0" + d.getSeconds())
    ;
}
function HandleFailureConnection(callback, cancel) {
  console.log("callback");
  console.log(callback);
  var guid = CreateGuid();
  // Prepare popup buttons why only buttons - at a time we are going to show only one
  var html = ' <input id="' + guid + '" class=" btn-red btn continue-set" style="font-size: 16px;font-family: camphor;color: #fff;width: 50%;margin-left:0;margin-right:0;float: right;" type="button" value="retry" >' +
    '<input id="' + guid + '-cancel" class="btn-red btn continue-set" style="font-size: 16px;font-family: camphor;color: #fff;width: 49%;margin-left:0;margin-right:0;float: left;background: transparent;border: 1px solid #ee3268;color: #ee3268;" type="button" value="cancel">';
  $(".connection-failed-overlay .reject-app-container").html(html);

  $(".connection-failed-overlay .reject-app-container").on('click', '#' + guid, function () {
    //console.log(callback);
    $(".connection-failed-overlay .reject-app-container").off('click', '#' + guid);
    console.log("calling from handle connection failue");
    if (callback) {
      $('.connection-failed-overlay').removeClass("active");
      $(".connection-failed-overlay .reject-app-container").html('');
      callback();
    };
  });
  $(".connection-failed-overlay .reject-app-container").on('click', '#' + guid + "-cancel", function () {
    $(".connection-failed-overlay .reject-app-container").off('click', '#' + guid + "-cancel");
    if (cancel) {
      cancel();
    }
    //cancelConnectionOverlay();
  });
  $('.connection-failed-overlay').addClass("active");
}

function ping(url, callback) {

  const condition = navigator.onLine ? 'online' : 'offline';


  fetch(url, {
    mode: 'no-cors',
  })
    .then(() => {
      callback(true);
    }).catch(() => callback(false))

  return;




}

export function GetDataByType(id, type, data) {

  var objToReturn = null;
  try {
    if (!id || !type) {
      return objToReturn;
    }

    switch (type.toUpperCase()) {
      case "ATTENDANCE":
        objToReturn = (data.Attendance || []).filter(t => t.Id == id)[0];
        break;
      case "SERVICEREQUEST":
        objToReturn = (data.ServiceRequests || []).filter(t => t.Id == id)[0];
        break;
      case "MEMO":
      case "AWARD":
      case "PAYSLIP":
        objToReturn = (data.PeopleNotes || []).filter(t => t.Id == id)[0];
        break;
      case "LEAD":
        objToReturn = (data.Leads || []).filter(t => t.TOId == id)[0];
        break;
      case "GOAL":
        objToReturn = (data.Goals || []).filter(t => t.Id == id)[0];
        break;
      case "THERAPIST":
      case "BOSS":
      case "PEOPLE":
        objToReturn = (data.People || data.FacilityPeople).filter(t => t.Id == id)[0];
        break;


    }
  } catch (e) {
    var exception = new Object();
    exception.Type = "GetDataByType";
    exception.Message = e;
    SaveExceptionToSentry(exception, "GetDataByType", getUserToken(), JSON.stringify(e))
  }
  return objToReturn

}

export function GetNotificationRedirect(id, type) {
  console.log("GetNotificationRedirect");
  try {
    var url = "";
    if (!id || !type) {
      return url;
    }

    switch (type.toUpperCase()) {
      case "ATTENDANCE":
        url = "/viewhomework?id=" + id
        break;
      case "SERVICEREQUEST":
        url = "/servicerequestdetails/" + id
        break;
      case "MEMO":
        url = "/hanuman?id=" + id + "&at=MEMO"
        break;
      case "LEAD":
        url = "/hermes?id=" + id
        break;
      case "GOAL":
        url = "/viewaigoal?Id=" + id
        break;
      case "THERAPIST":
        url = "/usercard?id=" + id + "&role=therapist"
        break;
      case "BOSS":
        url = "/usercard?id=" + id + "&role=boss"
        break;
      case "AWARD":
        url = "/hanuman?id=" + id + "&at=AWARD"
        break;
      case "PAYSLIP":
        url = "/payslip?id=" + id
        break;
      case "PEOPLE":
        url = "/usercard?id=" + id
        break;
      case "LEADINGLEADS":
        url = "/publishscreen?t=memo&type=Leading Leads&lid=" + id
        break;
      case "LEADINGLEADSAWARD":
        url = "/publishscreen?t=award&type=Leading Leads&lid=" + id
        break;
      case "ABILITYSCOREMEMO":
        url = "/publishscreen?t=memo&type=Ability Score&lid=" + id
        break;
      case "ABILITYSCOREAWARD":
        url = "/publishscreen?t=award&type=Ability Score&lid=" + id
        break;
      //leadingleadsaward    
      case "IRREGULAREXPENSE":
        url = "/publishscreen?t=memo&type=Irregular Expense Booking&lid=" + id
        break;
      case "LEAVEREQUEST":
        url = "/leaverequest?id=" + id
        break;
      case "PEOPLECALL":
        url = "/usercard?id=" + id + "&role=boss&call=true"
        break;
      case "BOT":
        url = "genericreports?type=" + type
        break;

    }
  }
  catch (e) {
    var exception = new Object();
    exception.Type = "GetNotificationRedirect";
    exception.Message = e;
    SaveExceptionToSentry(exception, "GetNotificationRedirect", getUserToken(), JSON.stringify(e))
  }
  return url;
}

export async function Translate(text, lang) {
  var FinalResult;
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    "q": text,
    "target": lang
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  var response = await fetch("https://translation.googleapis.com/language/translate/v2?key=AIzaSyD0800ZJC6Y-vHUyIyHc18v8zQ3v1ZrET4", requestOptions)
  var alldata = await response.json()
  console.log(alldata);
  if (alldata.error) {

    var exception = new Object();
    exception.Type = "GOOGLETRANSLATEERROR";
    exception.Message = alldata.error;
    SaveExceptionToSentry(exception, "GOOGLETRANSLATEERROR", getUserToken(), JSON.stringify(alldata.error))
    throw new Error(alldata.error.message);

  }
  if (alldata) {
    return alldata.data.translations.map(m => m.translatedText);
  }
  //.then(response => response.text())
  // .then(result =>{
  //     if(result){
  //         return JSON.parse(result).data.translations[0].translatedText
  //     }
  //     })

  //.catch(error => console.log('error', error));


}

export const abilityScoreData = [
  { category: 'Critical Delays', from: 0, to: 110, range: '0–110', colorTerm: "Red", stage: 1, color: '#f13f48', description: 'Your child faces significant developmental challenges. Progress may be gradual, often several years. With structured support, they can steadily gain basic skills and communication.', RightNow: "Your child is in the Critical Red Zone, facing profound, life-altering delays that threaten everyday functioning.", HowLong: "Improvements can be painfully slow, often stretching across critical formative years.", Improvement: "With swift and intense interventions, they might develop core survival skills and basic communication. Delaying help raises the risk of permanent developmental gaps." },
  { category: 'Severe Deficits', from: 111, to: 220, range: '111–220', colorTerm: "Red", stage: 2, color: '#f13f48', description: 'Your child’s difficulties are pronounced but not extreme. Noticeable progress may start within 1–2 years. With consistent therapies, they can improve in communication, self-help, and focus.', RightNow: "Severe Danger Zone: Your child's developmental hurdles are significant enough to jeopardize future academic, social, and self-care milestones.", HowLong: "Noticeable gains may take 1-2 years, and any lapse in support could cause severe backslides.", Improvement: "With rigorous therapies and continual oversight, they could bridge key gaps in language, focus, and independence. However, failing to address these issues promptly may lead to compounding deficits." },
  { category: 'Major Concerns', from: 221, to: 330, range: '221–330', colorTerm: "Red", stage: 3, color: '#f13f48', description: 'Your child has notable delays across multiple areas. Tangible growth often within 1–1.5 years. They can achieve meaningful strides in language, social engagement, and motor skills.', RightNow: "Major Risk Level: Your child faces multiple developmental deficits that could escalate quickly without immediate, specialized attention.", HowLong: "Tangible progress might show in 12-18 months, but only with aggressive, high-quality intervention.", Improvement: "Consistent, targeted programs can yield essential strides in speech, social interaction, and motor skills. A wait-and-see approach risks deepening the deficits and complicating future interventions." },
  { category: 'Serious Lags', from: 331, to: 440, range: '331–440', colorTerm: "Red", stage: 4, color: '#f13f48', description: 'Your child shows below-average abilities with some delays. Improvements often visible within 9–12 months. They can strengthen core skills, improve behavior, and become more independent.', RightNow: "Noticeable Risk: Your child is underperforming across several key areas—this gap could become permanent if ignored.", HowLong: "Expect to see improvements over 9-12 months with sustained commitment and monitoring.", Improvement: "By tackling core developmental challenges now, they may avoid falling further behind. Failure to intervene risks solidifying problematic behaviors and impairing self-sufficiency in the long run." },
  { category: 'Below Norms', from: 441, to: 550, range: '441–550', colorTerm: "Yellow", stage: 5, color: '#fb9511', description: 'Your child’s abilities are around average but still need support in some areas. Progress may be noticeable in 6–9 months. With guided help, they can refine language, social interactions, and daily living tasks.', RightNow: "Below Normal: Your child's abilities hover just beneath typical levels; unnoticed issues could quickly escalate if proper help is delayed.", HowLong: "Progress is frequently observed within 6-9 months, assuming consistent, intensive effort.", Improvement: "Timely support can realign them with their peers in language, social, and practical skills. But complacency at this stage could cause a deeper plunge into more serious deficits later." },
  { category: 'Mild Weaknesses', from: 551, to: 660, range: '551–660', colorTerm: "Yellow", stage: 6, color: '#fb9511', description: 'Your child’s abilities are slightly above average, but they may still have specific areas to work on. Changes often evident within 3–6 months. They can further enhance communication, problem-solving, and self-regulation skills.', RightNow: "Marginal Progress: Your child shows some positive signs, but lurking weaknesses could magnify without ongoing vigilance.", HowLong: "Meaningful changes might emerge in 3-6 months, but only with robust, proactive measures.", Improvement: "Focused interventions can fortify communication, self-regulation, and problem-solving, preventing potential regressions. Ignoring these subtle warning signs can trigger bigger obstacles down the road." },
  { category: 'Moderate Strength', from: 661, to: 770, range: '661–770', colorTerm: "Yellow", stage: 7, color: '#fcc911', description: 'Your child demonstrates high abilities, with minor challenges. Meaningful improvements could appear in 2–4 months. They can refine advanced language, peer interactions, and adaptability in daily routines.', RightNow: "Moderate Standing: Your child is generally doing well, yet is vulnerable to overlooked challenges that can snowball if not caught early.", HowLong: "You may see results in as little as 2-4 months, provided the issues are swiftly identified and addressed.", Improvement: "Targeted fine-tuning can push them to higher-level mastery. However, missing subtle gaps now might derail future performance and social integration." },
  { category: 'High Competence', from: 771, to: 880, range: '771–880', colorTerm: "Green", stage: 8, color: '#08b147', description: 'Your child’s abilities are very high, with few difficulties. Progress can be seen within 1–2 months. They can polish existing strengths, build resilience, and excel in complex tasks.', RightNow: "High Capability: Although your child scores well above average, minor blind spots could hinder advanced growth and confidence.", HowLong: "Noticeable gains may appear within 1-2 months, but only with consistent, specialized attention.", Improvement: "By preemptively addressing these hidden challenges, they can maintain a competitive edge. Failure to do so might result in missed opportunities and unmet potential—often going unnoticed until it's too late." },
  { category: 'Exceptional Skills', from: 881, to: 1000, range: '881–1000', colorTerm: "Green", stage: 9, color: '#12833e', description: 'Your child’s abilities are exceptional. Small refinements can appear within weeks. They can fine-tune their already strong skills and maintain well-rounded development.', RightNow: "Elite Range: Your child's abilities seem exceptional, but complacency or lack of challenging environments can stall further progress.", HowLong: "Even slight enhancements often arise within weeks, if interventions are precisely tuned to their needs.", Improvement: "With deliberate, advanced stimulation, they can avoid stagnation and continue to expand their brilliance. Neglecting to nurture these talents may lead to underachievement and a wasted advantage." },
];

export function GetAbilityScoreCurrentRange(score) {
  score = parseFloat(score);

  return abilityScoreData.find(f => f.from <= score && f.to >= score);
}

export function getHeroContentForCliders(userData) {
  try {
    const date = new Date();

    const network = userData.NetworkNotes?.filter(f =>
      f.Status?.toUpperCase() === "SPECIALOFFER" &&
      new Date(f.FDT) <= date &&
      new Date(f.TDT) >= date &&
      f.RS !== "DELETEACTIVITY"
    ).map(f => ({ ...f, Weightage: 100000 + (f.Weightage || 0) })) || [];

    const center = userData.CenterNotes?.filter(f =>
      f.Status?.toUpperCase() === "SPECIALOFFER" &&
      new Date(f.FDT) <= date &&
      new Date(f.TDT) >= date &&
      f.RS !== "DELETEACTIVITY"
    ).map(f => ({ ...f, Weightage: 10000 + (f.Weightage || 0) })) || [];

    const people = userData.PeopleNotes?.filter(f =>
      f.Status?.toUpperCase() === "SPECIALOFFER" &&
      new Date(f.FDT) <= date &&
      new Date(f.TDT) >= date &&
      f.RS !== "DELETEACTIVITY" &&
      String(userData.CFUser.Id) === String(f.TOId)
    ).map(f => ({ ...f, Weightage: 100 + (f.Weightage || 0) })) || [];

    // const renewalOffers = userData.Offers?.filter(f =>
    //   f.Status?.toUpperCase() === "RENEWALOFFER" &&
    //   new Date(f.FDT) <= date &&
    //   new Date(f.TDT) >= date &&
    //   f.RS !== "DELETEACTIVITY"
    // ).map(f => ({ ...f, Weightage: 100 + (f.Weightage || 0), PURL:'https://images.pinnacleblooms.org/Assets/Offers/'+f.Id+'.jpg' })) || [];

    return [...network, ...center, ...people]
      .sort((a, b) => b.Weightage - a.Weightage);
  } catch (e) {
    console.error(e);
    return [];
  }
}

export async function ConvertModelToConvertable(obj, lang, keys, donrt) {

  if (!obj || lang == "en") {
    return obj;
  }


  donrt = donrt || [];


  var alreadyExist = localStorage.getItem(obj.Id + "-" + lang);
  if (alreadyExist && obj.Id) {
    var cObj = JSON.parse(alreadyExist);
    if (cObj) {
      if (cObj.Type == "goalsjson") {
        for (var i = 0; i < (cObj.GJ.CommittedGoals || []).length; i++) {
          cObj.GJ.CommittedGoals[i].Committed = obj.GJ.CommittedGoals[i].Committed;
          cObj.GJ.CommittedGoals[i].Strech = obj.GJ.CommittedGoals[i].Strech;
        }

        for (var i = 0; i < (cObj.GJ.StretchGoals || []).length; i++) {
          cObj.GJ.StretchGoals[i].Committed = obj.GJ.StretchGoals[i].Committed;
          cObj.GJ.StretchGoals[i].Strech = obj.GJ.StretchGoals[i].Strech;
        }


      }
      return cObj;
    }

  }

  //    try{
  //     obj = Object.setPrototypeOf(obj,null);
  //    }
  //    catch{

  //    }

  // &&  obj[keys[i]] &&  obj[keys[i]].indexOf("overall") >-1)

  var keys = keys ? keys : Object.keys(obj);
  var newObj = {};
  var properties = [];
  var textArray = [];
  for (var i = 0; i < keys.length; i++) {
    if (keys[i] == "DN") {
      console.log("Hello");
    }
    if (donrt.indexOf(keys[i]) > -1) {
      continue;
    }
    if (obj[keys[i]] && Array.isArray(obj[keys[i]])) {
      var c = [];
      for (var j = 0; j < obj[keys[i]].length; j++) {
        c.push(await ConvertModelToConvertable(obj[keys[i]][j], lang, null, donrt));
      }
      obj[keys[i]] = c;
    }
    else if (obj[keys[i]] && typeof obj[keys[i]] == "object") {
      obj[keys[i]] = await ConvertModelToConvertable(obj[keys[i]], lang, null, donrt);
    }
    else {
      if (obj[keys[i]] && isNaN(obj[keys[i]]) && keys[i] != "GoalMatched") {
        properties.push(keys[i]);
        textArray.push(obj[keys[i]]);
      }
      // obj[keys[i]] =await Translate(obj[keys[i]],"te");
    }
  }
  if (textArray && textArray.length > 0) {
    var returnResponse = await Translate(textArray, lang);
    if (returnResponse && textArray) {
      for (var k = 0; k < properties.length; k++) {
        try {
          obj[properties[k]] = returnResponse[k];
        }
        catch (e) {

        }
      }
    }
  }

  if (obj.Id) {

    localStorage.setItem(obj.Id + "-" + lang, JSON.stringify(obj));
  }
  return obj;
}


function getDateByType(type) {
  var currentDate = new Date();


  if (type == 'today') {

    return currentDate;
  }
  else if (type == 'tomorrow') {

    return currentDate;
  }

  else if (type == 'thisweekstart') {
    var firstdayofWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1));
    return firstdayofWeek;
  }
  else if (type == 'thisweekend') {
    var lastdayofWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
    return lastdayofWeek;
  }
  else if (type == 'nextweekend') {
    var lastdayofnextWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 13));
    return lastdayofnextWeek;
  }
}

function GetMimeByType(type) {

  if (!type) {
    return "";
  }

  switch (type.toLowerCase()) {

    case "gif": return "image/gif";
    case "jpeg": return "image/jpeg";
    case "oga": return "audio/ogg";
    case "ogv": return "video/ogg";
    case "ogx": return "application/ogg";
    case "opus": return "audio/opus";
    case "png": return "image/png";
    case "pdf": return "application/pdf";
    case "xls": return "application/vnd.ms-excel";
    case "xlsx": return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "mp4": return "video/mp4";
    case "mp3": return "audio/mpeg";
    case "mpeg": return "video/mpeg";


  }
}

function GetFileDetails(filename) {
  if (!filename) {
    return { "T": "", "M": "" };
  }
  filename = filename.split("?")[0];
  var type = filename.substring(filename.lastIndexOf('.') + 1);
  type = type == "jpg" ? "jpeg" : type;

  var mime = GetMimeByType(type);
  return { "T": type, "M": mime };

}

export function CopyText(text) {
  navigator.clipboard.writeText(text);
  ShowToastMessage("Copied Successfully...");
}

export function NavigatorSharePlayYourStuff(fileName, title, message, shareurl) {
  var fileData = GetFileDetails(fileName);

  if (fileData && fileData.M && (fileName.indexOf("pinnacleblooms.org") > -1)) {


    //var xhr = new XMLHttpRequest();
    //xhr.open("GET", fileName, true);
    //xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    //xhr.responseType = "blob";
    //xhr.onload = function () {
    //    console.log(this.response);
    //}
    //xhr.send();

    let origin = new URL(window.location.href);
    let domain = (new URL(fileName));

    fileName = fileName.replace(domain.hostname, origin.hostname);


    fetch(fileName, {
      method: 'GET',
      crossorigin: true,
      mode: 'no-cors',
    })
      .then((response) => response.blob())
      .then((myBlob) => {
        // console.log(response);
        // const blob = response.blob();

        console.log(myBlob);
        const file = new File([myBlob], 'share.' + fileData.T, { type: fileData.M });
        console.log(file);
        if (navigator) {

          navigator.share({
            title: title,
            text: message,
            url: shareurl,
            files: [file]
          })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error in sharing', error));

        }
        else {
          showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
        }
      });
  }
  else if (fileData && fileData.M) {
    fetch("/api/getblob", {

      // Adding method type
      method: "POST",

      // Adding body or contents to send
      body: JSON.stringify({
        image: fileName
      })

      // Adding headers to the request

    })

      // Converting to JSON
      .then(response => response.blob())

      // Displaying results to console
      .then((myBlob) => {
        // console.log(response);
        // const blob = response.blob();

        console.log(myBlob);
        const file = new File([myBlob], 'share.' + fileData.T, { type: fileData.M });
        console.log(file);
        if (navigator) {

          navigator.share({
            title: title,
            text: message,
            url: shareurl,
            files: [file]
          })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error in sharing', error));

        }
        else {
          showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
        }
      });
  }
  else {
    if (navigator) {

      var d = shareurl ? {
        title: title,
        text: message,
        url: shareurl
      } : {
        title: title,
        text: message
      };
      //showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
      navigator.share(d)
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error in sharing', error));

    }
    else {
      showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
    }
  }
}

function IsGooglePingAvailable() {
  return new Promise(function (resolve, reject) {
    ping(googlePingUrl, function (boolvalue) {
      // Network Fails
      if (!boolvalue) {
        reject();
      }
      else {
        // online
        resolve();
      }
    });
  });
}



export function HandleOffline(retry, isSailent, cancel, useGstatic, online) {
  try {
    isSailent = isSailent || false;
    // return true;
    useGstatic = useGstatic || false;
    var online;
    if (window.navigator.onLine) {
      if (useGstatic) {
        IsGooglePingAvailable().then(function () {
          // online
          if (online) {
            online();
          }

        }).catch(function () {

          if (!isSailent) {
            // offline
            HandleFailureConnection(retry, cancel);
          }
        });
      }
      else {
        if (online) {
          online();
        }
      }
      return true;
    }
    else {
      if (!isSailent) {
        // offline
        HandleFailureConnection(retry, cancel);
      }
    }
    return false;
  } catch (e) {
    if (online) {
      online();
    }
    return true;
  }
}
//#endregion

export async function sendwatimessageviaworker(payload, curUser) {
  try {
    var dataURL = 'https://pbn-planetscale-message-process.kgv.workers.dev/';
    let myrequest = new Request(dataURL);
    var model = {};
    model.PayLoad = payload;
    model.CurrentUser = curUser;
    const init = {
      body: JSON.stringify(model),
      mode: 'no-cors',
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
    }

    const response = await fetch(dataURL, init)
    // .then(response => response.json())
    // .then(json => console.log(json))
    // .catch(e => console.error(e));
    console.log("payload for telegram")
    //var resp = await response.text();
    if (response) {

      showLockedBox("Successfully Sent", "Info", "ok");
    }
    else {
      console.log("NOT SENT");
    }
  }
  catch (e) {

  }
}


// #region
export function PrepareBookAssessment(activity, kid) {
  try {
    console.log("PrepareBookAssessment");

    // var state = getStore().getState();

    // var obj = new Object();
    // // var a = new Array();
    // // a.push(activity.UId);
    // //obj.RDUId = a;
    // obj.Amount = activity.F7 ? activity.F7 : 4599;// amount;
    // obj.AT = "INVOICE"

    // obj.NoOFTherapies = 1;
    // obj.TotalAmount = 0;
    // obj.SevaAmount = 0;
    // obj.Type = "ASSESSMENTS";
    // obj.FDT = PSdateFormate(new Date());
    // obj.TDT = PSdateFormate(new Date());
    // obj.CDT = PSdateFormate(new Date());
    // obj.E5 = activity.Name + ":2599 , StartDate: , EndDate : , Fees:2599";




    var assessmentObj = {};


    assessmentObj.CBPI = kid.Id;
    assessmentObj.ParentId = kid.Id;
    // assessmentObj.Report = this.state.CurrentAssessment.Report;
    assessmentObj.AssessmentTypeId = activity.Id;
    assessmentObj.ModeTypeId = activity.F4 == "SELF" ? 200 : 201;
    assessmentObj.TherapyId = 0;
    assessmentObj.IQMId = activity.F2;
    assessmentObj.Name = activity.F1;
    assessmentObj.CenterId = kid.CenterId;
    assessmentObj.Status = "PENDING";
    //assessmentObj.TherapistId = selectedTherapists && selectedTherapists.length>0 ? selectedTherapists[0] : 0;
    //assessmentObj.F1 = selectedTherapists && selectedTherapists.length > 0 ? selectedTherapists.join("{#}") : '';

    //assessmentObj.IQMId = this.state.CurrentAssessment.IQMId;
    //assessment.F5 = this.state.currentAssessmentBoss.F5;
    //assessment.F4 = $("#Assessmentage").val();



    ///SOURABH::CREATE PAYMENT ANALYTICS ONLY IF FULLY DISCOUNTED
    ///ELSE SEND NULL TO PAYMENT ANALYTICS
    var paymentAnalytic = null;
    /*if (assessment.F8 == assessment.F7) {
        paymentAnalytic = {};
        paymentAnalytic.F7 = this.state.bookAssessment.F7;
        paymentAnalytic.TOId = this.state.currentAssessmentBoss.OGID || 0;
        paymentAnalytic.F3 = this.state.currentAssessmentBoss.RDT;
        paymentAnalytic.F4 = "Seva";
        paymentAnalytic.CBPI = this.props.currentPersonDetails.UId;
        paymentAnalytic.CBPN = this.props.currentPersonDetails.RDT;
        paymentAnalytic.FId = parseInt(this.state.bookAssessment.FId);
        paymentAnalytic.RDT = this.state.bookAssessment.RDT;
        paymentAnalytic.RDUId = [parseInt(this.state.currentAssessmentBoss.OGID)]; //this just to fullfill server validation, actual invoice ID being assinged on server in this field.
        paymentAnalytic.AG = [parseInt(this.state.bookAssessment.FId), parseInt(this.state.currentAssessmentBoss.OGID)];
        paymentAnalytic.AT = "PAYMENT";
    }*/
    var assessmentInvoice = {};
    assessmentInvoice.CBPI = kid.Id;
    assessmentInvoice.AT = "INVOICE";
    assessmentInvoice.BOSSId = kid.Id;
    assessmentInvoice.Amount = activity.F7 ? activity.F7 : 4599;
    assessmentInvoice.Type = "ASSESSMENTS";
    assessmentInvoice.CenterId = kid.CenterId;
    assessmentInvoice.NoOFTherapies = 1;
    assessmentInvoice.TotalAmount = activity.F7 ? activity.F7 : 4599;
    assessmentInvoice.SevaAmount = 0;
    assessmentInvoice.FDT = PSdateFormate(new Date());
    assessmentInvoice.TDT = PSdateFormate(new Date());
    assessmentInvoice.CDT = PSdateFormate(new Date());
    assessmentInvoice.Status = "PAID";
    assessmentInvoice.E5 = activity.Name + ":2599 , StartDate: , EndDate : , Fees:2599";

    // Name + Lead + age + Gender + Faility name
    //obj.F3 = state.U.RDT + "{#}" + "" + "{#}" + "" + "{#}" + state.U.S + "{#}" + "" + "{#}" + state.U.F1;
    return { assessmentObj, assessmentInvoice };
  }
  catch (e) {
    console.log(e);
  }
}

export function setbar(parent, isRed) {
  isRed = isRed || true;
  var green = parent.getElementsByClassName("zero").length;
  var total = parent.getElementsByClassName("each-box").length;
  parent.classList.remove("greenbar");
  parent.classList.remove("redbar");


  if (total / 2 < green) {
    parent.classList.add(isRed ? "greenbar" : "redbar");
  }
  else {
    parent.classList.add(isRed ? "redbar" : "greenbar");
  }
}

export function CreateBookAssessmentFromGoal(goal, masterData, therapist) {
  if (!goal) {
    return;
  }


  var value = getUserSettingsValue("GoalAssessmentConfig");
  if (!value) {
    return;
  }
  var newId = masterData.Therapies.filter(e => e.Id == goal.TherapyId)[0];
  var newName = masterData.Types.filter(e => e.Id == newId.TypeId)[0];
  var currentassessment = masterData.Types.filter((e) => e.Category == "ASSESSMENT")


  var matchedId = $.grep(value.split("{#}"), function (e) { return e.indexOf(newName.Name) > -1 })[0];
  if (!matchedId) {
    return;
  }

  var activity = currentassessment.filter(e => e.F2 == matchedId.split(":")[1].toLowerCase())[0]
  // var activity = $.grep(masterData.MasterData, function (e) { return e.AT && e.AT.toUpperCase() == "ASSESSMENT" && e.RDId.toLowerCase() == matchedId.split(":")[1].toLowerCase() })[0];
  if (null == activity) {
    return;
  }



  var obj = new Object();
  //var a = new Array();
  //a.push(activity.UId);
  obj.AssessmentTypeId = activity.Id;// amount;
  // obj.F5 = state.U.F6;
  obj.ParentId = newId.BossId;
  // obj.F8 = 0;
  obj.TherapyId = goal.TherapyId;
  //obj.RDID = [activity.RDId];
  // obj.RDUId = a;
  obj.Name = activity.Name;
  obj.Status = "PENDING";
  obj.IQMId = activity.F2;
  //obj.AG = [goal.TOId, therapist.OGID, goal.FId, PBNGID]
  // obj.AT = "BOOKASSESSMENT";
  //obj.F10 = "GOAL";
  //obj.F11 = goal.UId + "";
  //obj.FId = goal.FId;
  //obj.FId = goal.FId;
  obj.CBPI = therapist.Id;
  // obj.CBPN = therapist.RDT;
  // Name + Lead + age + Gender + Faility name
  // obj.F3 = goal.F3 + "{#}" + "" + "{#}" + "" + "{#}" + state.U.S + "{#}" + "" + "{#}" + state.U.F1;
  //var facilityData = masterData.Facilities;

  //var facility = !goal.FId ? null : $.grep(facilityData, function (e) { return e.GUId == goal.FId + "" })[0];


  if (therapist) {
    var designation = "";
    if (therapist.F5) {
      var userDetails = therapist.F5.split("{#}");

      designation = userDetails[0];
    }

    //obj.F6 = therapist.OGID + "{#}" + designation + "{#}" + therapist.RDT + "{#}" + therapist.F1;

  }
  //obj.F12 = null == facility ? "" : facility.N;
  // obj.F3 = "SERVERWILLUPDATE{#}{#}{#}{#}{#}{#}{#}";
  // "F6": "20709089888{#}Behavioural Therapist{#}Madasi Jessy Diayana{#}9121388267",
  return obj;

}
// #endregionv

export function ManageOrgansGroup(groupList = [], keyvalue = "organColor",totalSessions=null) {
  if (!groupList || groupList.length === 0) return null;

  // count by color
  // count by color
  const colorCount = groupList.reduce(
    (acc, organ) => {
      const color = (organ[keyvalue] || "").toLowerCase();
      if (color === "red") acc.red += 1;
      else if (color === "yellow") acc.yellow += 1;
      else if (color === "green") acc.green += 1;
      return acc;
    },
    { red: 0, yellow: 0, green: 0 }
  );

  // hide if all are zero
  if (colorCount.red + colorCount.yellow + colorCount.green === 0) return null;

  return (
    <span
      className="settings-manage"
      style={{/* marginTop: '8px', */marginRight: '0px', display: 'inline-block', width: 'auto', paddingRight: "2px" }}
    >
    { (totalSessions && totalSessions > 0 && <><span className="green todo-right-badge " style={{marginRight: '2px'}}>900+</span> in {Math.round(totalSessions)} sessions</>)
}


      {(
        <span
          className="red todo-right-badge"
          style={{ marginRight: "2px" }}
        >
          {colorCount.red}
        </span>
      )}
      {(
        <span
          className="yellow todo-right-badge"
          style={{ marginRight: "2px" }}
        >
          {colorCount.yellow}
        </span>
      )}
      {(
        <span
          className="green todo-right-badge"
          style={{ marginRight: "2px" }}
        >
          {colorCount.green}
        </span>
      )}/{groupList.length}
    </span>
  );
}

// Accepts the array and key
export function groupBy(array, key, isLower) {
  // Return the end result
  isLower = isLower || false;
  array = array && array.length > 0 ? array : [];
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    if (currentValue && currentValue[key]) {
      if (isLower) {
        (result[currentValue[key].toLowerCase()] = result[currentValue[key].toLowerCase()] || []).push(
          currentValue
        );
      }
      else {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );
      }
    }
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
}

export function groupByMultiple(array, key, isLower, specialCharacter = ",") {
  // Return the end result
  isLower = isLower || false;
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    if (currentValue && currentValue[key]) {
      currentValue[key] = currentValue[key] + "" ? currentValue[key] : "";
      var multiple = (currentValue[key] + "").split(specialCharacter);
      for (var i = 0; i < multiple.length; i++) {
        var value = multiple[i];
        if (value) {
          value = value.trim();
          if (isLower) {
            (result[value.toLowerCase()] = result[value.toLowerCase()] || []).push(
              currentValue
            );
          }
          else {
            (result[value] = result[value] || []).push(
              currentValue
            );
          }
        }
      }

    }
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
}

export function groupByWithHypen(array, key, isLower) {
  // Return the end result
  array = JSON.parse(JSON.stringify(array));
  isLower = isLower || false;
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    if (currentValue && currentValue[key]) {
      currentValue[key] = currentValue[key].toLowerCase().indexOf("others") > -1 ? currentValue[key].split("-")[0] : currentValue[key];
      if (isLower) {
        (result[currentValue[key].toLowerCase()] = result[currentValue[key].toLowerCase()] || []).push(
          currentValue
        );
      }
      else {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );
      }
    }
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
}

export var arrowRight = <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeMiterlimit={10} x1={12} y1={24} x2={34} y2={24} strokeLinejoin="miter" strokeLinecap="butt" /> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points=" 26,16 34,24 26,32 " strokeLinejoin="miter" /> <circle fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={24} cy={24} r={22} strokeLinejoin="miter" /></g></svg>

//<svg id="Icons" enableBackground="new 0 0 128 128" height={512} viewBox="0 0 128 128" width={512} xmlns="http://www.w3.org/2000/svg"><path id="Right" d="m64 0c-35.289 0-64 28.711-64 64s28.711 64 64 64 64-28.711 64-64-28.711-64-64-64zm0 120c-30.879 0-56-25.121-56-56s25.121-56 56-56 56 25.121 56 56-25.121 56-56 56zm26.828-58.828c1.563 1.563 1.563 4.094 0 5.656l-20 20c-.781.781-1.805 1.172-2.828 1.172s-2.047-.391-2.828-1.172c-1.563-1.563-1.563-4.094 0-5.656l13.172-13.172h-38.344c-2.209 0-4-1.789-4-4s1.791-4 4-4h38.344l-13.172-13.172c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0z" /></svg>

export var arrowDown = <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth={3}><g strokeWidth={3} transform="translate(0.5, 0.5)"><circle fill="none" stroke="#444444" strokeWidth={3} strokeLinecap="square" strokeMiterlimit={10} cx={24} cy={24} r={22} strokeLinejoin="miter" /> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth={3} strokeLinecap="square" strokeMiterlimit={10} points=" 32,21 24,29 16,21 " strokeLinejoin="miter" /></g></svg>


export function getMonthDifference(startDate, endDate) {
  return (
    endDate.getMonth() -
    startDate.getMonth() +
    12 * (endDate.getFullYear() - startDate.getFullYear())
  );
}

export function getUserSettingsValue(key) {
  var configJsonString = localStorage.getItem("UserSettings");

  if (configJsonString) {
    var settings = JSON.parse(configJsonString).filter(function (e) { return e.Name == key })[0];
    if (settings) {
      return settings.Value;
    }
  }
  return "";
}
export function getUserRole() {
  try {
    var jsonString = localStorage.getItem("UserRoles");

    if (jsonString) {
      var rolesList = JSON.parse(jsonString);
      var role = rolesList.some(function (e) { return e.toLowerCase() == "ccc" }) ? "NCC" :
        rolesList.some(function (e) { return e.toLowerCase() == "receptionist" }) ? "Receptionist" : rolesList.some(function (e) { return e.toLowerCase() == "manager" }) ? "Manager" : rolesList.some(function (e) { return e.toLowerCase() == "owner" }) ? "Owner" : rolesList.some(function (e) { return e.toLowerCase() == "facilityowner" }) ? "FacilityOwner" : rolesList.some(function (e) { return e.toLowerCase() == "chieftherapist" }) ? "chieftherapist" : rolesList.some(function (e) { return e.toLowerCase() == "therapist" }) ? "therapist" : "boss";

      return role;
    }
    else {
      return "boss";
    }
  } catch (e) {
    console.error("error in reading clientype from local storage...");
    console.log(e);

    return "";
  }
}

export const isNullOrEmpty = (value) => {

  if (!value || value == "undefined" || null == value || value == "" || value == typeof ("undefined") || $.isEmptyObject(value) || value.length <= 0) {
    return true;
  }

  return false;
}

export function calculateAge(dobString, LangLabels) {
  if (!dobString) {
    return "0.0" + getLabel('Yrs', LangLabels);
  }
  dobString = dobString ? dobString : new Date();
  const dob = new Date(dobString);
  const now = new Date();

  const years = now.getFullYear() - dob.getFullYear();
  const months = now.getMonth() - dob.getMonth() + (years * 12);

  const ageInYears = Math.floor(months / 12);
  const remainingMonths = months % 12;

  return `${ageInYears}.${remainingMonths}${getLabel('Yrs', LangLabels)}`;
}

export function getYears(dobString) {
  const dob = new Date(dobString);
  const now = new Date();

  const years = now.getFullYear() - dob.getFullYear();
  const months = now.getMonth() - dob.getMonth() + (years * 12);

  const ageInYears = Math.floor(months / 12);

  return ageInYears;
}


///GET READINESSSCORE
export const GetReadinessScore = (assessmentResult, readinessConfig, kid) => {
  try {
    if (assessmentResult && readinessConfig) {
      var skillsConfig = readinessConfig && readinessConfig.F4 ? JSON.parse(readinessConfig.F4) : [];
      var abilitiesConfig = readinessConfig && readinessConfig.F5 ? JSON.parse(readinessConfig.F5) : [];
      var asagiiConfig = readinessConfig && readinessConfig.F6 ? JSON.parse(readinessConfig.F6) : [];

      var domainResponse = assessmentResult && assessmentResult.DomainResponse ? JSON.parse(assessmentResult.DomainResponse) : [];
      var abilityResponse = assessmentResult && assessmentResult.F1 ? JSON.parse(assessmentResult.F1) : [];
      ///Get Skills Score
      skillsConfig.forEach(t => {
        try {

          t.AS = domainResponse && domainResponse.length > 0 ? domainResponse.filter(d => d.DN == t.Name).reduce((acc, curr) => acc + curr.DS, 0) : 0;
          t.TS = domainResponse && domainResponse.length > 0 ? domainResponse.filter(d => d.DN == t.Name).reduce((acc, curr) => acc + curr.TS, 0) : 0;
          t.CS = t.AS == 0 && t.TS == 0 ? 0 : (t.Weightage / t.TS) * t.AS;
        }
        catch (e) {
          SaveCleintWaufli(e, "Skill Config Calculation Failed KIdId " + (assessmentResult && assessmentResult.KidId), "GetReadinessScore");
          throw e;
        }

      });

      ///Get Ablities Score
      abilitiesConfig.forEach(t => {
        try {
          t.AS = abilityResponse.filter(d => d.DK == t.Name).reduce((acc, curr) => acc + curr.DS, 0);
          t.TS = abilityResponse.filter(d => d.DK == t.Name).reduce((acc, curr) => acc + curr.TS, 0);
          t.CS = t.AS == 0 && t.TS == 0 ? 0 : (t.Weightage / t.TS) * t.AS
        }
        catch (e) {
          SaveCleintWaufli(e, "Abilities Config Calculation Failed " + (assessmentResult && assessmentResult.KidId), "GetReadinessScore");
          throw e;
        }

      });

      ///Calculate Total Scores

      var maxSkillScore = skillsConfig.reduce((acc, curr) => acc + curr.Weightage, 0);
      var maxAbilitiesScore = abilitiesConfig.reduce((acc, curr) => acc + curr.Weightage, 0);

      var averageSkillScore = (maxSkillScore / ((readinessConfig.F10) * 1.0));
      var averageAbilityScore = (maxAbilitiesScore / ((readinessConfig.F11) * 1.0));

      //   console.log(averageSkillScore);
      //   console.log(averageAbilityScore);





      var skillScore = skillsConfig.reduce((acc, curr) => acc + curr.CS, 0);
      var abilityScore = abilitiesConfig.reduce((acc, curr) => acc + curr.CS, 0);


      var skillPercentage = readinessConfig.F10;
      var abilityPercentage = readinessConfig.F11;

      ///Calculate Final Score 
      var finalScore = (((skillScore / averageSkillScore)) + ((abilityScore / averageAbilityScore))) * 10;

      // Get the child's age in years
      const age = getYears(kid?.DOB);

      var gender = kid?.Gender && kid?.Gender.toLowerCase() == "female" ? "Girl" : "Boy";

      // Find the corresponding ASAGII configuration based on age
      const asagii =
        asagiiConfig?.find(f => f.Gender == gender && f.Age === age) ||
        asagiiConfig?.find(f => f.Gender == gender && f.Age === 999);

      var assagiScore = asagii ? ((100 - (parseFloat(assessmentResult?.F2) / asagii.Baseline) * 100)) : 0;
      assagiScore = assagiScore > 0 ? assagiScore : 0;

      // Calculate the final score adjustment
      let adjustedScore = asagii
        ? finalScore - assagiScore
        : finalScore;

      // Ensure the final score is not negative
      return Math.max(adjustedScore, 0);
    }
  }
  catch (e) {
    SaveCleintWaufli(e, "GetReadinessScore Failed Overall KidId : " + (assessmentResult && assessmentResult.KidId), "GetReadinessScore");
  }
}



export function getUserToken() {
  var token = ""
  try {
    token = cookie.load('validatorauth-s');

    if (!token) {
      token = localStorage.getItem("validatorauth-s");
    }

  } catch (e) {
    //console.log("error in reading token from cookie...");
    //console.log(e);
    token = localStorage.getItem("validatorauth-s");
  }

  return token;
}

export function getFastCommentsSSO(user) {
  var fastCommentsObj = {};
  try {
    fastCommentsObj.tenantId = "Hv3JnFStbE";
    var image = user && user.IsProfileSet == 1 ? ('https://images.pinnacleblooms.org/images/ProfileImages/' + user.Id + '.jpg?v=' + CreateGuid()) : "https://mirracle.pinnacleblooms.org/images/logos/pinnacle-logo-amblum-48.png";
    if (user) {
      var email = user.EmailId ? user.EmailId.split(',')[0] : "";
      fastCommentsObj.simpleSSO = { "id": user.Id.toString(), "username": user.Name, "email": email && email.length > 1 ? email : user.Id + "_mirracle@gmail.com", "avatarSrc": image, "avatar": image, "websiteUrl": "https://mirracle.pinnacleblooms.org/" }
    }
    else {
      fastCommentsObj.simpleSSO = {};
    }

    return fastCommentsObj;
  } catch (err) {
    console.log("Error in getFastCommentsSSO : " + err);
  }
}

export function getCurrentDateTime() {

  var currentTime = new Date();

  var currentOffset = currentTime.getTimezoneOffset();

  var ISTOffset = 330; // IST offset UTC +5:30

  var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

  return ISTTime;
}

export const shareViaWeb = function () {

}

export const saveAs = (uri, filename) => {
  saveFile(uri, filename);
}

export const GetDiscountPercentage = function (totalAmount, disCountAmout) {
  return getCouponAmount(totalAmount, disCountAmout);

}
export const LoadGuestHandler = function (url, isAuthNeeded, title) {
  return loadGuestHandler(url, isAuthNeeded, title);
}
export const GetRedirectionURL = function (urltype, user, role, openurl, fid) {
  fid = fid || null;
  role = typeof role != "string" ? null : role;
  openurl = typeof openurl != "boolean" ? null : openurl;
  return getRedirectionURL(urltype, user, role, openurl, fid);
}



export const GetCouponAmount = function (totalAmount, percentage) {
  return getCouponAmount(totalAmount, percentage);

}

export const StoreChanakyaInLs = function (activity, config) {
  try {
    this.IsSavingChankya = activity;
    switch (config.toLowerCase()) {
      case "bookmark":
        this.BookMarksData = JSON.parse(localStorage.getItem(this.lsCBMD));
        this.BookMarksData = this.BookMarksData ? this.BookMarksData : [];

        this.BookMarksData.push(activity.Id);
        this.setState({ BookMarksData: this.BookMarksData, BookMarks: this.BookMarksData });
        localStorage.setItem(this.lsCBMD, JSON.stringify(this.BookMarksData));

        break;
      case "love":

        this.LoveData = JSON.parse(localStorage.getItem(this.lsCLD));
        this.LoveData = this.LoveData ? this.LoveData : [];
        this.LoveData.push(activity.Id);
        this.setState({ LoveData: this.LoveData, Favorites: this.LoveData });
        localStorage.setItem(this.lsCLD, JSON.stringify(this.LoveData));

        break;
      case "unbookmark":
        this.BookMarksData = JSON.parse(localStorage.getItem(this.lsCBMD));
        this.BookMarksData = this.BookMarksData ? this.BookMarksData : [];

        this.BookMarksData = $.grep(this.BookMarksData, function (e) { return e != activity.Id });
        this.setState({ BookMarksData: this.BookMarksData, BookMarks: this.BookMarksData });
        localStorage.setItem(this.lsCBMD, JSON.stringify(this.BookMarksData));

        break;
      case "unlove":
        this.LoveData = JSON.parse(localStorage.getItem(this.lsCLD));
        this.LoveData = this.LoveData ? this.LoveData : [];
        this.LoveData = $.grep(this.LoveData, function (e) { return e != activity.Id });
        this.setState({ LoveData: this.LoveData, Favorites: this.LoveData });
        localStorage.setItem(this.lsCLD, JSON.stringify(this.LoveData));
        break;
    }


  } catch (e) {
    console.log(e);
  }
}

export const ValidateDateInputs = (inputs) => {
  var ArrayOfErrorMsg = [];
  ArrayOfErrorMsg = inputs.split("{#}");
  if (ArrayOfErrorMsg != [] && ArrayOfErrorMsg.length > 0) {
    return false;
  } else {
    return true;
  }
  return false;
}
export const ValidateInputsOverlay2 = (tabId) => {
  var ArrayOfErrorMsg = [];
  try {
    ArrayOfErrorMsg = InputValidatorReturnObject(tabId);
    ResetErrorvalidation(ArrayOfErrorMsg);

    if (ArrayOfErrorMsg != [] && ArrayOfErrorMsg.length > 0) {

      if (ArrayOfErrorMsg.length > 20) {
        $('.validation-verify-overlay .status-msg').addClass('lotdatascrolflow');
      }
      else {
        $('.validation-verify-overlay .status-msg').removeClass('lotdatascrolflow');
      }

      var MessagewithHTMLTags = '';
      //console.log('sa:' + JSON.stringify(ArrayOfErrorMsg));
      $.each(ArrayOfErrorMsg, function (index, value) {
        try {
          MessagewithHTMLTags += "<div id='" + value.id + "'> <b>&nbsp;" + ++index + ".&nbsp;</b>" + value.msg + "</div>\n\n";
          $("span" + value.id).addClass("active");
          $("span" + value.id).removeClass("no-display");
          $("input" + value.id).addClass("caseerror");
          $("select" + value.id).addClass("caseerror");
          $("textarea" + value.id).addClass("caseerror");
          //console.log(value.msg + ": :" + value.id);
        } catch (e) {
          console.log(e.message);
        }
      });

      //if (overlayRequired) {
      //    ShowValidationStatusOverlay(MessagewithHTMLTags);
      //}

      return false;
    } else {
      return true;
    }

  } catch (e) {
    console.log(JSON.stringify(e));
  }
  return false;
}

export const showConfirmBoxWithCancel = (message, header, buttonvalue, isItError, callback) => {
  showConfirmBoxWithCancel2(message, header, buttonvalue, isItError, callback);
}

export const ShowToastMessage = (message, timeout, type) => {
  ToastMessage(message, timeout, type);
}



export const IsApp = (type) => {
  return (type && (type.toLowerCase().startsWith("ios") || type.toLowerCase().startsWith("android") || type.toLowerCase() == "ios" || type.toLowerCase() == "android"))
}

export const IsAndroid = (type) => {
  return (type && (type.toLowerCase().startsWith("android") || type.toLowerCase() == "android"))
}

export const IsIOS = (type) => {
  return (type && (type.toLowerCase().startsWith("ios") || type.toLowerCase() == "ios"))
}

export const getMobileOS = () => {
  return getMobileOperatingSystem();
}

export const getUsageType = () => {
  return getUsageTypeFromLS();
}

export const IsAppTypePro = () => {
  return IsProType();
}



export const showLockedBox = (message, header, buttonvalue, isItError, callback, image) => {
  showLockedBoxMessage(message, header, buttonvalue, isItError, callback, image);
}

export const ValidatePayload = (payload) => {
  return ValidatePayLoad(payload);
}

export const getDateTime = (date) => {
  return getTimeDay(date);
}

export const getPublishedDateFormat = (date) => {

  var param1 = new Date();
  var start_actual_time1 = new Date(date);

  var start_actual_time = Date.parse(start_actual_time1);//start_actual_time1.setMinutes(start_actual_time1.getMinutes() - 330);
  var epochTime = Date.parse(param1);
  // alert(start_actual_time + ' ' + end_actual_time);
  var diff = epochTime - start_actual_time;

  var diffSeconds = diff / 1000;
  var HH = parseInt(Math.floor(diffSeconds / 3600));
  var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);

  if (HH < 1) {
    if (MM <= 1) {
      return "Few Seconds ago";
    }
    else {
      return MM + " Minutes ago";
    }
  }
  else if (HH < 23) {
    return HH + " Hours ago";
  }
  else if (HH > 23 && HH < 36) {
    return "Yesterday";
  }
  else if (HH > 36) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var dayFs = Math.floor(HH / 24);
    // console.log(dayFs);
    if (dayFs > 365) {
      var year = dayFs / 365;
      return year.toFixed(1) + "  YEAR AGO";
    }
    return Math.floor(HH / 24) + ' DAYS AGO'; //+  days[start_actual_time1.getDay()];
  }

}

export function DurationInDays(t1, isAdd) {
  // console.log(t1);
  isAdd = isAdd || false;
  let d = ((isAdd ? new Date(t1).setHours(24) : new Date(t1)) - new Date());
  //console.log(d);


  var diffSeconds = d / 1000;
  var HH = parseInt(Math.floor(diffSeconds / 3600));
  var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);
  var dd = Math.floor(HH / 24);

  //let weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
  //let days = Math.floor(d / 1000 / 60 / 60 / 24 - weekdays * 7);
  //let hours = Math.floor(d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24);
  //let minutes = Math.floor(d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60);
  //let seconds = Math.floor(d / 1000 - weekdays * 7 * 24 * 60 * 60 - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60);
  //let milliseconds = Math.floor(d - weekdays * 7 * 24 * 60 * 60 * 1000 - days * 24 * 60 * 60 * 1000 - hours * 60 * 60 * 1000 - minutes * 60 * 1000 - seconds * 1000);

  //let t = {};
  //['weekdays', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'].forEach(q=>{ if (eval(q)>0) { t[q] = eval(q); } });


  return dd;
}


export function formatCDT(cdt) {
  const date = new Date(cdt);

  const day = String(date.getDate()).padStart(2, '0');

  const monthShort = date.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // "Sep" → "SEP"
  const year = date.getFullYear();

  const hours24 = date.getHours();
  const hours12 = hours24 % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours24 >= 12 ? 'PM' : 'AM';

  return `${day}-${monthShort}-${year} ${String(hours12).padStart(2, '0')}:${minutes} ${ampm}`;
}

export function LeftDuration(t1, isAdd) {
  // console.log("t1");
  isAdd = isAdd || false;

  let d = ((isAdd ? new Date(t1).setHours(24) : new Date(t1)) - new Date());
  //  console.log(d);


  var diffSeconds = d / 1000;
  var HH = parseInt(Math.floor(diffSeconds / 3600));
  var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);
  var dd = Math.floor(HH / 24);

  let weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
  let days = Math.floor(d / 1000 / 60 / 60 / 24 - weekdays * 7);
  let hours = Math.floor(d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24);
  let minutes = Math.floor(d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60);
  let seconds = Math.floor(d / 1000 - weekdays * 7 * 24 * 60 * 60 - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60);
  let milliseconds = Math.floor(d - weekdays * 7 * 24 * 60 * 60 * 1000 - days * 24 * 60 * 60 * 1000 - hours * 60 * 60 * 1000 - minutes * 60 * 1000 - seconds * 1000);

  //let t = {};
  //['weekdays', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'].forEach(q=>{ if (eval(q)>0) { t[q] = eval(q); } });


  return dd + " days " + hours + " hours left";
}


export const validationError = (event) => {
  validation(event);
}

export const GetTimeStamp = (data) => {
  //console.log("GetTimeStamp===");
  return getTimeStamp(data);
}

export const GetTimeStampfromTime = (time, add45) => {
  //console.log("GetTimeStamp===from time" + time);
  return getTimeStampfromTime(time, add45);
}

export const GetMonthNamefromDate = (date) => {
  return getMonthNamefromDate(date);
}

export const GetTimeSpan = (date) => {
  return getTimeSpan(date);
}

export const GetDueMessage = (date) => {
  return getDueMessage(date);
}
export const DynamicSort = (property) => {
  return dynamicSort(property);
}

export const convertJsonDateToDate = (data) => {
  //console.log("GetTimeStamp===");
  return convertJsonDateToDate1(data);
}

export const receivePayment = (invoice, $index) => {
  //console.log("GetTimeStamp===");
  return receivePayment(invoice, $index);
}
export const checkToday = (date) => {
  return isToday(date);
}
export const checkTomorrow = (date) => {
  return isTomorrow(date);
}

export const GetAggregateValue = (isleader) => {
  return getAggregateValue(isleader);
}




export const numbersafterthousand = (x) => {
  return Numbersafterthousand(x);
}

export const formatAMPM = (time) => {
  return FormatAMPM(time);
}

export const numberWithCommas = (x) => {
  return NumberWithCommas(x);
}

export const GetJoiningDate = (date, LangLabels) => {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }
    var nDate = new Date(date);
    return (((getLabel(allMonthShortNames[(nDate.getMonth())], LangLabels))) + " " + nDate.getUTCFullYear());
  } catch (e) {

  }
}
export const DateFromDateTime = (date) => {
  return dateFromDateTime(date);
}
export const DateFromDateTimeWithTime = (date) => {
  return dateFromDateTimeWithTime(date);
}
export const isValidDate = (date) => {
  return isDateValid(date);
}
export const CheckDateBetween = (dateF, dateTo, checkDate) => {
  return checkDateBetween(dateF, dateTo, checkDate);
}
function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

export function PSdateFormate(date) {
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join('-') +
    ' ' +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds()),
    ].join(':')
  );
}

export function GetMonthDateFormat(date) {
  date = new Date(date);
  const rDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return rDate;
}
export const GetDateFormat = (date) => {
  return GetDateFormatValue(date);
}

export const GetTimeFormat = (date) => {
  return GetTimeFormatValue(date);
}


export const AddDays = (date, days) => {
  return addDays(date, days);
}

export const CreateNewGuid = () => {

  try {
    return CreateGuid()
  } catch (e) {
    console.log(JSON.stringify(e));
  }
}

function getCouponAmount(totalAmount, percentage) {
  var amount = (totalAmount * percentage) / 100;;

  return amount
}

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
function dynamicSort(property) {
  var sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return function (a, b) {
    if (sortOrder == -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  }
}
function addDays(date, days) {
  var one_day = 1000 * 60 * 60 * 24;
  return new Date(date.getTime() + (days * one_day));
}
function convertJsonDateToDate1(jsonDate) {
  var strDate = new Date(jsonDate).toISOString().split("T")[0];
  var time = getTime(jsonDate);

  return strDate + " " + getTimeStamp(new Date(jsonDate));
}


function ValidatePayLoad(payLoad) {
  try {
    let orginalFields = [
      { "Field": "AT", "Type": "string" },
      { "Field": "Id", "Type": "string" },
      { "Field": "CBPI", "Type": "number" },
      { "Field": "CBPN", "Type": "string" },
      { "Field": "CDT", "Type": "date" },
      { "Field": "MG", "Type": "Array" },
      { "Field": "AG", "Type": "Array" },
      { "Field": "RDT", "Type": "string" },
      { "Field": "RDD", "Type": "string" },
      { "Field": "RS", "Type": "string" },
      { "Field": "RDID", "Type": "string" },
      { "Field": "RDUId", "Type": "Array" },
      { "Field": "UId", "Type": "number" },
      { "Field": "TOId", "Type": "number" },
      { "Field": "OGID", "Type": "number" },
      { "Field": "S", "Type": "string" },
      { "Field": "FDT", "Type": "date" },
      { "Field": "TDT", "Type": "date" },
      { "Field": "UDT", "Type": "date" },
      { "Field": "F1", "Type": "string" },
      { "Field": "F2", "Type": "string" },
      { "Field": "F3", "Type": "string" },
      { "Field": "F4", "Type": "string" },
      { "Field": "F5", "Type": "string" },
      { "Field": "F6", "Type": "string" },
      { "Field": "F7", "Type": "number" },
      { "Field": "F8", "Type": "number" },
      { "Field": "F9", "Type": "number" },
      { "Field": "F10", "Type": "string" },
      { "Field": "F11", "Type": "string" },
      { "Field": "O1", "Type": "object" },
      { "Field": "O2", "Type": "object" },
      { "Field": "O3", "Type": "object" },
      { "Field": "O4", "Type": "object" },
      { "Field": "FId", "Type": "number" }
    ];

    for (let field in payLoad) {
      var val = orginalFields.filter(x => x.Field == field);

      if (val && val.length > 0) {
        if ((val[0].Type == "string") && !payLoad[field]) {
          payLoad[field] = "";
        }
        else if (val[0].Type == "number" && !payLoad[field]) {
          payLoad[field] = 0;
        }
        else if ((val[0].Type == "Array") && !Array.isArray(payLoad[field])) {
          payLoad[field] = [];
        }
        else if (val[0].Type == "date") {
          var fdTimetamp = Date.parse(payLoad[field]);

          if (isNaN(fdTimetamp)) {
            payLoad[field] = "0001-01-01T00:00:00.000Z";
          }
        }
      }
    }

  } catch (e) {
    console.log(e);
  }
  return payLoad;
}


export function isRUToday(someDate) {
  try {
    if (!someDate) {
      return false;
    }

    //console.log(someDate.split("T")[0]);

    someDate = new Date(someDate.split("T")[0])
    var date = new Date();
    var d = date.getDay() == 6 ? 1 : date.getDay() == 0 ? 2 : 0;
    // console.log(date.setDate(date.getDate() - d));
    // date.setDate(date.getDate() - d);// new Date();
    return someDate.getDate() == date.getDate() &&
      someDate.getMonth() == date.getMonth() &&
      someDate.getFullYear() == date.getFullYear()

  } catch (e) {
    console.log("Error in isToday : " + e);
    return false;
  }
}


function isToday(someDate) {
  try {
    if (!someDate) {
      return false;
    }

    //console.log(someDate.split("T")[0]);

    someDate = someDate && someDate.includes("T") ? new Date(someDate.split("T")[0]) : new Date(someDate);
    var date = new Date();
    var d = date.getDay() == 6 ? 1 : date.getDay() == 0 ? 2 : 0;
    // console.log(date.setDate(date.getDate() - d));
    date.setDate(date.getDate() - d);// new Date();
    return someDate.getDate() == date.getDate() &&
      someDate.getMonth() == date.getMonth() &&
      someDate.getFullYear() == date.getFullYear()

  } catch (e) {
    console.log("Error in isToday : " + e);
    return false;
  }
}

function isTomorrow(someDate) {
  if (!someDate) {
    return false;
  }

  someDate = someDate && someDate.includes("T") ? new Date(someDate.split("T")[0]) : new Date(someDate);
  //someDate = new Date(someDate);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return someDate.getDate() == tomorrow.getDate() &&
    someDate.getMonth() == tomorrow.getMonth() &&
    someDate.getFullYear() == tomorrow.getFullYear()
}

function checkDateBetween(dateFrom, dateTo, dateCheck) {
  try {
    var check = new Date(dateCheck.getFullYear(), dateCheck.getMonth(), dateCheck.getDate());
    //  + "-" + (new Date(dateCheck).getMonth() + 1) + "-" + new Date(dateCheck).getFullYear()
    return dateFromSDateTime(dateTo) >= check && dateFromSDateTime(dateFrom) <= check;


    var from = new Date(dateFrom).getDate() + "-" + (new Date(dateFrom).getMonth() + 1) + "-" + new Date(dateFrom).getFullYear();  // -1 because months are from 0 to 11
    var to = new Date(dateTo).getDate() + "-" + (new Date(dateTo).getMonth() + 1) + "-" + new Date(dateTo).getFullYear();
    var check = new Date(dateCheck).getDate() + "-" + (new Date(dateCheck).getMonth() + 1) + "-" + new Date(dateCheck).getFullYear();
    return check >= from && check <= to;
  } catch (e) {

  }
}
function getTimeStampfromTime(time, add45) {
  if (!time) {
    return;
  }
  var time_part_array = time.split(":");

  var ampm = 'AM';

  if (add45) {
    time_part_array[1] = parseInt(time_part_array[1]) + 45;
    if (time_part_array[1] >= 60) {
      time_part_array[1] = parseInt(time_part_array[1]) - 60;
      time_part_array[0] = parseInt(time_part_array[0]) + 1;
      time_part_array[0] = time_part_array[0] < 9 ? "0" + time_part_array[0] : time_part_array[0];
      time_part_array[1] = time_part_array[1] < 9 ? "0" + time_part_array[1] : time_part_array[1];
    }
  }
  if (time_part_array[0] >= 12) {
    ampm = 'PM';
  }

  if (time_part_array[0] > 12) {
    time_part_array[0] = time_part_array[0] - 12;
  }



  var formatted_time = time_part_array[0] + ':' + time_part_array[1] + '' + ampm;

  return formatted_time;
}
export function getFormattedDate(date) {
  if (!date) {
    return;
  }
  //var time_part_array = date.split("T")[1].split(":");
  var newDate = new Date(date);
  var hours = newDate.getHours();
  var minutes = newDate.getMinutes();
  var ampm = 'am';


  if (hours >= 12) {
    ampm = 'pm';
  }

  if (hours > 12) {
    hours = hours - 12;
  }

  var allmonthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "December", "December"
  ];
  var newDate = new Date(date);
  var dd = newDate.getDate();
  var month = allmonthNames[newDate.getMonth()];
  var year = newDate.getFullYear();



  var formatted_time = dd + " " + month + " " + year + ' ' + hours + ':' + minutes + ' ' + ampm;

  return formatted_time;
}

function saveFile(uri, filename) {


  ///HANDLE SAFARI CHROME


  if (navigator.userAgent.match('CriOS')) {

    //alert('i am chrome safari');
    //  var dataURL = uri;
    var blob = window.dataURItoBlob(uri);
    // alert(blob);


    window.URL = window.URL || window.webkitURL;
    var url = window.URL.createObjectURL(blob);

    // downloadURI(url,"name.png");
    //window.open(url,"_blank");

    // location.href = url;
    var html_string = '<img src="' + uri + '" />'

    $('.card-download-overlay').addClass('active');

    // var iframe =  document.getElementById('download-frame'); //$('#download-frame')
    //  var iframedoc = iframe.contentDocument || iframe.contentWindow.document;
    //   iframedoc.body.innerHTML = "<style>html, body {margin: 0;} img{width:100%;}</style>" + html_string;


    $('#download-image').attr('src', uri);

    //download-frame
    //download-image
    return;


  }


  // alert('i am normal');


  var link = document.createElement('a');
  if (typeof link.download === 'string') {
    link.href = uri;
    link.download = filename;
    //Firefox requires the link to be in the body
    document.body.appendChild(link);
    //simulate click
    link.click();
    //remove the link when done
    document.body.removeChild(link);
  } else {
    window.open(uri);
  }
}
function CreateGuid() {
  function _p8(s) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }
  return _p8() + _p8(true) + _p8(true) + _p8();
}
export function GetSalaryGrades(amount) {
  try {
    if (!amount) return 0;

    if (amount <= 10000) return 52;
    if (amount <= 15000) return 53;
    if (amount <= 18000) return 54;
    if (amount <= 22000) return 55;
    if (amount <= 25000) return 56;
    if (amount <= 27000) return 57;
    if (amount <= 32000) return 58;
    if (amount <= 39000) return 59;
    if (amount <= 45000) return 60;
    if (amount <= 54000) return 61;
    if (amount <= 63000) return 62;
    if (amount <= 75000) return 63;
    if (amount <= 90000) return 64;
    if (amount <= 140000) return 65;
    if (amount <= 180000) return 66;
    if (amount <= 240000) return 67;
    if (amount <= 250000) return 68;
    if (amount > 250000) return 69;

    return 0;
  } catch (error) {
    return 0;
  }
}

export function filterKidsByUsers(users, kids) {
  if (!kids || !Array.isArray(kids)) {
    return [];
  }

  const usersArray = Array.isArray(users) ? users : (users ? [users] : []);

  const userIds = new Set(usersArray.map(u => u.Id));

  return kids
    .filter(k => k.RS !== 'DELETEACTIVITY' && userIds.has(k.BDCId))
    .map(k => k.Id);
}

export function dateFromSDateTime(date) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }

    if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.indexOf("T") > -1) {
      date = date + "Z";
    }

    var nDate = new Date(date);
    // console.log("dateFromSDateTime NEWDATE :"+nDate)
    var re = /-?\d+/;
    var m = re.exec(date);
    //  console.log(m);
    if (null == m || m.index == 0) {
      //nDate.setHours(nDate.getHours() - 5);
      // nDate.setMinutes(nDate.getMinutes() - 30);
    }
    return nDate;
  }
  catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}



export function mongodateforholidays(date) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }

    if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.indexOf("T") > -1) {
      date = date + "Z";
    }

    var nDate = new Date(date);
    // console.log("dateFromSDateTime NEWDATE :"+nDate)
    var re = /-?\d+/;
    var m = re.exec(date);
    //  console.log(m);
    if (null == m || m.index == 0) {
      nDate.setHours(nDate.getHours() - 5);
      nDate.setMinutes(nDate.getMinutes() - 30);
    }
    return nDate;
  }
  catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}
function getTimeData(h, m, s, ms, date) {
  var timeNew = new Date(date);
  timeNew.setHours(h, m, s, ms);
  // timeNew.setMinutes(m);
  var timeOfDay = timeNew.getTime();
  return timeOfDay;

}
export function GetAudioFile(data) {
  if (data.AT == "ATTENDANCE") {

    //var tag = data.UId + "-" + data.FId + "-" + data.TOId + "-" + data.CBPI + "-" + data.F6;
    //return window.root + "/Assets/VoiceMemo/" + data.FId + "/" + data.TOId + "/" + data.CBPI + "/" + tag + ".mp3";
    return window.R2Path + "/Assets/VoiceMemo/" + data.Id + ".mp3";
  }
  if (data.AT == "FEEDBACK") {
    //var tag = data.UId + "-" + data.FId + "-" + data.CBPI + "-" + data.TOId + "-" + data.CBPI;
    //return window.root  + "/Assets/VoiceMemo/" + data.FId + "/" + data.CBPI + "/" + data.TOId + "/" + tag + ".mp3";
    return window.R2Path + "/Assets/VoiceMemo/" + data.Id + ".mp3";
  }

  if (data.AT == "MEMO") {
    var tag = data.UId + "-" + data.FId + "-" + data.TOId + "-" + data.CBPI + "-" + data.CBPI;
    return window.R2Path + "/Assets/MemoVoiceMemo/" + data.Id;
    //return root + "/Assets/MemoVoiceMemo/" + data.FId + "/" + data.CBPI + "/" + data.TOId + "/" + tag + ".mp3";
  }
}

export function GetUTCDateForCreation(date) {
  //var date = new Date();
  var now_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(now_utc);
}



function convertArrayOfObjectsToCSV(args) {
  var result, ctr, keys, columnDelimiter, lineDelimiter, data;

  data = args.data || null;
  if (data == null || !data.length) {
    return null;
  }

  columnDelimiter = args.columnDelimiter || ',';
  lineDelimiter = args.lineDelimiter || '\n';

  var rKeys = data[0].RemovalKeys;
  // console.log("RemovalKeys",rKeys);
  // console.log("data",data[0]);
  if (rKeys && rKeys.length > 0) {

    data = data.map(obj => {
      const newObj = { ...obj }; // Create a shallow copy of the object

      rKeys.forEach(key => {
        delete newObj[key]; // Remove the specified keys from the object
      });

      return newObj;
    });
  }

  keys = Object.keys(data[0]);
  keys = keys.filter(f => f && f.toLowerCase().indexOf("mobile") == -1 && f.toLowerCase().indexOf("removalid") == -1);
  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  data.forEach(function (item) {
    ctr = 0;

    var removalId = item["RemovalId"];
    keys.forEach(function (key) {


      if (ctr > 0) result += columnDelimiter;

      var value = item[key];
      if (removalId && value) {
        removalId.split("{#}").forEach(function (val) {


          value = (value + "").replace(val, "");
        });
      }

      result += value ? ("\"" + ((value + "").replace(/#/gi, " ").replace(/,/gi, " ").replaceAll(/{#}/gi, " ").replace(/{/gi, " ").replace(/}/gi, " ")) + "\"") : value;

      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

export function GetInformationicon(top, left, color, type, mr) {
  mr = mr || "6";
  return <svg onClick={() => { ShowInformation(type) }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" style={{ height: '20px', width: '20px', top: top + 'px', position: 'relative', left: left + "px", float: 'right', marginRight: mr + 'px' }}><g transform="translate(0, 0)"><path d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm1,17c0,.553-.448,1-1,1s-1-.447-1-1v-6c0-.553,.448-1,1-1s1,.447,1,1v6Zm-1-9c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25,.56,1.25,1.25-.56,1.25-1.25,1.25Z" fill={color} /></g></svg>;
}

export function ShowInformation(type) {
  if (!type) {
    return;
  }

  var message = "";
  var buttonName = "I, Understood";
  switch (type.toLowerCase()) {
    case "kidstatus":
      type = "Empower Kids, Parents, Families ❤";
      message = `Your opportunity to showcase Pinnacle Scientiic Empowerment. Mark all the Conditions, All Behaviours relevant for the kid along with Mild, Moderate, Sever severities. Every goal review will have this Conditions, Behaviours review for you to showcase Pinnacle Scientific Empowerment.`;
      break;
    case "pending":
    case "dues":
      type = "Empower Kids, Parents, Families ❤";
      message = `Each pending attendance, compensation, homework, feedbacks, goals to be set, goals to be reviewed, every pending represents real kids, parents, families.

Complete pending work empower Kids, Parents, Families ❤.`;
      buttonName = "Understood, Will Complete.";
      break;
    case "achievements":
      type = "Hearty Congratulations ❤";
      message = `11 years of empowerment, 3+ million of successful therapies with 97%+ proven improvement, 1,400+ therapists, ~9,000 kids, parents, families everyday.`;
      buttonName = "Hearty Congratulations ❤";
      break;
    case "innovations":
      type = "~130 years old problem - Pinnacle Solution ❤";
      message = `160+ Patentable Technologies, Policies, Procedures, Systems, Integration, Ambience, Environment, Apps, Omni Channel Care, Free National Autism Helpline, Goal oriented therapies, Transparent therapies, Responsible, Accountable, Open, Honest, A lot more.

 Many more.. first of their kinds probably started and being imported only by Pinnacle to empower 90+ crore kids, parents, families ❤ to have self-sufficient, being part of mainstream, wonderful life plausible`;
    case "pinnacle wisdom":
      message = `The quality of having experience, knowledge, and good judgement, and experience the knowledge in multi folded direction.

Many more.. first of their kinds probably started and being imported only by Pinnacle to empower 90+ crore kids, parents, families ❤ to have self-sufficient, being part of mainstream, wonderful life plausible`;
      buttonName = "Let us Empower More";
      break;
    case "policies and procedures":
      type = "Pinnacle System";
      message = `3Million + Multi-Sensory, Multi-Disciplinary, Integrated Therapies across India from Delhi to Chennai, Delhi to Visakhapatnam.

Everything in Pinnacle across any Pinnacle in the country and world follows innovative policies, procedures check balanced through patentable technological systems deep rooted in Kids, Parents, Families Pinnacle Life Changing Therapeutic Empowerment ❤`;

      break;

    case "empowering":
      type = "Pinnacle Empowering 90+ Crore Kids, Parents, Families ❤";
      message = `Empower Kids, Parents, Families ❤

Empowering 90+ Crore Kids, Parents, Families to have Self-Sufficient, being part of Mainstream Society, Wonderful LIFE plausible, Bring smiles into their lives is the core purpose of Pinnacle existence.

Your role in the organization is to do your part - Contribute in this Devineful Opportunity, Noble Deed.`;

      break;
    case "proven improvement":
      type = "Pinnacle Proven Improvement ❤";
      message = `3+ Million Successful Multi-Sensory, Multi-Disciplinary, Integrated Autism therapy services with 97%+ Proven Improvement.

Directly hear it from parents across Delhi-Chennai, Delhi - Visakhapatnam, Probably Pinnacle is the only organization providing this wonderful therapeutic empowerment ❤`;
      break;
    case "renewals":
      type = "Pinnacle Life Renewal ❤";
      message = `Kids, Parents, Families on the name of god counting on Pinnacle to empower them to have Self-Sufficient, part of Mainstream Society, Wonderful Life Plausible.

Work with Parents, Families upfront by utilizing this wisdom in successfully completing Pinnacle Life Renewal ❤, Empower Kids, Parents, Families ❤`;
      break;
    case "invoices":
      type = "Fee Receipts";
      message = `This section maintains a comprehensive record of all your payments. If you need any assistance or have queries, don't hesitate to reach out to our support team. We're here to help. Thank you for your cooperation. - Pinnacle.`;
      break;
    case "service requests":
      type = "Pinnacle Service Requests ❤";
      message = `Being Open, Being Honest, Being Transparent, Being Self-Critical are the core values of Pinnacle Blooms Network.

Raise a Concern, Ask a Question, Seek Clarity, Suggest Betterment, Entire Pinnacle Staff & Leadership at your disposal in hearing you out and provide needed clarity, information, take necessary action .. Making Pinnacle as the most Responsible, Accountable organization across the world ❤`;
      break;
    case "compensations":
      type = "Pinnacle Leaves & Compensations ❤";
      message = `Pinnacle Life Changing Therapeutic Empowerment ❤ is the right of every kid, parent, family.

Ensure to provide all compensations duly before the month itself as Compensations refreshes upon beginning of the month.`;
      break;
    case "recent":
      type = "Latest Activities for You ";
      message = `Here are your latest activities within Pinnacle.`;
      break;
    case "leaves":
      type = "Leaves for You ";
      message = `Leaves applied so far and approved so far`;
      break;
    case "absent":
      type = "Absent & Compos";
      message = `Kids empowerment is taken hault through leaves and wants to epower those also through compos`;
      break;
    case "conditions":
      type = "Conditions";
      message = `Dear Parent, Pinnacle is proud to unveil our ‘Pinnacle 101’ courses. A global first, these empowering resources focus on conditions such as Autism and ADHD, illuminating their impact not just on your child, but also on you as parents and your family as a whole. Drawing from our extensive experience of over 6.3 million successful therapies, we aim to inspire, enlighten, and guide you all in this journey. Together, we're creating a world of understanding, enriching the lives of our children and their families. - Pinnacle.`;
      break;
    case "materials":
      type = "Materials";
      message = `Dear Parent, breaking new ground in the 126+ year history of autism therapy, Pinnacle is proud to introduce a unique collection of nearly 500 Speech Therapy, Occupational Therapy, ABA Therapy, Special Education, and Vision Therapy materials. Each item comes with practical usage guidance, to empower you at home. Drawing from the wisdom of over 6.3 million successful therapies, we're sharing this resource, a global first, to place the power of a 97%+ proven success rate in your hands. Together, we're empowering your child's future. - Pinnacle Therapy Team.`;
      break;
    case "behaviors":
      type = "Behaviors";
      message = `Dear Parent, we're pleased to introduce Pinnacle's Kids Behaviours Wisdom Bank. This groundbreaking resource is a first in the global arena, offering in-depth knowledge and understanding about children's tantrums. Our wisdom, drawn from over 6.3 million successful therapies, aims to provide practical strategies and insights to help you navigate these challenging moments. We believe in empowering parents and families with the information they need to support their child effectively. Together, we're creating a world of understanding and patience. - Pinnacle.`;
      break;
    case "assessments":
      type = "Assessments";
      message = `Dear Parent, we are excited to present Pinnacle's Assessment Bank. This first-of-its-kind global resource offers a comprehensive compilation of assessments used in understanding and addressing various conditions. Derived from our experience of over 6.3 million successful therapies, this bank aims to enlighten parents and families about the process and importance of these assessments. We believe in empowering families with knowledge, guiding you to better understand your child's unique journey. Together, we're shaping a brighter future. - Pinnacle.`;
      break;
    case "assessments":
      type = "Assessments";
      message = `Dear Parent, we are excited to present Pinnacle's Assessment Bank. This first-of-its-kind global resource offers a comprehensive compilation of assessments used in understanding and addressing various conditions. Derived from our experience of over 6.3 million successful therapies, this bank aims to enlighten parents and families about the process and importance of these assessments. We believe in empowering families with knowledge, guiding you to better understand your child's unique journey. Together, we're shaping a brighter future. - Pinnacle.`;
      break;
    case "servicerequestboss":
      type = "Service Request";
      message = `Dear Parent, at Pinnacle, we believe in the power of transparency, honesty, and open communication. We're committed to a partnership built on these pillars, and we embrace a self-critical approach to constantly improve our services. We understand that you may have queries, concerns, or suggestions - and we're here to listen. We encourage you to raise a service request about anything you feel needs our attention. Your feedback is invaluable in our continuous strive for excellence. Together, we're building a better future for our children. Thank you for being an integral part of this journey. - Pinnacle.`;
      break;
    case "provenimprovementboss":
      type = "Pinnacle Proven Improvement";
      message = `Dear Parent, our assessments at Pinnacle are more than mere evaluations. They serve as powerful instruments in tracking your child's progress and shaping their therapeutic journey. Each assessment is an opportunity for reflection, adjustment, and growth. These periodic goal reviews ensure that your child's therapy plan remains adaptive and responsive to their evolving needs. This process has been instrumental in achieving our 97%+ improvement rate. Together, we use these milestones to chart the course towards proven improvement. Your trust and partnership make this journey possible. - Pinnacle.`;
      break;
    case "policiesandproceduresforboss":
      type = "Pinnacle System";
      message = `Dear Parent, at the heart of Pinnacle's mission is a unique, patentable system that unifies the power of artificial intelligence, big data, and machine learning with the wisdom gleaned from over 6.3 million successful therapy services and 97%+ proven improvement. But our approach goes beyond these ground-breaking technologies.

                    We infuse our work with empathy, understanding that each child we serve is unique and deserves an individualized path to growth. Our core values of honesty, transparency, and self-critique guide us, ensuring that we continually evolve and adapt to serve your child better.

                    Our ultimate goal is to empower each child to be self-sufficient, to find their place in mainstream society, to lead fulfilling lives, and to bring smiles to their families. We believe that with the right support, every child can reach their potential and beyond.

                    At Pinnacle, we are not just shaping therapy; we are shaping futures. And we're grateful for your trust as we walk this transformative journey together. - Pinnacle.`;
      break;
    case "innovationsboss":
      type = "Innovations";
      message = `Dear Parent, in a journey that has spanned over a century, we at Pinnacle have dared to innovate and transform. Today, we stand as a beacon of hope, having achieved a 97%+ improvement rate in therapy outcomes for the first time ever. This is not just a breakthrough; it's a testament to the undying spirit of human resilience, the power of innovation, and the promise of a brighter future. We stand at the helm of this transformation, casting a new light on a challenge that has remained unmet for 126 years. Together, we have ascended to new heights, with Pinnacle living up to its name as a global beacon of hope. Your trust fuels this journey, and we are eternally grateful. - Pinnacle.`;
      break;
    case "absentsforboss":
      type = "Leaves/ Compensations";
      message = `Dear Parent, we understand that life can sometimes disrupt our best-laid plans. If you need to book leave for your child's therapy sessions, please let us know as soon as possible. You can also book compensatory sessions within the same month to ensure your child's progress isn't hindered. Together, we can work around life's unpredictability. Thank you for your cooperation. - Pinnacle.`;
      break;
    case "achievementsforboss":
      type = "Wins";
      message = `Dear Parent, every step in this journey, every task completed, every skill practiced, represents a win in your child's therapy journey. These wins may seem small but they contribute significantly to their overall growth. Let's celebrate each small victory as they come and continue to encourage your child. Remember, progress, self-sufficiency, mainstream, wonderful life, life is our goal. Your support makes all the difference. - Pinnacle.`;
      break;
    case "homeworkforboss":
      type = "Pending HopeWork";
      message = `Dear Parent, every stroke of your effort in helping your child with their therapy homework draws a line of progress in their journey. Each task, each moment you dedicate, knits the skills learned into the fabric of their everyday life. We understand amidst the whirlwind of life, it's a quiet commitment you make. But remember, each time you sit down with them for these assignments, you are not just teaching, but also giving them a hand to hold, and showing them they are not alone in their journey. It's more than homework, it's hope-work. Thank you for being their beacon. - With gratitude, Pinnacle Therapy Team.`;
      break;
    case "pendingsforboss":
      type = "Pendings";
      message = `Dear Parent, each pending task is a missed chance at growth for your child. Together, let's turn them into stepping stones towards progress. Your dedication lights their path. Let's kindle this hope together. Thank you for your unwavering support. - Pinnacle.`;
      break;


  }

  showLockedBox(message, type, buttonName, false, null, "/images/alert.png");
}

export function categorizeDate(dateInput) {

  if (!dateInput) return 'Pending';

  const date = new Date(dateInput);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const diffDays = Math.floor((date - today) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return "Overdue";
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Tomorrow";

  const dayOfWeek = today.getDay(); // Sunday=0, Monday=1, ...
  const daysTillSunday = 7 - dayOfWeek;

  if (diffDays <= daysTillSunday) return "ThisWeek";
  if (diffDays <= daysTillSunday + 7) return "NextWeek";

  return "Future";
}

export function DownloadFile(fileurl, filename, id) {
  ShowToastMessage("Downloading...");
  if ($("#" + id).hasClass("downloading")) {
    return;
  }
  $("#" + id).addClass("downloading");
  fetch("https://mirracle.pinnacleblooms.org/api/getblob", {

    // Adding method type
    method: "POST",
    crossorigin: true,
    mode: 'no-cors',
    // Adding body or contents to send
    body: JSON.stringify({
      image: fileurl
    })

    // Adding headers to the request

  })
    .then(resp => resp.blob())
    .then(blob => {
      console.log(blob);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      // the filename you want
      a.download = "proven-improvement-" + filename + ".mp4";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      $("#" + id).removeClass("downloading");
      ShowToastMessage("Successfully Downloaded...");
      // or you know, something with better UX...
    })
    .catch(function () { $("#" + id).removeClass("downloading"); });
  return;
  let tag = document.createElement('a');
  tag.href = fileurl;
  //link.setAttribute('download', "proven-improvement-" + (filename ? filename : "")+".mp4");
  tag.download = "proven-improvement-" + (filename ? filename : "") + ".mp4";
  document.body.appendChild(tag);
  tag.click();
  document.body.removeChild(tag);
}
export function downloadCSV(args, dataList, bios) {
  if (bios && bios.length > 0) {
    var mappedIds = dataList && dataList.length > 0 ? dataList.map(e => e.Seq) : [];
    dataList = mappedIds && mappedIds.length > 0 ? bios.filter(e => mappedIds.indexOf(e.Seq) > -1) : bios;
    dataList.forEach(function (v) { delete v.Seq });
  }
  //venu If you don't want to print any coloumn use below to remove it from excel
  //var dataToExcel = dataList && dataList.length > 0 && dataList[0] && (dataList[0].KidId || dataList[0].BossId || dataList[0].TherapistId) ? dataList.map(e=> (delete e["KidId"] && delete e["TherapistId"] && delete e["BossId"] )) : dataList;
  var data, filename, link;
  var csv = convertArrayOfObjectsToCSV({
    data: dataList
  });
  if (csv == null) return;

  filename = args.filename || 'export.csv';

  if (!csv.match(/^data:text\/csv/i)) {
    csv = 'data:text/csv;charset=utf-8,' + csv;
  }
  data = encodeURI(csv);

  link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', filename);
  link.click();
}


export function dateFromDateIncludeTime(date) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }


    try {
      if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.toLowerCase().indexOf("T") > -1) {
        date = date + "Z";
      }
    }
    catch {

    }
    var nDate = new Date(date);


    var re = /-?\d+/;
    var m = re.exec(date);
    //  console.log(m);
    // if (null == m || m.index == 0) {
    //     nDate.setHours(nDate.getHours() - 5);
    //     nDate.setMinutes(nDate.getMinutes() - 30);
    // }

    // var nDate = new Date(date);
    // // console.log(date);

    // var re = /-?\d+/;
    // var m = re.exec(date);
    // // console.log(m);
    // if ((null == m || m.index == 0) && date.indexOf("+05:30") == -1) {
    //     nDate.setHours(nDate.getHours() - 5);
    //     nDate.setMinutes(nDate.getMinutes() - 30);
    // }

    //if (date.endsWith("Z")) {
    //    nDate.setHours(nDate.getHours() - 5);
    //    nDate.setMinutes(nDate.getMinutes() - 30);
    //}

    var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear()) + " " + ((("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2)));
    return returnString;
  } catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}

export function dateFromDateIncludeOnlyTimeForPendings(date, onlytime = false) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }
    try {
      if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.toLowerCase().indexOf("T") > -1) {
        date = date + "Z";
      }
    }
    catch {

    }
    var nDate = new Date(date);
    // console.log(date);

    var re = /-?\d+/;
    var m = re.exec(date);
    // console.log(m);
    // if ((null == m || m.index == 0) && date.indexOf("+05:30") == -1) {
    //     nDate.setHours(nDate.getHours() - 5);
    //     nDate.setMinutes(nDate.getMinutes() - 30);
    // }

    //if (date.endsWith("Z")) {
    //    nDate.setHours(nDate.getHours() - 5);
    //    nDate.setMinutes(nDate.getMinutes() - 30);
    //}
    // console.log("dateFromDateIncludeOnlyTimeForPendings: " + date);
    // console.log("dateFromDateIncludeOnlyTimeForPendings New: " + nDate);
    //+ ":" + (("0" + (nDate.getSeconds())).slice(-2))
    if (onlytime) {
      return (("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2));
    }

    return (("0" + (nDate.getDate())).slice(-2)) + "/" + (("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2));

  } catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}

export function dateFromDateIncludeOnlyTime(date) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }

    var nDate = new Date(date);
    // console.log(date);

    var re = /-?\d+/;
    var m = re.exec(date);
    // console.log(m);
    if ((null == m || m.index == 0) && date.indexOf("+05:30") == -1) {
      nDate.setHours(nDate.getHours() - 5);
      nDate.setMinutes(nDate.getMinutes() - 30);
    }

    //if (date.endsWith("Z")) {
    //    nDate.setHours(nDate.getHours() - 5);
    //    nDate.setMinutes(nDate.getMinutes() - 30);
    //}

    var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear()) + " " + ((("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2)));

    var todayDate = new Date();
    if (nDate.getDate() == todayDate.getDate()) {
      returnString = ((("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2)) + ":" + (("0" + (nDate.getSeconds())).slice(-2)));
    }


    return returnString;
  } catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}


function dateFromDateTime(date) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }

    var nDate = new Date(date);


    var re = /-?\d+/;
    var m = re.exec(date);
    //  console.log(m);
    if (null == m || m.index == 0) {
      nDate.setHours(nDate.getHours() - 5);
      nDate.setMinutes(nDate.getMinutes() - 30);
    }

    //if (date.endsWith("Z")) {
    //    nDate.setHours(nDate.getHours() - 5);
    //    nDate.setMinutes(nDate.getMinutes() - 30);
    //}

    var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear());
    return returnString;
  } catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}

export function dateFromDateTimeForRoyalty(date) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }

    var nDate = new Date(date);


    var re = /-?\d+/;
    var m = re.exec(date);
    //  console.log(m);

    //if (date.endsWith("Z")) {
    //    nDate.setHours(nDate.getHours() - 5);
    //    nDate.setMinutes(nDate.getMinutes() - 30);
    //}

    var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear());
    return returnString;
  } catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}


function dateFromDateTimeWithTime(date) {
  try {
    //console.log("date=" + date);
    if (!date) {
      return;
    }

    var nDate = new Date(date);


    var re = /-?\d+/;
    var m = re.exec(date);
    //  console.log(m);
    if (null == m || m.index == 0) {
      nDate.setHours(nDate.getHours() - 5);
      nDate.setMinutes(nDate.getMinutes() - 30);
    }

    //if (date.endsWith("Z")) {
    //    nDate.setHours(nDate.getHours() - 5);
    //    nDate.setMinutes(nDate.getMinutes() - 30);
    //}

    var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear()) + " " + (("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2));
    return returnString;
  } catch (e) {

    //console.log("PLEASE FF" + e);
  }
  return "N/A";
}
export function Numbersafterthousand(x) {
  if (!x || x == "" || x == "NaN") {
    return 0;
  }
  try {
    var num = (x + "").split('.')[0];

    if (num.toString().length > 7) {
      x = (((num / 10000000)).toFixed(2)) + "Cr";
    }
    else if (num.toString().length > 5) {
      x = (((num / 100000)).toFixed(2)) + "L";
    }
    else if (num.toString().length > 3) {
      x = (((num / 1000)).toFixed(1)) + "K";
    }



  } catch (e) {

  }
  var data = x.toString().replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

  var value = data.split('.').length > 1 ? data : data.trim();
  return data.split('.').length > 1 ? data : data.trim();
}

export function formatName(name) {
  if (!name) return "...";
  return name.length > 20 ? name.slice(0, 20) + '...' : name;
}


function FormatAMPM(time) {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice(1);  // Remove full string match value
    time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(''); // return adjusted time or original string
}
function NumberWithCommas(x) {
  if (!x) {
    return x;
  }
  // x = parseFloat(x.toFixed(2));
  x = parseFloat(x);
  var data = x.toString().replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

  var value = data.split('.').length > 1 ? data : data.trim();
  return '₹' + value + '.00';
}
function getMonthNamefromDate(date) {
  var newDate = new Date(date);
  var month = newDate.toLocaleString('default', { month: 'long' });
  return month;
}

function getTimeStamp(data) {
  //var now = new Date();

  var dateStamp = new Date(data.getUTCFullYear(), data.getUTCMonth(), data.getUTCDate(), data.getUTCHours(), data.getUTCMinutes(), data.getUTCSeconds());

  //var dateStamResult = GetTimeStamp(dateStamp);
  //console.log(dateStamResult);
  // return dateStamResult;

  var hh = dateStamp.getHours();
  var min = dateStamp.getMinutes();
  var s = dateStamp.getSeconds();
  var ampm = (hh >= 12) ? 'PM' : 'AM';
  hh = hh % 12;

  var time = hh + ":" + min + " " + ampm;
  return time;
}

function getDueMessage(fDate) {
  var date = new Date();

  if (new Date(fDate) > date) {
    var diff = new Date(new Date(fDate) - date);
    var days = diff / 1000 / 60 / 60 / 24;
    return "Due in next " + Math.floor(days) + " days";
  }
  else {
    var diff = new Date(date - new Date(fDate));

    var days = diff / 1000 / 60 / 60 / 24;
    var text = Math.floor(days) == 0 ? "overdue started from today" : "overdue from last " + Math.floor(days) + " days";
    //activity.F16 = "red";
    return text;
  }
}


export function sundaysInMonth(m, y) {
  var days = new Date(y, m, 0).getDate();
  var start = 8 - (new Date(m + '/01/' + y).getDay());
  var sundays = [new Date(y, (m - 1), start)];

  for (var i = start + 7; i < days; i += 7) {
    sundays.push(new Date(y, m - 1, i));
  }
  return sundays;
}

export function getMonthLabelsAndValues() {
  const today = new Date();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const thisYear = today.getFullYear();
  const thisMonthIndex = today.getMonth();

  let lastMonthIndex = thisMonthIndex - 1;
  let lastMonthYear = thisYear;
  if (lastMonthIndex < 0) {
    lastMonthIndex = 11;
    lastMonthYear -= 1;
  }

  const thisMonthLabel = `${monthNames[thisMonthIndex]} - ${thisYear}`;
  const thisMonthValue = `${(thisMonthIndex).toString().padStart(2, '0')}-${thisYear}`;

  const lastMonthLabel = `${monthNames[lastMonthIndex]} - ${lastMonthYear}`;
  const lastMonthValue = `${(lastMonthIndex).toString().padStart(2, '0')}-${lastMonthYear}`;

  return [
    { label: thisMonthLabel, value: thisMonthValue },
    { label: lastMonthLabel, value: lastMonthValue }
  ];

}

export function formatLocalDateTime(date) {
  const pad = n => n.toString().padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // month is zero-indexed
  const day = pad(date.getDate());

  const hour = pad(date.getHours());
  const minute = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hour}:${minute}`;
}

export function SendTelegramMessageToAdminGroup(fid, message, buttons, imageURL, callback) {



  var token = getUserToken();

  var request = {
    "token": token,
    "fileName": imageURL,
    "parameters": buttons,
    "message": message,
    "fIds": fid

  };

  $.ajax({
    url: '/api/unsecuredapi/SendTelegramMessageWiFacilityId',
    data: JSON.stringify(request),
    cache: false,
    async: true,
    contentType: "application/json; charset=UTF-8",
    type: 'POST',
    timeout: 15 * 60 * 1000,
    success: function (result) {
      //showLockedBox("Image Updated successfully", "", "Ok", true);

      //window.URL = window.URL || window.webkitURL;
      //var url true window.URL.createObjectURL(result);
      callback(true);

    },
    error: function (xhr, ajaxOptions, thrownError) {
      //HideLoading();
      console.log(xhr);
      console.log(ajaxOptions);
      console.log(thrownError);
      // selfObj.setState({ IsSendingTheMessage: false });
      $('.submit-wrapper').removeClass('is-saving');
      callback(false);
      showLockedBox(thrownError, "Error", "Ok", true);
    }
  });




}

// export function GetAIPrompt(text, callback) {

//     var request = {
//         "prompt": text
//     };

//     $.ajax({
//         url: 'https://www.pinnacleblooms.org/api/aipinnacle/ai',
//         data: JSON.stringify(request),
//         cache: false,
//         mode:'no-cors',
//         async: true,
//         contentType: "application/json;",
//         type: 'POST',
//         timeout: 0,
//         success: function (result) {
//             console.log("GetAIPrompt");
//             console.log(result);
//             callback(result);

//         },
//         error: function (xhr, ajaxOptions, thrownError) {
//             $('.submit-wrapper').removeClass('is-saving');
//             callback(false);
//             showLockedBox(thrownError, "Error", "Ok", true);
//         }
//     });


// }

export async function GetAIPrompt(text) {

  try {
    //  var input = document.getElementById("userInput");
    //var message = document.createElement("p");
    // message.innerHTML = "<b>You:</b> " + text;
    // message.classList.add("you");
    //    document.getElementById("chatbox").appendChild(message);
    // document.getElementById("sendButton").classList.add("disabled");
    //  document.getElementById("stopButton").classList.add("active");
    let controller = null;
    // Create a new AbortController instance
    controller = new AbortController();
    const signal = controller.signal;

    // Send the user's message to the OpenAI API
    const response = await fetch("https://mirracle.pinnacleblooms.org/api/aipinnacle/ai", {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
        //'Authorization': 'Bearer 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'
      },
      body: JSON.stringify({
        "prompt": "this prompt is derivide by user, Answer should be embedded in html tags add beautified bullet points to the entire response with the best output\n" + text,

        //	'prompt':'You are AutismGPT of Pinnacle Blooms Network - #1 Autism Therapy Centres Network, Successfully provided 4Million+ 1:1 therapy services with 97%+ proven improvement rate, 96%+ measured parental satisfaction, You will provide anything and everything related to Autism, Sensorial Conditions, Kids Health, Children Health.. When asked otherwise, you would tell them you are AutismGPT of Pinnacle Blooms Network - #1 Autism Therapy Centres Network can provide anything and everything related to Autism, Sensorial Conditions, Having said all that answer this, Please provide me with information and insights on ['+input.value+'] related to autism',
        stream: true
      }),
      signal, // Pass the signal to the fetch request
    });


    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    console.log(decoder);
    var message = document.createElement("p");
    message.classList.add("gpt");
    message.innerHTML = "";
    document.getElementById("pinnacle-chatbox").innerHTML = "";
    document.getElementById("pinnacle-chatbox").appendChild(message);
    // input.value = "";

    //<b>AutismGPT:</b>
    var html = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      // Massage and parse the chunk of data
      const chunk = decoder.decode(value);
      html += chunk;
      message.innerHTML = "<div class='chat-gpt'>" + html + "</div>";
      console.log(chunk);
      const lines = chunk.split("\n\n");

    }
  }
  catch (e) {
    console.log("Error In GetAIPrompt");
    console.log(e)
  }

}


export async function PushTelegramMessage(payload) {
  var dataURL = 'https://telegram.kgvpl.com/api/sendtelegramwithbutton';
  try {
    let myrequest = new Request(dataURL);
    // console.log("Came to ProcessWhatsAppMessages Method ");
    // await LogForFuturePupose("ExpensesNotEnteredTodayV1", payload);

    const init = {
      body: JSON.stringify(payload),
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'content-type': 'application/json'
      },
    }

    const response = await fetch(dataURL, init);
    console.log("payload for telegram")
    var res = await response.text();
    console.log(res)

    if (null != res) {

    };
    return JSON.parse(res);
  } catch (err) {

    // logger.Log("PostAssessmentsDataToIQMServer", 4, err.message + "\n\n" + err.stack, err.message);
    console.log(err);
    console.log("Exception Came While sending PostDataToServer " + err);
  }

  return true;
}

const isIOSs = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function vibrate(pattern = 80) {
  if (!isIOSs() && "vibrate" in navigator) {
    const ok = navigator.vibrate(pattern); // 80ms or [60, 40, 60]
    if (!ok) console.debug("Vibration rejected/blocked by browser or settings.");
  } else {
    console.debug("Vibration not supported on this device/browser.");
  }
};


function fixUnclosedUnderscore(input) {
  if (!input) return input;

  let underscoreCount = 0;
  let result = "";

  for (let char of input) {
    if (char === "_") {
      underscoreCount++;
    }
  }

  // If count is odd, remove all underscores
  if (underscoreCount % 2 !== 0) {
    result = input.replace(/_/g, "");
  } else {
    result = input;
  }

  return result;
}


export async function SendCreativesTelegramGroup(messageObj) {
  // messageObj: { SendTo: string[], Title: string, Body: string, Clouser: string, MediaUrls: string[] }
  const chatIds = Array.isArray(messageObj.SendTo) ? messageObj.SendTo : [messageObj.SendTo];
  const urls = (messageObj.MediaUrls || []).filter(Boolean).slice(0, 10); // Telegram max 10
  if (!urls.length) return false;

  const botToken = getTelegramPersonal(); // same as your existing function
  const buildMessage = () => {
    const raw = `${messageObj.Title ? `*${messageObj.Title}*\n\n` : ""}${messageObj.Body || ""}${messageObj.Clouser ? `\n${messageObj.Clouser}` : ""
      }`;
    try {
      return typeof fixUnclosedUnderscore === "function" ? fixUnclosedUnderscore(raw) : raw;
    } catch {
      return raw;
    }
  };

  const message = buildMessage();
  const caption = message.length <= 1000 ? message : ""; // caption limit

  // Build media array (photos only). If you need videos, set type: "video" per URL.
  const media = urls.map((u, idx) => ({
    type: "photo",
    media: u,
    ...(idx === 0 && caption ? { caption, parse_mode: "Markdown" } : {}),
  }));

  try {
    for (const chatId of chatIds) {
      // sendMediaGroup
      const res = await fetch(`https://api.telegram.org/bot${botToken}/sendMediaGroup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, media }),
      });
      if (!res.ok) {
        // If album fails, you can optionally fall back to sending one-by-one
        return false;
      }
      const data = await res.json();

      // If message > 1000, send full text as a reply to the first item of the album
      if (message.length > 1000 && data?.result?.[0]?.message_id) {
        await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            chat_id: chatId,
            text: message,
            reply_to_message_id: data.result[0].message_id,
            parse_mode: "Markdown",
          }),
        });
      }
    }
    return true;
  } catch (err) {
    console.error("SendCreativesTelegramGroup error:", err);
    return false;
  }
}


export async function SendCreativesTelegram(messageObj) {

  var chatIds = messageObj.SendTo;
  var message = fixUnclosedUnderscore((messageObj.Title ? "*" + messageObj.Title + "*\n\n" : "") + messageObj.Body + "\n" + (messageObj.Clouser ? messageObj.Clouser : ""));
  var buttons = messageObj.Buttons;
  var mediaUrl = messageObj.Source;
  var umethod = messageObj.Method ? messageObj.Method : "Default";

  var botToken = getTelegramPersonal();
  var apiMethod = "";
  var mediaType = "";



  try {
    // Determine API method based on media type
    if (mediaUrl) {
      // Remove query parameters from the URL
      var cleanUrl = mediaUrl.split("?")[0];

      if (cleanUrl.endsWith(".mp4")) {
        apiMethod = "sendVideo";
        mediaType = "video";
      } else if (cleanUrl.endsWith(".mp3")) {
        apiMethod = "sendAudio";
        mediaType = "audio";
      } else if (cleanUrl.match(/\.(jpg|jpeg|png|gif)$/)) {
        apiMethod = "sendPhoto";
        mediaType = "photo";
      } else if (cleanUrl.match(/\.(pdf|doc|docx|xls|xlsx|txt)$/)) {
        apiMethod = "sendDocument";
        mediaType = "document";
      }
    }

    // Parse buttons from ["Button1{#}tick", "Button2{#}tick"]
    var inlineKeyboard = [];
    if (buttons && buttons.length > 0) {
      inlineKeyboard = buttons.map(btn => {
        var [text, callbackData, url] = btn.split("{#}");
        return [{ text: text.trim(), callback_data: text.trim() + "{#}false{#}" + callbackData.trim(), url: url }];
      });
    }

    // Send text message if no media
    if (message && !mediaUrl) {
      for (var i = 0; i < chatIds.length; ++i) {
        const textPayload = {
          chat_id: chatIds[i],
          text: message,
          reply_markup: JSON.stringify({ inline_keyboard: inlineKeyboard }),
          parse_mode: 'Markdown'
        };

        var textResponse = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(textPayload)
        });

        if (!textResponse.ok) {
          return false;
        }


      }
    }

    // Send media (image, video, document, or audio)
    if (mediaUrl) {
      for (var k = 0; k < chatIds.length; ++k) {
        var mediaPayload = {
          chat_id: chatIds[k],
          [mediaType]: mediaUrl, // Dynamically sets 'photo', 'video', 'document', or 'audio'
          caption: message.length <= 1000 ? message : "", // Include caption only if it's within the limit
          reply_markup: JSON.stringify({ inline_keyboard: inlineKeyboard }),
          parse_mode: 'Markdown'
        };

        var mediaResponse = await fetch(`https://api.telegram.org/bot${botToken}/${apiMethod}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(mediaPayload)
        });

        if (!mediaResponse.ok) {
          //throw new Error(`Telegram API Error (${mediaType}): ${mediaResponse.status} ${mediaResponse.statusText}`);
          return false;
        }

        var mediaData = await mediaResponse.json();

        // If message length > 1000, send it separately as a reply
        if (message.length > 1000) {
          var textPayload = {
            chat_id: chatIds[k],
            text: message, // Full message as text
            reply_to_message_id: mediaData.result?.message_id, // Reply to the media message
            parse_mode: 'Markdown'
          };

          var textResponse = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(textPayload)
          });

          if (!textResponse.ok) {
            return false;
          }
        }
      }
    }


    return true;

  } catch (error) {
    console.error("Error in SendCreativesTelegram:", error.message);// Ensure error response is returned
    return false;
  }
}


export async function SendGroupedMessages(parameters, message, cid, btnHide, url) {
  try {
    if (!message && !cid) {
      return false;
    }
    var objtoSend = {

      "parameters": parameters,
      "message": message,
      "pwd": "success9*",
      "cid": cid,
      "btnHide": btnHide,
      "url": url
    }
    const init = {
      body: JSON.stringify(objtoSend),
      mode: 'no-cors',
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
    }
    console.log(JSON.stringify(objtoSend));

    var result = await fetch('https://telegram.kgvpl.com/api/sendgroupedimages', init);
    return result;
  }
  catch (e) {
    console.log(e);
  }

}


export function GetHolidaysList(fid) {
  var holidaysList = getUserSettingsValue("HOLIDAYSLIST");
  var holidays = holidaysList ? JSON.parse(holidaysList) : [];
  const dates = [];
  for (var i = 0; i < holidays.length; i++) {


    dates.push(...getDatesInRange(dateFromSDateTime(holidays[i].OccasionFrom), dateFromSDateTime(holidays[i].OccasionTo)));
  }
  var StartDate = "2024-03-29T00:00:00Z";
  var EndDate = "2024-03-29T23:59:59Z";
  dates.push(...getDatesInRange(dateFromSDateTime(StartDate), dateFromSDateTime(EndDate)));
  // var bonaluStartDate = "2024-03-08T00:00:00Z";
  // var bonaluEndDate = "2024-03-08T23:59:59Z";
  //dates.push(...getDatesInRange(dateFromSDateTime(bonaluStartDate), dateFromSDateTime(bonaluEndDate)));
  return dates;
}


export function IsSunDayOrSecondOrFourthSaturday(date) {
  if (date.getDay() == 0 || date.getDay() != 6) {

    return date.getDay() == 0 ? true : false;
  }

  var yesSaturday = ((date.getDate() >= 8 && date.getDate() <= 14) || (date.getDate() >= 22 && date.getDate() <= 28));


  return yesSaturday;

}

function IsSunDayOrSaturday(date) {

  return date.getDay() == 0 || date.getDay() == 6 ? true : false;



}

function getMonthShortName(monthNo) {
  const date = new Date();
  date.setMonth(monthNo - 1);

  return date.toLocaleString('en-US', { month: 'short' });
}

export function GetShortDateandMonth(date) {
  var month = getMonthShortName(date.getMonth() + 1);
  var day = date.getDate();
  var dtString = (day <= 9 ? "0" + day : day) + "-" + month;
  return dtString;
}

export function GetTelegramTagString(user, altName = "") {
  if (!user || !user.Name) {
    return !altName ? "" : altName;
  }
  else if (!user.TelegramId) {
    return user.Name;
  }
  else {
    return "[" + user.Name + "]" + "(tg://user?id=" + user.TelegramId + ")";
  }

}

export function GetShortMonth(date) {
  var month = getMonthShortName(date.getMonth() + 1);
  return month;
}

export function GetDiffDays(startDate, endDate) {
  var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();
  return (Difference_In_Time / (1000 * 3600 * 24));
}



export function GetTotalWorkingDays(startDate, endDate) {
  //console.log('GetTotalWorkingDays');

  endDate = endDate > new Date ? new Date() : endDate;
  var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  var holidayList = GetHolidaysList();
  var dates = GetDatesInRange(startDate, endDate);
  var forDasra2023 = "2023-10-28 00:00:00";
  var dateForDasara = new Date(forDasra2023);
  dates.map(function (date) {
    var dt = holidayList.filter(function (e) { return e.toDateString() == date.toDateString() })[0];
    // console.log(dt);

    if (IsSunDayOrSecondOrFourthSaturday(date) || dt && (date.getMonth() != 10 && date.getFullYear() != 2023)) {
      //console.log(date + " - Is Excluded" );
      Difference_In_Days = Difference_In_Days - 1
    }
  });

  return Difference_In_Days;

}


export function GetLatestWorkingdaysinmonth(start, end) {


  start = new Date(start);
  end = new Date(end);
  var startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  var days = [];
  var holidaysList = GetHolidaysList();
  // console.log(holidaysList);
  while (startDate <= end) {
    // console.log(startDate);
    if (IsSunDayOrSecondOrFourthSaturday(startDate) || holidaysList.filter(function (e) { return e.toDateString() == startDate.toDateString() })[0]) {
      // No Holiday set date
    }
    else {
      days.push(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
    }

    startDate.setDate(startDate.getDate() + 1);
  }

  return days;
}

export function IsTodayHoliday() {
  var today = new Date();

  var holidayList = GetHolidaysList();
  var dt = holidayList.filter(function (e) { return e.toDateString() == today.toDateString() })[0];
  if (IsSunDayOrSecondOrFourthSaturday(today) || dt) {
    return true;
  }
  return false;
}

export function GetTotalWorkingDaysExcludingSaturdays(startDate, endDate) {
  //console.log('GetTotalWorkingDays');

  endDate = endDate > new Date ? new Date() : endDate;
  //var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();
  var Difference_In_Time = new Date(endDate).getTime() - new Date(startDate).getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  var holidayList = GetHolidaysList();
  var dates = GetDatesInRange(startDate, endDate);
  dates.map(function (date) {
    var dt = holidayList.filter(function (e) { return e.toDateString() == date.toDateString() })[0];
    // console.log(dt);
    if (IsSunDayOrSaturday(date) || dt) {
      //console.log(date + " - Is Excluded" );
      Difference_In_Days = Difference_In_Days - 1
    }
  });

  return Math.ceil(Difference_In_Days);

}


export function GetDatesInRange(startDate, endDate) {
  return getDatesInRange(startDate, endDate)
}


export function GetTimeSlotTotal(slot) {
  if (!slot) {
    return 0;
  }

  var values = slot.split(":");
  if (!values || values.length == 0) {
    return 0;
  }

  return (parseInt(values[0]) * 60) + (values.length > 1 && values[1] ? parseInt(values[1]) : 0)
}

export function GetCurretnSlot(slot) {
  var exact930 = 9 * 60 + 30;
  var exact11 = 11 * 60;
  var exact13 = 13 * 60;
  var exact16 = 16 * 60;
  var exact18 = 18 * 60;
  var exact19 = 19 * 60;

  var timeslot = GetTimeSlotTotal(slot);
  if (timeslot < exact930) {
    return "Before 9:30 AM";
  }
  else if (timeslot >= exact930 && timeslot <= exact11) {
    return "9:30 AM - 11:00 AM";
  }
  else if (timeslot > exact11 && timeslot <= exact13) {
    return "11:00 AM - 01:00 PM";
  }
  else if (timeslot > exact13 && timeslot <= exact16) {
    return "01:00 PM - 04:00 PM";
  }
  else if (timeslot > exact16 && timeslot <= exact18) {
    return "04:00 PM - 06:00 AM";
  }
  else if (timeslot > exact18 && timeslot <= exact19) {
    return "06:00 PM - 07:00 PM";
  }
  else if (timeslot > exact19) {
    return "After 7:00 PM";
  }
}


export function GetPendingMinutes(date) {

  var dateToCheck = dateFromSDateTime(date);

  var diff = Math.abs(new Date() - dateToCheck);
  var minutes1 = Math.floor((diff / 1000) / 60);


  let days = diff / (24 * 60 * 60 * 1000);
  let hours = (days % 1) * 24;
  let minutes = (hours % 1) * 60;

  [days, hours, minutes] = [Math.floor(days), Math.floor(hours), Math.floor(minutes)]

  var stringToSend = days > 0 ? days + ' day ' : "";
  stringToSend += hours > 0 ? hours + ' hrs ' : "";
  stringToSend += minutes + ' min'
  return stringToSend;
}

function getDayWithSuffix(day) {
  if (day > 3 && day < 21) return day + 'th';
  switch (day % 10) {
    case 1: return day + 'st';
    case 2: return day + 'nd';
    case 3: return day + 'rd';
    default: return day + 'th';
  }
}

export function formatPrettyDate(date, LangLabels) {
  date = new Date(date);
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const day = String(date.getDate()).padStart(2, '0');
  const suffix = getDayWithSuffix(Number(day));
  return `${day}${suffix.slice(2)} ${getLabel(months[date.getMonth()], LangLabels)} ${date.getFullYear()}`;
}

export function GetShortDesignation(type) {
  if (!type) {
    return type;
  }

  switch (type.toLowerCase().trim()) {
    case "behavioural therapist":
    case "4":
      return "ABA";
      break;
    case "occupational therapist":
    case "3":
      return "OT";
      break;
    case "special educator":
    case "6":
      return "SE";
      break;
    case "speech therapist":
    case "1":
      return "ST";
      break;
    case "receptionist":
      return "Admin";
      break;
    case "admin manager":
      return "Admin";
      break;
    case "care taker":
      return "CT";
      break;
    case "tech":
      return "Tech";
      break;
    case "seo":
      return "SEO";
      break;
    case "soc":
    case "security manager":
    case "security officer":
      return "SOC";
      break;
    case "finance officer":
      return "Finance";
      break;
    case "audit":
      return "Audit";
      break;
    case "harvest officer":
      return "HR";
      break;
    case "pdt":
      return "PDT";
      break;
    case "kid development officer":
      return "BDC";
      break;
    case "zonal manager":
      return "ZM";
      break;
  }

  return type;
}

export function GetServiceType(type) {
  if (!type) {
    return type;
  }

  switch (type.toLowerCase()) {
    case "behavioural therapist":
      return "Behavioral Modification";
      break;
    case "occupational therapist":
      return "Occupational Therapy";
      break;
    case "special educator":
      return "Special Education";
      break;
    case "speech therapist":
      return "Speech Therapy";
      break;
  }

  return type;
}
export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export function GetDesignationByServiceType(type) {
  if (!type) {
    return type;
  }

  switch (type.toLowerCase()) {
    case "behavioural modification":
    case "behavioral modification":
      return "behavioural therapist";
      break;
    case "occupational therapy":
      return "occupational therapist";
      break;
    case "special education":
      return "special educator";
      break;
    case "speech therapy":
      return "speech therapist";
      break;
  }

  return type;
}

export function GetGraceCompoCount(dataSource, startDate, endDate, kids) {
  var date = new Date();
  date.setDate(date.getDate() - 1);
  endDate = endDate > new Date() ? new Date() : endDate;
  kids = kids || [];

  //var typeId = dataSource.Types.filter(f => f.Name == "ATTENDANCE" && a.Category == "ActionType")[0].Id;
  var gracetypeId = dataSource.Types.filter(f => f.Name == "Grace Compensation Request" && f.Category == "Service Request")[0].Id;
  //var servicerequestAnalytics = Object.entries(groupBy((dataSource.ServiceRequestsAnalytics || []), "SRId")).map(m => m[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);

  var analytics = groupBy((dataSource.ServiceRequestsAnalytics || []), "SRId");
  var srData = Object.entries(analytics).reduce((acc, [key, values]) => {
    const reducedValue = values.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))
    acc[key] = reducedValue;

    return acc;
  }, {});

  //var srData = groupBy((servicerequestAnalytics || []), "SRId");
  var requests = (dataSource.ServiceRequests || []).filter(f => f.TypeId == gracetypeId && srData[f.Id] && srData[f.Id][0].Status && srData[f.Id][0].Status == "CLOSED" && srData[f.Id][0].CBPI && srData[f.Id][0].CBPI == f.CBPI && f.F1 && kids.indexOf(parseInt(f.F1)) > -1 && (dateFromSDateTime(f.FDT) >= startDate) && (dateFromSDateTime(f.FDT) <= endDate) && srData[f.Id][0].Amount && srData[f.Id][0].Amount > 0);
  requests = requests || [];
  /* var requests = $.grep(dataSource, function (e) { return e.AT == "SERVICEREQUESTANALYTIC" && e.F1 == "Grace Compensation Request" && kids.indexOf(e.OGID) > -1 && (dateFromSDateTime(e.FDT) >= startDate) && (dateFromSDateTime(e.FDT) <= endDate) && e.TOId == e.CBPI && e.F7 > 0 });*/

  var services = [];
  if (requests && requests.length > 0) {

    for (var i = 0; i < requests.length; i++) {

      var leave = requests[i];
      for (var j = 0; j < leave.Amount; j++) {
        var service = { "Id": leave.Id + "-grace-" + (j + 1), Grace: "Grace", CDT: leave.CDT, "FDT": leave.FDT, "ForDate": leave.FDT, "TDT": leave.FDT, "ServiceId": leave.F1, "TOId": leave.TOId, "Status": "Absent", "F3": leave.F4, "UId": leave.Id };
        services.push(service);
      }
    }
  }
  return services;
}

export function GetLeavesCompoCount(dataSource, startDate, endDate, user, servicesData) {
  var date = new Date();
  date.setDate(date.getDate() - 1);
  endDate = endDate > new Date() ? new Date() : endDate;
  var newservicesData = servicesData.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
  var therapistIds = newservicesData ? newservicesData.map(function (m) { return m.TherapistId }) : [];
  var leavesData = dataSource.Leaves;
  if (!leavesData) {
    var leaveId = GetTypeIdByName(dataSource.Types, "LEAVEREQUEST");
    leavesData = dataSource.PeopleNotes ? dataSource.PeopleNotes.filter(f => f.TypeId == leaveId) : [];
  }
  var leaveRequests = leavesData.filter(function (e) {
    return e.RS != "DELETEACTIVITY" && new Date(e.TDT) >= startDate && new Date(e.TDT) <= endDate && (null == user ? true : (e.TOId == user.Id || (therapistIds && therapistIds.length > 0 ? therapistIds.indexOf(e.TOId) > -1 : false)))


  });



  //&& e.F10 == "Parent" e.S == "Approved"
  if (!leaveRequests || leaveRequests.length == 0) {
    return [];
  }
  var leaves = [];
  var services = [];
  for (var i = 0; i < leaveRequests.length; i++) {
    var leave = leaveRequests[i]
    var already = leaves.filter(function (r) { return r.TDT == leave.TDT && leave.F10 == r.F10 })[0];
    if (!already) {

      if (leave.F1 == "Therapist" || leave.F1 == "AdminForTherapist") {

        var servicesData1 = newservicesData.filter(function (r) { return (null == user ? true : r.BossId == user.Id) && r.TherapistId == leave.TOId && new Date(r.StartDate) <= new Date(leave.FDT) && leave.F6 ? (leave.F11 + "").split(",").indexOf(r.Id + "") > -1 : true });
        if (servicesData1) {
          servicesData1.forEach(function (e) {
            var alreadyCompo = services.filter(function (f) { return f.ServiceId == e.Id && e.TDT == leave.TDT })[0];
            if (!alreadyCompo) {
              var service = { Id: leave.Id + "-therapistservice-" + e.Id, "AT": "ATTENDANCE", "CDT": leave.CDT, "FDT": leave.TDT, "TDT": leave.TDT, "F5": e.RDT, "TOId": e.TOId, "Status": "Absent", "F3": e.F2, "ServiceId": e.Id };
              services.push(service);
            }
          });
        }
      }
      else {

        var servicesData1 = newservicesData.filter(function (r) { return (null == user ? true : r.BossId == user.Id) && r.BossId == leave.TOId && new Date(r.StartDate) <= new Date(leave.FDT) });

        servicesData1.forEach(function (e) {
          var alreadyCompo = services.filter(function (f) { return f.ServiceId == e.Id && e.TDT == leave.TDT })[0];
          if (!alreadyCompo) {
            var service = { Id: leave.Id + "-parentservice-" + e.Id, "ForDate": leave.TDT, "AT": "ATTENDANCE", "CDT": leave.CDT, "FDT": leave.TDT, "TDT": leave.TDT, "F5": e.Title, "TOId": leave.TOId, "Status": "Absent", "F3": e.F2, "ServiceId": e.Id };
            services.push(service);
          }
        });
      }
      leaves.push(leave);
    }
  }

  return services;

}


export function getSlotsByDataByTherapist(therapies, compos, leaves, types, user, date) {

  var isSaturDay = false;
  try {
    var date = new Date(date);
    var data = []; //CF ERROR FIXING NEED TO FIND DATA
    isSaturDay = date.getDay() === 6;
    if (isSaturDay && data && data.length > 0) {

      data = data.filter(function (e) { return e.AT != "USERSERVICE" });
    }

  } catch (e) {

  }


  var tleave = leaves.map(m => m.TOId == user.Id);
  if (tleave && tleave.length > 0) {
    showLockedBox("Sorry, The therapist is leave on " + date, "Info", "Okay");
    return;
  }
  try {
    var parentLeaves = leaves.map(function (e) { return e.TOId });


    therapies = therapies.filter(function (e) { return !(parentLeaves.indexOf(e.BossId) > -1) && e.RS != "DELETEACTIVITY" });
  } catch (e) {

  }

  therapies = therapies || [];

  if (compos && compos.length > 0) {
    var obj = {};
    for (var i = 0; i < compos.length; i++) {
      try {
        obj.TherapistId = compos[i].CBPI;
        obj.Time = compos[i].Status;
        obj.TypeId = parseInt(compos[i].TypeId);
        obj.BossId = parseInt(compos[i].HomeWork);
        therapies.push(obj);
      } catch (e) {

      }

    }

  }
  var serviceType = GetServiceType(user.Designation.trim());
  var summary = [];
  var serviceId = types.filter(f => f.Name && f.Name == serviceType)[0].Id;

  if (!therapies || therapies.length == 0) {


    var cloud =
    {
      TherapistId: user.Id,
      Name: user.Name,
      TypeId: serviceId,
      CenterId: user.CenterId
    }

    var cservices = CalcSlotsMC("8:45", "19:01", cloud);
    if (cservices && cservices.length > 0) {
      summary.push(...cservices);
    }



  }
  else {
    if (therapies && therapies.length > 0) {
      var sortedServices = therapies.sort(function (a, b) {
        return GetTimeSlotTotal(a.Time) - GetTimeSlotTotal(b.Time);
      });
      console.log(sortedServices);

      var first = sortedServices[0];
      var last = sortedServices[sortedServices.length - 1];
      if (GetTimeSlotTotal(first.Time) > 570) {
        var cservices = CalcSlotsMC("8:45", first.Time, first);
        if (cservices && cservices.length > 0) {
          summary.push(...cservices);
        }
      }
      for (var i = 0; i <= sortedServices.length - 1; i++) {
        // tServices[i].RS = Utility.GetMeridiem(time1);
        sortedServices[i].S = "Fill";
        sortedServices[i].F7 = GetTimeSlotTotal(sortedServices[i].Time);
        summary.push(sortedServices[i]);
        if (sortedServices.length - 1 != i) {
          var cservices = CalcSlotsMC(sortedServices[i].Time, sortedServices[i + 1].Time, first);
          if (cservices && cservices.length > 0) {
            summary.push(...cservices);
          }
        }
      }

      if (GetTimeSlotTotal(last.Time) + 45 < 1140) {
        var cservices = CalcSlotsMC(last.Time, "19:01", first);
        if (cservices && cservices.length > 0) {
          summary.push(...cservices);
        }
      }




    }
  }
  try {
    if (isSaturDay && summary && summary.length > 0) {
      var alreadybooked = summary.filter(function (e) { return e.S != 'Fill' && GetTimeSlotTotal(e.Time) >= 660 && GetTimeSlotTotal(e.Time) < 750 });
      if (alreadybooked && alreadybooked.length > 0) {
        for (var i = 0; i < alreadybooked.length; i++) {
          alreadybooked[i].S = 'Fill';
        }
      }
    }
  } catch (e) {

  }


  try {

  } catch (e) {

  }
  return summary;
}

export function getDatesInRange(startDate, endDate) {
  const date = new Date(startDate.getTime());

  const dates = [];

  while (date <= endDate) {
    dates.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }

  return dates;
}

function getTimeDay(date) {
  var param1 = new Date();
  var start_actual_time = new Date(date);
  // alert(start_actual_time + ' ' + end_actual_time);
  var diff = param1 - start_actual_time;
  var diffSeconds = diff / 1000;

  var hh = start_actual_time.getHours();
  var min = start_actual_time.getMinutes();
  var s = start_actual_time.getSeconds();

  var ampm = (hh >= 12) ? 'PM' : 'AM';
  hh = hh % 12;

  var time = hh + ":" + min + " " + ampm;


  // alert(HH);
  if (start_actual_time.getDate() == param1.getDate()) {
    return "Today " + time;
  }
  else if (start_actual_time.getDate() == (param1.getDate() - 1)) {
    return "Yesterday " + time;
  }
  else {
    // return HH + " Hours ago";
    var monthstring = parseInt(start_actual_time.getMonth() + 1);
    if (monthstring <= 9) {
      monthstring = "0" + monthstring;
    }

    return start_actual_time.getDate() + "/" + monthstring + "/" + start_actual_time.getFullYear() + " " + time;
  }
}

function getTimeSpan(date) {
  var param1 = new Date();
  var start_actual_time1 = new Date(date);

  var start_actual_time = Date.parse(start_actual_time1);//start_actual_time1.setMinutes(start_actual_time1.getMinutes() - 330);

  var epochTime = Date.parse(param1);
  var diff = epochTime - start_actual_time;

  var diffSeconds = diff / 1000;
  var HH = parseInt(Math.floor(diffSeconds / 3600));
  var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);

  if (HH < 1) {
    if (MM <= 1) {
      return "Few Seconds ago";
    }
    else {
      return MM + " Minutes ago";
    }
  }
  else if (HH < 23) {
    return HH + " Hours ago";
  }
  else if (HH > 23 && HH < 36) {
    return "Yesterday";
  }
  else if (HH > 36 && HH < 150) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[start_actual_time1.getDay()];
  }
  else {
    return start_actual_time1.getDate() + "-" + (start_actual_time1.getMonth() + 1) + "-" + start_actual_time1.getFullYear();
  }
}

function getTime(date) {
  var param1 = new Date();
  var start_actual_time = new Date(date);
  var min = start_actual_time.getMinutes();
  if (min <= 9) {
    min = "0" + min
  }
  return start_actual_time.getHours() + " : " + min;
}


var invoicePrices = [18000, 15000, 16333, 14500, 14000, 10417, 12000, 10000, 8333, 9999, 8334, 9416, 9417, 9360, 9333, 10416, 10418, 9167, 9166, 8335, 21960, 19926, 19927, 17690, 14640];
var servicesOfeering = [
  { Name: "behavioral modification", Id: 4, ShortName: "BT" },
  { Name: "occupational therapy", Id: 3, ShortName: "OT" },
  { Name: "special education", Id: 6, ShortName: "SE" },
  { Name: "speech therapy", Id: 1, ShortName: "ST" }
];
export function GetTypeIdByName(types, name) {
  try {
    if (!types || !name) {
      return 0;
    }

    let returnData = types.find(f => f.Name == name);
    if (returnData) {
      return returnData.Id;
    }
    return 0;
  } catch (e) {

  }
}

export function GetTypeNameById(types, Id) {
  try {
    let returnData = types.find(f => f.Id == Id);
    if (returnData) {
      return returnData.Name;
    }
    return 0;
  } catch (e) {

  }
}

export function GetTypeByName(types, name) {
  try {
    if (!types || !name) {
      return null;
    }

    let returnData = types.find(f => f.Name == name);
    if (returnData) {
      return returnData;
    }
    return null;
  } catch (e) {

  }
}

export function GetTypeById(types, Id) {
  try {
    if (!types || !Id) {
      return null;
    }
    let returnData = types.find(f => f.Id == parseInt(Id));
    if (returnData) {
      return returnData;
    }
    return null;
  } catch (e) {

  }
}

export function GetBossById(data, Id) {
  try {
    if (!data || !Id) {
      return null;
    }
    let returnData = data.find(f => f.Id == parseInt(Id));
    if (returnData) {
      return returnData;
    }
    return null;
  } catch (e) {

  }
}

function CalcSlotsMC(start, end, service) {
  try {

    var tsStart = GetTimeSlotTotal(start);
    var tsEnd = GetTimeSlotTotal(end);

    var availableSlots = [];
    //  console.log(tsStart);
    //  console.log(tsEnd);
    var time = 45;

    while (tsStart < tsEnd) {
      tsStart = tsStart + time;
      if (tsStart + time <= tsEnd) {
        var timeString = (tsStart % 60) + "";
        timeString = timeString.length == 0 ? "00" : timeString.length == 1 ? "0" + timeString : timeString;
        availableSlots.push(
          {
            TherapistId: service.TherapistId,
            TypeId: service.TypeId,
            Time: Math.floor(tsStart / 60) + ":" + timeString,

            S: "available",
            F7: tsStart
          });
      }


    }
    return availableSlots;
  }
  catch (Exception) {

    console.log(Exception);
  }
}

export function getSlotsByData(therapies, therapistsData) {
  console.log('getSlotsByData', new Date())
  var summary = [];
  var tids = therapistsData.map(m => m.Id);
  therapies = (therapies || []).filter(f => tids.indexOf(f.TherapistId) > -1);
  therapies = therapies || [];

  var therapists = Object.entries(groupBy(therapies, "TherapistId"));
  var alreadyTaking = therapists.map(m => parseInt(m[0]));
  var nottaking = therapistsData.filter(f => alreadyTaking.indexOf(f.Id) == -1);
  if (nottaking && nottaking.length > 0) {
    nottaking.forEach(function (e) {
      /* var fId = (data.Facilities.filter(function (m) { return (null != e.MG && e.MG.indexOf(parseInt(m._key)) > -1) || (null != e.AG && e.AG.indexOf(parseInt(m._key)) > -1) })[0]);*/
      var fId = 0;
      var cloud =
      {
        F3: e.RDT,
        TypeId: GetServiceType(e.Designation ? e.Designation : ""),
        FId: 0,
        TherapistId: e.Id,
      }

      var cservices = CalcSlotsMC("8:45", "19:00", cloud);
      if (cservices && cservices.length > 0) {
        summary.push(...cservices);
      }

    });


  }

  if (therapists && therapists.length > 0) {

    therapists.forEach(function (e) {
      var services = e[1];
      if (services && services.length > 0) {
        var sortedServices = services.sort(function (a, b) {
          return GetTimeSlotTotal(a.Time) - GetTimeSlotTotal(b.Time);
        });

        var first = sortedServices[0];
        var last = sortedServices[sortedServices.length - 1];

        if (GetTimeSlotTotal(first.Time) > 570) {


          var cservices = CalcSlotsMC("8:45", first.Time, first);
          if (cservices && cservices.length > 0) {
            summary.push(...cservices);
          }

        }


        for (var i = 0; i <= sortedServices.length - 1; i++) {


          // tServices[i].RS = Utility.GetMeridiem(time1);
          // summary.Add(tServices[i]);

          if (sortedServices.length - 1 != i) {
            var cservices = CalcSlotsMC(sortedServices[i].Time, sortedServices[i + 1].Time, first);
            if (cservices && cservices.length > 0) {
              summary.push(...cservices);
            }
          }
        }

        if (GetTimeSlotTotal(last.Time) + 45 < 1140) {
          var cservices = CalcSlotsMC(last.Time, "19:00", first);
          if (cservices && cservices.length > 0) {
            summary.push(...cservices);
          }
        }




      }

    });


  }

  console.log('getSlotsByData END', new Date())

  console.log('SUMMARY ', summary);
  return summary;
}

export function SaveCleintWaufli(exception, type, module) {
  try {

    var lsd = localStorage.getItem("LastPSSyncDataTime");
    var configJsonString = localStorage.getItem("UserSettings");
    var UserData = localStorage.getItem("UserData");
    UserData = UserData ? JSON.parse(UserData) : null;

    var settingsSWV = "";
    if (configJsonString) {
      try {
        var settingsSW = JSON.parse(configJsonString).filter(function (e) { return e.Name == "SWVERSION" });
        if (settingsSW && settingsSW.length > 0) {
          settingsSWV = settingsSW[0].Value;
        }
      } catch (e) {

      }
    }

    var exObj = {};
    var v = (UserData ? UserData.Handle + "," : "") + " Version: " + window.swVersion + " USERSETTINGS: " + settingsSWV + " lsd: " + lsd + "\n\n *Browser Details:*" + GetBrowser();

    exObj.Message = (exception.Message ? exception.Message : exception.message) + ("\n\n" + module ? module : "") + "\n\n" + v + "\n\n" + (exception.stack ? exception.stack : "");
    exObj.Type = type;


    var clientWaufliURL = "https://psapi.pinnacleblooms.org/api/gl/clientlogexception";

    $.ajax({
      url: clientWaufliURL,
      type: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: JSON.stringify(exObj),
      success: function (data, textStatus, jqXHR) {
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
      }
    });
  } catch (err) {
    console.log("Error in SaveExceptionToSentry :: " + err);
  }
}

export function openChat() {
  window.tidioChatApi.open();

}

export function openUrl() {
  try {
    window.open("https://api.whatsapp.com/send?phone=919100181181&text=" + encodeURIComponent("I need support with therapy for my kid/") + "%0a%0a", '_top')
    //OpenTheUrlinWeb("https://api.whatsapp.com/send?phone=919100181181&text=" + encodeURIComponent("I need support with therapy for my kid/") + "%0a%0a")
  } catch (err) {
    console.log("Error in openUrl : " + err);
  }
}


export function OpenSR() {
  try {
    //this.setState({MenuEnabled:false});
    const elements = document.getElementsByClassName('menu-sr working-inprogress-overlay-withanimations');

    // Check if the element exists and remove the 'active' class
    if (elements.length > 0) {
      const overlay = elements[0]; // Assuming the first element is the target
      overlay.classList.remove('active');
      console.log('Active class removed from menu-sr.');
    } else {
      console.log('No element found with the specified class.');
    }
    window.historyInstance.push("/servicerequest");
  } catch (err) {
    console.log("Error in openUrl : " + err);
  }
}

export function getTherapeuticAiAssessmentOnlyButton(userData, currentUser) {

  var item = GetAbilityPrice(userData);
  if (!item) {
    return <></>
  }
  return <div className="price-container" style={{ padding: "0px", flexDirection: "column" }}>

    <span className="price" style={{ fontFamily: "poppins", fontSize: "13px", fontWeight: "500" }}>₹{item.F7}</span>
    <button className="lang-btn" onClick={() => window.historyInstance.push("/createeip?kid=" + currentUser.Id + "&service=&type=eip&id=")}>{"Continue"}</button>
  </div>
}

export function getTherapeuticAiAssessmentButton(userData, currentUser, fixedWidth = null) {

  var item = GetAbilityPrice(userData);
  if (!item) {
    return <></>
  }

  return <div className="price-container" style={{ padding: "0px", width: fixedWidth ? fixedWidth + "px" : "100%", margin: "0px auto" }}>
    <div className="price-section" onClick={() => LoadGuestHandler("https://www.pinnacleblooms.org/abilityscore-global-study?", false, item.Name)}>
      <div className="price-row">
        <span className="price">{item.F7}</span>
        <span className="fee-text">+ Fee</span>
      </div>
      <button className="details-btn">
        <span>View Details</span>
        <svg viewBox="0 0 16 16" fill="currentColor" className="arrow-icon">
          <path d="m8 8.781 3.3-3.3.943.943L8 10.667 3.758 6.424l.943-.943z" />
        </svg>
      </button>
    </div>
    <button className="lang-btn" onClick={() => window.historyInstance.push("/createeip?kid=" + currentUser.Id + "&service=&type=eip&id=")}>{"Continue"}</button>
  </div>
}

export var overlayMoreDotsOverlayHTML = <div className="overlay-container payment-section" style={{ width: '94%', left: '3%', top: '0px', height: 'auto', maxHeight: '96vh', margin: '0px', borderRadius: '0px', background: 'transparent', marginTop: '2vh', alignItems: 'center', top: "calc( 50% - 351px )", borderRadius: "30px" }}>
  {/* <span className="mirracles-filter-close" onClick={this.DisableMenuClick.bind(this)}>
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path fill="#444444" d="M9.3,22.7C9.5,22.9,9.7,23,10,23s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L17.4,16l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L16,14.6l-5.3-5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4 l5.3,5.3l-5.3,5.3C8.9,21.7,8.9,22.3,9.3,22.7z"></path></g></svg>
        </span> */}


  <div style={{ padding: '0px 20px' }}>
    <div className="pendings-topbanner" style={{ marginBottom: '0px', float: 'left' }}><span className="title" style={{ bottom: '-1px', left: '-10px' }}>NCC Care</span><img src="https://www.pinnacleblooms.org/images/discord/ncccare-tiny.png" style={{ width: 'calc(100% + 34px)', maxWidth: '200%', marginLeft: '-18px', /* marginTop: '-6px', */float: 'left' }} /></div>
  </div>

  <ul className='ul-for-search-category ar-more  ncccare' style={{ width: "100%", background: "#fff", float: "left" }}>



    <li data-name="pollination" onClick={openChat.bind(this)}>
      <Link to={""}>

        <span className={'ar-search ar-number '}>
          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M40.8,34.6A16.032,16.032,0,0,0,46,23c0-9.9-9.8-18-22-18S2,13.1,2,23s9.8,18,22,18a31.836,31.836,0,0,0,6.2-.7L42,45Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M31.562,17.443A4.9,4.9,0,0,0,24,18.2a4.916,4.916,0,1,0-7.562,6.206L24,32l7.563-7.59A4.939,4.939,0,0,0,31.562,17.443Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /></g></svg>
        </span>
        <div className='ar-content'>
          <span className={'tit-se-cat '}>Chat With US</span>
          <span className="tit-se-subcat ">
            24x7, 365 days, 18+ Regional, National, International languages.
          </span>
        </div>
      </Link>
    </li>


    <li data-name="pollination" onClick={openUrl.bind(this)}>
      <Link to={""}>

        <span className={'ar-search ar-number noborder'}>
          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48"><g transform="translate(0, 0)"><path fill="#3AC34C" d="M0.10739,48l3.37542-12.32542c-2.08204-3.60688-3.17763-7.69894-3.17592-11.89098 C0.31215,10.66928,10.98554,0,24.09976,0c6.36475,0.00253,12.33865,2.47971,16.83067,6.97547 c4.49214,4.49575,6.96465,10.47174,6.96218,16.82712c-0.00531,13.11432-10.67966,23.785-23.79253,23.785h-0.00006h-0.00974 c-3.98213-0.00164-7.89481-1.00024-11.36995-2.89505L0.10739,48z" /> <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M18.15336,13.84087 c-0.48253-1.1589-0.97266-1.0021-1.33759-1.02027c-0.34636-0.01724-0.74309-0.02088-1.13941-0.02088 s-1.04036,0.14873-1.5853,0.74366c-0.54492,0.59496-2.08067,2.03281-2.08067,4.958c0,2.92519,2.13022,5.7512,2.42748,6.14787 c0.29723,0.39667,4.19204,6.39961,10.15569,8.97392c1.41836,0.6123,2.52578,0.9779,3.38909,1.25194 c1.42423,0.45222,2.72022,0.38844,3.74456,0.23544c1.14216-0.17059,3.51729-1.43777,4.01272-2.82601 c0.49537-1.38824,0.49537-2.57817,0.34674-2.82608c-0.14856-0.24784-0.54491-0.3966-1.13937-0.69412 c-0.59452-0.29745-3.51734-1.73529-4.06233-1.93359c-0.54491-0.19831-0.9412-0.29746-1.33755,0.29751 c-0.39628,0.59491-1.5356,1.9336-1.88241,2.3302c-0.34674,0.39667-0.69355,0.44627-1.28801,0.14876 c-0.59453-0.29745-2.51008-0.92506-4.7808-2.94978c-1.76725-1.57578-2.96047-3.52215-3.30725-4.11712 c-0.34677-0.59496-0.03689-0.91665,0.26073-1.2129c0.26739-0.26626,0.59446-0.69412,0.89172-1.04118 c0.29723-0.34706,0.39632-0.59497,0.59446-0.99157c0.19818-0.39667,0.09909-0.74372-0.04955-1.04121 C19.83772,17.956,18.64879,15.03077,18.15336,13.84087z" /></g></svg>

        </span>
        <div className='ar-content'>
          <span className={'tit-se-cat '}>Whatsapp US</span>
          <span className="tit-se-subcat ">
            24x7, 365 days, 18+ Regional, National, International languages.
          </span>
        </div>
      </Link>
    </li>

    <li data-name="pollination" >
      <a href={"tel:9100181181"}>

        <span className={'ar-search ar-number '}>
          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M14,22,4,35v6a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V35L34,22Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><circle data-color="color-2" cx={24} cy={33} r={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M17.13,14.247,16.639,9.83a29.3,29.3,0,0,1,14.721,0l-.491,4.417a2.36,2.36,0,0,0,1.5,2.461l7.273,2.8A2.359,2.359,0,0,0,42.521,18.5l3.153-5.362a2.372,2.372,0,0,0-.615-3.091,34.988,34.988,0,0,0-42.119,0,2.372,2.372,0,0,0-.614,3.09L5.479,18.5a2.359,2.359,0,0,0,2.879,1.006l7.273-2.8A2.36,2.36,0,0,0,17.13,14.247Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        </span>
        <div className='ar-content'>
          <span className={'tit-se-cat '}>Call US</span>
          <span className="tit-se-subcat ">
            24x7, 365 days, 18+ Regional, National, International languages.
          </span>
        </div>
      </a>
    </li>
    <li data-name="pollination" onClick={OpenSR.bind(this)}>
      {/* <Link to={"/servicerequest"}> */}

      <span className={'ar-search ar-number '}>
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M28,46h10 c3.314,0,6-2.686,6-6v-6" strokeLinejoin="miter" /> <path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M14,24H4v10 c0,2.209,1.791,4,4,4h6V24z" strokeLinejoin="miter" /> <path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M44,24H34v14h6 c2.209,0,4-1.791,4-4V24z" strokeLinejoin="miter" /> <path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M44,24v-2 c0-11.046-8.954-20-20-20h0C12.954,2,4,10.954,4,22v2" strokeLinejoin="miter" /></g></svg>

      </span>
      <div className='ar-content'>
        <span className={'tit-se-cat '}>Raise SR</span>
        <span className="tit-se-subcat ">
          Innovated, Built by Mothers for Kids, Parents, Families. Ask all your questions here
        </span>
      </div>
      {/* </Link> */}
    </li>

  </ul>


</div>



export function GetAllTherapistsData(data, isUserTherapist, fids) {

  var startDate = new Date();
  if (!(data && data.People)) {
    return;
  }

  var people = data.People.filter(e => e.RS != "DELETEACTIVITY" && e.F8 != 1);
  var therapiesAll = data.Therapies ? data.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
  therapiesAll = therapiesAll || [];
  people = people || [];
  var facilityTherapies = data.FacilityTherapies || [];
  var facilityPeople = data.FacilityPeople || [];
  people.push(...facilityPeople);
  therapiesAll.push(...facilityTherapies);

  //console.log("COWORKERS WISDOM", GetDateDiff(startDate, new Date()));
  try {
    //var fids = [];
    if (!fids) {
      fids = data.Centers.map(m => m.Id);
    }


    var therapistRoleId = GetTypeIdByName(data.Types, "Therapist");
    var therapists = Object.entries(groupBy(people.filter(f => therapistRoleId == f.RoleId && fids.indexOf(f.CenterId) > -1 && f.RS != "DELETEACTIVITY" && f.F8 != 1), "Id")).map(m => m[1][0]);
    var therapies = therapiesAll ? therapiesAll.filter(f => fids.indexOf(f.CenterId) > -1) : [];

    var serviceIds = Object.entries(groupBy(therapiesAll, "BossId"));


    //console.log("COWORKERS WISDOM - 1", GetDateDiff(startDate, new Date()));

    var pollination = [];
    for (var i = 0; i < servicesOfeering.length; i++) {
      var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1).map(m => m[0]);
      boss = (boss || []);

      for (var b = 0; b < boss.length; b++) {
        pollination.push({ BossId: boss[b], ServiceId: servicesOfeering[i].Id, ShortName: servicesOfeering[i].ShortName });
      }
    }
    //console.log("COWORKERS WISDOM - POLLINATION", GetDateDiff(startDate, new Date()));
    var therapistsData = [];
    var therpistsGroup = groupBy(therapiesAll, "TherapistId");
    for (var i = 0; i < therapists.length; i++) {
      var therapist = { ...therapists[i] };
      var bossIds = therpistsGroup && therpistsGroup[therapist.Id + ""] && therpistsGroup[therapist.Id + ""].map(m => m.BossId + "");


      therapist.C = 0;
      if (bossIds) {
        var pollinations = pollination.filter(f => bossIds.indexOf(f.BossId) > -1);
        pollinations = pollinations || [];
        var psString = Object.entries(groupBy(pollinations, "ShortName")).map(m => m[0] + ":" + m[1].length);
        therapist.Pollination = pollinations;
        therapist.PC = pollinations.length;
        therapist.C = bossIds.length;
        therapist.Pollinate = psString;
        if (!isUserTherapist) {
          therapist.Totals = therapies.length;
        }
      }
      therapist.F2 = therapist && therapist.F1 == "CT" ? "Chief Therapist" : therapist.F1 == "Dy. CT" ? "Deputy Chief Therapist" : "";
      therapist.F1 = GetShortDesignation(therapist.Designation) + ", " + therapist.C + " kids";


      therapistsData.push(therapist);
    }

    //console.log("COWORKERS WISDOM - END", GetDateDiff(startDate, new Date()));
    //var therapistsData = [];
    return therapistsData;
  } catch (e) {
    return [];
  }
}

export function twitterLink(url, _a) {
  var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
  //(0, assert_1.default)(url, 'twitter.url');
  // (0, assert_1.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
  // (0, assert_1.default)(Array.isArray(related), 'twitter.related is not an array');
  return 'https://twitter.com/share' + objectToGetParams({
    url: url,
    text: title,
    via: via,
    hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
    related: related.length > 0 ? related.join(',') : undefined,
  });
}
export function linkedinLink(url, _a) {
  var title = _a.title, summary = _a.summary, source = _a.source;
  // (0, assert_1.default)(url, 'linkedin.url');
  return ('https://linkedin.com/shareArticle' +
    objectToGetParams({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}


export function differenceInMonths(date1, date2) {
  const monthDiff = date1.getMonth() - date2.getMonth();
  const yearDiff = date1.getYear() - date2.getYear();

  return monthDiff + yearDiff * 12;
}

export function objectToGetParams(object) {
  var params = Object.entries(object)
    .filter(function (_a) {
      var value = _a[1];
      return value !== undefined && value !== null;
    })
    .map(function (_a) {
      var key = _a[0], value = _a[1];
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
  return params.length > 0 ? "?".concat(params.join('&')) : '';
}


export function MakeTheraputicAICall(kidId, type, mno, callback) {
  var dataURL = "https://psapi.pinnacleblooms.org/api/gl/eipgeneratethroughclient?pwd=Success99*&kid=" + kidId + "&muno=" + mno;
  //var dataURL = "http://mirracle.pinnacle/api/UnsecuredApi/GenerateEIPForKid?pwd=52bf4cbb-a522-49b2-9d68-8886b628a39a&KidId="+kidId;
  //  var dataURL = "https://psapi.pinnacleblooms.org/api/gl/gettheraputicairesponse?pwd=Success99*&id=" + kidId + "&type=" + type + "&isStore=store";
  const response = fetch(dataURL, { mode: 'no-cors' }).then((r) => {
    callback(r);
  }).catch(() => callback(false))
  // do something with myJson
}

export function MakeGoalsAICall(serviceId, callback) {
  var dataURL = "https://psapi.pinnacleblooms.org/api/gl/goalgeneratethroughclient?pwd=Success99*&sid=" + serviceId;
  //var dataURL = "http://mirracle.pinnacle/api/UnsecuredApi/GenerateGoals?pwd=52bf4cbb-a522-49b2-9d68-8886b628a39a&serviceId="+serviceId;
  //  var dataURL = "https://psapi.pinnacleblooms.org/api/gl/gettheraputicairesponse?pwd=Success99*&id=" + kidId + "&type=" + type + "&isStore=store";
  const response = fetch(dataURL, { mode: 'no-cors' }).then((r) => {
    callback(r);
  }).catch(() => callback(false))
  // do something with myJson
}

export function GetReportsData(type, dataConst, isItKPI, FDT, TDT, facility) {
  try {


    isItKPI = isItKPI || false;



    /*DateTime seetaDateString = DateTime.Now.Date < to.Date ? DateTime.Now.Date.AddDays(-8) : to.Date.AddDays(-8);*/

    switch (type.toLowerCase()) {
      case "kuberamonthlyfee":
        if (dataConst.Fee && dataConst.Fee.length > 0) {
          var filtered = dataConst.Fee.filter(m => m.Amount == 21960 || m.Amount == 25229).map(m => m.BOSSId).filter(onlyUnique);
          if (isItKPI) {
            return filtered;
          }
        }
        else {
          return [];
        }
        break;
      case "kuberamissing":

        if (dataConst.Therapies) {
          dataConst.Fee = dataConst.Fee || [];
          var ids = dataConst.Fee ? dataConst.Fee.filter(f => f.Type && f.Type.toLowerCase() == "services").map(m => m.ServiceId) : [];
          TDT = TDT >= new Date() ? new Date() : TDT;
          return dataConst.Therapies.filter(f => ids.indexOf(f.Id) == -1 && dateFromSDateTime(f.StartDate) <= TDT && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE");

        }
        else {
          return [];
        }

        break;
      case "kuberaabnormal":

        if (dataConst.Fee && dataConst.Fee.length > 0) {

          var filtered = dataConst.Fee.filter(f => f.Type && f.Type.toLowerCase() == "services").filter(m => invoicePrices.indexOf(m.Amount) == -1);
          if (isItKPI) {
            return filtered;
          }
        }
        else {
          return [];
        }

        break;
      case "allinvoicesthismonth":


        if (dataConst.Fee && dataConst.Fee.length > 0) {

          var filtered = dataConst.Fee;
          if (isItKPI) {
            return filtered;
          }
        }
        else {
          return [];
        }

        break;
      case "empwoer2monthly":
        var filtered = dataConst.Fee.filter(m => m.NoOfTherapies == 1).map(m => m.BOSSId).filter(onlyUnique);
        if (isItKPI) {
          return filtered;
        }
        break;
      case "empwoer2single":
        var therapy = dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
        var filtered = groupBy(therapy, "BossId");
        if (isItKPI) {
          return Object.values(filtered).filter(f => f.length == 1);
        }
        break;
      case "empwoer2lostparents":
        var filtered = groupBy(dataConst.InActive, "BossId");
        if (isItKPI) {
          return Object.keys(filtered);
        }
        break;
      case "mirraclestotal":
        var filtered = dataConst.MirraclesData ? dataConst.MirraclesData : "";
        if (isItKPI) {
          return filtered;
        }
        break;
      case "mirraclescontributed":
        var filtered = dataConst.MirraclesData ? Object.keys(groupBy(dataConst.MirraclesData, "PersonId")) : "";
        if (isItKPI) {
          return filtered;
        }
        break;
      case "mnotcontributed":
        var adminId = dataConst.Types.filter(m => m.Name == "Receptionist")[0].Id;
        var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
        var filtered = Object.keys(groupBy(dataConst.People.filter(m => (m.RoleId == therapistId || m.RoleId == adminId) && m.F8 != 1 && m.RS != "DELETEACTIVITY"), "Id"))

        return filtered;

        break;
      case "allmirraclesviews":
        var mirraclesview = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT)) : "";
        var filtered = (mirraclesview || []).reduce(function (accumulator, item) {
          return accumulator + item.F8;
        }, 0);
        if (isItKPI) {
          return filtered;
        }
        break
      case "mirraclestop100":
        var top100Mirracles = (dataConst.MirraclesData || []).slice(0, 99).map(m => m.Id);

        var filtered = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT)).filter(m => top100Mirracles.indexOf(m.Id) > -1) : "";
        if (isItKPI) {
          return filtered;
        }
        break;
      case "mirraclesbottom100":
        var bottom100Mirracles = (dataConst.MirraclesData || []).slice(-100).map(m => m.Id);
        var filtered = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT)).filter(m => bottom100Mirracles.indexOf(m.Id) > -1) : "";
        if (isItKPI) {
          return filtered;
        }
        break;
      case "mirracleslc":
        var filtered = Object.keys(groupBy(dataConst.MirraclesData, "LanguageId"));
        if (isItKPI) {
          return filtered;
        }
        break;
      case "mirraclesnotcovered":
        var languageIds = dataConst.Types.filter(m => m.Category == "Languages").map(m => m.Id);
        var languages = Object.keys(groupBy(dataConst.MirraclesData, "LanguageId"));
        var filtered = languageIds.length - languages.length;
        if (isItKPI) {
          return filtered;
        }
        break;



      case "renewals":
        dataConst.FutureInvoices = dataConst.FutureInvoices || [];
        var currentInvoices = dataConst.Fee.filter(f => f.NoOfTherapies > 1);
        var ids = (currentInvoices || []).map(m => m.BOSSId)
        var futureInvoiceCreatedOld = dataConst.FutureInvoices.filter(f => dateFromSDateTime(f.CDT) < FDT);
        //var futureInvoiceCreatedInthisMonth = dataConst.FutureInvoices.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);
        var futureInvoiceCreatedInthisMonth = dataConst.FutureInvoicesCDTThisMonth;
        var bossIds = Object.entries(groupBy(dataConst.Therapies.filter(f => ids.indexOf(f.BossId) > -1 && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE"), "BossId"));
        var renewals = [];
        futureInvoiceCreatedOld = futureInvoiceCreatedOld || [];
        futureInvoiceCreatedInthisMonth = futureInvoiceCreatedInthisMonth || [];
        for (var i = 0; i < bossIds.length; i++) {
          var bid = parseInt(bossIds[i][0]);
          var length = bossIds[i][1].length;
          var invoiceslength = futureInvoiceCreatedOld.filter(f => f.BOSSId == bid).length;
          if (length > invoiceslength) {
            var status = futureInvoiceCreatedInthisMonth.filter(f => f.BOSSId == bid);
            var currentInvoice = currentInvoices.filter(f => f.BOSSId == bid);
            var invoice = {
              ...bossIds[i][1][0], Renewed: status && status.length > 0 ? "Yes" : "No", Package: (currentInvoice[0].NoOfTherapies)
            }
            renewals.push(invoice);
          }
        }

        if (isItKPI) {
          return renewals;
        }

      case "seetatotal":
      case "seetapending":
      case "seetapartiallypaid":
      case "seetapaid":
      case "seetakids":
      case "seetaallinvoicedata":
        var cDT = TDT > new Date() ? new Date() : TDT;// new Date(TDT.toString());
        cDT.setDate(cDT.getDate() - 10);
        var start = new Date();
        var attendanceToCal = dataConst.LastAttendance && dataConst.LastAttendance.length > 0 ? dataConst.LastAttendance : dataConst.Attendance;
        var t = attendanceToCal.filter(e => !e.TypeId).sort((a, b) => (new Date(b.ForDate) > new Date(a.ForDate) ? 1 : -1));//.filter(f =>  f.ForDate >= cDT);
        console.log("seetaallinvoicedata time", GetDateDiff(start, new Date()));
        t = t || [];
        var values = Object.entries(groupBy(t, "ServiceId"));

        var filtered = values.filter(f => f[1][0] && f[1][0].Status.toLowerCase() == "absent" && f[1][1] && f[1][1].Status == "absent" && f[1][2] && f[1][2].Status == "absent");


        if (type.toLowerCase() == "seetatotal") {
          return filtered;
        }

        if (filtered && filtered.length > 0) {

          var ids = filtered.map(function (m) { return { "A": (m[0]) } });
          var groupedIds = groupBy(ids, "A");
          //var bossIds = Object.keys();
          var therapiesGroup = groupBy(dataConst.Therapies.filter(f => groupedIds && (groupedIds[f.Id] || []).length > 0 && f.RS != "DELETEACTIVITY" && (!f.Status || f.Status.toUpperCase() != "INACTIVE")), "BossId");
          if (type.toLowerCase() == "seetakids") {
            return Object.keys(therapiesGroup);
          }
          dataConst.Fee = dataConst.Fee || [];
          var invoices = dataConst.Fee.filter(f => f.Type != "ASSESSMENTS" && (therapiesGroup && therapiesGroup[f.BOSSId] || []).length > 0);

          var groupInvoices = groupBy(invoices, "BOSSId");
          invoices = Object.entries(groupInvoices).map(m => m[1].sort((a, b) => (new Date(b.ForDate) > new Date(a.ForDate) ? 1 : -1))[0]);
          if (type.toLowerCase() == "seetaallinvoicedata") {
            return invoices;
          }
          if (type.toLowerCase() == "seetapending") {
            return invoices.filter(f => !f.Status || f.Status != "PAID");
          }
          else if (type.toLowerCase() == "seetapartiallypaid") {
            return invoices.filter(f => f.Status == "PARTIALLYPAID");
          }
          else if (type.toLowerCase() == "seetapaid") {
            return invoices.filter(f => f.Status == "PAID");
          }

        }


        if (isItKPI) {
          return filtered;
        }
        break;
      case "goalspending":
        try {
          //var therapiesfiltered = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE").map(t => t.Id) : [];
          //var therapiesfiltered = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
          var groupedTherapies = dataConst.Therapies ? groupBy(dataConst.Therapies, "Id") : [];
          var filteredgoaldata = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(t => groupedTherapies && groupedTherapies[t.TherapyId] && groupedTherapies[t.TherapyId].length > 0).sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1)).map(x => [x.TherapyId, dateFromSDateTime(x.CDT)]) : []
          var goalDictionary = filteredgoaldata && filteredgoaldata.length > 0 && dataConst.Goals.length > 0 ? Object.fromEntries(filteredgoaldata) : null;
          var attendanceForGoals = goalDictionary != null && dataConst.Attendance ? dataConst.Attendance.filter(m => m.Status == 'Present' && goalDictionary && goalDictionary[m.ServiceId] && dateFromSDateTime(m.ForDate) >= (goalDictionary[m.ServiceId])) : [];
          var attendanceDictionary = attendanceForGoals ? groupBy(attendanceForGoals, "ServiceId") : null;
          var allGoalsPending = attendanceDictionary && dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => groupedTherapies && groupedTherapies[m.TherapyId] && groupedTherapies[m.TherapyId].length > 0 && attendanceDictionary && attendanceDictionary[m.TherapyId] && (m.Services - 1) <= attendanceDictionary[m.TherapyId].length && m.Review == null) : [];
          return allGoalsPending;
        } catch (error) {
          console.log(error)
          return [];
        }
        break;
      case "goalsnotset":
        var dt = new Date()
        var filtered = [];
        var therapiesfiltered = dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
        // $.each(therapiesfiltered, function (key, therapy) {
        //     let currentGoal = $.grep(dataConst.Goals, function (e) { return e.TherapyId == therapy.Id })[0];
        //     if (!currentGoal) {
        //         filtered.push(therapy);
        //     }
        // });

        var goalsforTherapy = dataConst.Goals ? dataConst.Goals.map(e => e.TherapyId) : []
        var therapiesData = dataConst.Therapies.filter(e => goalsforTherapy && goalsforTherapy.indexOf(e.Id) == -1);
        var dat = new Date()
        console.log("goal not set", GetDateDiff(dt, dat))
        return therapiesData;
        break;
      case "aigoalsnotset":
        var therapies = (dataConst.Therapies).filter(f => f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE" && new Date(f.StartDate) <= new Date());
        var tIds = (therapies || []).map(m => m.Id);

        var allGoals = dataConst.Goals.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.Status != "REVIEWED" && f.AIId && tIds.indexOf(f.TherapyId) > -1);
        var setGoals = (allGoals || []).map(e => e.TherapyId);
        var TherapyForGoals = therapies.filter(e => setGoals && setGoals.indexOf(e.Id) == -1)
        return TherapyForGoals;
        break;
      case "homeworkpending":

        var fIds = (dataConst.Feedback || []).map(m => m.AttendanceId);
        var therapies = (dataConst.Therapies).filter(f => f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE" && new Date(f.StartDate) <= new Date());
        var tIds = (therapies || []).map(m => m.Id);

        return dataConst.Attendance.filter(f => tIds.indexOf(f.ServiceId) > -1 && dateFromSDateTime(f.ForDate) >= FDT && dateFromSDateTime(f.ForDate) <= TDT && f.Status && f.Status.toLowerCase() == 'present' && fIds.indexOf(f.Id) == -1);

        var filtered = dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == 'present' && m.Feedback == 0);
        if (isItKPI) {
          return filtered;
        }
        break;

      case "homeworkcompleted":

        var fIds = (dataConst.Feedback || []).map(m => m.AttendanceId);
        //var therapies = (dataConst.Therapies).filter(f =>  f.RS != "DELETEACTIVITY"  && f.Status!="INACTIVE" && new Date(f.StartDate) <= new Date());
        //  var tIds = (therapies || []).map(m => m.Id);

        return dataConst.Attendance.filter(f => dateFromSDateTime(f.ForDate) >= FDT && dateFromSDateTime(f.ForDate) <= TDT && f.Status && f.Status.toLowerCase() == 'present' && fIds.indexOf(f.Id) > -1);

        var filtered = dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == 'present' && m.Feedback == 0);
        if (isItKPI) {
          return filtered;
        }
        break;

      case "homeworkgiven":
        var filtered = dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == 'present');
        if (isItKPI) {
          return filtered;
        }
        break;
      case "feespending":
        return [];
        break;
      case "kpiattendancepending":
        var todayDate = new Date();
        TDT = TDT >= todayDate ? todayDate : TDT;
        var services = dataConst.Therapies ? dataConst.Therapies.filter(r => r.RS != "DELETEACTIVITY" && r.Status != "INACTIVE") : [];
        var servicesforTherapist = services ? services.map(e => e.TherapistId) : []
        var leaves = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(r => r.RS != "DELETEACTIVITY" && FDT <= dateFromSDateTime(r.FDT) && dateFromSDateTime(r.FDT) <= TDT && r.TypeId == 234) : [];
        var groupbyleaves = groupBy(leaves, "FDT")
        var excludecompos = dataConst.Compos ? dataConst.Compos.filter(m => m.RS != "DELETEACTIVITY" && FDT <= dateFromSDateTime(m.ForDate) && dateFromSDateTime(m.ForDate) <= TDT && servicesforTherapist.includes(m.CBPI)).map(e => e.Id) : [];
        //var excludecompos = composOfAll ? composOfAll.map(e => e.Id) : [];
        // var groupbycompos = composOfAll.reduce((Atttendances, val) => {
        //     var splitDate = val.ForDate.split(' ')[0];
        //     if (!Atttendances[splitDate]) {
        //         Atttendances[splitDate] = [];
        //     }
        //     Atttendances[splitDate].push(val);
        //     return Atttendances;
        // }, {});

        var currentTime = GetTimeSlotTotal(todayDate.getHours() + ":" + todayDate.getMinutes()) - 45;
        console.log("kpi att-1", GetDateDiff(todayDate, new Date()))

        //var groupbycompos=groupBy(composOfAll,"ForDate")
        var completedattendance = dataConst.Attendance ? dataConst.Attendance.filter(m => m.TypeId != 238 && (!excludecompos.includes(parseInt(m.F2)))) : [];
        var totalattendance = 0;
        var fdate = new Date(FDT);
        console.log("kpi att-2", GetDateDiff(todayDate, new Date()))
        var holidaysList = getUserSettingsValue("HOLIDAYSLIST");
        var specialHolidays = getUserSettingsValue("SpecialHolidays");
        var Atttendances = completedattendance.reduce((Atttendances, val) => {
          var splitDate = val.ForDate.split(' ')[0];
          if (!Atttendances[splitDate]) {
            Atttendances[splitDate] = [];
          }
          Atttendances[splitDate].push(val);
          return Atttendances;
        }, {});
        var specialHolidayDates = [];
        var arraySHD = specialHolidays.split("{#}");
        if (arraySHD) {
          arraySHD.forEach(function (val, index) {
            if (val) {
              specialHolidayDates.push(dateFromSDateTime(val.split("{=}")[0]));

            }
          });
        }

        var holidays = holidaysList ? JSON.parse(holidaysList) : [];
        console.log("kpi att-3", GetDateDiff(todayDate, new Date()))
        for (var date = fdate; date <= TDT; date.setDate(date.getDate() + 1)) {

          if (new Date(date).getDay() == 6 || new Date(date).getDay() == 0) {
            continue;
          }
          if (holidays) {
            var onHoliday = holidays.filter(function (e) {
              return mongodateforholidays(e.OccasionTo) >= date && mongodateforholidays(e.OccasionFrom) <= date
            })[0];
            if (onHoliday) {
              continue;
            }
          }
          if (specialHolidayDates) {
            var yesSpecialHoliday = specialHolidayDates.filter(function (e) { return e.getDate() == date.getDate() && e.getMonth() == date.getMonth() && e.getFullYear() == date.getFullYear() })[0]
            if (yesSpecialHoliday) {
              continue;
            }
          }
          var currentDates = PSdateFormate(date);

          //var composData = [];// (groupbycompos[currentDates.split(" ")[0]]) || [];
          var isToday = new Date().toDateString() == date.toDateString();
          //totalattendance += isToday ? (composData.filter(f=> GetTimeSlotTotal(f.Status) <= currentTime) || []).length : composData.length;
          // var filteredCompos=composData?composData.filter(e=>new Date(e.ForDate).getDate()==new Date().getDate()? e.Status.split(":")[0]<=new Date().getHours():true):[]
          //totalattendance+= (composData || []).length;
          totalattendance -= Object.keys(groupBy((Atttendances[currentDates.split(" ")[0]] || []), "ServiceId") || []).length;
          //totalattendance-= (Atttendances[currentDates.split(" ")[0]] || []).length;

          var leavesforday = groupbyleaves[currentDates];
          var leavesDate = leavesforday ? leavesforday.map(e => e.TOId) : [];

          var activeservices = services.filter(e => dateFromSDateTime(e.StartDate).setHours(0, 0, 0) <= new Date(date) && (isToday ? GetTimeSlotTotal(e.Time) < currentTime : true) && (leavesDate ? (!leavesDate.includes(e.BossId) && !leavesDate.includes(e.TherapistId)) : true))
          // if(activeservices){
          //    var service= activeservices.map(e=>e.Id)
          //    var attendancess=Atttendances[currentDates.split(" ")[0]]
          //    var byattendance=attendancess?attendancess.filter(e=>service.indexOf(e.ServiceId) > -1):[]
          //    totalattendance -= Object.keys(groupBy((byattendance || []), "ServiceId") || []).length;
          // }

          totalattendance += ((activeservices || []).length);
          //composOfAll[]
          //var groupbyattendance=groupBy(Atttendances,"ForDate");

          //totalattendance-=groupbycompos[date].length;
        }
        var last = new Date();
        var hahh = GetDateDiff(todayDate, last)
        console.log(hahh, "date for attendance")
        return (totalattendance > 0 ? totalattendance : 0);

        break;
      case "attendancepending":

        console.log("Attendance ", new Date());
        var filtered = [];


        //var totalAttendance = dataConst.TWD * dataConst.Therapies.length;
        var todayDate = new Date();
        TDT = TDT >= todayDate ? todayDate : TDT;
        var todatlWorkingDays = GetTotalWorkingDaysExcludingSaturdays(FDT, TDT);
        var currentTime = GetTimeSlotTotal(todayDate.getHours() + ":" + todayDate.getMinutes()) - 45;

        var filteredoftherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];

        var leavsOfAll = dataConst.Leaverequestall.filter(m => FDT <= dateFromSDateTime(m.FDT) && dateFromSDateTime(m.FDT) <= TDT && m.RS != "DELETEACTIVITY")
        var composOfAll = dataConst.Compos.filter(m => m.ForDate && FDT <= dateFromSDateTime(m.ForDate) && dateFromSDateTime(m.ForDate) <= TDT);
        var atendanceexcludecompos = composOfAll.map(e => e.Id)
        // var filteredLeaves = Object.entries(groupBy(leavsOfAll,"FDT")).map(m=> m[1][0]);
        var leavesGroup = groupBy(leavsOfAll, "TOId");
        var composGroup = groupBy(composOfAll, "ServiceId");
        var attendancesData = (dataConst.Attendance.filter(m => m.TypeId != 238 && !atendanceexcludecompos.includes(parseInt(m.F2))) || [])
        var presentattendancesData = (attendancesData.filter(m => m.Status && m.Status.toLowerCase() == "present") || []);
        var absentattendancesData = (attendancesData.filter(m => (!m.Status || m.Status.toLowerCase() != "present")) || []);

        var attendanceCounts = groupBy(attendancesData, "ServiceId");
        console.log("Attendance-v1 ", new Date());
        var totalAttendance = filteredoftherapies.reduce(function (accumulator, item) {

          // item.StartDate=new Date(item.StartDate).setHours(0,0,0,0)
          var due = (leavesGroup[item.BossId] || []);
          due.push(...(leavesGroup[item.TherapistId] || []));
          var filters = [];// due.filter(m=> (dateFromSDateTime(item.StartDate)) <=  dateFromSDateTime(m.FDT));
          // var filters =  dataConst.Leaverequestall.filter(m=> (m.TOId == item.BossId || m.TOId == item.TherapistId) && (dateFromSDateTime(item.StartDate)) <=  dateFromSDateTime(m.FDT) && FDT <= dateFromSDateTime(m.FDT) && dateFromSDateTime(m.FDT) <= TDT);
          var compos = [];//(composGroup[item.Id] || []);// (composGroup[item.Id] || []);// dataConst.Compos.filter(m=> m.ForDate && m.ServiceId == item.Id &&  FDT <= dateFromSDateTime(m.ForDate) && dateFromSDateTime(m.ForDate) <= TDT);

          var total = (dateFromSDateTime(item.StartDate) <= FDT ? todatlWorkingDays : ((dateFromSDateTime(item.StartDate) > FDT && dateFromSDateTime(item.StartDate) <= TDT) ? GetTotalWorkingDaysExcludingSaturdays(dateFromSDateTime(item.StartDate), TDT) : 0)) - (filters || []).length + (compos || []).length;
          var completed = (attendanceCounts[item.Id] || []).length;

          if (new Date().getDay() != 6 && new Date().getDay() != 0 && TDT.toDateString() == (new Date()).toDateString() && GetTimeSlotTotal(item.Time) > currentTime) {
            total -= 1;
          }
          // var leavesperson = leavsOfAll.filter(e => e.RS != "DELETEACTIVITY" && e.TOId == item.TherapistId)
          // if (leavesperson && leavesperson.length > 0) {
          //     total -= leavesperson.length
          // }
          // var leavesforKid = leavsOfAll.filter(e => e.RS != "DELETEACTIVITY" && e.TOId == item.BossId)
          // if (leavesforKid && leavesforKid.length > 0) {
          total -= (due.length)
          //}
          var pending = total - completed;
          pending = pending > 0 ? pending : 0;
          if (!isItKPI) {
            item.totalAttendance = total;
            item.CompletedAttendance = completed;
            item.PendingAttendance = pending;


            item.Present = (presentattendancesData[item.Id] || []).length;
            item.Absent = (absentattendancesData[item.Id] || []).length;
          }
          return pending + accumulator;

        }, 0);
        console.log("Attendance-v2 ", new Date());
        if (isItKPI) {
          return totalAttendance;
        }


        return dataConst.Therapies;
        //if (isItKPI) {
        //    return pending;
        //}
        // return dataConst.Attendance;
        break;

      case "kidattendancepending":

        console.log("kidattendancepending ", new Date());
        var filtered = [];


        //var totalAttendance = dataConst.TWD * dataConst.Therapies.length;
        var todayDate = new Date();
        //var ChangedFDT= new Date(todayDate.getFullYear(), todayDate.getMonth(), 28);
        TDT = TDT >= todayDate ? todayDate : TDT;
        var todatlWorkingDays = GetTotalWorkingDaysExcludingSaturdays(FDT, TDT);
        var currentTime = GetTimeSlotTotal(todayDate.getHours() + ":" + todayDate.getMinutes()) - 45;

        var filteredoftherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
        var BossTherapiesData = filteredoftherapies && filteredoftherapies.length > 0 ? filteredoftherapies.map(e => e.BossId) : []

        var leavsOfAll = dataConst.Leaverequestall && dataConst.Leaverequestall.length > 0 ? dataConst.Leaverequestall.filter(m => FDT <= dateFromSDateTime(m.FDT) && dateFromSDateTime(m.FDT) <= TDT && m.RS != "DELETEACTIVITY") : [];
        var composOfAll = dataConst.Compos && dataConst.Compos.length > 0 ? dataConst.Compos.filter(m => m.ForDate && FDT <= dateFromSDateTime(m.ForDate) && dateFromSDateTime(m.ForDate) <= TDT) : [];
        var atendanceexcludecompos = composOfAll && composOfAll.length > 0 ? composOfAll.map(e => e.Id) : [];
        var leavesGroup = groupBy(leavsOfAll, "TOId");
        var peopleGroup = groupBy(dataConst.People, "Id");
        var composGroup = groupBy(composOfAll, "ServiceId");
        var attendancesData = (dataConst.Attendance.filter(m => m.TypeId != 238 && FDT <= dateFromSDateTime(m.ForDate) && !atendanceexcludecompos.includes(parseInt(m.F2))) || [])
        var presentattendancesData = (attendancesData.filter(m => m.Status && m.Status.toLowerCase() == "present") || []);
        var absentattendancesData = (attendancesData.filter(m => (!m.Status || m.Status.toLowerCase() != "present")) || []);

        var attendanceCounts = groupBy(attendancesData, "ServiceId");
        var allkids = dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter(e => e.RS != "DELETEACTIVITY" && e.F8 != 1 && BossTherapiesData && BossTherapiesData.indexOf(e.Id) > -1) : []
        if (!allkids || allkids.length <= 0) {
          allkids = dataConst.FacilityPeople && dataConst.FacilityPeople.length > 0 ? dataConst.FacilityPeople.filter(e => e.RS != "DELETEACTIVITY" && e.F8 != 1 && BossTherapiesData && BossTherapiesData.indexOf(e.Id) > -1) : []
        }

        var allKidDataPending = []


        for (var i = 0; i < allkids.length; i++) {
          var kidtherapies = filteredoftherapies && filteredoftherapies.length > 0 ? filteredoftherapies.filter(r => r.BossId == allkids[i].Id) : [];
          var obj = {};
          var Totals = 0;
          var therapistNames = [];
          var totalAttendance = kidtherapies.reduce(function (accumulator, item) {

            var due = (leavesGroup[item.BossId] || []);


            due.push(...(leavesGroup[item.TherapistId] || []));
            //due=due.filter(e=> (e.F11+"").split(",").indexOf(item.Id +"") == -1)
            var filters = [];

            var compos = [];
            var total = (dateFromSDateTime(item.StartDate) <= FDT ? todatlWorkingDays : ((dateFromSDateTime(item.StartDate) >= FDT && dateFromSDateTime(item.StartDate) <= TDT) ? GetTotalWorkingDaysExcludingSaturdays(dateFromSDateTime(item.StartDate), TDT) : 0)) - (filters || []).length + (compos || []).length;
            var completedData = (attendanceCounts[item.Id] || []);
            var completed = completedData && completedData.length > 0 ? Object.keys(groupBy(completedData, "ForDate")).length : 0;

            if (new Date().getDay() != 6 && new Date().getDay() != 0 && TDT.toDateString() == (new Date()).toDateString() && GetTimeSlotTotal(item.Time) > currentTime) {
              total -= 1;
            }
            due = due && due.length > 0 ? due.filter(e => new Date(item.StartDate).setHours(0, 0, 0, 0) <= new Date(e.FDT)) : due;

            if (due && due.length > 0) {
              var groups = due.reduce((groups, val) => {
                var splitDate = val.FDT.split(' ')[0];
                if (!groups[splitDate]) {
                  groups[splitDate] = [];
                }
                groups[splitDate].push(val);
                return groups;
              }, {});

              var allKeys = Object.keys(groups);

              allKeys.forEach(leav => {
                var leaveDate = leav + " 00:00:00";
                var isSaturday = new Date(leaveDate);
                if (isSaturday.getDay() == 6) {
                  total += 1;
                }
              });


            }

            //due = due && due.length > 0 ? due.filter(e => item.StartDate <= e.FDT) : due;

            total -= (due.length)
            // total -= (Object.keys(groupBy(due, "FDT")).length)

            var pending = total - completed;
            pending = pending > 0 ? pending : 0;
            if (pending > 0) {
              var t = peopleGroup && peopleGroup[item.TherapistId] && peopleGroup[item.TherapistId][0].Name;

              // console.log("ATTENDANCE TherapistId",peopleGroup[item.TherapistId][0])
              if (t) {
                therapistNames.push(t);
                //console.log("ATTENDANCE PUSHED",therapistNames)
              }
            }
            Totals += pending


          }, 0);

          obj.Id = allkids[i].Id;
          obj.Pending = Totals;
          //console.log("HELLO ME ",therapistNames);
          obj.TherapistNames = therapistNames && therapistNames.length > 0 ? therapistNames.join(",") : "";
          // console.log("HELLO ME 2",obj.TherapistNames);
          filtered.push(obj);
        }
        if (isItKPI) {
          var Total = filtered.reduce(function (accumulator, item) {
            return accumulator + (item.Pending);
          }, 0);
          return Total;
        }

        return filtered;
        break;
      case "overallpti":
        var ptiType = GetTypeIdByName(dataConst.Types, "PTIHISTORY");
        var groupedPeople = dataConst && dataConst.People && dataConst.People.length > 0 ? groupBy(dataConst.People, "Id") : [];
        var ptiHistories = dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(e => e.TypeId && e.TypeId == ptiType && new Date(e.CDT) >= FDT && new Date(e.CDT) <= TDT && e.RS != "DELETEACTIVITY").sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1)) : [];
        var groupByHistories = groupBy(ptiHistories, "TOId");
        var groupedCenters = dataConst && dataConst.Centers && dataConst.Centers.length > 0 ? groupBy(dataConst.Centers, "Id") : [];
        var allServices = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY") : [];
        var uniqueUserServices = allServices.filter((value, index, self) => self.map(x => x.BossId).indexOf(value.BossId) == index);
        if (uniqueUserServices && uniqueUserServices.length > 0) {
          uniqueUserServices.forEach(function (r) {
            if (r.TherapistId) {
              r.Therapist = groupedPeople && groupedPeople[r.TherapistId] && groupedPeople[r.TherapistId].length > 0 ? groupedPeople[r.TherapistId][0].Name : '';
              r.Kid = groupedPeople && groupedPeople[r.BossId] && groupedPeople[r.BossId].length > 0 ? groupedPeople[r.BossId][0].Name : '';
              r.Assigned = groupedPeople && r.RId && groupedPeople[r.RId] && groupedPeople[r.RId].length > 0 ? groupedPeople[r.RId][0].Name : '';
            }
            r.IsCompleted = groupByHistories && groupByHistories[r.BossId + ""] && groupByHistories[r.BossId + ""].length > 0 ? "Completed" : "Pending";
            r.Rating = groupByHistories && groupByHistories[r.BossId + ""] && groupByHistories[r.BossId + ""].length > 0 ? groupByHistories[r.BossId + ""][0].F9 : 0;
            r.Center = groupedCenters && groupedCenters[r.CenterId + ""] && groupedCenters[r.CenterId + ""].length > 0 ? groupedCenters[r.CenterId + ""][0].Name : '';
          })
        }
        return uniqueUserServices;
        break;
      case "pendingpti":
        var ptiType = GetTypeIdByName(dataConst.Types, "PTIHISTORY");
        var groupedPeople = dataConst && dataConst.People && dataConst.People.length > 0 ? groupBy(dataConst.People, "Id") : [];
        var ptiHistories = dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(e => e.TypeId && e.TypeId == ptiType && new Date(e.CDT) >= FDT && new Date(e.CDT) <= TDT && e.RS != "DELETEACTIVITY") : [];
        var groupByHistories = groupBy(ptiHistories, "TOId");
        var completedIds = Object.keys(groupByHistories);
        var groupedCenters = dataConst && dataConst.Centers && dataConst.Centers.length > 0 ? groupBy(dataConst.Centers, "Id") : [];
        var allServices = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY") : [];
        var mappedServices = allServices.filter((value, index, self) => self.map(x => x.BossId).indexOf(value.BossId) == index);
        var uniqueUserServices = mappedServices.filter(e => completedIds.indexOf(e.BossId + "") == -1);
        if (uniqueUserServices && uniqueUserServices.length > 0) {
          uniqueUserServices.forEach(function (r) {
            if (r.TherapistId) {
              r.Therapist = groupedPeople && groupedPeople[r.TherapistId] && groupedPeople[r.TherapistId].length > 0 ? groupedPeople[r.TherapistId][0].Name : '';
              r.Kid = groupedPeople && groupedPeople[r.BossId] && groupedPeople[r.BossId].length > 0 ? groupedPeople[r.BossId][0].Name : '';
              r.Assigned = groupedPeople && r.RId && groupedPeople[r.RId] && groupedPeople[r.RId].length > 0 ? groupedPeople[r.RId][0].Name : '';
            }
            r.Center = groupedCenters && groupedCenters[r.CenterId + ""] && groupedCenters[r.CenterId + ""].length > 0 ? groupedCenters[r.CenterId + ""][0].Name : '';
          })
        }
        return uniqueUserServices;
        break;
      case "completedpti":
        var ptiType = GetTypeIdByName(dataConst.Types, "PTIHISTORY");
        var groupedPeople = dataConst && dataConst.People && dataConst.People.length > 0 ? groupBy(dataConst.People, "Id") : [];
        var ptiHistories = dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(e => e.TypeId && e.TypeId == ptiType && new Date(e.CDT) >= FDT && new Date(e.CDT) <= TDT && e.RS != "DELETEACTIVITY") : [];
        var groupByHistories = groupBy(ptiHistories, "TOId");
        var completedIds = Object.keys(groupByHistories);
        var groupedCenters = dataConst && dataConst.Centers && dataConst.Centers.length > 0 ? groupBy(dataConst.Centers, "Id") : [];
        var allServices = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY") : [];
        var mappedServices = allServices.filter((value, index, self) => self.map(x => x.BossId).indexOf(value.BossId) == index);
        var uniqueUserServices = mappedServices.filter(e => completedIds.indexOf(e.BossId + "") > -1);
        if (uniqueUserServices && uniqueUserServices.length > 0) {
          uniqueUserServices.forEach(function (r) {
            if (r.TherapistId) {
              r.Therapist = groupedPeople && groupedPeople[r.TherapistId] && groupedPeople[r.TherapistId].length > 0 ? groupedPeople[r.TherapistId][0].Name : '';
              r.Kid = groupedPeople && groupedPeople[r.BossId] && groupedPeople[r.BossId].length > 0 ? groupedPeople[r.BossId][0].Name : '';
              r.Assigned = groupedPeople && r.RId && groupedPeople[r.RId] && groupedPeople[r.RId].length > 0 ? groupedPeople[r.RId][0].Name : '';
            }
            r.Rating = groupByHistories && groupByHistories[r.BossId + ""] && groupByHistories[r.BossId + ""].length > 0 ? groupByHistories[r.BossId + ""][0].F9 : 0;
            r.Title = groupByHistories && groupByHistories[r.BossId + ""] && groupByHistories[r.BossId + ""].length > 0 ? groupByHistories[r.BossId + ""][0].Title : "";
            r.Description = groupByHistories && groupByHistories[r.BossId + ""] && groupByHistories[r.BossId + ""].length > 0 ? groupByHistories[r.BossId + ""][0].Description : "";
            r.Center = groupedCenters && groupedCenters[r.CenterId + ""] && groupedCenters[r.CenterId + ""].length > 0 ? groupedCenters[r.CenterId + ""][0].Name : '';
          })
        }
        return uniqueUserServices;
        break;
      case "credits":
      case "availablecredits":
        return dataConst.FutureInvoices ? dataConst.FutureInvoices : [];
        break;
      case "compospending":
        var filtered = [];

        var leaves = GetLeavesCompoCount(dataConst, FDT, TDT, null, dataConst.Therapies);
        var alltherapies = dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE");;
        var therapyIds = alltherapies.map(t => t.Id);



        var absent = dataConst.Attendance.filter(f => therapyIds.indexOf(f.ServiceId) > -1 && f.Status && f.Status.toLowerCase() == "absent" && !f.F2);
        var filterdcompospending = dataConst.Compos.filter(e => new Date(e.ForDate) > FDT);
        return (leaves.length + absent.length) - filterdcompospending.length;
        //var absent = dataConst.Compos.length;
        //return filtered;
        break;

      case "compos":
        return dataConst.Compos;

        break;
      case "mirraclepending":
        var pendingmirracle = dataConst.MirraclesAssigned.filter(f => !f.Status || f.Status == "pending");
        return pendingmirracle;
        break;
      case "inactivations":
        var now = new Date();
        var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        var allinactivations = dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => dateFromSDateTime(t.F14) >= fromDate) : [];
        //    var userRole = GetTypeNameById(dataConst?.Types,dataConst?.CFUser?.RoleId);
        //     if (userRole && userRole.toLowerCase() == "bdc") {
        //         var kids = filterKidsByUsers(dataConst?.CFUser, dataConst.AllKids)
        //         allinactivations = allinactivations.filter(r => kids && kids.indexOf(r.BossId) > -1);
        //     }
        return allinactivations;
        break;
      case "admissions":
        var totalAdmissions = 0;
        var allServices = dataConst.Therapies;
        var currentUserServices = allServices.filter(function (r) { return dateFromSDateTime(r.StartDate) >= FDT && dateFromSDateTime(r.StartDate) <= TDT });
        var previousUserServices = allServices.filter(function (r) { return dateFromSDateTime(r.StartDate) < FDT });
        if (currentUserServices) {
          var groupedKidIds = groupBy(currentUserServices, "BossId");
          var previousKidIds = groupBy(previousUserServices, "BossId");
          // console.log(groupedKidIds);
          var currentMonthKids = Object.keys(groupedKidIds);
          var prevMonthKids = Object.keys(previousKidIds);
          totalAdmissions = currentMonthKids.filter(function (e) { return prevMonthKids.indexOf(e) <= -1 });

        }
        return totalAdmissions;
        break;
      case "additions":
        var totalAdditions = 0;
        var allServices = dataConst.Therapies;
        var currentUserServices = allServices.filter(function (r) { return dateFromSDateTime(r.StartDate) >= FDT && dateFromSDateTime(r.StartDate) <= TDT });
        var previousUserServices = allServices.filter(function (r) { return dateFromSDateTime(r.StartDate) < FDT });
        if (currentUserServices) {
          var groupedKidIds = groupBy(currentUserServices, "BossId");
          var previousKidIds = groupBy(previousUserServices, "BossId");
          // console.log(groupedKidIds);
          var currentMonthKids = Object.keys(groupedKidIds);
          var prevMonthKids = Object.keys(previousKidIds);
          // totalAdmissions = $.grep(currentMonthKids, function (e) { return prevMonthKids.indexOf(e) <= -1 }).length;
          totalAdditions = currentMonthKids.filter(function (e) { return prevMonthKids.indexOf(e) >= 0 });


          //var inactive = this.props.currentAggregate && this.props.currentAggregate.TCS ? parseInt(this.props.currentAggregate.TCS) : 0;
          //var result = (40 / 100) * inactive;
          //console.log(result);
          //flagInactivations = (inactive + result) > totalAdditions

          //  console.log(totalAdmissions);
          //  console.log(totalAdditions);

        }
        return totalAdditions;
        break;
      case "walkinsold":
        var availableLeads = [];
        for (let i = 0; i < dataConst.Leads.length; ++i) {
          var leadObj = {};
          leadObj = dataConst.Leads[i];
          if (leadObj.F3) {
            var f3Index = leadObj.F3.indexOf("{");
            leadObj.F3 = leadObj.F3.slice(0, f3Index);
            availableLeads.push(leadObj);
          }
          else {
            continue;
          }

        }
        var leads = Object.entries(groupBy(availableLeads, "F3"));
        var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
        var filteredData = resultleads.filter((k) => k.F1.toLowerCase() == "walkin");
        return filteredData;

        break;
      case "paymentpending":
        var typeId = GetTypeIdByName(dataConst.Types, "Seva");
        var thismonthInvoice = dataConst.Fee ? dataConst.Fee.filter(f => ((dateFromSDateTime(f.CDT) <= TDT && dateFromSDateTime(f.CDT) >= FDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation"))) : [];
        var data = thismonthInvoice.map(m => m.Id);


        if (isItKPI && false) {
          const paymnet = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => data.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

          var invoiceamount = thismonthInvoice.reduce(function (accumulator, item) {
            return accumulator + (item.Amount - item.SevaAmount);
          }, 0);
          var paymentamount = paymnet ? paymnet.reduce(function (accc, items) {
            return accc + items.Amount;
          }, 0) : 0;
          var filtered = invoiceamount - paymentamount;
          return filtered;
        }
        else {
          const paymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => data.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

          var paymentsGroup = groupBy(paymnets, "FeeId");


          var paymentsWithGrouping = Object.entries(paymentsGroup);

          var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
            [m[0]]: m[1].reduce(function (accc, items) {
              return accc + items.Amount;
            }, 0)
          }))));

          var amounts = thismonthInvoice.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));


          if (isItKPI) {
            var invoiceamount = amounts.reduce(function (accumulator, item) {

              var amount = (item.Amount - item.SevaAmount - (paymentDict[item.Id] ? paymentDict[item.Id] : 0));
              amount = amount > 0 ? amount : 0;
              return accumulator + amount;
            }, 0);

            return invoiceamount;
          }

          var peopleGroup = groupBy(dataConst.People, "Id");
          var typesGroup = groupBy(dataConst.Types, "Id");
          var facilitiesGroup = groupBy(dataConst.Centers, "Id");

          var data = [];

          amounts.forEach(function (a, k) {
            var obj = {};
            var opending = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
            opending = opending ? opending : 0;
            obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
            obj.MonthId = appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
            obj.Id = a.Id;
            obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
            obj.KidId = a.BOSSId;
            obj.Created = a.CDT;
            obj.From = a.FDT;
            obj.To = a.TDT;
            obj.ETA = GetDateFormat(a.ETA);
            obj.Total = a.Amount;
            obj.Seva = a.SevaAmount;
            //obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
            obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
            obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
            obj.PendingAmt = opending;
            data.push(obj);
          });

          return data;
        }
        break;
      case "inflow":
        var typeId = GetTypeIdByName(dataConst.Types, "Seva");
        var allPayments = dataConst.FeeReceipt.filter(f => typeId != f.TypeId && (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT));
        var invoiceIds = allPayments.map(m => m.FeeId);
        var amounts = dataConst.FeeAll.filter(f => invoiceIds.indexOf(f.Id) > -1);

        const inflowpaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => invoiceIds.indexOf(f.FeeId) > -1 && typeId != f.TypeId && (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT)) : [];

        var paymentsGroup = groupBy(inflowpaymnets, "FeeId");
        var paymentsWithGrouping = Object.entries(paymentsGroup);
        var paymentDict = Object.assign({}, ...paymentsWithGrouping.map(m => ({
          [m[0]]: m[1].reduce(function (accc, items) {
            return accc + items.Amount;
          }, 0)
        })));


        var peopleGroup = groupBy(dataConst.People, "Id");
        var typesGroup = groupBy(dataConst.Types, "Id");
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");
        var data = [];
        amounts.forEach(function (a, k) {
          var obj = {};
          obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
          obj.MonthId = appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
          obj.Id = a.Id;
          obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
          obj.Created = a.CDT;
          obj.From = a.FDT;
          obj.To = a.TDT;
          obj.Total = a.Amount;

          obj.Seva = a.SevaAmount;
          obj.Amount = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
          obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
          obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
          obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
          obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
          data.push(obj);
        });
        return data;

        break;

      case "business":
        var advancedata = dataConst.FeeAll.filter(f => (f.Remarks && f.Remarks.toLowerCase() == "system automation") ? ((dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.FDT) <= TDT)) : (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT));
        var advances = advancedata ? advancedata.map(m => m.Id) : [];
        const buspaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => advances.indexOf(f.FeeId) > -1) : [];

        var paymentsGroup = groupBy(buspaymnets, "FeeId");


        var paymentsWithGrouping = Object.entries(paymentsGroup);

        var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
          [m[0]]: m[1].reduce(function (accc, items) {
            return accc + items.Amount;
          }, 0)
        }))));

        var amounts = advancedata;
        var peopleGroup = groupBy(dataConst.People, "Id");
        var typesGroup = groupBy(dataConst.Types, "Id");
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");
        var data = [];
        amounts.forEach(function (a, k) {
          var obj = {};
          obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
          obj.MonthId = appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
          obj.Id = a.Id;
          obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
          obj.Created = a.CDT;
          obj.From = a.FDT;
          obj.To = a.TDT;
          obj.Total = a.Amount;

          obj.Seva = a.SevaAmount ? a.SevaAmount : 0;
          obj.Amount = a.Amount - a.SevaAmount;
          obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
          obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
          obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
          obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
          obj.Download = a?.SUId;
          data.push(obj);
        });






        return data;

      case "advancepending":
        //var advancedata = dataConst.FutureInvoices ? dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) <= TDT && dateFromSDateTime(f.CDT) >= FDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")) : [];

        var groupedTherapies = groupBy(dataConst.Therapies, "BossId");

        var advancedata = dataConst.FutureInvoicesCDTThisMonth ? dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation")) : [];
        var advances = advancedata ? advancedata.map(m => m.Id) : [];


        var typeId = GetTypeIdByName(dataConst.Types, "Seva");
        const adpaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => f.TypeId != typeId && advances.indexOf(f.FeeId) > -1) : [];


        if (isItKPI && false) {

          var paymentsGroup = groupBy(adpaymnets, "FeeId");


          var paymentsWithGrouping = Object.entries(paymentsGroup);

          var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
            [m[0]]: m[1].reduce(function (accc, items) {
              return accc + items.Amount;
            }, 0)
          }))));

          advancedata = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0))


          var invoicesamount = advancedata ? advancedata.reduce(function (accumulator, item) {
            return accumulator + (item.Amount - item.SevaAmount);
          }, 0) : 0;

          advances = advancedata.map(f => f.Id);
          var paymentsamount = adpaymnets ? adpaymnets.filter(a => advances.indexOf(a.Id) > -1).reduce(function (accc, items) {
            return accc + items.Amount;
          }, 0) : 0;
          var filtered = invoicesamount - paymentsamount;
          return filtered;
        }
        else {
          const paymnets = adpaymnets;

          var paymentsGroup = groupBy(paymnets, "FeeId");


          var paymentsWithGrouping = Object.entries(paymentsGroup);

          var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
            [m[0]]: m[1].reduce(function (accc, items) {
              return accc + items.Amount;
            }, 0)
          }))));
          dataConst.Centers = dataConst.Centers ? dataConst.Centers : [];
          var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
          var peopleGroup = groupBy(dataConst.People, "Id");
          var typesGroup = groupBy(dataConst.Types, "Id");
          var facilitiesGroup = groupBy(dataConst.Centers, "Id");
          var data = [];
          amounts.forEach(function (a, k) {
            var obj = {};
            obj.Facility = facilitiesGroup[a.CenterId] ? facilitiesGroup[a.CenterId][0].Name : '';//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
            obj.MonthId = appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
            obj.Id = a.Id;
            obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
            obj.KidId = a.BOSSId;
            obj.Created = a.CDT;
            obj.From = a.FDT;
            obj.To = a.TDT;
            obj.Total = a.Amount;
            obj.Seva = a.SevaAmount;
            // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
            obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
            obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
            obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
            data.push(obj);
          });

          if (isItKPI) {
            var invoicesamount = data ? data.reduce(function (accumulator, item) {
              return accumulator + (item.PendingAmt);
            }, 0) : 0;
            return invoicesamount;
          }

          return data;
        }
        break;
      case "overallpending":
      case "etapending":
        var stDate = new Date();
        //var bids = dataConst.Therapies.map(m => m.BossId);
        var groupedTherapies = groupBy(dataConst.Therapies, "BossId");
        var allData = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.RS != "DELETEACTIVITY" && f.Status != "PAID") : [];
        //console.log("GROUPED:"+GetDateDiff(stDate,new Date()));
        // stDate = new Date();
        // var allData1 = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.RS != "DELETEACTIVITY" && f.Status != "PAID" && bids.indexOf(f.BOSSId) > -1) : [];
        // console.log("INDESXOF:"+GetDateDiff(stDate,new Date()));
        var typeId = GetTypeIdByName(dataConst.Types, "Seva");
        //stDate = new Date();
        const paymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => f.TypeId != typeId) : [];
        //console.log("PAYMENTS:"+GetDateDiff(stDate,new Date()));
        var paymentsGroup = groupBy(paymnets, "FeeId");


        var paymentsWithGrouping = Object.entries(paymentsGroup);

        stDate = new Date();
        // var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
        //     [m[0]]: m[1].reduce(function (accc, items) {
        //         return accc + items.Amount;
        //     }, 0)
        // }))));

        var paymentDict = Object.entries(paymentsGroup).reduce((acc, [key, values]) => {
          // Use whatever logic you need to reduce the values (sum, average, etc.)
          const reducedValue = values.reduce(function (accc, items) {
            return accc + items.Amount;
          }, 0)

          // Assign the reduced value to the key in the accumulator
          acc[key] = reducedValue;

          return acc;
        }, {});


        dataConst.Centers = dataConst.Centers ? dataConst.Centers : [];
        console.log("paymentDict:" + GetDateDiff(stDate, new Date()));
        var amounts = allData.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));

        var peopleGroup = groupBy(dataConst.People, "Id");
        var typesGroup = groupBy(dataConst.Types, "Id");
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");
        var data = [];
        amounts.forEach(function (a, k) {
          var obj = {};
          obj.Facility = facilitiesGroup[a.CenterId] ? facilitiesGroup[a.CenterId][0].Name : '';//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
          obj.MonthId = appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
          obj.Id = a.Id;
          obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
          obj.KidId = a.BOSSId;
          obj.Created = a.CDT;
          obj.From = a.FDT;
          if (type.toLowerCase() == "etapending") {
            obj.ETA = a.ETA;
          }
          obj.To = a.TDT;
          obj.Total = a.Amount ? a.Amount : 0;
          obj.Seva = a.SevaAmount ? a.SevaAmount : 0;
          // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
          obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
          obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
          obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
          data.push(obj);
        });

        if (isItKPI && type.toLowerCase() != "etapending") {
          var invoicesamount = data ? data.reduce(function (accumulator, item) {
            return accumulator + (item.PendingAmt);
          }, 0) : 0;
          return invoicesamount;
        }
        if (type.toLowerCase() == "etapending") {

          var data = data.filter(e => !e.ETA);
          if (isItKPI) {
            var invoicesamount = data ? data.reduce(function (accumulator, item) {
              return accumulator + (item.PendingAmt);
            }, 0) : 0;
            return invoicesamount;
          }
          return data;
        }

        return data;

        break;
      case "pastpending":
        var start = new Date();

        var bids = dataConst.Therapies.map(m => m.BossId);
        var therapiesGroup = groupBy(dataConst.Therapies, "BossId");
        // console.log("pastpending bids",GetDateDiff(start,new Date()));
        start = new Date();
        // bids.indexOf(f.BOSSId) > -1
        var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => (!f.Status || f.Status.toLowerCase() != "paid") && (dateFromSDateTime(f.CDT) < FDT)) : [];
        //console.log("pastpending advancedata",GetDateDiff(start,new Date()));
        start = new Date();
        var advances = advancedata ? advancedata.map(m => m.Id) : [];
        var groupBypendings = groupBy(advancedata, "Id");
        //console.log("pastpending advancedata",GetDateDiff(start,new Date()));
        start = new Date();
        // console.log(advances);
        const papaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => groupBypendings && (groupBypendings[f.FeeId] || []).length > 0) : [];
        // console.log("pastpending papaymnets",GetDateDiff(start,new Date()));

        // console.log("pastpending papaymnets",isItKPI);
        start = new Date();
        if (false) {

          var paymentsGroup = groupBy(papaymnets, "FeeId");
          // console.log("pastpending paymentsGroup",GetDateDiff(start,new Date()));
          start = new Date();

          var paymentsWithGrouping = Object.entries(paymentsGroup);
          // console.log("pastpending paymentsWithGrouping",GetDateDiff(start,new Date()));
          start = new Date();
          var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
            [m[0]]: m[1].reduce(function (accc, items) {
              return accc + items.Amount;
            }, 0)
          }))));
          console.log("pastpending paymentDict", GetDateDiff(start, new Date()));
          start = new Date();
          advancedata = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
          // console.log("pastpending advancedata",GetDateDiff(start,new Date()));
          start = new Date();
          var invoicesamount = advancedata ? advancedata.reduce(function (accumulator, item) {
            return accumulator + item.Amount;
          }, 0) : 0;
          // console.log("pastpending invoicesamount",GetDateDiff(start,new Date()));
          start = new Date();
          advances = advancedata.map(f => f.Id);
          // console.log("pastpending advances",GetDateDiff(start,new Date()));
          start = new Date();
          var paymentsamount = papaymnets ? papaymnets.filter(a => advances.indexOf(a.Id) > -1).reduce(function (accc, items) {
            return accc + items.Amount;
          }, 0) : 0;
          // console.log("pastpending advances",GetDateDiff(start,new Date()));
          start = new Date();
          var filtered = invoicesamount - paymentsamount;

          return filtered;
        }
        else {
          const paymnets = papaymnets;
          var paymentsGroup = groupBy(paymnets, "FeeId");
          var paymentsWithGrouping = Object.entries(paymentsGroup);

          var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
            [m[0]]: m[1].reduce(function (accc, items) {
              return accc + items.Amount;
            }, 0)
          }))));

          var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
          var peopleGroup = groupBy(dataConst.People, "Id");
          var typesGroup = groupBy(dataConst.Types, "Id");
          var facilitiesGroup = groupBy(dataConst.Centers, "Id");
          var data = [];
          amounts.forEach(function (a, k) {
            var obj = {};
            obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
            obj.MonthId = appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
            obj.Id = a.Id;
            obj.Kid = peopleGroup[a.BOSSId] && peopleGroup[a.BOSSId][0] ? peopleGroup[a.BOSSId][0].Name : "";
            obj.KidId = a.BOSSId;
            obj.Created = a.CDT;
            obj.From = a.FDT;
            obj.To = a.TDT;
            obj.Total = a.Amount;
            obj.Seva = a.SevaAmount;
            obj.Remarks = a.Remarks;
            // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
            obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
            obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
            obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
            data.push(obj);
          });

          if (isItKPI) {
            var invoicesamount = data ? data.reduce(function (accumulator, item) {
              return accumulator + (item.PendingAmt);
            }, 0) : 0;
            return invoicesamount;
          }


          return data;
        }
        break;
      case "leadspending":
      case "closedleadsdata":
      case "activeleadsdata":
      case "leadselsewhere":
      case "leadstoadmission":
      case "newleads":
      case "additionleads":
      case "admissionleads":
      case "joinedelsewhere":
      case "assessmentsleads":
      case "walkinleads":
      case "closedleadsnew":
      case "newleadsnew":
      case "pendingleads":
      case "activeleadsnew":
      case "activeleads":
      case "closedleads":
      case "totalleads":
      case "walkins":
      case "walkintoadmisssion":
      case "activewalkins":
      case "pendingwalkins":
      case "closedwalkins":
      case "walkincounselling":
      case "missedcalls":

        let leadsClosedSTatus = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
        var availLeads = [];
        //var startDate = new Date()
        var leadsGroups = dataConst && dataConst.LeadGroups && dataConst.LeadGroups.length > 0 ? dataConst.LeadGroups : dataConst && dataConst.Leads && dataConst.Leads.length > 0 ? Object.entries(groupBy(dataConst.Leads, "F17")) : [];
        var leadsData = dataConst && dataConst.GroupedLeads && dataConst.GroupedLeads.length > 0 ? dataConst.GroupedLeads : leadsGroups && leadsGroups.length ? leadsGroups.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))) : [];
        //var leadsData = leadsGroups && leadsGroups.length ? leadsGroups.map(m => m[1].sort((a, b) => (new Date(b.CDT) - new Date(a.CDT)))) : [];



        var curRoles = localStorage.getItem("UserRoles");
        var isUserBDC = curRoles && curRoles.indexOf("BDC") > -1;
        var currentUser = dataConst.CFUser;

        if (isUserBDC) {
          leadsData = leadsData.filter(f => parseInt(f[0].RId) == currentUser.Id || parseInt(f[0].AId) == currentUser.Id || parseInt(f[0].AId) == currentUser.AliasId || parseInt(f[0].RId) == currentUser.AliasId);
        }


        if (type.toLowerCase() == "leadspending" || type.toLowerCase() == "pendingleads") {

          return leadsData.filter(f => (!f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase())) && (!f[0].FDT || dateFromSDateTime(f[0].FDT) <= (TDT > new Date() ? new Date() : TDT)));
        }
        if (type.toLowerCase() == "newleads" || type.toLowerCase() == "additionleads" || type.toLowerCase() == "newleadsnew") {

          var newLeads = leadsData.filter(f => f[f.length - 1].CDT && new Date(f[f.length - 1].CDT) >= new Date(FDT) && new Date(f[f.length - 1].CDT) <= new Date(TDT));
          return newLeads;
        }
        else if (type.toLowerCase() == "closedleadsdata" || type.toLowerCase() == "closedleads" || type.toLowerCase() == "closedleadsnew") {
          var FleadsData = leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT) && (isUserBDC ? (f[0].AId == currentUser.Id || f[0].AId == currentUser.AliasId) && f[0].CenterId != 5 : true));
          // var userRole = GetTypeNameById(dataConst?.Types, dataConst?.CFUser?.RoleId);
          // if (userRole && userRole.toLowerCase() == "bdc") {
          //     var LeadsClarities = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "CLOSEDLEAD" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
          //     var pendingKids = LeadsClarities && LeadsClarities.length > 0 ? LeadsClarities.map(e => e.ForId) : [];
          //     FleadsData = leadsData.filter(f => pendingKids.indexOf(f[0].TOId) > -1)
          // }
          return FleadsData;
        }
        else if (type.toLowerCase() == "activeleadsdata" || type.toLowerCase() == "activeleadsnew" || type.toLowerCase() == "activeleads") {
          return leadsData.filter(f => !f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase()) && (isUserBDC ? (f[0].AId == currentUser.Id || f[0].AId == currentUser.AliasId) : true));
        }
        else if (type.toLowerCase() == "leadselsewhere" || type.toLowerCase() == "joinedelsewhere") {
          leadsClosedSTatus = ['ALREADY JOINED SOMEWHERE'];
          return leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
        }
        else if (type.toLowerCase() == "leadstoadmission" || type.toLowerCase() == "admissionleads") {
          leadsClosedSTatus = ["enrolled", "enroled"];
          var newLeadSData = leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toLowerCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
          var filteredleads = newLeadSData ? dataConst.People.map(e => e.Id) : []
          return newLeadSData.filter(e => filteredleads.includes(e[0].TOId));
        }
        else if (type.toLowerCase() == "walkins" || type.toLowerCase() == "walkinleads") {

          // var mobiles = dataConst.Leads.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.Status && f.Status.toLowerCase() == "walkin").map(m => m.F17);
          // return leadsGroups.filter(f => mobiles.indexOf(f[0]) > -1).map(m => m[1]);
          //startDate = new Date()
          var mobiles = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? (f.RId == currentUser.Id || f.AId == currentUser.Id || f.AId == currentUser.AliasId || f.RId == currentUser.AliasId) : true));
          //var mobiles = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? (f.RId == currentUser.Id || f.AId == currentUser.Id) : true));

          // console.log("Walkin T3 : "+GetDateDiff(startDate,new Date()))
          // startDate = new Date()
          var groupedData = groupBy(mobiles, 'F17');
          // console.log("Walkin T4: "+GetDateDiff(startDate,new Date()))
          // startDate = new Date()
          return leadsGroups.filter(f => groupedData[f[0]] && groupedData[f[0]].length > 0).map(m => m[1]);

        }
        else if (type.toLowerCase() == "totalleads") {
          var allLeads = [];
          var closedLeads = leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
          var activeLeads = leadsData.filter(f => !f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase()));
          allLeads.push(...closedLeads);
          allLeads.push(...activeLeads);

          return allLeads;///leadsData.filter(f => (f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase())) || (!f[0].Status || leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) == -1) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
        }
        else if (type.toLowerCase() == "walkintoadmisssion") {

          //var isUserBDC = userRoles && userRoles.filter(e=>e.toLowerCase() == "bdc") : [];
          leadsClosedSTatus = ["enrolled", "enroled"];
          var newLeadSData = leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toLowerCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
          var filteredleads = newLeadSData ? dataConst.People.map(e => e.Id) : [];
          var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.F1 && f.F1.toLowerCase() == "walkin");
          var groupByTOId = Object.keys(groupBy(filteredThisMonth, "TOId"));

          return newLeadSData.filter(e => filteredleads.includes(e[0].TOId) && groupByTOId.includes(e[0].TOId + ""));
        }
        else if (type.toLowerCase() == "activewalkins") {
          var allActiveLeads = leadsData.filter(f => !f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase()));
          // var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.F1 && f.F1.toLowerCase() == "walkin");
          var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? (f.RId == currentUser.Id || f.RId == currentUser.AliasId) : true));
          var groupByTOId = Object.keys(groupBy(filteredThisMonth, "TOId"));
          return allActiveLeads.filter(e => groupByTOId.includes(e[0].TOId + ""));
        }
        else if (type.toLowerCase() == "pendingwalkins") {
          var allActiveLeads = leadsData.filter(f => (!f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase())) && (!f[0].FDT || dateFromSDateTime(f[0].FDT) <= new Date()));

          var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? (f.RId == currentUser.Id || f.RId == currentUser.AliasId) : true));
          var groupByTOId = Object.keys(groupBy(filteredThisMonth, "TOId"));
          return allActiveLeads.filter(e => groupByTOId.includes(e[0].TOId + ""));
        }
        else if (type.toLowerCase() == "closedwalkins") {
          leadsClosedSTatus = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
          var allActiveLeads = leadsData.filter(f => f[0] && f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase()) && dateFromSDateTime(f[0].CDT) >= FDT && dateFromSDateTime(f[0].CDT) <= TDT);
          //var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.F1 && f.F1.toLowerCase() == "walkin");
          var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? (f.RId == currentUser.Id || f.RId == currentUser.AliasId) : true));
          var groupByTOId = Object.keys(groupBy(filteredThisMonth, "TOId"));
          var FleadsData = allActiveLeads.filter(e => groupByTOId.includes(e[0].TOId + ""));
          // var userRole = GetTypeNameById(dataConst?.Types, dataConst?.CFUser?.RoleId);
          // if (userRole && userRole.toLowerCase() == "bdc") {
          //     var LeadsClarities = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "CLOSEDWALKIN" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
          //     var pendingKids = LeadsClarities && LeadsClarities.length > 0 ? LeadsClarities.map(e => e.ForId) : [];
          //     FleadsData = leadsData.filter(f => pendingKids.indexOf(f[0].TOId) > -1)
          // }
          return FleadsData;
        }
        else if (type.toLowerCase() == "walkincounselling") {
          console.log("walkincounselling");
          var welcomeClarity = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "WALKIN" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
          var pendingKids = welcomeClarity && welcomeClarity.length > 0 ? welcomeClarity.map(e => e.ForId) : [];
          // var allActiveLeads = leadsData.filter(f => !f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase()));
          // var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? (f.RId == currentUser.Id || f.RId == currentUser.AliasId) : true));          
          // var mappedTOIds=filteredThisMonth && filteredThisMonth.length > 0 ? filteredThisMonth.map(e=>e.TOId):[];
          // const grouped = groupBy(dataConst.Leads,"TOId")


          // let result = [];
          // mappedTOIds.forEach(toid => {
          //     const records = (grouped[toid] || []).sort((a, b) => new Date(a.CDT) - new Date(b.CDT));
          //     const walkin = records.find(r => r.F1.toLowerCase() == "walkin" );
          //     if (!walkin) return;
          //     const later = records.find(r => new Date(r.CDT) > new Date(walkin.CDT) && (r.F1.toLowerCase() == "call" || r.F1.toLowerCase() =="followup" || leadsClosedSTatus.includes(r.Status.toUpperCase()) || r.Status == "NOT RESPONDING"));
          //     if (!later) {
          //         result.push(walkin);
          //     }
          // });
          // var groupByTOId = Object.keys(groupBy(result,"TOId"));
          return leadsData.filter(e => pendingKids.includes(e[0].TOId));
        }
        else if (type.toLowerCase() == "missedcalls") {
          var missedClarity = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "MISSEDCALL" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
          var pendingKids = missedClarity && missedClarity.length > 0 ? missedClarity.map(e => e.ForId) : [];

          var allActiveLeads = leadsData;
          // var result=[];
          // var allLeads= dataConst?.Leads.filter(r=>r.Status == "missed" && r.F5 == "incoming" && new Date(r.CDT) >= FDT && (r.F6 ? (r.F6+"").includes(currentUser.Handle) :true));
          // const grouped = dataConst.Leads.reduce((acc, lead) => {
          //     if (!acc[lead.TOId]) acc[lead.TOId] = [];
          //     acc[lead.TOId].push(lead);
          //     return acc;
          // }, {});
          // var leadIds= allLeads && allLeads.length > 0 ? allLeads.map(e=>e.TOId):[];
          // leadIds.forEach(toid => {
          //     const records = (grouped[toid] || []).sort((a, b) => new Date(a.CDT) - new Date(b.CDT));
          //     const missed = records.find(r => r.Status == "missed" && r.F5 == "incoming" && new Date(r.CDT) >= FDT );
          //     if (!missed) return;
          //     const later = records.find(r => new Date(r.CDT) > new Date(missed.CDT) && (r.F1.toLowerCase() == "call" || r.F1.toLowerCase() =="followup" || leadsClosedSTatus.includes(r.Status.toUpperCase())) );
          //     if (!later) {
          //         result.push(missed);
          //     }
          // });
          // var groupByTOId = Object.keys(groupBy(result,"TOId"));
          return allActiveLeads.filter(e => pendingKids.includes(e[0].TOId));
        }

        for (let i = 0; i < dataConst.Leads.length; ++i) {
          var leadObj = {};
          leadObj = dataConst.Leads[i];
          if (leadObj.F3) {
            var f3Index = leadObj.F3.indexOf("{");
            leadObj.F3 = leadObj.F3.slice(0, f3Index);
            availLeads.push(leadObj);
          }
          else {
            continue;
          }

        }
        var leads = Object.entries(groupBy(availLeads, "F3"));
        leads.filter(f => !f[1] || leadsClosedSTatus.indexOf(f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0].Status) == -1);

        return leads;
        break;
      case "welcomevalidation":
        console.log("welcomevalidation");
        var welcomeClarity = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "WELCOMECALL" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
        var currentUser = (dataConst.CFUser || null);
        const allFeeKidsDetail = currentUser ? (dataConst.FeeAll || []).filter(f => f.F18 && f.F18 == currentUser.Id && dateFromSDateTime(f.CDT) >= FDT).map(t => ({ BOSSId: t.BOSSId, CDT: t.CDT })) : [];
        const feeKidIds = allFeeKidsDetail.map(e => e.BOSSId).filter(onlyUnique);
        const peopleNotesDetail = (dataConst.PeopleNotes || []).filter(e => e.TOId && feeKidIds.indexOf(e.TOId) > -1 && e.Status && e.Status.toLowerCase() == 'connected').map(e => ({ TOId: e.TOId, CDT: e.CDT }));

        // var kidUniqData = {};
        // Object.entries(groupBy(peopleNotesDetail,"TOId")).forEach(e=>{
        //     const sortedRecord = e[1].sort((a,b)=> new Date(b.CDT) - new Date(a.CDT))[0];
        //     kidUniqData[sortedRecord.TOId] = sortedRecord.CDT;
        // })

        // const qualifiedBossIds = allFeeKidsDetail.filter(feeKid => {
        //     const kidCDT = kidUniqData[feeKid.BOSSId];
        //     if (!kidCDT) return true;
        //     return new Date(kidCDT) < new Date(feeKid.CDT);
        // }).map(feeKid => feeKid.BOSSId);

        var finalFilteredKids = (dataConst.People || []).filter(f => f.F8 != 1 && f.RS != "DELETEACTIVITY" && feeKidIds.indexOf(f.Id) > -1);
        //    var userRole = GetTypeNameById(dataConst?.Types, dataConst?.CFUser?.RoleId);
        //     if (userRole && userRole.toLowerCase() == "bdc") {
        //         var pendingKids =welcomeClarity && welcomeClarity.length > 0 ?welcomeClarity.map(e=>e.ForId) :[];
        //         var kids = filterKidsByUsers(dataConst?.CFUser, dataConst.AllKids)
        //         finalFilteredKids = finalFilteredKids.filter(r => kids && kids.indexOf(r.Id) > -1 && pendingKids.indexOf(r.Id) > -1);
        //     }
        return finalFilteredKids;
        break;
      case "bdcoverdue":
        console.log("bdcoverdue");
        // var curRoles = localStorage.getItem("UserRoles");
        // var isUserBDC = curRoles && curRoles.indexOf("BDC") > -1;
        var currentUser = dataConst.CFUser;
        var bossId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id;
        var cDate = new Date();

        var allFeeKids = (dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.F18 && f.F18 == currentUser.Id && f.Status != "PAID" && f.ETA < cDate) : []).map(t => t.BOSSId);

        var filteredKids = dataConst.People.filter(f => f.RoleId == bossId && f.F8 != 1 && f.RS != "DELETEACTIVITY" && allFeeKids.indexOf(f.Id) > -1);
        // var userRole = GetTypeNameById(dataConst?.Types, dataConst?.CFUser?.RoleId);
        // if (userRole && userRole.toLowerCase() == "bdc") {
        //     var kids = filterKidsByUsers(dataConst?.CFUser, dataConst.AllKids)
        //     filteredKids = filteredKids.filter(r => kids && kids.indexOf(r.Id) > -1);
        // }
        return filteredKids;
        break;
      case "assessmentpending":
        var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() != "completed" && dateFromSDateTime(m.CDT) >= FDT) : [];
        if (isItKPI) {
          return filteredasss;
        }

        break;
      case "assessmentcompleted":
        var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => m.Status && m.Status.toLowerCase() == "completed" && dateFromSDateTime(m.CDT) >= FDT) : [];
        if (isItKPI) {
          return filteredasss;
        }

        break;
      case "assessmentall":
        var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => dateFromSDateTime(m.CDT) >= FDT) : [];
        if (isItKPI) {
          return filteredasss;
        }

        break;
      case "leavespending":
        var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => (!m.Status || (m.Status == "Pending" || m.Status.toLowerCase() == "pending")) && m.F1 != "Parent" && m.RS != "DELETEACTIVITY") : [];
        //var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status != "APPROVED" && m.Status != "CANCELED" && m.F8 == "" && m.F1 != "Parent" && m.RS != "DELETEACTIVITY") : [];
        if (isItKPI) {
          return filtered;
        }
        break;
      case "leavesall":
        var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.F1 != "Parent" && m.RS != "DELETEACTIVITY") : [];
        if (isItKPI) {
          return filtered;
        }
        break;
      case "leavesapproved":
        var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status == "APPROVED" && m.F1 != "Parent" && m.RS != "DELETEACTIVITY") : [];
        if (isItKPI) {
          return filtered;
        }
        break;
      case "leavesunapproved":
        var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status == "UNAPPROVED" && m.F1 != "Parent" && m.RS != "DELETEACTIVITY") : [];
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestpending":

        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        // var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        // var responses = groupBy(analytics, "SRId");

        var analytics = groupBy(dataConst.ServiceRequestAnalytic, "SRId");
        var responses = Object.entries(analytics).reduce((acc, [key, values]) => {
          const reducedValue = values.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))
          acc[key] = reducedValue;

          return acc;
        }, {});

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });

        var service = serviceRequests ? serviceRequests.map(m => m.Id) : [];
        //const analticsdta = dataConst.ServiceRequestAnalytic ? dataConst.ServiceRequestAnalytic.filter(f => service.indexOf(f.SRId) > -1) : [];
        var filtered = srs.LastAnalytic ? srs.filter(m => m.LastAnalytic.Status != "CLOSED") : "";

        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestall":
        //var filtered = [];
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        //var empty = []
        var servicee = serviceRequests ? serviceRequests.map(m => m.Id) : [];
        var SRRO = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");

        var SRR = srs.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
        var SRW = srs.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "CLOSED" || m.LastAnalytic.Status == "UPDATED") && m.CBPI != m.LastAnalytic.CBPI)
        var SRIPdata = dataConst.ServiceRequestAnalytic ? dataConst.ServiceRequestAnalytic.filter(f => servicee.indexOf(f.SRId) > -1) : [];
        var SRIP = SRIPdata.filter(m => m.Status != "CLOSED");

        //empty.push(...SRRO, ...SRR, ...SRIP, ...SRW)
        var newdata = SRRO.concat(SRR, SRW)
        //var filtered = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
        var filtered = newdata;
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestactive":
        var filtered = [];

        //var filtered = aggregate.SRT + aggregate.SRW + aggregate.SRIP + aggregate.SRRO;
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestwaiting":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status != "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestclosedbyus":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestresolved":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        // dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT
        var filtered = srs.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestreopened":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN")
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestrating5":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.Rating == 5)
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestrating4":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.Rating == 4)
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestrating3":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.Rating == 3)
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestrating2":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.Rating == 2)
        if (isItKPI) {
          return filtered;
        }
        break;
      case "servicerequestrating1":
        var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        var filtered = srs.filter(m => m.Rating == 1)
        if (isItKPI) {
          return filtered;
        }
        break;
      case "chipending":
        dataConst.Types = dataConst.Types || [];
        var typeId = dataConst.Types.filter(m => m.Name == "CHI" && m.Category == "ASSESSMENT")[0].Id;
        var ids = dataConst.Responses ? dataConst.Responses.map(m => m.CenterNoteId) : [];
        return dataConst.CenterNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && m.TypeId == typeId && (!m.RS || m.RS != "DELETEACTIVITY"));
        break;
      case "whipending":
        dataConst.Types = dataConst.Types || [];
        var typeId = dataConst.Types.filter(m => m.Name == "WHI" && m.Category == "ASSESSMENT")[0].Id;
        var ids = dataConst.Responses ? dataConst.Responses.map(m => m.PeopleNoteId) : [];
        return dataConst.PeopleNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && ids.indexOf(m.Id) == -1 && m.TypeId == typeId);

        // return [];
        break;

      case "pisipending":
        dataConst.Types = dataConst.Types || [];
        var ids = dataConst.Responses ? dataConst.Responses.map(m => m.PeopleNoteId) : [];
        var typeId = dataConst.Types.filter(m => m.Name == "PISI" && m.Category == "ASSESSMENT")[0].Id
        return dataConst.PeopleNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && m.TypeId == typeId);

        // return [];
        break;

      case "therapiesprovided":
        return dataConst.Therapies;
        break;
      case "activeservices":
        if (TDT > new Date()) {
          // TDT = new Date();
          return dataConst.Therapies.filter(m => dateFromSDateTime(m.StartDate) <= new Date() && (!m.Status || (m.Status && m.Status.toLowerCase() != "inactive")))
        }
        TDT = TDT > new Date() ? new Date() : TDT;

        return dataConst.Therapies.filter(m => dateFromSDateTime(m.StartDate) <= TDT && ((m.UDT >= dateFromSDateTime(TDT) ? (m.Status && m.Status.toLowerCase() == "inactive") : false) || (!m.Status || m.Status && m.Status.toLowerCase() != "inactive")));
        break;

      case "pendingmilestones":

        var activeServices = dataConst.Therapies.filter(m => m.RS != "DELETEACTIVITY");
        var servicesGroup = groupBy(activeServices, "BossId");
        var bossIds = Object.keys(servicesGroup);

        var filteredPeople = dataConst.People.filter(f => bossIds.indexOf(f.Id + "") >= -1);
        //console.log(filteredPeople);
        var peopleGroup = groupBy(filteredPeople || [], "Id");
        //console.log(peopleGroup);

        var notAttendedKids = bossIds.filter(f => IsAllMileStoneQuestionsAnsweredForKPI(peopleGroup[f] ? peopleGroup[f][0] : null) == false);
        if (isItKPI) {
          return notAttendedKids.length;
        }

        var results = [];
        var centers = groupBy(dataConst.Centers, "Id");
        for (var i = 0; i < notAttendedKids.length; i++) {
          var kidId = notAttendedKids[i];

          var kid = peopleGroup[kidId] ? peopleGroup[kidId][0] : null;
          if (kid) {
            var obj = {};
            obj.Facility = centers[kid.CenterId] ? centers[kid.CenterId][0].Name : "";
            obj.Name = kid.Name;
            obj.Therapist = servicesGroup[kidId] ? servicesGroup[kidId].map(m => peopleGroup[m.TherapistId] ? peopleGroup[m.TherapistId][0].Name : "").join(",") : ""
            results.push(obj);
          }
        }

        return results;




        break;
      case "completedmilestones":

        var activeServices = dataConst.Therapies.filter(m => m.RS != "DELETEACTIVITY");
        var servicesGroup = groupBy(activeServices, "BossId");
        var bossIds = Object.keys(servicesGroup);

        var peopleGroup = groupBy(dataConst.People.filter(f => bossIds.indexOf(f.Id + "")) || [], "Id");
        var notAttendedKids = bossIds.filter(f => IsAllMileStoneQuestionsAnsweredForKPI(peopleGroup[f] ? peopleGroup[f][0] : null) == true);
        if (isItKPI) {
          return notAttendedKids.length;
        }

        var results = [];
        var centers = groupBy(dataConst.Centers, "Id");
        for (var i = 0; i < notAttendedKids.length; i++) {
          var kidId = notAttendedKids[i];

          var kid = peopleGroup[kidId] ? peopleGroup[kidId][0] : null;
          if (kid) {
            var obj = {};
            obj.Facility = centers[kid.CenterId] ? centers[kid.CenterId][0].Name : "";
            obj.Name = kid.Name;
            obj.Therapist = servicesGroup[kidId] ? servicesGroup[kidId].map(m => peopleGroup[m.TherapistId] ? peopleGroup[m.TherapistId][0].Name : "").join(",") : ""
            results.push(obj);
          }
        }

        return results;




        break;
      case "futureservices":

        TDT = TDT > new Date() ? new Date() : TDT;
        return dataConst.Therapies.filter(m => dateFromSDateTime(m.StartDate) > TDT && ((m.UDT >= dateFromSDateTime(TDT) ? (m.Status && m.Status.toLowerCase() == "inactive") : false) || (!m.Status || m.Status && m.Status.toLowerCase() != "inactive")));
        break;

      case "newservices":
        return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE")
        break;
      case "newservicesst":
        dataConst.Types = dataConst.Types || [];
        var typeId = dataConst.Types.filter(m => m.Name == "Speech Therapy" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
        return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
        break;
      case "newservicesbt":
        dataConst.Types = dataConst.Types || [];
        var typeId = dataConst.Types.filter(m => m.Name == "Behavioral Modification" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
        return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
        break;

      case "newservicesse":
        dataConst.Types = dataConst.Types || [];
        var typeId = dataConst.Types.filter(m => m.Name == "Special Education" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
        return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
        break;
      case "newservicesot":
        dataConst.Types = dataConst.Types || [];
        var typeId = dataConst.Types.filter(m => m.Name == "Occupational Therapy" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
        return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
        break;

      case "inactiveservices":
        var now = new Date();
        var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        var allinactivations = dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => dateFromSDateTime(t.F14) >= fromDate) : [];
        // var userRole = GetTypeNameById(dataConst?.Types,dataConst?.CFUser?.RoleId);
        // if (userRole && userRole.toLowerCase() == "bdc") {
        //     var kids = filterKidsByUsers(dataConst?.CFUser, dataConst.AllKids)
        //     allinactivations = allinactivations.filter(r => kids && kids.indexOf(r.BossId) > -1);
        // }
        return allinactivations;
        break;
      case "inactivecausepending":
        var now = new Date();
        var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        return dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => dateFromSDateTime(t.F14) >= fromDate && (!t.F23 || !t.F24)) : [];
        break;

      case "attendancepresent":
        return dataConst.Attendance && dataConst.Attendance.length > 0 ? dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == "present" && (!m.RS || m.RS != "DELETEACTIVITY") && dateFromSDateTime(m.ForDate) >= FDT && dateFromSDateTime(m.ForDate) <= TDT) : [];
        break;
      case "attendanceabsent":
        return dataConst.Attendance && dataConst.Attendance.length > 0 ? dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == "absent" && (!m.RS || m.RS != "DELETEACTIVITY") && dateFromSDateTime(m.ForDate) >= FDT && dateFromSDateTime(m.ForDate) <= TDT) : [];
        break;
      case "renewalclarityall":
      case "renewalclarityoverdue":
      case "renewalclaritytoday":
      case "renewalclaritytomorrow":
      case "renewalclaritythisweek":
      case "renewalclaritynextweek":
      case "renewalclaritythismonth":
      case "renewalclaritynextmonth":
      case "renewalclarityothers":
      case "renewalclaritypending":
      case "renewalclarityrenewed":
      case "renewalclaritytoberenewed":
      case "notrenewedrenewals":
        var curUser = dataConst.CFUser;
        var userRole = GetTypeNameById(dataConst.Types, curUser.RoleId);
        //(userRole && userRole.toLowerCase() == "bdc" ? (e.RId == curUser.Id || e.RId == curUser.AliasId) : true )
        var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.Category && e.Category.toLowerCase().indexOf("renewal") > -1 && (dateFromSDateTime(e.FDT) >= FDT && dateFromSDateTime(e.FDT) <= TDT))) : [];
        var inactivationType = allPinnacleClarity && allPinnacleClarity.length > 0 ? allPinnacleClarity[0].Category.replace("Renewals", "Inactivation") : "";
        var inactivations = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.Category && e.Category == inactivationType && e.Reply)) : [];
        inactivations = inactivations ? inactivations : [];
        var inactivationsByKid = groupBy(inactivations, "ForId");
        var todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        var tomorrowRC = new Date();
        tomorrowRC.setDate(tomorrowRC.getDate() + 1);
        var peopleGroup = groupBy(dataConst.People, "Id");
        var typesGroup = groupBy(dataConst.Types, "Id");
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");






        var data = [];

        var ncc = dataConst && dataConst.UserSettings ? dataConst.UserSettings.filter(f => f.Name == "NCC")[0] : null;
        var nccArray = [];
        try {
          nccArray = dataConst.IsUserOwner && ncc ? ncc.Value.split("{##}").map(m => ({ "Centers": m.split("{==}")[1], "Name": m.split("{==}")[3] })) : [];

        }
        catch (e) {
          nccArray = []
        }
        //var nccIds = ncc ? ncc.split("{==}") : [];


        var activetherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
        if (allPinnacleClarity) {
          var forIds = allPinnacleClarity.map(m => m.ForId + "");
          var dt = new Date();
          var usedCredits = dataConst && dataConst.FeeAll && dataConst.FeeAll.length > 0 ? dataConst.FeeAll.filter(f => dateFromSDateTime(f.FDT) <= dt && forIds.indexOf(f.BOSSId + "") > -1) : [];
          var usedCreditsOfBoss = groupBy(usedCredits, "BOSSId");
          allPinnacleClarity.forEach(function (a, k) {

            var obj = {};

            var priorReply = a.Reply ? a.Reply : a.NCCReply;
            var details = (a.F5 == "RENEWED" || a.F5 == "Renewed") ? "Renewed" : !a.Reply ? "Pending" : (dateFromSDateTime(a.Reply) <= 0 || dateFromSDateTime(a.Reply) == "Invalid Date") ? "Others" : dateFromSDateTime(priorReply) < todayDate ? "OverDue" : priorReply && dateFromSDateTime(priorReply) && (dateFromSDateTime(priorReply)).toDateString() == todayDate.toDateString() ? "Today" :
              (dateFromSDateTime(priorReply)).toDateString() == tomorrowRC.toDateString() ? "Tomorrow" :
                (dateFromSDateTime(priorReply) > getDateByType("thisweekstart") && dateFromSDateTime(priorReply) <= getDateByType("thisweekend")) ? "ThisWeek" :
                  dateFromSDateTime(priorReply) > getDateByType("thisweekend") && dateFromSDateTime(priorReply) <= getDateByType("nextweekend") ? "NextWeek" :
                    (dateFromSDateTime(priorReply)).getMonth() == todayDate.getMonth() ? "ThisMonth" :
                      (dateFromSDateTime(priorReply)).getMonth() == (todayDate.getMonth() + 1) ? "NextMonth" :
                        "Future";

            try {
              if (isItKPI) {
                obj.Details = details.toLowerCase();
              }
              else {


                var therapistName = "";
                var therapistNames = "";
                var nccCat = "";
                if (!isItKPI) {
                  var alltherapiesforkid = activetherapies.filter(e => e.BossId == a.ForId)
                  for (i = 0; i < alltherapiesforkid.length; i++) {
                    var names = dataConst.People.filter(e => e.Id && e.Id == alltherapiesforkid[i].TherapistId)[0]
                    therapistName += names.Id + "#" + names.Name + "{#}"
                    therapistNames += names.Name + ",";
                  }
                  try {
                    //nccCat = nccArray.filter(f => f.Centers.indexOf(a.CenterId) > -1)[0].Name;
                    nccCat = "";
                  }
                  catch (e) {
                    console.log(e);
                  }
                }
                var myRegExp = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/g;


                var noOfMonths = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? differenceInMonths(new Date(), dateFromSDateTime(peopleGroup[a.ForId][0].CDT)) : 0;



                obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                obj.FId = a.CenterId;
                if (a.Category.indexOf("Renewals") > -1) {
                  obj.Kid = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                  obj.KidId = a.ForId;
                  obj.ETAs = !a.Reply ? "Pending" : a.Reply && (a.Reply).match(myRegExp) ? (a.Reply).split(" ")[0] : "Other";
                  obj.ETA2 = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                  obj.ETA3 = a.NCCReply && a.NCCReply.trim() != "" ? a.NCCReply : "Pending";
                  //obj.Uneven = obj.Reply == obj.TherapistReply ? "No" : "Yes";
                  obj.Packs = a.F4;
                  obj.Therapist = therapistName ? therapistName : null;
                  obj.TherapistId = therapistNames ? therapistNames : "";
                  obj.DOJ = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? GetDateFormat(peopleGroup[a.ForId][0].CDT) : "";
                  obj.Fee = a.F2 ? a.F2 : a.Message.replace(obj.For + " ", "").replace(" Fee Clearing ETA ?", "");
                  obj.Offer = a.F1 ? a.F1 : 0;
                  obj.KIDO = peopleGroup[a.RId] && peopleGroup[a.RId][0] ? peopleGroup[a.RId][0].Name : "";
                  obj.Remarks = a.F5 ? a.F5 : "";
                  obj.Details = details.toLowerCase();
                  obj.Description = !a.Reply ? "Pending" : a.Reply && (a.Reply).match(myRegExp) ? (a.Reply).split(" ")[0] : a.Reply;

                }
                else {
                  obj.For = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                  obj.Message = a.Message;
                  obj.KidId = a.ForId;
                  obj.MobileId = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Handle : "";
                  obj.Details = details;
                  obj.getElementsByClassName = a.Reply && (a.Reply).match(myRegExp) ? (a.Reply).split(" ")[0] : "Other";

                  obj.TOId = a.UBPI;

                  obj.Reply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";


                  obj.Longitivity = noOfMonths == 0 ? "" : noOfMonths >= 12 ? "L" : noOfMonths >= 6 ? "M" : "S";

                  obj.AdminDiscontinueMarked = inactivationsByKid && inactivationsByKid[a.ForId] ? inactivationsByKid[a.ForId].filter(f => (f.Reply && f.Reply.toLowerCase().indexOf("continue empowerment") > -1))[0] ? "" : "Discontinue" : "N/A";
                  obj.TherapistDiscontinueMarked = inactivationsByKid && inactivationsByKid[a.ForId] ? inactivationsByKid[a.ForId].filter(f => (f.TherapistReply && f.TherapistReply.toLowerCase().indexOf("continue empowerment") > -1))[0] ? "" : "Discontinue" : "N/A";
                  obj.CreditsUsed = usedCreditsOfBoss && usedCreditsOfBoss[a.ForId + ""] ? usedCreditsOfBoss[a.ForId + ""].length : 0;

                }



                //obj.HBDT = a.HBDT;
                //obj.Category = nccCat;






                //obj.NCCReply = a.NCCReply && a.NCCReply.trim() != "" ? a.NCCReply : "Pending";
                // obj.UnevenNCC = obj.Reply == obj.TherapistReply == obj.NCCReply ? "No" : "Yes";
              }
              data.push(obj);
            }
            catch (e) {
              console.log(e);
            }
          });
        }

        var tobeRenewed = ["others", "renewed", "pending"];
        var pendingRenewed = ["renewed"];

        var AllFeeETA = data && data.length > 0 ? data.filter(e => (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "notrenewedrenewals" ? pendingRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity" + e.Details.toLowerCase() + "")) : [];
        //    if (isItKPI) {
        //        return AllFeeETA.length;
        //    }
        // var userRole = GetTypeNameById(dataConst?.Types, dataConst?.CFUser?.RoleId);
        if (userRole && userRole.toLowerCase() == "bdc") {
          // var RenewalClarities = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "RENEWALPENDING" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
          // var pendingKids = RenewalClarities && RenewalClarities.length > 0 ? RenewalClarities.map(e => e.ForId) : [];
          var kids = filterKidsByUsers(curUser, dataConst.AllKids)
          AllFeeETA = AllFeeETA.filter(r => kids && kids.indexOf(r.KidId) > -1);
        }


        return AllFeeETA;


        break;
      case "pollinationclaritypromised":
      case "pollinationclaritycompleted":
      case "pollinationclarityyetto":
      case "pollinationclarityzero":
      case "pollinationclaritylessthanthree":
      case "pollinationclaritygreaterthanthree":
      case "pollinationopty":

        var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY" && e.Category && ((e.Category.toLowerCase().indexOf("therapist pollination") > -1) || (e.Category.toLowerCase().indexOf("admin pollination") > -1))) && dateFromSDateTime(e.CDT) >= FDT && dateFromSDateTime(e.CDT) <= TDT) : [];

        var data = groupBy(allPinnacleClarity, 'ForId');
        var currentPeopleData = dataConst.People.filter(e => e.RS != "DELETEACTIVITY" && e.F8 != 1)
        var peopleGroup = groupBy(currentPeopleData, "Id");
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");
        var addedSessions = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && peopleGroup[f.BossId] && dateFromSDateTime(peopleGroup[f.BossId][0].CDT) < FDT) : [];
        addedSessions = addedSessions || [];
        var newelyAddeddSessionGroup = groupBy(addedSessions, 'TherapistId');
        var allOppertunities = [];
        Object.entries(data).forEach(function ([k, byGroupData]) {
          //  data.forEach(function (k, byGroupData) {
          var obj = {};

          // const reducer = (accumulator, curr) => accumulator + parseInt(curr.Reply);
          //var promise = (byGroupData.filter(m=> !isNaN(m.Reply)) || []).reduce(reducer);
          var tobeprocessed = byGroupData.filter(m => m.Reply && !isNaN(m.Reply));
          var promise = tobeprocessed && tobeprocessed.length > 0 ? tobeprocessed.reduce(function (accumulator, item) {
            return accumulator + parseInt(item.Reply);
          }, 0) : 0;

          obj.Facility = facilitiesGroup[byGroupData[0].CenterId] && facilitiesGroup[byGroupData[0].CenterId][0] ? facilitiesGroup[byGroupData[0].CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";

          obj.Therapist = peopleGroup[k] && peopleGroup[k][0].Name;
          obj.Discipline = peopleGroup[k] && peopleGroup[k][0].Designation;

          obj.ThrapistId = k;
          obj.Promise = parseInt(promise);
          obj.Completed = newelyAddeddSessionGroup[k] ? newelyAddeddSessionGroup[k].length : 0;
          obj.YetTo = obj.Promise - obj.Completed > 0 ? obj.Promise - obj.Completed : 0;

          obj.ShortName = GetShortDesignation(peopleGroup[k] && peopleGroup[k][0].Designation);
          obj.Opty = byGroupData[0].F2;
          obj.Count = type.toLowerCase() == "pollinationclaritypromised" ? parseInt(promise) :
            type.toLowerCase() == "pollinationclaritycompleted" ? obj.Completed :
              type.toLowerCase() == "pollinationclarityyetto" ? obj.YetTo :
                type.toLowerCase() == "pollinationclarityzero" ? promise == 0 ? 1 : 0 :
                  type.toLowerCase() == "pollinationopty" ? parseInt(obj.Opty) :
                    type.toLowerCase() == "pollinationoptyst" ? obj.ShortName == "ST" ? obj.Promise : 0 :
                      type.toLowerCase() == "pollinationoptyot" ? obj.ShortName == "OT" ? obj.Promise : 0 :
                        type.toLowerCase() == "pollinationoptyaba" ? obj.ShortName == "BT" ? obj.Promise : 0 :
                          type.toLowerCase() == "pollinationoptyse" ? obj.ShortName == "SE" ? obj.Promise : 0 :
                            type.toLowerCase() == "pollinationclaritylessthanthree" ? promise < 3 ? 1 : 0 :
                              type.toLowerCase() == "pollinationclaritygreaterthanthree" ? promise >= 3 ? 1 : 0 : 0
          allOppertunities.push(obj);
        });

        //    console.log("---ALL-CLARTIY--");
        //    console.log(type.toLowerCase());
        //    console.log(allOppertunities);

        var allcount = "Count"
        if (isItKPI) {
          var invoicesamount = allOppertunities ? allOppertunities.reduce(function (accumulator, item) {
            return accumulator + parseInt(item[allcount]);
          }, 0) : 0;
          return invoicesamount;
        }
        return allOppertunities;



        break;

      case "dueall":
      case "dueoverdue":
      case "duetoday":
      case "duetomorrow":
      case "duethisweek":
      case "duenextweek":
      case "duethismonth":
      case "duenextmonth":
      case "duefuture":

        var todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        //var bids = dataConst.Therapies.map(m => m.BossId);


        //var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => !f.ETA) : [];


        var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.ETA && f.ETA != null) : [];

        //var advances = advancedata ? advancedata.map(m => m.Id) : [];
        var groupedAdvance = groupBy(advancedata, "Id");

        var j1 = new Date();
        let feereciepts = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(e => groupedAdvance && (groupedAdvance[e.FeeId] || []).length > 0) : [];

        var j2 = new Date();
        console.log("T7");
        console.log(j2.getTime() - j1.getTime());

        var paymentsGroup = groupBy(feereciepts, "FeeId");

        var paymentsWithGrouping = Object.entries(paymentsGroup);

        var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
          [m[0]]: m[1].reduce(function (accc, items) {
            return accc + items.Amount;
          }, 0)
        }))));


        var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));

        var peopleGroup = groupBy(dataConst.People, "Id");
        var typesGroup = groupBy(dataConst.Types, "Id");
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");

        var data = [];
        amounts.forEach(function (a, k) {

          var obj = {};
          if (isItKPI) {
          }
          else {
            obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
            obj.MonthId = appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
            obj.Id = a.Id;
            obj.Kid = peopleGroup[a.BOSSId] && peopleGroup[a.BOSSId][0] ? capitalizeWords(peopleGroup[a.BOSSId][0].Name) : "";
            obj.KidId = a.BOSSId;
            obj.Created = a.CDT;
            obj.From = a.FDT;
            obj.To = a.TDT;
            obj.Total = a.Amount;
            obj.Seva = a.SevaAmount ? a.SevaAmount : 0;
            obj.On = a.ETA;
          }


          obj.ETA = !a.ETA ? null : dateFromSDateTime(a.ETA) < todayDate ? "OverDue" : (dateFromSDateTime(a.ETA)).toDateString() == todayDate.toDateString() ? "Today" :
            (dateFromSDateTime(a.ETA)).toDateString() == tomorrow.toDateString() ? "Tomorrow" :
              (dateFromSDateTime(a.ETA) > getDateByType("thisweekstart") && dateFromSDateTime(a.ETA) <= getDateByType("thisweekend")) ? "ThisWeek" :
                dateFromSDateTime(a.ETA) > getDateByType("thisweekend") && dateFromSDateTime(a.ETA) <= getDateByType("nextweekend") ? "NextWeek" :
                  (dateFromSDateTime(a.ETA)).getMonth() == todayDate.getMonth() ? "ThisMonth" :
                    (dateFromSDateTime(a.ETA)).getMonth() == (todayDate.getMonth() + 1) ? "NextMonth" :
                      "Future";
          // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";

          obj.Amount = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);


          if (!isItKPI) {
            obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
            obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
          }
          data.push(obj);
        });

        // return data;

        var amountField = "Amount";

        var AllFeeETA = data.filter(e => e.ETA && null != e.ETA && (type.toLowerCase() == "dueall" ? true : type.toLowerCase() == "due" + e.ETA.toLowerCase() + ""));
        //  if (isItKPI) {
        //     var invoicesamount = AllFeeETA ? AllFeeETA.reduce(function (accumulator, item) {
        //         return accumulator + (item[amountField]);
        //     }, 0) : 0;
        //     return invoicesamount;
        // }
        return AllFeeETA;

        if (type.toLowerCase() == "dueall") {
          var AllFeeETA = data.filter(e => e.ETA && null != e.ETA)
          if (isItKPI) {
            var invoicesamount = AllFeeETA ? AllFeeETA.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }

          return AllFeeETA
        }
        if (type.toLowerCase() == "dueoverdue") {
          var DueETA = data.filter(e => e.ETA && new Date(e.ETA) < todayDate);

          if (isItKPI) {
            var invoicesamount = DueETA ? DueETA.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }
          return DueETA
        }
        if (type.toLowerCase() == "duetoday") {
          var TodayETA = data.filter(e => e.ETA && (new Date(e.ETA)).toDateString() == todayDate.toDateString())

          if (isItKPI) {
            var invoicesamount = TodayETA ? TodayETA.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }
          return TodayETA
        }
        if (type.toLowerCase() == "duetomorrow") {
          let currentDate = todayDate;
          currentDate.setDate(currentDate.getDate() + 1);
          var TomorrowETA = data.filter(e => e.ETA && (new Date(e.ETA)).toDateString() == currentDate.toDateString());

          if (isItKPI) {
            var invoicesamount = TomorrowETA ? TomorrowETA.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }

          return TomorrowETA
        }

        if (type.toLowerCase() == "duethisweek") {
          var ThisWeek = data.filter(e => e.ETA && (new Date(e.ETA) > getDateByType("thisweekstart") && new Date(e.ETA) <= getDateByType("thisweekend")))
          if (isItKPI) {
            var invoicesamount = ThisWeek ? ThisWeek.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }


          return ThisWeek;
        }
        if (type.toLowerCase() == "duenextweek") {
          var NextWeeek = data.filter(e => e.ETA && new Date(e.ETA) > getDateByType("thisweekend") && new Date(e.ETA) > getDateByType("nextweekend"))

          if (isItKPI) {
            var invoicesamount = NextWeeek ? NextWeeek.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }
          return NextWeeek
        }
        if (type.toLowerCase() == "duethismonth") {
          var Thismonth = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() == todayDate.getMonth());
          if (isItKPI) {
            var invoicesamount = Thismonth ? Thismonth.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }
          return Thismonth;
        }
        if (type.toLowerCase() == "duenextmonth") {
          var NextMonth = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() == (todayDate.getMonth() + 1));
          if (isItKPI) {
            var invoicesamount = NextMonth ? NextMonth.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }
          return NextMonth;
        }
        if (type.toLowerCase() == "duefuture") {
          var FutureDues = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() > (todayDate.getMonth() + 1))
          if (isItKPI) {
            var invoicesamount = FutureDues ? FutureDues.reduce(function (accumulator, item) {
              return accumulator + (item[amountField]);
            }, 0) : 0;
            return invoicesamount;
          }
          return FutureDues;
        }
        //  if (type.toLowerCase() == "etapending") {
        //     var etapendigamount=data.filter(e=>!e.ETA)
        //     if (isItKPI) {
        //         var invoicesamount = etapendigamount ? etapendigamount.reduce(function (accumulator, item) {
        //             return accumulator + (item[amountField]);
        //         }, 0) : 0;
        //         return invoicesamount;
        //     }
        //     return etapendigamount;
        //  }


        break;


      case "compenstationcompleted":

        // var compoIds = dataConst.Compos.map(m => m.Id + "");
        var composGroup = groupBy(dataConst.Compos, "Id");
        var composGiven = dataConst.Attendance.filter(m => composGroup && (composGroup[m.F2] || []).length > 0);
        var composGivenGroup = groupBy(composGiven, "F2");

        return dataConst.Compos.filter(m => composGivenGroup && (composGivenGroup[m.Id + ""] || []).length > 0);
        // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
        break;
      case "compenstationfuture":
        var cdt = new Date();
        return dataConst.Compos.filter(m => m.ForDate && dateFromSDateTime(m.ForDate) > cdt && m.RS != "DELETEACTIVITY");

        // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
        break;
      case "compenstationtoday":
        var cdt = new Date();
        return dataConst.Compos.filter(m => m.ForDate && dateFromSDateTime(m.ForDate).toDateString() == cdt.toDateString() && m.RS != "DELETEACTIVITY");

        // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
        break;
      case "compenstationcanceled":

        return dataConst.Compos.filter(m => m.RS == "DELETEACTIVITY");

        // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
        break;

      case "compenstationorphan":
        var cdt = TDT > new Date() ? new Date() : TDT;
        var attendanceGroup = groupBy(dataConst.Attendance, "F2")
        //var compoids = dataConst.Attendance.filter(f => f.F2).map(m => m.F2);
        return dataConst.Compos.filter(m => dateFromSDateTime(m.ForDate) <= cdt && m.RS != "DELETEACTIVITY" && (attendanceGroup && (attendanceGroup[m.Id + ""] || []).length > 0));
        // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
        break;
      case "totalgoals":
        var totalgoaldata = dataConst.Goals ? dataConst.Goals : []
        return totalgoaldata
        break;

      case "activegoals":
        var goalsreview = dataConst.Goals ? dataConst.Goals.filter(m => m.Status != "REVIEWED") : []
        return goalsreview;
        break;
      case "todaypendinggoals":
        var goalDictionary = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? Object.fromEntries(dataConst.Goals.map(x => [x.TherapyId, x.CDT])) : null;
        var attendanceForGoals = goalDictionary != null && dataConst && dataConst.Attendance && dataConst.Attendance.length > 0 ? dataConst.Attendance.filter(m => m.Status == 'Present' && goalDictionary[m.ServiceId] && new Date(goalDictionary[m.ServiceId]) > new Date(m.ForDate)) : null;
        var attendanceDictionary = attendanceForGoals ? groupBy(attendanceForGoals, "ServiceId") : null;
        var allGoalsPending = attendanceDictionary && dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => attendanceDictionary[m.TherapyId] && m.Services == attendanceDictionary[m.TherapyId].length) : [];
        return allGoalsPending
        break;
      case "goalreviewed":
        var goalsreview = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && (!m.RS || m.RS != "DELETEACTIVITY" || m.RS != "DELETE") && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) < TDT) : []
        return goalsreview;
        break;

      case "activeleadsdataOLD":
        var leadsClosedStatusesforactive = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
        var availableLeads = [];
        for (let i = 0; i < dataConst.Leads.length; ++i) {
          var leadObj = {};
          leadObj = dataConst.Leads[i];
          if (leadObj.F3) {
            var f3Index = leadObj.F3.indexOf("{");
            leadObj.F3 = leadObj.F3.slice(0, f3Index);
            availableLeads.push(leadObj);
          }
          else {
            continue;
          }

        }
        var leads = Object.entries(groupBy(availableLeads, "F3"));
        var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
        var filteredData = resultleads.filter((k) => leadsClosedStatusesforactive.indexOf(k.Status) == -1);
        return filteredData;
        break;
      case "closedleadsdataOLD":
        let closedLeadsStatus = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
        var closedLeads = [];
        for (let i = 0; i < dataConst.Leads.length; ++i) {
          var leadObj = {};
          leadObj = dataConst.Leads[i];
          if (leadObj.F3) {
            var f3Index = leadObj.F3.indexOf("{");
            leadObj.F3 = leadObj.F3.slice(0, f3Index);
            closedLeads.push(leadObj);
          }
          else {
            continue;
          }

        }
        var leads = Object.entries(groupBy(closedLeads, "F3"));

        var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
        var filteredData = resultleads.filter((k) => closedLeadsStatus.indexOf(k.Status) > -1);
        return filteredData;

        break;
      case "leadselsewhereOLD":
        var closedLeads = [];
        for (let i = 0; i < dataConst.Leads.length; ++i) {
          var leadObj = {};
          leadObj = dataConst.Leads[i];
          if (leadObj.F3) {
            var f3Index = leadObj.F3.indexOf("{");
            leadObj.F3 = leadObj.F3.slice(0, f3Index);
            closedLeads.push(leadObj);
          }
          else {
            continue;
          }

        }
        var leads = Object.entries(groupBy(closedLeads, "F3"));

        var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
        var filteredData = resultleads.filter((k) => k.Status.toLowerCase() == "already joined somewhere");
        return filteredData;

        break;
      case "leadstoadmissionOLD":
        var LeadAdmission = ["enrolled", "enroled"];
        var closedLeads = [];
        for (let i = 0; i < dataConst.Leads.length; ++i) {
          var leadObj = {};
          leadObj = dataConst.Leads[i];
          if (leadObj.F3) {
            var f3Index = leadObj.F3.indexOf("{");
            leadObj.F3 = leadObj.F3.slice(0, f3Index);
            closedLeads.push(leadObj);
          }
          else {
            continue;
          }

        }
        var leads = Object.entries(groupBy(closedLeads, "F3"));

        var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
        var filteredData = resultleads.filter((k) => LeadAdmission.indexOf(k.Status.toLowerCase()) > -1);
        return filteredData;

        break;
      //case "goalontime":
      //    return []
      //    break;
      //case "goallate":
      //    return []
      //    break;
      case "goalmet":

        var met = dataConst.Goals ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && (!m.RS || m.RS != "DELETEACTIVITY" || m.RS != "DELETE") && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT && m.Review && m.Review.indexOf("F") == -1) : [];

        return met;
        break;
      case "goalnotmet":
        var notmet = dataConst.Goals ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && ((!m.RS || m.RS != "DELETEACTIVITY" || m.RS != "DELETE")) && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT && m.Review && m.Review.indexOf("F") > -1) : [];

        return notmet;
        break;
      case "conditionsstats":
        kidstate = dataConst && dataConst.KidStates && dataConst.KidStates.length > 0 ? dataConst.KidStates : [];
        if (kidstate) {
          kidstate.forEach(function (e) {
            e.Condition = e.Kid + "+" + e.TypeId + "+" + e.Category + ""
          });
        }

        var groupedKidstate = kidstate ? groupBy(kidstate, "Condition") : [];
        var firstRecords = Object.entries(groupedKidstate).map(m => m[1].sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0]);

        var conditionStates = groupBy(firstRecords || [], "Category");


        var categories = (dataConst.MirracleTypes || []).filter(f => f.Category == "MIRAVERSECONDITIONS");

        var allConditions = [];
        categories.forEach(function (e) {
          var obj = {};
          obj.Condition = e.Title;
          obj.Services = categories && categories[e.Id] ? categories[e.Id].length : 0;
          allConditions.push(obj);
        });

        allConditions.sort((a, b) => (b.Services - a.Services));


        break;
      case "kidconditionsandbehaviours":
      case "pendingconditions":
      case "pendingbehaviours":
        var kidstate = [];
        kidstate = dataConst && dataConst.KidStates && dataConst.KidStates.length > 0 ? dataConst.KidStates : [];



        if (kidstate) {
          kidstate.forEach(function (e) {
            e.Condition = e.Kid + "+" + e.TypeId + "+" + e.Category + ""
          });
        }






        var groupedKidstate = kidstate ? groupBy(kidstate, "Condition") : [];



        var firstRecords = Object.entries(groupedKidstate).map(m => m[1].sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0]);

        var cmaxScore = Math.ceil(((firstRecords.filter(f => f.Category == KidStateCategoryEnum.Condition).map(m => m.Score)).sort((a, b) => b - a)[0]) / 3);
        var bmaxScore = Math.ceil(((firstRecords.filter(f => f.Category == KidStateCategoryEnum.Tantrum).map(m => m.Score)).sort((a, b) => b - a)[0]) / 3);
        groupedKidstate = groupBy(firstRecords, "Condition");


        var allTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => (!e.RS || e.RS != "DELETEACTIVITY" || e.RS != "DELETE")) : []
        allTherapies.forEach(function (e) {
          try {
            e.Condition = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Condition] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Condition].length > 0 ? "Yes" : "NO";
            e.Tantrum = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Condition] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Tantrum].length > 0 ? "Yes" : "NO";
            e.ConditionScore = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Condition] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Condition].length > 0 ? groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Condition][0].Score : 0;
            e.TantrumScore = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Tantrum] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Tantrum].length > 0 ? groupedKidstate[e.BossId + "+" + e.TypeId + "+" + KidStateCategoryEnum.Tantrum][0].Score : 0;
            e.ConditionsRange = e.ConditionScore == 0 ? "Pending" : 0 < e.ConditionScore && e.ConditionScore <= cmaxScore ? "0 - " + cmaxScore : cmaxScore < e.ConditionScore && e.ConditionScore <= 2 * cmaxScore ? cmaxScore + " - " + 2 * (cmaxScore) : 2 * (cmaxScore) + " - " + 3 * (cmaxScore);
            e.BehavioursRange = e.TantrumScore == 0 ? "Pending" : 0 < e.TantrumScore && e.TantrumScore <= bmaxScore ? "0 - " + bmaxScore : bmaxScore < e.TantrumScore && e.TantrumScore <= 2 * bmaxScore ? bmaxScore + " - " + 2 * (bmaxScore) : 2 * (bmaxScore) + " - " + 3 * (bmaxScore);

          }
          catch (ex) {
            e.ConditionScore = 0;
            e.TantrumScore = 0;
            e.ConditionsRange = "Pending";
            e.BehavioursRange = "Pending";
          }
        });

        if (type && type.toLowerCase() == "pendingconditions") {
          // KidStateCategoryEnum.Condition
          allTherapies = allTherapies.filter(f => f.ConditionsRange == "Pending");
        }
        if (type && type.toLowerCase() == "pendingbehaviours") {
          // KidStateCategoryEnum.Condition
          allTherapies = allTherapies.filter(f => f.BehavioursRange == "Pending");
        }




        allTherapies.sort((a, b) => (b.ConditionScore - a.ConditionScore));

        //allTherapies =  allTherapies.filter(m=> m.Condition == "NO" || m.Tantrum == "NO");



        return allTherapies;
        break;
      case "pollinate":
        var services = dataConst.Therapies;
        var serviceIds = Object.entries(groupBy(dataConst.Therapies, "BossId"));

        var total = 0;
        for (var i = 0; i < servicesOfeering.length; i++) {
          var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1);
          total += (boss || []).length;
        }
        return total;

      case "pollinatedata":
      case "pollinationoptyst":
      case "pollinationoptyot":
      case "pollinationoptyaba":
      case "pollinationoptyse":
        var people = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter((e) => e.RS != "DELETEACTIVITY" && e.F8 != 1) : [];
        var therapiesAll = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter((e) => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
        therapiesAll = therapiesAll || [];
        people = people || [];
        var facilityTherapies = dataConst.FacilityTherapies || [];
        var facilityPeople = dataConst.FacilityPeople || [];
        people.push(...facilityPeople);
        therapiesAll.push(...facilityTherapies);

        //var fids = [];
        //if (!fids) {
        //    fids = dataConst.Centers.map(m => m.Id);
        //}


        var therapistRoleId = GetTypeIdByName(dataConst.Types, "Therapist");
        var therapists = Object.entries(groupBy(people.filter(f => therapistRoleId == f.RoleId), "Id")).map(m => m[1][0]);
        var therapies = therapiesAll ? therapiesAll : [];
        var kidsServices = groupBy(therapiesAll, "BossId");
        var serviceIds = Object.entries(kidsServices);

        var peopleGroup = groupBy(people, "Id");
        var centersGroup = groupBy(dataConst.Centers, "Id");

        var pollination = [];
        var sofferings = servicesOfeering;
        switch (type.toLowerCase()) {
          case "pollinationoptyst":
            sofferings = servicesOfeering.filter(f => f.ShortName == "ST");
            break;
          case "pollinationoptyot":
            sofferings = servicesOfeering.filter(f => f.ShortName == "OT");
            break;
          case "pollinationoptyaba":
            sofferings = servicesOfeering.filter(f => f.ShortName == "BT");
            break;
          case "pollinationoptyse":
            sofferings = servicesOfeering.filter(f => f.ShortName == "SE");
            break;
        }

        if (type && (type.toLowerCase() == "pollinationoptyst" || type.toLowerCase() == "pollinationoptyot" || type.toLowerCase() == "pollinationoptyaba" || type.toLowerCase() == "pollinationoptyse")) {

        }

        for (var i = 0; i < sofferings.length; i++) {
          var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(sofferings[i].Id) == -1).map(m => m[0]);
          boss = (boss || []);

          for (var b = 0; b < boss.length; b++) {
            var tids = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => peopleGroup && peopleGroup[m.TherapistId] && peopleGroup[m.TherapistId][0] ? peopleGroup[m.TherapistId][0].Name + "\n\n" : "\n\n") : [];
            //therapistName+= names.Id+"#"+names.Name+"{#}"

            var therapistNames = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => peopleGroup && peopleGroup[m.TherapistId] && peopleGroup[m.TherapistId][0] ? m.TherapistId + "#" + peopleGroup[m.TherapistId][0].Name + "\n\n" : "\n\n").join("{#}") : "";
            var removalIds = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => peopleGroup && peopleGroup[m.TherapistId] && peopleGroup[m.TherapistId][0] ? m.TherapistId + "#" : "").join("{#}") : "";

            var FId = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => m.CenterId)[0] : null;


            pollination.push({ BossId: boss[b], TOId: boss[b], ServiceId: sofferings[i].Id, RemovalId: removalIds, "KidName": (peopleGroup[boss[b]] && peopleGroup[boss[b]][0] ? peopleGroup[boss[b]][0].Name : ""), "Facility": (peopleGroup[boss[b]] && peopleGroup[boss[b]][0] && centersGroup[peopleGroup[boss[b]][0].CenterId] ? centersGroup[peopleGroup[boss[b]][0].CenterId][0].Name : ""), "Discipline": sofferings[i].ShortName, Therapist: therapistNames, FId: FId });
          }
        }




        return pollination;

      case "available":


        var therapists = dataConst.Therapists;
        therapists = therapists && therapists.length > 0 ? therapists.filter(e => (e.RS != "DELETEACTIVITY")) : therapists;

        var slots = getSlotsByData(dataConst.Therapies.filter(f => f.RS != "DELETEACTIVITY"), therapists);
        return slots;
        break;


      case "activestaff":
        var bossRoleId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id;
        var leadRoleId = dataConst.Types.filter(m => m.Name == "Lead")[0].Id;
        // f.RoleId == therapistId &&
        var filteredStaff = dataConst.People.filter(f => f.RoleId && f.RoleId != bossRoleId && f.RoleId != leadRoleId && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF" && f.RS != "DELETEACTIVITY" && f.F8 != 1);
        filteredStaff = Object.entries(groupBy(filteredStaff, "Id")).map(m => m[1][0]);
        return filteredStaff;
        break;
      case "activeparents":
        var pIds = dataConst.Therapies.map(m => m.BossId);
        var parentsTofilter = dataConst && dataConst.Parents ? dataConst.Parents : dataConst.People;
        var filteredParents = parentsTofilter.filter(p => pIds.indexOf(p.Id) > -1);
        var groupedParents = Object.entries(groupBy(filteredParents, "Handle"));
        var uniqParents = groupedParents.map(m => m[1][0]);
        return uniqParents;
        break;
      case "needpollination":
        var STNeed = dataConst && dataConst.Pollinations && dataConst.Pollinations.length > 0 ? dataConst.Pollinations.filter(e => e.S != "Y" && e.ST <= 799)?.map(e => ({ ...e, Type: "Speech Therapy" })) : [];
        var BTNeed = dataConst && dataConst.Pollinations && dataConst.Pollinations.length > 0 ? dataConst.Pollinations.filter(e => e.B != "Y" && e.BT <= 799)?.map(e => ({ ...e, Type: "Behavioural Therapy" })) : [];
        var OTNeed = dataConst && dataConst.Pollinations && dataConst.Pollinations.length > 0 ? dataConst.Pollinations.filter(e => e.O != "Y" && e.OT <= 799)?.map(e => ({ ...e, Type: "Occupational Therapy" })) : [];
        var SENeed = dataConst && dataConst.Pollinations && dataConst.Pollinations.length > 0 ? dataConst.Pollinations.filter(e => e.E != "Y" && e.SE <= 799)?.map(e => ({ ...e, Type: "Special Education" })) : [];

        var allpollins = [...STNeed, ...BTNeed, ...OTNeed, ...SENeed]
        // var userRole = GetTypeNameById(dataConst?.Types, dataConst?.CFUser?.RoleId);
        // if (userRole && userRole.toLowerCase() == "bdc") {
        //     var kids = filterKidsByUsers(dataConst?.CFUser, dataConst.AllKids)
        //     allpollins = allpollins.filter(r => kids && kids.indexOf(r.K) > -1);
        // }
        return allpollins;
        break;
      case "leftparents":
        var available = [];
        var now = new Date();
        var lastMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        var pIds = dataConst.InActive.filter(t => dateFromSDateTime(t.F14) >= new Date(lastMonthDate) && dateFromSDateTime(t.F14) <= TDT).map(m => m.BossId);
        var parentsTofilter = dataConst && dataConst.Parents ? dataConst.Parents : dataConst.People;
        var currentparents = parentsTofilter.filter(p => pIds.indexOf(p.Id) > -1 && p.RS != "DELETEACTIVITY" && p.F8 != 1);
        var serviceData = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => (e.RS == null || e.RS != "DELETEACTIVITY") && (!e.Status || e.Status != "INACTIVE")).map(k => k.BossId) : [];

        var filteredParents = currentparents && currentparents.length > 0 ? currentparents.filter(e => serviceData.indexOf(e.Id) == -1) : [];
        // var userRole = GetTypeNameById(dataConst.Types,dataConst?.CFUser?.RoleId);
        // if (userRole && userRole.toLowerCase() == "bdc") {
        //     var leftClarities = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "LOSTPARENTS" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
        //     var pendingKids = leftClarities && leftClarities.length > 0 ? leftClarities.map(e => e.ForId) : [];
        //    var kids = filterKidsByUsers(dataConst?.CFUser, dataConst.AllKids)
        //     filteredParents = filteredParents.filter(r => pendingKids.indexOf(r.Id) > -1);
        // }
        // for(var i=0;i<currentparents.length;i++){
        //     var serviceData=dataConst.Therapies.filter(e=>e.BossId==currentparents[i].Id && e.RS!="DELETEACTIVITY" && e.Status!="INACTIVE")
        //     if(serviceData.length<=0){
        //         available.push(currentparents[i])
        //     }
        // }
        //  return available;
        return filteredParents;
        break;
      case "addedparents":
        var bossId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id
        var filteredStaff = dataConst.People.filter(f => f.RoleId == bossId && f.F8 != 1 && f.RS != "DELETEACTIVITY");
        return filteredStaff.filter(p => p.CDT && dateFromSDateTime(p.CDT) >= FDT && dateFromSDateTime(p.CDT) <= TDT);
        break;
      case "upgrades":
        var bossId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id;
        var activeTherapies = dataConst?.Therapies.filter(r => r.RS != 'DELETEACTIVITY')?.map(e => e.BossId)
        var filteredKids = dataConst.People.filter(f => f.RoleId == bossId && f.F8 != 1 && f.RS != "DELETEACTIVITY" && activeTherapies.indexOf(f.Id) > -1 && parseInt(f.MCP) < 12);
        var userRole = GetTypeNameById(dataConst?.Types, dataConst?.CFUser?.RoleId);
        if (userRole && userRole.toLowerCase() == "bdc") {
          var kids = filterKidsByUsers(dataConst?.CFUser, dataConst.AllKids)
          filteredKids = filteredKids.filter(r => kids && kids.indexOf(r.Id) > -1);
        }
        return filteredKids;
        break;
      case "addedstaff":
        var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
        var filteredStaff = dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF");
        return filteredStaff.filter(f => f.CDT && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);
        break;
      case "leftstaff":
        var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
        var filteredStaff = dataConst.People.filter(f => f.RoleId == therapistId && f.F8 == 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF");
        return filteredStaff.filter(f => f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT);
        break;
      case "staffbots":
        var filteredStaff = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter(f => f.F22 && f.F22 == "BOT") : [];
        if (!filteredStaff || filteredStaff.length == 0) {
          return [];
        }
        var key = 'Handle';
        var arrayUniqueByKey = [...new Map(filteredStaff.map(item => [item[key], item])).values()];
        return arrayUniqueByKey;
        break;
      case "blockedstaff":
        var filteredStaff = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter(f => f.RS && f.RS == "DELETEACTIVITY" && f.F22 && f.F22 == "BLOCKED") : [];
        if (!filteredStaff || filteredStaff.length == 0) {
          return [];
        }
        var key = 'Handle';
        var arrayUniqueByKey = [...new Map(filteredStaff.map(item => [item[key], item])).values()];
        return arrayUniqueByKey;
        break;
      case "activememos":
        //return dataConst.Memos.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.Status != "CLOSED" && f.RS!="DELETEACTIVITY");
        return dataConst.Memos.filter(f => f.Status != "CLOSED" && f.RS != "DELETEACTIVITY");
        break;
      case "pendingmemos":
        return dataConst.Memos.filter(f => f.Status && f.Status != "CLOSED" && f.RS != "DELETEACTIVITY");
        //return dataConst.Memos.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.Status && f.Status != "CLOSED" && f.RS != "DELETEACTIVITY");
        break;
      case "closedmemos":
        return dataConst.Memos.filter(f => f.Status == "CLOSED" && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT && f.RS != "DELETEACTIVITY");
        break;


      case "viewpayslips":

        var typeId = GetTypeIdByName(dataConst.Types, "VIEWPAYSLIP")



        return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId) : [];


        break;
      case "downloadpayslips":
        var typeId = GetTypeIdByName(dataConst.Types, "DOWNLOADPAYSLIP")



        return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) : [];
        break;
      case "salary":

        var typeId = GetTypeIdByName(dataConst.Types, "PAYSLIP")



        return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.RS != "DELETEACTIVITY") : [];
        break;
      case "paid":
        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        var thismonth = dataConst.Fee.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation")).map(m => m.Id);
        return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId != typeId);
      case "paidseva":
        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        var thismonth = dataConst.Fee.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation")).map(m => m.Id);
        return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);

      case "advancepaid":
        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        //var thismonth = dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);
        var thismonth = dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);
        return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId != typeId);

      case "advancepaidseva":
        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        //var thismonth = dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
        var thismonth = dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
        var groupedData = groupBy(thismonth, "Id");
        return dataConst.FeeReceipt.filter(f => groupedData && groupedData[f.FeeId] && groupedData[f.FeeId].length > 0 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);

      case "pastpaid":
        var startDate = new Date();
        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        //var futuremonth = dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
        var futuremonth = dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
        var thismonth = dataConst.Fee.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation"));
        var combinedData = futuremonth.concat(thismonth);
        // var combinedData = [...futuremonth,...thismonth];
        var groupedData = groupBy(combinedData, "Id");
        var pastpaidData = dataConst.FeeReceipt.filter(f => f.TypeId != typeId && !groupedData[f.FeeId] && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);
        console.log("past paid this", GetDateDiff(startDate, new Date()))
        return pastpaidData;
      case "alreadyfulfilled":
        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        var oldInvoices = dataConst.Fee.filter(f => f.Type != "ASSESSMENTS" && (dateFromSDateTime(f.CDT) < FDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
        var groupedIds = groupBy(oldInvoices, "Id");
        return dataConst.FeeReceipt.filter(f => groupedIds && groupedIds[f.FeeId] && groupedIds[f.FeeId].length > 0 && dateFromSDateTime(f.CDT) < FDT && f.TypeId != typeId);

      case "tobefulfilled":
        var startDate = new Date()
        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        var allinvoices = dataConst.FeeAll.filter(f => f.Type != "ASSESSMENTS" && dateFromSDateTime(f.FDT) >= FDT);
        console.log("tobefulfilled", GetDateDiff(startDate, new Date()))
        return allinvoices;

      case "pastpaidseva":

        var typeId = GetTypeIdByName(dataConst.Types, "Seva")
        //var futuremonth = dataConst.FutureInvoices.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);
        var futuremonth = dataConst.FutureInvoicesCDTThisMonth;
        var thismonth = dataConst.Fee.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);
        var combinedData = futuremonth.concat(thismonth);
        //var combinedData = [...futuremonth,...thismonth];
        var groupedData = groupBy(combinedData, "Id");

        return dataConst.FeeReceipt.filter(f => (!groupedData[f.FeeId] || groupedData[f.FeeId].length == 0) && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);


      case "discount":
        return dataConst.FeeAll.filter(f => ((f.Remarks && f.Remarks.toLowerCase() == "system automation") ? (dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.FDT) <= TDT) : (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT)) && f.Discount > 0 && f.Remarks != "Renewal Offer" && f.Remarks != "PINNACLEGIFTVOUCHER");


      case "expenses":

        var typeId = dataConst.Types.find(f => f.Name.toLowerCase() == "expenses" && f.Category == "Activitytype").Id;



        return dataConst.CenterNotes ? dataConst.CenterNotes.filter(f => f.TypeId == typeId && dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.FDT) <= TDT && (!f.RS || f.RS != "DELETEACTIVITY")) : [];
        break;

      //feedbacksgiven
      case "feedbacksgiven":


        // return dataConst.Feedback ? dataConst.Feedback : [];

        // return dataConst.Feedback ? dataConst.Feedback : [];


        var fIds = (dataConst.Feedback || []).map(m => m.AttendanceId);
        //var therapies = (dataConst.Therapies).filter(f =>  f.RS != "DELETEACTIVITY"  && f.Status!="INACTIVE" && new Date(f.StartDate) <= new Date());
        //  var tIds = (therapies || []).map(m => m.Id);

        var attendanceData = dataConst.Attendance.filter(f => dateFromSDateTime(f.ForDate) >= FDT && dateFromSDateTime(f.ForDate) <= TDT && f.Status && f.Status.toLowerCase() == 'present' && fIds.indexOf(f.Id) > -1);
        var aids = attendanceData.map(t => t.Id);
        return (dataConst.Feedback || []).filter(t => aids.indexOf(t.AttendanceId) > -1);
        break;

      case "totalstaff":
        var staffdata = dataConst.People ? dataConst.People.filter((e) => e.RoleId != 28) : []
        return staffdata;
        break;
      case "biometricabsent":
        var biometricabsent = []
        return biometricabsent;
        break;
      case "biometricpresent":
        var biometricpresent = []
        //var biometricpresent = groupBy(dataConst.Biometric,new Date("FDT").getDate());
        //var present = groupBy(dataConst.Biometric,m=> new Date(m.FDT).getDate());
        //var biometricpresent = dataConst.Biometric.groupBy(m => new Date(m.FDT).Date + "#" + m.TOId).map(m => m.OrderByDescending(o => o.CDT)[0]);
        return biometricpresent;
        break;
      case "biometricentryearly":
        var biometricentryearly = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? new Date(m.FDT).getTime() < getTimeData(9, 30, 0, 0, m.FDT) : new Date(m.FDT).getTime() < getTimeData(8, 35, 0, 0, m.FDT)) : [];
        return biometricentryearly;
        break;
      case "biometricentryontime":
        var biometricentryontime = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? (new Date(m.FDT).getTime() >= getTimeData(9, 30, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= getTimeData(9, 35, 0, 0, m.FDT)) : (new Date(m.FDT).getTime() >= getTimeData(8, 30, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= getTimeData(8, 35, 0, 0, m.FDT))) : [];
        return biometricentryontime;
        break;
      case "biometricentrylate":
        var biometricentrylate = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? new Date(m.FDT).getTime() > getTimeData(9, 35, 0, 0, m.FDT) && new Date(m.FDT).getTime() < getTimeData(12, 0, 0, 0, m.FDT) : new Date(m.FDT).getTime() > getTimeData(8, 35, 0, 0, m.FDT)) : [];
        return biometricentrylate;
        break;
      case "biometricexitearly":
        var biometricexitearly = dataConst.Biometric ? dataConst.Biometric.filter(m => new Date(m.FDT).getTime() < getTimeData(19, 0, 0, 0, m.FDT)) : [];
        return biometricexitearly;
        break;
      case "biometricexitontime":
        var biometricexitontime = dataConst.Biometric ? dataConst.Biometric.filter(m => (new Date(m.FDT).getTime() >= getTimeData(19, 0, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= getTimeData(19, 5, 0, 0, m.FDT))) : [];
        return biometricexitontime;
        break;
      case "biometricexitlate":
        var biometricexits = dataConst.Biometric ? dataConst.Biometric.filter((m) => new Date(m.FDT).getTime() > getTimeData(19, 5, 0, 0, m.FDT)) : [];
        return biometricexits;
        break;

      case "feedbackratings":
        var allFeedbacks = dataConst.Feedback ? dataConst.Feedback : [];

        var totalRating = allFeedbacks.reduce(function (accumulator, item) {
          return accumulator + item.Rating;
        }, 0);
        return totalRating;
        break;

      case "servicerequests":
        var serviceRequests = dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest : [];
        var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
        var responses = groupBy(analytics, "SRId");

        var srs = serviceRequests.map(function (m) {
          return {
            ...m, "LastAnalytic"
              : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
          }
        });
        //})
        return srs;
        break;
      case "chilatest":
        var CHITypeId = dataConst.Types.filter(f => f.Name == "CHI")[0].Id;
        var allCHIData = dataConst.CenterNotes.filter(f => f.TypeId == CHITypeId && (!f.RS || f.RS != "DELETEACTIVITY"));
        var latestCHIDate = allCHIData && allCHIData.length > 0 ? allCHIData.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : null;
        var returnData = {};
        if (latestCHIDate) {
          var latestCHIDateValue = new Date(latestCHIDate);
          var startCHI = new Date(latestCHIDateValue.getFullYear(), latestCHIDateValue.getMonth(), 1);

          var allAssessments = allCHIData.filter(f => dateFromSDateTime(f.CDT) >= startCHI);
          returnData.Assessments = allAssessments;

          var assmids = allAssessments.map(m => m.Id);
          var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];
          if (allResposnese) {
            allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
              var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
              if (!result[key]) {
                result[key] = currentValue
              }
              return result;
            }, {})).map(m => m[1]);


          }

          allResposnese = allResposnese || [];
          returnData.Reponses = allResposnese;

        }

        return returnData;
        break;
      case "pisilatest":
        var PISITypeId = dataConst.Types.filter(f => f.Name == "PISI")[0].Id;
        var allCHIData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == PISITypeId) : [];
        var latestCHIDate = allCHIData.length > 0 ? allCHIData.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : [];

        var returnData = {};
        if (latestCHIDate) {
          var latestCHIDateValue = new Date(latestCHIDate);
          var startCHI = new Date(latestCHIDateValue.getFullYear(), latestCHIDateValue.getMonth(), 1);

          var allAssessments = allCHIData.filter(f => dateFromSDateTime(f.CDT) >= startCHI);
          returnData.Assessments = allAssessments;

          var assmids = allAssessments.map(m => m.Id);
          var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];
          if (allResposnese && allResposnese.length > 0) {
            allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
              var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
              if (!result[key]) {
                result[key] = currentValue
              }
              return result;
            }, {})).map(m => m[1]);


          }

          allResposnese = allResposnese || [];
          returnData.Reponses = allResposnese;

        }

        return returnData;
        break;
      case "whilatest":
        var WHITypeId = GetTypeIdByName(dataConst.Types, "WHI");//.filter(f => f.Name == "WHI")[0].Id;
        var allWHIData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == WHITypeId) : [];
        var latest = allWHIData && allWHIData.length > 0 ? allWHIData.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : null;

        var returnData = {};

        if (latest) {

          var latestDate = new Date(latest);
          var start = new Date(latestDate.getFullYear(), latestDate.getMonth(), 1);
          var allAssessments = allWHIData.filter(f => dateFromSDateTime(f.CDT) >= start);
          returnData.Assessments = allAssessments;

          var assmids = allAssessments.map(m => m.Id);
          var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];

          if (allResposnese) {
            allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
              var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
              if (!result[key]) {
                result[key] = currentValue
              }
              return result;
            }, {})).map(m => m[1]);



          }
          allResposnese = allResposnese || [];
          returnData.Reponses = allResposnese;
          var ranks = allResposnese.filter(f => f.Type == "RANK");
          var suggestions = allResposnese.filter(f => f.Type == "SUGGESTION");

          returnData.Suggestions = suggestions;

          //var peopleData = groupBy(dataConst.People, "Id");
          //var centers = groupBy(dataConst.Centers, "Id");
          var final = [];
          for (const [indexval, values] of Object.entries(groupBy(ranks, 'IQMId'))) {


            var ranks = Object.entries(groupBy(values, 'TOId')).map(function (m) { return { "Id": m[0], "TOId": m[0], "RDId": indexval, "Weightage": (m[1].reduce((partialSum, a) => partialSum + parseInt(a.Response), 0)) } });

            var length = ranks.length;


            var P10 = Math.ceil((length * 10.0 / 100));
            var M50 = Math.ceil((length * 50.0 / 100));
            var B90 = Math.ceil((length * 90.0 / 100));


            ranks = ranks.sort((a, b) => (a.Weightage > b.Weightage ? 1 : -1));


            var weightage = groupBy(ranks, "Weightage");
            var rank = 0;

            for (const [index, content] of Object.entries(weightage)) {
              rank++;
              content.forEach(function (a) {
                var rankTextId = rank <= P10 ? "top10" : rank <= M50 ? "top40" : rank <= B90 ? "bottom40" : "bottom10";
                a = { "Rank": rank, "RankTextId": rankTextId, ...a };

                final.push(a);
              });


            }


          }

          returnData.Ranks = final;
          // console.log("returnData.Ranks");
          //console.log(returnData.Ranks);



        }

        return returnData;


        break;

      case "leaverequestnonparentcompleted":
        var currentDate = new Date();
        const types1 = dataConst.Types ? dataConst.Types : [];
        var leaverequestId = GetTypeIdByName(types1, "LEAVEREQUEST");

        var allLeaves = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestId && f.RS != "DELETEACTIVITY" && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

        var completednpLeaves = allLeaves.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && dateFromSDateTime(m.FDT) <= currentDate && m.Status != "CANCELED");
        return completednpLeaves;
        break;
      case "leaverequestcomposlt4":
        var currentDate = new Date();
        const types2 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIds = GetTypeIdByName(types2, "LEAVEREQUEST");

        var allLeavesData = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIds && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

        var leaverequestcomposlt4 = allLeavesData.filter(m => m.F1 && (m.F1.toLowerCase() == "therapist" || m.F1.toLowerCase() == "adminfortherapist") && m.F2 && parseInt(m.F2) < 4);
        return leaverequestcomposlt4;
        break;
      case "leaverequestanalytic":
        var currentDate = new Date();
        const types3 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIdsforapproved = GetTypeIdByName(types3, "LEAVEREQUEST");

        var allLeavesData1 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIdsforapproved && f.RS != "DELETEACTIVITY" && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

        var approvedLeaves = allLeavesData1.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status && m.Status.toUpperCase() == "APPROVED");

        return approvedLeaves;
        break;
      case "leaverequestnonparentcanceled":
        var currentDate = new Date();
        const types4 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIdforCanceledleaves = GetTypeIdByName(types4, "LEAVEREQUEST");

        var allLeavesData2 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIdforCanceledleaves && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
        var cancellednpLeaved = allLeavesData2 ? allLeavesData2.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status == "CANCELED" && m.UDT && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT) : [];
        return cancellednpLeaved;
        break;
      case "leaverequestanalyticunapproved":
        var currentDate = new Date();
        const types5 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIdforCanceledleaves = GetTypeIdByName(types5, "LEAVEREQUEST");
        var allLeavesData3 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIdforCanceledleaves && f.RS != "DELETEACTIVITY" && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
        var unapprovedLeaves = allLeavesData3.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status && m.Status.toUpperCase() == "UNAPPROVED");
        return unapprovedLeaves;
        break;
      case "leavespendingapproval":
        var currentDate = new Date();
        const types10 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIdforPendingleaves = GetTypeIdByName(types10, "LEAVEREQUEST");
        var allLeavesData3 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIdforPendingleaves && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
        var pendingleaves = allLeavesData3.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && (!m.Status || m.Status == null || m.Status == '' || m.Status == 'Pending') && m.RS != "DELETEACTIVITY");
        return pendingleaves;
        break;
      //leavespendingapproval
      // var pendingLeaves = GetReportsData("leavespendingapproval", dataConst, true, fdt, tdt, facility);

      case "leaverequestnonparentfuture":
        var currentDate = new Date();
        const types6 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIdforCanceledleaves = GetTypeIdByName(types6, "LEAVEREQUEST");
        var allLeavesData4 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIdforCanceledleaves && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT)) && (!f.F1 || f.F1.toLowerCase() != "parent") && dateFromSDateTime(f.FDT) > currentDate && f.Status != "CANCELED" && f.RS != "DELETEACTIVITY") : [];
        //var futurenpLeaves = allLeavesData4.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && dateFromSDateTime(m.FDT) > currentDate && m.Status != "Cancelled");
        return allLeavesData4;
        break;
      case "leaverequestparentfuture":
        var currentDate = new Date();
        const types7 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIds = GetTypeIdByName(types7, "LEAVEREQUEST");
        var allLeavesData5 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIds && f.RS != "DELETEACTIVITY" && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
        var futurenpLeavesParent = allLeavesData5.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && dateFromSDateTime(m.FDT) > currentDate && m.Status != "CANCELED");
        return futurenpLeavesParent;
        break;
      case "leaverequestparentcompleted":
        var currentDate = new Date();
        const types8 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIds = GetTypeIdByName(types8, "LEAVEREQUEST");
        var allLeavesData6 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIds && f.RS != "DELETEACTIVITY" && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
        var completedParentleaves = allLeavesData6.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && dateFromSDateTime(m.FDT) <= currentDate && m.Status != "CANCELED");
        return completedParentleaves;
        break;
      case "leaverequestparentcanceled":
        var currentDate = new Date();
        const types9 = dataConst.Types ? dataConst.Types : [];
        var leaverequestIds = GetTypeIdByName(types9, "LEAVEREQUEST");
        var allLeavesData4 = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(f => f.TypeId == leaverequestIds && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
        var cancelledLeaved = allLeavesData4.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && m.Status == "CANCELED" && m.UDT && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT);
        return cancelledLeaved;
        break;
      case "awardswon":
        var awards = dataConst.Awards ? dataConst.Awards.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) : [];
        return awards;
        break;
      case "lockedaccounts":
        var adminId = GetTypeIdByName(dataConst.Types, "Receptionist")
        var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
        var caretakerId = GetTypeIdByName(dataConst.Types, "CareTaker")
        var accounts = dataConst.People ? dataConst.People.filter(e => ((e.F8 != 0 || e.F8 != null) || (e.RS != "ACTIVE" || e.RS != null)) && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId) && e.F17 && (e.F17).indexOf("SYSTEM INACTIVATED DUE TO CONSEQUITE LEAVES MORE THAN") > -1) : [];
        // var accounts=[];
        var key = 'Handle';
        var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
        return arrayUniqueByKey;
        break;
      case "unlockedaccounts":
        var adminId = GetTypeIdByName(dataConst.Types, "Receptionist")
        var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
        var caretakerId = GetTypeIdByName(dataConst.Types, "CareTaker")
        var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 == 0 || e.RS == "ACTIVE" && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId) && e.F17 && (e.F17).indexOf("SYSTEM ACTIVATED THE ACCOUNT FROM BIOMETRIC SYNC") > -1) : [];
        var key = 'Handle';
        var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
        return arrayUniqueByKey;
        break;
      case "staffutil":
        var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
        var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 != 1 && e.RS != "DELETEACTIVITY" && e.RoleId == TherapistId) : [];
        var key = 'Handle';
        var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
        return arrayUniqueByKey;
        break;
      case "birthdayreports":
        var adminId = GetTypeIdByName(dataConst.Types, "Receptionist")
        var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
        var caretakerId = GetTypeIdByName(dataConst.Types, "CareTaker")
        var ownerId = GetTypeIdByName(dataConst.Types, "Owner");
        var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 != 1 && e.RS != "DELETEACTIVITY" && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId || e.RoleId == ownerId) && (new Date(e.DOB).getMonth() == new Date(FDT).getMonth())) : [];
        return accounts;

        break;
      case "gracecompensation":
        var gracetypeId = dataConst.Types.filter(f => f.Name == "Grace Compensation Request" && f.Category == "Service Request")[0].Id;
        var servicerequestAnalytics = Object.entries(groupBy((dataConst.ServiceRequestAnalytic || []), "SRId")).map(m => m[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
        var allPeople = dataConst.People;
        var parentId = GetTypeIdByName(dataConst.Types, "Boss");
        var filterKids = allPeople && allPeople.length > 0 ? allPeople.filter(e => e.RoleId != parentId && (null == e.RS || e.RS != "DELETEACTIVITY")) : [];
        var kids = filterKids && filterKids.length > 0 ? filterKids.map(e => e.Id) : []; //NEED TO FIX STOPPEd FOR CF ERRORS
        var srData = groupBy((dataConst.ServiceRequestAnalytic || []), "SRId");
        // var requests = dataConst && dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(f => f.TypeId == gracetypeId && srData[f.Id] && srData[f.Id].Status == "CLOSED" && srData[f.Id].CBPI == f.CBPI && kids.indexOf(f.TOId) > -1 && (dateFromSDateTime(f.FDT) >= FDT) && (dateFromSDateTime(f.FDT) <= TDT) && srData[f.Id].Amount > 0) : [];
        var requests = dataConst && dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(f => f.TypeId == gracetypeId && (dateFromSDateTime(f.FDT) >= FDT) && (dateFromSDateTime(f.FDT) <= TDT)) : [];

        return requests;
        break;
      case "noprofileusers":
        var allPeople = dataConst.People;
        var leadId = GetTypeIdByName(dataConst.Types, "Lead");
        var parentId = GetTypeIdByName(dataConst.Types, "Boss");
        var filteredByPeople = allPeople.filter(e => e.RoleId != leadId && e.RoleId != parentId && e.RS != "DELETEACTIVITY" && e.F8 != 1);
        var filtereByProfile = filteredByPeople.filter(e => e.IsProfileSet != 1);
        return filtereByProfile;
        break;
      case "dangpendingtoday":
        var dangAnalyticTypeId = GetTypeIdByName(dataConst.Types, "DANGANALYTIC");
        var dangType = dataConst && dataConst.Types && dataConst.Types.length > 0 ? dataConst.Types.filter(e => e.Name == "DANG")[0] : '';

        var currentDang = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(f => f.TypeId == dangAnalyticTypeId && new Date(f.CDT) >= FDT && new Date(f.CDT) <= TDT) : [];
        var dtN = new Date();
        dtN.setHours(5);
        dtN.setMinutes(30);
        var todayDang = currentDang.filter(f => dateFromSDateTime(f.CDT).toDateString() == new Date().toDateString());
        var pendingorToday = CalculateDangPendingForToday(todayDang, dangType, new Date(), new Date(), facility, dataConst.People);
        return pendingorToday;
        break;
      case "allpendingcourses":
        var totalPending = 0;
        var totalTantrumsPending = 0;
        var totalConditionsPending = 0;
        var ptiPendingAssesmsnets = 0;
        var leaveApprovalPending = 0;

        var pendingObj = {};

        var allCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? dataConst.MirracleTypes.filter(function (e) { return (e.Category == "MIRAVERSETANTRUMS" || e.Category == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];
        var coursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(function (e) { return (e.AT == "MIRACOURSECOMPLETED") && e.RS != "DELETEACTIVITY" }) : [];
        totalPending = allCourses && allCourses.length > 0 ? allCourses.length : 0;
        if (totalPending > 0 && coursesCompleted && coursesCompleted.length > 0) {
          totalPending = totalPending - coursesCompleted.length;

        }
        if (allCourses) {
          var allTantrumsCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? dataConst.MirracleTypes.filter(function (e) { return (e.Category == "MIRAVERSETANTRUMS") && e.RS != "DELETEACTIVITY" }) : [];
          var tantrumcoursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(function (e) { return (e.Category == "MIRACOURSECOMPLETED" && e.F5 == "MIRAVERSETANTRUMS") && e.RS != "DELETEACTIVITY" }) : [];

          totalTantrumsPending = tantrumcoursesCompleted && tantrumcoursesCompleted.length > 0 ? allTantrumsCourses.length - tantrumcoursesCompleted.length : allTantrumsCourses.length;


          var allConditionCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? dataConst.MirracleTypes.filter(function (e) { return (e.Category == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];
          var conditioncoursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(function (e) { return (e.AT == "MIRACOURSECOMPLETED" && e.F5 == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];

          totalConditionsPending = conditioncoursesCompleted && conditioncoursesCompleted.length > 0 ? allConditionCourses.length - conditioncoursesCompleted.length : allConditionCourses.length;
        }
        pendingObj.totalPending = totalPending;
        pendingObj.totalTantrumsPending = totalTantrumsPending;
        pendingObj.totalConditionsPending = totalConditionsPending;
        pendingObj.ptiPendingAssesmsnets = ptiPendingAssesmsnets;
        pendingObj.leaveApprovalPending = leaveApprovalPending;

        return pendingObj;

        break;
      case "abilityscorerefreshpending":
        var data = [];
        var refreshClarity = dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(r => r.Remarks == "ABILITYSCORE" && !r.Reply && r.RId == dataConst?.CFUser?.Id) : [];
        var clarityKids = refreshClarity && refreshClarity.length > 0 ? refreshClarity.map(e => e.ForId) : [];
        var finalFilteredKids = (dataConst.People || []).filter(f => clarityKids.indexOf(f.Id) > -1);
        const abilityAssessment = (dataConst?.TherapeuticEipAssessments || []).filter(r => clarityKids.includes(r.KidId)).reduce((acc, curr) => {
          const existing = acc[curr.KidId];
          if (!existing || new Date(curr.CDT) > new Date(existing.CDT)) {
            acc[curr.KidId] = curr;
          }
          return acc;
        }, {});
        return Object.values(abilityAssessment);
        break;
      case "abilityscorerefresh":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        leadsDataForKPI.forEach(function (a, k) {
          const msPerDay = 1000 * 60 * 60 * 24;
          var noofWorkingDays = Math.ceil((new Date() - new Date(a.CDT)) / msPerDay)
          if (noofWorkingDays && noofWorkingDays > 31) {
            data.push(a)
          }
        });
        return data;

        break;

      case "abilityscoredeficit":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, F2, KidId }) => {
          if (F2 && 1000 - F2 > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - F2 });
            score += 1000 - F2;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;

        break;
      case "abilityscorescri":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, SCRI, KidId }) => {
          if (SCRI && 1000 - SCRI > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - SCRI });
            score += 1000 - SCRI;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;

        break;
      case "abilityscoressri":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, SSRI, KidId }) => {
          if (SSRI && 1000 - SSRI > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - SSRI });
            score += 1000 - SSRI;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;
        break;

      case "abilityscoremsri":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, MSRI, KidId }) => {
          if (MSRI && 1000 - MSRI > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - MSRI });
            score += 1000 - MSRI;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;
        break;

      case "abilityscorestri":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, STRI, KidId }) => {
          if (STRI && 1000 - STRI > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - STRI });
            score += 1000 - STRI;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;
        break;

      case "abilityscoreotri":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, OTRI, KidId }) => {
          if (OTRI && 1000 - OTRI > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - OTRI });
            score += 1000 - OTRI;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;
        break;

      case "abilityscorebtri":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, BTRI, KidId }) => {
          if (BTRI && 1000 - BTRI > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - BTRI });
            score += 1000 - BTRI;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;
        break;

      case "abilityscoreseri":
        var data = []
        var abilityAssessments = dataConst && dataConst.TherapeuticEipAssessments && dataConst.TherapeuticEipAssessments.length > 0 ? dataConst.TherapeuticEipAssessments : []
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY").map(e => e.BossId) : [];
        var filteredBossAssessments = abilityAssessments.filter(r => bossTherapies && bossTherapies.indexOf(r.KidId) > -1 && r.F2 > 0);
        var assessmentGroupBy = Object.entries(groupBy(filteredBossAssessments, "KidId"));
        var leadsDataForKPI = assessmentGroupBy && assessmentGroupBy.length > 0 ? assessmentGroupBy.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))[0]) : [];
        var score = 0;
        leadsDataForKPI.map(({ Id, SERI, KidId }) => {
          if (SERI && 1000 - SERI > 0) {
            data.push({ K: KidId, I: Id, S: 1000 - SERI });
            score += 1000 - SERI;
          }
        });
        var obj = {};
        obj.S = score
        obj.ids = data;
        return obj;
        break;

      case "renewaloffer":
        console.log("renewaloffer");
        var offers = dataConst && dataConst.Offers && dataConst.Offers.length > 0 ? dataConst.Offers.filter(e => new Date(e.FDT) <= new Date() && new Date(e.TDT) >= new Date()) : [];
        return offers && offers[0] && offers[0].F3 ? offers[0].F3 : 0;
        break;

      case "inclusiveleaders":
        var allData = dataConst && dataConst.HyperLocal && dataConst.HyperLocal.length > 0 ? dataConst.HyperLocal : []
        var pendingData = allData.filter(e => !(e.Awarded == 1) && e.RS != 'DELETEACTIVITY')
        return pendingData;
        break;

      case "bossachivements":

        var bossObj = {};
        var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY") : [];
        var bossGoals = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(e => e.RS != "DELETEACTIVITY") : [];
        var bossFeedBacks = dataConst && dataConst.Feedback && dataConst.Feedback.length > 0 ? dataConst.Feedback.filter(e => e.RS != "DELETEACTIVITY") : [];;
        bossObj.totalBossTherapies = bossTherapies.length;
        bossObj.totalBossGoals = bossGoals.length;
        bossObj.totalBossFeedback = bossFeedBacks.length;

        return bossObj;

        break;

      case "bosshomework":
        var attendanceData = dataConst.Attendance ? dataConst.Attendance.filter(r => r.TypeId != 238 && r.Status.toLowerCase() == "present") : []
        var feedbacksDataforboss = dataConst.Feedback && dataConst.Feedback.length > 0 ? dataConst.Feedback.filter(r => r.CBPI).map(e => e.AttendanceId) : []
        var combinedDatas = attendanceData.length > 0 && feedbacksDataforboss.length > 0 ? attendanceData.filter(e => feedbacksDataforboss && feedbacksDataforboss.indexOf(e.Id) < 0) : attendanceData;
        return combinedDatas;
        break;
      case "familynotaddedd":
        var currentTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(r => r.RS != "DELETEACTIVITY" && r.Status != "INACTIVE").map(e => e.BossId) : [];
        var peopleData = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter(t => currentTherapies.indexOf(t.Id) > -1 && !t.AltHandle) : [];
        var key = 'Handle';
        var arrayUniqueByKey = [...new Map(peopleData.map(item => [item[key], item])).values()];
        return arrayUniqueByKey;
        break;
      case "telegramnotlinked":
        var currentTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(r => r.RS != "DELETEACTIVITY" && r.Status != "INACTIVE").map(e => e.BossId) : [];
        var peopleData = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter(t => currentTherapies.indexOf(t.Id) > -1 && !t.TId) : [];
        var key = 'Handle';
        var arrayUniqueByKey = [...new Map(peopleData.map(item => [item[key], item])).values()];
        return arrayUniqueByKey;
        break;
      case "bosspendingfee":
        var pendingAmount = 0;
        var typeId = GetTypeIdByName(dataConst.Types, "Seva");
        var paymentsParent = dataConst && dataConst.Fee && dataConst.Fee.length > 0 ? dataConst.Fee.filter(t => t.ServiceId && t.ServiceId != null) : [];
        var mapids = paymentsParent ? paymentsParent.map(m => m.Id) : []
        var receiptpayment = dataConst && dataConst.FeeReceipt && dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => mapids.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];


        var invoiceamount = paymentsParent.reduce(function (accumulator, item) {
          return accumulator + item.Amount;
        }, 0);
        var paymentamount = receiptpayment ? receiptpayment.reduce(function (accc, items) {
          return accc + items.Amount;
        }, 0) : 0;
        pendingAmount = invoiceamount - paymentamount;

        return pendingAmount
        break;

      case "demographicaipending":
        var data = [];
        var DemographicNotes = groupBy(dataConst.DemoGraphicNotes, "DId");
        var AllDemographicsData = dataConst.DemoGraphics;
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");
        if (isItKPI) {
          return AllDemographicsData.filter(e => !DemographicNotes[e.Id]);
        }

        AllDemographicsData.forEach(function (a, k) {
          var obj = {};
          obj.Facility = facilitiesGroup[a.CenterId][0].Name
          obj.Category = a.Type ? a.Type : "";
          obj.Status = DemographicNotes[a.Id] && DemographicNotes[a.Id].length > 0 ? "COMPLETED" : "PENDING";
          data.push(obj)
        });

        return data;
        break;
      case "pinnacleclaritypending":
        var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY") && ((e.Roles && e.Roles.toLowerCase().indexOf(",therapist") > -1) ? (!e.Reply || !e.TherapistReply) : !e.Reply)) : [];
        if (isItKPI) {
          return allPinnacleClarity;
        }

        // allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity : [];


        var data = [];
        var facilitiesGroup = groupBy(dataConst.Centers, "Id");
        var peopleGroup = groupBy(dataConst.People, "Id");
        var activetherapies = dataConst.Therapies ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
        var dt = new Date();
        var futureCredits = dataConst.FeeAll.filter(f => f.Type == "services" && f.FDT == "9999-01-01 00:00:00");

        //var futureCredits = dataConst.FeeAll;


        var futureCreditsOfBoss = groupBy(futureCredits, "BOSSId");
        if (allPinnacleClarity) {

          var forIds = allPinnacleClarity.map(m => m.ForId + "");

          var usedCredits = dataConst.FeeAll.filter(f => f.Type == "services" && forIds.indexOf(f.BOSSId + "") > -1);


          var usedCreditsOfBoss = groupBy(usedCredits, "BOSSId");

          var groupedClarity = groupBy(allPinnacleClarity, "ForId");

          // console.log(groupedClarity);


          allPinnacleClarity.forEach(function (a, k) {
            var obj = {};

            if (a.Category.indexOf("Inactivation") > -1 && !isItKPI) {

              var numberOfTherapies = usedCreditsOfBoss && usedCreditsOfBoss[a.ForId] && usedCreditsOfBoss[a.ForId].length > 0 ? usedCreditsOfBoss[a.ForId].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? 1 : -1))[0].NoOfTherapies : 1;
              obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
              obj.Kid = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
              obj.AdminReply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";
              obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
              //futureCreditsOfBoss[a.ForId] && futureCreditsOfBoss[a.ForId].length > 0 ? futureCreditsOfBoss[a.ForId][0].NoOfTherapies
              //peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].F12  : 1;
              obj.Package = numberOfTherapies;
              obj.Credits = futureCreditsOfBoss[a.ForId] ? futureCreditsOfBoss[a.ForId].length : 0;
              obj.CDT = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].CDT : "";
              obj.Uneven = obj.TherapistReply == "Pending" || obj.AdminReply == "Pending" || obj.TherapistReply.split("-")[0].trim() == obj.AdminReply.split("-")[0].trim() ? "No" : "Yes";
              obj.KidId = a.ForId;
              obj.ServiceId = a.F2;
              obj.AllServices = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => e && e.Reply && e.Reply.toLowerCase() == "continue empowerment").length > 0 ? "Continue" : "Discontinue" : "Pending";

              try {
                var therapistId = activetherapies.filter(f => a.F2 + "" == f.Id + "")[0].TherapistId;
                // obj.For = (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                obj.Therapist = therapistId + "#" + (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
              }
              catch {

              }

              obj.Category = a.Category;
              obj.Reply = obj.TherapistReply == "Pending" || obj.AdminReply == "Pending" || obj.TherapistReply.split("-")[0].trim() == obj.AdminReply.split("-")[0].trim() ? obj.AdminReply : "Uneven";
            }
            else if (a.Category.indexOf("Pollination") > -1 && !isItKPI) {
              if (!data.filter(f => f.ForId == a.ForId)[0]) {
                obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                obj.Name = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                obj.ForId = a.ForId;
                obj.Category = a.Category;
                var filteredData1St = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => (e.Category == 'February Admin Pollination 2024' || e.Category == 'February Therapist Pollination 2024') && e.Message.indexOf("5th feb") > -1)[0] : '';
                var filteredData2nd = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => (e.Category == 'February Admin Pollination 2024' || e.Category == 'February Therapist Pollination 2024') && e.Message.indexOf("7th feb") > -1)[0] : '';
                obj["Total Pollination sessions"] = a.F2;
                obj["By 1st"] = filteredData1St && filteredData1St.Reply && filteredData1St.Reply.indexOf("0 - Others") == -1 ? filteredData1St.Reply : 0;
                obj["By 5th"] = filteredData2nd && filteredData2nd.Reply && filteredData2nd.Reply.indexOf("0 - Others") == -1 ? filteredData2nd.Reply : 0;
              }
            }
            else {
              var alltherapiesforkid = activetherapies.filter(e => e.BossId == a.ForId)
              var therapistName = ""
              var speechtherapy = ""
              var specialeducation = ""
              var behavioraltherapy = ""
              var occupationaltherapy = ""
              for (i = 0; i < alltherapiesforkid.length; i++) {

                var names = dataConst.People.filter(e => e.Id == alltherapiesforkid[i].TherapistId)[0]
                // if(names!=null &&alltherapiesforkid ){
                //     alltherapiesforkid.filter(e=>e.TherapistId == names.Id && )
                // }
                //  if(names!=null){
                //  therapistName+= names.Id+"#"+names.Name+"{#}"
                //  }

                //obj.Therapist=therapistName ? therapistName :null;
                if (names.Designation && names.Designation == "Occupational Therapist") {
                  occupationaltherapy += names.Id + "#" + names.Name + "{#}";
                } else if (names.Designation && names.Designation == "Behavioural Therapist") {
                  behavioraltherapy += names.Id + "#" + names.Name + "{#}";
                }
                else if (names.Designation && names.Designation == "Speech Therapist") {
                  speechtherapy += names.Id + "#" + names.Name + "{#}";
                }
                else if (names.Designation && names.Designation == "Special Educator ") {
                  specialeducation += names.Id + "#" + names.Name + "{#}";
                }

              }

              obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
              obj.For = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
              obj.HBDT = a.HBDT;
              obj.Category = a.Category;
              obj.Message = a.Message;
              obj.KidId = a.ForId;

              if (a.Category.indexOf("Fee Pending") > -1 || a.Category.indexOf("Renewals") > -1) {



                obj.OT = occupationaltherapy ? occupationaltherapy : null;

                obj.BT = behavioraltherapy ? behavioraltherapy : null;

                obj.ST = speechtherapy ? speechtherapy : null;

                obj.SE = specialeducation ? specialeducation : null;

              }
              obj.Remarks = a.F5;
              obj.TOId = a.UBPI;

              obj.Reply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";
              if (a.Category.indexOf("Inactivation") > -1 && !isItKPI) {
                obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                obj.Uneven = obj.TherapistReply == "Pending" || obj.Reply == "Pending" || a.TherapistReply == a.Reply ? "" : "Uneven";
                try {
                  var therapistId = activetherapies.filter(f => a.F2 + "" == f.Id + "")[0].TherapistId;
                  obj.For = (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                  obj.Therapist = therapistId + "#" + (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                }
                catch {

                }

              }
              if (a.Category.indexOf("Renewals") > -1 && !isItKPI) {
                obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                obj.Uneven = obj.Reply == obj.TherapistReply ? "No" : "Yes";
                obj["Offer Amount"] = a.F1;
                obj.Package = a.F4;
              }

              obj.Amount = a.F2 ? a.F2 : a.Message.replace(obj.For + " ", "").replace(" Fee Clearing ETA ?", "");
            }
            data.push(obj);
          });
        }

        return data;

        break;

      default:
        return [];
        break;


    }
  } catch (e) {
    console.log("EXCEPTION IN REPORTS FOR: " + type + " isItKPI: " + isItKPI + "  FDT: " + FDT + " TDT: " + TDT);
    console.log(e);

    SaveCleintWaufli(e, "Client Reports Failed", " GetReportsData " + type);
    return [];
  }
}
export function GetDateDiff(date1, date2) {
  return date2.getTime() - date1.getTime();
}


export var fixedExpenses = [
  "rent",
  "internet",
  "internet charges",
  "establishment",
  "maintenance"

];

export var benefitExpenses = [
  "team out"

];


export var incentiveExpenses = [
  "incentives"


];
function CalculateDangPendingForToday(list, config, from, to, fids, people) {
  list = (list || []);
  var facilititesLength = ((fids || []).length);
  var startDate = new Date(2022, 9, 12);
  from = from <= startDate ? startDate : from;
  var currentDateTime = new Date();
  var currentCDT = new Date();
  currentCDT.setDate(currentCDT.getDate() + 1)
  var toDate = currentDateTime.getDate() <= to ? currentCDT : to;
  to = currentDateTime.getDate() <= to ? currentDateTime : to;

  var noofWorkingDays = Math.ceil(GetTotalWorkingDays(from, toDate));

  var stringArray = config && config.Description && config.Description.includes("{=}") ? config.Description.split("{=}") : [];
  var timespanList = [];
  if (stringArray.length > 0) {
    for (let i = 0; i < stringArray.length; ++i) {
      var val = stringArray[i].split("{#}")[0];
      timespanList.push(val);
    }
  }
  //var total = noofWorkingDays * timespanList.length;

  var mappedPeople = list && list.length > 0 ? list.map(e => e.CBPI) : [];

  list.forEach(function (e) {
    var filterByDang = people && people.length > 0 ? people.filter(k => k.Id == e.CBPI)[0] : '';
    e.CenterId = filterByDang && filterByDang.CenterId ? filterByDang.CenterId : 0;
  });

  // var filterPeople = people && people.length > 0 ? people.filter(e=>mappedPeople.indexOf(e.CBPI) > -1) : [];

  // var mappedCenters = filterPeople && filterPeople.length > 0 ? filterPeople.map(e=>e.CenterId):[];

  // var filterFacilities = fids && fids.length > 0 ? fids.filter(e=>mappedCenters.indexOf(e.Id)==-1) : [];

  var returnObj = [];
  for (var i = 0; i < fids.length; ++i) {
    var fac = fids[i];
    for (var j = 0; j < timespanList.length; ++j) {
      var currTime = timespanList[j];
      var listFilter = list && list.length > 0 ? list.filter(e => e.CenterId == fac.Id && currTime == e.F1)[0] : '';
      if (!listFilter) {
        var obj = {};
        obj.Facility = fac.Name;
        obj.Time = currTime;
        obj.FId = fac.Id;
        returnObj.push(obj);
      }
    }
  }
  return returnObj;
}
function CalculateDangPendingCount(list, config, from, to, fids) {
  list = (list || []);
  var facilititesLength = ((fids || []).length);
  var startDate = new Date(2022, 9, 12);
  from = from <= startDate ? startDate : from;
  var currentDateTime = new Date();
  var currentCDT = new Date();
  currentCDT.setDate(currentCDT.getDate() + 1)
  var toDate = currentDateTime.getDate() <= to ? currentCDT : to;
  to = currentDateTime.getDate() <= to ? currentDateTime : to;

  var noofWorkingDays = Math.ceil(GetTotalWorkingDays(from, toDate));

  var stringArray = config && config.F1 && config.F1.includes("{=}") ? config.F1.split("{=}") : [];
  var timespanList = [];
  if (stringArray.length > 0) {
    for (let i = 0; i < stringArray.length; ++i) {
      var val = stringArray[i].split("{#}")[0];
      timespanList.push(GetTimeSlotTotal(val));
    }
  }

  var total = noofWorkingDays * timespanList.length;
  if (currentDateTime.getDate() == to.getDate()) {
    var currentHoursMins = currentDateTime.getHours() * 60 + currentDateTime.getMinutes();
    total += timespanList.filter(m => currentHoursMins >= m).length;
  }
  var totalPendings = (facilititesLength * total) - list.length;
  return totalPendings > 0 ? totalPendings : 0;

}

var dangConfig = {
  "F1": "8:30{#}Biometric Punch-In,  Supervise Readiness: Cleaning, Hygiene, Ambience, Organize, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync{=}9:00{#}Supervise Readiness: Ambience, Organize Reception, Therapy Rooms, Playzone, Pantry. Clear Pending: Goals, Attendance, Fee, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync{=}9:30{#}Staff Check-In, Biometric Sync, Staff Leaves, Handle unapproved leaves, Compensations. Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Clear Pending: Goals, Attendance, Fee, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync,  Parents 1:1{=}10:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize, Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync,  Parents 1:1{=}11:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}12:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}13:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}14:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}15:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}16:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}16:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}17:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}17:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}18:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}18:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1",
  "F2": "LEP,AP,GP,TGNS,PP,KUM,SETP",
  "F7": 15,
  "S": "ADMINISTRATOR"
}


export function SumOfAllAggregates(aggreagates) {
  var aggregate = {};
  aggreagates.forEach(function (v, k) {
    // var facilityName = (allfacilities, function (e) { return e.Id == v.GID })[0];
    // v["FACSFT"] = facilityName && facilityName.SFT > 0 ? facilityName.SFT : 0;
    var business = (v.PP + v.PPE + v.PA + v.APEN);
    v["BUSINESS"] = business;
    var keys = Object.keys(v);
    // console.log(keys);

    v["PROFIT"] = business - (v.E + v.TS);
    //v["FACILITY"] = facilityName ? facilityName.N : "";



    //v["COSTPEREXPENSE"] = facilityName && facilityName.SFT > 0 ? (v.E + v.TS) / facilityName.SFT : 0;
    //v["COSTPEREARNING"] = facilityName && facilityName.SFT > 0 ? (v.PP + v.PPE + v.PA + v.APEN) / facilityName.SFT : 0;

    //v["EXPENSEPERPERSON"] =
    //console.log(keys);
    keys.forEach((key, index) => {

      if (key == "WD" || key == "PROLM" || key == "PROLY" || key == "PTILY" || key == "PTILM") {
        aggregate[key] = v[key];
      }
      else {
        if (!aggregate.hasOwnProperty(key)) {
          if (key == "L") {
            aggregate[key] = [];
          }
          else if (key == "CDT" || key == "UDT" || key == "FDT" || key == "TDT") {
            aggregate[key] = new Date();
          }
          else {
            aggregate[key] = 0;
          }
        }
        if (typeof v[key] == "object") {

          if (v[key] && v[key].length > 0) {
            Array.prototype.push.apply(aggregate[key], v[key]);
          }
        }
        else if (key == "CDT" || key == "UDT" || key == "FDT" || key == "TDT") {
          aggregate[key] = v[key];
        }
        else if (typeof v[key] != "string") {
          aggregate[key] = aggregate[key] + v[key];
        }
      }
    });
  });

  return aggregate;
}

export function GetLocalStorageDetailsFor() {
  var lsd = localStorage.getItem("LastPSSyncDataTime");
  var configJsonString = localStorage.getItem("UserSettings");
  var UserData = localStorage.getItem("UserData");

  UserData = UserData ? JSON.parse(UserData) : null;


  return {
    LSD: lsd,
    Config: configJsonString,
    UserData: UserData
  };

}

function GetPrepData(role, data, fromDate, toDate, fids, $this) {
  var todayDate = new Date();

  var fdt = fromDate ? fromDate : new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
  var tdt = toDate ? toDate : new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0, 23, 59, 59);
  var FDT = fdt;
  var TDT = tdt;
  var logs = [];
  var inittialStart = new Date();
  var startDate = new Date();
  var incentiveIds = [2413, 2412, 2411, 2410, 2409, 2408, 2407, 2406, 2405];
  var fsIds = fids.map(m => m + "");

  const totalworkingdays = GetTotalWorkingDays(FDT, TDT);
  const therapies = data.Therapies ? data.Therapies.filter(f => fids.indexOf(f.CenterId) > -1 && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE" && ($this.IsUserTherapist && role != "Senior" ? data.CFUser.Id == f.TherapistId : true)) : [];
  var pinnacleClarities = data.PinnacleClarity ? data.PinnacleClarity.filter(f => (fids.indexOf(f.CenterId) > -1 || f.Category == "AAA" || f.ForId == data.CFUser.Id) && f.RS != "DELETEACTIVITY") : [];

  if (role && role.toLowerCase() == "bdc") {
    pinnacleClarities = pinnacleClarities.filter(e => (e.Roles.indexOf("BDC") > -1 && (e.RId == data.CFUser.Id || e.ForId == data.CFUser.Id)) || e.Category.indexOf("Renewals") > -1)
  }


  var therapyIds = therapies ? therapies.map(m => m.Id) : [];
  const goals = data.Goals ? data.Goals.filter(f => therapyIds.indexOf(f.TherapyId) > -1) : [];
  const types = data.Types ? data.Types : [];
  const usersettings = data.UserSettings;

  const holidays = GetHolidaysList();

  var people = (data.People || []).filter(f => fids.indexOf(f.CenterId) > -1 && ($this.IsUserTherapist && role != "Senior" ? data.CFUser.Id == f.Id : true));
  //For BDC we have to consider all centers otherwise pending not matched
  //var leads = (data.Leads || []).filter(f => (role && role.toLowerCase() == "bdc") ? true : fids.indexOf(f.CenterId) > -1);

  var leads = (data.Leads || []).filter(f => {
    // BDC role gets all, others filtered by CenterId
    const centerCheck = (role && role.toLowerCase() === "bdc") ? true : fids.indexOf(f.CenterId) > -1;

    // Exclude 'call' + 'outgoing'
    const isCallOutgoing = typeof f.F1 === 'string' && typeof f.F5 === 'string' &&
      f.F1.toLowerCase() === 'call' && f.F5.toLowerCase() === 'outgoing';

    return centerCheck && !isCallOutgoing;
  });

  var gfId = $("#insightsFacility").val();
  if (gfId && gfId != "") {
    //leads = (data.Leads || []).filter(f => fids.indexOf(f.CenterId) > -1);

    leads = (data.Leads || []).filter(f => {
      const centerCheck = fids.indexOf(f.CenterId) > -1;
      const isCallOutgoing =
        typeof f.F1 === 'string' &&
        typeof f.F5 === 'string' &&
        f.F1.toLowerCase() === 'call' &&
        f.F5.toLowerCase() === 'outgoing';
      return centerCheck && !isCallOutgoing;
    });

  }
  people = people || [];
  var pIds = people.map(m => m.Id);
  const allPeopleNotes = data.PeopleNotes ? data.PeopleNotes.filter(f => pIds.indexOf(f.TOId) > -1 && (!f.RS || f.RS != "DELETEACTIVITY")) : [];
  data.Mirracles = (data.Mirracles || []);
  const mirracles = data.Mirracles.filter(m => pIds.indexOf(m.PersonId) > -1 && dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT);

  data.Dang = (data.Dang || []);
  const dang = data.Dang.filter(f => fids.indexOf(f.CenterId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);

  const allCenterNotes = data.CenterNotes ? data.CenterNotes.filter(f => fids.indexOf(f.CenterId) > -1 && (!f.RS || f.RS != "DELETEACTIVITY")) : [];


  const allLeaveRequests = allPeopleNotes ? allPeopleNotes.filter(f => f.TypeId == GetTypeIdByName(types, "LEAVEREQUEST")) : [];

  var compoTypeId = GetTypeIdByName(types, "SERVICECOMPENSATION");
  const allCompensations = data.Attendance ? data.Attendance.filter(f => f.TypeId == compoTypeId && therapyIds.indexOf(f.ServiceId) > -1 && dateFromSDateTime(f.ForDate) >= FDT && dateFromSDateTime(f.ForDate) <= TDT) : [];
  //pIds.indexOf(f.BOSSId) > -1 ||
  data.Fee = data.Fee ? data.Fee.filter(f => f.BOSSId ? true : false) : [];

  var feeThisMonth = data.Fee ? data.Fee.filter(f => dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.TDT) <= TDT && (fids.indexOf(f.CenterId) > -1 || fsIds.indexOf(f.CenterId) > -1) && f.RS != "DELETEACTIVITY") : [];

  var inactiveServices = data.Therapies ? data.Therapies.filter(m => null != m.F14 && dateFromSDateTime(m.F14) <= TDT && m.Status.toUpperCase() == "INACTIVE" && fids.indexOf(m.CenterId) > -1) : [];

  var fututreMonthInvoices = data.Fee ? data.Fee.filter(f => dateFromSDateTime(f.FDT) > TDT && (fids.indexOf(f.CenterId) > -1 || fsIds.indexOf(f.CenterId) > -1) && f.RS != "DELETEACTIVITY") : [];

  var futureInvoicesCreatedThisMonth = fututreMonthInvoices && fututreMonthInvoices.length > 0 ? fututreMonthInvoices.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) : [];

  var attendance = data.Attendance ? data.Attendance.filter(f => dateFromSDateTime(f.ForDate) >= FDT && dateFromSDateTime(f.ForDate) <= TDT && therapyIds.indexOf(f.ServiceId) > -1) : [];
  var paymentsThisMonth = data.FeeReceipt ? data.FeeReceipt.filter(e => e.RS != "DELETEACTIVITY" && (fids.indexOf(e.CenterId) > -1 || fsIds.indexOf(e.CenterId) > -1)) : [];
  //var servicerequest = data.ServiceRequests ? data.ServiceRequests.filter(m => (data.CFUser && data.CFUser.RoleId == 18 ) ? (((data.CFUser && m.CBPI==data.CFUser.Id) || (incentiveIds.indexOf(m.TypeId) > -1)) && (!m.RS || m.RS != "DELETEACTIVITY") ) : (data.CFUser && (data.CFUser.RoleId == 19 || data.CFUser.RoleId == 404) && data.CFUser.Id != 2287&& data.CFUser.Id != 1786) ? (data.CFUser && m.CBPI==data.CFUser.Id && (!m.RS || m.RS != "DELETEACTIVITY")) : (pIds.indexOf(m.TOId) > -1 || pIds.indexOf(m.CBPI) > -1 && (!m.RS || m.RS != "DELETEACTIVITY"))) : [];
  var servicerequest = data.ServiceRequests ? data.ServiceRequests.filter(m => (data.CFUser && (data.CFUser.RoleId == 19) && data.CFUser.Id != 2287 && data.CFUser.Id != 1786) ? (data.CFUser && m.CBPI == data.CFUser.Id && (!m.RS || m.RS != "DELETEACTIVITY")) : (pIds.indexOf(m.TOId) > -1 || pIds.indexOf(m.CBPI) > -1 && (!m.RS || m.RS != "DELETEACTIVITY"))) : [];
  var analyticsData = servicerequest.map(e => e.Id);
  var ServiceRequestAnalytic = data.ServiceRequestsAnalytics ? data.ServiceRequestsAnalytics.filter(m => analyticsData && analyticsData.indexOf(m.SRId) > -1 && m.RS != "DELETEACTIVITY") : [];

  var memoTypeId = GetTypeIdByName(types, "MEMO")
  var leaverequestId = GetTypeIdByName(types, "LEAVEREQUEST");
  var awardId = GetTypeIdByName(types, "AWARD");
  var mirracleAssignId = GetTypeIdByName(types, "MIRRACLEASSIGNED");

  var allLeaves = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == leaverequestId && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

  var allMirraclesAssigned = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == mirracleAssignId) : [];

  var allMemos = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == memoTypeId && (role && role.toLowerCase() == "bdc" ? f.TOId == data.CFUser.Id : true)) : [];
  var allawards = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == awardId) : [];

  var feeAllMonths = data.Fee ? data.Fee.filter(e => (fids.indexOf(e.CenterId) > -1 || fsIds.indexOf(e.CenterId) > -1) && e.RS != "DELETEACTIVITY") /*.filter(f => dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.TDT) < TDT)*/ : [];
  var allassessmentdata = data.Assessments ? data.Assessments.filter(e => e.RS != "DELETEACTIVITY") : [];
  var filteringfeedback = data.Feedback ? data.Feedback.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) : []
  var dataConst = {};

  var leadsGroupsForKPI = leads && leads && leads.length > 0 ? Object.entries(groupBy(leads, "F17")) : [];
  var leadsDataForKPI = leadsGroupsForKPI && leadsGroupsForKPI.length > 0 ? leadsGroupsForKPI.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))) : [];
  var demographics = data.DemoGraphicAI ? data.DemoGraphicAI.filter(e => e.RS != "DELETEACTIVITY") : [];
  var demographicsNotes = data.DemoGraphicAINotes ? data.DemoGraphicAINotes.filter(e => e.RS != "DELETEACTIVITY") : [];
  var allKids = data.People && data.People && data.People.length > 0 ? data.People.filter(r => r.RoleId == 28) : [];
  ///leave Approvals
  var allTypeLeaves = allLeaves;
  var Roles = localStorage.getItem("UserRoles");
  var allRoles = JSON.parse(Roles);
  if (allRoles && allRoles.indexOf("Boss") == -1 && allRoles.indexOf("Therapist") == -1) {
    if (data && data.People && data.Types) {

      if (allRoles.indexOf("Receptionist") > -1) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => (e.F1 == "Therapist" || e.F1 == "AdminForTherapist" || e.F1 == "Admin" || e.F1 == "AdminForBlueForce")) : [];
      }
      if (allRoles.indexOf("Zonal Manager") > -1) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => (e.F1 == "Therapist" || e.F1 == "AdminForTherapist" || e.F1 == "Admin" || e.F1 == "ZM" || e.F1 == "AdminForBlueForce")) : [];
      }
      if (allRoles.indexOf("SOC") > -1 || allRoles.indexOf("BDC") > -1 || allRoles.indexOf("NCC") > -1) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => e.TOId == data.CFUser.Id) : [];
      }
      if (allRoles && (allRoles.indexOf("SOC Manager") > -1 || allRoles.indexOf("SOC Officer") > -1)) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => e.F1 == "SOC" || e.F1 == "SOCM" || e.F1 == "SOCO" || e.F1 == "Admin" || e.F1 == "AdminForBlueForce") : [];
      }
      if (allRoles.indexOf("AUDIT") > -1) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => e.TOId == data.CFUser.Id) : [];
      }
      if (allRoles.indexOf("AUDIT Manager") > -1) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => e.F1 == "AUDIT" || e.F1 == "AUDITM" || e.F1 == "BDC") : [];
      }
      if (allRoles.indexOf("PDT") > -1) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => e.F1 == "ZM" || e.F1 == "PDT") : [];
      }
      if (allRoles.indexOf("PDT Manager") > -1) {
        allTypeLeaves = allLeaves && allLeaves.length > 0 ? allLeaves.filter(e => e.F1 == "PDT" || e.F1 == "AUDITM" || e.F1 == "SOCO" || e.F1 == "SOCM" || e.F1 == "NCC" || e.F1 == "BDC" || e.F1 == "ZM" || e.F1 == "HR" || e.F1 == "Finance") : [];
      }
    }

  }

  dataConst.Therapies = therapies;
  dataConst.Goals = goals;

  dataConst.Types = types;
  dataConst.Centers = data.Centers;
  dataConst.UserSettings = usersettings;
  dataConst.Holidays = holidays;
  dataConst.People = people;
  dataConst.TWD = totalworkingdays;
  dataConst.Leaves = allLeaveRequests;
  dataConst.Compos = allCompensations;
  dataConst.Fee = feeThisMonth;
  dataConst.InActive = inactiveServices;
  dataConst.Attendance = attendance;
  dataConst.FutureInvoices = fututreMonthInvoices;
  dataConst.FutureInvoicesCDTThisMonth = futureInvoicesCreatedThisMonth;
  dataConst.FeeReceipt = paymentsThisMonth;
  dataConst.ServiceRequest = servicerequest;
  dataConst.ServiceRequestAnalytic = ServiceRequestAnalytic;
  dataConst.Leaverequestall = allTypeLeaves;
  dataConst.MirraclesAssigned = allMirraclesAssigned;
  dataConst.FeeAll = feeAllMonths;
  dataConst.PeopleNotes = allPeopleNotes;
  dataConst.CenterNotes = allCenterNotes;
  dataConst.Assessmentsdata = allassessmentdata;
  dataConst.Leads = leads;
  dataConst.Memos = allMemos;
  dataConst.Responses = data.Responses;
  dataConst.Awards = allawards;
  dataConst.Feedback = filteringfeedback;
  dataConst.Biometric = data.Biometric;
  dataConst.MirraclesData = mirracles;
  dataConst.MirracleTypes = data.MirracleTypes;
  dataConst.Dang = dang;
  dataConst.LeadGroups = leadsGroupsForKPI;
  dataConst.GroupedLeads = leadsDataForKPI;
  dataConst.PinnacleClarity = pinnacleClarities;
  dataConst.KidStates = data && data.KidStates ? data.KidStates : [];
  dataConst.DemoGraphics = demographics;
  dataConst.DemoGraphicNotes = demographicsNotes;
  dataConst.CFUser = data.CFUser;
  dataConst.Pollinations = data.Pollinations;
  dataConst.TherapeuticEipAssessments = data.TherapeuticEipAssessments;
  dataConst.HyperLocal = data.HyperLocal;
  dataConst.FacilityPeople = data.FacilityPeople ? data.FacilityPeople : [];
  dataConst.AllKids = allKids;
  dataConst.Offers = data.Offers ? data.Offers : [];
  return dataConst;
}

function PrepBossAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese) {
  var logs = [];
  //credits available
  var aggregate = {};
  var startDate = new Date();
  var FDT = fdt;
  var TDT = tdt;
  aggregate.FCI = GetReportsData("availablecredits", dataConst, true, fdt, tdt, facility).length;
  logs.push("FCI:" + GetDateDiff(startDate, new Date()));

  //goals
  startDate = new Date();
  aggregate.TAG = GetReportsData("activegoals", dataConst, true, fdt, tdt, facility).length;
  logs.push("TAG:" + GetDateDiff(startDate, new Date()));
  //Goal Reviewed

  startDate = new Date();
  aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
  logs.push("GR:" + GetDateDiff(startDate, new Date()));

  //Goal Pending
  startDate = new Date();
  aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
  console.log("GOALS PENDING Time: " + GetDateDiff(startDate, new Date()));
  logs.push("GP:" + GetDateDiff(startDate, new Date()));


  // Pending - assessments

  aggregate.ASP = dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() != "completed" && dateFromSDateTime(m.CDT) >= FDT).length;

  // Completed -assessments
  aggregate.AST = dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() == "completed" && dateFromSDateTime(m.CDT) >= FDT).length;

  // pending attendance
  //startDate = new Date();
  //aggregate.AP = GetReportsData("attendancepending", dataConst, true, fdt, tdt, facility);
  //logs.push("AP:" + GetDateDiff(startDate, new Date()));


  // attendance present

  startDate = new Date();
  aggregate.AGP = GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
  logs.push("AGP:" + GetDateDiff(startDate, new Date()));

  //attendance absent
  startDate = new Date();
  aggregate.AGA = GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
  logs.push("AGA:" + GetDateDiff(startDate, new Date()));

  // attendance
  aggregate.AG = aggregate.AGP + aggregate.AGA;

  // Homework pending
  startDate = new Date();
  aggregate.RP = GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  logs.push("RP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RG = GetReportsData("homeworkcompleted", dataConst, true, fdt, tdt, facility).length;
  logs.push("RG:" + GetDateDiff(startDate, new Date()));

  // Homework pending
  // startDate = new Date();
  // aggregate.RG = GetReportsData("homeworkgiven", dataConst, true, fdt, tdt, facility).length;
  // logs.push("RG:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  var servicerequests = GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
  var inprocess = servicerequests.filter(m => !m.LastAnalytic || m.LastAnalytic.Status == "REOPEN");
  aggregate.SRIP = (inprocess || []).length;
  console.log("SERVICEREQUEST TIME :" + GetDateDiff(startDate, new Date()));
  logs.push("srip:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var waiting = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status != "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
  aggregate.SRW = (waiting || []).length;
  logs.push("SRW:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  var closedByUs = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
  aggregate.SRCU = (closedByUs || []).length;
  logs.push("SRCU:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var closed = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
  aggregate.SRR = (closed || []).length;
  logs.push("SRR:" + GetDateDiff(startDate, new Date()));



  startDate = new Date();
  var reopen = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");
  aggregate.SRRO = (reopen || []).length;
  logs.push("SRRO:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  //aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
  var cmSR = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT);
  aggregate.SRT = cmSR && cmSR.length > 0 ? cmSR.length : 0;

  startDate = new Date();
  var compodataa = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
  aggregate.CPC = compodataa > 0 ? compodataa : 0;
  logs.push("CPC:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.ROFF = GetReportsData("renewaloffer", dataConst, true, fdt, tdt, facility);
  logs.push("ROFF:" + GetDateDiff(startDate, new Date()));

  var pendingCourses = GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);

  aggregate.TCOP = pendingCourses.totalPending;
  aggregate.TTP = pendingCourses.totalTantrumsPending;
  aggregate.TCNP = pendingCourses.totalConditionsPending;
  aggregate.TPISIP = pendingCourses.ptiPendingAssesmsnets;

  aggregate.HWP = GetReportsData("bosshomework", dataConst, true, fdt, tdt, facility).length;


  var bossAchivements = GetReportsData("bossachivements", dataConst, true, fdt, tdt, facility);

  aggregate.TBOT = bossAchivements.totalBossTherapies;
  aggregate.TBOG = bossAchivements.totalBossGoals;
  aggregate.TBOF = bossAchivements.totalBossFeedback;

  var bossPendingFee = GetReportsData("bosspendingfee", dataConst, true, fdt, tdt, facility);

  aggregate.BPF = bossPendingFee;


  return aggregate;
}


function PrepTherapistAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese) {
  var aggregate = {};
  var logs = [];
  var initialStart = new Date();
  var startDate = new Date();
  var FDT = fdt;
  var TDT = tdt;

  var logs = [];
  var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id;

  aggregate.FId = fids;

  dataConst.Therapists = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);
  aggregate.PCP = GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
  logs.push("PCP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.TGNS = GetReportsData("goalsnotset", dataConst, true, fdt, tdt, facility).length;
  // logs.push("TGNS:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.TGNS = GetReportsData("aigoalsnotset", dataConst, true, fdt, tdt, facility).length;
  logs.push("TGNS:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.AHWP = GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  logs.push("AHWP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
  console.log("GOALS PENDING Time: " + GetDateDiff(startDate, new Date()));
  logs.push("GP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.AP = GetReportsData("kpiattendancepending", dataConst, true, fdt, tdt, facility);
  // logs.push("AP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.AP = GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
  logs.push("AP:" + GetDateDiff(startDate, new Date()));





  // startDate = new Date();
  // aggregate.KIDAP = GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
  // logs.push("KIDAP:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  var compodataa = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
  aggregate.CPC = compodataa > 0 ? compodataa : 0;
  logs.push("CPC:" + GetDateDiff(startDate, new Date()));

  //startDate = new Date();
  //aggregate.AGP = GetReportsData("therapiesprovided", dataConst, true, fdt, tdt, facility).length;
  //logs.push("AGP:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.AGP = GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
  logs.push("AGP:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.AGA = GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
  logs.push("AGA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
  logs.push("GR:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.AWARDS = GetReportsData("awardswon", dataConst, true, fdt, tdt, facility).length;
  logs.push("AWARDS:" + GetDateDiff(startDate, new Date()));

  ///POLLINATION

  startDate = new Date();
  aggregate.PCP = GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
  logs.push("PCP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCC = GetReportsData("pollinationclaritycompleted", dataConst, true, fdt, tdt, facility);
  logs.push("PCC:" + GetDateDiff(startDate, new Date()));

  // Homework pending
  startDate = new Date();
  aggregate.RP = GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  logs.push("RP:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.RG = GetReportsData("homeworkcompleted", dataConst, true, fdt, tdt, facility).length;
  logs.push("RG:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCYT = GetReportsData("pollinationclarityyetto", dataConst, true, fdt, tdt, facility);
  logs.push("RPCYTCTD:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCZ = GetReportsData("pollinationclarityzero", dataConst, true, fdt, tdt, facility);
  logs.push("PCZ:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.PCLT = GetReportsData("pollinationclaritylessthanthree", dataConst, true, fdt, tdt, facility);
  logs.push("PCLT:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCGT = GetReportsData("pollinationclaritygreaterthanthree", dataConst, true, fdt, tdt, facility);
  logs.push("PCGT:" + GetDateDiff(startDate, new Date()));


  //  startDate = new Date();
  //  aggregate.PAO=GetReportsData("pollinationopty", dataConst, true, fdt, tdt, facility);
  //  logs.push("PAO:" + GetDateDiff(startDate, new Date()));



  startDate = new Date();
  aggregate.AMEMO = GetReportsData("activememos", dataConst, true, fdt, tdt, facility).length;
  logs.push("AMEMO:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PMEMO = GetReportsData("pendingmemos", dataConst, true, fdt, tdt, facility).length;
  logs.push("PMEMO:" + GetDateDiff(startDate, new Date()));

  ///POLLINATION


  /*startDate = new Date();
  var pisiLatesttherapy = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

  var pisiids = pisiLatesttherapy.Reponses.map(m => m.PeopleNoteId);


  startDate = new Date();
  var TOA = pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy"));
  aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
  logs.push("TOE:" + GetDateDiff(startDate, new Date()));

  var TAS = pisiLatesttherapy && pisiLatesttherapy.length > 0 ? pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



  aggregate.TASS = TAS.length;
  //aggregate.TCA = pisiLatest && pisiLatest.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
  logs.push("TASS:" + GetDateDiff(startDate, new Date()));
  */

  // #region PISI
  startDate = new Date();
  var pisiLatest = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

  var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

  aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
  logs.push("TPA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
  aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
  logs.push("TOE:" + GetDateDiff(startDate, new Date()));

  // therapy improvemnet
  startDate = new Date();
  var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
  aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
  logs.push("TTI:" + GetDateDiff(startDate, new Date()));

  // Daily Homework Feedback
  startDate = new Date();
  var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

  aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
  logs.push("TDH:" + GetDateDiff(startDate, new Date()));
  // Daily after therapy interaction

  startDate = new Date();
  var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
  aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
  logs.push("TDA:" + GetDateDiff(startDate, new Date()));
  // Daily Homework Feedback

  startDate = new Date();
  var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



  aggregate.TASS = TAS.length;
  aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
  logs.push("TASS:" + GetDateDiff(startDate, new Date()));
  // #endregion PISI

  startDate = new Date();
  var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
  var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
  aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
  logs.push("PROA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROS = whiLatest && whiLatest.length > 0 ? whiLatest.Suggestions.length : 0;
  logs.push("PROS:" + GetDateDiff(startDate, new Date()));


  //if (role == "Therapist") {
  //    startDate = new Date();
  //    aggregate.TOE = GetReportsData("pisirating", dataConst, true, fdt, tdt, facility).length;
  //    logs.push("TOE:" + GetDateDiff(startDate, new Date()));
  //}



  //startDate = new Date();
  //aggregate.MIRT = GetReportsData("mirracles", dataConst, true, fdt, tdt, facility).length;
  //logs.push("MIRT:" + GetDateDiff(startDate, new Date()));

  /*startDate = new Date();
  aggregate.RP = GetReportsData("feedbackspending", dataConst, true, fdt, tdt, facility).length;
  logs.push("RP:" + GetDateDiff(startDate, new Date()));*/
  //Change below like above

  // Homework pending
  //   startDate = new Date();
  //   aggregate.RP = GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  //   logs.push("RP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.RG = GetReportsData("feedbacksgiven", dataConst, true, fdt, tdt, facility).length;
  // logs.push("RG:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  //aggregate.RP = aggregate.AGP - aggregate.RG;//  GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  //logs.push("RP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RGT = GetReportsData("feedbackratings", dataConst, true, fdt, tdt, facility);
  logs.push("RGT:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.RAT = aggregate.RG ? (aggregate.RGT / aggregate.RG).toFixed(2) : 0;
  logs.push("RAT:" + GetDateDiff(startDate, new Date()));

  //TOE
  //AGP
  //CPC
  //Goals for therapist
  startDate = new Date();
  aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
  logs.push("GR:" + GetDateDiff(startDate, new Date()));

  //Goal Pending for therapist
  // startDate = new Date();
  // aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
  // console.log("GOALS PENDING Time: "+GetDateDiff(startDate,new Date()));
  // logs.push("GP:" + GetDateDiff(startDate, new Date()));

  //services

  startDate = new Date();
  aggregate.SF = GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
  logs.push("SF:" + GetDateDiff(startDate, new Date()));

  //Assessments

  startDate = new Date();
  var allAssessmentsData = dataConst.Assessmentsdata;

  startDate = new Date();
  aggregate.ASP = allAssessmentsData.filter(m => m.Status.toLowerCase() != "completed" && dateFromSDateTime(m.CDT) >= FDT).length;
  logs.push("ASP:" + GetDateDiff(startDate, new Date()));

  // Completed assessment
  startDate = new Date();
  aggregate.AST = GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
  logs.push("AST:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
  aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
  logs.push("PROA:" + GetDateDiff(startDate, new Date()));




  startDate = new Date();
  aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
  logs.push("PROS:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
  aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
  logs.push("PROP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
  logs.push("PROT10:" + GetDateDiff(startDate, new Date()));




  startDate = new Date();
  aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
  logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
  logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
  logs.push("PROB10:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  var allrenewalClarity = GetReportsData("renewalclarityall", dataConst, true, fdt, tdt, facility);
  // var AllFeeETA = data.filter(e =>  (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity"+e.Details.toLowerCase()+""));

  aggregate.RCA = allrenewalClarity.length;
  logs.push("RCA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();

  aggregate.RCOD = allrenewalClarity.filter(f => f.Details == "overdue").length;//  GetReportsData("renewalclarityoverdue", dataConst, true, fdt, tdt, facility);
  logs.push("RCOD:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCTD = allrenewalClarity.filter(f => f.Details == "today").length; //GetReportsData("renewalclaritytoday", dataConst, true, fdt, tdt, facility);
  logs.push("RCTD:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCTR = allrenewalClarity.filter(f => f.Details == "tomorrow").length; //GetReportsData("renewalclaritytomorrow", dataConst, true, fdt, tdt, facility);
  logs.push("RCTR:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.RCTW = allrenewalClarity.filter(f => f.Details == "thisweek").length; //GetReportsData("renewalclaritythisweek", dataConst, true, fdt, tdt, facility);
  logs.push("RCTW:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCNW = allrenewalClarity.filter(f => f.Details == "nextweek").length; //GetReportsData("renewalclaritynextweek", dataConst, true, fdt, tdt, facility);
  logs.push("RCNW:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.RCTM = allrenewalClarity.filter(f => f.Details == "thismonth").length; //GetReportsData("renewalclaritythismonth", dataConst, true, fdt, tdt, facility);
  logs.push("RCTM:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCNM = allrenewalClarity.filter(f => f.Details == "nextmonth").length; //GetReportsData("renewalclaritynextmonth", dataConst, true, fdt, tdt, facility);
  logs.push("RCNM:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCOT = allrenewalClarity.filter(f => f.Details == "others").length; //GetReportsData("renewalclarityothers", dataConst, true, fdt, tdt, facility);
  logs.push("RCOT:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCP = allrenewalClarity.filter(f => f.Details == "pending").length; //GetReportsData("renewalclaritypending", dataConst, true, fdt, tdt, facility);
  logs.push("RCP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCR = allrenewalClarity.filter(f => f.Details == "renewed").length; //GetReportsData("renewalclarityrenewed", dataConst, true, fdt, tdt, facility);
  logs.push("RCR:" + GetDateDiff(startDate, new Date()));
  startDate = new Date();
  aggregate.RCTBR = aggregate.RCA - aggregate.RCR - aggregate.RCP - aggregate.RCOT;
  logs.push("RCTBR:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var servicerequests = GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
  var inprocess = servicerequests.filter(m => (!m.LastAnalytic || m.LastAnalytic.Status == "REOPEN") && familyIncentiveIds.indexOf(m.TypeId) == -1);
  aggregate.SRIP = (inprocess || []).length;
  console.log("SERVICEREQUEST TIME :" + GetDateDiff(startDate, new Date()));
  logs.push("srip:" + GetDateDiff(startDate, new Date()));

  const inprocessFamily = servicerequests.filter(m => (!m.LastAnalytic || m.LastAnalytic.Status == "REOPEN") && familyIncentiveIds.indexOf(m.TypeId) > -1);
  aggregate.SRFIP = (inprocessFamily || []).length;

  startDate = new Date();
  var waiting = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status != "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
  aggregate.SRW = (waiting || []).length;
  logs.push("SRW:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var closedByUs = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
  aggregate.SRCU = (closedByUs || []).length;
  logs.push("SRCU:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var closed = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
  aggregate.SRR = (closed || []).length;
  logs.push("SRR:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var reopen = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");
  aggregate.SRRO = (reopen || []).length;
  logs.push("SRRO:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  //aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
  var cmSR = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT);
  aggregate.SRT = cmSR && cmSR.length > 0 ? cmSR.length : 0;

  startDate = new Date();
  aggregate.LVP = GetReportsData("leavespending", dataConst, true, fdt, tdt, facility).length;
  logs.push("LVP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.LVAL = GetReportsData("leavesall", dataConst, true, fdt, tdt, facility).length;
  logs.push("LVAL:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.LVAP = GetReportsData("leavesapproved", dataConst, true, fdt, tdt, facility).length;
  logs.push("LVAP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.LVUA = GetReportsData("leavesunapproved", dataConst, true, fdt, tdt, facility).length;
  logs.push("LVUA:" + GetDateDiff(startDate, new Date()));


  var services = dataConst.Therapies;
  var serviceIds = Object.entries(groupBy(dataConst.Therapies, "BossId"));

  var total = 0;
  var totalST = 0;
  var totalOT = 0;
  var totalBT = 0;
  var totalSE = 0;
  for (var i = 0; i < servicesOfeering.length; i++) {
    var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1);
    total += (boss || []).length;
    if (servicesOfeering[i].ShortName == "ST") {
      totalST += (boss || []).length;
    }
    else if (servicesOfeering[i].ShortName == "BT") {
      totalBT += (boss || []).length;
    }
    else if (servicesOfeering[i].ShortName == "OT") {
      totalOT += (boss || []).length;
    }
    else if (servicesOfeering[i].ShortName == "SE") {
      totalSE += (boss || []).length;
    }
  }


  startDate = new Date();
  aggregate.POL = total;
  logs.push("POL:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.AVL = GetReportsData("available", dataConst, true, fdt, tdt, facility).length;
  logs.push("AVL:" + GetDateDiff(startDate, new Date()));

  var pendingCourses = GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);

  aggregate.TCOP = pendingCourses.totalPending;
  aggregate.TTP = pendingCourses.totalTantrumsPending;
  aggregate.TCNP = pendingCourses.totalConditionsPending;
  aggregate.TPISI = pendingCourses.ptiPendingAssesmsnets;

  console.log("THERAPISTAGGREGTAES:" + GetDateDiff(initialStart, new Date()));

  return aggregate;
}


function PrepOwnerAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese, role) {
  var initialStart = new Date();
  var logs = [];
  var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id;
  var startDate = new Date();
  var aggregate = {};
  var FDT = fdt;
  var TDT = tdt;

  var adminId = dataConst.Types.filter(m => m.Name == "Receptionist")[0].Id;
  var bossid = dataConst.Types.filter(m => m.Name == "Boss")[0].Id
  dataConst.Therapists = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);


  dataConst.LeftTherapists = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 == 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);

  dataConst.Parents = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == bossid && f.F8 != 1), 'Id')).map(m => m[1][0]);;

  if (null == onlyThese || onlyThese.indexOf("kubera") > -1) {
    // #region kubera



    startDate = new Date();

    var aggregateKu18 = GetReportsData("kuberamonthlyfee", dataConst, true, fdt, tdt, facility);
    aggregate.KU18 = aggregateKu18 && aggregateKu18.length > 0 ? aggregateKu18.length : 0;
    logs.push("KU18:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.KUM = GetReportsData("kuberamissing", dataConst, true, fdt, tdt, facility).length;
    logs.push("KUM:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var aggregateKUAB = GetReportsData("kuberaabnormal", dataConst, true, fdt, tdt, facility);
    aggregate.KUAB = aggregateKUAB && aggregateKUAB.length > 0 ? aggregateKUAB.length : 0;
    logs.push("KUAB:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var aggregateTotalInvoices = GetReportsData("allinvoicesthismonth", dataConst, true, fdt, tdt, facility);

    var filtered = [...aggregateKu18, ...aggregateKUAB];
    var totalInvoices = aggregateTotalInvoices && aggregateTotalInvoices.length > 0 ? aggregateTotalInvoices.filter(val => !filtered.includes(val) && val.Type != 'ASSESSMENTS').length : 0;

    //aggregate.KUR = totalInvoices - aggregate.KU18 - aggregate.KUAB;
    aggregate.KUR = totalInvoices;
    logs.push("KUR:" + GetDateDiff(startDate, new Date()));
    // #endregion kubera
  }

  if (null == onlyThese || onlyThese.indexOf("empower2") > -1) {
    // #region Empower2empwoer2single
    startDate = new Date();
    aggregate.EMPM = GetReportsData("empwoer2monthly", dataConst, true, fdt, tdt, facility).length;
    logs.push("EMPM:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.EMPS = GetReportsData("empwoer2single", dataConst, true, fdt, tdt, facility).length;
    logs.push("EMPS:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.EMPRNW = GetReportsData("empwoer2lostparents", dataConst, true, fdt, tdt, facility).length;
    logs.push("EMPRNW:" + GetDateDiff(startDate, new Date()));


    // startDate = new Date();

    // var renewalsData = GetReportsData("renewals", dataConst, true, fdt, tdt, facility);
    // renewalsData = renewalsData || [];
    // aggregate.RWT = renewalsData.length;
    // logs.push("RWT:" + GetDateDiff(startDate, new Date()));

    // startDate = new Date();
    // aggregate.RWP = (renewalsData.filter(f => f.Renewed == "No") || []).length;
    // logs.push("RWP:" + GetDateDiff(startDate, new Date()));
    // startDate = new Date();
    // aggregate.RWC = (renewalsData.filter(f => f.Renewed == "Yes") || []).length;
    // logs.push("RWC:" + GetDateDiff(startDate, new Date()));
    // startDate = new Date();
    // aggregate.RW3 = (renewalsData.filter(f => f.Renewed == "No" && f.Package >= 2 && f.Package <= 3) || []).length;
    // logs.push("RW3:" + GetDateDiff(startDate, new Date()));
    // startDate = new Date();
    // aggregate.RW6 = (renewalsData.filter(f => f.Renewed == "No" && f.Package > 3 && f.Package <= 6) || []).length;;
    // logs.push("RW6:" + GetDateDiff(startDate, new Date()));
    // startDate = new Date();
    // aggregate.RW12 = (renewalsData.filter(f => f.Renewed == "No" && f.Package > 6 && f.Package <= 48) || []).length;;
    // logs.push("RW12:" + GetDateDiff(startDate, new Date()));
    // startDate = new Date();

    // aggregate.RWC3 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package >= 2 && f.Package <= 3) || []).length;
    // logs.push("RWC3:" + GetDateDiff(startDate, new Date()));
    // startDate = new Date();
    // aggregate.RWC6 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package > 3 && f.Package <= 6) || []).length;;
    // logs.push("RWC6:" + GetDateDiff(startDate, new Date()));
    // startDate = new Date();
    // aggregate.RWC12 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package > 6 && f.Package <= 48) || []).length;;

    // logs.push("RWC12:" + GetDateDiff(startDate, new Date()));

    // #endregion Empwoer2
  }

  if (null == onlyThese || onlyThese.indexOf("seeta") > -1) {
    // #region Seeta
    startDate = new Date();
    aggregate.SETT = GetReportsData("seetatotal", dataConst, true, fdt, tdt, facility).length;
    logs.push("SETT:" + GetDateDiff(startDate, new Date()));




    startDate = new Date();
    var allseetainvoices = GetReportsData("seetaallinvoicedata", dataConst, true, fdt, tdt, facility);
    aggregate.SETP = (allseetainvoices.filter(f => !f.Status || f.Status != "PAID")).length;
    logs.push("SETP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.SETPP = (allseetainvoices.filter(f => f.Status == "PARTIALLYPAID")).length;
    logs.push("SETPP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.SETPA = (allseetainvoices.filter(f => f.Status == "PAID")).length;
    logs.push("SETPA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.SETKI = GetReportsData("seetakids", dataConst, true, fdt, tdt, facility).length;
    logs.push("SETKI:" + GetDateDiff(startDate, new Date()));
    // #endregion Seeta
  }

  //#Walkin Region

  startDate = new Date();
  aggregate.TMWTA = GetReportsData("walkintoadmisssion", dataConst, true, fdt, tdt, facility).length;
  logs.push("TMWTA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.TMWC = GetReportsData("walkincounselling", dataConst, true, fdt, tdt, facility).length;
  logs.push("TMWC:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.WANDV = GetReportsData("welcomevalidation", dataConst, true, fdt, tdt, facility).length;
  logs.push("WANDV:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.ODKIDS = GetReportsData("bdcoverdue", dataConst, true, fdt, tdt, facility).length;
  logs.push("ODKIDS:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.TMAW = GetReportsData("activewalkins", dataConst, true, fdt, tdt, facility).length;
  logs.push("TMAW:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.TMAP = GetReportsData("pendingwalkins", dataConst, true, fdt, tdt, facility).length;
  logs.push("TMAP:" + GetDateDiff(startDate, new Date()));



  startDate = new Date();
  aggregate.TMCW = GetReportsData("closedwalkins", dataConst, true, fdt, tdt, facility).length;
  logs.push("TMCW:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.TAPTI = GetReportsData("overallpti", dataConst, true, fdt, tdt, facility).length;
  logs.push("TAPTI:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.TPPTI = GetReportsData("pendingpti", dataConst, true, fdt, tdt, facility).length;
  logs.push("TPPTI:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.TCPTI = GetReportsData("completedpti", dataConst, true, fdt, tdt, facility).length;
  logs.push("TCPTI:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.MCLS = GetReportsData("missedcalls", dataConst, true, fdt, tdt, facility).length;
  logs.push("MCLS:" + GetDateDiff(startDate, new Date()));




  if (null == onlyThese || onlyThese.indexOf("achievements") > -1) {
    // #region Achievements
    startDate = new Date();
    aggregate.OW = GetReportsData("walkins", dataConst, true, fdt, tdt, facility).length;
    console.log("Walkins Time :" + GetDateDiff(startDate, new Date()))
    logs.push("OW:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.FCI = GetReportsData("credits", dataConst, true, fdt, tdt, facility).length;
    logs.push("FCI:" + GetDateDiff(startDate, new Date()));

    //credits

    startDate = new Date();
    aggregate.ADM = GetReportsData("admissionleads", dataConst, true, fdt, tdt, facility).length;
    console.log("ADMISSION LEADS TIME :" + GetDateDiff(startDate, new Date()));
    logs.push("ADM:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.ADD = GetReportsData("additions", dataConst, true, fdt, tdt, facility).length;
    logs.push("ADD:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TCS = GetReportsData("inactivations", dataConst, true, fdt, tdt, facility).length;
    logs.push("TCS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.AC = GetReportsData("availablecredits", dataConst, true, fdt, tdt, facility).length;
    logs.push("AC:" + GetDateDiff(startDate, new Date()));
    // #endregion Achievements
  }


  if (null == onlyThese || onlyThese.indexOf("pendings") > -1) {
    // #region Pendings


    var services = dataConst.Therapies;
    var serviceIds = Object.entries(groupBy(dataConst.Therapies, "BossId"));

    var total = 0;
    var totalST = 0;
    var totalOT = 0;
    var totalBT = 0;
    var totalSE = 0;
    for (var i = 0; i < servicesOfeering.length; i++) {
      var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1);
      total += (boss || []).length;
      if (servicesOfeering[i].ShortName == "ST") {
        totalST += (boss || []).length;
      }
      else if (servicesOfeering[i].ShortName == "BT") {
        totalBT += (boss || []).length;
      }
      else if (servicesOfeering[i].ShortName == "OT") {
        totalOT += (boss || []).length;
      }
      else if (servicesOfeering[i].ShortName == "SE") {
        totalSE += (boss || []).length;
      }
    }


    startDate = new Date();
    aggregate.POL = total;
    logs.push("POL:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PAST = totalST;
    logs.push("PAST:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PAOT = totalOT;
    logs.push("PAOT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PAABA = totalBT;
    logs.push("RCP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PASE = totalSE;
    logs.push("RCR:" + GetDateDiff(startDate, new Date()));
    startDate = new Date();




    startDate = new Date();
    aggregate.AVL = GetReportsData("available", dataConst, true, fdt, tdt, facility).length;
    logs.push("AVL:" + GetDateDiff(startDate, new Date()));




    startDate = new Date();
    aggregate.AHWP = GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
    logs.push("AHWP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RG = GetReportsData("homeworkcompleted", dataConst, true, fdt, tdt, facility).length;
    logs.push("RG:" + GetDateDiff(startDate, new Date()));



    startDate = new Date();
    aggregate.ASP = GetReportsData("assessmentpending", dataConst, true, fdt, tdt, facility).length;
    logs.push("ASP:" + GetDateDiff(startDate, new Date()));


    //startDate = new Date();
    //aggregate.CPC = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
    //logs.push("CPC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LVP = GetReportsData("leavespending", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LVAL = GetReportsData("leavesall", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVAL:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LVAP = GetReportsData("leavesapproved", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVAP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LVUA = GetReportsData("leavesunapproved", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVUA:" + GetDateDiff(startDate, new Date()));

    // startDate = new Date();
    // aggregate.SRIP = GetReportsData("servicerequestpending", dataConst, true, fdt, tdt, facility).length;
    // console.log("ServiceRequest Pending:"+GetDateDiff(startDate, new Date()));
    // logs.push("SRIP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.CPA = 0;// GetReportsData("chipending", dataConst, true, fdt, tdt, facility).length;
    logs.push("CPA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.WPA = 0;// GetReportsData("whipending", dataConst, true, fdt, tdt, facility).length;
    logs.push("WPA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TPA = 0;// GetReportsData("pisipending", dataConst, true, fdt, tdt, facility).length;
    logs.push("TPA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.CST = GetReportsData("compos", dataConst, true, fdt, tdt, facility).length;
    logs.push("CST:" + GetDateDiff(startDate, new Date()));

    // #endregion pendings
  }


  if (null == onlyThese || onlyThese.indexOf("services") > -1) {
    startDate = new Date();
    aggregate.SF = GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
    logs.push("SF:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TCS = GetReportsData("inactiveservices", dataConst, true, fdt, tdt, facility).length;
    logs.push("TCS:" + GetDateDiff(startDate, new Date()));

    //INACTIVATION ROOT CAUSE PENDING
    startDate = new Date();
    aggregate.TCSR = GetReportsData("inactivecausepending", dataConst, true, fdt, tdt, facility).length;
    logs.push("TCSR:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TFADD = GetReportsData("futureservices", dataConst, true, fdt, tdt, facility).length;
    logs.push("TFADD:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.ADDS = GetReportsData("newservices", dataConst, true, fdt, tdt, facility).length;
    logs.push("ADDS:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TSTS = GetReportsData("newservicesst", dataConst, true, fdt, tdt, facility).length;
    logs.push("TSTS:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TBTS = GetReportsData("newservicesbt", dataConst, true, fdt, tdt, facility).length;
    logs.push("TBTS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TSES = GetReportsData("newservicesse", dataConst, true, fdt, tdt, facility).length;
    logs.push("TSES:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TOTS = GetReportsData("newservicesot", dataConst, true, fdt, tdt, facility).length;
    logs.push("TOTS:" + GetDateDiff(startDate, new Date()));
  }
  if (null == onlyThese || onlyThese.indexOf("attendance") > -1) {
    startDate = new Date();
    aggregate.CSC = GetReportsData("compenstationcompleted", dataConst, true, fdt, tdt, facility).length;
    logs.push("CSC:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.CSF = GetReportsData("compenstationfuture", dataConst, true, fdt, tdt, facility).length;
    logs.push("CSF:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.CSTO = GetReportsData("compenstationtoday", dataConst, true, fdt, tdt, facility).length;
    logs.push("CSTO:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.CSO = GetReportsData("compenstationorphan", dataConst, true, fdt, tdt, facility).length;
    logs.push("CSO:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.CCL = GetReportsData("compenstationcanceled", dataConst, true, fdt, tdt, facility).length;
    logs.push("CCL:" + GetDateDiff(startDate, new Date()));

  }


  if (null == onlyThese || onlyThese.indexOf("misc") > -1) {
    startDate = new Date();
    aggregate.TStaff = GetReportsData("activestaff", dataConst, true, fdt, tdt, facility).length;
    logs.push("TStaff:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.ASTAFF = GetReportsData("addedstaff", dataConst, true, fdt, tdt, facility).length;
    logs.push("ASTAFF:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TLStaff = GetReportsData("leftstaff", dataConst, true, fdt, tdt, facility).length;
    logs.push("TLStaff:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.KIDS = GetReportsData("activeparents", dataConst, true, fdt, tdt, facility).length;
    logs.push("KIDS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TLKIDS = GetReportsData("leftparents", dataConst, true, fdt, tdt, facility).length;
    logs.push("TLKIDS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PNEED = GetReportsData("needpollination", dataConst, true, fdt, tdt, facility).length;
    logs.push("TLKIDS:" + GetDateDiff(startDate, new Date()));



    startDate = new Date();
    aggregate.AKIDs = GetReportsData("addedparents", dataConst, true, fdt, tdt, facility).length;
    logs.push("AKIDs:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.UGS = GetReportsData("upgrades", dataConst, true, fdt, tdt, facility).length;
    logs.push("UGS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.AMEMO = GetReportsData("activememos", dataConst, true, fdt, tdt, facility).length;
    logs.push("AMEMO:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.PMEMO = GetReportsData("pendingmemos", dataConst, true, fdt, tdt, facility).length;
    logs.push("PMEMO:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.CMEMO = GetReportsData("closedmemos", dataConst, true, fdt, tdt, facility).length;
    logs.push("CMEMO:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TVPS = GetReportsData("viewpayslips", dataConst, true, fdt, tdt, facility).length;
    logs.push("TVPS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TDPS = GetReportsData("downloadpayslips", dataConst, true, fdt, tdt, facility).length;
    logs.push("TDPS:" + GetDateDiff(startDate, new Date()));

  }

  if (null == onlyThese || onlyThese.indexOf("money") > -1) {
    startDate = new Date();
    aggregate.PP = GetReportsData("paymentpending", dataConst, true, fdt, tdt, facility);
    logs.push("PP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.APEN = GetReportsData("advancepending", dataConst, true, fdt, tdt, facility);
    logs.push("APEN:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PPE = GetReportsData("paid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    logs.push("PPE:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PA = GetReportsData("advancepaid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    logs.push("PA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    var allexpenses = GetReportsData("expenses", dataConst, true, fdt, tdt, facility);
    aggregate.E = allexpenses.reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    console.log("EXPENSES TIME :" + GetDateDiff(startDate, new Date()));
    logs.push("E:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    var fixedHeaderIds = (dataConst.Types.filter(f => f.Category == "Expenses" && fixedExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

    aggregate.EF = allexpenses.filter(f => fixedHeaderIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);

    logs.push("EF:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var benefitsHeadersIds = (dataConst.Types.filter(f => f.Category == "Expenses" && benefitExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

    aggregate.EBT = allexpenses.filter(f => benefitsHeadersIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);

    logs.push("EBT:" + GetDateDiff(startDate, new Date()));



    startDate = new Date();
    var incentivesHeadersIds = (dataConst.Types.filter(f => f.Category == "Expenses" && incentiveExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

    aggregate.EIT = allexpenses.filter(f => incentivesHeadersIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);

    logs.push("EIT:" + GetDateDiff(startDate, new Date()));

    aggregate.EVE = aggregate.E - aggregate.EF - aggregate.EBT - aggregate.EIT;
    aggregate.EVE = aggregate.EVE > 0 ? aggregate.EVE : 0;


    startDate = new Date();
    aggregate.PIP = GetReportsData("pastpending", dataConst, true, fdt, tdt, facility);
    logs.push("PIP:" + GetDateDiff(startDate, new Date()));

  }




  if (null == onlyThese && (role == "Owner" || role == "FacilityOwner")) {
    startDate = new Date();
    aggregate.TS = GetReportsData("salary", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    logs.push("TS:" + GetDateDiff(startDate, new Date()));



    // startDate = new Date();
    // aggregate.PPE = GetReportsData("paid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
    //     return accc + items.Amount;
    // }, 0);
    // logs.push("PPE:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PTS = GetReportsData("paidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    logs.push("PTS:" + GetDateDiff(startDate, new Date()));




    startDate = new Date();
    aggregate.AS = GetReportsData("advancepaidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    console.log("ADVANCEPAID SEVA Time :" + GetDateDiff(startDate, new Date()));
    logs.push("AS:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TPMPA = GetReportsData("pastpaid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    console.log("PAST PAID TIME: " + GetDateDiff(startDate, new Date()))
    logs.push("TPMPA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TPMSPA = GetReportsData("pastpaidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    logs.push("TPMSPA:" + GetDateDiff(startDate, new Date()));
    console.log("past paid seva:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.ALFP = GetReportsData("alreadyfulfilled", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Amount;
    }, 0);
    console.log("ALREADY FULL FILLED :" + GetDateDiff(startDate, new Date()));
    logs.push("ALFP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.ATBF = GetReportsData("tobefulfilled", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + (items.Amount - items.SevaAmount);
    }, 0);
    logs.push("ATBF:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TDB = GetReportsData("discount", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
      return accc + items.Discount;
    }, 0);
    console.log("DISCOUNT TIME :" + GetDateDiff(startDate, new Date()));
    logs.push("TDB:" + GetDateDiff(startDate, new Date()));

  }
  else {
    aggregate.TS = 0;
    aggregate.PTS = 0;
    aggregate.AS = 0;
    aggregate.TPMPA = 0;
    aggregate.TPMSPA = 0;
    aggregate.ALFP = 0;
    aggregate.ATBF = 0;
    aggregate.TDB = 0;

  }








  if (null == onlyThese || onlyThese.indexOf("servicerequests") > -1) {

    // #region servicerequests



    startDate = new Date();
    var servicerequests = GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
    var inprocess = servicerequests.filter(m => (!m.LastAnalytic || m.LastAnalytic.Status == "REOPEN") && familyIncentiveIds.indexOf(m.TypeId) == -1);
    aggregate.SRIP = (inprocess || []).length;
    console.log("SERVICEREQUEST TIME :" + GetDateDiff(startDate, new Date()));
    logs.push("srip:" + GetDateDiff(startDate, new Date()));

    const inprocessFamily = servicerequests.filter(m => (!m.LastAnalytic || m.LastAnalytic.Status == "REOPEN") && familyIncentiveIds.indexOf(m.TypeId) > -1);
    aggregate.SRFIP = (inprocessFamily || []).length;

    startDate = new Date();
    var waiting = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status != "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
    aggregate.SRW = (waiting || []).length;
    logs.push("SRW:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var closedByUs = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
    aggregate.SRCU = (closedByUs || []).length;
    logs.push("SRCU:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var closed = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
    aggregate.SRR = (closed || []).length;
    logs.push("SRR:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var reopen = servicerequests.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "REOPEN"));
    aggregate.SRRO = (reopen || []).length;
    logs.push("SRRO:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    //aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
    var cmSR = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT);
    aggregate.SRT = cmSR && cmSR.length > 0 ? cmSR.length : 0;

    //aggregate.SRT = GetReportsData("servicerequestall", dataConst, true, fdt, tdt, facility).length;

    aggregate.SR5 = servicerequests.filter(m => m.Rating == 5).length;
    logs.push("SR5:" + GetDateDiff(startDate, new Date()));
    startDate = new Date();
    aggregate.SR4 = servicerequests.filter(m => m.Rating == 4).length;
    logs.push("SR4:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.SR3 = servicerequests.filter(m => m.Rating == 3).length;
    logs.push("SR3:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.SR2 = servicerequests.filter(m => m.Rating == 2).length;
    logs.push("SR2:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.SR1 = servicerequests.filter(m => m.Rating == 1).length;
    logs.push("SR1:" + GetDateDiff(startDate, new Date()));

    // #endregion servicerequests

  }
  if (null == onlyThese || onlyThese.indexOf("leads") > -1) {

    // #region lead

    startDate = new Date();
    aggregate.LEP = GetReportsData("leadspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("LEP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var allLeads = dataConst.Leads;


    //active
    startDate = new Date();
    var activeLeads = GetReportsData("activeleadsdata", dataConst, true, fdt, tdt, facility);
    aggregate.LA = activeLeads.length;
    console.log("LEADS ACTIVE TIME:" + GetDateDiff(startDate, new Date()));
    logs.push("LA:" + GetDateDiff(startDate, new Date()));


    //closed
    startDate = new Date();
    var closedLeads = GetReportsData("closedleadsdata", dataConst, true, fdt, tdt, facility);
    aggregate.LC = closedLeads.length;
    logs.push("LC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LTO = aggregate.LA + aggregate.LC;
    logs.push("LTO:" + GetDateDiff(startDate, new Date()));

    // New
    startDate = new Date();
    aggregate.LN = GetReportsData("newleads", dataConst, true, fdt, tdt, facility).length;
    logs.push("LN:" + GetDateDiff(startDate, new Date()));


    // Else where

    startDate = new Date();
    var elseWhere = GetReportsData("leadselsewhere", dataConst, true, fdt, tdt, facility);
    aggregate.JSW = elseWhere.length;
    logs.push("JSW:" + GetDateDiff(startDate, new Date()));
    // Assessments - Doubt
    //var lIds = groupBy(allLeads,"TOId").map(m => m.Id);
    //aggregate.LASM = data.ANALYTICS.Where(m => m.AT == EnumSharb.ActivityType.BookAssessment.ToString().ToUpper() && lIds.Contains(m.TOId)).Count();

    // Admissions

    startDate = new Date();
    var filteredLta = GetReportsData("leadstoadmission", dataConst, true, fdt, tdt, facility);
    aggregate.LTA = filteredLta.length;
    logs.push("LTA:" + GetDateDiff(startDate, new Date()));

    // #endregion lead
  }
  if (null == onlyThese || onlyThese.indexOf("goals") > -1) {

    // #region Goals

    //total goals

    startDate = new Date();
    aggregate.TGO = GetReportsData("totalgoals", dataConst, true, fdt, tdt, facility).length;
    logs.push("TGO:" + GetDateDiff(startDate, new Date()));


    //active goals

    startDate = new Date();
    aggregate.TAG = GetReportsData("activegoals", dataConst, true, fdt, tdt, facility).length;
    logs.push("TAG:" + GetDateDiff(startDate, new Date()));

    // Today pending goals
    startDate = new Date();
    aggregate.TGP = GetReportsData("todaypendinggoals", dataConst, true, fdt, tdt, facility).length;
    logs.push("TGP:" + GetDateDiff(startDate, new Date()));

    //Goal Reviewed

    startDate = new Date();
    aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
    logs.push("GR:" + GetDateDiff(startDate, new Date()));


    // Goal ontime
    //startDate = new Date();
    //aggregate.TGONT = GetReportsData("goalontime", dataConst, true, fdt, tdt, facility).length;
    //logs.push("TGONT:" + GetDateDiff(startDate, new Date()));


    //// Goal late
    //startDate = new Date();
    //aggregate.TGOOT = GetReportsData("goallate", dataConst, true, fdt, tdt, facility).length;
    //logs.push("TGOOT:" + GetDateDiff(startDate, new Date()));


    // Goal Met
    startDate = new Date();
    aggregate.TGM = GetReportsData("goalmet", dataConst, true, fdt, tdt, facility).length;
    logs.push("TGM:" + GetDateDiff(startDate, new Date()));

    // Goal Not Met
    startDate = new Date();
    aggregate.GNM = GetReportsData("goalnotmet", dataConst, true, fdt, tdt, facility).length;
    logs.push("GNM:" + GetDateDiff(startDate, new Date()));

    // #endregion Goals
  }

  if (null == onlyThese || onlyThese.indexOf("assessments") > -1) {

    // #region assessments
    startDate = new Date();
    var allAssessmentsData = dataConst.Assessmentsdata;
    aggregate.TAB = GetReportsData("assessmentall", dataConst, true, fdt, tdt, facility).length;
    logs.push("TAB:" + GetDateDiff(startDate, new Date()));
    // Pending - NIPL

    startDate = new Date();
    aggregate.ASP = allAssessmentsData.filter(m => m.Status.toLowerCase() != "completed" && dateFromSDateTime(m.CDT) >= FDT).length;
    logs.push("ASP:" + GetDateDiff(startDate, new Date()));

    // Completed assessment
    startDate = new Date();
    aggregate.AST = GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
    // aggregate.AST = allAssessmentsData.filter(m => m.Status.toLowerCase() == "completed").length;
    logs.push("AST:" + GetDateDiff(startDate, new Date()));


    /*   var assessmentIds = allAssessmentsData.map(m => m.Id);
       var assessmnetInvoices = facilityInvoices.Where(m => null != m.RDUId && m.RDUId.Count() > 0 && assessmentIds.Contains(m.RDUId[0].ToString())).ToList();
       aggregate.TPFA = assessmnetInvoices.Sum(m => m.F7);
       aggregate.TSPFA = assessmnetInvoices.Sum(m => m.F8);*/

    // #endregion assessments
  }

  if (null == onlyThese || onlyThese.indexOf("leaves") > -1) {

    // #region Leave Requests


    var currentDate = new Date();

    startDate = new Date();
    var futureLeaves = GetReportsData("leaverequestparentfuture", dataConst, true, fdt, tdt, facility);
    aggregate.PLF = (futureLeaves || []).length;
    logs.push("PLF:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var completedLeaves = GetReportsData("leaverequestparentcompleted", dataConst, true, fdt, tdt, facility);
    aggregate.PLC = (completedLeaves || []).length;
    logs.push("PLC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var cancelledLeaved = GetReportsData("leaverequestparentcanceled", dataConst, true, fdt, tdt, facility);
    aggregate.PLCA = (cancelledLeaved || []).length;
    logs.push("PLCA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TOPL = aggregate.PLF + aggregate.PLC + aggregate.PLCA;
    logs.push("TOPL:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var futurenpLeaves = GetReportsData("leaverequestnonparentfuture", dataConst, true, fdt, tdt, facility);
    aggregate.SLF = (futurenpLeaves || []).length;
    logs.push("SLF:" + GetDateDiff(startDate, new Date()));



    startDate = new Date();
    var lrclt4 = GetReportsData("leaverequestcomposlt4", dataConst, true, fdt, tdt, facility);
    aggregate.SLCLT4 = (lrclt4 || []).length;
    logs.push("SLCLT4:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    var completednpLeaves = GetReportsData("leaverequestnonparentcompleted", dataConst, true, fdt, tdt, facility);
    aggregate.SLC = (completednpLeaves || []).length;
    logs.push("SLC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var cancellednpLeaved = GetReportsData("leaverequestnonparentcanceled", dataConst, true, fdt, tdt, facility);
    aggregate.SLCA = (cancellednpLeaved || []).length;
    logs.push("SLCA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TOSL = aggregate.SLF + aggregate.SLC + aggregate.SLCA;
    logs.push("TOSL:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var approvedLeaves = GetReportsData("leaverequestanalytic", dataConst, true, fdt, tdt, facility);
    aggregate.SLA = (approvedLeaves || []).length;
    logs.push("SLA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var unapprovedLeaves = GetReportsData("leaverequestanalyticunapproved", dataConst, true, fdt, tdt, facility);
    aggregate.SLUA = (unapprovedLeaves || []).length;
    logs.push("SLUA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.SLAP = aggregate.SLF + aggregate.SLC - aggregate.SLA - aggregate.SLUA;
    logs.push("SLAP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var pendingLeaves = GetReportsData("leavespendingapproval", dataConst, true, fdt, tdt, facility);
    aggregate.SLPA = (pendingLeaves || []).length;
    logs.push("SLPA:" + GetDateDiff(startDate, new Date()));



    // #endregion Leave Requests
  }

  if (null == onlyThese || onlyThese.indexOf("whi") > -1) {

    // #region WHI
    startDate = new Date();
    var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
    aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
    logs.push("PROA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
    logs.push("PROS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
    aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
    logs.push("PROP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
    logs.push("PROT10:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
    logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
    logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
    logs.push("PROB10:" + GetDateDiff(startDate, new Date()));
    // #endregion WHI
    // start biometric

    //totalstaff


    /*  startDate = new Date();
      aggregate.TStaff = GetReportsData("totalstaff", dataConst, true, fdt, tdt, facility).length;
      logs.push("TStaff:" + GetDateDiff(startDate, new Date()));
*/
    // biometric absent
    // startDate = new Date();
    // aggregate.BMA = GetReportsData("biometricabsent", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMA:" + GetDateDiff(startDate, new Date()));

    // // biometric present
    // startDate = new Date();
    // aggregate.BMP = GetReportsData("biometricpresent", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMP:" + GetDateDiff(startDate, new Date()));
    // // biometric entry early
    // startDate = new Date();
    // aggregate.BMENE = GetReportsData("biometricentryearly", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMENE:" + GetDateDiff(startDate, new Date()));
    // // biometric entry ontime
    // startDate = new Date();
    // aggregate.BMENOT = GetReportsData("biometricentryontime", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMENOT:" + GetDateDiff(startDate, new Date()));
    // // biometric entry late
    // startDate = new Date();
    // aggregate.BMENL = GetReportsData("biometricentrylate", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMENL:" + GetDateDiff(startDate, new Date()));
    // // biometric exit early
    // startDate = new Date();
    // aggregate.BMEXE = GetReportsData("biometricexitearly", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMEXE:" + GetDateDiff(startDate, new Date()));
    // // biometric exit ontime
    // startDate = new Date();
    // aggregate.BMEXOT = GetReportsData("biometricexitontime", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMEXOT:" + GetDateDiff(startDate, new Date()));
    // // biometric exit late
    // startDate = new Date();
    // aggregate.BMEXL = GetReportsData("biometricexitlate", dataConst, true, fdt, tdt, facility).length;
    // logs.push("BMEXL:" + GetDateDiff(startDate, new Date()));


    // #endregion biometric
  }


  if (null == onlyThese || onlyThese.indexOf("chi") > -1) {

    // #region CHI
    startDate = new Date();
    var chiLatest = GetReportsData("chilatest", dataConst, true, fdt, tdt, facility);

    var chiids = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.map(m => m.CenterNoteId) : [];

    aggregate.CPA = chiLatest && chiLatest.Assessments && chiLatest.Assessments.length > 0 ? chiLatest.Assessments.filter(f => chiids.indexOf(f.Id) == -1).length : 0;

    logs.push("CPA:" + GetDateDiff(startDate, new Date()));
    // Overall efficacy

    startDate = new Date();
    var COA = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
    logs.push("COA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.COE = !COA || COA.length == 0 ? 0 : Math.round(COA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (COA.length * 5), 2);
    logs.push("COE:" + GetDateDiff(startDate, new Date()));



    // center hygiene
    startDate = new Date();
    var CHG = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("center hygiene")) : [];


    aggregate.CHG = !CHG || CHG.length == 0 ? 0 : Math.round(CHG.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CHG.length * 5), 2);
    logs.push("CHG:" + GetDateDiff(startDate, new Date()));

    // washroom hygiene
    startDate = new Date();
    var CWH = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("washroon hygiene")) : [];

    aggregate.CWH = !CWH || CWH.length == 0 ? 0 : Math.round(CWH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CWH.length * 5), 2);
    logs.push("CWH:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    // center welcomeness
    var CWN = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("center welcomeness")) : [];

    aggregate.CWN = !CWN || CWN.length == 0 ? 0 : Math.round(CWN.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CWN.length * 5), 2);
    logs.push("CWN:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    // Suggestions
    var suggestions = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.indexOf("Appreciations / Suggestions") && m.Response) : [];
    aggregate.CAS = suggestions.length;
    logs.push("CAS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.CCA = chiLatest && chiLatest.Assessments && chiLatest.Assessments.length > 0 ? chiLatest.Assessments.length : 0 - aggregate.CPA;
    logs.push("CCA:" + GetDateDiff(startDate, new Date()));

    // #endregion CHI
  }
  if (null == onlyThese || onlyThese.indexOf("pisi") > -1) {

    // #region PISI
    startDate = new Date();
    var pisiLatest = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

    var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

    aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
    logs.push("TPA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
    aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
    logs.push("TOE:" + GetDateDiff(startDate, new Date()));

    // therapy improvemnet
    startDate = new Date();
    var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
    aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
    logs.push("TTI:" + GetDateDiff(startDate, new Date()));

    // Daily Homework Feedback
    startDate = new Date();
    var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

    aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
    logs.push("TDH:" + GetDateDiff(startDate, new Date()));
    // Daily after therapy interaction

    startDate = new Date();
    var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
    aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
    logs.push("TDA:" + GetDateDiff(startDate, new Date()));
    // Daily Homework Feedback

    startDate = new Date();
    var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



    aggregate.TASS = TAS.length;
    aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
    logs.push("TASS:" + GetDateDiff(startDate, new Date()));
    // #endregion PISI

    // #region Mirracles*/

    startDate = new Date();
    aggregate.MIRT = GetReportsData("mirraclestotal", dataConst, true, fdt, tdt, facility).length;
    logs.push("MIRT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.MIRC = GetReportsData("mirraclescontributed", dataConst, true, fdt, tdt, facility).length;
    logs.push("MIRC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.MIRNC = GetReportsData("mnotcontributed", dataConst, true, fdt, tdt, facility).length;
    logs.push("MIRNC:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.MIRV = GetReportsData("allmirraclesviews", dataConst, true, fdt, tdt, facility);
    logs.push("MIRV:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.MIRT100 = GetReportsData("mirraclestop100", dataConst, true, fdt, tdt, facility).length;
    logs.push("MIRT100:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.MIRB100 = GetReportsData("mirraclesbottom100", dataConst, true, fdt, tdt, facility).length;
    logs.push("MIRB100:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.MIRLC = GetReportsData("mirracleslc", dataConst, true, fdt, tdt, facility).length;
    logs.push("MIRLC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.MIRLNC = GetReportsData("mirraclesnotcovered", dataConst, true, fdt, tdt, facility);
    logs.push("MIRLNC:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.MAC = GetReportsData("mirraclepending", dataConst, true, fdt, tdt, facility).length;
    logs.push("MAC:" + GetDateDiff(startDate, new Date()));

    //var mirraclesFiltered = (mirracles || []).filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT);
    //var allmirracles = data.Mirracles.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) < TDT)).sort((a, b) => (b.F8 < a.F8 ? -1 : 1));

    //var top100Mirracles = (allmirracles || []).slice(0, 99).map(m=> m.Id);
    //var bottom100Mirracles = (allmirracles || []).slice(-100).map(m=> m.Id);

    //var mirraclesFilteredIncludingUpdate = (mirracles || []).filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) < TDT));

    //aggregate.MIRT100 =  mirraclesFilteredIncludingUpdate.filter(m => top100Mirracles.indexOf(m.Id) > -1).length;

    //aggregate.MIRB100 = mirraclesFilteredIncludingUpdate.filter(m => bottom100Mirracles.indexOf(m.Id) > -1).length;


    //mirraclesFiltered = mirraclesFiltered || [];

    //aggregate.MIRT = mirraclesFiltered.length;
    //try {
    //    aggregate.MIRC = Object.keys(groupBy(mirraclesFiltered, "PersonId")).length;
    //} catch (e) {

    //}



    //aggregate.MIRNC = Object.keys(groupBy(dataConst.People.filter(m => (m.RoleId == therapistId || m.RoleId == adminId) && m.F8 != 1 && m.RS != "DELETEACTIVITY"), "Id")).length - aggregate.MIRC;


    //aggregate.MIRV = (mirraclesFilteredIncludingUpdate || []).reduce(function (accumulator, item) {
    //    return accumulator + item.F8;
    //}, 0);


    //var languageIds = data.Types.filter(m => m.Category == "Languages").map(m => m.Id);
    //aggregate.MIRLC = Object.keys(groupBy(mirraclesFiltered, "LanguageId")).length;
    //aggregate.MIRLNC = languageIds.length - aggregate.MIRLC;

    // #endregion Mirracles*/
  }
  if (null == onlyThese || onlyThese.indexOf("dang") > -1) {

    // #region Dang*/
    var dangTypeId = GetTypeIdByName(dataConst.Types, "DANGANALYTIC");
    var currentDang = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(f => f.TypeId == dangTypeId && new Date(f.CDT) >= FDT && new Date(f.CDT) <= TDT) : [];

    aggregate.DYES = currentDang && currentDang && currentDang.length > 0 ? currentDang.filter(f => f.F7 == 1).length : 0;
    aggregate.DNO = currentDang && currentDang && currentDang.length > 0 ? currentDang.filter(f => f.F7 != 1).length : 0;

    // aggregate.DYES = dang.filter(f => f.IsDone == 1).length;
    // aggregate.DNO = dang.filter(f => f.IsDone != 1).length;
    aggregate.DOT = currentDang.filter(f => f.F6 != 1).length;
    aggregate.DLATE = currentDang.filter(f => f.F6 == 1).length;

    aggregate.DPM = CalculateDangPendingCount(currentDang, dangConfig, FDT, TDT, fids);

    var todayDang = currentDang.filter(f => dateFromSDateTime(f.CDT).toDateString() == new Date().toDateString());
    aggregate.DPD = CalculateDangPendingCount(todayDang, dangConfig, new Date(), new Date(), fids);
    // #endregion Dang*/
  }


  // startDate = new Date();
  // aggregate.DA=GetReportsData("pollincationclarity", dataConst, true, fdt, tdt, facility);
  // logs.push("DA:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  var dueAll = GetReportsData("dueall", dataConst, true, fdt, tdt, facility);


  //     return invoicesamount;
  aggregate.DA = dueAll ? dueAll.reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0) : 0;
  logs.push("DA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();

  aggregate.DO = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "overdue").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0);//  GetReportsData("dueoverdue", dataConst, true, fdt, tdt, facility);
  logs.push("DO:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.DT = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "today").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0);  // GetReportsData("duetoday", dataConst, true, fdt, tdt, facility);
  logs.push("DT:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.DTM = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "tomorrow").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0); //  GetReportsData("duetomorrow", dataConst, true, fdt, tdt, facility);
  logs.push("DTM:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.DTW = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "thisweek").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0); //GetReportsData("duethisweek", dataConst, true, fdt, tdt, facility);
  logs.push("DTW:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.DNW = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "nextweek").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0);  //GetReportsData("duenextweek", dataConst, true, fdt, tdt, facility);
  logs.push("DNW:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.DTMN = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "thismonth").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0); //GetReportsData("duethismonth", dataConst, true, fdt, tdt, facility);
  logs.push("DTMN:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.DNM = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "nextmonth").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0); //GetReportsData("duenextmonth", dataConst, true, fdt, tdt, facility);
  logs.push("DNM:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.DF = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "future").reduce(function (accumulator, item) {
    return accumulator + (item["Amount"]);
  }, 0);//GetReportsData("duefuture", dataConst, true, fdt, tdt, facility);
  logs.push("DF:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.DEP = GetReportsData("etapending", dataConst, true, fdt, tdt, facility);
  console.log("ETA PENDING Time:" + GetDateDiff(startDate, new Date()));
  logs.push("DEP:" + GetDateDiff(startDate, new Date()));













  startDate = new Date();
  aggregate.WD = dataConst.TWD;
  logs.push("TWD:" + GetDateDiff(startDate, new Date()));

  var pendingClarity = GetReportsData("pinnacleclaritypending", dataConst, true, fdt, tdt, facility);
  var pinnacleClarityPending = (pendingClarity || []).filter(e => (!e.Reply || e.Reply == ''));
  var pinnacleClarityCompleted = (pendingClarity || []).filter(e => !(!e.Reply || e.Reply == ''));
  aggregate.PCLAP = pinnacleClarityPending && pinnacleClarityPending.length > 0 ? pinnacleClarityPending.length : 0;
  aggregate.PCLAC = pinnacleClarityCompleted && pinnacleClarityCompleted.length > 0 ? pinnacleClarityCompleted.length : 0;

  aggregate.BUSINESS = (parseInt(aggregate.PP) + parseInt(aggregate.PPE) + parseInt(aggregate.PA) + parseInt(aggregate.APEN));


  startDate = new Date();
  aggregate.PCP = GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
  logs.push("PCP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.TGNS = GetReportsData("goalsnotset", dataConst, true, fdt, tdt, facility).length;
  // logs.push("TGNS:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.TGNS = GetReportsData("aigoalsnotset", dataConst, true, fdt, tdt, facility).length;
  logs.push("TGNS:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.DAIP = GetReportsData("demographicaipending", dataConst, true, fdt, tdt, facility).length;
  console.log("demographicai PENDING Time: " + GetDateDiff(startDate, new Date()));
  logs.push("DAIP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.KPIAP = GetReportsData("attendancepending", dataConst, true, fdt, tdt, facility);
  // logs.push("AP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.AP = GetReportsData("kpiattendancepending", dataConst, true, fdt, tdt, facility);
  // logs.push("AP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.AP = GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
  logs.push("AP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.KIDAP = GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
  // logs.push("KIDAP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var compodataa = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
  aggregate.CPC = compodataa > 0 ? compodataa : 0;
  logs.push("CPC:" + GetDateDiff(startDate, new Date()));

  //startDate = new Date();
  //aggregate.AGP = GetReportsData("therapiesprovided", dataConst, true, fdt, tdt, facility).length;
  //logs.push("AGP:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.AGP = GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
  logs.push("AGP:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.AGA = GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
  logs.push("AGA:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.TOA = aggregate.AP + aggregate.AGP + aggregate.AGA;
  logs.push("TOA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.ABS = (aggregate.AGA - aggregate.CST) > 0 ? (aggregate.AGA - aggregate.CST) : 0;
  logs.push("ABS:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
  logs.push("GR:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.AWARDS = GetReportsData("awardswon", dataConst, true, fdt, tdt, facility).length;
  logs.push("AWARDS:" + GetDateDiff(startDate, new Date()));

  ///POLLINATION

  // startDate = new Date();
  // aggregate.PCP =GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
  // logs.push("PCP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCC = GetReportsData("pollinationclaritycompleted", dataConst, true, fdt, tdt, facility);
  logs.push("PCC:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCYT = GetReportsData("pollinationclarityyetto", dataConst, true, fdt, tdt, facility);
  logs.push("RPCYTCTD:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCZ = GetReportsData("pollinationclarityzero", dataConst, true, fdt, tdt, facility);
  logs.push("PCZ:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.PCLT = GetReportsData("pollinationclaritylessthanthree", dataConst, true, fdt, tdt, facility);
  logs.push("PCLT:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PCGT = GetReportsData("pollinationclaritygreaterthanthree", dataConst, true, fdt, tdt, facility);
  logs.push("PCGT:" + GetDateDiff(startDate, new Date()));


  //  startDate = new Date();
  //  aggregate.PAO=GetReportsData("pollinationopty", dataConst, true, fdt, tdt, facility);
  //  logs.push("PAO:" + GetDateDiff(startDate, new Date()));





  ///POLLINATION


  /*startDate = new Date();
  var pisiLatesttherapy = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

  var pisiids = pisiLatesttherapy.Reponses.map(m => m.PeopleNoteId);


  startDate = new Date();
  var TOA = pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy"));
  aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
  logs.push("TOE:" + GetDateDiff(startDate, new Date()));

  var TAS = pisiLatesttherapy && pisiLatesttherapy.length > 0 ? pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



  aggregate.TASS = TAS.length;
  //aggregate.TCA = pisiLatest && pisiLatest.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
  logs.push("TASS:" + GetDateDiff(startDate, new Date()));
  */

  // #region PISI
  startDate = new Date();
  var pisiLatest = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

  var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

  aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
  logs.push("TPA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
  aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
  logs.push("TOE:" + GetDateDiff(startDate, new Date()));

  // therapy improvemnet
  startDate = new Date();
  var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
  aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
  logs.push("TTI:" + GetDateDiff(startDate, new Date()));

  // Daily Homework Feedback
  startDate = new Date();
  var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

  aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
  logs.push("TDH:" + GetDateDiff(startDate, new Date()));
  // Daily after therapy interaction

  startDate = new Date();
  var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
  aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
  logs.push("TDA:" + GetDateDiff(startDate, new Date()));
  // Daily Homework Feedback

  startDate = new Date();
  var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



  aggregate.TASS = TAS.length;
  aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
  logs.push("TASS:" + GetDateDiff(startDate, new Date()));
  // #endregion PISI

  startDate = new Date();
  var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
  aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 > 0 ? whiLatest.Assessments.length : 0;
  logs.push("PROA:" + GetDateDiff(startDate, new Date()));
  var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];

  startDate = new Date();
  aggregate.PROS = whiLatest && whiLatest.length > 0 ? whiLatest.Suggestions.length : 0;
  logs.push("PROS:" + GetDateDiff(startDate, new Date()));


  //if (role == "Therapist") {
  //    startDate = new Date();
  //    aggregate.TOE = GetReportsData("pisirating", dataConst, true, fdt, tdt, facility).length;
  //    logs.push("TOE:" + GetDateDiff(startDate, new Date()));
  //}



  //startDate = new Date();
  //aggregate.MIRT = GetReportsData("mirracles", dataConst, true, fdt, tdt, facility).length;
  //logs.push("MIRT:" + GetDateDiff(startDate, new Date()));

  /*startDate = new Date();
  aggregate.RP = GetReportsData("feedbackspending", dataConst, true, fdt, tdt, facility).length;
  logs.push("RP:" + GetDateDiff(startDate, new Date()));*/
  //Change below like above


  startDate = new Date();
  aggregate.RG = GetReportsData("feedbacksgiven", dataConst, true, fdt, tdt, facility).length;
  logs.push("RG:" + GetDateDiff(startDate, new Date()));


  // Homework pending
  startDate = new Date();
  aggregate.RP = GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  logs.push("RP:" + GetDateDiff(startDate, new Date()));

  // startDate = new Date();
  // aggregate.RP = aggregate.AGP - aggregate.RG;//  GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  // logs.push("RP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RGT = GetReportsData("feedbackratings", dataConst, true, fdt, tdt, facility);
  logs.push("RGT:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RAT = aggregate.RG ? (aggregate.RGT / aggregate.RG).toFixed(2) : 0;
  logs.push("RAT:" + GetDateDiff(startDate, new Date()));
  //TOE
  //AGP
  //CPC
  //Goals for therapist
  startDate = new Date();
  aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
  logs.push("GR:" + GetDateDiff(startDate, new Date()));

  //Goal Pending for therapist
  startDate = new Date();
  aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
  console.log("GOALS PENDING Time: " + GetDateDiff(startDate, new Date()));
  logs.push("GP:" + GetDateDiff(startDate, new Date()));

  //services

  startDate = new Date();
  aggregate.SF = GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
  logs.push("CST:" + GetDateDiff(startDate, new Date()));

  //Assessments

  startDate = new Date();
  var allAssessmentsData = dataConst.Assessmentsdata;

  startDate = new Date();
  aggregate.ASP = allAssessmentsData.filter(m => m.Status.toLowerCase() != "completed" && dateFromSDateTime(m.CDT) >= FDT).length;
  logs.push("ASP:" + GetDateDiff(startDate, new Date()));

  // Completed assessment
  startDate = new Date();
  aggregate.AST = GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
  logs.push("AST:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);

  aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
  logs.push("PROA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
  logs.push("PROS:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
  aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
  logs.push("PROP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
  logs.push("PROT10:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
  logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
  logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
  logs.push("PROB10:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  var allrenewalClarity = GetReportsData("renewalclarityall", dataConst, true, fdt, tdt, facility);
  // var AllFeeETA = data.filter(e =>  (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity"+e.Details.toLowerCase()+""));

  aggregate.RCA = allrenewalClarity.length;
  logs.push("RCA:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();

  aggregate.RCOD = allrenewalClarity.filter(f => f.Details == "overdue").length;//  GetReportsData("renewalclarityoverdue", dataConst, true, fdt, tdt, facility);
  logs.push("RCOD:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCTD = allrenewalClarity.filter(f => f.Details == "today").length; //GetReportsData("renewalclaritytoday", dataConst, true, fdt, tdt, facility);
  logs.push("RCTD:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCTR = allrenewalClarity.filter(f => f.Details == "tomorrow").length; //GetReportsData("renewalclaritytomorrow", dataConst, true, fdt, tdt, facility);
  logs.push("RCTR:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.RCTW = allrenewalClarity.filter(f => f.Details == "thisweek").length; //GetReportsData("renewalclaritythisweek", dataConst, true, fdt, tdt, facility);
  logs.push("RCTW:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCNW = allrenewalClarity.filter(f => f.Details == "nextweek").length; //GetReportsData("renewalclaritynextweek", dataConst, true, fdt, tdt, facility);
  logs.push("RCNW:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.RCTM = allrenewalClarity.filter(f => f.Details == "thismonth").length; //GetReportsData("renewalclaritythismonth", dataConst, true, fdt, tdt, facility);
  logs.push("RCTM:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCNM = allrenewalClarity.filter(f => f.Details == "nextmonth").length; //GetReportsData("renewalclaritynextmonth", dataConst, true, fdt, tdt, facility);
  logs.push("RCNM:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCOT = allrenewalClarity.filter(f => f.Details == "others").length; //GetReportsData("renewalclarityothers", dataConst, true, fdt, tdt, facility);
  logs.push("RCOT:" + GetDateDiff(startDate, new Date()));


  startDate = new Date();
  aggregate.RCP = allrenewalClarity.filter(f => f.Details == "pending").length; //GetReportsData("renewalclaritypending", dataConst, true, fdt, tdt, facility);
  logs.push("RCP:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.RCR = allrenewalClarity.filter(f => f.Details == "renewed").length; //GetReportsData("renewalclarityrenewed", dataConst, true, fdt, tdt, facility);
  logs.push("RCR:" + GetDateDiff(startDate, new Date()));
  startDate = new Date();
  aggregate.RCTBR = aggregate.RCA - aggregate.RCR - aggregate.RCP - aggregate.RCOT;
  logs.push("RCTBR:" + GetDateDiff(startDate, new Date()));
  startDate = new Date();
  var pendingCourses = GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);


  //start kid state Region

  startDate = new Date();
  var kidStatuses = GetReportsData("kidconditionsandbehaviours", dataConst, true, fdt, tdt, facility);

  aggregate.KIDCON = kidStatuses && kidStatuses.length > 0 ? kidStatuses.filter(e => e.ConditionsRange == "Pending").length : 0;
  aggregate.KIDBEH = kidStatuses && kidStatuses.length > 0 ? kidStatuses.filter(e => e.BehavioursRange == "Pending").length : 0;
  logs.push("RCTBR:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.PMILES = GetReportsData("pendingmilestones", dataConst, true, fdt, tdt, facility);
  console.log("PMILES:" + GetDateDiff(startDate, new Date()));
  logs.push("PMILES:" + GetDateDiff(startDate, new Date()));

  startDate = new Date();
  aggregate.CMILES = GetReportsData("completedmilestones", dataConst, true, fdt, tdt, facility);
  console.log("CMILES:" + GetDateDiff(startDate, new Date()));
  logs.push("CMILES:" + GetDateDiff(startDate, new Date()));


  aggregate.TCOP = pendingCourses.totalPending;
  aggregate.TTP = pendingCourses.totalTantrumsPending;
  aggregate.TCNP = pendingCourses.totalConditionsPending;
  aggregate.TPISI = pendingCourses.ptiPendingAssesmsnets;
  logs.push("PENDINGCOURCES:" + GetDateDiff(startDate, new Date()));

  console.log("OWNERAGGREGTAES:" + GetDateDiff(initialStart, new Date()));
  console.log(logs);
  return aggregate;
}

export function SetCurrentComponentName(name) {
  localStorage.setItem("CURRENTCOMPONENTNAME", name);
}
export function GetCurrentComponentName() {
  return localStorage.getItem("CURRENTCOMPONENTNAME");
}


export function PrepAggregates(role, data, aggregateType, facility, $this, onlyThese, fromDate, toDate, prepedData) {
  try {

    console.log("LEADERS SYNC : START " + new Date());
    onlyThese = onlyThese || null;
    if (!data || !data.Centers) {
      return {};
    }
    var aggregate = {};



    // console.log(facility);
    var fids = [];
    if (facility) {
      fids = (facility + "").split(",").map(m => parseInt(m));
    }
    else {
      fids = data.Centers.map(m => m.Id);
    }

    aggregate.FId = fids;

    var fsIds = fids.map(m => m + "");

    //console.log(fids);

    var todayDate = new Date();

    var fdt = fromDate ? fromDate : new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
    var tdt = toDate ? toDate : new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0, 23, 59, 59);
    var FDT = fdt;
    var TDT = tdt;
    var logs = [];
    var inittialStart = new Date();
    var startDate = new Date();
    var dataConst = {};

    dataConst = GetPrepData(role, data, fromDate, toDate, fids, $this);
    // if(prepedData)
    // {
    //     dataConst = prepedData;
    // }
    // else{

    // }
    var startDate = new Date();
    switch (role.toUpperCase()) {
      case "BOSS":
        console.log("BOSS SYNC : START " + new Date());
        startDate = new Date();
        aggregate = PrepBossAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese);
        console.log("BOSS SYNC : END " + GetDateDiff(startDate, new Date()));
        break;
      case "THERAPIST":
        console.log("Therapist SYNC : START " + new Date());
        startDate = new Date();
        aggregate = PrepTherapistAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese);
        console.log("Therapist SYNC : END " + GetDateDiff(startDate, new Date()));
        break;
      default:
        console.log("Senior SYNC : START " + new Date());
        startDate = new Date();
        aggregate = PrepOwnerAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese, role);
        console.log("Senior SYNC : END " + GetDateDiff(startDate, new Date()));
        break;

    }

    //THIS IS FOR AUTISM GPT STORE BUILDING
    localStorage.setItem("AutismGPTConfigRefresh", "TRUE");

    // logs.push("Prep:" + GetDateDiff(startDate, new Date()));
    // if (role == "Admin" || role == "Receptionist" || role == "NCC" || role == "Owner"|| role=="FacilityOwner" || role=="Senior" || role=="Manager" || role == "Investor" || role == "Harvest") {


    //     // #endregion Pendings
    // }

    // try {

    //     if ((!onlyThese || onlyThese.length == 0) && (role == "Therapist" || role == "Senior" || role == "Admin" || role == "Harvest" || role == "Receptionist" || role == "Receptionist" || role == "NCC" || role == "Owner"|| role == "FacilityOwner" || role == "Investor" || role== 'Manager')) {



    //     }



    // }
    // catch (e) {
    //     console.log(e);
    // }
    // try {
    //     if (role == "Boss") {


    //     }

    //     else
    //     {

    //     }
    // }
    // catch (e) {

    //     SaveCleintWaufli(e,"Prep Aggregates Failed","PrepAggregates");

    //     console.log(e);
    // }



    if (null == onlyThese) {


      var endDate = new Date();
      console.log(inittialStart);
      var log = data.CFUser.Handle + "," + role + ","
        + inittialStart.getHours() + ":" + inittialStart.getMinutes() + ":" + inittialStart.getUTCSeconds() + ","
        + endDate.getHours() + ":" + endDate.getMinutes() + ":" + endDate.getUTCSeconds() + "," +
        GetDateDiff(inittialStart, endDate) + ","
        + logs.join(",");
      var exception = {};
      exception.Type = "CLIENTPREPAGGREGATES1V";
      exception.Message = log;
      // SaveExceptionToSentry(exception, "Transaction", getUserToken(), "CLIENTPREPAGGREGATES1V");
    }

    console.log("LEADERS SYNC : END " + new Date());
    bbp.Log("PA", inittialStart, new Date());
    aggregate.CDT = new Date();
    return aggregate;
  }
  catch (e) {
    SaveCleintWaufli(e, "Prep Aggregates Failed", "PrepAggregates");

  }
}

export function PrepIndividualCenterAggregates($this, data) {
  console.log("PrepIndividualCenterAggregates");


  if (!data || !data.Centers) {
    return {};
  }




  //console.log(fids);






  //  var dataConst = GetPrepData("Owner", data,null,null,data.Centers.map(m => m.Id),$this);




  var aggregates = [];
  data.Centers.forEach(function (center) {
    var agg = PrepAggregates("Owner", data, "MONTHLYAGGREGATES", center.Id + "", $this, ["money"]);
    agg.GID = center.Id;
    agg.CenterName = center.Name;
    aggregates.push(agg);

  });
  //     res(aggregates);
  // });

  return aggregates;

}

function getAggregateValue(isleader) {
  var month = 0;
  var year = 0;
  var type = "ASON";
  var radioValue = $("input[name='custom-health-filter']:checked").val();
  console.log(radioValue);
  if (radioValue == "thismonth") {
    month = new Date().getMonth() + 1;
    year = new Date().getFullYear();
    type = "thismonth";
  }
  if (radioValue == "custom") {
    month = $("#business-month option:selected").val();
    year = $("#business-year option:selected").val();
    type = "custom";
  }
  var range = "";
  if (radioValue == "today" || radioValue == "thisweek" || radioValue == "yesterday") {
    range = radioValue;
  }
  if (isleader && isleader == "false") {
    month = $("#BTbusiness-month option:selected").val();
    year = $("#BTbusiness-year option:selected").val();

  }
  var obj = {};
  obj.month = month;
  obj.year = year;
  obj.range = range;
  obj.type = type;
  return obj;
}
function validation(event) {

  //console.log(event.target.value + "naveen");
  var value = event.target.value;
  var id = event.target.id;
  showValidationtext(value, id);

}
function isDateValid(value) {
  var dateWrapper = new Date(value);
  return !isNaN(dateWrapper.getDate());
}
function GetDateFormatValue(dateValue) {
  try {
    var minDate = "1900-01-01"
    var dates = new Date(dateValue);
    var someDate = !isNaN(dates) && dates ? dates : new Date("1900-01-01");
    someDate.setDate(someDate.getDate());
    var date = someDate.toISOString().substr(0, 10);

    if (date.toString() == "0001-01-01" || date.toString() == "01-01-0001") {
      date = minDate;
    }
    return date;
  }
  catch (e) {
    console.log(e);
  }

}
export function GetDateesofrleave(dateValue) {
  var minDate = "1900-01-01"
  var someDate = dateValue ? new Date(dateValue) : new Date("0001-01-01");
  someDate.setDate(someDate.getDate() + 1);
  var date = someDate.toISOString().substr(0, 10);

  if (date.toString() == "0001-01-01" || date.toString() == "01-01-0001") {
    date = minDate;
  }
  return date;
}
function GetTimeFormatValue(timeValue) {
  var minTime = "00:00:00"
  return timeValue ? new Date(timeValue) : new Date("0001-01-01");
  //return date;
}

function CaptializeText(str) {
  if (!str) {
    return '';
  }

  const arr = str.toLowerCase().split(" ");

  //loop through each element of the array and capitalize the first letter.


  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

  }

  //Join all the elements of the array back into a string
  //using a blankspace as a separator
  return arr.join(" ");
}

function getRedirectionURL(Htype, currentuser, role, openUrl, fid) {
  var facilityId = fid && typeof fid != 'object' ? fid : $('#insightsFacility option:selected').val();
  var facilityText = fid && typeof fid != 'object' ? fid : $('#insightsFacility option:selected').text();

  var leaderRoles = ["receptionist", "manager", "owner", "ccc", "harvestadmin", "facilityowner"];


  if (!facilityId) {
    facilityId = "";
  }
  if (Htype && Htype == "dailyattendance") {
    var date = $('#att-label-date-from').val();
    var status = $('#att-status  option:selected').val();
  }


  var radioValue = $("input[name='custom-health-filter']:checked").val();
  var month = 0;
  var year = "";
  var type = "ASON";
  if (radioValue == "thismonth") {
    month = new Date().getMonth() + 1;
    year = new Date().getFullYear().toString();
    type = "thismonth";
  }
  if (radioValue == "custom") {
    var month = $("#business-month option:selected").val();
    var year = $("#business-year option:selected").val();

    type = "custom";
  }
  var range = "";
  if (radioValue == "today" || radioValue == "thisweek" || radioValue == "yesterday") {
    range = radioValue;
  }
  var fdt = "";
  var tdt = "";
  if (radioValue == "today") {
    var date = $("#business-date-filter").val();
    if (date) {
      fdt = date;
      tdt = date;
    }
  }
  if (!month) {
    month = 0;
  }
  var isFDTENable = true;
  var GHtitle = "";
  switch (Htype.toLowerCase()) {
    case "newpayments":
      isFDTENable = false;

      var st = "";
      var filterType = "";
      if (role) {
        var drole = role.split("{#}");
        st = drole[0];

        if (drole.length > 1) {
          filterType = drole[1];
        }
      }

      var url = "/payments?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&status=" + (st) + "&filtertype=" + filterType + "&radiofiltertype=" + radioValue;
      break;
    case "leavespending":
    case "leavesall":
    case "allleaves":
    case "leavesapproved":
    case "leavesunapproved":
      let ft = Htype == "leavespending" ? "pending" : Htype == "leavesapproved" ? "approved" : Htype == "leavesunapproved" ? "unapproved" : ""

      var url = "/alltherapistleaves?ft=" + ft + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&status=" + (st) + "&filtertype=" + filterType + "&radiofiltertype=" + radioValue;
      break;

    case "discountbusiness":
    case "pastpaid":
    case "advancepaidseva":
    case "advancepaid":
    case "paidseva":
    case "paid":
    case "paymentpending":
    case "advancepending":
    case "pastpending":
    case "overallpending":
    case "pinnacleclaritypending":
    case "business":
    case "inflow":
    case "outflow":
      var headerName = Htype == "discountbusiness" ? "discount" : Htype == "pastpaid" ? "Past Paid" : Htype == "paymentpending" ? "Pending" : Htype == "advancepending" ? "Advance Pending" : Htype == "pastpending" ? "Past Pending" : Htype == "advancepaidseva" ? "Advance Paid Seva" : Htype == "advancepaid" ?
        "Advance Paid" : Htype == "paidseva" ? "Paid Seva" : Htype == "overallpending" ? "Over All Pending" : Htype == "pastpending" ? "Past Pending" : Htype == "pinnacleclaritypending" ? "Pinnacle Clarity Report" : Htype == "business" ? "Business" : Htype == "inflow" ? "Inflow" : Htype == "outflow" ? "Outflow" : "Paid";
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;

      break;

    case "dueall":
    case "dueoverdue":
    case "duetoday":
    case "duetomorrow":
    case "duethisweek":
    case "duenextweek":
    case "duethismonth":
    case "duenextmonth":
    case "duefuture":
    case "etapending":

      var headerName = Htype == "dueall" ? "All Due" : Htype == "duetoday" ? "Today Due" : Htype == "dueoverdue" ? "Overdue" : Htype == "duetomorrow" ? "Tomorrow Due"
        : Htype == "duethisweek" ? "This Week" : Htype == "duenextweek" ? "Next Week" : Htype == "duethismonth" ?
          "This Month" : Htype == "duenextmonth" ? "Next Month" : Htype == "duefuture" ? "Future Month" : Htype == "etapending" ? "Pending ETA" : "";

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;

      break;
    case "renewalclarityall":
    case "renewalclarityoverdue":
    case "renewalclaritytoday":
    case "renewalclaritytomorrow":
    case "renewalclaritythisweek":
    case "renewalclaritynextweek":
    case "renewalclaritythismonth":
    case "renewalclaritynextmonth":
    case "renewalclarityothers":
    case "renewalclaritypending":
    case "renewalclarityrenewed":
    case "renewalclaritytoberenewed":

      var headerName = Htype == "renewalclaritytoberenewed" ? "To Be Renewed" : Htype == "renewalclarityrenewed" ? "Renewed" : Htype == "renewalclarityall" ? "All" : Htype == "renewalclarityoverdue" ? "Overdue" : Htype == "renewalclaritytoday" ? "Today" : Htype == "renewalclaritytomorrow" ? "Tomorrow"
        : Htype == "renewalclaritythisweek" ? "This Week" : Htype == "renewalclaritynextweek" ? "Next Week" : Htype == "duerenewalclaritythismonththismonth" ?
          "This Month" : Htype == "renewalclaritynextmonth" ? "Next Month" : Htype == "renewalclarityothers" ? "Not Renewing" : Htype == "renewalclaritypending" ? "Pending" : "";

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;


      break;
    case "pendingmilestones":
    case "completedmilestones":
      var headerName = Htype == "pendingmilestones" ? "Pending Milestones" : "Completed Milestones";
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;


      break;


    case "pollinationclaritypromised":
    case "pollinationclaritycompleted":
    case "pollinationclarityyetto":
    case "pollinationclarityzero":
    case "pollinationclaritylessthanthree":
    case "pollinationclaritygreaterthanthree":
    case "pollinationopty":
    case "pollinationoptyst":
    case "pollinationoptyot":
    case "pollinationoptyaba":
    case "pollinationoptyse":


      var headerName = Htype == "pollinationclaritypromised" ? "Promised" : Htype == "pollinationclaritycompleted" ? "Completed" : Htype == "pollinationclarityyetto" ? "YetTo" : Htype == "renewalclarityoverdue" ? "Overdue" : Htype == "renewalclaritytoday" ? "Today" : Htype == "renewalclaritytomorrow" ? "Tomorrow"
        : Htype == "pollinationclarityzero" ? "Zero" : Htype == "pollinationclaritylessthanthree" ? "Less than 3" : Htype == "pollinationclaritygreaterthanthree" ?
          "Greater then 3" : Htype == "pollinationopty" ? "Opty" : Htype == "pollinationoptyst" ? "ST" : Htype == "pollinationoptyaba" ? "ABA" : Htype == "pollinationoptyot" ? "OT" : Htype == "pollinationoptyse" ? "SE" : "";

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;


      break;

    case "feedbacksgiven":
    case "feedbackratings":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Feedbacks&rtype=feedbacksgiven";

      break;
    case "pollinatebytherapy":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Pollinate&rtype=pollinatebytherapy&FilterType=" + role;
      break;

    case "viewpayslips":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=View Payslips&rtype=viewpayslips";
      break;
    case "salarystatement":
      var url = "/salarystatement?facility=" + facilityId;
      //var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Salary Statement&rtype=salarystatement";
      break;
    case "attendancesheet":
      var url = "/attendancesheet?facility=" + facilityId;
      break;
    case "demographicaipending":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Demographic AI&rtype=demographicaipending";
      break;
    case "downloadpayslips":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Download Payslips&rtype=downloadpayslips";
      break;
    case "coursescompleted":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Completed Courses&rtype=coursescompleted";
      break;
    case "dangpendingtoday":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Dang Today Pending&rtype=dangpendingtoday";
      break;

    case "therapistpti":
    case "adminpti":
      month = currentuser && currentuser.PTILM > 0 ? currentuser.PTILM : month;
      year = currentuser && currentuser.PTILY > 0 ? currentuser.PTILY : year;
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + ((Htype && Htype.toLowerCase() == "therapistpti" ? "PISI" : "CHI") + " " + CaptializeText(role)) + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "compenstation":

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + " " + CaptializeText("Compenstation " + (role ? role : '')) + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "therapistptireport":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + ((Htype && Htype.toLowerCase() == "therapistpti" ? "PISI" : "CHI") + " " + CaptializeText(role)) + "&rtype=" + Htype + "&FilterType=" + role + "&isFromLocal=true";
      break;
    case "servicerequest":
    case "servicerequestactive":
    case "servicerequestrating":
    case "servicerequestwaiting":
    case "servicerequestresolved":
    case "servicerequestreopened":
    case "servicerequestrating1":
    case "servicerequestrating2":
    case "servicerequestrating3":
    case "servicerequestrating4":
    case "servicerequestrating5":
    case "sevatenurecompletion":
    case "servicerequestclosedbyus":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (role == "expire" ? "SEVA Tenure Completion" : "Service Request " + CaptializeText(role ? role : '')) + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "leaverequestanalytic":
    case "leaverequestnonparent":
    case "leaverequestparent":
    case "leaverequestparentfuture":
    case "leaverequestparentcanceled":
    case "leaverequestparentcompleted":
    case "leaverequestanalyticunapproved":
    case "leaverequestnonparentcompleted":
    case "leaverequestnonparentfuture":
    case "leaverequestnonparentcanceled":
    case "leaverequestcomposlt4":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + ("Leave Request " + CaptializeText(role ? role : '')) + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "sevadocs":
    case "discountdocs":
    case "voucherdocs":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (Htype == "sevadocs" ? "Seva Docs" : Htype == "discountdocs" ? "Discount Docs" : "Gift Vouchers") + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "pinnaclegiveawayoffer":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Offers&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "availvoucherdocs":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (Htype == "availvoucherdocs" ? "Available Vouchers" : "Available Vouchers") + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "gracecompensation":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + (Htype == "gracecompensation" ? "Grace Compensation" : "Grace Compensation") + "&rtype=" + Htype;
      break;
    case "noprofileusers":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + (Htype == "noprofileusers" ? "NO Profile Pics" : "No Profile Pics") + "&rtype=" + Htype;
      break;
    case "familynotaddedd":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=Family Pending&rtype=familynotaddedd";
      break;
    case "coworkers":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + ("Co-Workers") + "&rtype=" + Htype + "&isFromLocal=true";
      break;
    case "pinnaclerenewaloffer":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + ("Renewals") + "&rtype=" + Htype + "&isFromLocal=true&FilterType=" + role;
      break;
    case "empoweringkids":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + ("Empowring") + "&rtype=" + Htype + "&isFromLocal=true";
      break;
    case "allinvoices":

      var url = "/allinvoices?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (Htype == "sevadocs" ? "Seva Docs" : "Discount Docs") + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "overallpti":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=PTI&rtype=overallpti";
      break;
    case "coursespending":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Pending Courses&rtype=coursespending";
      break;

    case "tobefulfilled":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=To-be Fulfilled&rtype=tobefulfilled";
      break;
    //case "newprofits":
    //    isFDTENable = false;
    //    var url = "/payments?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + currentuser.FDT + "&TDT=" + currentuser.TDT + "&status=" + (role ? role : "");
    //    break;
    case "payments":
      var url = "/d/PaymentsRecievedInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range;
      break;
    case "paymenttype":
      var url = "/d/PaymentInsightsByType?facility = " + facilityId + "&month=" + month + "&year=" + year + " &status=Paid&mode=" + Htype + "&range=" + range;
      break;
    case "paidfee":
      var url = "/d/MonthlyPaidInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=paid" + "&range=" + range;

    case "alreadypaid":

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Advance Cleared&rtype=alreadyfulfilled&FilterType=";

      break;


    case "biometriclateearly":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&month=" + month + "&year=" + year + "&hname=Impunctual&rtype=biometriclateearly";


      break;
    case "pendingfee":
      var url = "/d/PaymentInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=Pending" + "&range=" + range;
      break;
    case "seva":
      var url = "/d/SevaPaymentInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "totalseva":
      var url = "/d/SevaInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "fixedexpenses":
      var url = "/d/ExpensesInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&IsOnlyForStaff=NO&hname=fixed";
      GHtitle = "Expenses";

      break;


    case "expensesreport":

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (role == "outflow" ? "Outflow" : (role && role.toUpperCase() == "VARIABLEEXPENSES" ? "Variable " : role && role.toUpperCase() == "FIXEDEXPENSES" ? "Fixed " : "") + "Expanses") + "&rtype=expensesreport&FilterType=" + role;


      break;
    case "outflowreport":

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=OutFlow&rtype=outflowreport&FilterType=";


      break;


    case "dang":

      var url = "/dangkpi?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Dang&rtype=dangreport&FilterType=" + role;


      break;
    case "parentsnotusingapp":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Parents Not Using App&rtype=parentsnotusingapp&FilterType=";
      break;
    case "proquery":

      month = currentuser && currentuser.PROLM > 0 ? currentuser.PROLM : month;
      year = currentuser && currentuser.PROLY > 0 ? currentuser.PROLY : year;

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=WHI" + (role ? " " + (role == "Top40" ? "Middle40" : role == "Bottom10" ? "Worst10" : role) : "") + "&rtype=proquery&FilterType=" + role;
      break;
    case "pisirankquery":
      month = currentuser && currentuser.PTILM > 0 ? currentuser.PTILM : month;
      year = currentuser && currentuser.PTILY > 0 ? currentuser.PTILY : year;

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=PISI" + (role ? " " + (role == "Top40" ? "Middle40" : role == "Bottom10" ? "Worst10" : role) : "") + "&rtype=pisirankquery&FilterType=" + role;
      break;

    case "expenses":


      //kpireport?facility=&month=8&year=2025&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Fixed%20Expanses&rtype=expensesreport&FilterType=fixedexpenses&FDT=&TDT=&range=
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&IsOnlyForStaff=" + (role && role.toLowerCase() == "therapist" ? "YES" : "NO") + "&radiofiltertype=thismonth&hname=Food__Snacks&rtype=expensesreport&FilterType=variableexpenses";
      //GHtitle = "Expenses";
      // if (role && role.toLowerCase() == "therapist") {
      //     GHtitle = "Food__Snacks";

      // }
      openUrl = true;
      break;
    case "salary":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Salaries" + "&rtype=salary&FilterType=";
      break;
    case "paymentinsights":
      var url = "/d/PaymentInsights?userId=" + currentuser.Id + "&month=" + (new Date().getMonth() + 1) + "&year=" + new Date().getFullYear() + "&facility=" + facilityId;
      break;
    case "services":
      var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=all&month=" + month + "&year=" + year;
      break;

    case "addedservices":
      var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=new&month=" + month + "&year=" + year;
      break;
    case "closedservices":
      var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=lost&month=" + month + "&year=" + year;
      break;
    case "abnormalservices":
      var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=abnormal&month=" + month + "&year=" + year;
      break;
    case "unhappyservices":
      var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=unhappy&month=" + month + "&year=" + year;
      break;
    case "attendance":
      var url = "/d/TherapistStarAttendance?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=";
      break;
    case "pendingattendance":
    case "attendancepresent":
    case "attendanceabsent":
    case "homeworkpending":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + "Attendance" + "&rtype=" + Htype + "&FilterType=" + role;
      break;
    case "pendingattendanceai":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + "Attendance" + "&rtype=pendingattendanceai&FilterType=" + role;
      break;
    case "compospending":
    case "compenstations":
      //var url = "/d/TherapistStarAttendance?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=pending";
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + "Compensations" + "&rtype=" + Htype + "&FilterType=" + role;
      // var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Pending Attendance&rtype=pendingattendance";

      break;
    case "mirraclepending":
      //var url = "/d/TherapistStarAttendance?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=pending";

      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Mirracle Pending&rtype=mirraclepending";

      break;

    //mirraclepending

    case "parentrating":
      var url = "/d/ParentRating?facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "pendingparentrating":
      var url = "/d/ParentRating?status=pending&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "allparentrating":
      var url = "/d/ParentRating?status=all&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "allassessments":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessments&rtype=allassessments";
      break;
    case "consecutiveleaves":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Consecutive Leaves&rtype=consecutiveleaves";
      break;
    case "allrenewals":
      var st1 = "";
      var filterType1 = "";
      if (role) {
        var drole1 = role.split("{#}");
        st1 = drole1[0];

        if (drole1.length > 1) {
          filterType1 = drole1[1];
        }
      }
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&FilterType=" + filterType1 + "&status=" + st1 + "&month=" + month + "&year=" + year + "&hname=" + (st1 ? st1 + " " : "") + "Renewals" + (filterType1 ? " " + filterType1 : "") + "&rtype=allrenewals";
      break;
    case "birthdayreports":
      var month = (new Date().getMonth() + 1);
      var year = (new Date().getFullYear());
      //fdt = year + "-" + month + "-01";
      // tdt = year + "-" + month + "-31";
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Birthdays&rtype=birthdayreports";
      break;


    case "extendedservices":
      var month = (new Date().getMonth() + 1);
      var year = (new Date().getFullYear());
      // fdt = year + "-" + month + "-01";
      // tdt = year + "-" + month + "-31";
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Extended Services&rtype=extendedservices";
      break;

    case "assessmentscompleted":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Completed Assessments&rtype=assessmentscompleted";
      break;
    case "assessmentpending":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Assessments&rtype=assessmentpending";
      break;

    case "familyadded":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Family Added&rtype=familyadded";
      break;
    case "familynotadded":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Family Not Added&rtype=familynotadded";
      break;
    case "assessmentspayment":
      var url = "/d/AssessmentPaymentInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=";
      break;
    case "assessmentsfee":
      var url = "/d/assessmentsinsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=";
      break;
    case "assessmentspaymentseva":
      var url = "/d/assessmentsinsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status& mode=seva";
      // window.location.href = url;
      break;
    case "leads":
      var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=new" + "&month=" + month + "&year=" + year;
      //window.location.href = url;
      break;
    case "closedleads":
      var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=closed" + "&month=" + month + "&year=" + year;
      break;
    case "closedleadsnew":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Closed Leads&rtype=closedleads";
      break;
    case "activememos":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Active Memos&rtype=activememos";
      break;
    case "pendingmemos":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Memos&rtype=pendingmemos";
      break;
    case "activestaff":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Staff&rtype=activestaff";
      break;
    case "activeparents":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Parents&rtype=activeparents";
      break;
    case "closedmemos":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Closed Memos&rtype=closedmemos";
      break;
    case "awards":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Awards&rtype=awards";
      break;
    case "newleadsnew":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=New Leads&rtype=newleads";
      break;
    case "walkinleads":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Walkins&rtype=walkinleads";
      break;
    case "walkintoadmisssion":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Admission Walkins&rtype=walkintoadmisssion";
      break;
    case "activewalkins":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Active Walkins&rtype=activewalkins";
      break;
    case "pendingwalkins":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Walkins&rtype=pendingwalkins";
      break;
    case "closedwalkins":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Closed Walkins&rtype=closedwalkins";
      break;
    case "incentiveinsights":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Incentive Insights&rtype=incentiveinsights";
      break;
    case "joinedelsewhere":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Joined Else Where&rtype=joinedelsewhere";
      break;
    case "admissionleads":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Admissions&rtype=admissionleads";
      break;



    case "additionleads":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Additions&rtype=additionleads";
      break;
    case "assessmentsleads":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessments&rtype=assessmentsleads";
      break;
    case "activeleads":
      var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year;
      break;
    case "activeleadsnew":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Active Leads&rtype=activeleads";
      break;
    case "totalleads":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=All Leads&rtype=totalleads";
      break;
    case "pendingleads":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Leads&rtype=pendingleads";
      break;
    case "goalsnotsetnew":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Not Set&rtype=goalsnotset";
      break;
    case "pendingpti":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending PTI&rtype=pendingpti";
      break;
    case "inactiveservices":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Inactive Services&rtype=inactiveservices";
      break;
    case "inactivecausepending":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Service Root Cause&rtype=inactivecausepending";

      break;
    case "completedpti":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Completed PTI&rtype=completedpti";
      break;
    case "mirraclestotal":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Mirracles&rtype=mirraclestotal";

      break;
    case "mirraclestop100":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Top 100&rtype=mirraclestop100";
      break;
    case "mirraclesnotcovered":
      break;
    case "mirraclesbottom100":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Bottom 100&rtype=mirraclesbottom100";
      break;
    case "allmirraclesviews":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Views&rtype=allmirraclesviews";
      break;
    case "mirraclescontributed":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Contributed&rtype=mirraclescontributed";
      break;
    case "mconsumedusers":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Consumed&rtype=mconsumedusers";
      break;
    case "mnconsumedusers":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Not Consumed&rtype=mnconsumedusers";
      break;
    case "mnotcontributed":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Not Contributed&rtype=mnotcontributed";

      break;
    case "mirracleslc":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Languages Covered&rtype=mirracleslc";
      break;
    case "kuberamonthlyfee":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Kubera KU18&rtype=kuberamonthlyfee";
      break;
    case "kuberamissing":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Kubera Missing&rtype=kuberamissing";
      break;
    case "kuberaabnormal":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Kubera Abnormal&rtype=kuberaabnormal";
      break;
    case "allinvoicesthismonth":
      var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Rest&rtype=allinvoicesthismonth";
      break;
    case "activeservices":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Services&rtype=activeservices";
      break;
    case "empwoer2single":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Single Services&rtype=empwoer2single";
      break;
    case "seetapending":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Pending&rtype=seetapending";
      break;
    case "seetapartiallypaid":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Partially paid&rtype=seetapartiallypaid";
      break;
    case "seetapaid":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Paid&rtype=seetapaid";
      break;
    case "seetakids":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Kids&rtype=seetakids";
      break;
    case "creditpackrenew":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Renew&rtype=creditpackrenew";
      break;
    case "monthlypack":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Monthly Packs&rtype=monthlypack";
      break;
    case "newservices":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services") + "&rtype=newservices&FilterType=" + (role ? role : "");
      break;
    case "newservicesst":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services ST") + "&rtype=newservicesst&FilterType=" + (role ? role : "");
      break;
    case "newservicesbt":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services BT") + "&rtype=newservicesbt&FilterType=" + (role ? role : "");
      break;
    case "newservicesot":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services OT") + "&rtype=newservicesot&FilterType=" + (role ? role : "");
      break;
    case "newservicesse":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services SE") + "&rtype=newservicesse&FilterType=" + (role ? role : "");
      break;
    case "futureservices":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "Future Services") + "&rtype=futureservices&FilterType=" + (role ? role : "");
      break;
    case "addedparents":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Added Parents&rtype=addedparents";
      break;
    case "leftparents":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Lost Parents&rtype=leftparents";
      break;
    case "addedstaff":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Added Staff&rtype=addedstaff";
      break;

    case "localtherapistptireport":
      var url = "/kpireport?facility=&month=" + month + "&year=" + year + "&range=&fdt=&TDT=&radiofiltertype=&hname=Therapy PTI&rtype=therapistptireport&FilterType=pending&isFromLocal=true";
      break;
    case "leftstaff":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Left Staff&rtype=leftstaff";
      break;
    case "blockedstaff":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Blocked&rtype=blockedstaff";
      break;
    case "staffbots":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=BOT&rtype=staffbots";
      break;
    case "lockedaccounts":

      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Locked Accounts&rtype=lockedaccounts";
      break;
    case "pinnacleperks":

      var url = "/pinnacleperks?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pinnacle Perks&rtype=pinnacleperks";
      break;
    case "employeedetail":

      var url = "/employeedetail?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Employe Detail&rtype=employeedetail";
      break;
    case "bodyrecognition":

      var url = "/bodyrecognition?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Body Recognition&rtype=bodyrecognition";
      break;
    case "centerexpenses":

      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Centers Emp&rtype=centerexpenses";
      break;
    case "biometricrepo":

      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Bio Metric Repo&rtype=biometricrepo";
      break;
    case "staffutil":

      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Staff Util&rtype=staffutil";
      break;
    case "servicerequestpending":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Servicerequest Pending&rtype=servicerequestpending";
      break;
    case "servicerequestpendingfamily":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Family Servicerequest Pending&rtype=servicerequestpendingfamily";
      break;
    case "allservicerequests":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Servicerequest All&rtype=allservicerequests";
      break;
    case "assessmentcompleted":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessment Completed&rtype=assessmentcompleted";
      break;
    case "assessmentall":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessments&rtype=assessmentall";
      break;
    case "goalspending":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goals Pending&rtype=goalspending";
      break;
    case "totalgoals":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goals Total&rtype=totalgoals";
      break;
    case "todaypendinggoals":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Today Goals Pending&rtype=todaygoalspending";
      break;
    case "activegoals":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goals Active&rtype=activegoals";
      break;
    case "goalreviewed":
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goal Reviewed&rtype=goalreviewed";
      break;
    case "leadsTadmissions":
      var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=admissions" + "&month=" + month + "&year=" + year;
      break;
    //case "goalspending":
    //    var url = "/d/GoalsInsights?status=pendinggoals&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
    //    break;


    //case "goalreviewed":
    //    var url = "/d/GoalsInsights&status=goalreviews&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
    //    break;
    case "goalsdelayed":
      var url = "/d/GoalsInsights&status=delayed&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    //case "totalgoals":
    //    var url = "/d/GoalsInsights?status=goals&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
    //    break;
    case "goalsnotset":
      var url = "/d/GoalsInsights?status=goalsnotset&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "activegoalnew":
      var url = "/d/GoalsInsights?status=activegoals&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "goalnotmet":
      //var url = "/d/GoalsInsights?status=goalsnotmet&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goals Not Achived&rtype=goalnotmet";
      break;
    case "goalmet":
      //var url = "/d/GoalsInsights?status=goalsmet&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
      var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goal Achieved&rtype=goalmet";
      break;
    case "kidconditionsandbehaviours":
      var url = "/kpireport?facility=&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Kid Status&rtype=kidconditionsandbehaviours";
      break;
    case "pendingconditions":
      var url = "/kpireport?facility=&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Conditions&rtype=pendingconditions";
      break;
    case "pendingbehaviours":
      var url = "/kpireport?facility=&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Behaviours&rtype=pendingbehaviours";
      break;
    case "conditionsstats":
      var url = "/kpireport?facility=&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Kid Status&rtype=conditionsstats";


      break;
    case "goalsdelayed":
      var url = "/d/GoalsInsights?status=delayed&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "totalbiometric":
      var url = "/d/biometric?status=all&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;

    case "ontimebiometric":
      var url = "/d/biometric?status=ontime&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "latebiometric":
      var url = "/d/biometric?status=late&facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;

    case "newparents":
      var url = "/d/ParentsInsightsForBusiness?facility=" + facilityId + "&Btype=new&month=" + month + "&year=" + year;
      break;
    case "lostparents":
      var url = "/d/ParentsInsightsForBusiness?facility=" + facilityId + "&Btype=lost&month=" + month + "&year=" + year;
      break;
    case "parents":
      var url = "/d/ParentsInsightsForBusiness?facility=" + facilityId + "&Btype=all" + "&month=" + month + "&year=" + year;
      break;


    case "newstaff":
      var url = "/d/GetNewStaffInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "closedstaff":
      var url = "/d/GetDeleteUserInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
      break;
    case "staff":
      var url = "/d/StaffInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=" + "monthly therapist";
      break;
    case "ptiactive":
      var url = "/d/PTIInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=active";

      break;

    case "pticlosed":
      var url = "/d/PTIInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=closed";

      break;
  }

  if (facilityText) {
    url = url + "&fatext=" + (facilityText + "").replace(/\+/gi, "PLUS");
  }

  //  alert(url);
  if (openUrl) {
    if (isFDTENable) {
      url = url + "&FDT=" + fdt + "&TDT=" + tdt + "&range=" + range;
    }
    window.historyInstance.push(url);
  }
  else {
    var token = getUserTokenMethod();
    var Token = encodeURIComponent(token);
    url += "&range=" + range + "&salt=" + Token;

    loadGuestHandler(url, "no", GHtitle);
  }
}

export function GetAbilityPrice(userData) {
  if (!userData) return { F7: 27000 };
  const abilityPrice = (userData?.Types || []).filter((t) => t.Category?.toUpperCase() === "ABILITYSCORE")[0];
  return abilityPrice;
}

export function GetShortFormForService(sN) {

  if (!sN) {
    return "";
  }


  switch (sN.toLowerCase()) {
    case "speech therapy":
      return "ST";
    case "behavioral modification":
      return "ABA";
    case "special education":
      return "SE";
    case "occupational therapy":
      return "OT";
    case "physio therapy":
      return "PT";
    case "autism therapy":
      return "AT";
    case "Psychological Counseling":
      return "PC";
  }

  return sN;
}


export function GetServiceNameFromShortForm(sN) {

  if (!sN) {
    return "";
  }

  // console.log(sN);
  switch (sN.toLowerCase()) {
    case "st":
      return "Speech Therapy";
    case "bt":
    case "bm":
      return "Behavioral Modification";
    case "se":
      return "Special Education";
    case "ot":
      return "Occupational Therapy";
    case "pt":
      return "physio therapy";
  }

  return sN;
}

function loadGuestHandler(url, isAuthNeeded, title) {
  var guesturl = url;
  title = title || "";
  var token = getUserTokenMethod();
  if (isAuthNeeded != "no") {
    guesturl = url;// + encodeURIComponent(token);
  }
  console.log(guesturl);
  // var app = getMobileOperatingSystem();
  // if (app && IsApp(app)) {

  //     var operator = guesturl && guesturl.indexOf("?") > -1 ? "&" : "?";
  //     guesturl = guesturl + operator + "Device=" + app;
  // }
  localStorage.setItem("GuestUrl", guesturl);
  localStorage.setItem("SiteUrl", currentURL);
  window.historyInstance.push("/guesthandler?ptitle=" + title);
}
function getUsageTypeFromLS() {
  try {
    var type = localStorage.getItem("UsageType");
    return type;
  } catch (e) {
    console.log("Error in getUsageTypeFromLS : " + e);
  }
}


function IsProType() {
  try {
    var type = getUsageTypeFromLS() == "2";
    return type;
  } catch (e) {
    console.log("Error in IsProType : " + e);
  }
}


function showValidationtext(value, id) {
  if (!id) {
    return;
  }
  if (!value) {
    $("span#" + id).addClass("active");
    // $(event.target).addClass("caseerror");
    //isCanBeValidated = false;
  }

  else {
    $("span#" + id).removeClass("active");
    //$(event.target).removeClass("caseerror");
    // isCanBeValidated = true;
  }
}

export function getNoOfAttendacesForGoals(goal, attendanceData) {
  if (goal.Title) {
    var isAttenadceTDTConsider = window.attendancesRecordingDate <= dateFromSDateTime(goal.CDT);

    var attendaceByGoal = $.grep(attendanceData, function (e) { return e.Status == "Present" && e.ServiceId == goal.TherapyId && new Date(e.ForDate) >= new Date(goal.CDT) });

    //var attendaceByGoal = $.grep(attendanceData, function (e) { return dateFromSDateTime(goal.CDT) <= dateFromSDateTime(window.attendancesRecordingDate <= dateFromSDateTime(e.CDT) ? e.TDT : e.CDT) && e.S && e.S.toLowerCase() == "present" && e.TOId == goal.TOId && e.F5 && e.F5.toLowerCase() == goal.F1.toLowerCase() && e.F2 && goal.RDD.toLowerCase().indexOf(e.F2.split("{#}")[0].toLowerCase()) > -1 });
    return attendaceByGoal && attendaceByGoal.length > 0 && attendaceByGoal.length > goal.Services ? goal.Services : attendaceByGoal && attendaceByGoal.length > 0 ? attendaceByGoal.length : 0;
  }
  return 0;
}
export function isGoalCompleted(goal, attendanceData) {
  var length = getNoOfAttendacesForGoals(goal, attendanceData);
  return (goal.Services - 1) <= length;
}

export function disableFirstFiveDigits(phoneNumber) {
  if (!/^\d{10}$/g.test(phoneNumber)) {
    console.error('Invalid phone number');
    return phoneNumber;
  }
  // const disabledPhoneNumber = phoneNumber.replace(/^\d{5}/, '*****'); 
  //var disabledPhoneNumber = phoneNumber.slice(0, 1) + phoneNumber.slice(1, -1).replace(/\d/g, '*') + phoneNumber.slice(-1);

  var disabledPhoneNumber = phoneNumber.slice(0, 3) + phoneNumber.slice(3, -3).replace(/\d/g, '*') + phoneNumber.slice(-3);
  return disabledPhoneNumber;
}

export function disbleNumbersIfNotMatched(phoneNumber, lastNumbers) {
  lastNumbers = lastNumbers ? lastNumbers : 1;
  if (!/^\d{10}$/g.test(phoneNumber)) {
    console.error('Invalid phone number');
    return phoneNumber;
  }

  // const disabledPhoneNumber = phoneNumber.replace(/^\d{5}/, '*****'); 
  var disabledPhoneNumber = phoneNumber.slice(0, 3) + phoneNumber.slice(3, -3).replace(/\d/g, '*') + phoneNumber.slice(0 - lastNumbers);
  return disabledPhoneNumber;
}

export function maskMobileNumbers(array) {
  // Create a map to group numbers by their last digit sequences
  const sequencesMap = {};

  // Populate the map with the numbers
  array.forEach(item => {
    const number = item.F17;

    // Create sequences from the last digit up to the entire number
    for (let i = 1; i <= number.length; i++) {
      const sequence = number.slice(-i);
      if (!sequencesMap[sequence]) {
        sequencesMap[sequence] = [];
      }
      sequencesMap[sequence].push(number);
    }
  });

  // Mask the numbers based on the longest matching sequence
  array.forEach(item => {
    const number = item.F17;
    let unmaskLength = 1; // Always unmask the first and last digit

    // Find the longest sequence match
    for (let i = 1; i < number.length; i++) {
      const sequence = number.slice(-i);
      if (sequencesMap[sequence] && sequencesMap[sequence].length > 1) {
        unmaskLength = i + 1;
      } else {
        break;
      }
    }

    // Create the masked number
    item.Masked = number[0] + '*'.repeat(10 - unmaskLength - 1) + number.slice(-unmaskLength);
  });

  return array;
}

export function disableFirstSixDigits(phoneNumber) {
  if (!/^\d{10}$/g.test(phoneNumber)) {
    console.error('Invalid phone number');
    return phoneNumber;
  }
  var disabledPhoneNumber = phoneNumber.slice(0, 3) + phoneNumber.slice(3, -3).replace(/\d/g, '*') + phoneNumber.slice(-3);
  return disabledPhoneNumber;
}

export function ShowAttendanceLockedBoxMessage() {
  showLockedBoxMessage(`Dear Therapists,

    Each day at Pinnacle, we are not just guiding therapy sessions, we're fostering hope, understanding, and empowerment in the hearts of families worldwide. Our unique approach of providing daily updates to parents is a Pinnacle innovation that sets us apart on a global scale.

    These updates, encapsulating the day's focused goals, observed behaviors, conditions addressed, and therapy materials used, are more than just reports. They are bridges of understanding, connecting us with parents, and reinforcing their trust in our journey together.

    Remember, these updates you prepare are not just sent within our team, but directly to the parents. This transparency fortifies our bond with the families and underscores our commitment to their child's growth.

    As you document these updates, let's remember the impact of our work. Each detail you record, every progress you note, fuels the hopes of a family. Your diligence is shaping a child's journey, and in doing so, it's shaping the future of therapeutic care around the world.

    Thank you for being a part of this revolutionary journey. Together, we're not just making a difference, but setting a global standard in therapy.

    Empower Lives - Include Parents, Families.

    Pinnacle.`, "Pinnacle Therapy Record", "I, Understood", false, null, "/images/alert.png");
}

function showLockedBoxMessage(message, header, buttonvalue, isItError, callback, image) {

  header = header ? header : "Error";
  console.log(header.toLowerCase());
  var imageUrl = header.toLowerCase() == "alert" || header.toLowerCase() == "info" || header.indexOf("Important Updates") > -1 || header.toLowerCase() == "validation" || header.toLowerCase() == "pinnacle updated" ? "/images/alert.png" : header.toLowerCase() == "warning" || header == "Acho! You have gone too deep" ? "/images/warning.png" : header.toLowerCase() == "success" || header.toLowerCase() == "introducing" || header.toLowerCase() == "pinnacle mirracles : kids wonderful life" ? "/images/Success.jpg" : "/images/error.png";
  if (image) {
    imageUrl = image;
  }

  var multiple = message.split("{#}");
  message = multiple[0];

  header = multiple.length > 1 ? multiple[1] : header;

  try {
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations .asco-img").attr("src", imageUrl);
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass("single");
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations #alert-success-confirm-overlay-header').html(header);
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value="ok"]').val(buttonvalue);
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value="ok"]').css("width", "100%");
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .alert-header').html(message);
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('close');
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('open');
    $('.alert-success-confirm-overlay').show().addClass('active');
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").hide();

    // $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations svg').hide();
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('error');
    if (isItError) {
      $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass('error');
    }

    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").click(function () {
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
      $('.alert-success-confirm-overlay').show().removeClass('active');
      $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass("single");

      if (callback) {
        callback(true);
      }
    });

  } catch (e) {
    console.log(e.message);
  }
}

function ResetErrorvalidation() {
  try {
    $('.case-error').removeClass('active').addClass('no-display');
    $('.book-details-section input').removeClass('caseerror');
    $('.book-details-section select').removeClass('caseerror');
    $('.book-details-section textarea').removeClass('caseerror');
    //$('.fsBody .fsForm input.error, .fsBody .fsForm select.error, .fsBody .fsForm textarea.error').css({ 'border': '1px solid #dedede !important;' });
  } catch (e) {
    console.log(e);
  }
}



function InputValidatorReturnObject(parent) {

  var ReadStatus = [];
  var focuscount = 0;
  var bool = false; //var isAllReq = true;
  $(parent + ' input:not(input[type="button"],.donot-validate),' + parent + ' select:not(.donot-validate),' + parent + ' textarea:not(.donot-validate)').removeClass('error');
  $(parent + ' input:not(input[type="button"],.donot-validate),' + parent + ' select:not(.donot-validate),' + parent + ' textarea:not(.donot-validate)').each(function () {
    //  console.log('why');
    //  console.log($(this).is(":visible"));
    if ($(this).is(":visible")) {
      var eid = $(this).attr('id');
      var specificInputID = (eid == undefined || eid.length == 0) ? false : true;

      if (!specificInputID) {
        return;
      }
      if ($(this).attr('data-handledifferently') == "datepicker") {
        var pickerValue = $(this).val();
        if (pickerValue.valueOf() == "" || pickerValue.valueOf() == undefined || pickerValue.valueOf() == null) {
          $(this).addClass('error');
          $(this).focus();
          bool = true;
        }
      }
      else {
        if (!$(this).val()) {
          console.log($(this).attr('id'));
          if ($(this).attr('data-error-message') != undefined) {
            ReadStatus.push({ 'id': '#' + $(this).attr('id'), 'msg': ("&nbsp; <div class='errormsg'> " + $(this).attr('data-error-message') + "</div>") });
          }
          else if ($(this).attr('placeholder') == undefined) {
            ReadStatus.push({ 'id': '#' + $(this).attr('id'), 'msg': (($('#' + $(this).attr('id')).find(":selected").text()) + "&nbsp;&nbsp:&nbsp; <div class='errormsg'> Please " + $('#' + $(this).attr('id')).find(":selected").text() + "</div>") });
          } else {
            ReadStatus.push({ 'id': '#' + $(this).attr('id'), 'msg': ($(this).attr('placeholder') + " &nbsp;&nbsp; :&nbsp; <div class='errormsg'>Please enter " + $(this).attr('placeholder') + "</div>") });
          }

          $(this).addClass('error');
          if (focuscount == 0) {
            focuscount = 1;
            $(this).focus();
          }
          bool = true;
        }
      }
    }
  });

  return ReadStatus;
}

export function IsAllMileStoneQuestionsAnsweredForKPI(kid) {
  if (!kid) {
    return false;
  }
  var months = getMonthDifference(new Date(kid.DOB ? kid.DOB : kid.CDT), new Date())
  var filteredQuestions = MileStoneQuestions.filter(f => f.Age <= months && f.RS != "DELETEACTIVITY");
  var response = GetMappedValues(kid);
  var qids = response.filter(f => f);
  return (qids || []).length >= filteredQuestions.length;
}

export function IsAllMileStoneQuestionsAnswered(kid) {
  if (!kid) {
    return false;
  }
  var months = getMonthDifference(new Date(kid.DOB ? kid.DOB : kid.CDT), new Date())
  var filteredQuestions = MileStoneQuestions.filter(f => f.Age <= months && f.RS != "DELETEACTIVITY");
  return GetAllQuestionsAnswered(filteredQuestions, kid);
}


export function GetMappedValues(kid) {
  return (kid.MileStone || "").split(",").map(function (m) { return { Q: m.substring(0, m.length - 1), V: m.substring(m.length - 1, m.length) } })
}

export function GetAllQuestionsAnswered(questions, kid) {
  var response = GetMappedValues(kid);
  var qids = response.map(m => m.Q + "");
  return (questions.filter(f => qids.indexOf(f.Id + "") == -1) || []).length == 0;
}

function showConfirmBoxWithCancel2(message, header1, buttonvalue, isItError, callback) {
  try {
    setTimeout(function () {
      //$('html, body').addClass('popUpBackround');
    }, 20);
    if (message == "DONTSHOWCONFIRMATIONBOX") {
      callback(false);
      return;
    }

    if ("whatsappmessagescreen" == header1) {
      $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass('whatsappmessage');
    }

    var header = header1 ? (header1.split("{#}").length > 1 ? header1.split("{#}")[0] : header1) : "Error";

    console.log("header", header)
    var textToDisplay = header1 ? (header1.split("{#}").length > 1 ? header1.split("{#}")[1] : header1) : "Error";
    var goalsForKids = header1 ? (header1.split("{#}").length > 2 ? header1.split("{#}")[2] : header1) : "Error";
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations #alert-success-confirm-overlay-header').html(textToDisplay);
    console.log("textToDisplay", textToDisplay)
    var okbuttonName = buttonvalue ? buttonvalue.split("{#}")[0] ? buttonvalue.split("{#}")[0] : "Okay" : "Okay";
    var cancelbuttonName = buttonvalue ? buttonvalue.split("{#}")[1] ? buttonvalue.split("{#}")[1] : "Remove" : "Cancel";


    var imageUrl = header.toLowerCase() == "alert" || header.toLowerCase() == "info" || header.toLowerCase() == "add service" || header.toLowerCase() == "receipts missing" || header.toLowerCase() == "validation" || header == "Rember, It is all about a kids future, 6 families lifes " ? "/images/alert.png" : header.toLowerCase() == "warning" || header.toLowerCase() == "confirmation" || header.toLowerCase() == "full day" || header.toLowerCase() == "half day morning" || header.toLowerCase() == "half day evening" ? "/images/warning.png" : (header.toLowerCase() == "success" || header.toLowerCase() == "pinnacle mirracles : kids wonderful life") ? "/images/Success.jpg" : header.toLowerCase().indexOf("kidgoals") > -1 ? "https://images.pinnacleblooms.org/images/ProfileImages/" + goalsForKids + ".jpg" : "/images/error.png";
    console.log("imageUrl", imageUrl)
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations .asco-img").attr("src", imageUrl);

    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value="ok"]').val(okbuttonName);
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").val(cancelbuttonName);

    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .alert-header').html(message);
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('close');
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('open');
    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").show();
    if (cancelbuttonName == "Remove") {
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").hide();
    }
    $('.alert-success-confirm-overlay').show().addClass('active');
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('error');
    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations svg').hide();

    $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .SVU-close svg').show();
    if (isItError) {
      $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass('error');
    }

    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").click(function () {
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
      $('.alert-success-confirm-overlay').show().removeClass('active');
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").unbind("click");
      //$('html, body').removeClass('popUpBackround');
      $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('whatsappmessage');
      callback(true);

    });

    $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").click(function () {
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").unbind("click");
      $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
      $('.alert-success-confirm-overlay').show().removeClass('active');
      //$('html, body').removeClass('popUpBackround');
      $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('whatsappmessage');
      callback(false);
    });

  } catch (e) {
    console.log(e.message);
    // $('html, body').removeClass('popUpBackround');
  }
}

function ToastMessage(message, timeout, type) {
  var toast = $('.toast-message .jq-toast-single:last-child');
  $(toast).find('.message').text(message);
  var typeClass = "";
  if (type != null && typeof (type) != "undefined" && type == "red") {
    typeClass = "error";
  }
  else {
    typeClass = "active";
  }

  console.log("Toast Message Loaded.");

  //$(toast).addClass(typeClass);
  //var time = ((timeout) / 1000) - 1;
  //if (timeout) {

  $(toast).slideToggle(400).delay(2000).slideToggle(400);


  //setTimeout(function () {
  //    $(toast).slideUp(function () {
  //        $(toast).removeClass(typeClass);
  //        $(toast).find('.message').text("");
  //    });

  //}, timeout);
  //}
}

export function GetAuthTokenFromLS() {
  var token = "";
  try {
    token = cookie.load('validatorauth-s');

    if (!token) {
      token = localStorage.getItem("validatorauth-s");
    }

  } catch (e) {
    token = localStorage.getItem("validatorauth-s");
  }
  return token;
}

export function EnableGuestHandlerFOrIQM(assessment, bookingId) {
  try {
    var token = "";
    try {
      token = cookie.load('validatorauth-s');

      if (!token) {
        token = localStorage.getItem("validatorauth-s");
      }

    } catch (e) {
      token = localStorage.getItem("validatorauth-s");
    }
    var orgId = "c316c785-2429-4a15-69ad-56d25dc8aefb";

    var sclientType = localStorage.getItem('validatorclienttype-s');
    var isWeb = sclientType && sclientType.toLocaleLowerCase() != "web" ? false : true;
    var assId = assessment.F2;
    var url = window.IQMURL + 'viewassessment/' + assId + '?orgid=' + orgId + '&authtoken=' + encodeURIComponent(token) + '&isweb=' + isWeb + '&bid=' + bookingId + (assessment.ISHANDLE ? "&issectionbased=true" : "") + "&";
    console.log(url);
    localStorage.setItem("SiteUrl", window.IQMURL);
    localStorage.setItem("GuestUrl", url);
    loadGuestHandler(url, true, assessment.Title)
    //window.historyInstance.push("/guesthandler");
  } catch (e) {

  }
}
export function downloadPDF(URLToPDF, name) {
  try {
    console.log("download pdf called");
    console.log(URLToPDF);
    var oReq = new XMLHttpRequest();
    // The Endpoint of your server
    // var URLToPDF = serverPath + "Reports/" + analytic.Id + ".pdf";
    //  var URLToPDF = root + (analytic.Data3 ? analytic.Data3 : analytic.Data2);//analytic.Data2;//rootUrl + analytic.Data2;//"http://localhost:5523/" + analytic.Data2;//
    //   if (type == "Asse") {
    //      URLToPDF = iqmRooturl + analytic.F1;
    //  }


    // Configure XMLHttpRequest
    oReq.open("GET", URLToPDF, true);

    // Important to use the blob response type
    oReq.responseType = "blob";

    // When the file request finishes
    // Is up to you, the configuration for error events etc.
    oReq.onload = function () {
      try {
        // Once the file is downloaded, open a new window with the PDF
        // Remember to allow the POP-UPS in your browser
        var file = new Blob([oReq.response], {
          type: 'application/pdf'
        });

        // Generate file download directly in the browser !
        saveAs(file, name + ".pdf");

      } catch (e) {
        console.log("Err::downloadPDF()" + e);
      }
    };

    oReq.send();
  } catch (e) {
    console.log("Error in  downloadPDF :" + e);
  }
}

export function GetPaymentOrderId(amount, callback) {
  amount = amount / 100;
  var dataURL = "https://www.pinnacleblooms.org/api/unsecuredapi/getpaymentorderid?amount=" + amount



  const response = fetch(dataURL, { mode: 'no-cors' }).then((r) => {
    callback(r);
  }).catch(() => callback(false))
  return;
}

export function sendTelegramMessage(subject, GID) {
  GID = GID || "1967073562";

  if (subject.indexOf("Invalid Request, Time not completed, Please Retry") > -1) {
    return;
  }
  var obj = {
    "chat_id": "-100" + GID,
    "text": subject,
    "parse_mode": 'Markdown'
  };

  var stringified = JSON.stringify(obj);

  //declare global varialble. : sreenivas
  var dataURL = "https://api.telegram.org/bot5961621807:AAEKrsNqOhdgaTNqcfJiYRLUgfAt3KP8CCI/sendMessage"

  const init = {
    body: stringified,
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'cache-control': 'no-cache'
    },
  }

  const response = fetch(dataURL, init);

  try {
    var res = response;
    //check statuss : sreenivas
    // read result.
    console.log(res)
  }
  catch (err) {
    console.log(err);
    //
  }
}

export async function shareOfferToParent(paramObj, currentUser) {
  var dataURL = 'https://pbn-planetscale-message-process.kgv.workers.dev/';

  let myrequest = new Request(dataURL);
  //console.log("Came to ProcessWhatsAppMessages Method ");
  paramObj.AT = "SHAREOFFERMESSAGETOPARENT";
  paramObj.Handle = "9676163423";
  var model = {};
  model.PayLoad = paramObj;
  model.CurrentUser = currentUser;
  model.IsEdit = false;

  console.log(JSON.stringify(model));

  const init = {
    body: JSON.stringify(model),
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
  }

  const response = await fetch(dataURL, init);

  try {
    var res = response;
    //check statuss : sreenivas
    // read result.
    console.log(res)
  }
  catch (err) {
    console.log(err);
    //
  }
}


//export function uploadImage(file) {
//    fetch('https://<YOUR-OWN-WORKER>.workers.dev', {
//        method: 'POST',
//        headers: {
//            'Access-Control-Allow-Origin': '*',
//            'Content-Type': file.type
//        },
//        body: file
//    })
//        .then((response) => response.text())
//        .then((data) => console.log(data))
//        .catch((error) => console.error(error));
//}
async function calculateHash(file) {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  return [...new Uint8Array(hashBuffer)]
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

async function checkIfFileExists(hash) {
  const res = await fetch(`https://pbn-test.862998def1cd610fdb86b8e5c1d6ed4d.r2.cloudflarestorage.com/${hash}`, { method: 'HEAD' });
  return res.status !== 404;
}

export function UploadProfileFiletoR2(file, ActionType, MediaType, userId, FileName, callBack) {
  try {


    if ((null == file)) {
      callBack([{ Path: "" }]);
      return;
    }
    // const hash = await calculateHash(file.target ? file.target : file);
    // const exists = await checkIfFileExists(hash);

    // if (exists) {
    //     alert("File already exists!");
    //     //callBack([{ Path: hash }]);  // Or handle it differently
    //     return;
    // }

    var fileToUpload = file && file.target ? file.target : file;
    var uplaoddata = new FormData();

    //if (croppedFIles) {
    //    //  alert(croppedFIles.length);
    //    for (var i = 0; i < croppedFIles.length; i++) {
    //        uplaoddata.append("croper", croppedFIles[i].target, croppedFIles[i].name);
    //    }
    //}
    $.ajax({
      //url: '/api/unsecuredapi/SaveMultMediaFile',
      url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
      //url: 'http://localhost:8787/api/uploadr2',

      beforeSend: function (request) {
        request.setRequestHeader("ActionType", ActionType);
        request.setRequestHeader("MediaType", MediaType);
        request.setRequestHeader("ClientType", "WEB");
        request.setRequestHeader("ImagePersonId", userId);
        request.setRequestHeader("FileName", FileName);
        request.setRequestHeader("Tag", FileName);
        request.setRequestHeader("Content-Type", fileToUpload.type);

      },
      data: fileToUpload,
      xhr: function () {
        var myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener('progress', function (e) {

            if (e.lengthComputable) {
              var max = e.total;
              var current = e.loaded;
              var Percentage = (current * 100) / max;
              //console.log(Percentage);
              // console.log(page.toLowerCase());



              if (Percentage >= 100) {
                // process completed
              }
              else {
                //callbackPerscentage(Percentage);
              }
            }
          }, false);
        }
        return myXhr;
      },
      cache: false,
      // contentType: false,
      async: true,
      processData: false,
      type: 'POST',
      success: function (result) {
        //showLockedBox("Image Updated successfully", "", "Ok", true);
        callBack(result);
        return true;

      },
      error: function (xhr, ajaxOptions, thrownError) {
        //HideLoading();
        if (callBack) {
          callBack();
        }
        $('.submit-wrapper').removeClass('is-saving');
        showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
      }
    });



  } catch (e) {
    console.log("Err::UploadProfileFile()" + e);
  }

}


export function UploadProfileFiletoServer(file, ActionType, MediaType, userId, FileName, callBack) {
  try {


    if ((null == file)) {
      callBack([{ Path: "" }]);
      return;
    }
    // const hash = await calculateHash(file.target ? file.target : file);
    // const exists = await checkIfFileExists(hash);

    // if (exists) {
    //     alert("File already exists!");
    //     //callBack([{ Path: hash }]);  // Or handle it differently
    //     return;
    // }

    var fileToUpload = file && file.target ? file.target : file;
    var uplaoddata = new FormData();




    if (file) {
      //  alert(croppedFIles.length);
      uplaoddata.append("croper", fileToUpload, FileName);

    }
    $.ajax({
      //url: 'http://localhost:5528/api/unsecuredapi/SaveMultMediaFile',
      url: 'https://www.pinnacleblooms.org/api/unsecuredapi/SaveMultMediaFile',

      // url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
      //url: 'http://localhost:8787/api/uploadr2',

      beforeSend: function (request) {
        request.setRequestHeader("ActionType", ActionType);
        request.setRequestHeader("MediaType", MediaType);
        request.setRequestHeader("ClientType", "WEB");
        request.setRequestHeader("ImagePersonId", userId);
        request.setRequestHeader("FileName", FileName);
        request.setRequestHeader("Tag", FileName);
        //request.setRequestHeader("Content-Type", fileToUpload.type);

      },
      data: uplaoddata,
      xhr: function () {
        var myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener('progress', function (e) {

            if (e.lengthComputable) {
              var max = e.total;
              var current = e.loaded;
              var Percentage = (current * 100) / max;
              //console.log(Percentage);
              // console.log(page.toLowerCase());



              if (Percentage >= 100) {
                // process completed
              }
              else {
                //callbackPerscentage(Percentage);
              }
            }
          }, false);
        }
        return myXhr;
      },
      cache: false,
      // contentType: false,
      async: true,
      contentType: false,
      processData: false,
      type: 'POST',
      success: function (result) {
        //showLockedBox("Image Updated successfully", "", "Ok", true);
        console.log(result);
        callBack(result);
        return true;

      },
      error: function (xhr, ajaxOptions, thrownError) {
        //HideLoading();
        if (callBack) {
          callBack();
        }
        $('.submit-wrapper').removeClass('is-saving');
        showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
      }
    });



  } catch (e) {
    console.log("Err::UploadProfileFile()" + e);
  }

}

export function UploadSecureFiletoR2(file, ActionType, MediaType, FileName, Tag, callBack) {
  try {


    if ((null == file)) {
      callBack([{ Path: "" }]);
      return;
    }
    var fileToUpload = file && file.target ? file.target : file;
    var uplaoddata = new FormData();

    //if (croppedFIles) {
    //    //  alert(croppedFIles.length);
    //    for (var i = 0; i < croppedFIles.length; i++) {
    //        uplaoddata.append("croper", croppedFIles[i].target, croppedFIles[i].name);
    //    }
    //}
    $.ajax({
      //url: '/api/unsecuredapi/SaveMultMediaFile',
      url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
      // url: 'http://localhost:8787/api/uploadr2',

      beforeSend: function (request) {
        request.setRequestHeader("ActionType", ActionType);
        request.setRequestHeader("MediaType", MediaType);
        request.setRequestHeader("ClientType", "WEB");
        request.setRequestHeader("FileName", FileName);
        request.setRequestHeader("Tag", Tag);
        request.setRequestHeader("Content-Type", fileToUpload.type);

      },
      data: fileToUpload,
      xhr: function () {
        var myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener('progress', function (e) {

            if (e.lengthComputable) {
              var max = e.total;
              var current = e.loaded;
              var Percentage = (current * 100) / max;
              //console.log(Percentage);
              // console.log(page.toLowerCase());



              if (Percentage >= 100) {
                // process completed
              }
              else {
                //callbackPerscentage(Percentage);
              }
            }
          }, false);
        }
        return myXhr;
      },
      cache: false,
      // contentType: false,
      async: true,
      processData: false,
      type: 'POST',
      success: function (result) {
        //showLockedBox("Image Updated successfully", "", "Ok", true);
        callBack(result);
        return true;

      },
      error: function (xhr, ajaxOptions, thrownError) {
        //HideLoading();
        if (callBack) {
          callBack();
        }
        $('.submit-wrapper').removeClass('is-saving');
        showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
      }
    });



  } catch (e) {
    console.log("Err::UploadProfileFile()" + e);
  }

}


export function UploadSecureFiletoServer(file, ActionType, MediaType, FileName, Tag, callBack) {
  try {


    if ((null == file)) {
      callBack([{ Path: "" }]);
      return;
    }
    var fileToUpload = file && file.target ? file.target : file;
    var uplaoddata = new FormData();

    //if (croppedFIles) {
    //    //  alert(croppedFIles.length);
    //    for (var i = 0; i < croppedFIles.length; i++) {
    //        uplaoddata.append("croper", croppedFIles[i].target, croppedFIles[i].name);
    //    }
    //}
    $.ajax({
      url: '/api/unsecuredapi/SaveMultMediaFile',
      //url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
      // url: 'http://localhost:8787/api/uploadr2',

      beforeSend: function (request) {
        request.setRequestHeader("ActionType", ActionType);
        request.setRequestHeader("MediaType", MediaType);
        request.setRequestHeader("ClientType", "WEB");
        request.setRequestHeader("FileName", FileName);
        request.setRequestHeader("Tag", Tag);
        request.setRequestHeader("Content-Type", fileToUpload.type);

      },
      data: fileToUpload,
      xhr: function () {
        var myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener('progress', function (e) {

            if (e.lengthComputable) {
              var max = e.total;
              var current = e.loaded;
              var Percentage = (current * 100) / max;
              //console.log(Percentage);
              // console.log(page.toLowerCase());



              if (Percentage >= 100) {
                // process completed
              }
              else {
                //callbackPerscentage(Percentage);
              }
            }
          }, false);
        }
        return myXhr;
      },
      cache: false,
      // contentType: false,
      async: true,
      processData: false,
      type: 'POST',
      success: function (result) {
        //showLockedBox("Image Updated successfully", "", "Ok", true);
        callBack(result);
        return true;

      },
      error: function (xhr, ajaxOptions, thrownError) {
        //HideLoading();
        if (callBack) {
          callBack();
        }
        $('.submit-wrapper').removeClass('is-saving');
        showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
      }
    });



  } catch (e) {
    console.log("Err::UploadProfileFile()" + e);
  }

}



export function UploadProfileFile(croppedFIles, ActionType, MediaType, userId, FileName, callBack) {
  try {


    if ((null == croppedFIles || croppedFIles.length == 0)) {
      callBack([{ Path: "" }]);
      return;
    }
    var uplaoddata = new FormData();

    if (croppedFIles) {
      //  alert(croppedFIles.length);
      for (var i = 0; i < croppedFIles.length; i++) {
        uplaoddata.append("croper", croppedFIles[i].target, croppedFIles[i].name);
      }
    }
    $.ajax({
      //url: '/api/unsecuredapi/SaveMultMediaFile',
      url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
      // url: 'http://localhost:8787/api/uploadr2',

      beforeSend: function (request) {
        request.setRequestHeader("ActionType", ActionType);
        request.setRequestHeader("MediaType", MediaType);
        request.setRequestHeader("ClientType", "WEB");
        request.setRequestHeader("ImagePersonId", userId);
        request.setRequestHeader("FileName", FileName);
        request.setRequestHeader("Content-Type", croppedFIles[0].target.type);

      },
      data: croppedFIles[0].target,
      xhr: function () {
        var myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener('progress', function (e) {

            if (e.lengthComputable) {
              var max = e.total;
              var current = e.loaded;
              var Percentage = (current * 100) / max;
              //console.log(Percentage);
              // console.log(page.toLowerCase());



              if (Percentage >= 100) {
                // process completed
              }
              else {
                // callbackPerscentage(Percentage);
              }
            }
          }, false);
        }
        return myXhr;
      },
      cache: false,
      // contentType: false,
      async: true,
      processData: false,
      type: 'POST',
      success: function (result) {
        //showLockedBox("Image Updated successfully", "", "Ok", true);
        callBack(result);
        return true;

      },
      error: function (xhr, ajaxOptions, thrownError) {
        //HideLoading();
        if (callBack) {
          callBack();
        }
        $('.submit-wrapper').removeClass('is-saving');
        showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
      }
    });



  } catch (e) {
    console.log("Err::UploadProfileFile()" + e);
  }

}
export function UploadSecureFile(blob, folderName, fileName, tag, callBack) {
  try {

    var uplaoddata = new FormData();
    uplaoddata.append(fileName, blob);

    $.ajax({
      url: '/api/unsecuredapi/SecureFileSave',
      beforeSend: function (request) {
        request.setRequestHeader("AuthToken", GetAuthTokenFromLS());
        request.setRequestHeader("Project", folderName);
        request.setRequestHeader("FID", fileName);
        request.setRequestHeader("TAG", tag);
        request.setRequestHeader("APPType", IamIOSWebAlso() ? "IOS" : "");
        //request.setRequestHeader("RelevantDataTitle", ActionType && ActionType.toLowerCase() != "cards" ? $('#ArticleTitle').val() : "IndiaHeraldCards");
      },
      data: uplaoddata,
      xhr: function () {
        var myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener('progress', function (e) {

            if (e.lengthComputable) {
              var max = e.total;
              var current = e.loaded;
              var Percentage = (current * 100) / max;
              console.log(Percentage);
            }
          }, false);
        }
        return myXhr;
      },
      cache: false,
      contentType: false,
      async: false,
      processData: false,
      type: 'POST',
      success: function (result) {
        console.log(result);
        $('.file-publish-loader').addClass('displaynone');
        callBack(result);

      },
      error: function (xhr, ajaxOptions, thrownError) {
        callBack("failed");

        showLockedBox(thrownError, "Error", "Ok", true);
        $('.file-publish-loader').addClass('displaynone');
        console.log(xhr);

        var errorObj = {};
        errorObj.Type = 3;
        errorObj.Message = thrownError;
        errorObj.CreatedDateTime = getCurrentDateTime();

        SaveExceptionToSentry(errorObj, "ERROR", getUserToken(), "UPLOADSECUREFILE");
        //alert("Sorry, We are unable to upload files to server", false);
      }
    });



  } catch (e) {
    console.log("Err::UploadProfileFile()" + e);
  }

}

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }
  else if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection
  else if (/iPad|iPhone|iPod/.test(userAgent)) {
    return "iOS";
  }

  return "unknown";
}




// #region cropper


// #endregion cropper

function cleanTelegramMessage(encodedHtml) {
  const txt = document.createElement("textarea");
  txt.innerHTML = encodedHtml;
  let message = txt.value;         // first decode
  txt.innerHTML = message;
  message = txt.value;             // second decode

  // 2️⃣ Replace <undefined> and <br> with new lines
  // message = message.replace(/<\s*undefined\s*>/gi, "\n")
  //     .replace(/<\s*\/\s*undefined\s*>/gi, "\n")
  //     .replace(/<br\s*\/?>/gi, "\n");
  message = message
    .replace(/<\s*undefined\s*>/gi, "\n")
    .replace(/<\s*\/\s*undefined\s*>/gi, "\n")
    // Replace multiple consecutive <br> tags with matching number of \n
    .replace(/(<br\b[^>]*>)+/gi, match => "\n".repeat((match.match(/<br\b[^>]*>/gi) || []).length));


  // 3️⃣ Remove all other HTML tags except <b>
  message = message.replace(/<(?!\/?b\b)[^>]+>/gi, "");

  // 4️⃣ Convert <b> tags to Telegram bold
  message = message.replace(/<b>/gi, "*").replace(/<\/b>/gi, "*");

  // 5️⃣ Remove unwanted texts
  message = message.replace(/Powered by|Froala Editor/gi, "");

  // 6️⃣ Trim lines and remove empty lines
  //message = message.split("\n").map(line => line.trim()).filter(line => line.length > 0).join("\n");

  return message;
}

export function ShowShare(activity, type) {
  try {
    if (!HandleOffline(function () { ShowShare(activity, type); })) {
      return;
    }
    var rootUrl = "";
    // var sTitle = FormatStringForUrl(activity.SN && activity.SN != "" ? activity.SN : activity.Title);
    var title = "";
    var url = "";
    if (!activity.AT) {
      var d1Data = window.globalCacheData.Types;
      // console.log(d1Data);
      console.log(activity.TypeId);
      var typeInLocal = d1Data ? d1Data.find((e) => e.Id == activity.TypeId) : null;
      console.log(typeInLocal);


      activity.AT = typeInLocal ? typeInLocal.Name : "";

      if (activity.Category) {


        activity.AT = activity.Category && activity.Category == "Service" ? "services" : activity.Category;  //d1Data ? d1Data.find((e) => e.Id == fdata.Category).Name : "";
      }
    }
    type = type.toLowerCase() == "pinnacleprofile" ? "pinnacleprofile" : activity.AT;
    switch (type.toLowerCase()) {
      case "mirracles":
        title = "*MIRRACLES @ PINNACLE*";
        url = "mirraclescheme://https://mirracle.pinnacleblooms.org" + "/mirracles?id=" + activity.UId;
        var description = activity.F2;
        break;
      case "pinnacleprofile":
        title = "*PINNACLE @ PROFILE*";
        url = "mirraclescheme://https://mirracle.pinnacleblooms.org" + "/" + activity.O4;
        var description = "";
        break;
      case "blogpost":
      case "imagegallery":
      case "video":
      case "audio":
      case "file":
      case "event":
        title = "*" + activity.Title + "*";
        url = "https://www.pinnacleblooms.org" + "/latest/" + activity.Id + "/" + FormatStringForUrl(activity.Title && activity.Title != "" ? activity.Title : "title-missing");
        var description = cleanTelegramMessage(activity.Description && activity.Description.length > 0 ? activity.Description : "");
        break;
      case "assessment":
        title = "*SELF ASSESS:" + activity.RDT + "*";
        url = "https://mirracle.pinnacleblooms.org/assessment/" + FormatStringForUrl(activity.SN && activity.SN != "" ? activity.SN : "");
        var description = activity.RDD && activity.RDD.length > 0 ? parse(activity.RDD.substring(0, 180)) : "";
        break;
      case "services":
        title = "*" + activity.RDT + "*";
        url = "https://mirracle.pinnacleblooms.org/services/" + FormatStringForUrl(activity.SN && activity.SN != "" ? activity.SN : "");
        var description = activity.RDD && activity.RDD.length > 0 ? parse(activity.RDD.substring(0, 180)) : "";
        description = description ? description + "\n\n" + "*Enroll:* https://www.pinnacleblooms.org/enroll" : "";
        break;
      case "attendance":
        if (activity.S.toLowerCase() == "present") {
          title = activity.F9 + "/5 -" + activity.F3 + " empowerment for " + getFormattedDate(activity.CDT) + "\n\nGoals Workedupon:\n" + activity.F2 + "\n\nTherapist Feedback:\n" + activity.RDT + "\n\nHomework:\n" + activity.RDD;
        } else if (activity.S.toLowerCase() == "absent") {
          title = "We all at Pinnacle Blooms Network missed " + activity.F3 + " today.Our Therapist - Shri." + activity.CBPN + " Garu time of " + activity.F1 + " has remained empty."
            + "\n\n" + "Would love to see " + activity.F1 + " making use of every single  therapy session and get the most of it.We would love to see you in next day and every working day session " + activity.F3 + " Garu."
        }
        url = "https://mirracle.pinnacleblooms.org/hanuman?id=" + activity.UId + "&at=" + activity.AT;
        break;
      case "invoice":
        var allmonthNames = ["January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "December", "December"
        ];
        title = "RECEIPT: " + (activity && activity.KidName ? activity.KidName : "") + " " + activity.ServiceName + " fee receipt for ₹" + activity.Amount + " of " + allmonthNames[new Date(activity.FDT).getMonth()] + "/" + new Date(activity.FDT).getFullYear() + "\n\n*Receipt*";
        url = "https://mirracle.pinnacleblooms.org/viewinvoice/" + activity.Id;
        break;
      case "goal settings":
        var committed = activity.Details.split('{##}')[0].replace(/{#}/gi, "\n\n");
        var stretched = activity.Details.split('{##}').length > 1 && activity.Details.split('{##}')[1] != "" ? ("\n\n*Stretched*\n\n " + activity.Details.split('{##}')[1].replace(/{#}/gi, "\n\n")) : "";

        title = activity.Title + " of " + activity.F3 + " by " + activity.CBPN + " created on " + getFormattedDate(activity.CDT) + "\n\n*Committed*" + committed + stretched;
        url = "https://mirracle.pinnacleblooms.org/hanuman?id=" + activity.Id + "&at=GOAL%20SETTINGS";
        break;
      case "userservice":
        title = "Dear Parent,\n\nHearty Congratulations on the empowerment journey for " + activity.RDT + ".\n\n" + activity.F2 + " by " + activity.F3 + " between " + getTimeStampfromTime(activity.F1, false) + " - " + getTimeStampfromTime(activity.F1, true) + " has been reserved for " + activity.F3
          + "\n\nFirst 15 therapies are all about therapist earning emotional confidence of kid.\n\nThere after therapist and you will decide goals for every 20 therapy sessions and every therapy would be based upon the goal.\n\n"
          + "Everyday therapy will be of 40 minutes therapeutic empowerment + 3 minutes of parental discussion with therapist.\n\n" + "You may please reach out to centre Administration manager for anything other than therapies, can speak to therapist or chief therapist everything about the therapies.\n\n"
          + "You may reach National Care Centre on 9100 181 181 at any/ all times for anything/ everything of kids empowerment.\n\n" + "Hearty Congratulations! Wishing you all the very best  - Promising to do everything plausible. \n\n"
          + "https://mirracle.pinnacleblooms.org \n# Autism Therapy Centres Network";
        description = "";
        url = "https://mirracle.pinnacleblooms.org/hanuman?id=" + activity.UId + "&at=" + activity.AT;
        break;
      case "user":
        url = "https://mirracle.pinnacleblooms.org/usercard?id=" + activity.OGID + "&role=" + type;
        if (type == "boss") {
          var d = activity.S && activity.S.toLowerCase() == "female" ? "Baby" : "Master";
          title = "*" + d + ". " + activity.RDT + "*";
        } else if (type == "staff") {
          title = "Shri. " + activity.RDT + " - " + activity.F5.split("{#}")[0] + ", Since " + getFormattedDate(activity.TDT) + " @ " + activity.F5.split("{#}")[4];
        }


        break;
      case "award":
        url = window.R2Path + "/Assets/GeneratedAwards/" + activity.Id + "_Award.pdf";
        title = "Hearty Congratulations to " + activity.F2 + " on recieving " + activity.Title + "\n\n" + activity.Description;

        break;
      case "pinnaclegiftvoucher":
        url = activity.URL;
        title = activity.RDD;

        break;
      case "uspshare":
        url = "https://mirracle.pinnacleblooms.org/globalinnovation?type=" + activity.type;
        break;
      default:
        break;
    }

    console.log(url);
    var footer = "";//"*Call 9100 181 181 for Franchise* ( Eligibility: Only for parents of kid with sensorial conditions, Proven Doctors, Certified Therapists with Profound work expertise in empowering kids, parents, families), *Admission*";

    console.log(description);
    title = title + "\n\n" + url + (description ? "\n\n" + description + "..." + "\n\n" : "\n\n") + footer;
    var app = localStorage.getItem("validatorapptype-s");
    console.log(title);
    if (IsIOS(app)) {
      window.location.href = "mirraclescheme://sharecallback=" + title;
      return;
    }

    if (navigator.share === undefined) {
      console.log('Undefined!');

      if (IsAndroid(app)) {
        // alert("handle android");
        window.currentShareVal = title;
        window.location.href = "mirraclescheme://sharecallback";
      }
      else {
        alert("Sharing is not available for your browser currently, we will enable it soon. You may still share via WhatsApp.");
      }
    }
    else {
      console.log('Sharing!');
      navigator.share({ title: title, text: title });
    }
  }
  catch (e) {
    console.log("Error in share: " + e);
  }

}

export function ConnectCall(mobile, Id, callback, type) {



  ConnectCallTWebSocket(mobile, function (response, error) {
    if (!error) {
      showLockedBox("Call Connected Successfully", 'info', "Ok");
    }
    else {
      showLockedBox(error.ErrorMsg, "Error", "ok");
    }

  }, null, type);
  // $.ajax({
  //     url: "/api/UnsecuredAPI/ClickOCall?mobileNumber=" + mobile + "&userId=" + Id,
  //     type: "POST",
  //     dataType: "json",
  //     success: function (data) {
  //         if (callback) {
  //             callback(true);
  //         }
  //     },
  //     error: function (x, y, z) {
  //         showLockedBox(x.responseText, "", "ok");

  //     }
  // });
}


export function SendTelegramMessageViaServer(request, callback) {

  var psurl = "https://psapi.pinnacleblooms.org/api/sendtelegramviaserver";

  $.ajax({
    url: psurl,
    data: JSON.stringify(request),
    type: "POST",
    dataType: "application/json",
    success: function (data) {
      if (callback) {
        callback(true);
      }
    },
    error: function (x, y, z) {
      //  showLockedBox(x.responseText, "", "ok");
    }
  });
}


export function SendTelegramMessageForPersonal(request, callback) {

  var psurl = "https://psapi.pinnacleblooms.org/api/sendtelegramforpersonal";

  $.ajax({
    url: psurl,
    data: JSON.stringify(request),
    type: "POST",
    dataType: "application/json",
    success: function (data) {
      if (callback) {
        callback(true);
      }
    },
    error: function (x, y, z) {
      //  showLockedBox(x.responseText, "", "ok");
    }
  });
}

export function LeadOrPTIShare(activity, type, facility) {
  try {

    var d1Data = localStorage.getItem("MasterFacilities");
    //var md = [{Id:44,Name:"Anna Nagar, Chennai"}, {Id:7,Name:"AS Rao Nagar"}, {Id:33,Name:"Attapur"}, {Id:4,Name:"Begumpet"}, {Id:41,Name:"Bhimavaram"}, {Id:37,Name:"BN Reddy Nagar"}, {Id:53,Name:"Chanda Nagar"}, {Id:15,Name:"Dilsukhnagar"}, {Id:34,Name:"Eluru"}, {Id:56,Name:"Gachibowli"}, {Id:35,Name:"Gajuwaka @ Vizag"}, {Id:20,Name:"Guntur"}, {Id:12,Name:"Habsiguda"}, {Id:31,Name:"Hayathnagar"}, {Id:6,Name:"Himayat Nagar"}, {Id:42,Name:"HitechCity, Madhapur"}, {Id:11,Name:"HyderNagar"}, {Id:25,Name:"Indira Nagar"}, {Id:26,Name:"Jaya Nagar"}, {Id:58,Name:"JNTU"}, {Id:9,Name:"Jubliee Hills"}, {Id:45,Name:"Kachiguda"}, {Id:40,Name:"Kakinada"}, {Id:28,Name:"Karimnagar"}, {Id:22,Name:"KGV"}, {Id:43,Name:"Khajaguda, Mehdipatnam"}, {Id:38,Name:"Khammam"}, {Id:17,Name:"Kondapur"}, {Id:2,Name:"Kukatpally"}, {Id:39,Name:"Kurnool"}, {Id:13,Name:"Labbipet"}, {Id:10,Name:"LB Nagar"}, {Id:51,Name:"Marathahalli"}, {Id:18,Name:"Mumbai"}, {Id:49,Name:"MVP, Vizag"}, {Id:27,Name:"NAD, Vizag"}, {Id:29,Name:"Nallagandla"}, {Id:5,Name:"NCC"}, {Id:30,Name:"Nellore"}, {Id:24,Name:"New Delhi"}, {Id:8,Name:"NIHWN.co"}, {Id:57,Name:"Nizamabad"}, {Id:54,Name:"NOFACILITY"}, {Id:55,Name:"Paradise"}, {Id:32,Name:"Pragathi Nagar"}, {Id:52,Name:"Rajhamundary"}, {Id:47,Name:"Santosh Nagar"}, {Id:3,Name:"SR Nagar"}, {Id:1,Name:"Suchitra"}, {Id:23,Name:"Suchitra II"}, {Id:46,Name:"Uppal"}, {Id:50,Name:"USA"}, {Id:16,Name:"Vanasthalipuram"}, {Id:48,Name:"Vijayawada"}, {Id:21,Name:"Vikrampuri"}, {Id:14,Name:"Visakhapatnam"}, {Id:36,Name:"Warangal"}]
    var md = JSON.parse(d1Data);
    var centername = "NCC";
    if (md) {
      try {
        centername = $.grep(md, function (e) { return e.Id == activity.CenterId })[0].Name;
      }
      catch (e) {
      }
    }
    var url = (type == "leadhistory") ? "mirraclescheme://https://mirracle.pinnacleblooms.org/hermes?id=" + activity.TOId : "mirraclescheme://https://mirracle.pinnacleblooms.org" + "/pti";

    var title = (facility ? facility + ": " : "") + (activity.F2 ? activity.F2 : " Lead") + " created on " + dateFromDateTime(activity.CDT) + (activity.F6 && activity.F6.split("{#}")[0] ? ", last followed up on " + activity.F6.split("{#}")[0] : "") + " , Next follow up: " + (activity.FDT ? dateFromDateTime(activity.FDT) : "N/A")
    //var description = activity.RDD && activity.RDD.length > 0 ? parse(activity.RDD.substring(0, 180)) : "";
    var footer = "*Download app:* https://mirracle.pinnacleblooms.org/dl \n*Brought to you by: *Pinnacle Blooms Network,\n#1 Autism Therapy Centres Network,\n#1 Multi - sensory, Multi - disciplinary, Integrated Autism Therapy Centres Network,\n\nPROVIDERS OF FREE NATIONAL AUTISM HELPLINE.*WhatsApp :* https://wa.me/+919100181181";
    title = title + "\n\n" + url + "\n\n" + footer;

    title = facility + '\n\n';
    title += (activity.Description ? (activity.Description == "MYOPERATOR CALL" ? "Pinnacle OMNI MO" : activity.Description == "Job enquiry" ? "Pinnacle OMNI JE" : activity.Description.indexOf("whatsapp to 9100 181 181") > -1 ? "Pinnacle OMNIW"
      : activity.Description == " TIDIO " ? "Pinnacle OMNIT" : activity.Description) + "\n\n" : "");
    title += ("Last Active: " + getFormattedDate(activity.CDT) + "\n\n");
    title += ("Created: " + (activity.CDT ? getFormattedDate(activity.CDT) : "") + "\n\n")
    title += ("" + url + "\n\n");

    var app = localStorage.getItem("validatorapptype-s");
    console.log(title);

    if (IsIOS(app)) {
      window.location.href = "mirraclescheme://sharecallback=" + title;
      return;
    }

    if (navigator.share === undefined) {
      console.log('Undefined!');

      if (IsAndroid(app)) {
        // alert("handle android");
        window.currentShareVal = title;
        window.location.href = "mirraclescheme://sharecallback";
      }
      else {
        alert("Sharing is not available for your browser currently, we will enable it soon. You may still share via WhatsApp.");
      }
    }
    else {
      console.log('Sharing!');
      navigator.share({ title: title, text: title });
    }
  }
  catch (e) {
    console.log("Error in share: " + e);
  }
}
export function GetFormatStringForUrl(text) {
  return FormatStringForUrl(text);
}
function FormatStringForUrl(text) {

  //  console.log("i am called with " + text);
  try {
    if (!text) {
      return text;
    }
    // return text.replace(/[^a-z0-9\s]/gi, '_').replace(/[_\s]/g, '_').replace(/--/g, '_').trim()

    return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-').replace(/ /g, "-").replace(/--/g, '-').trim()
  }
  catch (e) {
  }

  return "";
}

export var DownArrow = <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><polyline fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} points="11.5,6.5 8,10 4.5,6.5 " data-color="color-2" /> <circle fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={8} cy={8} r="7.5" /></g></svg>

export var UpArrow = <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><polyline fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} points="11.5,9.5 8,6 4.5,9.5 " data-color="color-2" /> <circle fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={8} cy={8} r="7.5" /></g></svg>


export var SlidaeBar = <div className="h-l">
  <span className="high">
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><path d="M14.622,5.62l-.645,1.935C13.988,7.7,14,7.85,14,8A6,6,0,1,1,8,2c.151,0,.3.012.448.023l1.931-.644.745-.745a8,8,0,1,0,4.242,4.242Z" fill="#444444" /><path d="M15.707.293a1,1,0,0,0-1.414,0L11.459,3.126,5.684,5.052A1,1,0,0,0,5,6a5.006,5.006,0,0,0,5,5,1,1,0,0,0,.949-.684L12.874,4.54l2.833-2.833A1,1,0,0,0,15.707.293Z" fill="#444444" data-color="color-2" /></g></svg>
  </span>
  <span className="low">
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><path data-color="color-2" fill="#444444" d="M9.4,6.6c0.8,0.8,0.8,2,0,2.8c-0.8,0.8-2,0.8-2.8,0C5.8,8.6,1.6,1.6,1.6,1.6S8.6,5.8,9.4,6.6 z" /> <path fill="#444444" d="M8,16c-4.4,0-8-3.6-8-8c0-0.6,0.4-1,1-1s1,0.4,1,1c0,3.3,2.7,6,6,6s6-2.7,6-6s-2.7-6-6-6C7.4,2,7,1.6,7,1 s0.4-1,1-1c4.4,0,8,3.6,8,8S12.4,16,8,16z" /></g></svg>
  </span>
</div>

export function GetHyperlink(item, noRoot) {
  return CreateHyperlink(item, noRoot);
}


export function IamIOSWebAlso() {
  console.log("(!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform))");
  console.log((!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)));
  return AreYouIOS() || (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform));

}


export function GetClientType() {
  var appCType = "";
  var cType = localStorage.getItem("validatorclienttype-s");
  if (isNullOrEmpty(cType) || cType == "null")
    cType = "";



  try {
    if (!cType) {
      cType = localStorage.getItem("validatorapptype-s");
      if (!cType) {
        cType = cookie.load("validatorapptype-s");
      }
    }

  } catch (e) {
  }


  return cType;
}

export function extractSGID(type, input) {
  //const regex = /SGID-[\w-]+/; 
  const regex = new RegExp(`${type}-[\\w-]+`);
  const match = input.match(regex);

  if (match) {
    return match[0];
  } else {
    return null;
  }
}

export function AreYouIOS() {
  var appCType = "";
  var cType = localStorage.getItem("validatorclienttype-s");
  if (isNullOrEmpty(cType) || cType == "null")
    cType = "";



  try {
    appCType = localStorage.getItem("validatorapptype-s");
    if (!appCType) {
      appCType = cookie.load("validatorapptype-s");
    }

  } catch (e) {
  }

  return IsIOS(appCType) || IsIOS(cType);
}


export const settingsHeaderIcons =
{
  Deficits: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><polyline data-color="color-2" points="16 7 16 16 25 16" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path data-cap="butt" d="M2.618,22.783A15.005,15.005,0,1,0,1,16" fill="none" stroke="#000000" strokeMiterlimit={10} strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" /><polyline points="3.617 30.78 2.617 22.78 10.617 23.78" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>),
  Pendings: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><polyline data-color="color-2" points="16 7 16 16 25 16" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path data-cap="butt" d="M2.618,22.783A15.005,15.005,0,1,0,1,16" fill="none" stroke="#000000" strokeMiterlimit={10} strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" /><polyline points="3.617 30.78 2.617 22.78 10.617 23.78" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>),
  Training: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><path d="M26,28H6a5,5,0,0,1-5-5H31A5,5,0,0,1,26,28Z" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M4,19V7A3,3,0,0,1,7,4H25a3,3,0,0,1,3,3V19" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><polygon points="14 11 14 17 19 14 14 11" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /></g></svg>),
  Immediate: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><polyline points="9 12 16 15 23 12" fill="none" stroke="#000000" strokeMiterlimit={10} strokeWidth={2} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><line x1={16} y1={15} x2={16} y2={24} fill="none" stroke="#000000" strokeMiterlimit={10} strokeWidth={2} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><polygon points="23 12 16 9 9 12 9 21 16 24 23 21 23 12" fill="none" stroke="#000000" strokeMiterlimit={10} strokeWidth={2} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M1,16A15,15,0,0,1,16,1h2L15,4" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><path d="M31,16A15,15,0,0,1,16,31H14l3-3" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /></g></svg>),
  Bookings: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle data-color="color-2" cx={23} cy={24} r={7} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line data-color="color-2" x1={23} y1={21} x2={23} y2={27} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line data-color="color-2" x1={20} y1={24} x2={26} y2={24} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line x1={9} y1={1} x2={9} y2={5} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line x1={23} y1={1} x2={23} y2={5} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><line data-cap="butt" x1={31} y1={11} x2={1} y2={11} fill="none" stroke="#000000" strokeMiterlimit={10} strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" /><path d="M12,29H4c-1.657,0-3-1.343-3-3V8c0-1.657,1.343-3,3-3H28c1.657,0,3,1.343,3,3v7" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>),
  Connect: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><path d="M30,23,22,13H10L2,23v4a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3Z" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /> <path d="M1.494,5.442,2,10H8L9,6H23l1,4h6l.506-4.558A4,4,0,0,0,26.531,1H5.469A4,4,0,0,0,1.494,5.442Z" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /> <circle data-color="color-2" cx={16} cy={21} r={4} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>),
  JoinCause: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><circle cx={16} cy={24} r={7} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><line x1={16} y1={21} x2="15.999" y2={27} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} data-color="color-2" strokeLinejoin="miter" /><circle cx={7} cy={4} r={3} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M12.197,13c-1.037-1.793-2.976-3-5.197-3-3.314,0-6,2.686-6,6v3H6" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><circle cx={25} cy={4} r={3} fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M19.803,13c1.037-1.793,2.976-3,5.197-3,3.314,0,6,2.686,6,6v3h-5" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>),
  Fulfillment: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><path d="M2,11V5A3,3,0,0,1,5,2h6" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path data-color="color-2" d="M21,2h6a3,3,0,0,1,3,3v6" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path d="M30,21v6a3,3,0,0,1-3,3H21" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path data-color="color-2" d="M11,30H5a3,3,0,0,1-3-3V21" fill="none" stroke="#000000" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>
  ),

  Account: (<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)">
    <rect x={3} y={1} fill="none" stroke="#000" width={26} height={30} />
    <rect x={7} y={5} fill="none" stroke="#000" width={18} height={6} />
    <line x1={7} y1={16} x2={10} y2={16} stroke="#000" />
    <line x1={14} y1={16} x2={18} y2={16} stroke="#000" />
    <line x1={7} y1={21} x2={10} y2={21} stroke="#000" />
    <line x1={14} y1={21} x2={18} y2={21} stroke="#000" />
    <line x1={7} y1={26} x2={10} y2={26} stroke="#000" />
    <line x1={14} y1={26} x2={18} y2={26} stroke="#000" />
    <line x1={22} y1={16} x2={25} y2={16} stroke="#000" />
    <line x1={22} y1={21} x2={25} y2={21} stroke="#000" />
    <line x1={22} y1={26} x2={25} y2={26} stroke="#000" />
  </g>
  </svg>
  ),


  Enroll: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}>
      <g strokeWidth={2}>
        <polyline points="31 9 31 29 1 29 1 4 19 4" fill="none" stroke="#000" />
        <polyline points="27 14 27 23 9 23 9 9 15 9" fill="none" stroke="#000" />
        <line x1="5" y1="10" x2="5" y2="22" stroke="#000" />
        <path d="M16,16l1-4L27.379,1.621a2.122,2.122,0,0,1,3,0,2.122,2.122,0,0,1,0,3L20,15Z" fill="none" stroke="#000" />
      </g>
    </svg>
  ),


  Patents: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}>
      <g strokeWidth={2}>
        <polyline points="16,27 1,27 1,1 24,1 24,8" fill="none" stroke="#000" />
        <polyline points="28,20.743 28,30 24,28 20,30 20,20.743" fill="none" stroke="#000" />
        <circle cx={24} cy={15} r={7} fill="none" stroke="#000" />
        <line x1={6} y1={9} x2={14} y2={9} stroke="#000" />
        <line x1={6} y1={14} x2={12} y2={14} stroke="#000" />
        <line x1={6} y1={19} x2={12} y2={19} stroke="#000" />
      </g>
    </svg>
  ),

  Resources: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}>
      <g strokeWidth={2}>
        <circle cx={16} cy={4} r={3} fill="none" stroke="#000" />
        <path d="M21,12.683c-1.075-1.617-2.913-2.683-5-2.683-2.087,0-3.925,1.066-5,2.683" fill="none" stroke="#000" />
        <circle cx={7} cy={19} r={3} fill="none" stroke="#000" />
        <path d="M7,25c-3.314,0-6,2.686-6,6H13c0-3.314-2.686-6-6-6Z" fill="none" stroke="#000" />
        <circle cx={25} cy={19} r={3} fill="none" stroke="#000" />
        <path d="M25,25c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z" fill="none" stroke="#000" />
      </g>
    </svg>
  ),

  "Pinnacle Platform": (
    <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}>
      <g strokeWidth={2}>
        <rect x={1} y={7} width={30} height={18} rx={3} fill="none" stroke="#000" />
        <line x1={6} y1={18} x2={6} y2={14} stroke="#000" />
        <line x1={8} y1={16} x2={4} y2={16} stroke="#000" />
        <circle cx={26} cy={16} r={2} fill="none" stroke="#000" />
        <rect x={11} y={11} width={10} height={10} fill="none" stroke="#000" />
      </g>
    </svg>
  ),

  "Pinnacle Of Bharath Healthcare": (
    <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}>
      <g strokeWidth={2}>
        <path d="M23,20h2.324a5,5,0,0,1,4.16,2.226L30,23,14.832,28.9a6,6,0,0,1-5.4-.53L1,23V14H3c2.631,0,5.638.967,7,3h5a5,5,0,0,1,5,5H9" fill="none" stroke="#000" />
        <path d="M19.268,10.268a2.5,2.5,0,0,1-3.536-3.536l5-5a2.5,2.5,0,0,1,3.536,3.536Z" fill="none" stroke="#000" />
        <line x1="18.232" y1="4.232" x2="21.768" y2="7.768" fill="none" stroke="#000" />
      </g>
    </svg>
  ),


};

const getAppType = () => {
  try {
    let clientType = localStorage.getItem("validatorapptype-s");
    if (!clientType) {
      clientType = getFromCookie("validatorapptype-s"); // assumes you have getFromCookie utility
    }
    return clientType;
  } catch (e) {
    console.log("error in reading clientType from local storage...", e);
    return null;
  }
};

const isIOS = (app) => app && app.toLowerCase().includes("ios");
const isAndroid = (app) => app && app.toLowerCase().includes("android");

export function tellAFriend() {
  const title =
    "Life Skills, Social Skills, Emotional Skills, Cognitive Skills can enable your kid to be self-sufficient, to be part of mainstream society, to stand chance at life, career, family, have wonderful life. Bring smiles into your family. \n\n" +
    "8,50,000 + 1:1 exclusive therapy services with 97% + proven improvement, 96% + parental satisfaction promising to do everything plausible for your kid to be self - sufficient, to be part of mainstream society, to stand chance at life, career, family, have wonderful life.Bring smiles into your family. \n\n" +
    "For Speech, ABA, OT, SE & Self Assessments.. Download app: https://mirracle.pinnacleblooms.org/dl \n\n\n" +
    "https://pinnacleblooms.org \n#1 Autism Therapy Centres Network, \n\n" +
    "#1 Multi-Sensory, Multi-Disciplinary, Integrated Autism Therapy Centres Network. \n\n" +
    "CALL OUR FREE NATIONAL AUTISM HELPLINE for anything/ everything about autism. \n\n" +
    "WhatsApp: https://wa.me/+919100181181";

  const app = getAppType();

  if (isIOS(app)) {
    window.location.href = "mirraclescheme://sharecallback=" + encodeURIComponent(title);
    return;
  }

  if (navigator.share === undefined) {
    window.currentShareVal = title;

    if (isAndroid(app)) {
      window.location.href = "mirraclescheme://sharecallback";
    } else {
      alert(
        "Sharing is not available for your browser currently. You may still share via WhatsApp."
      );
    }
  } else {
    navigator.share({ title, text: title }).catch((err) => {
      console.log("Share failed:", err);
    });
  }
}
export function useTellaFriend() {





  return { tellAFriend };
}

// Helper to read cookie (can move to utils)
function getFromCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}
export function logOff() {
  //alert("log off called");
  //if (!IsOnline) {
  //   // UtilClass.ShowToastMessage("You can't logoff now, Please do connect to internet");
  //    return;
  //}

  showConfirmBoxWithCancel("Are you sure you want to logoff?", "Info", "Cancel{#}Proceed", false, function (callback) {
    if (!callback) {
      clearUserRelatedData();
    }
  });
}


export function clearUserRelatedData(isForceLogOff) {
  try {

    var cType = localStorage.getItem("validatorclienttype-s");
    if (isNullOrEmpty(cType) || cType == "null")
      cType = "";

    var appCType = "";

    try {
      appCType = localStorage.getItem("validatorapptype-s");
      if (!appCType) {
        appCType = cookie.load("validatorapptype-s");
      }
    } catch (e) {
    }

    localStorage.removeItem("Role");
    localStorage.removeItem("UserRoles");
    localStorage.removeItem("UserData");
    clearLocalStorage();

    cookie.remove("validatorauth-s");
    cookie.remove("validatormobilenumber-s");
    cookie.remove("UserRoles");
    cookie.remove("UserData");
    try {
      cookie.remove('validatorauth-s', { path: "/", domain: "pinnacleblooms.org" });
      cookie.remove('validatormobilenumber-s', { path: "/", domain: "pinnacleblooms.org" });
      cookie.remove('UserRoles', { path: "/", domain: "pinnacleblooms.org" });
      cookie.remove('UserData', { path: "/", domain: "pinnacleblooms.org" });
    } catch (e) {

    }
    try {
      if ('caches' in window) {
        caches.keys()
          .then(function (keyList) {
            return Promise.all(keyList.map(function (key) {
              return caches.delete(key);
            }));
          })
      }
    } catch (e) {
      console.log(e);
    }

    if (IsIOS(appCType) || IsAndroid(appCType)) {
      window.location.href = "mirraclescheme://logoff";
    }

    setTimeout(function () {

      if (isForceLogOff) {
        window.location.href = "/forcelogoff";
      }
      else {
        window.location.href = "/epass" + (appCType ? "?ct=" + appCType : "");
      }

    }, 20);

  } catch (e) {
    console.log("Error in clearUserRelatedData : " + e);
  }
}



export function IsLocalKeyExist(keyName) {
  const name = localStorage.getItem(keyName);
  return name ? true : false;

}

export function FlushServiceWorkerCache(currentVersion, serverVersion, callback) {
  console.log("Came for For Flush");
  // const name_of_cache = ['PINNACLE_M_063'];
  var isAllClean = false;
  try {
    var currentMajorVersion = currentVersion.split('.')[1];
    var serverMajorVersion = serverVersion.split('.')[1];
    if (currentMajorVersion != serverMajorVersion) {
      isAllClean = true;
    }
  } catch (e) {

  }
  try {
    if ('caches' in window) {
      caches.keys()
        .then(function (keyList) {
          return Promise.all(keyList.map(function (key) {

            //ADDED FOR ONLY REFRESHING THE HTML // DATA RAMIANS AS IT IS.
            if (key.indexOf("PINNACLE_") >= 0) {
              return caches.delete(key);

            }
            else if (isAllClean) {
              return caches.delete(key);
            }


            //return caches.delete(key);
          })).then(function (x) {
            try {
              //   localStorage.removeItem("LastPSSyncDataTime");
              console.log("Flush Completed");
              callback(true);
            } catch (e) {
              console.log("Error in FlushServiceWorkerCache : after flush successful.");
              callback(false);
            }
            // location.reload();
          });
        })
    }
  } catch (err) {
    console.log("Error while flushing : FlushServiceWorkerCache " + err);
  }
}

function clearLocalStorage() {
  try {
    var userid = "";
    var clientType = "";
    var vAppType = "";
    try {
      userid = localStorage.getItem('UserId');
      clientType = localStorage.getItem('validatorclienttype-s');
      vAppType = localStorage.getItem('validatorapptype-s');

    } catch (e) {

    }

    localStorage.clear();
    try {

      localStorage.setItem('validatorclienttype-s', clientType);
      localStorage.setItem('validatorapptype-s', vAppType);
      localStorage.removeItem('UserData');
      localStorage.removeItem('UserRoles');
      localStorage.removeItem('MasterData');
      localStorage.removeItem('LastPSSyncDataTime');
    } catch (e) {
    }
    console.log("start db clear");
  } catch (e) {

  }

  // clearIndexDB();
}


function CreateHyperlink(item, noRoot) {
  var approot = "https://mirracle.pinnacleblooms.org";
  //alert(item);
  // console.log("create hyperlink");
  if (typeof (item) == 'undefined' || null == item || null == item.AT) {
    return approot;
  }

  //  return noRoot ? "/" + "guru/" + item.RDT.replace(/ /g, "-") + "/" + item.UId : approot + "/guru/" + item.RDT.replace(/ /g, "-") + "/" + item.UId;

  if (item.AT.toLowerCase() == "imagegallery" || item.AT.toLowerCase() == "audio" || item.AT.toLowerCase() == "file" || item.AT.toLowerCase() == "blogpost" || item.AT.toLowerCase() == "video") {
    return approot + "/guru/" + item.Title.replace(/ /g, "-") + "/" + item.Id;
  }
  else if (item.AT.toLowerCase() == "services" || item.AT.toLowerCase() == "assessment") {
    return approot + "/" + item.AT.toLowerCase() + "/" + item.Title.replace(/ /g, "-");
  }
  return "";
}

export function GetLastSyncedFromLS() {

  try {
    console.log("LastPSSyncDataTime");
    var lsd = localStorage.getItem("LastPSSyncDataTime");
    if (lsd) {
      let dateStamp = new Date(lsd);
      return getFormattedDate(lsd);
    }
  } catch (e) {

  }

  return "";
}

export function SaveHelloPinnacleExceptionToSentry(event, message, type, token, module) {
  try {
    var exObj = {};
    exObj.transaction = type;
    var exception = {};
    exception.Type = event;
    exception.Message = message;
    //errorObj.CreatedDateTime = getCurrentDateTime();
    try {
      ReactGA.event({
        category: event,
        action: type,
        label: message
      });
    }
    catch {

    }



    token = (!token) ? getUserToken() : token;

    exObj.event_type = (type) ? type : "Error";
    exObj.timestamp = getCurrentDateTime();


    var lsd = localStorage.getItem("LastPSSyncDataTime");
    var configJsonString = localStorage.getItem("UserSettings");
    var settingsSWV = "";
    if (configJsonString) {
      try {
        var settingsSW = JSON.parse(configJsonString).filter(function (e) { return e.Name == "SWVERSION" });
        if (settingsSW && settingsSW.length > 0) {
          settingsSWV = settingsSW[0].Value;
        }
      } catch (e) {

      }
    }
    exObj.extra = {
      "token": (!token) ? "Token Does not exit" : token,
      "module": module ? module : "N/A",
      "SWVersion": "Layout: " + window.swVersion + " USERSETTINGS: " + settingsSWV,
      "LSD": lsd
    }

    //exObj.tags = { "from": "client" };


    var exList = [];
    exList.push({ "type": "" + exception.Type, "value": exception.Message });

    exObj.exception = { "values": exList };

    console.log(JSON.stringify(exObj));

    var sentryIOUrl = "https://sentry.io/api/4505963993825280/store/";
    $.ajax({
      url: sentryIOUrl,
      type: "POST",
      headers: {
        "content-type": "application/json",
        "X-Sentry-Auth": "Sentry sentry_version=7,sentry_timestamp=1329096377,sentry_key=c133d651b05dfe53d9d9542192ef99ba,sentry_secret=383990ec5ecc11ee901fea1b4c052383,sentry_client=sentry-python/1.0",
      },
      data: JSON.stringify(exObj),
      success: function (data, textStatus, jqXHR) {
        console.log(data);

        //alert('Success!');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //alert('Error occurred!');
        console.log(jqXHR);
      }
    });
  } catch (err) {
    console.log("Error in SaveExceptionToSentry :: " + err);
  }
}

export function SaveExceptionToSentry(exception, type, token, module) {
  try {
    var exObj = {};
    exObj.transaction = "PBN_Client_Logs"

    token = (!token) ? getUserToken() : token;

    exObj.event_type = (type) ? type : "Error";
    exObj.timestamp = getCurrentDateTime();


    var lsd = localStorage.getItem("LastPSSyncDataTime");
    var configJsonString = localStorage.getItem("UserSettings");
    var settingsSWV = "";
    if (configJsonString) {
      try {
        var settingsSW = JSON.parse(configJsonString).filter(function (e) { return e.Name == "SWVERSION" });
        if (settingsSW && settingsSW.length > 0) {
          settingsSWV = settingsSW[0].Value;
        }
      } catch (e) {

      }
    }
    exObj.extra = {
      "token": (!token) ? "Token Does not exit" : token,
      "module": module ? module : "N/A",
      "SWVersion": "Layout: " + window.swVersion + " USERSETTINGS: " + settingsSWV,
      "LSD": lsd
    }

    //exObj.tags = { "from": "client" };


    var exList = [];
    exList.push({ "type": "" + exception.Type, "value": exception.Message });

    exObj.exception = { "values": exList };

    console.log(JSON.stringify(exObj));

    var sentryIOUrl = "https://sentry.io/api/5903837/store/";

    $.ajax({
      url: sentryIOUrl,
      type: "POST",
      headers: {
        "content-type": "application/json",
        "X-Sentry-Auth": "Sentry sentry_version=7,sentry_timestamp=1329096377,sentry_key=394708243fac4e4896f2446f5b4dd3c7,sentry_secret=330ef66ced594b09a1fa603a5bd693f1,sentry_client=sentry-python/1.0",
      },
      data: JSON.stringify(exObj),
      success: function (data, textStatus, jqXHR) {
        console.log(data);

        //alert('Success!');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //alert('Error occurred!');
        console.log(jqXHR);
      }
    });
  } catch (err) {
    console.log("Error in SaveExceptionToSentry :: " + err);
  }
}

function GetBrowser() {
  try {
    let userAgent = navigator.userAgent;

    return JSON.stringify(userAgent);

    //let browserName;

    // if(userAgent.match(/chrome|chromium|crios/i)){
    //     browserName = "chrome";
    //   }else if(userAgent.match(/firefox|fxios/i)){
    //     browserName = "firefox";
    //   }  else if(userAgent.match(/safari/i)){
    //     browserName = "safari";
    //   }else if(userAgent.match(/opr\//i)){
    //     browserName = "opera";
    //   } else if(userAgent.match(/edg/i)){
    //     browserName = "edge";
    //   }else{
    //     browserName="No browser detection";
    //   }
  }
  catch {
    return "No browser detection";
  }
}




export function makeUrlSchemeCallforIOS() {
  var app = getapptype();
  //  var userAgent = this.getMobileOperatingSystem();

  var isProType = IsAppTypePro();

  if (IsIOS(app)) {
    setTimeout(function () {
      window.location.href = "mirraclescheme://imagepickeropen";
    }, 100);
  }
}

export function StoreAIEIntoLocal(type, data) {
  var urls = localStorage.getItem(type);

  localStorage.setItem(type, data);
}
export function StoreViewMirraclesIntoLocal(id, type) {
  var urls = localStorage.getItem(type ? type : "viewmirracles");
  urls = urls ? urls + "{#}" : "";
  if (urls.indexOf(id) == -1) {
    urls = urls + id;
    localStorage.setItem(type ? type : "viewmirracles", urls);
  }
}

let colorsArray = ["#017EAE", "#96BF0D", "#E42827", "#FF7903", "#FFB900", "#9c27b0", "#009688", "#00bcd4", "#3f51b5", "#e91e63", "#f44336", "#827717", "#00c853", "#e64a19", "#4caf50", "#18ffff", "#e91e63"];

export function MgroupBy(objectArray, property) {

  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

export function GetColors(count, leastMatching) {
  let colorCodes = [];
  for (var i = 0; i < count; i++) {
    let randomMatched = false;
    do {
      randomMatched = false;
      let random = Math.floor(Math.random() * Math.floor(colorsArray.length));
      let cNBA = colorsArray[random];

      for (var j = 0; j < leastMatching; j++) {
        if (colorCodes.length >= j + 1) {

          randomMatched = colorCodes[colorCodes.length - (j + 1)] == cNBA;
        }
        if (randomMatched) {
          break;
        }
      }
      if (!randomMatched) {
        colorCodes.push(cNBA);
      }

    }
    while (randomMatched);

  }
  console.log(colorCodes);
  return colorCodes;
}

export function GetViewMirracles(type) {
  var urls = localStorage.getItem(type ? type : "viewmirracles");
  urls = urls ? urls : "";
  return urls.split("{#}");
}

export function callIOSImageClose() {
  var app = getapptype();
  var userAgent = getMobileOperatingSystem();

  var isProType = IsAppTypePro();
  // alert(app);
  if (IsIOS(app)) {
    setTimeout(function () {
      window.location.href = "mirraclescheme://imagepickerclose";

      //document.body.onfocus = null;
    }, 100);
  }
}


export function SkillsAndAbilities(UserData, assId, withOutGroup = false, assessmentExisting = null) {

  var assessment = assessmentExisting ? assessmentExisting : UserData && UserData.TherapeuticEipAssessments && UserData.TherapeuticEipAssessments.length > 0
    ? UserData.TherapeuticEipAssessments.filter(e => e.Id === parseInt(assId))[0]
    : null;
  if (!assessment) {
    return { Abilities: [], Skills: [] };
  }
  // var domainResponse = JSON.parse(assessment.DomainResponse);
  // var domainResponseList = JSON.parse(assessment.F1);
  var domainResponse = assessment?.DomainResponse ? JSON.parse(assessment.DomainResponse) : [];
  var domainResponseList = assessment?.F1 ? JSON.parse(assessment.F1) : [];

  var listofPrognosis =  GetPrognosisBySkills(domainResponse.map(m=> m.DN),UserData.Types,assessment);
  if(listofPrognosis && listofPrognosis.length > 0)
  {
   var pgns=  groupBy(listofPrognosis,"Key");
    domainResponse.forEach(element => {
      element.PGN = pgns[element.DN] && pgns[element.DN].length > 0 ? pgns[element.DN][0] : null;
      element.Sessions = element.PGN && element.PGN.S10;
    });

  }
  //console.log("listofPrognosis",listofPrognosis);

  var listofAbilitiesPrognosis =  GetPrognosisByAbilities(domainResponseList.map(m=> m.DK),UserData.Types,assessment);
  if(listofAbilitiesPrognosis && listofAbilitiesPrognosis.length > 0)
  {
   var pgns=  groupBy(listofAbilitiesPrognosis,"Key");
    domainResponseList.forEach(element => {
      element.PGN = pgns[element.DK] && pgns[element.DK].length > 0 ? pgns[element.DK][0] : null;
      element.Sessions = element.PGN && element.PGN.S10;
    });
  }
  
  if (withOutGroup) {
    return { Abilities: domainResponseList, Skills: domainResponse };
  }

  const colorOrder = ["Red", "Yellow", "Green"];
  const group = (arr) => arr.reduce((a, r) => ((a[r.C] ||= []).push(r), a), {});
  const groupByColor = group(domainResponseList);
  const groupSkillsByColor = group(domainResponse);
  const mapOrdered = (grp) => colorOrder.filter(c => grp[c]).map(c => ({ color: c, scores: grp[c] }));
  return { Abilities: mapOrdered(groupByColor), Skills: mapOrdered(groupSkillsByColor) };
}

function getapptype() {
  try {
    var clientType = localStorage.getItem("validatorapptype-s");
    if (!clientType) {
      clientType = cookie.load("validatorapptype-s");
    }

    console.log(clientType);
    return clientType;
  } catch (e) {
    console.log("error in reading clientype from local storage...");
    console.log(e);
  }
}


export function IsAppView() {

  var app = getapptype();

  if (app) {
    return true;
  }
  return false;
}
export function OpenTheUrlinWeb(url) {
  var app = getapptype();

  if (!app) {
    app = getMobileOperatingSystem();
  }

  if (IsApp(app)) {

    window.open(url, '_blank')
    // setTimeout(function () {
    //     window.location.href = "mirraclescheme://openinweb=" + url;
    // }, 100);
  }
  else {
    window.open(url, '_blank');

    // location.href = url;
  }
}

export function GetUrlForAPP(url) {

  return "mirraclescheme://" + url;
}

export function getCreatedDateTime() {

  var currentTime = new Date();

  var currentOffset = currentTime.getTimezoneOffset();

  var ISTOffset = 330; // IST offset UTC +5:30

  var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

  return ISTTime.toISOString();
}

export function getDateString(dateString, isDate) {

  var currentTime = isDate ? dateString : new Date(dateString);

  var currentMonth = currentTime.getMonth() + 1;
  var currentDate = currentTime.getDate();

  var currentDateString = currentTime.getFullYear() + "-" + (currentMonth <= 9 ? "0" + currentMonth : currentMonth) + "-" + (currentDate <= 9 ? "0" + currentDate : currentDate) + "T00:00:00.000Z";

  return currentDateString;
}

export function ShowInActivePaymentOverlay(allData) {

  try {

    //return true;
    var roles = localStorage.getItem("UserRoles");
    roles = JSON.parse(roles);
    if (!roles || roles == null) {
      return true;
    }

    var allowedRoles = ["Therapist", "Receptionist", "ChiefTherapist", "FacilityOwner", "CCC", "NCC", "HarvestAdmin", "Manager", "Owner"];
    var UserRoles = $.grep(roles, function (e) { return allowedRoles.indexOf(e) > -1 });

    var isAllowed = false;
    $.each(UserRoles, function (key, value) {
      var c = $.grep(allowedRoles, function (e) { return e.toLowerCase() == value.toLowerCase() })[0];
      if (c) {
        isAllowed = true;
      }

    });

    if (isAllowed) {
      return false;
    }
    else {
      var activeService = $.grep(allData, function (e) { return e.AT == "USERSERVICE" && e.RS != "DELETEACTIVITY" && (!e.S || (e.S && e.S.toLowerCase() != "inactive")) });
      if (!activeService || activeService.length == 0) {
        return true;
      }
    }
    return false;
  } catch (e) {
    return false;
  }

}

function groupOnMultipleKeys(data, key) {
  if (!data || data.length == 0 || !key) {
    return;
  }
  var keys = key.split(",");

  // return array.reduce((data, currentValue) => {
  //     // If an array already present for key, push it to the array. Else create an array and push the object

  //     if (currentValue) {

  //         var valueType = [];

  //         keys.forEach(function (e) {
  //             valueType.push((currentValue[e] ? currentValue[e] : ""));
  //         });


  //         (result[valueType.join(",")] = result[valueType.join(",")] || []).push(
  //             currentValue
  //         );

  //     }
  //     // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
  //     return result;
  //}, {});
}

export function FilterCourses(data, AT, S, pending) {
  if (!data || !AT) {
    return;
  }

  var courses = data.filter(function (e) {
    return e.AT == AT && ((!S || S == "Pending") ? (!e.S || e.S.toLowerCase() != "completed") : e.S.toLowerCase() == S.toLowerCase())
  });
  if (!courses) {
    return;
  }

  // lang = a.F10, Course = a.F14

  var gData = groupOnMultipleKeys(courses, "F10,F14");


  var finalPendingCources = [];
  gData.forEach(function (value, index) {

    finalPendingCources.push(value[0]);

  });


  if (S && S.toLowerCase() == "completed") {
    if (!pending) {

    }
  }
  console.log("finalPendingCources");
  console.log(finalPendingCources);
}

